const  data= {
  "Adana": {
    "Aladağ": {
      "Akören": true,
      "Akpınar": true,
      "Başpınar": true,
      "Boztahta": true,
      "Büyüksofulu": true,
      "Ceritler": true,
      "Dailer": true,
      "Darılık": true,
      "Dölekli": true,
      "Ebrişim": true,
      "Eğner": true,
      "Gerdibi": true,
      "Gireğiyeniköy": true,
      "Gökçeköy": true,
      "Kabasakal": true,
      "Karahan": true,
      "Kıcak": true,
      "Kışlak": true,
      "Kızıldam": true,
      "Kökez": true,
      "Köprücük": true,
      "Küp": true,
      "Madenli": true,
      "Mansurlu": true,
      "Mazılık": true,
      "Posyağbasan": true,
      "Sinanpaşa": true,
      "Topallı": true,
      "Uzunkuyu": true,
      "Yetimli": true,
      "Yüksekören": true
    },
    "Ceyhan": {
      "Adapınar": true,
      "Adatepe": true,
      "Ağaçlı": true,
      "Ağaçpınar": true,
      "Akdam": true,
      "Altıgözbekirli": true,
      "Altıkara": true,
      "Altıocak": true,
      "Atatürk": true,
      "Aydemiroğlu": true,
      "Aydınlar": true,
      "Azizli": true,
      "Başören": true,
      "Belediye Evleri": true,
      "Birkent": true,
      "Bota": true,
      "Burhaniye": true,
      "Burhanlı": true,
      "Büyükburhaniye": true,
      "Büyükkırım": true,
      "Büyükmangıt": true,
      "Camuzağılı": true,
      "Ceyhanbekirli": true,
      "Civantayak": true,
      "Cumhuriyet": true,
      "Çakaldere": true,
      "Çataklı": true,
      "Çatalhüyük": true,
      "Çevretepe": true,
      "Çiçekli": true,
      "Çiftlikler": true,
      "Çokçapınar": true,
      "Dağıstan": true,
      "Değirmendere": true,
      "Değirmenli": true,
      "Dikilitaş": true,
      "Dokuztekne": true,
      "Doruk": true,
      "Durhasandede": true,
      "Dutlupınar": true,
      "Ekinyazı": true,
      "Elmagölü": true,
      "Emek": true,
      "Erenler": true,
      "Esentepe": true,
      "Fatih Sultan Mehmet": true,
      "Gazi Osman Paşa": true,
      "Gümürdülü": true,
      "Gündoğan": true,
      "Günlüce": true,
      "Hamdilli": true,
      "Hamidiye": true,
      "Hamitbey": true,
      "Hamitbeybucağı": true,
      "Hürriyet": true,
      "Irmaklı": true,
      "Isırganlı": true,
      "İmran": true,
      "İnceyer": true,
      "İnönü": true,
      "İsalı": true,
      "İstiklal": true,
      "Karakayalı": true,
      "Kelemeti": true,
      "Kılıçkaya": true,
      "Kıvrıklı": true,
      "Kızıldere": true,
      "Konakoğlu": true,
      "Koruklu": true,
      "Köprülü": true,
      "Körkuyu": true,
      "Kösreli": true,
      "Kurtkulağı": true,
      "Kurtpınar": true,
      "Kuzucak": true,
      "Küçükburhaniye": true,
      "Küçükkırım": true,
      "Küçükmangıt": true,
      "Mercimek": true,
      "Mercin": true,
      "Mithat Paşa": true,
      "Modernevler": true,
      "Muradiye": true,
      "Mustafabeyli": true,
      "Namık Kemal": true,
      "Narlık": true,
      "Nazımbey Yeniköy": true,
      "Sağırlar": true,
      "Sağkaya": true,
      "Sarıbahçe": true,
      "Sarımazı": true,
      "Sarısakal": true,
      "Selimiye": true,
      "Sirkeli": true,
      "Soğukpınar": true,
      "Soysallı": true,
      "Şahin Özbilen": true,
      "Şehit Hacı Ibrahim": true,
      "Tatarlı": true,
      "Tatlıkuyu": true,
      "Toktamış": true,
      "Tumlu": true,
      "Ulus": true,
      "Üçdutyeşilova": true,
      "Veysiye": true,
      "Yalak": true,
      "Yarsuat": true,
      "Yellibel": true,
      "Yeşilbahçe": true,
      "Yeşildam": true,
      "Yılankale": true,
      "Zübeyde Hanım": true
    },
    "Çukurova": {
      "Belediye Evleri": true,
      "Beyazevler": true,
      "Bozcalar": true,
      "Dörtler": true,
      "Esentepe": true,
      "Fadıl": true,
      "Gökkuyu": true,
      "Güzelyalı": true,
      "Huzurevleri": true,
      "Kabasakal": true,
      "Karahan": true,
      "Karslılar": true,
      "Kaşoba": true,
      "Kocatepe": true,
      "Kurttepe": true,
      "Küçükçınar": true,
      "Mahfesığmaz": true,
      "Memişli": true,
      "Örcün": true,
      "Pirili": true,
      "Salbaş Esentepe": true,
      "Söğütlü": true,
      "Şambayadı": true,
      "Toros": true,
      "Yeni": true,
      "Yurt": true,
      "Yüzüncüyıl": true
    },
    "Feke": {
      "Akkaya": true,
      "Akoluk": true,
      "Bağdatlı": true,
      "Bahçecik": true,
      "Belenköy": true,
      "Çandırlar": true,
      "Çondu": true,
      "Çürükler": true,
      "Değirmenciuşağı": true,
      "Gaffaruşağı": true,
      "Gedikli": true,
      "Göbelli": true,
      "Gökçeli": true,
      "Gürümze": true,
      "Güzpınarı": true,
      "Hıdıruşağı": true,
      "İncirci": true,
      "İslam": true,
      "Kaleyüzü": true,
      "Karacaoğlan": true,
      "Karacauşağı": true,
      "Kaşaltı": true,
      "Kayadibi": true,
      "Kazancı": true,
      "Keklikçi": true,
      "Kırıkuşağı": true,
      "Kısacıklı": true,
      "Kızılyer": true,
      "Koçyazı": true,
      "Konakkuran": true,
      "Kovukçınar": true,
      "Mansurlu": true,
      "Musalar": true,
      "Olucak": true,
      "Ormancık": true,
      "Ortaköy": true,
      "Oruçlu": true,
      "Paşalı": true,
      "Sülemişli": true,
      "Süphandere": true,
      "Şahmuratlı": true,
      "Tenkerli": true,
      "Tokmanaklı": true,
      "Tortulu": true,
      "Uğurlubağ": true,
      "Yaylapınar": true,
      "Yerebakan": true,
      "Yeşil Düşmüş": true
    },
    "İmamoğlu": {
      "Adalet": true,
      "Ağzıkaraca": true,
      "Alaybeyi": true,
      "Aliler": true,
      "Ayvalı": true,
      "Camili": true,
      "Cumhuriyet": true,
      "Çörten": true,
      "Danacılı": true,
      "Fatih": true,
      "Hacıhasanlı": true,
      "Hürriyet": true,
      "Koyunevi": true,
      "Malıhıdırlı": true,
      "Menteş": true,
      "Otluk": true,
      "Pekmezci": true,
      "Sayca": true,
      "Saygeçit": true,
      "Sevinçli": true,
      "Sokutaş": true,
      "Tuna": true,
      "Ufacıkören": true,
      "Uluçınar": true,
      "Üçtepe": true,
      "Yazıtepe": true,
      "Yenievler": true
    },
    "Karaisalı": {
      "Akçalı": true,
      "Aktaş": true,
      "Altınova": true,
      "Aşağıbelemedik": true,
      "Aşağıyörükler": true,
      "Ayakkıf": true,
      "Barakdağı": true,
      "Başkıf": true,
      "Bekirli": true,
      "Beydemir": true,
      "Bolacalı": true,
      "Bucak": true,
      "Çakallı": true,
      "Çatalan": true,
      "Çeceli": true,
      "Çevlik": true,
      "Çocuklar": true,
      "Çorlu": true,
      "Çukur": true,
      "Demirçit": true,
      "Döşekevi": true,
      "Durak": true,
      "Eğlence": true,
      "Emelcik": true,
      "Etekli": true,
      "Fettahlı": true,
      "Filikli": true,
      "Gildirli": true,
      "Gökhasanlı": true,
      "Gülüşlü": true,
      "Güvenç": true,
      "Hacıkırı": true,
      "Hacılı": true,
      "Hacımusalı": true,
      "Kaledağı": true,
      "Kapıkaya": true,
      "Karahasanlı": true,
      "Karakılıç": true,
      "Karakuyu": true,
      "Karapınar": true,
      "Kırıklı": true,
      "Kocaveliler": true,
      "Körüklü": true,
      "Kuşcusofulu": true,
      "Kuyucu": true,
      "Kuzgun": true,
      "Maraşlı": true,
      "Merkezboztahta": true,
      "Murtçukuru": true,
      "Nergizlik": true,
      "Nuhlu": true,
      "Ömerli": true,
      "Sadıkali": true,
      "Sarımehmetli": true,
      "Saypınar": true,
      "Selampınar": true,
      "Tatık": true,
      "Topaktaş": true,
      "Topkaralı": true,
      "Torunsolaklı": true,
      "Tümenli": true,
      "Yazıbaşı": true
    },
    "Karataş": {
      "Adalı": true,
      "Ataköy": true,
      "Bahçe": true,
      "Bebeli": true,
      "Çağşırlı": true,
      "Çakırören": true,
      "Çavuşlu": true,
      "Çimeli": true,
      "Çukurkamış": true,
      "Damlapınar": true,
      "Develiören": true,
      "Dolaplı": true,
      "Gölkaya": true,
      "Hacıhasan": true,
      "Hasırağacı": true,
      "Helvacı": true,
      "İnneplihüyüğü": true,
      "İsahacılı": true,
      "Kapı": true,
      "Karagöçer": true,
      "Karataş": true,
      "Karşıyaka": true,
      "Kemaliye": true,
      "Kesik": true,
      "Kırhasan": true,
      "Kızıltahta": true,
      "Kiremitli": true,
      "Meletmez": true,
      "Orta": true,
      "Oymaklı": true,
      "Sarımsak": true,
      "Sirkenli": true,
      "Tabaklar": true,
      "Tabur": true,
      "Terliksiz": true,
      "Topraklı": true,
      "Tuzkuyusu": true,
      "Tuzla": true,
      "Yassıveren": true,
      "Yemişli": true,
      "Yeni": true,
      "Yenimurat": true,
      "Yüzbaşı": true
    },
    "Kozan": {
      "Acarmantaş": true,
      "Ağlıboğaz": true,
      "Akarca": true,
      "Akçalıuşağı": true,
      "Akdam": true,
      "Akkaya": true,
      "Alapınar": true,
      "Andıl": true,
      "Arslanlı": true,
      "Arslanpaşa": true,
      "Aydın": true,
      "Ayşehoca": true,
      "Bağlar": true,
      "Bağözü": true,
      "Bağtepe": true,
      "Boztahta": true,
      "Bucak": true,
      "Bulduklu": true,
      "Cumhuriyet": true,
      "Çamdere": true,
      "Çamlarca": true,
      "Çanaklı": true,
      "Çandık": true,
      "Çelenuşağı": true,
      "Çobanpınarı": true,
      "Çokak": true,
      "Çukurören": true,
      "Çulluuşağı": true,
      "Çürüklü": true,
      "Damyeri": true,
      "Dikilitaş": true,
      "Dilekkaya": true,
      "Doğanalanı": true,
      "Duraluşağı": true,
      "Durmuşlu": true,
      "Düzağaç": true,
      "Enizçakırı": true,
      "Ergenuşağı": true,
      "Eskikabasakal": true,
      "Eskimantaş": true,
      "Faydalı": true,
      "Ferhatlı": true,
      "Gazi": true,
      "Gedikli": true,
      "Gökçeyol": true,
      "Gökgöz": true,
      "Görbeyaz": true,
      "Güneri": true,
      "Hacıbeyli": true,
      "Hacımirzalı": true,
      "Hacıuşağı": true,
      "Hamam": true,
      "Ilıca": true,
      "Işıkkaya": true,
      "Işıklı": true,
      "İdemköy": true,
      "Kabaktepe": true,
      "Kahveli": true,
      "Kalkumaç": true,
      "Kapıkaya": true,
      "Karabucak": true,
      "Karacaoğlan": true,
      "Karacaören": true,
      "Karahamzalı": true,
      "Karanebili": true,
      "Kemerköy": true,
      "Kıbrıslar": true,
      "Kızıllar": true,
      "Kızlarsekisi": true,
      "Köseli": true,
      "Kuytucak": true,
      "Kuyubeli": true,
      "Kuyuluk": true,
      "Mahmutlu": true,
      "Mahyalar": true,
      "Marankeçili": true,
      "Minnetli": true,
      "Orçan": true,
      "Oruçlu": true,
      "Örendere": true,
      "Özbaşı": true,
      "Pekmezci": true,
      "Postkabasakal": true,
      "Salmanlı": true,
      "Şerifli": true,
      "Şevkiye": true,
      "Taş": true,
      "Tavşantepe": true,
      "Tepecikören": true,
      "Tufanlı": true,
      "Tufanpaşa": true,
      "Turgutlu": true,
      "Turunçlu": true,
      "Türkeli": true,
      "Varsaklar": true,
      "Velicanlı": true,
      "Yanalerik": true,
      "Yarımoğlu": true,
      "Yassıçalı": true,
      "Yeniköy": true,
      "Yukarıkeçili": true,
      "Yüksekören": true,
      "Zerdali": true
    },
    "Pozantı": {
      "Akçatekir": true,
      "Alpu": true,
      "Aşçıbekirli": true,
      "Belemedik": true,
      "Cumhuriyet": true,
      "Çamlıbel": true,
      "Dağdibi": true,
      "Eskikonacık": true,
      "Fındıklı": true,
      "Gökbez": true,
      "Hamidiye": true,
      "İstiklal": true,
      "Kamışlı": true,
      "Karakışlakçı": true,
      "Kurtuluş": true,
      "Ömerli": true,
      "Yağlıtaş": true,
      "Yazıcak": true,
      "Yenikonacık": true,
      "Yukarıbelemedik": true,
      "Zafer": true
    },
    "Saimbeyli": {
      "Aksaağaç": true,
      "Avcıpınarı": true,
      "Ayvacık": true,
      "Beypınarı": true,
      "Cumhurlu": true,
      "Çatak": true,
      "Çeralan": true,
      "Çorak": true,
      "Değirmenciuşağı": true,
      "Eyüplü": true,
      "Fatih": true,
      "Gökmenler": true,
      "Gürleşen": true,
      "Halilbeyli": true,
      "Himmetli": true,
      "İslam": true,
      "Kandilli": true,
      "Kapaklıkuyu": true,
      "Karakuyu": true,
      "Kızılağaç": true,
      "Mahmutlu": true,
      "Naltaş": true,
      "Narlıdere": true,
      "Topallar": true,
      "Tülü": true,
      "Yardibi": true,
      "Yeniköy": true,
      "Yeşilbağlar": true
    },
    "Sarıçam": {
      "Acıdere": true,
      "Aflak": true,
      "Akkuyu": true,
      "Avcılar": true,
      "Aydınyurdu": true,
      "Ayvalı": true,
      "Balcalı": true,
      "Bayram Hacılı": true,
      "Beyceli": true,
      "Boynuyoğun": true,
      "Boztepe": true,
      "Buruk Cumhuriyet": true,
      "Büyük Baklalı": true,
      "Cerenli": true,
      "Cihadiye": true,
      "Çamlıca": true,
      "Çarkıpare": true,
      "Çaylı": true,
      "Çınarlı": true,
      "Çiçekli": true,
      "Çirişgediği": true,
      "Dağcı": true,
      "Dutluca": true,
      "Eğeciuşağı": true,
      "Elif Su Uludağ": true,
      "Ertuğrulgazi": true,
      "Esentepe": true,
      "Gökbuket": true,
      "Göztepe": true,
      "Gültepe": true,
      "Hakkıbeyli": true,
      "Hasanbeyli": true,
      "Hocallı": true,
      "Hürriyet": true,
      "İstiklal": true,
      "Karaömerli": true,
      "Karayusuflu": true,
      "Kargakekeç": true,
      "Karlık": true,
      "Kaşobası": true,
      "Kemalpaşa": true,
      "Kepeztepe": true,
      "Kılbaş": true,
      "Kılıçlı": true,
      "Kızılkaş": true,
      "Kösefakılı": true,
      "Küçükbaklalı": true,
      "Maltepe": true,
      "Mehmet Akif Ersoy": true,
      "Menekşe": true,
      "Mustafalar": true,
      "Müminli": true,
      "Orhangazi": true,
      "Osmangazi": true,
      "Remzi Oğuz Arık": true,
      "Sarıçam": true,
      "Sofudede": true,
      "Suluca": true,
      "Şahintepe": true,
      "Turunçlu": true,
      "Ünlüce": true,
      "Yağızlar": true,
      "Yarımca": true,
      "Yavuz Sultan Selim": true,
      "Yeni": true,
      "Yeniyayla": true,
      "Yeşiltepe": true,
      "Yıldırım Beyazıt": true,
      "Yürekli": true
    },
    "Seyhan": {
      "2000 Evler": true,
      "Ahmet Remzi Yüreğir": true,
      "Akkapı": true,
      "Alidede": true,
      "Aydınlar": true,
      "Bahçelievler": true,
      "Bahçeşehir": true,
      "Barbaros": true,
      "Barış": true,
      "Beşocak": true,
      "Bey": true,
      "Büyükçıldırım": true,
      "Büyükdikili": true,
      "Camuzcu": true,
      "Cemalpaşa": true,
      "Çaputçu": true,
      "Çınarlı": true,
      "Dağlıoğlu": true,
      "Demetevler": true,
      "Denizli": true,
      "Dervişler": true,
      "Dörtağaç": true,
      "Döşeme": true,
      "Dumlupınar": true,
      "Emek": true,
      "Fatih": true,
      "Fevzipaşa": true,
      "Gazipaşa": true,
      "Gökçeler": true,
      "Gölbaşı": true,
      "Gülbahçesi": true,
      "Gülpınar": true,
      "Gürselpaşa": true,
      "Hadırlı": true,
      "Hanedan": true,
      "Havuzlubahçe": true,
      "Hurmalı": true,
      "Hürriyet": true,
      "İsmetpaşa": true,
      "İstiklal": true,
      "Karakuyu": true,
      "Karasoku": true,
      "Karayusuflu": true,
      "Kavaklı": true,
      "Kayalıbağ": true,
      "Kayışlı": true,
      "Kocavezir": true,
      "Koyuncu": true,
      "Koza": true,
      "Köylüoğlu": true,
      "Kurtuluş": true,
      "Kuruköprü": true,
      "Kuyumcular": true,
      "Küçükçıldırım": true,
      "Küçükdikili": true,
      "Mekan": true,
      "Mestanzade": true,
      "Meydan": true,
      "Mıdık": true,
      "Mirzaçelebi": true,
      "Mithatpaşa": true,
      "Mürseloğlu": true,
      "Namık Kemal": true,
      "Narlıca": true,
      "Onur": true,
      "Ova": true,
      "Pınar": true,
      "Reşatbey": true,
      "Sakarya": true,
      "Salmanbeyli": true,
      "Sarıhamzalı": true,
      "Sarıhuğlar": true,
      "Sarıyakup": true,
      "Serinevler": true,
      "Söğütlü": true,
      "Sucuzade": true,
      "Sümer": true,
      "Şakirpaşa": true,
      "Şehitduran": true,
      "Tellidere": true,
      "Tepebağ": true,
      "Türkocağı": true,
      "Uçak": true,
      "Ulucamii": true,
      "Yalmanlı": true,
      "Yeni": true,
      "Yenibaraj": true,
      "Yenibey": true,
      "Yenidam": true,
      "Yeşilevler": true,
      "Yeşiloba": true,
      "Yeşilyurt": true,
      "Yeşilyuva": true,
      "Yolgeçen": true,
      "Zeytinli": true,
      "Ziyapaşa": true
    },
    "Tufanbeyli": {
      "Akçal": true,
      "Akpınar": true,
      "Ayvat": true,
      "Bolatpınarı": true,
      "Bozgüney": true,
      "Cumhuriyet": true,
      "Çatalçam": true,
      "Çukurkışla": true,
      "Damlalı": true,
      "Demiroluk": true,
      "Doğanbeyli": true,
      "Doğanlı": true,
      "Elemanlı": true,
      "Evci": true,
      "Fatmakuyu": true,
      "Güzelim": true,
      "Hanyeri": true,
      "İğdebel": true,
      "İstiklal": true,
      "Karsavran": true,
      "Kayapınar": true,
      "Kayarcık": true,
      "Kirazlıyurt": true,
      "Koccağız": true,
      "Ortaköy": true,
      "Pekmezli": true,
      "Pınarlar": true,
      "Şar": true,
      "Taşpınar": true,
      "Tozlu": true,
      "Yamanlı": true,
      "Yenicami": true,
      "Yeşilova": true
    },
    "Yumurtalık": {
      "Akdeniz": true,
      "Akyuva": true,
      "Asmalı": true,
      "Ayas": true,
      "Ayvalık": true,
      "Demirtaş": true,
      "Deveciuşağı": true,
      "Devrişiye": true,
      "Gölovası": true,
      "Hamzalı": true,
      "Haylazlı": true,
      "Kaldırım": true,
      "Kalemli": true,
      "Kemalpaşa": true,
      "Kesmeburun": true,
      "Kırmızıdam": true,
      "Kuzupınarı": true,
      "Narlıören": true,
      "Ören": true,
      "Sugözü": true,
      "Yeniköy": true,
      "Yeşilköy": true,
      "Yumurtalık": true,
      "Zeytinbeli": true
    },
    "Yüreğir": {
      "19 Mayıs": true,
      "Abdioğlu Cumhuriyet": true,
      "Ağzıbüyük": true,
      "Akarcalı": true,
      "Akdam": true,
      "Akdeniz": true,
      "Akıncılar": true,
      "Akpınar": true,
      "Alihocalı": true,
      "Anadolu": true,
      "Atakent": true,
      "Atatürk": true,
      "Aydıncık": true,
      "Bahçelievler": true,
      "Başak": true,
      "Belören": true,
      "Beyköy": true,
      "Büyükkapılı": true,
      "Camili": true,
      "Cırık": true,
      "Cine": true,
      "Cumhuriyet": true,
      "Çağırkanlı": true,
      "Çamlıbel": true,
      "Çatalpınar": true,
      "Çelemli": true,
      "Çotlu": true,
      "Dadaloğlu": true,
      "Danışment": true,
      "Dede Korkut": true,
      "Dedepınarı": true,
      "Denizkuyusu": true,
      "Dervişler": true,
      "Doğankent Bahçelievler": true,
      "Doğankent Cumhuriyet": true,
      "Doğankent Kışla": true,
      "Düzce": true,
      "Eğriağaç": true,
      "Esenler": true,
      "Eski Misis": true,
      "Gazipaşa": true,
      "Geçitli Cumhuriyet": true,
      "Gökçeli": true,
      "Gümüşyazı": true,
      "Güneşli": true,
      "Güveloğlu": true,
      "Güzel Cumhuriyet": true,
      "Güzelevler": true,
      "Hacıali": true,
      "Havraniye": true,
      "Havutlu": true,
      "Haydaroğlu": true,
      "Herekli": true,
      "Irmakbaşı": true,
      "Kadıköy": true,
      "Kamışlı": true,
      "Karaahmetli": true,
      "Karacaoğlan": true,
      "Kaşlıca": true,
      "Kayarlı": true,
      "Kazım Karabekir": true,
      "Kışla": true,
      "Kiremithane": true,
      "Koza": true,
      "Köklüce": true,
      "Köprügözü": true,
      "Köprülü": true,
      "Kütüklü": true,
      "Levent": true,
      "Mutlu": true,
      "Özgür": true,
      "Özler": true,
      "P.t.t": true,
      "Paşaköy": true,
      "Pekmezli": true,
      "Sağdıçlı": true,
      "Sakızlı": true,
      "Sarıçam": true,
      "Sazak": true,
      "Selahattin Eyyubi": true,
      "Serinevler": true,
      "Seyhan": true,
      "Sinanpaşa": true,
      "Solaklı Cumhuriyet": true,
      "Solaklı Hürriyet": true,
      "Şahinağa": true,
      "Şehit Erkut Akbay": true,
      "Şeyhmurat": true,
      "Tahsilli": true,
      "Taşçı": true,
      "Ulubatlı Hasan": true,
      "Vayvaylı": true,
      "Yahşiler": true,
      "Yakapınar": true,
      "Yalnızca": true,
      "Yamaçlı": true,
      "Yavuzlar": true,
      "Yenice": true,
      "Yenidoğan": true,
      "Yeniköy": true,
      "Yerdelen": true,
      "Yeşil Bağlar": true,
      "Yukarıçiçekli": true,
      "Yunus Emre": true,
      "Yunusoğlu Cumhuriyet": true,
      "Yunusoğlu Hürriyet": true,
      "Zağarlı": true
    }
  },
  "Adıyaman": {
    "Besni": {
      "15 Temmuz Şehitler": true,
      "Abımıstık": true,
      "Adalet": true,
      "Ali Erdemoğlu": true,
      "Aşağısarhan": true,
      "Aşağısöğütlü": true,
      "Atatürk": true,
      "Bayat": true,
      "Boybeypınarı": true,
      "Cirit Meydanı": true,
      "Cumhuriyet": true,
      "Çakmak": true,
      "Çat": true,
      "Dumlupınar": true,
      "Erdemoğlu": true,
      "Fatih": true,
      "Hürriyet": true,
      "İnce": true,
      "İnönü": true,
      "Kaymakam Hasan Tütün": true,
      "Korupınar": true,
      "Köprübaşı": true,
      "Levzin": true,
      "Menderes": true,
      "Oyalı": true,
      "Pınarbaşı": true,
      "Tetirli": true,
      "Turgut Özal": true,
      "Yeni": true,
      "Yeni Besni": true,
      "Yeşilova": true,
      "Yukarı Sarhan": true
    },
    "Çelikhan": {
      "Aktaş": true,
      "Bahçeli Evler": true,
      "Balıkburun": true,
      "Başpınar": true,
      "Cami": true,
      "Cumhuriyet": true,
      "Çamlıyayla": true,
      "Fatih": true,
      "Hacılar": true,
      "İnönü": true,
      "Kaya": true,
      "Kurudere": true,
      "Mahmut Nedim Ökmen": true,
      "Merkez": true,
      "Yunus Emre": true,
      "Zafer": true
    },
    "Gerger": {
      "Fatih": true,
      "Keleşan": true,
      "Merkez": true,
      "Yeni": true
    },
    "Gölbaşı": {
      "Asfalt": true,
      "Cumhuriyet": true,
      "Çakmak": true,
      "Fatih": true,
      "Hürriyet": true,
      "Kalemkas": true,
      "Kurugeçit": true,
      "Merkez": true,
      "Mimar Sinan": true,
      "Yavuz Selim": true,
      "Yeni": true,
      "Yenikent": true
    },
    "Kahta": {
      "Akıncılar Atatürk": true,
      "Atatürk": true,
      "Bağlar": true,
      "Bayraktar": true,
      "Cami": true,
      "Cumhuriyet": true,
      "Çamlıca": true,
      "Çobanlı": true,
      "Fatih": true,
      "Fırat": true,
      "Gazi": true,
      "Girne": true,
      "Hürriyet": true,
      "Kangülü": true,
      "Karşıyaka": true,
      "Kılavuz": true,
      "Menderes": true,
      "Soğuksu": true,
      "Şeyhbaba": true,
      "Turgut Özal": true,
      "Yavuz Selim": true,
      "Yeni": true
    },
    "Merkez": {
      "Alitaşı": true,
      "Altınşehir": true,
      "Bahçecik": true,
      "Bahçelievler": true,
      "Barbaros Hayrettin": true,
      "Cumhuriyet": true,
      "Çatderesi": true,
      "Çimenke": true,
      "Esence": true,
      "Esentepe": true,
      "Eskisaray": true,
      "Fatih": true,
      "Gazi": true,
      "Hasankan": true,
      "Hocaömer": true,
      "Hürriyet": true,
      "İmamağa": true,
      "İncekoz": true,
      "Kapcami": true,
      "Karaçalı": true,
      "Karapınar": true,
      "Kayalık": true,
      "Malazgirt": true,
      "Mara": true,
      "Mehmet Akif": true,
      "Merkez": true,
      "Mimar Sinan": true,
      "Musalla": true,
      "Mustafa Yücel Özbilgin": true,
      "Örenli": true,
      "Serintepe": true,
      "Sıratut": true,
      "Siteler": true,
      "Sümerevler": true,
      "Turgut Reis": true,
      "Türkiye Petrolleri": true,
      "Ulucami": true,
      "Varlık": true,
      "Yakacık": true,
      "Yavuz Selim": true,
      "Yeni": true,
      "Yeni Sanayi": true,
      "Yenipınar": true,
      "Yeşilyurt": true,
      "Yunus Emre": true,
      "Zivar": true
    },
    "Samsat": {
      "Baraj": true,
      "Kale": true,
      "Örentaş": true,
      "Yavuz Selim": true
    },
    "Sincik": {
      "Ayengin": true,
      "Cumhuriyet": true,
      "Çınar": true,
      "Çükan": true,
      "Fatih": true,
      "Fırat": true,
      "Karadağ": true,
      "Karaman": true,
      "Mahmutoğlu": true,
      "Merkez": true,
      "Onur": true,
      "Özbilgin": true,
      "Taşlıca": true,
      "Tuna": true,
      "Zeynel Aslan": true
    },
    "Tut": {
      "Ayniye": true,
      "Bulanık": true,
      "Cumhuriyet": true,
      "Çamlıca": true,
      "Fethiye": true,
      "Reşadiye": true,
      "Salah": true
    }
  },
  "Afyonkarahisar": {
    "Başmakçı": {
      "Aşağı Hilal": true,
      "Barbaros": true,
      "Çağlayan": true,
      "Fatih": true,
      "Gülistan": true,
      "Mimar Sinan": true,
      "Yeni": true,
      "Yukarı Hilal": true
    },
    "Bayat": {
      "Büyük": true,
      "Cumhuriyet": true,
      "Hürriyet": true,
      "Yeni": true
    },
    "Bolvadin": {
      "Akçeşme": true,
      "Alaca": true,
      "Bademli": true,
      "Bağlarbaşı": true,
      "Bağlarüstü": true,
      "Bahçelievler": true,
      "Bucak": true,
      "Cirit": true,
      "Çaybaşı": true,
      "Emrullah": true,
      "Erkmen": true,
      "Ethem Kelekçi": true,
      "Fatih": true,
      "Gökçeyayla": true,
      "Gölbaşı": true,
      "Hacı Halife": true,
      "Hacı Ömer": true,
      "Hisar": true,
      "İhsaniye": true,
      "Karabağ": true,
      "Kaymaz": true,
      "Kırkgöz": true,
      "Konak": true,
      "Köprübaşı": true,
      "Lala Sinan Paşa": true,
      "Malazgirt": true,
      "Mevlana": true,
      "Müslümana": true,
      "Okul": true,
      "Selçuklu": true,
      "Şehirönü": true,
      "Şeyh Şamil": true,
      "Şıhlar": true,
      "Taşağıl": true,
      "Ulucami": true,
      "Üsküdar": true,
      "Yakup Şevki Paşa": true,
      "Yavuz Selim": true,
      "Yeni": true,
      "Yenice": true,
      "Yukarı": true,
      "Yunus Emre": true
    },
    "Çay": {
      "Afyon": true,
      "Aktaş": true,
      "Ali Ihsan Paşa": true,
      "Ali Kaleli": true,
      "Aşağı": true,
      "Bağlar": true,
      "Bahçelievler": true,
      "Beşevler": true,
      "Cedit": true,
      "Demirağaç": true,
      "Dumlupınar": true,
      "Elbiz": true,
      "İstasyon": true,
      "Karabulut": true,
      "Köprübaşı": true,
      "Orta": true,
      "Seka": true,
      "Şirinevler": true,
      "Tekke": true,
      "Vakıf": true,
      "Yaka": true,
      "Yeşilevler": true,
      "Yukarı": true
    },
    "Çobanlar": {
      "Atatürk": true,
      "Bucak": true,
      "Cumhuriyet": true,
      "Fatih": true,
      "Gölcük": true,
      "Işık": true,
      "İstiklal": true,
      "Karadede": true,
      "Sırakapı": true,
      "Termalkent": true,
      "Yavuz Selim": true,
      "Yeni": true,
      "Zafer": true
    },
    "Dazkırı": {
      "Barbaros": true,
      "Çamlık": true,
      "Esentepe": true,
      "Kurtuluş": true,
      "Yeniyol": true,
      "Yeşilyurt": true
    },
    "Dinar": {
      "Adliye": true,
      "Altınhisar": true,
      "Altmışevler": true,
      "Atatürk": true,
      "Bağlar": true,
      "Camikebir": true,
      "Cumhuriyet": true,
      "Çağlayan": true,
      "Çamlıca": true,
      "Dörtyol": true,
      "Emniyet": true,
      "Fatih": true,
      "Gazi Mehmet Çavuş": true,
      "Hürriyet": true,
      "Ilıca": true,
      "İncirli": true,
      "İstasyon": true,
      "İstiklal": true,
      "İtfaiye": true,
      "Konak": true,
      "Korubaşı": true,
      "Merkez": true,
      "Ocaklı": true,
      "Otogar": true,
      "Örnek": true,
      "Pancar": true,
      "Pazar": true,
      "Pınarbaşı": true,
      "Sanayi": true,
      "Santral": true,
      "Stadyum": true,
      "Suçıkan": true,
      "Toptepe": true,
      "Üçlerce": true,
      "Yeni": true,
      "Yeşilyurt": true
    },
    "Emirdağ": {
      "Adaçal": true,
      "Alasakallı": true,
      "Aziziye": true,
      "Bağlarbaşı": true,
      "Cumhuriyet": true,
      "Çilli": true,
      "Domurlu": true,
      "Dörtyol": true,
      "Emirbaba": true,
      "Eski Kacerli": true,
      "Fatih": true,
      "Gökçeyaka": true,
      "Hisarköy": true,
      "İncik": true,
      "İncili": true,
      "İnkilap": true,
      "Karakuyu": true,
      "Karşıyaka": true,
      "Menderes": true,
      "Sofulu": true,
      "Toki": true,
      "Yeni": true,
      "Yeni Kacerli": true,
      "Yenidoğan": true
    },
    "Evciler": {
      "Camikebir": true,
      "Fatih": true,
      "Kayalık": true,
      "Mehmet Akif": true,
      "Yavuz Selim": true,
      "Yunus Emre": true
    },
    "Hocalar": {
      "Hürriyet": true,
      "Şafak": true,
      "Yeni": true
    },
    "İhsaniye": {
      "Akören": true,
      "Atatürk": true,
      "Bahçelievler": true,
      "Belce": true,
      "Cumhuriyet": true,
      "Esentepe": true,
      "Fatih": true,
      "Hürriyet": true,
      "Kervansaray": true,
      "Kunduzlu": true,
      "Pınar": true,
      "Susuz Osmaniye": true,
      "Şahinler": true,
      "Türbe": true,
      "Yeni": true,
      "Yenikent": true,
      "Yunus Emre": true,
      "Zafer": true
    },
    "İscehisar": {
      "Cumhuriyet": true,
      "Çukur": true,
      "Esentepe": true,
      "Eski Hamam": true,
      "Fatih": true,
      "Hasan Basri": true,
      "Kavak": true,
      "Kurtuluş": true,
      "Medrese": true,
      "Selçuklu": true,
      "Şirinevler": true,
      "Tepecik": true,
      "Zeybek": true
    },
    "Kızılören": {
      "Cumhuriyet": true,
      "Yeni": true
    },
    "Merkez": {
      "Akçin": true,
      "Akmescit": true,
      "Ali Çetinkaya": true,
      "Ali Ihsan Paşa": true,
      "Altındağ": true,
      "Ataköy": true,
      "Atatürk": true,
      "Barbaros": true,
      "Battalgazi": true,
      "Bayatcık": true,
      "Beyazıt": true,
      "Burmalı": true,
      "Cumhuriyet": true,
      "Çakır": true,
      "Dairecep": true,
      "Demirçevre": true,
      "Derviş Paşa": true,
      "Dörtyol": true,
      "Dumlupınar": true,
      "Erenler": true,
      "Ertuğrul Gazi": true,
      "Esentepe": true,
      "Eşrefpaşa": true,
      "Fakıpaşa": true,
      "Fatih": true,
      "Fevzi Çakmak": true,
      "Gazi": true,
      "Gökhan": true,
      "Gültepe": true,
      "Gümüş Tepe": true,
      "Güvenevler": true,
      "Halil Ibrahim Sultan": true,
      "Hamidiye": true,
      "Hasan Karaağaç": true,
      "Hattat Karahisar": true,
      "Hisar": true,
      "Hoca Ahmet Yesevi": true,
      "Huzur": true,
      "Hürriyet": true,
      "İsmail": true,
      "İstiklal": true,
      "Kanlıca": true,
      "Karaman": true,
      "Karşıyaka": true,
      "Kasımpaşa": true,
      "Kayadibi": true,
      "Kışlacık": true,
      "Kocatepe": true,
      "Kurtuluş": true,
      "Mareşal Fevzi Çakmak": true,
      "Marulcu": true,
      "Mecidiye": true,
      "Mehmet Akif": true,
      "Nazmi Saatçi": true,
      "Olucak": true,
      "Orhangazi": true,
      "Osman Gazi": true,
      "Osmanlı": true,
      "Örnek": true,
      "Örnekevler": true,
      "Sadıkbey": true,
      "Sahipata": true,
      "Sakarya": true,
      "Selçuklu": true,
      "Sümer": true,
      "Şehit Ahmet": true,
      "Şeker": true,
      "Tacı Ahmet": true,
      "Taşpınar": true,
      "Uğur": true,
      "Ulucami": true,
      "Veysel Karani": true,
      "Yaka": true,
      "Yarenler": true,
      "Yavuz Selim": true,
      "Yeni": true,
      "Yenice": true,
      "Yeşilyurt": true,
      "Yunus Emre": true,
      "Yunuslar": true,
      "Zafer": true
    },
    "Sandıklı": {
      "Cuma": true,
      "Çakır": true,
      "Çay": true,
      "Çiğiltepe": true,
      "Dikmen": true,
      "Ece": true,
      "Fatih": true,
      "Hisar": true,
      "İstasyon": true,
      "Kevser": true,
      "Sazak": true,
      "Şirinevler": true,
      "Tapduk Emre": true,
      "Yunus Emre": true,
      "Zafer": true
    },
    "Sinanpaşa": {
      "Akpınar": true,
      "Ali Çetinkaya": true,
      "Ambar": true,
      "Aşağı": true,
      "Atatürk": true,
      "Bağdat": true,
      "Bahçelievler": true,
      "Cumhuriyet": true,
      "Çalışlar": true,
      "Çankaya": true,
      "Çınarlı": true,
      "Çiğiltepe": true,
      "Dibekbaşı": true,
      "Fatih": true,
      "Fevzi Çakmak": true,
      "Gölcük": true,
      "Halkalı": true,
      "Hisar": true,
      "Hozman": true,
      "Hürriyet": true,
      "Işık": true,
      "Kocatepe": true,
      "Köprübaşı": true,
      "Kurtuluş": true,
      "Küçüktepe": true,
      "Kümbet": true,
      "Orta": true,
      "Öğretmenler": true,
      "Saray": true,
      "Yavuz Sultan Selim": true,
      "Yeni": true,
      "Yıldırım Beyazıt": true,
      "Yukarı": true,
      "Zafer": true
    },
    "Sultandağı": {
      "Akpınar": true,
      "Aşağı": true,
      "Atatürk": true,
      "Camikebir": true,
      "Cumhuriyet": true,
      "Çavuş": true,
      "Karaman": true,
      "Kavaklı": true,
      "Kayran": true,
      "Pazaraltı": true,
      "Selçuk": true,
      "Sıra": true,
      "Tepebaşı": true,
      "Yeni": true,
      "Yenikent": true,
      "Yıldırım": true,
      "Yıldız": true,
      "Yukarı": true
    },
    "Şuhut": {
      "Altıgöz": true,
      "Baş": true,
      "Çağlayan": true,
      "Develi": true,
      "Erenler": true,
      "Gazipaşa": true,
      "Hacı Musa": true,
      "Hisar": true,
      "İplik": true,
      "İstiklal": true,
      "Kurtuluş": true,
      "Mehmet Akif Ersoy": true,
      "Pazar": true,
      "Taşlıca": true,
      "Yalı": true,
      "Zafer": true
    }
  },
  "Ağrı": {
    "Diyadin": {
      "14 Nisan": true,
      "Atatürk": true,
      "Fatih": true,
      "Göl": true,
      "İsaağa": true,
      "Ketenpınar": true,
      "Murat": true
    },
    "Doğubayazıt": {
      "Abdigör": true,
      "Ahmedihani": true,
      "Barış": true,
      "Büyük Ağrı": true,
      "Çiftepınar": true,
      "Hasankeyf": true,
      "Hürriyet": true,
      "İshakpaşa": true,
      "Koçkıran": true,
      "Sanayi": true,
      "Sarıgül": true,
      "Uluyol": true,
      "Vatan": true,
      "Yeni": true
    },
    "Eleşkirt": {
      "Aşağıcihanbey": true,
      "Aydıntepe": true,
      "Cumhuriyet": true,
      "Değirmengeçidi": true,
      "Esentepe": true,
      "Fatih": true,
      "Gökçayır": true,
      "Hürriyet": true,
      "İstiklal": true,
      "Karşıyaka": true,
      "Kazım Karabekir": true,
      "Lozan": true,
      "Müftüselim": true,
      "Oklavalı": true,
      "Şehit Engin": true,
      "Yeşil": true,
      "Yeşilyurt": true
    },
    "Hamur": {
      "Buzhane": true,
      "Kale": true,
      "Kümbet": true,
      "Yeni": true
    },
    "Merkez": {
      "100.yıl": true,
      "Abide": true,
      "Alpaslan": true,
      "Aşağıküpkıran": true,
      "Bahçelievler": true,
      "Cumhuriyet": true,
      "Fatih": true,
      "Fevzi Çakmak": true,
      "Fırat": true,
      "Gazi": true,
      "Hürriyet": true,
      "Kazım Karabekir": true,
      "Kurtuluş": true,
      "Leylek Pınar": true,
      "Mehmet Akif Ersoy": true,
      "Murat": true,
      "Sıtkıye": true,
      "Yavuz": true
    },
    "Patnos": {
      "14 Nisan": true,
      "Abdulvehap Küfrevi": true,
      "Ahmed-i Hani": true,
      "Akbulut": true,
      "Alpaslan": true,
      "Atatürk": true,
      "Badişan": true,
      "Budak": true,
      "Cami": true,
      "Cumhuriyet": true,
      "Çay": true,
      "Çaybaşı": true,
      "Değirmen": true,
      "İnönü": true,
      "Merkez": true,
      "Sanayi": true,
      "Sarısu": true,
      "Selahaddini Eyyubi": true,
      "Serhad": true,
      "Süphan Dağı": true,
      "Sütlü Pınar": true,
      "Turgut Özal": true,
      "Üzümlü": true,
      "Yeni": true,
      "Yeşil Çimen": true,
      "Yeşilova": true,
      "Yunusemre": true
    },
    "Taşlıçay": {
      "15 Temmuz Şehitler": true,
      "Adnan Menderes": true,
      "Cumhuriyet": true,
      "Hürriyet": true
    },
    "Tutak": {
      "Cami": true,
      "Karşıyaka": true,
      "Murat": true,
      "Pınar": true,
      "Yeni": true
    }
  },
  "Aksaray": {
    "Ağaçören": {
      "Gümüştepe": true,
      "Kale": true,
      "Yeni": true,
      "Yenişabanlı": true,
      "Yurtsever": true,
      "Zafer": true
    },
    "Eskil": {
      "Aydınlık": true,
      "Camikebir": true,
      "Cumhuriyet": true,
      "Çulfa": true,
      "Fatih": true,
      "Fevzi Çakmak": true,
      "Hürriyet": true,
      "İstiklal": true,
      "Karşıyaka": true,
      "Kayacık": true,
      "Merkez": true,
      "Mimar Sinan": true,
      "Muratlı": true,
      "Yavuz Sultan Selim": true,
      "Yeni": true,
      "Yeşilyurt": true,
      "Yıldırım": true,
      "Zafer": true
    },
    "Gülağaç": {
      "Atatürk": true,
      "Cumhuriyet": true,
      "Eskicami": true,
      "Fatih": true,
      "Hürriyet": true,
      "İstiklal": true,
      "Kalealtı": true,
      "Karşıyaka": true,
      "Koyunlu": true,
      "Kurtuluş": true,
      "Meydan": true,
      "Pınarbaşı": true,
      "Tuzla": true,
      "Yeni": true,
      "Yenipazar": true,
      "Zafer": true
    },
    "Güzelyurt": {
      "Akpınar": true,
      "Akyamaç": true,
      "Aşağı": true,
      "Harmanlık": true,
      "Karşıyaka": true,
      "Kayaaltı": true,
      "Kayaardı": true,
      "Köprübaşı": true,
      "Yeni": true,
      "Yukarı": true
    },
    "Merkez": {
      "Alasakallı": true,
      "Aratol Bahçeli": true,
      "Aratol Istiklal": true,
      "Aydınlar": true,
      "Bahçeli": true,
      "Bahçesaray": true,
      "Bayrambaba": true,
      "Bedir Muhtar": true,
      "Boğaziçi": true,
      "Büyük Bölcek": true,
      "Coğlaki": true,
      "Cumhuriyet": true,
      "Çalışkan": true,
      "Çerdiğin": true,
      "Çiftlik": true,
      "Çimeli": true,
      "Dere": true,
      "Divanoğlu": true,
      "Ereğlikapı": true,
      "Erenler": true,
      "Fatih": true,
      "Gazi": true,
      "Gülhane": true,
      "Hacıhasanlı": true,
      "Hacılar Harmanı": true,
      "Hamidiye": true,
      "Hasas": true,
      "Hürriyet": true,
      "İstiklal": true,
      "Kalanlar": true,
      "Kılıçaslan": true,
      "Kırımlı": true,
      "Kirazlı": true,
      "Köseli": true,
      "Kurtuluş": true,
      "Küçük Bölcek": true,
      "Laleli": true,
      "Medeni": true,
      "Mehmet Akif Ersoy": true,
      "Meydan": true,
      "Minarecik": true,
      "Muhsin Çelebi": true,
      "Nakkaş": true,
      "Pamucak": true,
      "Parabaşlı": true,
      "Paşacık": true,
      "Pınar": true,
      "Sanayi": true,
      "Selçuklu": true,
      "Sofular": true,
      "Somuncu Baba": true,
      "Şamlı": true,
      "Şeyhhamit": true,
      "Şifahane": true,
      "Tacin": true,
      "Taşpazar": true,
      "Yavuz Selim": true,
      "Yavuz Sultan Selim": true,
      "Yeni Cami": true,
      "Yenimahalle": true,
      "Yeşilçam": true,
      "Yunus Emre": true,
      "Zafer": true,
      "Zincirli": true
    },
    "Ortaköy": {
      "Balcı": true,
      "Çankaya": true,
      "Esentepe": true,
      "Fatih": true,
      "İstiklal": true,
      "Karşı": true,
      "Kızılay": true,
      "Maltepe": true,
      "Mehmet Akif Ersoy": true,
      "Plevne": true,
      "Yeni": true,
      "Zafer": true
    },
    "Sarıyahşi": {
      "15 Temmuz": true,
      "Fatih": true,
      "Karşıyaka": true,
      "Kızılırmak": true,
      "Kurtuluş": true,
      "Özal": true,
      "Şafaktepe": true,
      "Yenidoğan": true
    },
    "Sultanhanı": {
      "Cumhuriyet": true,
      "Gazi": true,
      "İstikamet": true,
      "Koyuncu": true,
      "Selçuk": true,
      "Türkistan": true,
      "Zafer": true
    }
  },
  "Amasya": {
    "Göynücek": {
      "Cumhuriyet": true,
      "Merkez": true,
      "Yeni": true
    },
    "Gümüşhacıköy": {
      "Adatepe": true,
      "Ağcadede": true,
      "Artıkabat": true,
      "Camikebir": true,
      "Cumara": true,
      "Çay": true,
      "Hacıyahya": true,
      "Irgat": true,
      "Saray": true,
      "Şıhlar": true,
      "Tekke": true,
      "Yenicami": true
    },
    "Hamamözü": {
      "Arkutbey": true,
      "Hamitkaplan": true,
      "Köprübaşı": true,
      "Saray": true
    },
    "Merkez": {
      "Akbilek": true,
      "Aşağı": true,
      "Bahçeleriçi": true,
      "Beyazıtpaşa": true,
      "Boğazköy": true,
      "Çakallar": true,
      "Demet Evler": true,
      "Dere": true,
      "Ellibeşevler": true,
      "Fethiye": true,
      "Fındıklı": true,
      "Gökmedrese": true,
      "Göllü Bağları": true,
      "Gümüşlü": true,
      "Hacı Ilyas": true,
      "Hacılar Meydanı": true,
      "Hatuniye": true,
      "Helvacı": true,
      "Hızırpaşa": true,
      "İhsaniye": true,
      "Karasenir": true,
      "Kirazlıdere": true,
      "Koza": true,
      "Kurşunlu": true,
      "Mehmet Paşa": true,
      "Nergiz": true,
      "Orman Bağları": true,
      "Pirinççi": true,
      "Saraycık": true,
      "Savadiye": true,
      "Sofular": true,
      "Şamlar": true,
      "Şehirüstü": true,
      "Şeyhcui": true,
      "Üçler": true,
      "Yazı Bağları": true,
      "Yeniköy": true,
      "Yeşilyenice": true,
      "Yukarı": true,
      "Yüzevler": true
    },
    "Merzifon": {
      "Abidehatun": true,
      "Bağlarbaşı": true,
      "Bahçelievler": true,
      "Buğdaylı": true,
      "Camicedit": true,
      "Eski Camii": true,
      "Gazimahbup": true,
      "Hacıbalı": true,
      "Hacıhasan": true,
      "Harmanlar": true,
      "Hocasüleyman": true,
      "Kümbet Hatun": true,
      "Mahsen": true,
      "Mehmet Akif Ersoy": true,
      "Naccar": true,
      "Nusratiye": true,
      "Sofular": true,
      "Tavşan": true,
      "Yeni": true,
      "Yunus Emre": true
    },
    "Suluova": {
      "Ata": true,
      "Beyazıt": true,
      "Bir Eylül": true,
      "Borsa": true,
      "Cevizdibi": true,
      "Cumhuriyet": true,
      "Çeltekmadeni": true,
      "Eymir": true,
      "Fatih": true,
      "Girne": true,
      "Hacıbayram": true,
      "Hacıhayta": true,
      "Hürriyet": true,
      "Maarif": true,
      "Magosa": true,
      "Orta": true,
      "Pazar": true,
      "Saraydüzü": true,
      "Şeker": true,
      "Yeni": true,
      "Yenidoğan": true
    },
    "Taşova": {
      "Cumhuriyet": true,
      "Doğu": true,
      "Sanayii": true,
      "Tepe": true,
      "Yemişen": true,
      "Yeni": true,
      "Yeşilırmak": true
    }
  },
  "Ankara": {
    "Akyurt": {
      "Ahmetadil": true,
      "Atatürk": true,
      "Balıkhisar": true,
      "Beyazıt": true,
      "Büğdüz": true,
      "Cücük": true,
      "Çam": true,
      "Çardakbağı": true,
      "Çınar": true,
      "Elecik": true,
      "Galaba": true,
      "Güzelhisar": true,
      "Haydar": true,
      "Karacakaya": true,
      "Karacalar": true,
      "Karayatak": true,
      "Kızık": true,
      "Kozayağı": true,
      "Samut": true,
      "Saracalar": true,
      "Şeyhler": true,
      "Teberik": true,
      "Timurhan": true,
      "Uzunlar": true,
      "Yeşiltepe": true,
      "Yıldırım": true
    },
    "Altındağ": {
      "Atıfbey": true,
      "Aydıncık": true,
      "Aydınlıkevler": true,
      "Baraj": true,
      "Başpınar": true,
      "Battalgazi": true,
      "Beşikkaya": true,
      "Doğantepe": true,
      "Feridun Çelik": true,
      "Gicik": true,
      "Gültepe": true,
      "Güneşevler": true,
      "Hacettepe": true,
      "Hacı Bayram": true,
      "Kale": true,
      "Karacaören": true,
      "Karapürçek": true,
      "Kavaklı": true,
      "Önder": true,
      "Örnek": true,
      "Peçenek": true,
      "Solfasol": true,
      "Tatlar": true,
      "Ulubey": true,
      "Yıldıztepe": true,
      "Zübeyde Hanım": true
    },
    "Ayaş": {
      "Akkaya": true,
      "Başayaş": true,
      "Başbereket": true,
      "Bayat": true,
      "Bayram": true,
      "Camiatik": true,
      "Çanıllı Çiğdemci": true,
      "Çanıllı Uluyol": true,
      "Dervişimam": true,
      "Emine Tevfika Ayaşlı": true,
      "Evci": true,
      "Ferahfaki": true,
      "Feruz": true,
      "Gençali": true,
      "Gökçebağ": true,
      "Gökler": true,
      "Hacımemi": true,
      "Hacırecep": true,
      "Hacıveli": true,
      "Ilıca": true,
      "İlhanköy": true,
      "Oltan": true,
      "Ortabereket": true,
      "Ömeroğlu": true,
      "Pınaryaka": true,
      "Sinanlı Cuma": true,
      "Sinanlı Hocasinan": true,
      "Sinanlı Mahkeme": true,
      "Şeyhmuhittin": true,
      "Tekke": true,
      "Uğurçayırı": true,
      "Ulupınar": true,
      "Yağmurdede": true
    },
    "Bala": {
      "Abazlı": true,
      "Afşar": true,
      "Ahmetçayırı": true,
      "Akkoyunlu": true,
      "Aşağıhacıbekir": true,
      "Aşıkoğlu": true,
      "Aydoğan": true,
      "Bahçekaradalak": true,
      "Bektaşlı": true,
      "Belçarşak": true,
      "Beynam": true,
      "Büyükbayat": true,
      "Büyükboyalık": true,
      "Büyükcamili": true,
      "Çatalçeşme": true,
      "Çatalören": true,
      "Çiğdemli": true,
      "Davdanlı": true,
      "Derekışla": true,
      "Eğribasan": true,
      "Ergin": true,
      "Göztepe": true,
      "Gülbağı": true,
      "Hamidiye": true,
      "Hanburun": true,
      "İsmetpaşa": true,
      "Karahamzalı": true,
      "Kartaltepe": true,
      "Kerişli": true,
      "Kesikköprü": true,
      "Kesikköprü Erdemli": true,
      "Kesikköprü Kızılırmak": true,
      "Koçyayla": true,
      "Köseli": true,
      "Kuyular": true,
      "Küçükbayat": true,
      "Küçükbıyık": true,
      "Küçükboyalık": true,
      "Küçükcamili": true,
      "Sarıhüyük": true,
      "Sırapınar": true,
      "Sofular": true,
      "Suyugüzel": true,
      "Şehriban": true,
      "Şentepe": true,
      "Tatarhüyük": true,
      "Tepeköy": true,
      "Tolköy": true,
      "Üçem": true,
      "Yaylalıözü": true,
      "Yeniköy": true,
      "Yeniyapançarşak": true,
      "Yeniyapanşeyhli": true,
      "Yöreli": true,
      "Yukarıhacıbekir": true
    },
    "Beypazarı": {
      "Acısu": true,
      "Adaören": true,
      "Akçakavak": true,
      "Akçalı": true,
      "Aşağıgüney": true,
      "Ayvaşık": true,
      "Bağözü": true,
      "Başağaç": true,
      "Başören": true,
      "Batça": true,
      "Beytepe": true,
      "Boyalı": true,
      "Cumhuriyet": true,
      "Çakıloba": true,
      "Çantırlı": true,
      "Dağşeyhler": true,
      "Dereli": true,
      "Dibecik": true,
      "Dibekören": true,
      "Dikmen": true,
      "Doğançalı": true,
      "Doğanyurt": true,
      "Dudaş": true,
      "Fasıl": true,
      "Gazipaşa": true,
      "Geyikpınarı": true,
      "Gürsöğüt": true,
      "Hacıkara": true,
      "Harmancık": true,
      "Haydarlar": true,
      "Hırkatepe": true,
      "İncepelit": true,
      "İstiklal": true,
      "Kabaca": true,
      "Kabalar": true,
      "Kaplan": true,
      "Kapullu": true,
      "Karacaören": true,
      "Karaören": true,
      "Karaşar": true,
      "Kargı": true,
      "Kayabükü": true,
      "Kerbanlar": true,
      "Kırbaşı": true,
      "Kırşeyhler": true,
      "Kızılcasöğüt": true,
      "Kozağaç": true,
      "Kozalan": true,
      "Köseler": true,
      "Köst": true,
      "Kurtkovan": true,
      "Kurtuluş": true,
      "Kuyucak": true,
      "Kuyumcutekke": true,
      "Macun": true,
      "Mahmutlar": true,
      "Mençeler": true,
      "Mikail": true,
      "Nuhhoca": true,
      "Oymaağaç": true,
      "Rüstempaşa": true,
      "Saray": true,
      "Sarıağıl": true,
      "Sekli": true,
      "Sopçaalan": true,
      "Tacettin": true,
      "Tahir": true,
      "Uruş": true,
      "Uşakgöl": true,
      "Üreğil": true,
      "Yalnızçam": true,
      "Yeşilağaç": true,
      "Yıldız": true,
      "Yiğerler": true,
      "Yoğunpelit": true,
      "Yukarıgüney": true,
      "Yukarıulucak": true,
      "Zafer": true
    },
    "Çamlıdere": {
      "Ahatlar": true,
      "Akkaya": true,
      "Alakoç": true,
      "Atça": true,
      "Avdan": true,
      "Avşarlar": true,
      "Bardakçılar": true,
      "Bayındır": true,
      "Beşbeyler": true,
      "Beyler": true,
      "Bökeler": true,
      "Buğralar": true,
      "Çamköy": true,
      "Çukurören": true,
      "Dağkuzören": true,
      "Doğancı": true,
      "Doğanlar": true,
      "Doymuş": true,
      "Dörtkonak": true,
      "Eldelek": true,
      "Elmalı": true,
      "Elören": true,
      "Elvanlar": true,
      "Gümele": true,
      "Güney": true,
      "İnceöz": true,
      "Kayabaşı": true,
      "Körler": true,
      "Kuşçular": true,
      "Kuyubaşı": true,
      "Meşeler": true,
      "Muzrupağacın": true,
      "Müsellim": true,
      "Orta": true,
      "Osmansin": true,
      "Ömerağa": true,
      "Örenköy": true,
      "Özmüş": true,
      "Peçenek": true,
      "Pelitçik": true,
      "Sarıkavak": true,
      "Tatlak": true,
      "Yahşihan": true,
      "Yahyalar": true,
      "Yayalar": true,
      "Yediören": true,
      "Yılanlı": true,
      "Yoncatepe": true
    },
    "Çankaya": {
      "100.yıl": true,
      "50.yıl": true,
      "Ahlatlıbel": true,
      "Akarlar": true,
      "Akpınar": true,
      "Alacaatlı": true,
      "Anıttepe": true,
      "Arka Topraklık": true,
      "Aşağı Imrahor": true,
      "Aşağı Öveçler": true,
      "Aşıkpaşa": true,
      "Ata": true,
      "Aydınlar": true,
      "Ayrancı": true,
      "Aziziye": true,
      "Bademlidere": true,
      "Bağcılar": true,
      "Bahçelievler": true,
      "Balgat": true,
      "Barbaros": true,
      "Bayraktar": true,
      "Beytepe": true,
      "Birlik": true,
      "Boztepe": true,
      "Büyükesat": true,
      "Cebeci": true,
      "Cevizlidere": true,
      "Cumhuriyet": true,
      "Çamlıtepe": true,
      "Çankaya": true,
      "Çavuşlu": true,
      "Çayyolu": true,
      "Çiğdem": true,
      "Çukurambar": true,
      "Devlet": true,
      "Dilekler": true,
      "Dodurga": true,
      "Doğuş": true,
      "Dumlupınar": true,
      "Ehlibeyt": true,
      "Emek": true,
      "Ertuğrulgazi": true,
      "Erzurum": true,
      "Esatoğlu": true,
      "Eti": true,
      "Evciler": true,
      "Fakülteler": true,
      "Fidanlık": true,
      "Gaziosmanpaşa": true,
      "Gökkuşağı": true,
      "Göktürk": true,
      "Güvenevler": true,
      "Güzeltepe": true,
      "Harbiye": true,
      "Hilal": true,
      "Huzur": true,
      "İleri": true,
      "İlkadım": true,
      "İlkbahar": true,
      "İlker": true,
      "İncesu": true,
      "İşçi Blokları": true,
      "Karahasanlı": true,
      "Karapınar": true,
      "Karataş": true,
      "Kavaklıdere": true,
      "Kazım Özalp": true,
      "Keklik Pınarı": true,
      "Kırkkonaklar": true,
      "Kızılay": true,
      "Kızılırmak": true,
      "Kocatepe": true,
      "Konutkent": true,
      "Korkutreis": true,
      "Koru": true,
      "Kömürcü": true,
      "Küçükesat": true,
      "Kültür": true,
      "Malazgirt": true,
      "Maltepe": true,
      "Mebusevleri": true,
      "Meşrutiyet": true,
      "Metin Akkuş": true,
      "Metin Oktay": true,
      "Mimar Sinan": true,
      "Muhsin Ertuğrul": true,
      "Murat": true,
      "Mustafa Kemal": true,
      "Mutlukent": true,
      "Mürsel Uluç": true,
      "Naci Çakır": true,
      "Nasuh Akar": true,
      "Oğuzlar": true,
      "Oran": true,
      "Orta Imrahor": true,
      "Osman Temiz": true,
      "Ön Cebeci": true,
      "Öveçler": true,
      "Prof. Dr. Ahmet Taner Kışlalı": true,
      "Remzi Oğuz Arık": true,
      "Sağlık": true,
      "Sancak": true,
      "Seyranbağları": true,
      "Sokullu Mehmet Paşa": true,
      "Söğütözü": true,
      "Şehit Cengiz Karaca": true,
      "Şehit Cevdet Özdemir": true,
      "Tınaztepe": true,
      "Tohumlar": true,
      "Topraklık": true,
      "Umut": true,
      "Ümit": true,
      "Üniversiteler": true,
      "Yakupabdal": true,
      "Yaşamkent": true,
      "Yayla": true,
      "Yeşilkent": true,
      "Yıldızevler": true,
      "Yukarı Bahçelievler": true,
      "Yukarı Dikmen": true,
      "Yukarı Öveçler": true,
      "Yücetepe": true,
      "Zafertepe": true
    },
    "Çubuk": {
      "Ağılcık": true,
      "Akbayır": true,
      "Akkuzulu": true,
      "Aşağıçavundur": true,
      "Aşağıemirler": true,
      "Aşağıobruk": true,
      "Atatürk": true,
      "Avcıova": true,
      "Barbaros": true,
      "Camili": true,
      "Cumhuriyet": true,
      "Çatokcular": true,
      "Çitköy": true,
      "Dağkalafat": true,
      "Dalyasan": true,
      "Dedeler": true,
      "Demirci": true,
      "Dumlupınar": true,
      "Durhasan": true,
      "Eğriekin": true,
      "Esenboğa Merkez": true,
      "Eskiçöte": true,
      "Fatih": true,
      "Gökçedere": true,
      "Güldarpı": true,
      "Gümüşyayla": true,
      "Hacılar": true,
      "İkipınar": true,
      "İmamhüseyin": true,
      "Kapaklı": true,
      "Karaağaç": true,
      "Karaçam": true,
      "Karadana": true,
      "Karaman": true,
      "Karataş": true,
      "Kargın": true,
      "Kavaklı": true,
      "Kışlacık": true,
      "Kızılca": true,
      "Kızılören": true,
      "Kızılöz": true,
      "Kösrelik": true,
      "Kuruçay": true,
      "Kutuören": true,
      "Kuyumcu": true,
      "Küçükali": true,
      "Mahmutoğlan": true,
      "Melikşah": true,
      "Meşeli": true,
      "Muhsin Yazıcıoğlu": true,
      "Mutlu": true,
      "Nusratlar": true,
      "Okçular": true,
      "Ovacık": true,
      "Oyumiğde": true,
      "Ömercik": true,
      "Özlüce": true,
      "Saraycık": true,
      "Sarıkoz": true,
      "Sarısu": true,
      "Sele": true,
      "Sığırlıhacı": true,
      "Susuz": true,
      "Sünlü": true,
      "Tahtayazı": true,
      "Taşpınar": true,
      "Tuğla": true,
      "Uluağaç": true,
      "Yakuphasan": true,
      "Yavuzselim": true,
      "Yaylak": true,
      "Yazır": true,
      "Yazlıca": true,
      "Yenice": true,
      "Yeşilkent": true,
      "Yıldırım Beyazıt": true,
      "Yıldırımaydoğan": true,
      "Yıldırımelören": true,
      "Yıldırımevci": true,
      "Yılmazköy": true,
      "Yiğitli": true,
      "Yukarı Çavundur": true,
      "Yukarıemirler": true,
      "Yukarıobruk": true
    },
    "Elmadağ": {
      "Akçaali": true,
      "Aşağıkamışlı": true,
      "Deliler": true,
      "Ediğe": true,
      "Gümüşpala": true,
      "Hasanoğlan Bahçelievler": true,
      "Hasanoğlan Fatih": true,
      "Hasanoğlan Havuzbaşı": true,
      "İsmetpaşa": true,
      "İstasyon": true,
      "Karacahasan": true,
      "Kayadibi": true,
      "Kemalpaşa": true,
      "Kurtuluş": true,
      "Kuşçuali": true,
      "Lalabel": true,
      "Muzaffer Ekşi": true,
      "Seyitcemali": true,
      "Süleymanlı": true,
      "Şehitlik": true,
      "Taburlar": true,
      "Tatlıca": true,
      "Tekke": true,
      "Üçevler": true,
      "Yenice": true,
      "Yenidoğan": true,
      "Yenimahalle": true,
      "Yenipınar": true,
      "Yeşildere Fatih": true,
      "Yukarıkamışlı": true
    },
    "Etimesgut": {
      "30 Ağustos": true,
      "Ahi Mesut": true,
      "Alsancak": true,
      "Altay": true,
      "Aşağıyurtçu": true,
      "Atakent": true,
      "Atayurt": true,
      "Ayyıldız": true,
      "Bağlıca": true,
      "Bahçekapı": true,
      "Balıkuyumcu": true,
      "Devlet": true,
      "Elvan": true,
      "Erler": true,
      "Eryaman": true,
      "Etiler": true,
      "Fatih Sultan": true,
      "Fevziye": true,
      "Göksu": true,
      "Güzelkent": true,
      "İstasyon": true,
      "Kazım Karabekir": true,
      "Oğuzlar": true,
      "Orhun": true,
      "Piyade": true,
      "Süvari": true,
      "Şehit Osman Avcı": true,
      "Şehitali": true,
      "Şeker": true,
      "Şeyh Şamil": true,
      "Topçu": true,
      "Tunahan": true,
      "Turkuaz": true,
      "Yapracık": true,
      "Yavuz Selim": true,
      "Yeni Bağlıca": true,
      "Yeşilova": true,
      "Yukarıyurtçu": true
    },
    "Evren": {
      "Altınbaşak": true,
      "Cebirli": true,
      "Çatalpınar": true,
      "Demirayak": true,
      "Esentepe": true,
      "Eskitorunobası": true,
      "İbrahimbeyli": true,
      "İnebeyli": true,
      "Modern": true,
      "Solakuşağı": true,
      "Şerafettin Yılmaz": true,
      "Yeni": true,
      "Yusufuşağı": true
    },
    "Gölbaşı": {
      "Ahiboz": true,
      "Akörençarşak": true,
      "Altunçanak": true,
      "Bağiçi": true,
      "Bahçelievler": true,
      "Ballıkpınar": true,
      "Bezirhane": true,
      "Boyalık": true,
      "Çayırlı": true,
      "Çeltek": true,
      "Çimşit": true,
      "Dikilitaş": true,
      "Emirler": true,
      "Eymir": true,
      "Gaziosmanpaşa": true,
      "Gökçehüyük": true,
      "Gölbek": true,
      "Günalan": true,
      "Hacıhasan": true,
      "Hacılar": true,
      "Hacımuratlı": true,
      "Halaçlı": true,
      "İkizce": true,
      "İncek": true,
      "Karaali Merkez": true,
      "Karaali Yazlık": true,
      "Karacaören": true,
      "Karagedik Aydın": true,
      "Karagedik Ercan": true,
      "Karaoğlan": true,
      "Karşıyaka": true,
      "Kırıklı": true,
      "Kızılcaşar": true,
      "Koparan": true,
      "Mahmatlı": true,
      "Mahmatlıbahçe": true,
      "Oğulbey": true,
      "Oyaca Akarsu": true,
      "Oyaca Yeşilçam": true,
      "Örencik": true,
      "Seğmenler": true,
      "Selametli Şehit Emrah": true,
      "Soğulcak": true,
      "Subaşı": true,
      "Şafak": true,
      "Taşpınar": true,
      "Tepeyurt": true,
      "Topaklı": true,
      "Tulumtaş": true,
      "Velihimmetli": true,
      "Yağlıpınar": true,
      "Yavrucuk": true,
      "Yaylabağ": true,
      "Yurtbeyi": true
    },
    "Güdül": {
      "Adalıkuzu": true,
      "Afşar": true,
      "Akbaş": true,
      "Akçakese": true,
      "Aşağı": true,
      "Boyalı": true,
      "Çağa": true,
      "Çukurören": true,
      "Emirler": true,
      "Garipçe": true,
      "Güneyce": true,
      "Güzel": true,
      "Hacılar": true,
      "Kadıobası": true,
      "Kamanlar": true,
      "Karacaören": true,
      "Kavaközü": true,
      "Kayı": true,
      "Kırkkavak": true,
      "Meyvabükü": true,
      "Özçaltı": true,
      "Özköy": true,
      "Salihler": true,
      "Sapanlı": true,
      "Sorgun": true,
      "Tahtacıörencik": true,
      "Taşören": true,
      "Yelli": true,
      "Yeni": true,
      "Yeşilöz": true,
      "Yukarı": true
    },
    "Haymana": {
      "Ahırlıkuyu": true,
      "Alaçık": true,
      "Alahacılı": true,
      "Altıpınar": true,
      "Ataköy": true,
      "Bahçecik": true,
      "Balçıkhisar": true,
      "Baltalin": true,
      "Boğazkaya": true,
      "Bostanhüyük": true,
      "Bumsuz": true,
      "Büyükkonak": true,
      "Büyükyağcı": true,
      "Cihanşah": true,
      "Cingirli": true,
      "Culuk": true,
      "Çaldağ": true,
      "Çalış": true,
      "Çatak": true,
      "Çayraz": true,
      "Çeltikli": true,
      "Demirözü": true,
      "Dereköy": true,
      "Deveci": true,
      "Devecipınarı": true,
      "Durupınar": true,
      "Durutlar": true,
      "Emirler": true,
      "Esen": true,
      "Eskikışla": true,
      "Evci": true,
      "Evliyafakı": true,
      "Gedik": true,
      "Gültepe": true,
      "Güzelcekale": true,
      "İncirli": true,
      "Kadıköy": true,
      "Karahoca": true,
      "Karapınar": true,
      "Karasüleymanlı": true,
      "Katrancı": true,
      "Kavak": true,
      "Kayabaşı": true,
      "Kerpiç": true,
      "Kesikkavak": true,
      "Kızılkoyunlu": true,
      "Kirazoğlu": true,
      "Kutluhan": true,
      "Küçükkonak": true,
      "Küçükyağcı": true,
      "Mandıra": true,
      "Medrese": true,
      "Saatli": true,
      "Sarıdeğirmen": true,
      "Sarıgöl": true,
      "Sazağası": true,
      "Serinyayla": true,
      "Seyran": true,
      "Sındıran": true,
      "Sırçasaray": true,
      "Sinanlı": true,
      "Soğulca": true,
      "Söğüttepe": true,
      "Şerefligökgöz": true,
      "Tabaklı": true,
      "Tepeköy": true,
      "Toyçayırı": true,
      "Türkhüyük": true,
      "Türkşerefli": true,
      "Yamak": true,
      "Yaprakbayırı": true,
      "Yaylabeyi": true,
      "Yeni": true,
      "Yeniköy": true,
      "Yergömü": true,
      "Yeşilköy": true,
      "Yukarısebil": true,
      "Yurtbeyli": true
    },
    "Kahramankazan": {
      "Ahi": true,
      "Akçaören": true,
      "Akıncı": true,
      "Alpagut": true,
      "Aşağıkaraören": true,
      "Atatürk": true,
      "Aydın": true,
      "Bitik": true,
      "Ciğir": true,
      "Çalta": true,
      "Çimşit": true,
      "Dağyaka": true,
      "Dutözü": true,
      "Emirgazi": true,
      "Fatih": true,
      "Fethiye": true,
      "Günbaşı": true,
      "Güvenç": true,
      "İçören": true,
      "İmrendi": true,
      "İnceğiz": true,
      "İne": true,
      "İymir": true,
      "Kanuni Sultan Süleyman": true,
      "Karalar": true,
      "Kayı": true,
      "Kılıçlar": true,
      "Kınık": true,
      "Kışla": true,
      "Kumpınar": true,
      "Orhaniye": true,
      "Örencik": true,
      "Peçenek": true,
      "Sancar": true,
      "Saraç": true,
      "Saray": true,
      "Sarıayak": true,
      "Sarılar": true,
      "Satıkadın": true,
      "Soğucak": true,
      "Tekke": true,
      "Uçarı": true,
      "Yakupderviş": true,
      "Yassıören": true,
      "Yavuz Sultan Selim": true,
      "Yayalar": true,
      "Yazıbeyli": true,
      "Yıldırımbeyazıt": true
    },
    "Kalecik": {
      "Afşar": true,
      "Ahikemalşenyurt": true,
      "Ahiler Yenice": true,
      "Akcataş": true,
      "Akkaynak": true,
      "Akkuzulu": true,
      "Aktepe": true,
      "Alibeyli": true,
      "Altıntaş": true,
      "Arkbürk": true,
      "Beykavağı": true,
      "Buğra": true,
      "Cuma Saray": true,
      "Çandır": true,
      "Çanşa Kale": true,
      "Çaykaya": true,
      "Çiftlikköy": true,
      "Dağdemir": true,
      "Değirmenkaya": true,
      "Demirtaş": true,
      "Elmapınar": true,
      "Eskiköy": true,
      "Eşmedere": true,
      "Gökçeören": true,
      "Gökdere": true,
      "Gölköy": true,
      "Gümüşpınar": true,
      "Hacıköy": true,
      "Halilağa Tabakhane": true,
      "Halitcevriaslangil": true,
      "Hançılı": true,
      "Hasayaz": true,
      "Karahöyük": true,
      "Karalar": true,
      "Karatepe": true,
      "Karkın": true,
      "Keklicek": true,
      "Kılçak": true,
      "Kınık": true,
      "Kızılkaya": true,
      "Koyunbaba": true,
      "Kuyucak": true,
      "Mahmutlar": true,
      "Samanlık": true,
      "Satılar": true,
      "Şemsettin": true,
      "Şeyhmahmut": true,
      "Tavşancık": true,
      "Tilki": true,
      "Uyurca": true,
      "Yalımköy": true,
      "Yeniçöte": true,
      "Yenidoğan Yeşilyurt": true,
      "Yeşilöz": true,
      "Yılanlı": true,
      "Yurtyenice": true,
      "Yüzbey": true
    },
    "Keçiören": {
      "19 Mayıs": true,
      "23 Nisan": true,
      "Adnan Menderes": true,
      "Aktepe": true,
      "Aşağı Eğlence": true,
      "Atapark": true,
      "Ayvalı": true,
      "Bademlik": true,
      "Bağlarbaşı": true,
      "Bağlum Güzelyurt": true,
      "Basınevleri": true,
      "Çaldıran": true,
      "Çalseki": true,
      "Çiçekli": true,
      "Emrah": true,
      "Esertepe": true,
      "Etlik": true,
      "Güçlükaya": true,
      "Gümüşdere": true,
      "Güzelyurt": true,
      "Hasköy": true,
      "Hisar": true,
      "İncirli": true,
      "Kafkas": true,
      "Kalaba": true,
      "Kamil Ocak": true,
      "Kanuni": true,
      "Karakaya": true,
      "Karargahtepe": true,
      "Karşıyaka": true,
      "Kavacık Subayevleri": true,
      "Kösrelik": true,
      "Köşk": true,
      "Kuşcağız": true,
      "Osmangazi": true,
      "Ovacık": true,
      "Pınarbaşı": true,
      "Sancaktepe": true,
      "Sarıbeyler": true,
      "Şefkat": true,
      "Şehit Kubilay": true,
      "Şenlik": true,
      "Şenyuva": true,
      "Tepebaşı": true,
      "Ufuktepe": true,
      "Uyanış": true,
      "Yakacık": true,
      "Yayla": true,
      "Yeşilöz": true,
      "Yeşiltepe": true,
      "Yükseltepe": true
    },
    "Kızılcahamam": {
      "Akçakese": true,
      "Akçay": true,
      "Akdoğan": true,
      "Aksak": true,
      "Alibey": true,
      "Alpagut": true,
      "Aşağıada": true,
      "Aşağıçanlı": true,
      "Aşağıhüyük": true,
      "Ayvacık": true,
      "Bademli": true,
      "Bağlıca": true,
      "Bağören": true,
      "Balcılar": true,
      "Başağaç": true,
      "Bayır": true,
      "Belpınar": true,
      "Berçinçatak": true,
      "Berçinyayalar": true,
      "Beşkonak": true,
      "Bezcikuzören": true,
      "Binkoz": true,
      "Bulak": true,
      "Ciğirler": true,
      "Çavuşlar": true,
      "Çeltikçi": true,
      "Çeltikçi Akçaören": true,
      "Çeltikçi Başören": true,
      "Çeltikçi Kınık": true,
      "Çeştepe": true,
      "Çırpan": true,
      "Çukurca": true,
      "Çukurören": true,
      "Değirmenönü": true,
      "Demirciören": true,
      "Dereneci": true,
      "Doğanözü": true,
      "Doymuşören": true,
      "Eğerlialören": true,
      "Eğerlibaşköy": true,
      "Eğerlidere": true,
      "Eğerlikozören": true,
      "Esenler": true,
      "Gazi Mustafa Kemalpaşa": true,
      "Gebeler": true,
      "Gökbel": true,
      "Göl": true,
      "Gümele": true,
      "Güneysaray": true,
      "Güvem": true,
      "Hıdırlar": true,
      "İğdir": true,
      "İğmir": true,
      "İnceğez": true,
      "İsmetpaşa": true,
      "İyceler": true,
      "Kalemler": true,
      "Karaağaç": true,
      "Karacaören": true,
      "Karşıyaka": true,
      "Kasımlar": true,
      "Kavaközü": true,
      "Kırkırca": true,
      "Kırköy": true,
      "Kışlak": true,
      "Kızık": true,
      "Kızılcaköy": true,
      "Kızılcaören": true,
      "Kocalar": true,
      "Kurumcu": true,
      "Kuşcuören": true,
      "Mahkemeağcin": true,
      "Oğlakcı": true,
      "Olucak": true,
      "Ortaköy": true,
      "Otacı": true,
      "Örencik": true,
      "Pazar": true,
      "Pazar Başören": true,
      "Pazar Kınık": true,
      "Salın": true,
      "Saray": true,
      "Saraycık": true,
      "Sazak": true,
      "Semeler": true,
      "Semer": true,
      "Süleler": true,
      "Şahinler": true,
      "Tahtalar": true,
      "Taşlıca": true,
      "Turnalı": true,
      "Uğurlu": true,
      "Üçbaş": true,
      "Üyücek": true,
      "Yağcıhüseyin": true,
      "Yakakaya": true,
      "Yanık Özbekler": true,
      "Yenice": true,
      "Yeşilköy": true,
      "Yıldırımçatak": true,
      "Yıldırımdemirciler": true,
      "Yıldırımhacılar": true,
      "Yıldırımören": true,
      "Yıldırımyağlıca": true,
      "Yukarıada": true,
      "Yukarıçanlı": true,
      "Yukarıhüyük": true,
      "Yukarıkaraören": true,
      "Yukarıkese": true
    },
    "Mamak": {
      "Abidinpaşa": true,
      "Akdere": true,
      "Akşemsettin": true,
      "Altıağaç": true,
      "Altınevler": true,
      "Araplar": true,
      "Aşık Veysel": true,
      "Bahçeleriçi": true,
      "Bahçelerüstü": true,
      "Balkiraz": true,
      "Başak": true,
      "Bayındır": true,
      "Boğaziçi": true,
      "Bostancık": true,
      "Cengizhan": true,
      "Çağlayan": true,
      "Çiğiltepe": true,
      "Demirlibahçe": true,
      "Derbent": true,
      "Diriliş": true,
      "Dostlar": true,
      "Durali Alıç": true,
      "Dutluk": true,
      "Ege": true,
      "Ekin": true,
      "Fahri Korutürk": true,
      "General Zeki Doğan": true,
      "Gökçeyurt": true,
      "Gülveren": true,
      "Harman": true,
      "Hürel": true,
      "Hüseyingazi": true,
      "Karaağaç": true,
      "Karşıyaka": true,
      "Kartaltepe": true,
      "Kayaş": true,
      "Kazım Orbay": true,
      "Kıbrısköy": true,
      "Kızılca": true,
      "Köstence": true,
      "Kusunlar": true,
      "Kutlu": true,
      "Kutludüğün": true,
      "Küçük Kayaş": true,
      "Lalahan": true,
      "Mehtap": true,
      "Misket": true,
      "Mutlu": true,
      "Ortaköy": true,
      "Peyami Safa": true,
      "Saimekadın": true,
      "Şafaktepe": true,
      "Şahap Gürler": true,
      "Şahintepe": true,
      "Şehit Cengiz Topel": true,
      "Şirintepe": true,
      "Tepecik": true,
      "Tuzluçayır": true,
      "Türközü": true,
      "Üreğil": true,
      "Yeni Bayındır": true,
      "Yeşilbayır": true,
      "Yukarı Imrohor": true,
      "Zirvekent": true
    },
    "Nallıhan": {
      "100.yıl": true,
      "Akdere": true,
      "Aksu": true,
      "Alan": true,
      "Aliağa": true,
      "Aliefe": true,
      "Alpağut": true,
      "Arkutça": true,
      "Aşağıbağdere": true,
      "Aşağıbağlıca": true,
      "Aşağıkavacık": true,
      "Atatürk": true,
      "Atça": true,
      "Aydoğmuş": true,
      "Belenalan": true,
      "Belenören": true,
      "Beyalan": true,
      "Beycik": true,
      "Beydili": true,
      "Bozyaka": true,
      "Cendere": true,
      "Çalıcaalan": true,
      "Çamalan": true,
      "Çayırhan": true,
      "Çiller": true,
      "Çive": true,
      "Çulhalar": true,
      "Danişment": true,
      "Davutoğlan": true,
      "Demirköy": true,
      "Dereköy": true,
      "Doğandere": true,
      "Döğmeci": true,
      "Eğri": true,
      "Emremsultan": true,
      "Epçeler": true,
      "Ericek": true,
      "Eymir": true,
      "Fatih": true,
      "Gökçeöz": true,
      "Güzelöz": true,
      "Hacıbey": true,
      "Hacıhasanlar": true,
      "Hıdırlar": true,
      "İslamalan": true,
      "Kabaca": true,
      "Kadıköy": true,
      "Karacasu": true,
      "Karahisar": true,
      "Karahisargölcük": true,
      "Karahisarkozlu": true,
      "Karaköy": true,
      "Kavakköy": true,
      "Kulu": true,
      "Kuruca": true,
      "Kuzucular": true,
      "Meyildere": true,
      "Meyilhacılar": true,
      "Nallıdere": true,
      "Nallıgölcük": true,
      "Nasuhpaşa": true,
      "Nebioğlu": true,
      "Osmanköy": true,
      "Ozan": true,
      "Ömerşeyhler": true,
      "Öşürler": true,
      "Sarıkaya": true,
      "Sarıyar": true,
      "Sobran": true,
      "Soğukkuyu": true,
      "Subaşı": true,
      "Tekirler": true,
      "Tekke": true,
      "Tepe": true,
      "Uluhan": true,
      "Uluköy": true,
      "Uzunöz": true,
      "Yakapınar": true,
      "Yazı": true,
      "Yenice": true,
      "Yeşilyurt": true,
      "Yukarıbağdere": true,
      "Yukarıbağlıca": true,
      "Yukarıkavacık": true
    },
    "Polatlı": {
      "Adatoprakpınar": true,
      "Avdanlı": true,
      "Avşar": true,
      "Babayakup": true,
      "Basrı": true,
      "Beşköprü": true,
      "Beyceğiz": true,
      "Beylikköprü": true,
      "Cumhuriyet": true,
      "Çamlıca": true,
      "Çanakçı": true,
      "Çekirdeksiz": true,
      "Çimenceğiz": true,
      "Esentepe": true,
      "Eskikarsak": true,
      "Eskiköseler": true,
      "Eskipolatlı": true,
      "Fatih": true,
      "Gazi": true,
      "Gedikli": true,
      "Gençali": true,
      "Gülpınar": true,
      "Gülveren": true,
      "Gümüşyaka": true,
      "Gündoğan": true,
      "Güreş": true,
      "Hacımusa": true,
      "Hacımuslu": true,
      "Hacıosmanoğlu": true,
      "Hacıtuğrul": true,
      "Hıdırşeyh": true,
      "Ilıca": true,
      "İğciler": true,
      "İnler": true,
      "İstiklal": true,
      "Kabak": true,
      "Karaahmet": true,
      "Karabenli": true,
      "Karacaahmet": true,
      "Karahamzalı": true,
      "Karailyas": true,
      "Karakaya": true,
      "Karakuyu": true,
      "Karapınar": true,
      "Karayavşan": true,
      "Kargalı": true,
      "Kayabaşı": true,
      "Kıranharmanı": true,
      "Kızılcakışla": true,
      "Kocahacılı": true,
      "Kurtuluş": true,
      "Kuşcu": true,
      "Macun": true,
      "Mehmetakif": true,
      "Müslüm": true,
      "Oğuzlar": true,
      "Olukpınar": true,
      "Ömerler": true,
      "Ördekgölü": true,
      "Özyurt": true,
      "Poyraz": true,
      "Sabanca": true,
      "Sakarya": true,
      "Sarıhalil": true,
      "Sarıoba": true,
      "Sazlar": true,
      "Sinanlı": true,
      "Sincik": true,
      "Sivri": true,
      "Şabanözü": true,
      "Şehitlik": true,
      "Şentepe": true,
      "Şeyhali": true,
      "Şıhahmetli": true,
      "Taşpınar": true,
      "Tatlıkuyu": true,
      "Toydemir": true,
      "Tüfekçioğlu": true,
      "Türkkarsak": true,
      "Türktaciri": true,
      "Uzunbey": true,
      "Üçpınar": true,
      "Yağcıoğlu": true,
      "Yağmurbaba": true,
      "Yaralı": true,
      "Yassıhüyük": true,
      "Yeni": true,
      "Yenice": true,
      "Yenidoğan": true,
      "Yeniköseler": true,
      "Yenimehmetli": true,
      "Yeşilöz": true,
      "Yıldızlı": true,
      "Yüzükbaşı": true,
      "Zafer": true
    },
    "Pursaklar": {
      "Abadan": true,
      "Altınova": true,
      "Ayyıldız": true,
      "Fatih": true,
      "Karaköy": true,
      "Karşıyaka": true,
      "Kösrelikkızığı": true,
      "Merkez": true,
      "Mimar Sinan": true,
      "Peçenek": true,
      "Saray Cumhuriyet": true,
      "Saray Fatih": true,
      "Saray Gümüşoluk": true,
      "Saray Osmangazi": true,
      "Sirkeli Yeşilova": true,
      "Sirkeli Yeşilyurt": true,
      "Tevfik Ileri": true,
      "Yeni Karaköy": true,
      "Yıldırım Beyazıt": true,
      "Yunus Emre": true,
      "Yuva": true
    },
    "Sincan": {
      "29 Ekim": true,
      "Adalet": true,
      "Ahi Evran": true,
      "Akçaören": true,
      "Akşemsettin": true,
      "Alagöz": true,
      "Alcı": true,
      "Anayurt": true,
      "Andiçen": true,
      "Atatürk": true,
      "Bacı": true,
      "Beyobası": true,
      "Cumhuriyet": true,
      "Çiçektepe": true,
      "Çoğlu": true,
      "Çokören": true,
      "Erkeksu": true,
      "Ertuğrulgazi": true,
      "Esenler": true,
      "Fatih": true,
      "Fevzi Çakmak": true,
      "Gazi": true,
      "Gazi Osmanpaşa": true,
      "Girmeç": true,
      "Gökçek": true,
      "Hisarlıkaya": true,
      "Hürriyet": true,
      "İlyakut": true,
      "İncirlik": true,
      "İstasyon": true,
      "İstiklal": true,
      "Kesiktaş": true,
      "Malazgirt": true,
      "Malıköy": true,
      "Maraşal Çakmak": true,
      "Menderes": true,
      "Mevlana": true,
      "Mustafa Kemal": true,
      "Mülk": true,
      "Osmaniye": true,
      "Osmanlı": true,
      "Pınarbaşı": true,
      "Plevne": true,
      "Polatlar": true,
      "Saraycık": true,
      "Selçuklu": true,
      "Tandoğan": true,
      "Tatlar": true,
      "Törekent": true,
      "Türkobası": true,
      "Ulubatlı Hasan": true,
      "Ücret": true,
      "Yeniçimşit": true,
      "Yenihisar": true,
      "Yenikayı": true,
      "Yenipeçenek": true,
      "Yunus Emre": true
    },
    "Şereflikoçhisar": {
      "Acıkuyu": true,
      "Acıöz": true,
      "Akarca": true,
      "Akin": true,
      "Akseki": true,
      "Aktaş": true,
      "Aliuşağı": true,
      "Bağobası": true,
      "Baltalı": true,
      "Boğaziçi": true,
      "Büyükdamlacık": true,
      "Büyükkışla": true,
      "Cıngıl": true,
      "Cumhuriyet": true,
      "Çalören": true,
      "Çatçat": true,
      "Çavuşköy": true,
      "Çayırönü": true,
      "Deliller": true,
      "Devekovan": true,
      "Doğankaya": true,
      "Ekici": true,
      "Eley": true,
      "Emek": true,
      "Fadıllı": true,
      "Geçitli": true,
      "Gülhüyük": true,
      "Hacıbektaşlı": true,
      "Hacıenbiya": true,
      "Hamzalı": true,
      "Haydarlı": true,
      "Hürriyet": true,
      "İstiklal": true,
      "Kacarlı": true,
      "Kadıncık": true,
      "Kadıobası": true,
      "Kale": true,
      "Karabük": true,
      "Karamollauşağı": true,
      "Karandere": true,
      "Küçükdamlacık": true,
      "Mehmet Akif Ersoy": true,
      "Mustafacık": true,
      "Musular": true,
      "Odunboğazı": true,
      "Palazobası": true,
      "Parlasan": true,
      "Sadıklı": true,
      "Sanayi": true,
      "Sarıkaya": true,
      "Seymenli": true,
      "Şanlıkışla": true,
      "Şekerköy": true,
      "Şereflidavutlu": true,
      "Şeyh Kuyusu": true,
      "Şeyhli": true,
      "Tuzla": true,
      "Üzengilik": true,
      "Yalnızpınar": true,
      "Yazısöğüt": true,
      "Yeni": true,
      "Yeşilova": true,
      "Yeşilyurt": true,
      "Yusufkuyusu": true
    },
    "Yenimahalle": {
      "25 Mart": true,
      "Anadolu": true,
      "Aşağı Yahyalar": true,
      "Ata": true,
      "Avcılar": true,
      "Barış": true,
      "Barıştepe": true,
      "Batı Sitesi": true,
      "Beştepe": true,
      "Burç": true,
      "Çamlıca": true,
      "Çarşı": true,
      "Çiğdemtepe": true,
      "Demetevler": true,
      "Demetgül": true,
      "Demetlale": true,
      "Emniyet": true,
      "Ergazi": true,
      "Ergenekon": true,
      "Esentepe": true,
      "Gayret": true,
      "Gazi": true,
      "Güventepe": true,
      "Güzelyaka": true,
      "Işınlar": true,
      "İlkyerleşim": true,
      "İnönü": true,
      "İvedikköy": true,
      "Kaletepe": true,
      "Karacakaya": true,
      "Kardelen": true,
      "Karşıyaka": true,
      "Kayalar": true,
      "Kentkoop": true,
      "Kuzey Yıldızı": true,
      "Macun": true,
      "Mehmet Akif Ersoy": true,
      "Memlik": true,
      "Ostim": true,
      "Özevler": true,
      "Pamuklar": true,
      "Ragıp Tüzün": true,
      "Serhat": true,
      "Susuz": true,
      "Tepealtı": true,
      "Turgut Özal": true,
      "Uğur Mumcu": true,
      "Varlık": true,
      "Yakacık": true,
      "Yeni Batı": true,
      "Yeniçağ": true,
      "Yeşilevler": true,
      "Yukarı Yahyalar": true,
      "Yunus Emre": true,
      "Yuvaköy": true
    }
  },
  "Antalya": {
    "Akseki": {
      "Akşahap": true,
      "Alaçeşme": true,
      "Aşağıaşıklar": true,
      "Bademli": true,
      "Belenalan": true,
      "Boğaz": true,
      "Bucakalan": true,
      "Bucakkışla": true,
      "Büyükalan": true,
      "Ceceler": true,
      "Cemerler": true,
      "Cendeve": true,
      "Cevizli": true,
      "Çaltılıçukur": true,
      "Çanakpınar": true,
      "Çınardibi": true,
      "Çimiköy": true,
      "Çukurköy": true,
      "Değirmenlik": true,
      "Demirciler": true,
      "Dikmen": true,
      "Dutluca": true,
      "Emiraşıklar": true,
      "Erenyaka": true,
      "Fakılar": true,
      "Geriş": true,
      "Güçlüköy": true,
      "Gümüşdamla": true,
      "Güneykaya": true,
      "Günyaka": true,
      "Güzelsu": true,
      "Hacı Ilyas": true,
      "Hocaköy": true,
      "Hüsamettinköy": true,
      "Karakışla": true,
      "Kepez": true,
      "Kepezbeleni": true,
      "Kuyucak": true,
      "Mahmutlu": true,
      "Menteşbey": true,
      "Minareli": true,
      "Pınarbaşı": true,
      "Sadıklar": true,
      "Salihler": true,
      "Sarıhacılar": true,
      "Sarıhaliller": true,
      "Sinanhoca": true,
      "Susuzşahap": true,
      "Süleymaniye": true,
      "Taşlıca": true,
      "Yarpuz": true
    },
    "Aksu": {
      "Alaylı": true,
      "Altıntaş": true,
      "Atatürk": true,
      "Barbaros": true,
      "Boztepe": true,
      "Cihadiye": true,
      "Cumhuriyet": true,
      "Çalkaya": true,
      "Çamköy": true,
      "Dumanlar": true,
      "Fatih": true,
      "Fettahlı": true,
      "Gökdere": true,
      "Güloluk": true,
      "Güzelyurt": true,
      "Hacıaliler": true,
      "İhsaniye": true,
      "Karaçallı": true,
      "Karaöz": true,
      "Kayadibi": true,
      "Kemerağzı": true,
      "Konak": true,
      "Kumköy": true,
      "Kundu": true,
      "Kurşunlu": true,
      "Macun": true,
      "Mandırlar": true,
      "Murtuna": true,
      "Pınarlı": true,
      "Soğucaksu": true,
      "Solak": true,
      "Topallı": true,
      "Yenidumanlar": true,
      "Yeşilkaraman": true,
      "Yurtpınar": true
    },
    "Alanya": {
      "Akçatı": true,
      "Akdam": true,
      "Alacami": true,
      "Alara": true,
      "Aliefendi": true,
      "Asmaca": true,
      "Avsallar": true,
      "Bademağacı": true,
      "Basırlı": true,
      "Başköy": true,
      "Bayır": true,
      "Bayırkozağacı": true,
      "Bektaş": true,
      "Beldibi": true,
      "Beyreli": true,
      "Bıçakçı": true,
      "Bucak": true,
      "Burçaklar": true,
      "Büyükhasbahçe": true,
      "Büyükpınar": true,
      "Cikcilli": true,
      "Cumhuriyet": true,
      "Çakallar": true,
      "Çamlıca": true,
      "Çarşı": true,
      "Çıplaklı": true,
      "Değirmendere": true,
      "Demirtaş": true,
      "Dere": true,
      "Dinek": true,
      "Elikesik": true,
      "Emişbeleni": true,
      "Fakırcalı": true,
      "Fığla": true,
      "Gözübüyük": true,
      "Gözüküçüklü": true,
      "Güller Pınarı": true,
      "Gümüşgöze": true,
      "Gümüşkavak": true,
      "Güney": true,
      "Güzelbağ": true,
      "Hacet": true,
      "Hacıkerimler": true,
      "Hacımehmetli": true,
      "Hisariçi": true,
      "Hocalar": true,
      "İmamlı": true,
      "İncekum": true,
      "İsbatlı": true,
      "İshaklı": true,
      "Kadıpaşa": true,
      "Karakocalı": true,
      "Karamanlar": true,
      "Karapınar": true,
      "Kargıcak": true,
      "Kayabaşı": true,
      "Kestel": true,
      "Keşefli": true,
      "Kızılcaşehir": true,
      "Kızlar Pınarı": true,
      "Kocaoğlanlı": true,
      "Konaklı": true,
      "Kuzyaka": true,
      "Küçükhasbahçe": true,
      "Mahmutlar": true,
      "Mahmutseydi": true,
      "Oba": true,
      "Obaalacami": true,
      "Okurcalar": true,
      "Orhan": true,
      "Öteköy": true,
      "Özvadi": true,
      "Paşaköy": true,
      "Payallar": true,
      "Saburlar": true,
      "Sapadere": true,
      "Saray": true,
      "Seki": true,
      "Soğukpınar": true,
      "Sugözü": true,
      "Süleymanlar": true,
      "Şekerhane": true,
      "Şıhlar": true,
      "Taşbaşı": true,
      "Tepe": true,
      "Tırılar": true,
      "Tophane": true,
      "Toslak": true,
      "Tosmur": true,
      "Türkler": true,
      "Türktaş": true,
      "Uğrak": true,
      "Uğurlu": true,
      "Uzunöz": true,
      "Üzümlü": true,
      "Yalçı": true,
      "Yasirali": true,
      "Yaylakonak": true,
      "Yaylalı": true,
      "Yenice": true,
      "Yeniköy": true,
      "Yeşilöz": true
    },
    "Demre": {
      "Alakent": true,
      "Belören": true,
      "Beymelek": true,
      "Büyükkum": true,
      "Çağman": true,
      "Çevreli": true,
      "Davazlar": true,
      "Gökyazı": true,
      "Gürses": true,
      "Kaleüçağız": true,
      "Kapaklı": true,
      "Karabucak": true,
      "Kayaaltı": true,
      "Köşkerler": true,
      "Küçükkum": true,
      "Yavu": true,
      "Yaylakaya": true
    },
    "Döşemealtı": {
      "Ahırtaş": true,
      "Akkoç": true,
      "Altınkale": true,
      "Aşağıoba": true,
      "Ayanlar": true,
      "Aydınlar": true,
      "Bademağacı": true,
      "Bahçeyaka": true,
      "Bıyıklı": true,
      "Camili": true,
      "Çığlık": true,
      "Çıplaklı": true,
      "Dağbeli": true,
      "Dereli": true,
      "Düzlerçamı": true,
      "Ekşili": true,
      "Ilıcaköy": true,
      "Karaman": true,
      "Karataş": true,
      "Karaveliler": true,
      "Kevşirler": true,
      "Killik": true,
      "Kovanlık": true,
      "Kömürcüler": true,
      "Nebiler": true,
      "Orta": true,
      "Selimiye": true,
      "Tomalar": true,
      "Yağca": true,
      "Yalınlı": true,
      "Yeniköy": true,
      "Yeşilbayır": true
    },
    "Elmalı": {
      "Afşar": true,
      "Ahatlı": true,
      "Akçaeniş": true,
      "Akçay": true,
      "Armutlu": true,
      "Bayındır": true,
      "Bayralar": true,
      "Beyler": true,
      "Bozhüyük": true,
      "Büyüksöğle": true,
      "Camiatik": true,
      "Camicedit": true,
      "Çaybaşı": true,
      "Çobanisa": true,
      "Çukurelma": true,
      "Dereköy": true,
      "Düden": true,
      "Eskihisar": true,
      "Eymir": true,
      "Geçit": true,
      "Geçmen": true,
      "Gökpınar": true,
      "Gölova": true,
      "Göltarla": true,
      "Gümüşyaka": true,
      "Gündoğan": true,
      "Hacımusalar": true,
      "Hacıyusuflar": true,
      "İlyağı": true,
      "İmircik": true,
      "İplik Pazarı": true,
      "İslamlar": true,
      "Kapmescit": true,
      "Karaköy": true,
      "Karamık": true,
      "Karyağdı": true,
      "Kışla": true,
      "Kızılca": true,
      "Kocapınar": true,
      "Kuzköy": true,
      "Küçüksöğle": true,
      "Macun": true,
      "Mursal": true,
      "Ovacık": true,
      "Özdemir": true,
      "Pirhasanlar": true,
      "Salur": true,
      "Sarılar": true,
      "Tahtamescit": true,
      "Tavullar": true,
      "Tekke": true,
      "Toklular": true,
      "Yakaçiftlikköyü": true,
      "Yalnızdam": true,
      "Yapraklı": true,
      "Yeni": true,
      "Yılmazlı": true,
      "Yörenler": true,
      "Yuva": true,
      "Zümrütova": true
    },
    "Finike": {
      "Akçaalan": true,
      "Alacadağ": true,
      "Arif": true,
      "Asarönü": true,
      "Boldağ": true,
      "Çamlıbel": true,
      "Dağbağ": true,
      "Ernez": true,
      "Eski": true,
      "Gökbük": true,
      "Gökçeyaka": true,
      "Hasyurt": true,
      "İskele": true,
      "Kale": true,
      "Karşıyaka": true,
      "Kızılca": true,
      "Kum": true,
      "Sahilkent": true,
      "Saklısu": true,
      "Turunçova": true,
      "Yalnız": true,
      "Yazır": true,
      "Yeni": true,
      "Yeşilköy": true,
      "Yeşilyurt": true,
      "Yuvalı": true
    },
    "Gazipaşa": {
      "Akoluk": true,
      "Aydın": true,
      "Aydıncık": true,
      "Bakılar": true,
      "Beyobası": true,
      "Beyrebucak": true,
      "Cumhuriyet": true,
      "Çakmak": true,
      "Çalıpınar": true,
      "Çamlıca": true,
      "Çığlık": true,
      "Çile": true,
      "Çimenbağ": true,
      "Çobanlar": true,
      "Çörüş": true,
      "Doğanca": true,
      "Ekmel": true,
      "Esenpınar": true,
      "Esentepe": true,
      "Gazi": true,
      "Göçük": true,
      "Gökçebelen": true,
      "Gökçesaray": true,
      "Güneyköy": true,
      "Gürçam": true,
      "Hasdere": true,
      "Ilıca": true,
      "İnal": true,
      "İnceğiz": true,
      "İstiklal": true,
      "Kahyalar": true,
      "Karaçukur": true,
      "Karalar": true,
      "Karatepe": true,
      "Kırahmetler": true,
      "Kızılgüney": true,
      "Koru": true,
      "Korubaşı": true,
      "Küçüklü": true,
      "Macar": true,
      "Muzkent": true,
      "Öznurtepe": true,
      "Pazarcı": true,
      "Sarıağaç": true,
      "Sugözü": true,
      "Şahinler": true,
      "Üçkonak": true,
      "Yakacık": true,
      "Yeni": true,
      "Yenigüney": true,
      "Yeniköy": true,
      "Yeşilyurt": true,
      "Zeytinada": true
    },
    "Gündoğmuş": {
      "Akyar": true,
      "Balkaya": true,
      "Bedan": true,
      "Çaltı": true,
      "Çamlıalan": true,
      "Çayırözü": true,
      "Çiçekoluk": true,
      "Eskibağ": true,
      "Fatih": true,
      "Güneycik": true,
      "Güneyyaka": true,
      "Kalecik": true,
      "Karabul": true,
      "Karadere": true,
      "Karaisa": true,
      "Karaköy": true,
      "Kayabükü": true,
      "Kozağacı": true,
      "Köprülü": true,
      "Narağacı": true,
      "Ortakonuş": true,
      "Ortaköy": true,
      "Özügür": true,
      "Pembelik": true,
      "Rasih Kaplan": true,
      "Senir": true,
      "Serinyaka": true,
      "Umutlu": true,
      "Yeniköy": true
    },
    "İbradı": {
      "Aşağı": true,
      "Aydınyayla": true,
      "Başlar": true,
      "Çukurviran": true,
      "Düzlen": true,
      "Ormana": true,
      "Ürünlü": true,
      "Üzümdere": true,
      "Yukarı": true
    },
    "Kaş": {
      "Ağullu": true,
      "Ahatlı": true,
      "Aklar": true,
      "Akörü": true,
      "Andifli": true,
      "Bayındır": true,
      "Beldibi": true,
      "Belenli": true,
      "Belkonak": true,
      "Bezirgan": true,
      "Cemre": true,
      "Çamlıköy": true,
      "Çamlıova": true,
      "Çataloluk": true,
      "Çavdır": true,
      "Çayköy": true,
      "Çerler": true,
      "Çeşme": true,
      "Çukurbağ": true,
      "Dere": true,
      "Dirgenler": true,
      "Doğantaş": true,
      "Gelemiş": true,
      "Gökçeören": true,
      "Gökçeyazı": true,
      "Gömbe": true,
      "Gürsu": true,
      "Hacıoğlan": true,
      "İkizce": true,
      "İslamlar": true,
      "Kalkan": true,
      "Karadağ": true,
      "Kasaba": true,
      "Kemer": true,
      "Kınık": true,
      "Kızılağaç": true,
      "Ortabağ": true,
      "Ova": true,
      "Palamut": true,
      "Pınarbaşı": true,
      "Sahil Barak": true,
      "Sahilkılınçlı": true,
      "Sarıbelen": true,
      "Sarılar": true,
      "Sinneli": true,
      "Sütleğen": true,
      "Uğrar": true,
      "Üzümlü": true,
      "Yaylakılınçlı": true,
      "Yaylapalamut": true,
      "Yeniköy": true,
      "Yeşilbarak": true,
      "Yeşilköy": true,
      "Yuvacık": true
    },
    "Kemer": {
      "Arslanbucak": true,
      "Beldibi": true,
      "Beycik": true,
      "Çamyuva": true,
      "Göynük": true,
      "Kiriş": true,
      "Kuzdere": true,
      "Merkez": true,
      "Ovacık": true,
      "Tekirova": true,
      "Ulupınar": true,
      "Yeni": true
    },
    "Kepez": {
      "Ahatlı": true,
      "Aktoprak": true,
      "Altıayak": true,
      "Altınova Düden": true,
      "Altınova Orta": true,
      "Altınova Sinan": true,
      "Atatürk": true,
      "Avni Tolunay": true,
      "Ayanoğlu": true,
      "Aydoğmuş": true,
      "Baraj": true,
      "Barış": true,
      "Başköy": true,
      "Beşkonaklılar": true,
      "Çamlıbel": true,
      "Çamlıca": true,
      "Çankaya": true,
      "Demirel": true,
      "Duacı": true,
      "Duraliler": true,
      "Düdenbaşı": true,
      "Emek": true,
      "Erenköy": true,
      "Esentepe": true,
      "Fabrikalar": true,
      "Fatih": true,
      "Fevzi Çakmak": true,
      "Gazi": true,
      "Gaziler": true,
      "Göçerler": true,
      "Göksu": true,
      "Gülveren": true,
      "Gündoğdu": true,
      "Güneş": true,
      "Habibler": true,
      "Hüsnü Karakaş": true,
      "Kanal": true,
      "Karşıyaka": true,
      "Kazım Karabekir": true,
      "Kepez": true,
      "Kızıllı": true,
      "Kirişçiler": true,
      "Kuzeyyaka": true,
      "Kültür": true,
      "Kütükçü": true,
      "Mehmet Akif Ersoy": true,
      "Menderes": true,
      "Odabaşı": true,
      "Özgürlük": true,
      "Santral": true,
      "Sütçüler": true,
      "Şafak": true,
      "Şelale": true,
      "Teomanpaşa": true,
      "Ulus": true,
      "Ünsal": true,
      "Varsak Esentepe": true,
      "Varsak Karşıyaka": true,
      "Varsak Menderes": true,
      "Yavuz Selim": true,
      "Yeni": true,
      "Yeni Doğan": true,
      "Yeni Emek": true,
      "Yeşiltepe": true,
      "Yeşilyurt": true,
      "Yükseliş": true,
      "Zafer": true,
      "Zeytinlik": true
    },
    "Konyaaltı": {
      "Akdamlar": true,
      "Akkuyu": true,
      "Altınkum": true,
      "Arapsuyu": true,
      "Aşağıkaraman": true,
      "Aydınlık": true,
      "Bahtılı": true,
      "Çağlarca": true,
      "Çakırlar": true,
      "Çitdibi": true,
      "Demircilik": true,
      "Doyran": true,
      "Doyran Çamlıbel": true,
      "Doyran Dağ": true,
      "Geyikbayırı": true,
      "Gökçam": true,
      "Gökdere": true,
      "Gürsu": true,
      "Hacısekililer": true,
      "Hisarçandır": true,
      "Hurma": true,
      "Karatepe": true,
      "Kır": true,
      "Kuruçay": true,
      "Kuşkavağı": true,
      "Liman": true,
      "Molla Yusuf": true,
      "Öğretmenevleri": true,
      "Pınarbaşı": true,
      "Sarısu": true,
      "Siteler": true,
      "Suiçecek": true,
      "Toros": true,
      "Uluç": true,
      "Uncalı": true,
      "Üçoluk": true,
      "Yarbaşçandır": true,
      "Yeni": true,
      "Zümrüt": true
    },
    "Korkuteli": {
      "Akyar": true,
      "Alaaddin": true,
      "Aşağıpazar": true,
      "Avdan": true,
      "Bahçeyaka": true,
      "Bayat": true,
      "Bayatbademleri": true,
      "Beğiş": true,
      "Bozova": true,
      "Büyükköy": true,
      "Çaykenarı": true,
      "Çıvgalar": true,
      "Çomaklı": true,
      "Çukurca": true,
      "Dereköy": true,
      "Duraliler": true,
      "Esenyurt": true,
      "Garipce": true,
      "Göçerler": true,
      "Güzle": true,
      "İmecik": true,
      "İmrahor": true,
      "Karabayır": true,
      "Karakuyu": true,
      "Karataş": true,
      "Kargalık": true,
      "Kargın": true,
      "Karşıyaka": true,
      "Kayabaş": true,
      "Kemerağzı": true,
      "Kevzer": true,
      "Kırkpınar": true,
      "Kızılaliler": true,
      "Kızılcadağ": true,
      "Kiremitli": true,
      "Kozağacı": true,
      "Köseler": true,
      "Küçükköy": true,
      "Küçüklü": true,
      "Leylek": true,
      "Mamatlar": true,
      "Manay": true,
      "Nebiler": true,
      "Osmankalfalar": true,
      "Sımandır": true,
      "Söğütcük": true,
      "Sülekler": true,
      "Taşkesiği": true,
      "Tatköy": true,
      "Uzunoluk": true,
      "Yakaköy": true,
      "Yazır": true,
      "Yeleme": true,
      "Yelten": true,
      "Yeni": true,
      "Yeşiloba": true,
      "Yeşilyayla": true,
      "Yukarıkaraman": true
    },
    "Kumluca": {
      "Adrasan": true,
      "Altınyaka": true,
      "Bağlık": true,
      "Belen": true,
      "Beşikçi": true,
      "Beykonak": true,
      "Büyükalan": true,
      "Cumhuriyet": true,
      "Çaltı": true,
      "Çayiçi": true,
      "Dereköy": true,
      "Ellinci Yıl": true,
      "Erentepe": true,
      "Eskicami": true,
      "Göksu": true,
      "Gölcük": true,
      "Güzören": true,
      "Hacıveliler": true,
      "Hızırkahya": true,
      "İncircik": true,
      "Karacaağaç": true,
      "Karacaören": true,
      "Karşıyaka": true,
      "Kasapçayırı": true,
      "Kavakköy": true,
      "Kum": true,
      "Kuzca": true,
      "Mavikent": true,
      "Merkez": true,
      "Meydan": true,
      "Narenciye": true,
      "Ortaköy": true,
      "Salur": true,
      "Sarıcasu": true,
      "Sarıkavak": true,
      "Temel Eğitim": true,
      "Toptaş": true,
      "Yazır": true,
      "Yeni": true,
      "Yenikışla": true,
      "Yeşilköy": true
    },
    "Manavgat": {
      "A. Hisar": true,
      "A. Pazarcı": true,
      "Ahmetler": true,
      "Aksaz": true,
      "Altınkaya": true,
      "Aşağıışıklar": true,
      "Aydınevler": true,
      "Bahçelievler": true,
      "Ballıbucak": true,
      "Belenobası": true,
      "Bereket": true,
      "Beşkonak": true,
      "Beydiğin": true,
      "Boztepe": true,
      "Bucakşeyhler": true,
      "Burmahan": true,
      "Büklüce": true,
      "Cevizler": true,
      "Çağlayan": true,
      "Çakış": true,
      "Çaltepe": true,
      "Çardakköy": true,
      "Çavuşköy": true,
      "Çayyazı": true,
      "Çeltikçi": true,
      "Çenger": true,
      "Çolaklı": true,
      "Değirmenözü": true,
      "Demirciler": true,
      "Denizkent": true,
      "Denizyaka": true,
      "Dikmen": true,
      "Doğançam": true,
      "Dolbazlar": true,
      "Düzağaç": true,
      "Emek": true,
      "Eski Hisar": true,
      "Evrenleryavşı": true,
      "Evrenseki": true,
      "Gaziler": true,
      "Gebece": true,
      "Gençler": true,
      "Gültepe": true,
      "Gündoğdu": true,
      "Güzelyalı": true,
      "Hacıali": true,
      "Hacıisalı": true,
      "Hacıobası": true,
      "Halitağalar": true,
      "Hatipler": true,
      "Hocalar": true,
      "Hocalı": true,
      "Ilıca": true,
      "Kadılar": true,
      "Kalemler": true,
      "Karabucak": true,
      "Karabük": true,
      "Karacalar": true,
      "Karakaya": true,
      "Karaöz": true,
      "Karavca": true,
      "Kasaplar": true,
      "Kavaklı": true,
      "Kırkkavak": true,
      "Kısalar": true,
      "Kızılağaç": true,
      "Kızıldağ": true,
      "Kızılot": true,
      "Milli Egemenlik": true,
      "Mimar Sinan": true,
      "Namaras": true,
      "Odaönü": true,
      "Oymapınar": true,
      "Örenşehir": true,
      "Örnek": true,
      "Perakende": true,
      "Sağırin": true,
      "Salkım Evler": true,
      "Salur": true,
      "Sanayi": true,
      "Saraçlı": true,
      "Sarılar": true,
      "Sevinçköy": true,
      "Seydiler": true,
      "Sırtköy": true,
      "Side": true,
      "Sorgun": true,
      "Sülek": true,
      "Şelale": true,
      "Şişeler": true,
      "Taşağıl": true,
      "Taşkesiği": true,
      "Tepeköy": true,
      "Tilkiler": true,
      "Ulukapı": true,
      "Uzunkale": true,
      "Uzunlar": true,
      "Y.hisar": true,
      "Y.pazarcı": true,
      "Yalçıdibi": true,
      "Yavrudoğan": true,
      "Yayla": true,
      "Yaylaalan": true,
      "Yeniköy": true,
      "Yeşilbağ": true,
      "Yukarıışıklar": true
    },
    "Muratpaşa": {
      "Altındağ": true,
      "Bahçelievler": true,
      "Balbey": true,
      "Barbaros": true,
      "Bayındır": true,
      "Cumhuriyet": true,
      "Çağlayan": true,
      "Çaybaşı": true,
      "Demircikara": true,
      "Deniz": true,
      "Doğuyaka": true,
      "Dutlubahçe": true,
      "Elmalı": true,
      "Ermenek": true,
      "Etiler": true,
      "Fener": true,
      "Gebizli": true,
      "Gençlik": true,
      "Güvenlik": true,
      "Güzelbağ": true,
      "Güzeloba": true,
      "Güzeloluk": true,
      "Haşimişcan": true,
      "Kılınçarslan": true,
      "Kırcami": true,
      "Kışla": true,
      "Kızılarık": true,
      "Kızılsaray": true,
      "Kızıltoprak": true,
      "Konuksever": true,
      "Mehmetçik": true,
      "Meltem": true,
      "Memurevleri": true,
      "Meydankavağı": true,
      "Muratpaşa": true,
      "Sedir": true,
      "Selçuk": true,
      "Sinan": true,
      "Soğuksu": true,
      "Şirinyalı": true,
      "Tahılpazarı": true,
      "Tarım": true,
      "Topçular": true,
      "Tuzcular": true,
      "Üçgen": true,
      "Varlık": true,
      "Yenigöl": true,
      "Yenigün": true,
      "Yeşilbahçe": true,
      "Yeşildere": true,
      "Yeşilova": true,
      "Yıldız": true,
      "Yüksekalan": true,
      "Zerdalilik": true,
      "Zümrütova": true
    },
    "Serik": {
      "Abdurrahmanlar": true,
      "Akbaş": true,
      "Akçaalan": true,
      "Akçapınar": true,
      "Alacami": true,
      "Aşağıçatma": true,
      "Aşağıkocayatak": true,
      "Aşağıoba": true,
      "Belek": true,
      "Belkıs": true,
      "Belpınar": true,
      "Berendi": true,
      "Bilginler": true,
      "Boğazkent": true,
      "Bozdoğan": true,
      "Bucakköy": true,
      "Burmahancı": true,
      "Büğüş": true,
      "Cumalı": true,
      "Cumhuriyet": true,
      "Çakallık": true,
      "Çanakçı": true,
      "Çandır": true,
      "Çatallar": true,
      "Demirciler": true,
      "Deniztepesi": true,
      "Dikmen": true,
      "Dorumlar": true,
      "Eminceler": true,
      "Eskiyürük": true,
      "Etler": true,
      "Gebiz": true,
      "Gedik": true,
      "Gökçepınar": true,
      "Hacıosmanlar": true,
      "Hasdümen": true,
      "Haskızılören": true,
      "Haspınar": true,
      "Kadriye": true,
      "Karadayı": true,
      "Karataş": true,
      "Karıncalı": true,
      "Kayaburnu": true,
      "Kırbaş": true,
      "Kozağacı": true,
      "Kozan": true,
      "Kökez": true,
      "Kuşlar": true,
      "Kürüş": true,
      "Merkez": true,
      "Nebiler": true,
      "Orta": true,
      "Pınarcık": true,
      "Sarıabalı": true,
      "Şatırlı": true,
      "Tekke": true,
      "Töngüşlü": true,
      "Üründü": true,
      "Yanköy": true,
      "Yeni": true,
      "Yeşilvadi": true,
      "Yeşilyurt": true,
      "Yukarıçatma": true,
      "Yukarıkocayatak": true,
      "Yumaklar": true,
      "Zırlankaya": true
    }
  },
  "Ardahan": {
    "Çıldır": {
      "Aşıkşenlik": true,
      "Çankaya": true,
      "Çay": true,
      "Dedekorkut": true,
      "Kuzukaya": true,
      "Suhara": true,
      "Ufuktepe": true,
      "Yakınsu": true,
      "Yeni": true,
      "Yıldırımtepe": true
    },
    "Damal": {
      "Ata": true,
      "Cumhuriyet": true,
      "Çaybaşı": true,
      "İnönü": true,
      "Kalender": true,
      "Konuk Sever": true,
      "Mustafa Kemal": true,
      "Serhat": true
    },
    "Göle": {
      "Dedeşen": true,
      "Durançam": true,
      "Fevzi Çakmak": true,
      "Kazım Karabekir": true,
      "Köprülü Merkez": true,
      "Kubilay Bey": true,
      "Kuzupınarı": true,
      "Salim Bey": true
    },
    "Hanak": {
      "Alaçam": true,
      "Atalar": true,
      "Avcılar": true,
      "Hürriyet": true,
      "Ortakent Merkez": true,
      "Selam Verdi": true
    },
    "Merkez": {
      "Atatürk": true,
      "Gürçayır": true,
      "Halilefendi": true,
      "İnönü": true,
      "Kaptanpaşa": true,
      "Karagöl": true,
      "Yeni": true
    },
    "Posof": {
      "Doğrular": true,
      "Merkez": true
    }
  },
  "Artvin": {
    "Ardanuç": {
      "Merkez": true
    },
    "Arhavi": {
      "Aşağı Hacılar": true,
      "Boğaziçi": true,
      "Cumhuriyet": true,
      "Kale": true,
      "Musazade": true,
      "Yemişlik": true,
      "Yukarı Hacılar": true
    },
    "Borçka": {
      "Aksu": true,
      "Gündoğdu": true,
      "Küçük Köy": true,
      "Merkez": true,
      "Yeniyol": true
    },
    "Hopa": {
      "Bucak": true,
      "Cumhuriyet": true,
      "Merkez Kuledibi": true,
      "Ortahopa": true,
      "Sugören": true,
      "Sundura": true,
      "Yukarı Kuledibi": true
    },
    "Kemalpaşa": {
      "Cumhuriyet": true,
      "Selimiye": true,
      "Uzunyalı": true
    },
    "Merkez": {
      "Balcıoğlu": true,
      "Çamlık": true,
      "Çarşı": true,
      "Çayağzı": true,
      "Dere": true,
      "Orta": true,
      "Yeni": true
    },
    "Murgul": {
      "Damar": true,
      "Küre": true
    },
    "Şavşat": {
      "Armutlu": true,
      "Söğütlü": true,
      "Yeniköy": true
    },
    "Yusufeli": {
      "Çoruh": true,
      "Erdemler": true,
      "Kaçkar": true,
      "Livane": true,
      "Sancak": true
    }
  },
  "Aydın": {
    "Bozdoğan": {
      "Akçay": true,
      "Akseki": true,
      "Akyaka": true,
      "Alamut": true,
      "Alhisar": true,
      "Altıntaş": true,
      "Amasya": true,
      "Asma": true,
      "Başalan": true,
      "Cumhuriyet": true,
      "Çamlıdere": true,
      "Çarşı": true,
      "Dömen": true,
      "Dutağaç": true,
      "Eymir": true,
      "Güney": true,
      "Güneyyaka": true,
      "Güre": true,
      "Güvenir": true,
      "Haydere": true,
      "Hıdırbaba": true,
      "Hışımlar": true,
      "Hisar": true,
      "Kakkalan": true,
      "Kamışlar": true,
      "Karaahmetler": true,
      "Karabağlar": true,
      "Kavaklı": true,
      "Kazandere": true,
      "Kemer": true,
      "Kılavuzlar": true,
      "Kızılca": true,
      "Kızıltepe": true,
      "Konaklı": true,
      "Koyuncular": true,
      "Körteke": true,
      "Madran": true,
      "Olukbaşı": true,
      "Osmaniye": true,
      "Örencik": true,
      "Örentaht": true,
      "Örmepınar": true,
      "Örtülü": true,
      "Pınarlı": true,
      "Seki": true,
      "Sırma": true,
      "Tütüncüler": true,
      "Yaka": true,
      "Yazıkent": true,
      "Yeni": true,
      "Yenice": true,
      "Yeniköy": true,
      "Yeşil Yenice": true,
      "Yeşilçam": true,
      "Ziyaretli": true
    },
    "Buharkent": {
      "Ericek": true,
      "Feslek": true,
      "Gelenbe": true,
      "Gündoğan": true,
      "İstiklal": true,
      "Kamilpaşa": true,
      "Kayaburnu": true,
      "Kızıldere": true,
      "Menderes": true,
      "Muratdağı": true,
      "Ortakçı": true,
      "Savcıllı": true,
      "Üçeylül": true,
      "Zafer": true
    },
    "Çine": {
      "Akçaova": true,
      "Akdam": true,
      "Alabayır": true,
      "Altınabat": true,
      "Altınova": true,
      "Bağlarbaşı": true,
      "Bahçearası": true,
      "Bedirler": true,
      "Bereket": true,
      "Bölüntü": true,
      "Bucak": true,
      "Camızağılı": true,
      "Cumalı": true,
      "Cumhuriyet": true,
      "Çaltı": true,
      "Çatak": true,
      "Çöğürlük": true,
      "Dereli": true,
      "Doğanyurt": true,
      "Dorumlar": true,
      "Dutluoluk": true,
      "Elderesi": true,
      "Esentepe": true,
      "Eskiçine": true,
      "Evciler": true,
      "Gökyaka": true,
      "Hacıpaşalar": true,
      "Hallaçlar": true,
      "Hamitabat": true,
      "Hasanlar": true,
      "İbrahimkavağı": true,
      "Kabalar": true,
      "Kabataş": true,
      "Kadılar": true,
      "Kahraman": true,
      "Karahayıt": true,
      "Karakollar": true,
      "Karanfiller": true,
      "Karğı": true,
      "Kasar": true,
      "Kavşıt": true,
      "Kırkışık": true,
      "Kırksakallar": true,
      "Kızılgüney": true,
      "Kirazderesi": true,
      "Kuruköy": true,
      "Mutaflar": true,
      "Ovacık": true,
      "Özeren": true,
      "Sağlık": true,
      "Saraçlar": true,
      "Sarıköy": true,
      "Sarıoğlu": true,
      "Sarnıç": true,
      "Seferler": true,
      "Soğancılar": true,
      "Soğukoluk": true,
      "Söğütçük": true,
      "Subaşı": true,
      "Şevketiye": true,
      "Taşoluk": true,
      "Tatarmemişler": true,
      "Tepeköy": true,
      "Topçam": true,
      "Umurköy": true,
      "Ünlüce": true,
      "Yağcılar": true,
      "Yeni": true,
      "Yeniköy": true,
      "Yeşilköy": true,
      "Yolboyu": true,
      "Yörükler": true
    },
    "Didim": {
      "Ak-yeniköy": true,
      "Akbük": true,
      "Akköy": true,
      "Altınkum": true,
      "Balat": true,
      "Batıköy": true,
      "Cumhuriyet": true,
      "Çamlık": true,
      "Denizköy": true,
      "Efeler": true,
      "Fevzipaşa": true,
      "Hisar": true,
      "Mavişehir": true,
      "Mersindere": true,
      "Yalıköy": true,
      "Yeni": true
    },
    "Efeler": {
      "Adnan Menderes": true,
      "Alanlı": true,
      "Alatepe": true,
      "Ambarcık": true,
      "Armutlu": true,
      "Aşağıkayacık": true,
      "Ata": true,
      "Bademli": true,
      "Balıkköy": true,
      "Baltaköy": true,
      "Böcek": true,
      "Cuma": true,
      "Cumhuriyet": true,
      "Çayyüzü": true,
      "Çeştepe": true,
      "Çiftlikköy": true,
      "Dağeymiri": true,
      "Dalama": true,
      "Dalama Bucağı Yeniköy": true,
      "Danişment": true,
      "Dereköy": true,
      "Doğan": true,
      "Efeler": true,
      "Eğrikavak": true,
      "Emirdoğan": true,
      "Fatih": true,
      "Girne": true,
      "Gödrenli": true,
      "Gölcük": true,
      "Gölhisar": true,
      "Gözpınar": true,
      "Güzelhisar": true,
      "Hasanefendi-ramazan Paşa": true,
      "Horozköy": true,
      "Ilıcabaşı": true,
      "Işıklı": true,
      "İlyasdere": true,
      "İmamköy": true,
      "İstiklal": true,
      "Kadıköy": true,
      "Kalfaköy": true,
      "Karahayıt": true,
      "Karaköy": true,
      "Kardeşköy": true,
      "Kemer": true,
      "Kenger": true,
      "Kırıklar": true,
      "Kızılcaköy": true,
      "Kocagür": true,
      "Konuklu": true,
      "Kozalaklı": true,
      "Köprülü-veysipaşa": true,
      "Kuloğullar": true,
      "Kurtuluş": true,
      "Kuyucular": true,
      "Kuyulu": true,
      "Merkez Bucağı Yeniköy": true,
      "Mesudiye": true,
      "Mesutlu": true,
      "Meşrutiyet": true,
      "Mimar Sinan": true,
      "Musluca": true,
      "Orta": true,
      "Ortaköy": true,
      "Osman Yozgatlı": true,
      "Ovaeymir": true,
      "Pınardere": true,
      "Savrandere": true,
      "Serçeköy": true,
      "Sıralılar": true,
      "Şahnalı": true,
      "Şevketiye": true,
      "Tepecik": true,
      "Tepeköy": true,
      "Terziler": true,
      "Umurlu": true,
      "Yağcılar": true,
      "Yedi Eylül": true,
      "Yılmazköy": true,
      "Yukarıkayacık": true,
      "Zafer": true,
      "Zeybek": true,
      "Zeytinköy": true
    },
    "Germencik": {
      "Abdurrahmanlar": true,
      "Alangüllü": true,
      "Balatçık": true,
      "Bozköy": true,
      "Camikebir": true,
      "Çamköy": true,
      "Çarıklar": true,
      "Dağkaraağaç": true,
      "Dağyeni": true,
      "Dampınar": true,
      "Dereköy": true,
      "Gümüşköy": true,
      "Gümüşyeniköy": true,
      "Habibler": true,
      "Hıdırbeyli": true,
      "İstasyon": true,
      "Karaağaçlı": true,
      "Kızılcagedik": true,
      "Kızılcapınar": true,
      "Mesudiye": true,
      "Meşeli": true,
      "Moralı": true,
      "Mursallı": true,
      "Naipli": true,
      "Neşetiye": true,
      "Ortaklar": true,
      "Ömerbeyli": true,
      "Park": true,
      "Reisköy": true,
      "Selatin": true,
      "Tekin": true,
      "Turanlar": true,
      "Uzunkum": true,
      "Üzümlü": true,
      "Yedieylül": true,
      "Yeni": true
    },
    "İncirliova": {
      "Acarlar": true,
      "Akçeşme": true,
      "Arpadere": true,
      "Arzular": true,
      "Atatürk": true,
      "Beyköy": true,
      "Cumhuriyet": true,
      "Dereağzı": true,
      "Eğrek": true,
      "Erbeyli": true,
      "Gerenkova": true,
      "Hacıaliobası": true,
      "Hamitler": true,
      "Hürriyet": true,
      "İkizdere": true,
      "İsafakılar": true,
      "İstiklal": true,
      "Karabağ": true,
      "Karagözler": true,
      "Köprüova": true,
      "Kurtuluş": true,
      "Osmanbükü": true,
      "Palamut": true,
      "Sandıklı": true,
      "Sınırteke": true,
      "Şirindere": true,
      "Yazıdere": true,
      "Zafer": true
    },
    "Karacasu": {
      "Alemler": true,
      "Aşağıgörle": true,
      "Ataeymir": true,
      "Ataköy": true,
      "Bahçeköy": true,
      "Bereketli": true,
      "Bingeç": true,
      "Büyükdağlı": true,
      "Cabi": true,
      "Cuma": true,
      "Çamarası": true,
      "Çamköy": true,
      "Dedeler": true,
      "Dereköy": true,
      "Dikmen": true,
      "Esençay": true,
      "Geyre": true,
      "Görle": true,
      "Güzelbeyli": true,
      "Güzelköy": true,
      "Hacıhıdırlar": true,
      "Işıklar": true,
      "Karabağlar": true,
      "Karacaören": true,
      "Küçükdağlı": true,
      "Nargedik": true,
      "Palamutçuk": true,
      "Tekeliler": true,
      "Tepecik": true,
      "Yaykın": true,
      "Yaylalı": true,
      "Yazır": true,
      "Yenice": true,
      "Yeniköy": true,
      "Yeşilköy": true,
      "Yeşilyurt": true,
      "Yolaltı": true,
      "Yolüstü": true
    },
    "Karpuzlu": {
      "Abak": true,
      "Akçaabat": true,
      "Bayraktepe": true,
      "Cumalar": true,
      "Çobanisa": true,
      "Ektirli": true,
      "Gölcük": true,
      "Güney": true,
      "Hatıpkışla": true,
      "Işıklar": true,
      "Koğuk": true,
      "Meriçler": true,
      "Mutluca": true,
      "Orta": true,
      "Ovapınarı": true,
      "Ömerler": true,
      "Şenköy": true,
      "Tekeler": true,
      "Tütünlük": true,
      "Ulukonak": true,
      "Umcular": true,
      "Yağşılar": true,
      "Yeni": true
    },
    "Koçarlı": {
      "Adnan Menderes": true,
      "Akmescit": true,
      "Atatürk": true,
      "Bağarcık": true,
      "Bağcılar": true,
      "Bıyıklı": true,
      "Birci": true,
      "Boğaziçi": true,
      "Boydere": true,
      "Büyükdere": true,
      "Cincin": true,
      "Çakırbeyli": true,
      "Çakmar": true,
      "Çallı": true,
      "Çeşmeköy": true,
      "Çulhalar": true,
      "Dedeköy": true,
      "Dereköy": true,
      "Esentepe": true,
      "Evsekler": true,
      "Gaffarlar": true,
      "Gözkaya": true,
      "Güdüşlü": true,
      "Gündoğan": true,
      "Hacıhamzalar": true,
      "Halilbeyli": true,
      "Haydarlı": true,
      "Karaağaç": true,
      "Karacaören": true,
      "Karadut": true,
      "Kasaplar": true,
      "Kızılcabölük": true,
      "Kızılkaya": true,
      "Kullar": true,
      "Kuşlarbelen": true,
      "Mersinbelen": true,
      "Orhaniye": true,
      "Orta": true,
      "Sapalan": true,
      "Satılar": true,
      "Sobuca": true,
      "Şahinciler": true,
      "Şenköy": true,
      "Taşköy": true,
      "Tekeli": true,
      "Tığıllar": true,
      "Timinciler": true,
      "Yağcıdere": true,
      "Yağhanlı": true,
      "Yeni": true,
      "Yeniköy": true,
      "Zeytinköy": true
    },
    "Köşk": {
      "Ahatlar": true,
      "Akçaköy": true,
      "Altıeylül": true,
      "Baklaköy": true,
      "Başçayır": true,
      "Beyköy": true,
      "Cumadere": true,
      "Cumayanı": true,
      "Çarşı": true,
      "Çiftlikköy": true,
      "Gökkiriş": true,
      "Gündoğan": true,
      "Güzelköy": true,
      "Ilıdağ": true,
      "Karatepe": true,
      "Ketenyeri": true,
      "Kıran": true,
      "Kızılcaköy": true,
      "Kızılcayer": true,
      "Koçak": true,
      "Menteşeler": true,
      "Mezeköy": true,
      "Ovaköy": true,
      "Sarıçam": true,
      "Serdaroğlu": true,
      "Soğukkuyu": true,
      "Uzundere": true,
      "Yavuzköy": true
    },
    "Kuşadası": {
      "Alacamescit": true,
      "Bayraklıdede": true,
      "Caferli": true,
      "Camiatik": true,
      "Camikebir": true,
      "Cumhuriyet": true,
      "Çınarköy": true,
      "Dağ": true,
      "Davutlar": true,
      "Değirmendere": true,
      "Ege": true,
      "Güzelçamlı": true,
      "Hacıfeyzullah": true,
      "İkiçeşmelik": true,
      "Kadıkalesi": true,
      "Kadınlar Denizi": true,
      "Karaova": true,
      "Kirazlı": true,
      "Soğucak": true,
      "Türkmen": true,
      "Yavansu": true,
      "Yaylaköy": true,
      "Yeniköy": true
    },
    "Kuyucak": {
      "Aksaz": true,
      "Aydınoğlu": true,
      "Azizabat": true,
      "Başaran": true,
      "Belenova": true,
      "Beşeylül": true,
      "Beşeylül (merkez)": true,
      "Bucakköy": true,
      "Cumhuriyet": true,
      "Çamdibi": true,
      "Çobanisa": true,
      "Dereköy": true,
      "Fatih": true,
      "Gencelli": true,
      "Gencellidere": true,
      "Horsunlu": true,
      "İğdecik": true,
      "Karapınar": true,
      "Kayran": true,
      "Kurtuluş": true,
      "Kurtuluş (horsunlu)": true,
      "Musakolu": true,
      "Mustafapaşa": true,
      "Ovacık": true,
      "Ören": true,
      "Pamucak": true,
      "Pamukören": true,
      "Sarıcaova": true,
      "Taşoluk": true,
      "Yakuppaşa": true,
      "Yamalak": true,
      "Yaylalı": true,
      "Yeni": true,
      "Yeşildere": true,
      "Yöre": true,
      "Yukarıyakacık": true
    },
    "Nazilli": {
      "Akpınar": true,
      "Aksu": true,
      "Altıntaş": true,
      "Apaklar": true,
      "Arslanlı": true,
      "Aşağıörencik": true,
      "Aşağıyakacık": true,
      "Aydoğdu": true,
      "Bağcıllı": true,
      "Bayındır": true,
      "Beğerli": true,
      "Bekirler": true,
      "Bereketli": true,
      "Bozyurt": true,
      "Cumhuriyet": true,
      "Çapahasan": true,
      "Çatak": true,
      "Çaylı": true,
      "Çobanlar": true,
      "Dallıca": true,
      "Demirciler": true,
      "Dereağzı": true,
      "Derebaşı": true,
      "Dualar": true,
      "Dumlupınar": true,
      "Durasıllı": true,
      "Esenköy": true,
      "Esentepe": true,
      "Eycelli": true,
      "Gedik": true,
      "Gedikaltı": true,
      "Güzelköy": true,
      "Hamidiye": true,
      "Hamzallı": true,
      "Hasköy": true,
      "Haydarlı": true,
      "Hisarcık": true,
      "Işıklar": true,
      "İsabeyli": true,
      "İstiklal": true,
      "Kahvederesi": true,
      "Karaçay": true,
      "Karahallı": true,
      "Kardeşköy": true,
      "Kaşıkçılar": true,
      "Kavacık": true,
      "Kestel": true,
      "Ketendere": true,
      "Ketenova": true,
      "Kırcaklı": true,
      "Kızıldere": true,
      "Kocakesik": true,
      "Kozdere": true,
      "Kurtuluş": true,
      "Kuşçular": true,
      "Mescitli": true,
      "Ocaklı": true,
      "Ovacık": true,
      "Pınarbaşı": true,
      "Pirlibey": true,
      "Prof.muammer Aksoy": true,
      "Rahmanlar": true,
      "Sailer": true,
      "Samailli": true,
      "Sevindikli": true,
      "Sümer": true,
      "Şimşelli": true,
      "Şirinevler": true,
      "Toygar": true,
      "Turan": true,
      "Uzunçam": true,
      "Yalınkuyu": true,
      "Yaylapınar": true,
      "Yazırlı": true,
      "Yellice": true,
      "Yeni": true,
      "Yeni Sanayii": true,
      "Yeşil": true,
      "Yeşilyurt": true,
      "Yıldıztepe": true,
      "Yukarıörencik": true,
      "Zafer": true
    },
    "Söke": {
      "Ağaçlı": true,
      "Akçakaya": true,
      "Akçakonak": true,
      "Argavlı": true,
      "Arslanyaylası": true,
      "Atatürk": true,
      "Atburgazı": true,
      "Avcılar": true,
      "Avşar": true,
      "Bağarası": true,
      "Bayırdamı": true,
      "Burunköy": true,
      "Cumhuriyet": true,
      "Çalıköy": true,
      "Çalışlı": true,
      "Çavdar": true,
      "Çeltikçi": true,
      "Demirçay": true,
      "Doğanbey": true,
      "Fevzipaşa": true,
      "Gölbent": true,
      "Güllübahçe": true,
      "Güneyyaka": true,
      "Güzeltepe": true,
      "Karaatlı": true,
      "Karacahayıt": true,
      "Karakaya": true,
      "Kaygıllı": true,
      "Kemalpaşa": true,
      "Kisir": true,
      "Konak": true,
      "Köprüalan": true,
      "Nalbantlar": true,
      "Özbaşı": true,
      "Pamukçular": true,
      "Sarıkemer": true,
      "Savuca": true,
      "Sayrakçı": true,
      "Sazlı": true,
      "Serçin": true,
      "Sofular": true,
      "Tuzburgazı": true,
      "Yamaç": true,
      "Yenicamii": true,
      "Yenidoğan": true,
      "Yenikent": true,
      "Yeniköy": true,
      "Yeşilköy": true,
      "Yuvaca": true
    },
    "Sultanhisar": {
      "Atça": true,
      "Beşeylül": true,
      "Demirhan": true,
      "Eskihisar": true,
      "Güvendik": true,
      "Hisar": true,
      "İncealan": true,
      "Kabaca": true,
      "Kavaklı": true,
      "Kılavuzlar": true,
      "Kurtuluş": true,
      "Malgaçemir": true,
      "Malgaçmustafa": true,
      "Rekmez": true,
      "Salavatlı": true,
      "Uzunlar": true,
      "Yağdere": true,
      "Zafer": true
    },
    "Yenipazar": {
      "Alhan": true,
      "Alioğullar": true,
      "Çarşı": true,
      "Çavdar": true,
      "Çulhan": true,
      "Dereköy": true,
      "Direcik": true,
      "Doğu": true,
      "Donduran": true,
      "Eğridere": true,
      "Hacıköseler": true,
      "Hamzabali": true,
      "Hükümet": true,
      "Karacaören": true,
      "Karaçakal": true,
      "Koyunlar": true,
      "Paşaköy": true,
      "Yeni": true
    }
  },
  "Balıkesir": {
    "Altıeylül": {
      "1.gündoğan": true,
      "2.gündoğan": true,
      "Akarsu": true,
      "Akçaköy": true,
      "Aliağa": true,
      "Altı Eylül": true,
      "Aslıhan": true,
      "Aslıhantepeciği": true,
      "Ataköy": true,
      "Atköy": true,
      "Aynaoğlu": true,
      "Ayşebacı": true,
      "Ayvacık": true,
      "Ayvatlar": true,
      "Bağalan": true,
      "Bahçedere": true,
      "Bahçelievler": true,
      "Balıklı": true,
      "Bayat": true,
      "Bereketli": true,
      "Beşpınar": true,
      "Boğatepe": true,
      "Bozen": true,
      "Büyükbostancı": true,
      "Cinge": true,
      "Çakıllık": true,
      "Çamköy": true,
      "Çandır": true,
      "Çayırhisar": true,
      "Çınarlıdere": true,
      "Çiftçidere": true,
      "Çiftlikköy": true,
      "Çukurhüseyin": true,
      "Dallımandıra": true,
      "Dedeburnu": true,
      "Dereçiftlik": true,
      "Dereköy": true,
      "Dinkçiler": true,
      "Dişbudak": true,
      "Ertuğrul": true,
      "Gaziosmanpaşa": true,
      "Gökçeören": true,
      "Gökköy": true,
      "Gümüsçesme": true,
      "Hacı Ilbey": true,
      "Halalca": true,
      "Hasan Basri Çantay": true,
      "İnkaya": true,
      "Kabaklı": true,
      "Karabeyler": true,
      "Karakavak": true,
      "Karakaya": true,
      "Karaman": true,
      "Karamanlar": true,
      "Kasaplar": true,
      "Kesirven": true,
      "Kılcılar": true,
      "Kirazköy": true,
      "Kirazpınar": true,
      "Konakpınar": true,
      "Kozderegüvem": true,
      "Kozören": true,
      "Köseler": true,
      "Köylü Köyü": true,
      "Kuşkaya": true,
      "Kutludüğün": true,
      "Kuyualan": true,
      "Küçükbostancı": true,
      "Küpeler": true,
      "Kürse": true,
      "Macarlar": true,
      "Meryemdere": true,
      "Nergiz": true,
      "Orhanlı": true,
      "Ortamandıra": true,
      "Ovabayındır": true,
      "Ovaköy": true,
      "Pamukçu": true,
      "Paşaköy": true,
      "Plevne": true,
      "Sarıalan": true,
      "Selimiye": true,
      "Sıvatpınar": true,
      "Sütlüce": true,
      "Taşköy": true,
      "Taşpınar": true,
      "Tayyipler": true,
      "Turnalar": true,
      "Türkali": true,
      "Yakupköy": true,
      "Yenice": true,
      "Yeşiller": true,
      "Yeşilyurt": true,
      "Yıldız": true
    },
    "Ayvalık": {
      "150 Evler": true,
      "Akçapınar": true,
      "Ali Çetinkaya": true,
      "Altınova": true,
      "Bağyüzü": true,
      "Beşiktepe": true,
      "Bulutçeşme": true,
      "Çakmak": true,
      "Çamoba": true,
      "Fethiye": true,
      "Fevzipaşa-vehbibey": true,
      "Gazi Kemal Paşa": true,
      "Hacıveliler": true,
      "Hamdibey": true,
      "Hayrettinpaşa": true,
      "İsmetpaşa": true,
      "Karaayıt": true,
      "Kazım Karabekir": true,
      "Kırcalar": true,
      "Küçükköy": true,
      "Mithatpaşa": true,
      "Murateli": true,
      "Mutlu": true,
      "Namık Kemal": true,
      "Odaburnu": true,
      "Sahil Kent": true,
      "Sakarya": true,
      "Sefa Çamlık": true,
      "Tıfıllar": true,
      "Türközü": true,
      "Üçkabaağaç": true,
      "Yeni": true,
      "Yeniköy": true,
      "Zekibey": true
    },
    "Balya": {
      "Akbaş": true,
      "Alidemirci": true,
      "Bengiler": true,
      "Çakallar": true,
      "Çalova": true,
      "Çamavşar": true,
      "Çamucu": true,
      "Çarmık": true,
      "Çiğdem": true,
      "Çukurcak": true,
      "Danişment": true,
      "Değirmendere": true,
      "Dereköy": true,
      "Doğanlar": true,
      "Enverpaşa": true,
      "Farsak": true,
      "Gökmusa": true,
      "Göktepe": true,
      "Göloba": true,
      "Habipler": true,
      "Hacıhüseyin": true,
      "Havutbaşı": true,
      "Ilıca": true,
      "Kadıköy": true,
      "Karacahisar": true,
      "Karlık": true,
      "Kaşıkçı": true,
      "Kavakalanı": true,
      "Kayalar": true,
      "Kayapınar": true,
      "Koca Camii": true,
      "Kocabük": true,
      "Koyuneri": true,
      "Mancılık": true,
      "Medrese": true,
      "Müstecap": true,
      "Narlı": true,
      "Orhanlar": true,
      "Örenköy": true,
      "Patlak": true,
      "Semizköy": true,
      "Söbücealan": true,
      "Yarışalanı": true,
      "Yaylacık": true,
      "Yazlık": true,
      "Yenikavak": true
    },
    "Bandırma": {
      "100.yıl": true,
      "17 Eylül": true,
      "600 Evler": true,
      "Akçapınar": true,
      "Aksakal": true,
      "Ayyıldız": true,
      "Bentbaşı": true,
      "Bereketli": true,
      "Beyköy": true,
      "Bezirci": true,
      "Çakılköy": true,
      "Çalışkanlar": true,
      "Çarıkköy": true,
      "Çepni": true,
      "Çınarlı": true,
      "Çinge": true,
      "Dedeoba": true,
      "Dere": true,
      "Doğa": true,
      "Doğanpınar": true,
      "Doğruca": true,
      "Dutliman": true,
      "Edincik": true,
      "Emre": true,
      "Ergili": true,
      "Erikli": true,
      "Eskiziraatli": true,
      "Gölyaka": true,
      "Günaydın": true,
      "Hacı Yusuf": true,
      "Haydar Çavuş": true,
      "Hıdırköy": true,
      "İhsaniye": true,
      "Karaçalılık": true,
      "Kayacık": true,
      "Kirazlı": true,
      "Kuşcenneti": true,
      "Külefli": true,
      "Levent": true,
      "Mahbubeler": true,
      "Misakça": true,
      "Orhaniye": true,
      "Ömerli": true,
      "Paşabayır": true,
      "Paşakent": true,
      "Paşakonak": true,
      "Paşamescit": true,
      "Sahil Yenice": true,
      "Sunullah": true,
      "Şirinçavuş": true,
      "Yeni": true,
      "Yenisığırcı": true,
      "Yeniyenice": true,
      "Yeniziraatli": true,
      "Yeşilçomlu": true
    },
    "Bigadiç": {
      "4 Eylül": true,
      "Abacı": true,
      "Adalı": true,
      "Akyar": true,
      "Alanköy": true,
      "Altınlar": true,
      "Aşağıçamlı": true,
      "Aşağıgöcek": true,
      "Babaköy": true,
      "Bademli": true,
      "Balatlı": true,
      "Başçeşme": true,
      "Beğendikler": true,
      "Bekirler": true,
      "Bozbük": true,
      "Camii": true,
      "Çağış": true,
      "Çamköy": true,
      "Çavuş": true,
      "Çayüstü": true,
      "Çekirdekli": true,
      "Çeribaşı": true,
      "Çıtak": true,
      "Çömlekçi": true,
      "Davutça": true,
      "Davutlar": true,
      "Dedeçınar": true,
      "Değirmenli": true,
      "Dere Çerkes": true,
      "Dikkonak": true,
      "Doğançam": true,
      "Durasılar": true,
      "Dündarcık": true,
      "Elyapan": true,
      "Emek": true,
      "Emirler": true,
      "Esenli": true,
      "Fethibey": true,
      "Güvemçetmi": true,
      "Hacıömerderesi": true,
      "Hamidiye": true,
      "Hisarköy": true,
      "Işıklar": true,
      "İğciler": true,
      "İlyaslar": true,
      "İskeleköy": true,
      "Kadıköy": true,
      "Kalafat": true,
      "Karabahçe": true,
      "Kargın": true,
      "Kayalıdere": true,
      "Kayırlar": true,
      "Kırca": true,
      "Kızılçukur": true,
      "Kozpınar": true,
      "Köseler": true,
      "Kuyu": true,
      "Küçükyeniköy": true,
      "Kürsü": true,
      "Mecidiye": true,
      "Meyvalı": true,
      "Okçular": true,
      "Okçularyeri": true,
      "Orta": true,
      "Osmanca": true,
      "Özgören": true,
      "Panayır": true,
      "Salmanlı": true,
      "Servi": true,
      "Topalak": true,
      "Tozağan": true,
      "Turfullar": true,
      "Yağcıbedir": true,
      "Yağcılar": true,
      "Yeniköy": true,
      "Yeşildere": true,
      "Yolbaşı": true,
      "Yukarıçamlı": true,
      "Yukarıgöçek": true,
      "Yürücekler": true
    },
    "Burhaniye": {
      "Ağacık": true,
      "Ali Çetinkaya": true,
      "Avunduk": true,
      "Bahadınlı": true,
      "Bahçelievler": true,
      "Börezli": true,
      "Cumhuriyet": true,
      "Çallı": true,
      "Çamtepe": true,
      "Çoruk": true,
      "Damlalı": true,
      "Dutluca": true,
      "Geriş": true,
      "Hacıahmet": true,
      "Hacıbozlar": true,
      "Hisarköy": true,
      "Hürriyet": true,
      "İskele": true,
      "Karadere": true,
      "Kırtık": true,
      "Kızıklı": true,
      "Kocacami": true,
      "Kurucaoluk": true,
      "Kuyucak": true,
      "Kuyumcu": true,
      "Mahkeme": true,
      "Memiş": true,
      "Öğretmenler": true,
      "Ören": true,
      "Pelitköy": true,
      "Sübeylidere": true,
      "Şahinler": true,
      "Şarköy": true,
      "Tahtacı": true,
      "Taylıeli": true,
      "Yabancılar": true,
      "Yaylacık": true,
      "Yunus": true,
      "Yunuslar": true
    },
    "Dursunbey": {
      "Adaören": true,
      "Akbaşlar": true,
      "Akçagüney": true,
      "Akyayla": true,
      "Alaçam": true,
      "Alagüney": true,
      "Arıklar": true,
      "Aşağımusalar": true,
      "Aşağıyağcılar": true,
      "Ayvacık": true,
      "Aziziye": true,
      "Bayıryüzügüney": true,
      "Beyce": true,
      "Beyel": true,
      "Boyalıca": true,
      "Bozyokuş": true,
      "Büyükakçaalan": true,
      "Cebeci": true,
      "Çakırca": true,
      "Çakmak": true,
      "Çaltıcak": true,
      "Çamharman": true,
      "Çamköy": true,
      "Çanakçı": true,
      "Çatalçam": true,
      "Çelikler": true,
      "Çınarköy": true,
      "Çiftçi": true,
      "Dada": true,
      "Değirmenciler": true,
      "Delice": true,
      "Demirciler": true,
      "Dereköy": true,
      "Dodurga": true,
      "Doğancılar": true,
      "Durabeyler": true,
      "Ericek": true,
      "Ferah": true,
      "Gazellidere": true,
      "Göbül": true,
      "Gökçedağ": true,
      "Gökçepınar": true,
      "Gölcük": true,
      "Güğü": true,
      "Gürleyen": true,
      "Hacıahmetpınarı": true,
      "Hacılar": true,
      "Hamzacık": true,
      "Hasanlar": true,
      "Hindikler": true,
      "Hondular": true,
      "Hopanlar": true,
      "Işıklar": true,
      "İrfaniye": true,
      "İsmailler": true,
      "İstasyon": true,
      "Karagöz": true,
      "Karakaya": true,
      "Karamanlar": true,
      "Karapınar": true,
      "Kardeşler": true,
      "Kavacık": true,
      "Kavakköy": true,
      "Kazimiye": true,
      "Kızılcadere": true,
      "Kızılöz": true,
      "Kireç": true,
      "Kumlu": true,
      "Kurtlar": true,
      "Kuzköy": true,
      "Küçükakçaalan": true,
      "Küçükler": true,
      "Mahmudiye": true,
      "Mahmutça": true,
      "Meydançayırı": true,
      "Mıcırlar": true,
      "Mollaoğlu": true,
      "Naipler": true,
      "Odaköy": true,
      "Osmaniye": true,
      "Örenköy": true,
      "Poyracık": true,
      "Ramazanlar": true,
      "Resüller": true,
      "Reşadiye": true,
      "Saçayak": true,
      "Sağırlar": true,
      "Sakızköy": true,
      "Sarısipahiler": true,
      "Sarnıçköy": true,
      "Sebiller": true,
      "Selimağa": true,
      "Sinderler": true,
      "Süleler": true,
      "Şabanlar": true,
      "Şenköy": true,
      "Tafak": true,
      "Taşkesiği": true,
      "Taşpınar": true,
      "Tepeköy": true,
      "Tezlik": true,
      "Turnacık": true,
      "Umurlar": true,
      "Üçeylül": true,
      "Vakıf": true,
      "Veliler": true,
      "Yassıören": true,
      "Yukarımusalar": true,
      "Yukarıyağcılar": true,
      "Yunuslar": true
    },
    "Edremit": {
      "Akçay": true,
      "Altınkum": true,
      "Altınoluk": true,
      "Arıtaşı": true,
      "Atatürk": true,
      "Avcılar": true,
      "Beyoba": true,
      "Bostancı": true,
      "Camivasat": true,
      "Cennetayağı": true,
      "Cumhuriyet": true,
      "Çamcı": true,
      "Çamlıbel": true,
      "Çıkrıkçı": true,
      "Darsofa": true,
      "Dereli": true,
      "Doyran": true,
      "Eroğlan": true,
      "Gazicelal": true,
      "Gaziilyas": true,
      "Güre": true,
      "Güre Cumhuriyet": true,
      "Hacıarslanlar": true,
      "Hacıtuğrul": true,
      "Hamidiye": true,
      "Hekimzade": true,
      "İbrahimce": true,
      "İkizçay": true,
      "İskele": true,
      "Kadıköy": true,
      "Kapıcıbaşı": true,
      "Kavlaklar": true,
      "Kızılkeçili": true,
      "Mehmetalan": true,
      "Narlı": true,
      "Ortaoba": true,
      "Pınarbaşı": true,
      "Sarıkız": true,
      "Soğanyemez": true,
      "Şahindere": true,
      "Tahtakuşlar": true,
      "Turhanbey": true,
      "Tuzcumurat": true,
      "Yaşyer": true,
      "Yaylaönü": true,
      "Yolören": true,
      "Zeytinli": true
    },
    "Erdek": {
      "Alaettin": true,
      "Aşağıyapıcı": true,
      "Atatürk": true,
      "Balıklı": true,
      "Ballıpınar": true,
      "Belkıs": true,
      "Çakıl": true,
      "Çeltikçi": true,
      "Doğanlar": true,
      "Halitpaşa": true,
      "Hamamlı": true,
      "Harmanlı": true,
      "İlhan": true,
      "Karşıyaka": true,
      "Kestanelik": true,
      "Narlı": true,
      "Ocaklar": true,
      "Ormanlı": true,
      "Paşalimanı": true,
      "Poyrazlı": true,
      "Sahil": true,
      "Şahinburgaz": true,
      "Tatlısu": true,
      "Turan": true,
      "Tuzla": true,
      "Yalı": true,
      "Yukarıyapıcı": true,
      "Zeytinli": true
    },
    "Gömeç": {
      "Dursunlu": true,
      "Hacıhüseyinler": true,
      "Hacıoğlu": true,
      "Hacıosman": true,
      "Karaağaç": true,
      "Kemalpaşa": true,
      "Keremköy": true,
      "Kobaşlar": true,
      "Kumgedik": true,
      "Kuyualan": true,
      "Mithatpaşa": true,
      "Ulubeyler": true,
      "Yaya": true
    },
    "Gönen": {
      "100.yıl": true,
      "Akçaali": true,
      "Akçapınar": true,
      "Alacaoluk": true,
      "Alaettin": true,
      "Alaşar": true,
      "Altay": true,
      "Armutlu": true,
      "Asmalıdere": true,
      "Atıcıoba": true,
      "Ayvalıdere": true,
      "Babayaka": true,
      "Bakırlı": true,
      "Balcı": true,
      "Balcıdede": true,
      "Bayramiç": true,
      "Beyoluk": true,
      "Bostancı": true,
      "Buğdaylı": true,
      "Büyüksoğuklar": true,
      "Canbaz": true,
      "Çakmak": true,
      "Çalıca": true,
      "Çalıoba": true,
      "Çatak": true,
      "Çığmış": true,
      "Çınarlı": true,
      "Çınarpınar": true,
      "Çifteçeşmeler": true,
      "Çiftlikalan": true,
      "Çobanhamidiye": true,
      "Dereköy": true,
      "Dışbudak": true,
      "Dumanalan": true,
      "Ekşidere": true,
      "Fındıklı": true,
      "Gaybular": true,
      "Gebeçınar": true,
      "Gelgeç": true,
      "Geyikli": true,
      "Gökçesu": true,
      "Gündoğan": true,
      "Gündoğdu": true,
      "Güneşli": true,
      "Hacımenteş": true,
      "Hacıvelioba": true,
      "Hafızhüseyinbey": true,
      "Hasanbey": true,
      "Havutça": true,
      "Hodul": true,
      "Ilıcak": true,
      "Ilıcaoba": true,
      "İncirli": true,
      "Kalburcu": true,
      "Kalfaköy": true,
      "Kaplanoba": true,
      "Karaağaçalan": true,
      "Karalarçiftliği": true,
      "Karasukabaklar": true,
      "Karşıyaka": true,
      "Kavakalan": true,
      "Kavakoba": true,
      "Keçeler": true,
      "Kınalar": true,
      "Killik": true,
      "Kocapınar": true,
      "Koçbayır": true,
      "Korudeğirmen": true,
      "Körpeağaç": true,
      "Köteyli": true,
      "Kumköy": true,
      "Kurtuluş": true,
      "Küçüksoğuklar": true,
      "Küpçıktı": true,
      "Malkoç": true,
      "Muratlar": true,
      "Ortaoba": true,
      "Osmanpazar": true,
      "Ömerler": true,
      "Paşaçiftlik": true,
      "Pehlivanhoca": true,
      "Plevne": true,
      "Reşadiye": true,
      "Rüstem": true,
      "Saraçlar": true,
      "Sarıköy": true,
      "Sebepli": true,
      "Söğüt": true,
      "Suçıktı": true,
      "Şaroluk": true,
      "Tahtalı": true,
      "Taştepe": true,
      "Tırnova": true,
      "Turplu": true,
      "Tuzakçı": true,
      "Tütüncü": true,
      "Ulukır": true,
      "Üçpınar": true,
      "Üzümlü": true,
      "Yeniakçapınar": true,
      "Yürükkeçidere": true
    },
    "Havran": {
      "Büyükdere": true,
      "Büyükşapçı": true,
      "Camiikebir": true,
      "Çakırdere": true,
      "Çakmak": true,
      "Çamdibi": true,
      "Çiğitzade": true,
      "Dereören": true,
      "Ebubekir": true,
      "Eğmir": true,
      "Eseler": true,
      "Fazlıca": true,
      "Halılar": true,
      "Hallaçlar": true,
      "Hamambaşı": true,
      "Hüseyinbeşeler": true,
      "İnönü": true,
      "Kalabak": true,
      "Karalar": true,
      "Karaoğlanlar": true,
      "Kobaklar": true,
      "Kocadağ": true,
      "Kocaseyit": true,
      "Köylüce": true,
      "Küçükdere": true,
      "Küçükşapçı": true,
      "Mescit": true,
      "Sarnıç": true,
      "Tarlabaşı": true,
      "Taşarası": true,
      "Tekke": true,
      "Temaşalık": true,
      "Tepeoba": true,
      "Yeni": true
    },
    "İvrindi": {
      "7eylül": true,
      "Akçal": true,
      "Aşağıkaleoba": true,
      "Ayaklı": true,
      "Bahçelievler": true,
      "Bedrettin": true,
      "Bozören": true,
      "Büyükfındık": true,
      "Büyükılıca": true,
      "Büyükyenice": true,
      "Çarkacı": true,
      "Çatalan": true,
      "Çelimler": true,
      "Çiçekli": true,
      "Çobanlar": true,
      "Çukurlar": true,
      "Çukuroba": true,
      "Değirmenbaşı": true,
      "Demirciler": true,
      "Döşeme": true,
      "Erdel": true,
      "Eriklikömürcü": true,
      "Evciler": true,
      "Gebeçınar": true,
      "Geçmiş": true,
      "Gökçeler": true,
      "Gökçeyazı": true,
      "Gömeniç": true,
      "Gözlüçayır": true,
      "Gümeli": true,
      "Hacıahmetler": true,
      "Haydar": true,
      "Hüseyinbeyobası": true,
      "Ilıcakpınar": true,
      "İkizce": true,
      "Karaçepiş": true,
      "Kaşağıl": true,
      "Kayapa": true,
      "Kılcılar": true,
      "Kına": true,
      "Kınık": true,
      "Kıpıklar": true,
      "Kışladere": true,
      "Kiraz Ören": true,
      "Kocaeli": true,
      "Kocaoba": true,
      "Korucu": true,
      "Kurtuluş": true,
      "Kuşdere": true,
      "Küçükfındık": true,
      "Küçükılıca": true,
      "Küçükyenice": true,
      "Mallıca": true,
      "Okçular": true,
      "Osmanköy": true,
      "Osmanlar": true,
      "Pelitören": true,
      "Sakarya": true,
      "Sarıca": true,
      "Sarıpınar": true,
      "Sofular": true,
      "Soğanbükü": true,
      "Susuzyayla": true,
      "Taşdibi": true,
      "Topuzlar": true,
      "Yağlılar": true,
      "Yaren": true,
      "Yeşilköy": true,
      "Yukarıkaleoba": true,
      "Yürekli": true
    },
    "Karesi": {
      "1.oruçgazi": true,
      "1.sakarya": true,
      "2.oruçgazi": true,
      "2.sakarya": true,
      "Adnan Menderes": true,
      "Akıncılar": true,
      "Aktarma": true,
      "Alacabayır": true,
      "Ali Hikmet Paşa": true,
      "Armutalan": true,
      "Atatürk": true,
      "Aygören": true,
      "Bakacak": true,
      "Beyköy": true,
      "Boğazköy": true,
      "Büyükpınar": true,
      "Çanacık": true,
      "Çay": true,
      "Çaypınar": true,
      "Davutlar": true,
      "Deliklitaş": true,
      "Dumlupınar": true,
      "Düzoba": true,
      "Ege": true,
      "Eski Kuyumcular": true,
      "Fethiye": true,
      "Hacı Ismail": true,
      "Halkapınar": true,
      "Hisaralan": true,
      "Hisariçi": true,
      "İbirler": true,
      "Kabakdere": true,
      "Kalaycılar": true,
      "Kamçıllı": true,
      "Karabeyler": true,
      "Karakol": true,
      "Karaoğlan": true,
      "Karesi": true,
      "Kavaklı": true,
      "Kayabey": true,
      "Kırmızılar": true,
      "Kızpınar": true,
      "Kocaavşar": true,
      "Köteyli": true,
      "Kurtdere": true,
      "Kuva-i Milliye": true,
      "Maltepe": true,
      "Mirzabey": true,
      "Naipli": true,
      "Ortaca": true,
      "Ovacık": true,
      "Paşa Alanı": true,
      "Şamlı": true,
      "Taşkesiği": true,
      "Tatlıpınar": true,
      "Toybelen": true,
      "Toygar": true,
      "Turplu": true,
      "Üçpınar": true,
      "Vicdaniye": true,
      "Yağcılar": true,
      "Yaylabayır": true,
      "Yaylacık": true,
      "Yeni": true,
      "Yeniiskender": true,
      "Yeniköy": true,
      "Yeroluk": true,
      "Yeşilova": true,
      "Yıldırım": true,
      "Ziyaretli": true
    },
    "Kepsut": {
      "Ahmetölen": true,
      "Akçakertil": true,
      "Akçaköy": true,
      "Alagüney": true,
      "Armutlu": true,
      "Bağtepe": true,
      "Bektaşlar": true,
      "Beyköy": true,
      "Bükdere": true,
      "Büyükkatrancı": true,
      "Camiiatik": true,
      "Camiicedit": true,
      "Çalkandil": true,
      "Dalköy": true,
      "Danahisar": true,
      "Darıçukuru": true,
      "Dedekaşı": true,
      "Dereli": true,
      "Dombaydere": true,
      "Durak": true,
      "Eşeler": true,
      "Eyüpbükü": true,
      "Göbel": true,
      "Gökköy": true,
      "Hotaşlar": true,
      "Işıklar": true,
      "İhsaniye": true,
      "İsaalan": true,
      "Kalburcu": true,
      "Karacaağaç": true,
      "Karacaören": true,
      "Karaçaltı": true,
      "Karagöz": true,
      "Karahaliller": true,
      "Kasapzade": true,
      "Kayacıklar": true,
      "Kayaeli": true,
      "Keçidere": true,
      "Kepekler": true,
      "Kızıloluk": true,
      "Küçükkatrancı": true,
      "Mahkeme": true,
      "Mahmudiye": true,
      "Mehmetler": true,
      "Mestanlar": true,
      "Mezitler": true,
      "Nusret": true,
      "Osmaniye": true,
      "Ovacık": true,
      "Örencik": true,
      "Örenharman": true,
      "Örenli": true,
      "Piyade": true,
      "Recep": true,
      "Saraç": true,
      "Sarıçayır": true,
      "Sarıfakılar": true,
      "Sayacık": true,
      "Seçdere": true,
      "Serçeören": true,
      "Servet": true,
      "Şeremetler": true,
      "Tekkeışıklar": true,
      "Tilkicik": true,
      "Tuzak": true,
      "Yaylabaşı": true,
      "Yenice": true,
      "Yeşildağ": true,
      "Yoğunoluk": true
    },
    "Manyas": {
      "Akçaova": true,
      "Atatürk": true,
      "Boğazpınar": true,
      "Bölceağaç": true,
      "Cumhuriyet": true,
      "Çakırca": true,
      "Çal": true,
      "Çamlı": true,
      "Çarşı": true,
      "Çataltepe": true,
      "Çavuşköy": true,
      "Darıca": true,
      "Değirmenboğazı": true,
      "Dereköy": true,
      "Doğancı": true,
      "Dura": true,
      "Erecek": true,
      "Eskiçatal": true,
      "Eskimanyas": true,
      "Eşen": true,
      "Hacıibrahimpınarı": true,
      "Hacıosman": true,
      "Hacıyakup": true,
      "Hamamlı": true,
      "Haydar": true,
      "Hekim": true,
      "Işıklar": true,
      "İrşadiye": true,
      "Kalebayır": true,
      "Kalfa": true,
      "Kapaklı": true,
      "Karakabaağaç": true,
      "Kayaca": true,
      "Kızık": true,
      "Kızıksa": true,
      "Kocagöl": true,
      "Koçoğlu": true,
      "Kubaş": true,
      "Kulak": true,
      "Maltepe": true,
      "Necip": true,
      "Ören": true,
      "Peynirkuyu": true,
      "Salur": true,
      "Süleymanlı": true,
      "Şevketiye": true,
      "Tepecik": true,
      "Yayla": true,
      "Yeni": true,
      "Yeniköy": true
    },
    "Marmara": {
      "Abroz": true,
      "Asmalı": true,
      "Avşa": true,
      "Cumhuriyet": true,
      "Çınarlı": true,
      "Deniz": true,
      "Ekinlik": true,
      "Gündoğdu": true,
      "Hürriyet": true,
      "Okullar": true,
      "Saraylar": true,
      "Topağaç": true,
      "Yeni": true,
      "Yiğitler": true
    },
    "Savaştepe": {
      "Akpınar": true,
      "Ardıçlı": true,
      "Aşağıdanişment": true,
      "Beyköy": true,
      "Bozalan": true,
      "Cumhuriyet": true,
      "Çaltılı": true,
      "Çamurlu": true,
      "Çavlı": true,
      "Çiftlikdere": true,
      "Çukurçayır": true,
      "Deveören": true,
      "Dikmeler": true,
      "Eğerci": true,
      "Esenköy": true,
      "Fatih": true,
      "Güvem": true,
      "Güvemküçüktarla": true,
      "Hıdırbalı": true,
      "Hürriyet": true,
      "İsadere": true,
      "İstiklal": true,
      "Kalemköy": true,
      "Karacalar": true,
      "Karaçam": true,
      "Karapınar": true,
      "Kocabıyıklar": true,
      "Kocaören": true,
      "Koğukyurt": true,
      "Kongurca": true,
      "Kurudere": true,
      "Madenmezarı": true,
      "Mecidiye": true,
      "Minnetler": true,
      "Pelitcik": true,
      "Sarıbeyler": true,
      "Sarısüleymanlar": true,
      "Sıtmapınar": true,
      "Soğucak": true,
      "Söğütçük": true,
      "Söğütlügözle": true,
      "Tavşancık": true,
      "Türediler": true,
      "Yazören": true,
      "Yeşilhisar": true,
      "Yolcupınarı": true,
      "Yukarıdanişment": true,
      "Yukarıkaraçam": true,
      "Yunakdere": true,
      "Zafer": true
    },
    "Sındırgı": {
      "Akçakısrak": true,
      "Aktaş": true,
      "Alacaatlı": true,
      "Alakır": true,
      "Alayaka": true,
      "Armutlu": true,
      "Aslandede": true,
      "Bayraklı": true,
      "Bulak": true,
      "Bükrecik": true,
      "Büyükdağdere": true,
      "Camicedit": true,
      "Camikebir": true,
      "Cüneyt": true,
      "Çakıllı": true,
      "Çaltılı": true,
      "Çamalanı": true,
      "Çavdaroğlu": true,
      "Çaygören": true,
      "Çayır": true,
      "Çelebiler": true,
      "Çıkrıkçı": true,
      "Çılbırcı": true,
      "Çoturtepe": true,
      "Danaçayır": true,
      "Dedeler": true,
      "Derecikören": true,
      "Devletlibaba": true,
      "Düğüncüler": true,
      "Düvertepe": true,
      "Eğridere": true,
      "Emendere": true,
      "Eşmedere": true,
      "Gölcük": true,
      "Gözören": true,
      "Hisaralan": true,
      "Işıklar": true,
      "İbiller": true,
      "İzzettin": true,
      "Karaağaç": true,
      "Karacalar": true,
      "Karagür": true,
      "Karakaya": true,
      "Kepez": true,
      "Kertil": true,
      "Kınık": true,
      "Kıranköy": true,
      "Kızılgür": true,
      "Kocabey": true,
      "Kocakonak": true,
      "Kocasinan": true,
      "Kozlu": true,
      "Kurtuluş": true,
      "Küçükbükü": true,
      "Küçükdağdere": true,
      "Kürendere": true,
      "Mandıra": true,
      "Mumcuköy": true,
      "Ormaniçi": true,
      "Osmanlar": true,
      "Pelitören": true,
      "Pürsünler": true,
      "Rızaiye": true,
      "Sinandede": true,
      "Süller": true,
      "Şahinkaya": true,
      "Şapçı": true,
      "Taşköy": true,
      "Umurlar": true,
      "Yağcıbedir": true,
      "Yaylabayır": true,
      "Yaylacık": true,
      "Yolcupınar": true,
      "Yusufçamı": true,
      "Yüreğil": true
    },
    "Susurluk": {
      "Alibey": true,
      "Asmalıdere": true,
      "Aziziye": true,
      "Babaköy": true,
      "Balıklıdere": true,
      "Beyköy": true,
      "Bozen": true,
      "Burhaniye": true,
      "Buzağılık": true,
      "Danaveli": true,
      "Demirkapı": true,
      "Dereköy": true,
      "Duman": true,
      "Ekinlik": true,
      "Eminpınarı": true,
      "Göbel": true,
      "Gökçeağaç": true,
      "Gökçedere": true,
      "Günaydın": true,
      "Gürece": true,
      "Han": true,
      "Ilıcaboğazı": true,
      "İclaliye": true,
      "Kalfaköy": true,
      "Karaköy": true,
      "Karapürçek": true,
      "Karşıyaka": true,
      "Kayalıdere": true,
      "Kayıkçı": true,
      "Kepekler": true,
      "Kışla": true,
      "Kiraz": true,
      "Kocapınar": true,
      "Kulat": true,
      "Kurucaoluk": true,
      "Muradiye": true,
      "Odalıdam": true,
      "Okçugöl": true,
      "Orta": true,
      "Ömerköy": true,
      "Paşaköy": true,
      "Reşadiye": true,
      "Söğütçayır": true,
      "Söve": true,
      "Sultançayır": true,
      "Sultaniye": true,
      "Sülecek": true,
      "Şeker": true,
      "Ümiteli": true,
      "Yağcı": true,
      "Yahyaköy": true,
      "Yaylaçayır": true,
      "Yeni": true,
      "Yıldız": true
    }
  },
  "Bartın": {
    "Amasra": {
      "Boztepe": true,
      "Fatih": true,
      "Kaleiçi": true,
      "Kaleşah": true,
      "Kum": true
    },
    "Kurucaşile": {
      "Kargacak": true,
      "Liman": true,
      "Ömerler": true,
      "Şile": true
    },
    "Merkez": {
      "Ağdacı": true,
      "Aladağ": true,
      "Cumhuriyet": true,
      "Çaydüzü": true,
      "Değirmenci": true,
      "Demirci Ahmetler": true,
      "Demirciler": true,
      "Esentepe": true,
      "Gecen": true,
      "Gerişli": true,
      "Gölbucağı": true,
      "Gürgenpınarı": true,
      "Hürriyet": true,
      "Karaçay": true,
      "Karaköy": true,
      "Kavlaklık": true,
      "Kemer Köprü": true,
      "Kırtepe": true,
      "Köyortası": true,
      "Merkez": true,
      "Okulak": true,
      "Orduyeri": true,
      "Orta": true,
      "Şabankadı": true,
      "Şiremirçavuş": true,
      "Tuna": true,
      "Tüloğlu": true,
      "Uzunöz": true,
      "Yenişar": true,
      "Yıldız": true
    },
    "Ulus": {
      "Derecik": true,
      "Kadıoğlu": true,
      "Kaldırım": true,
      "Karadiken": true,
      "Kasımlar": true,
      "Kavaklıkaldırım": true,
      "Merkez": true,
      "Mezgeller": true,
      "Samat": true,
      "Saz": true,
      "Ulupınar": true,
      "Yeni": true,
      "Yeşilpazar": true
    }
  },
  "Batman": {
    "Beşiri": {
      "Bağdu": true,
      "Behrem Yoğun": true,
      "Cumhuriyet": true,
      "Karaduman": true,
      "Kıyanç": true,
      "Kobin": true,
      "Mehmet Yatkın": true,
      "Milli Egemenlik": true,
      "Turgut Özal": true
    },
    "Gercüş": {
      "Bağlarbaşı": true,
      "Çukurçeşme": true,
      "Pınarbaşı": true,
      "Yeşilyurt": true,
      "Yolağzı": true
    },
    "Hasankeyf": {
      "Dicle": true,
      "Eyyubi": true,
      "Kültür": true,
      "Raman": true
    },
    "Kozluk": {
      "75. Yıl": true,
      "Adnan Menderes": true,
      "Ağaçlık": true,
      "Aşağıgüneşli": true,
      "Bahçeli": true,
      "Beşevler": true,
      "Çaybaşı": true,
      "Değirmendere": true,
      "Gülpınar": true,
      "Hamam": true,
      "İslambey": true,
      "Kale": true,
      "Karpuzlu": true,
      "Karşıyaka": true,
      "Kavaklı": true,
      "Kemalpaşa": true,
      "Komando": true,
      "Köprübaşı": true,
      "Ortaçay": true,
      "Pınarbaşı": true,
      "Sağlık": true,
      "Selahaddini Eyyübi": true,
      "Şemdinağa": true,
      "Tepecik": true,
      "Tepeüstü": true,
      "Turgut Özal": true,
      "Yamaçlı": true,
      "Yapraklı": true,
      "Yeni": true,
      "Yeşiltepe": true,
      "Yolaltı": true,
      "Yolüstü": true,
      "Yukarı Güneşli": true
    },
    "Merkez": {
      "19 Mayıs": true,
      "Akyürek": true,
      "Aydınlıkevler": true,
      "Bağlar": true,
      "Bahçelievler": true,
      "Bayındır": true,
      "Belde": true,
      "Beşevler": true,
      "Cudi": true,
      "Cumhuriyet": true,
      "Çamlıca": true,
      "Çamlıtepe": true,
      "Çarşı": true,
      "Çay": true,
      "Fatih": true,
      "Gap": true,
      "Girbereşik": true,
      "Gültepe": true,
      "Güneykent": true,
      "Hilal": true,
      "Huzur": true,
      "Hürriyet": true,
      "İluh": true,
      "İrmi": true,
      "Kardelen": true,
      "Karşıyaka": true,
      "Kısmet": true,
      "Korik": true,
      "Kültür": true,
      "Meydan": true,
      "Pazaryeri": true,
      "Petrol": true,
      "Petrolkent": true,
      "Pınarbaşı": true,
      "Raman": true,
      "Sağlık": true,
      "Segirkan": true,
      "Seyitler": true,
      "Seyrantepe": true,
      "Site": true,
      "Şafak": true,
      "Şirinevler": true,
      "Tilmerc": true,
      "Yeni": true,
      "Yeniköy": true,
      "Yenimahalle": true,
      "Yenişehir": true,
      "Yeşiltepe": true,
      "Ziyagökalp": true
    },
    "Sason": {
      "Aşağı": true,
      "Aydınlık": true,
      "Aykut Ozan": true,
      "Barış": true,
      "Beşevler": true,
      "Binekli": true,
      "Demetevler": true,
      "Dumlupınar": true,
      "Emek": true,
      "Erdemli": true,
      "Günlüce": true,
      "Gürpınar": true,
      "Haydar": true,
      "Karşıyaka": true,
      "Kayabaşı": true,
      "Koçkaya": true,
      "Kurtuluş": true,
      "Mehmet Akif": true,
      "Orta": true,
      "Pınarbaşı": true,
      "Sevek": true,
      "Şirinevler": true,
      "Tekevler": true,
      "Tekinler": true,
      "Tepe": true,
      "Yaylatepe": true,
      "Yeni": true,
      "Yeşilevler": true,
      "Yeşiller": true,
      "Yeşilova": true,
      "Yeşiltepe": true,
      "Yıldız": true,
      "Yukarı": true,
      "Zafer": true
    }
  },
  "Bayburt": {
    "Aydıntepe": {
      "Ahmet Yesevi": true,
      "Hacı Ali Efendi": true,
      "Kale": true,
      "Yakudiye": true
    },
    "Demirözü": {
      "Çiftetaş": true,
      "Esentepe": true,
      "Güneşli": true,
      "Karşıyaka": true,
      "Pınarbaşı": true,
      "Şirin": true,
      "Yeşilyurt": true
    },
    "Merkez": {
      "Camiikebir": true,
      "Cumhuriyet": true,
      "Çiçekli": true,
      "Esentepe": true,
      "Gençosman": true,
      "Halfikale (kaleardı)": true,
      "Hürriyet": true,
      "Kadızade": true,
      "Karasakal": true,
      "Mehmet Çelebi": true,
      "Şeyhhayran": true,
      "Şingah": true,
      "Tuzcuzade": true,
      "Uzungazi": true,
      "Velişaban": true,
      "Veysel": true,
      "Zahit": true
    }
  },
  "Bilecik": {
    "Bozüyük": {
      "4 Eylül": true,
      "Akpınar": true,
      "Çarşı": true,
      "İçköy": true,
      "Kasımpaşa": true,
      "Mehmet Akif": true,
      "Mithatpaşa": true,
      "Namık Kemal": true,
      "Tekke": true,
      "Yediler": true,
      "Yeni": true,
      "Yenidoğan": true,
      "Yeşilkent": true,
      "Ziya Gökalp": true
    },
    "Gölpazarı": {
      "Bahçelievler": true,
      "İsmetpaşa": true,
      "İstiklal": true,
      "Orta": true,
      "Reşadiye": true
    },
    "İnhisar": {
      "Akkum": true,
      "Güner Orbay": true,
      "Karaağaç": true,
      "Zafer": true
    },
    "Merkez": {
      "Bahçelievler": true,
      "Beşiktaş": true,
      "Cumhuriyet": true,
      "Ertuğrulgazi": true,
      "Fatih": true,
      "Gazi": true,
      "Gazipaşa": true,
      "Hürriyet": true,
      "İsmetpaşa": true,
      "İstasyon": true,
      "İstiklal": true,
      "Kayı Boyu": true,
      "Köprülü Mehmet Paşa": true,
      "Mahan": true,
      "Orhangazi": true,
      "Osmangazi": true,
      "Pelitözü": true,
      "Sarmaşık": true,
      "Yeni": true
    },
    "Osmaneli": {
      "Camicedit": true,
      "Camikebir": true,
      "Haceloğlu": true,
      "İnönü": true
    },
    "Pazaryeri": {
      "Beşikli": true,
      "Çarşı": true,
      "Dereboğaz": true,
      "Doğanlar": true,
      "Yeni": true,
      "Yüzbaşı": true
    },
    "Söğüt": {
      "Balaban": true,
      "Cumhuriyet": true,
      "Kayhan": true,
      "Orta": true,
      "Türkmenbaşı": true
    },
    "Yenipazar": {
      "Çöte": true,
      "Osmangazi": true,
      "Yeni": true,
      "Zafer": true
    }
  },
  "Bingöl": {
    "Adaklı": {
      "Afet Konutları": true,
      "Arıca": true,
      "Demiroluk": true,
      "Döşlüce": true,
      "Güngörsün": true,
      "Merkez": true,
      "Yeşiltepe": true
    },
    "Genç": {
      "Cumhuriyet": true,
      "Kültür": true,
      "Yenişehir": true,
      "Yeşildere": true,
      "Yoldaşan": true
    },
    "Karlıova": {
      "Kale": true,
      "Kanıreş": true,
      "Kanitaht": true,
      "Seyran Tepe": true,
      "Turgut Özal": true,
      "Yeşilyurt": true
    },
    "Kiğı": {
      "Eskişehir": true,
      "Yenişehir": true,
      "Yeşilyurt": true
    },
    "Merkez": {
      "Akbudak": true,
      "Bahçelievler": true,
      "Büyükbaşköy": true,
      "Çay": true,
      "Çimenli": true,
      "Hoşkar": true,
      "Ilıca": true,
      "İçmeler": true,
      "İçpınar": true,
      "İnalı": true,
      "İnönü": true,
      "Kamışlı": true,
      "Karapınar": true,
      "Karşıyaka": true,
      "Kılıçlı": true,
      "Küçükbaşköy": true,
      "Kültür": true,
      "Mirzan": true,
      "Recep Tayyip Erdoğan": true,
      "Saray": true,
      "Sarıgümüş": true,
      "Selahaddin-i Eyyubi": true,
      "Simani": true,
      "Şehit Mustafa Gündoğdu": true,
      "Uzundere": true,
      "Yeni": true,
      "Yenişehir": true,
      "Yeşilova": true,
      "Yeşilyurt": true
    },
    "Solhan": {
      "Boğlan": true,
      "Halime Pınar": true,
      "Karşıyaka": true,
      "Kültür": true,
      "Merkez": true,
      "Yeni": true,
      "Yeşilova": true
    },
    "Yayladere": {
      "Akçadamlar": true,
      "Conag": true,
      "Haktanır": true,
      "Hasköy": true,
      "Merkez": true,
      "Yolgüden": true
    },
    "Yedisu": {
      "Döşengi": true,
      "Kabaoluk": true,
      "Koşan": true,
      "Merkez": true,
      "Yeni": true
    }
  },
  "Bitlis": {
    "Adilcevaz": {
      "Alacaatlı": true,
      "Atatürk": true,
      "Budaklı": true,
      "Cevizli": true,
      "Çayır": true,
      "Esentepe": true,
      "Gültepe": true,
      "Hıdırşah": true,
      "İsmet Paşa": true,
      "Kaleboynu": true,
      "Kışkılı": true,
      "Menderes": true,
      "Orta": true,
      "Selçuklu": true
    },
    "Ahlat": {
      "Erkizan": true,
      "Haraba Şehir": true,
      "İki Kubbe": true,
      "Kacer": true,
      "Kale": true,
      "Kırklar": true,
      "Kulaksız": true,
      "Kurtuluş": true,
      "Kültür": true,
      "Orta": true,
      "Saray": true,
      "Selçuklu": true,
      "Tahtı Süleyman": true,
      "Tunus": true,
      "Yıldızlar": true
    },
    "Güroymak": {
      "Bağlar": true,
      "Barajyolu": true,
      "Barış": true,
      "Bölmedere": true,
      "Cami": true,
      "Cumhuriyet": true,
      "Değirmen": true,
      "Erentepe": true,
      "Girne": true,
      "Gültepe": true,
      "Haydar": true,
      "Hürriyet": true,
      "Köşk": true,
      "Kümbet": true,
      "Nurtepe": true,
      "Pınarbaşı": true,
      "Refahiye": true,
      "Şenevler": true,
      "Şenkaya": true,
      "Şenova": true,
      "Şentepe": true,
      "Şenyayla": true,
      "Şenyurt": true,
      "Şirintepe": true,
      "Uğurlu": true,
      "Yamaç": true,
      "Yeni": true,
      "Yeşilli": true,
      "Yeşilova": true,
      "Yeşiltepe": true,
      "Yeşilyurt": true
    },
    "Hizan": {
      "Altınoluk": true,
      "Aşağıkarasu": true,
      "Bahçelievler": true,
      "Esentepe": true,
      "Gökçimen": true,
      "Kültür": true,
      "Taşlı Pınar": true,
      "Yemişli": true,
      "Yeni Kent": true,
      "Yeşil Ova": true
    },
    "Merkez": {
      "Atatürk": true,
      "Beş Minare": true,
      "Boztepe": true,
      "Çınarbaşı": true,
      "Düz": true,
      "Gazi Bey": true,
      "Hersan": true,
      "Hüsrev Paşa": true,
      "İnönü": true,
      "Kale": true,
      "Konaç": true,
      "Muştakbaba": true,
      "Pınarbaşı": true,
      "Saray": true,
      "Sekiz Ağustos": true,
      "Şemsi Bitlis": true,
      "Taş": true,
      "Üç Kardeş": true,
      "Yeni": true,
      "Yolalan": true,
      "Yükseliş": true,
      "Zeydan": true
    },
    "Mutki": {
      "Arpalıseki": true,
      "Cami": true,
      "Çimen": true,
      "Gölbaşı": true,
      "Orta": true,
      "Pınarbaşı": true,
      "Taşlı Pınar": true,
      "Yeni": true,
      "Yenibağ": true,
      "Yüksekova": true
    },
    "Tatvan": {
      "Aydınlar": true,
      "Bahçelievler": true,
      "Cumhuriyet": true,
      "Çağlayan": true,
      "Dumlupınar": true,
      "Esentepe": true,
      "Fatih": true,
      "Fuar": true,
      "Hidayet": true,
      "İşletme": true,
      "Kale": true,
      "Karataş": true,
      "Karşıyaka": true,
      "Kültür": true,
      "Pınarbaşı": true,
      "Sahil": true,
      "Saray": true,
      "Sosyal": true,
      "Şirinevler": true,
      "Tuğ": true,
      "Yeni": true,
      "Yeşilmezra": true
    }
  },
  "Bolu": {
    "Dörtdivan": {
      "Adakınık": true,
      "Bayramlar": true,
      "Çavuşlar": true,
      "Çitler": true,
      "Deveciler": true,
      "Hacetler": true,
      "Kadılar": true,
      "Kargıbayramlar": true
    },
    "Gerede": {
      "Bahçelievler": true,
      "Dayıoğlu": true,
      "Demirciler": true,
      "Kabiller": true,
      "Kitirler": true,
      "Orta": true,
      "Seviller": true,
      "Yeni": true
    },
    "Göynük": {
      "Cuma": true,
      "Çeşme": true,
      "Hacı Abdi": true,
      "Kepkebir": true,
      "Sofu Ali": true,
      "Yenice": true
    },
    "Kıbrıscık": {
      "Karadoğan": true,
      "Köroğlu": true
    },
    "Mengen": {
      "Adasal": true,
      "Atatürk": true,
      "Beşler": true,
      "Çakırlar": true,
      "Hürriyet": true,
      "Karapınar": true,
      "Tabaklar Yazıyaka": true,
      "Türkbeyli": true
    },
    "Merkez": {
      "Akpınar": true,
      "Aktaş": true,
      "Alpağut": true,
      "Alpağutbey": true,
      "Aşağısoku": true,
      "Bahçelievler": true,
      "Beşkavaklar": true,
      "Borazanlar": true,
      "Büyükcami": true,
      "Çakmaklar": true,
      "Çıkınlar": true,
      "Çivril": true,
      "Dağkent": true,
      "Dodurga": true,
      "Gölyüzü": true,
      "Ilıcakınık": true,
      "İhsaniye": true,
      "İzzet Baysal": true,
      "Karacaağaç": true,
      "Karacasu Fatih": true,
      "Karaçayır": true,
      "Karaköy": true,
      "Karamanlı": true,
      "Kasaplar": true,
      "Kılıçarslan": true,
      "Köroğlu": true,
      "Kuruçay": true,
      "Küçükberk": true,
      "Kültür": true,
      "Kürkçüler": true,
      "Ovadüzü": true,
      "Paşaköy": true,
      "Sağlık": true,
      "Salıbeyler": true,
      "Sandallar": true,
      "Sarıcalar": true,
      "Semerkant": true,
      "Seyit": true,
      "Sümer": true,
      "Tabaklar": true,
      "Tepecik": true,
      "Umutkent": true,
      "Yaşamkent": true,
      "Yenimahalle": true,
      "Yukarısoku": true
    },
    "Mudurnu": {
      "Büyükcami": true,
      "Hızırfakı": true,
      "Karacakaya": true,
      "Karacasumandıra": true,
      "Karaçomak": true,
      "Kaygana": true,
      "Merkez": true,
      "Musalla": true,
      "Seyrancık": true,
      "Tosunlar": true,
      "Yeğenderesi": true,
      "Yıldırım Bayazıd": true
    },
    "Seben": {
      "Çarşı": true,
      "Keskinli": true
    },
    "Yeniçağa": {
      "Asil Bey": true,
      "Camiatik": true,
      "Gölyüzü": true
    }
  },
  "Burdur": {
    "Ağlasun": {
      "Bala": true,
      "Çınar": true,
      "Hamam": true,
      "Kıraç": true,
      "Kum": true,
      "Sakarca": true
    },
    "Altınyayla": {
      "Gülpınar": true,
      "Heybeli": true,
      "Taşyaka": true,
      "Yeni": true
    },
    "Bucak": {
      "Alaattin": true,
      "Atilla": true,
      "Avdan": true,
      "Barboros": true,
      "Camii": true,
      "Çamlıca": true,
      "Çavuşlar": true,
      "Çukur": true,
      "Fatih": true,
      "Gökalan": true,
      "Karayvatlar": true,
      "Karşıyaka": true,
      "Konak": true,
      "Mehmet Akif": true,
      "Mimar Sinan": true,
      "Oğuzhan": true,
      "Onaç": true,
      "Pazar": true,
      "Sanayi": true,
      "Yeni": true,
      "Yetmiş Evler": true,
      "Yörükler": true,
      "Yunus Emre": true,
      "Yuva": true
    },
    "Çavdır": {
      "Atatürk": true,
      "Bayır": true,
      "Çeşme": true,
      "Çınar": true,
      "Fatih": true,
      "Kocapınar": true,
      "Menevşelik": true,
      "Pazar": true,
      "Yeni": true,
      "Yeşil": true
    },
    "Çeltikçi": {
      "Camii": true,
      "Konak": true
    },
    "Gölhisar": {
      "Armutlu": true,
      "Aşağı": true,
      "Çakmak": true,
      "Çeşme": true,
      "Fatih": true,
      "Horzum": true,
      "Konak": true,
      "Merkez Camii": true,
      "Pazar": true,
      "Ulucamii": true,
      "Yeni": true,
      "Yukarı": true
    },
    "Karamanlı": {
      "Barbaros": true,
      "Cafer": true,
      "Camii": true,
      "Çamlık": true,
      "Eşeler": true,
      "Fatih": true,
      "Hürriyet": true,
      "İstiklal": true,
      "Karaman": true,
      "Pazar": true,
      "Yeni": true,
      "Zafer": true
    },
    "Kemer": {
      "Konak": true,
      "Saray": true,
      "Yeni Camii": true
    },
    "Merkez": {
      "Akın": true,
      "Armağan Ilci": true,
      "Atatürk": true,
      "Aydınlıkevler": true,
      "Bağlar": true,
      "Bahçelievler": true,
      "Bozkurt": true,
      "Burç": true,
      "Cemil": true,
      "Çeşmedamı": true,
      "Değirmenler": true,
      "Dere": true,
      "Emek": true,
      "Fevzi Çakmak": true,
      "Hızır Ilyas": true,
      "İnönü": true,
      "Karasenir": true,
      "Kışla": true,
      "Konak": true,
      "Kuyu": true,
      "Mehmet Akif Ersoy": true,
      "Menderes": true,
      "Necati Bey": true,
      "Özgür": true,
      "Pazar": true,
      "Recep": true,
      "Sakarya": true,
      "Sinan": true,
      "Şeker Evleri": true,
      "Şirinevler": true,
      "Tepe": true,
      "Üçdibek": true,
      "Yeni": true,
      "Yenice": true,
      "Zafer": true
    },
    "Tefenni": {
      "Ece": true,
      "Esentepe": true,
      "Eşeler": true,
      "Fatih": true,
      "Göktürk": true,
      "Kır": true,
      "Pazar": true,
      "Yenice": true,
      "Yokuş": true,
      "Zafer": true
    },
    "Yeşilova": {
      "Bahcelievler": true,
      "Değirmen": true,
      "Emek": true,
      "Kayadibi": true,
      "Koyunlar Çeşme": true,
      "Merkez": true
    }
  },
  "Bursa": {
    "Büyükorhan": {
      "Akçasaz": true,
      "Aktaş": true,
      "Armutçuk": true,
      "Bademlik": true,
      "Balaban": true,
      "Bayındır": true,
      "Burunca": true,
      "Cumhuriyet": true,
      "Çakıryenice": true,
      "Çeribaşı": true,
      "Danacılar": true,
      "Danaçalı": true,
      "Demirler": true,
      "Derecik": true,
      "Durhasan": true,
      "Düğüncüler": true,
      "Elekçalı": true,
      "Ericek": true,
      "Gedikler": true,
      "Geynik": true,
      "Hacıahmetler": true,
      "Hacılar": true,
      "Hemşeriler": true,
      "Hocahasan": true,
      "İsmetiye": true,
      "Karaağız": true,
      "Karaçukur": true,
      "Karalar": true,
      "Kayapa": true,
      "Kınık": true,
      "Kuşlar": true,
      "Mazlumlar": true,
      "Orhan": true,
      "Osmanlar": true,
      "Örencik": true,
      "Özlüce": true,
      "Perçin": true,
      "Pınarköy": true,
      "Pirebeyler": true,
      "Sarnıç": true,
      "Tekerler": true,
      "Yenice": true,
      "Zaferiye": true
    },
    "Gemlik": {
      "Adliye": true,
      "Ata": true,
      "Balıkpazarı": true,
      "Büyükkumla": true,
      "Cihatlı": true,
      "Cumhuriyet": true,
      "Demirsubaşı": true,
      "Dr.ziya Kaya": true,
      "Engürücük": true,
      "Eşref Dinçer": true,
      "Feyziye": true,
      "Fındıcak": true,
      "Gençali": true,
      "Güvenli": true,
      "Halitpaşa": true,
      "Hamidiye": true,
      "Hamidiyeköy": true,
      "Haydariye": true,
      "Hisar": true,
      "Karacaali": true,
      "Katırlı": true,
      "Kayhan": true,
      "Kumla": true,
      "Kurşunlu": true,
      "Kurtul": true,
      "Küçükkumla": true,
      "Muratoba": true,
      "Narlı": true,
      "Orhaniye": true,
      "Osmaniye": true,
      "Şahinyurdu": true,
      "Şükriye": true,
      "Umurbey": true,
      "Yeni": true,
      "Yeniköy": true
    },
    "Gürsu": {
      "Adaköy": true,
      "Ağaköy": true,
      "Canbazlarköyü": true,
      "Dışkayaköyü": true,
      "Ericekköyü": true,
      "Hasanköy": true,
      "İğdirköyü": true,
      "İpekyolu": true,
      "İstiklal": true,
      "Karahıdırköyü": true,
      "Kazıklıköyü": true,
      "Kumlukalan": true,
      "Kurtuluş": true,
      "Yenidoğan": true,
      "Zafer": true
    },
    "Harmancık": {
      "Akpınar": true,
      "Alutca": true,
      "Balatdanişment": true,
      "Ballısaray": true,
      "Bekdemirler": true,
      "Çakmak": true,
      "Çamoğlu": true,
      "Çatalsöğüt": true,
      "Dedebali": true,
      "Delicegüney": true,
      "Dutluca": true,
      "Ece": true,
      "Gedikören": true,
      "Gökçeler": true,
      "Gülözü": true,
      "Harmancık Akalan": true,
      "Hopandanişment": true,
      "Ilıcaksu": true,
      "İshaklar": true,
      "Karaca": true,
      "Kepekdere": true,
      "Kılavuzlar": true,
      "Kışmanlar": true,
      "Kocapınar": true,
      "Kozluca": true,
      "Merkez": true,
      "Nalbant": true,
      "Okçular": true,
      "Saçaklı": true,
      "Yayabaşı": true,
      "Yeşilyurt": true
    },
    "İnegöl": {
      "Akbaşlar": true,
      "Akhisar": true,
      "Akıncılar": true,
      "Alibey": true,
      "Aşağıballık": true,
      "Babaoğlu": true,
      "Bahariye": true,
      "Bahçekaya": true,
      "Baykoca": true,
      "Bayramşah": true,
      "Bilalköy": true,
      "Boğazköy": true,
      "Burhaniye": true,
      "Cemiyet": true,
      "Cerrah": true,
      "Cuma": true,
      "Cumhuriyet": true,
      "Çavuşköy": true,
      "Çaylıca": true,
      "Çayyaka": true,
      "Çeltikçi": true,
      "Çiftlikköy": true,
      "Çitli": true,
      "Deydinler": true,
      "Dipsizgöl": true,
      "Doğanyurdu": true,
      "Dömez": true,
      "Edebey": true,
      "Elmaçayır": true,
      "Ertuğrulgazi": true,
      "Esenköy": true,
      "Esentepe": true,
      "Eski Bahçekaya": true,
      "Eskikaracakaya": true,
      "Eskiköy": true,
      "Eymir": true,
      "Fatih": true,
      "Fevziye": true,
      "Fındıklı": true,
      "Gazelli": true,
      "Gedikpınar": true,
      "Gülbahçe": true,
      "Gündüzlü": true,
      "Güneykestane": true,
      "Güzelyurt": true,
      "Hacıkara": true,
      "Halhalca": true,
      "Hamamlı": true,
      "Hamidiye": true,
      "Hamitabat": true,
      "Hamzabey": true,
      "Hasanpaşa": true,
      "Hayriye": true,
      "Hilmiye": true,
      "Hocaköy": true,
      "Huzur": true,
      "İclaliye": true,
      "İhsaniye": true,
      "İsaören": true,
      "Karagölet": true,
      "Karahasanlar": true,
      "Karakadı": true,
      "Karalar": true,
      "Kayapınar": true,
      "Kemalpaşa": true,
      "Kestanealanı": true,
      "Kınık": true,
      "Kıran": true,
      "Kocakonak": true,
      "Konurlar": true,
      "Kozluca": true,
      "Kulaca": true,
      "Kurşunlu": true,
      "Küçükyenice": true,
      "Lütfiye": true,
      "Madenköy": true,
      "Mahmudiye": true,
      "Mesudiye": true,
      "Mezit": true,
      "Muratbey": true,
      "Olukman": true,
      "Orhaniye": true,
      "Ortaköy": true,
      "Osmaniye": true,
      "Osmaniyeköy": true,
      "Özlüce": true,
      "Paşaören": true,
      "Rüştiye": true,
      "Saadet": true,
      "Sarıpınar": true,
      "Sinanbey": true,
      "Soğukdere": true,
      "Sulhiye": true,
      "Sultaniye": true,
      "Sungurpaşa": true,
      "Süle": true,
      "Süleymaniye": true,
      "Sülüklügöl": true,
      "Süpürtü": true,
      "Şehitler": true,
      "Şipali": true,
      "Tahtaköprü": true,
      "Tekkeköy": true,
      "Tokuş": true,
      "Turgutalp": true,
      "Turgutalpköy": true,
      "Tuzla": true,
      "Tüfekçikonak": true,
      "Yeni": true,
      "Yenice": true,
      "Yeniceköy": true,
      "Yeniköy": true,
      "Yeniyörük": true,
      "Yiğit": true,
      "Yukarıballık": true,
      "Yunusemre": true
    },
    "İznik": {
      "Aydınlar": true,
      "Bayındır": true,
      "Beyler": true,
      "Boyalıca": true,
      "Candarlı": true,
      "Çakırca": true,
      "Çamdibi": true,
      "Çamoluk": true,
      "Çampınar": true,
      "Çiçekli": true,
      "Derbent": true,
      "Dereköy": true,
      "Dırazali": true,
      "Elbeyli": true,
      "Elmalı": true,
      "Eşrefzade": true,
      "Göllüce": true,
      "Gürmüzlü": true,
      "Hacıosman": true,
      "Hisardere": true,
      "Hocaköy": true,
      "İhsaniye": true,
      "İnikli": true,
      "Karatekin": true,
      "Kaynarca": true,
      "Kırıntı": true,
      "Kutluca": true,
      "Mahmudiye": true,
      "Mahmut Çelebi": true,
      "Mecidiye": true,
      "Mustafa Kemal Paşa": true,
      "Mustafalı": true,
      "Müşküle": true,
      "Orhaniye": true,
      "Osmaniye": true,
      "Ömerli": true,
      "Sansarak": true,
      "Sarıağıl": true,
      "Selçuk": true,
      "Süleymaniye": true,
      "Şerefiye": true,
      "Tacir": true,
      "Yeni": true,
      "Yenişerefiye": true,
      "Yeşil Camii": true,
      "Yürükler": true
    },
    "Karacabey": {
      "Abdullahpaşa": true,
      "Akçakoyun": true,
      "Akçasusurluk": true,
      "Akhisar": true,
      "Arız": true,
      "Bakırköy": true,
      "Ballıkaya": true,
      "Bayramdere": true,
      "Beylik": true,
      "Boğazköy": true,
      "Canbalı": true,
      "Canbaz": true,
      "Çamlıca": true,
      "Çarıkköy": true,
      "Çavuş": true,
      "Çeşnigir": true,
      "Dağesemen": true,
      "Dağkadı": true,
      "Danişment": true,
      "Doğla": true,
      "Drama": true,
      "Ekinli": true,
      "Ekmekçi": true,
      "Emirsultan": true,
      "Esentepe": true,
      "Eskikaraağaç": true,
      "Eskisarıbey": true,
      "Fevzipaşa": true,
      "Garipçe": true,
      "Gazi": true,
      "Gölecik": true,
      "Gölkıyı": true,
      "Gönü": true,
      "Güngörmez": true,
      "Hamidiye": true,
      "Harmanlı": true,
      "Hayırlar": true,
      "Hotanlı": true,
      "Hüdavendigar": true,
      "Hürriyet": true,
      "İkizce": true,
      "İnkaya": true,
      "İsmetpaşa": true,
      "Karacaahmet": true,
      "Karakoca": true,
      "Karasu": true,
      "Kedikaya": true,
      "Keşlik": true,
      "Kıranlar": true,
      "Kulakpınar": true,
      "Kurşunlu": true,
      "Küçükkaraağaç": true,
      "Mamuriyet": true,
      "Mecidiye": true,
      "Muratlı": true,
      "Nasrettin": true,
      "Okçular": true,
      "Orhaniye": true,
      "Ortasarıbey": true,
      "Ova Hamidiye": true,
      "Ovaesemen": true,
      "Örencik": true,
      "Runguşpaşa": true,
      "Saadet": true,
      "Sazlıca": true,
      "Selimiye": true,
      "Seyran": true,
      "Sırabademler": true,
      "Subaşı": true,
      "Sultaniye": true,
      "Şahinköy": true,
      "Şahmelek": true,
      "Tabaklar": true,
      "Taşlık": true,
      "Taşpınar": true,
      "Tavşanlı": true,
      "Tophisar": true,
      "Uluabat": true,
      "Yarış": true,
      "Yeni": true,
      "Yenice": true,
      "Yenikaraağaç": true,
      "Yenisarıbey": true,
      "Yeşildere": true,
      "Yolağzı": true
    },
    "Keles": {
      "Akçapınar": true,
      "Alpağut": true,
      "Avdan": true,
      "Baraklı": true,
      "Basak": true,
      "Belenören": true,
      "Bıyıklıalanı": true,
      "Cuma": true,
      "Çukur": true,
      "Dağ Demirciler": true,
      "Dağdibi": true,
      "Davutlar": true,
      "Dedeler": true,
      "Delice": true,
      "Denizler": true,
      "Durak": true,
      "Düvenli": true,
      "Epçeler": true,
      "Ertuğrulgazi": true,
      "Gelemiç": true,
      "Gököz": true,
      "Harmanalanı": true,
      "Harmancık Demirci": true,
      "Haydar": true,
      "Hereke": true,
      "Issızören": true,
      "Karaardıç": true,
      "Kemaliye": true,
      "Kıran Işıklar": true,
      "Kirazlı": true,
      "Koca Kovacık": true,
      "Kozbudaklar": true,
      "Küçük Kovacık": true,
      "Menteşe": true,
      "Pınarcık": true,
      "Sofular": true,
      "Sorgun": true,
      "Uzunöz": true,
      "Yağcılar": true,
      "Yazıbaşı": true,
      "Yenice": true,
      "Yunuslar": true
    },
    "Kestel": {
      "Ağlaşan": true,
      "Ahmetvefikpaşa": true,
      "Aksu": true,
      "Alaçam": true,
      "Babasultan": true,
      "Barakfakih": true,
      "Burhaniye": true,
      "Çataltepe": true,
      "Derekızık": true,
      "Dudaklı": true,
      "Erdoğan": true,
      "Esentepe": true,
      "Gölbaşı": true,
      "Gölcük": true,
      "Gözede": true,
      "Kale": true,
      "Kayacık": true,
      "Kazancı": true,
      "Kozluören": true,
      "Lütfiye": true,
      "Narlıdere": true,
      "Nüzhetiye": true,
      "Orhaniye": true,
      "Osmaniye": true,
      "Saitabat": true,
      "Sayfiye": true,
      "Serme": true,
      "Seymen": true,
      "Soğuksu": true,
      "Şevketiye": true,
      "Turanköy": true,
      "Ümitalan": true,
      "Vanimehmet": true,
      "Yağmurlu": true,
      "Yeni": true
    },
    "Mudanya": {
      "Akköy": true,
      "Altıntaş": true,
      "Aydınpınar": true,
      "Bademli": true,
      "Balabancık": true,
      "Çağrışan": true,
      "Çamlık": true,
      "Çayönü": true,
      "Çekrice": true,
      "Çepni": true,
      "Çınarlı": true,
      "Dedeköy": true,
      "Dereköy": true,
      "Eğerce": true,
      "Emirleryenicesi": true,
      "Esence": true,
      "Evciler": true,
      "Göynüklü": true,
      "Güzelyalı Burgaz": true,
      "Güzelyalı Eğitim": true,
      "Güzelyalı Siteler": true,
      "Güzelyalı Yalı": true,
      "Halitpaşa": true,
      "Hançerli": true,
      "Hasanbey": true,
      "Hasköy": true,
      "Işıklı": true,
      "İpekyayla": true,
      "Kaymakoba": true,
      "Kumyaka": true,
      "Küçükyenice": true,
      "Mesudiye": true,
      "Mirzaoba": true,
      "Mürsel": true,
      "Mütareke": true,
      "Orhaniye": true,
      "Ömerbey": true,
      "Söğütpınar": true,
      "Şükrüçavuş": true,
      "Tirilye": true,
      "Ülkü": true,
      "Yalıçiftlik": true,
      "Yaman": true,
      "Yaylacık": true,
      "Yeni": true,
      "Yörükali": true,
      "Yörükyenicesi": true
    },
    "Mustafakemalpaşa": {
      "Adaköy": true,
      "Adalet": true,
      "Ağaçlı": true,
      "Akarca": true,
      "Akçapınar": true,
      "Alacaat": true,
      "Aliseydi": true,
      "Alpağut": true,
      "Aralık": true,
      "Aşağıbalı": true,
      "Atariye": true,
      "Atatürk": true,
      "Ayaz": true,
      "Bahariye": true,
      "Barış": true,
      "Behram": true,
      "Boğaz": true,
      "Bostandere": true,
      "Bük": true,
      "Camandar": true,
      "Cumhuriyet": true,
      "Çakallar": true,
      "Çaltılıbük": true,
      "Çamlıca": true,
      "Çardakbelen": true,
      "Çavuş": true,
      "Çeltikçi": true,
      "Çırpan": true,
      "Çiviliçam": true,
      "Çömlekçi": true,
      "Çördük": true,
      "Dallıca": true,
      "Demirdere": true,
      "Demireli": true,
      "Dere": true,
      "Derecik": true,
      "Derekadı": true,
      "Devecikonağı": true,
      "Doğanalan": true,
      "Doğancı": true,
      "Dorak": true,
      "Döllük": true,
      "Durumtay": true,
      "Eskibalçık": true,
      "Eskikızılelma": true,
      "Fevzidede": true,
      "Fındıcak": true,
      "Garipçetekke": true,
      "Güller": true,
      "Güllüce": true,
      "Gündoğdu": true,
      "Güveçdere": true,
      "Güvem": true,
      "Hacıahmet": true,
      "Hacıali": true,
      "Hamidiye": true,
      "Hamidiyeköyü": true,
      "Hamzabey": true,
      "Hisaraltı": true,
      "Işıklar": true,
      "İlyasçılar": true,
      "İncealipınar": true,
      "Kabulbaba": true,
      "Kadirçeşme": true,
      "Kapaklıoluk": true,
      "Karacalar": true,
      "Karaköy": true,
      "Karaoğlan": true,
      "Karaorman": true,
      "Karapınar": true,
      "Kayabaşı": true,
      "Kazanpınar": true,
      "Keltaş": true,
      "Kestelek": true,
      "Killik": true,
      "Kocakoru": true,
      "Kosova": true,
      "Koşuboğazı": true,
      "Kömürcükadı": true,
      "Körekem": true,
      "Kösehoroz": true,
      "Kumkadı": true,
      "Kurşunlu": true,
      "Lalaşahin": true,
      "Lütfiye": true,
      "Melik": true,
      "Muradiyesarnıç": true,
      "Ocaklı": true,
      "Onaç": true,
      "Orhaniye": true,
      "Ormankadı": true,
      "Orta": true,
      "Osmaniye": true,
      "Ovaazatlı": true,
      "Ömeraltı": true,
      "Paşalar": true,
      "Sarımustafalar": true,
      "Selimiye": true,
      "Sincansarnıç": true,
      "Soğucak": true,
      "Soğukpınar": true,
      "Söğütalan": true,
      "Sünlük": true,
      "Şapçı": true,
      "Şehriman": true,
      "Şerefiye": true,
      "Şevketiye": true,
      "Şeyhmüftü": true,
      "Taşköprü": true,
      "Taşpınar": true,
      "Tatkavaklı": true,
      "Tepecik": true,
      "Tırnova": true,
      "Uğurlupınar": true,
      "Üçbeyli": true,
      "Vıraca": true,
      "Yalıntaş": true,
      "Yamanlı": true,
      "Yavelli": true,
      "Yaylaçayır": true,
      "Yenibalçık": true,
      "Yenice": true,
      "Yenidere": true,
      "Yenikızılelma": true,
      "Yeşilova": true,
      "Yoncaağaç": true,
      "Yukarıbalı": true,
      "Yumurcaklı": true,
      "Yunus Emre": true,
      "Yüzbaşı Sabribey": true,
      "Züferbey": true
    },
    "Nilüfer": {
      "19 Mayıs": true,
      "23 Nisan": true,
      "29 Ekim": true,
      "30 Ağustos Zafer": true,
      "Ahmet Yesevi": true,
      "Akçalar": true,
      "Alaaddinbey": true,
      "Altınşehir": true,
      "Ataevler": true,
      "Atlas": true,
      "Ayvaköy": true,
      "Badırga": true,
      "Balat": true,
      "Balkan": true,
      "Barış": true,
      "Başköy": true,
      "Beşevler": true,
      "Büyükbalıklı": true,
      "Cumhuriyet": true,
      "Çalı": true,
      "Çamlıca": true,
      "Çatalağıl": true,
      "Çaylı": true,
      "Dağyenice": true,
      "Demirci": true,
      "Doğanköy": true,
      "Dumlupınar": true,
      "Ertuğrul": true,
      "Esentepe": true,
      "Fadıllı": true,
      "Fethiye": true,
      "Gökçe": true,
      "Gölyazı": true,
      "Görükle": true,
      "Gümüştepe": true,
      "Güngören": true,
      "Hasanağa": true,
      "Işıktepe": true,
      "İhsaniye": true,
      "İnegazi": true,
      "İrfaniye": true,
      "Kadriye": true,
      "Karacaoba": true,
      "Karaman": true,
      "Kayapa": true,
      "Kızılcıklı": true,
      "Konak": true,
      "Konaklı": true,
      "Korubaşı": true,
      "Kurtuluş": true,
      "Kuruçeşme": true,
      "Kültür": true,
      "Makşempınarı": true,
      "Minareliçavuş": true,
      "Odunluk": true,
      "Özlüce": true,
      "Tahtalı": true,
      "Unçukuru": true,
      "Üçevler": true,
      "Üçpınar": true,
      "Ürünlü": true,
      "Yaylacık": true,
      "Yolçatı": true,
      "Yüzüncüyıl": true
    },
    "Orhaneli": {
      "300 Evler": true,
      "Ağaçhisar": true,
      "Akalan": true,
      "Akçabük": true,
      "Altıntaş": true,
      "Argın": true,
      "Balıoğlu": true,
      "Başköy": true,
      "Belenoluk": true,
      "Celepler": true,
      "Çeki": true,
      "Çınarcık": true,
      "Çivili": true,
      "Çöreler": true,
      "Dağgüney": true,
      "Deliballılar": true,
      "Demirci": true,
      "Dere": true,
      "Dündar": true,
      "Emir": true,
      "Erenler": true,
      "Esentepe": true,
      "Eskidanişment": true,
      "Fadıl": true,
      "Fevzipaşa": true,
      "Firoz": true,
      "Gazioluk": true,
      "Gazipaşa": true,
      "Girencik": true,
      "Göktepe": true,
      "Göynükbelen": true,
      "Gümüşpınar": true,
      "İkizoluk": true,
      "İsmetpaşa": true,
      "Kabaklar": true,
      "Kadı": true,
      "Karabekirpaşa": true,
      "Karaoğlanlar": true,
      "Karasi": true,
      "Karıncalı": true,
      "Koçu": true,
      "Kusumlar": true,
      "Küçükorhan": true,
      "Letafet": true,
      "Mahaller": true,
      "Nalınlar": true,
      "Orta": true,
      "Osmaniyeçatak": true,
      "Sadağı": true,
      "Semerci": true,
      "Serçeler": true,
      "Sırıl": true,
      "Söğüt": true,
      "Süleymanbey": true,
      "Şükriye": true,
      "Tepecik": true,
      "Topuk": true,
      "Yakuplar": true,
      "Yenidanişment": true,
      "Yeşiller": true,
      "Yörükler": true
    },
    "Orhangazi": {
      "Akharem": true,
      "Arapzade": true,
      "Bayırköy": true,
      "Camiikebir": true,
      "Cihanköy": true,
      "Çakırlı": true,
      "Çeltikçi": true,
      "Dutluca": true,
      "Fatih": true,
      "Fındıklı": true,
      "Gedelek": true,
      "Gemiç": true,
      "Gölyaka": true,
      "Gürle": true,
      "Hamzalı": true,
      "Heceler": true,
      "Hürriyet": true,
      "Karsak": true,
      "Keramet": true,
      "Mahmudiye": true,
      "Muradiye": true,
      "Narlıca": true,
      "Ortaköy": true,
      "Örnekköy": true,
      "Paşapınar": true,
      "Sölöz": true,
      "Tekke": true,
      "Üreğil": true,
      "Yenigürle": true,
      "Yeniköy": true,
      "Yenisölöz": true
    },
    "Osmangazi": {
      "Adalet": true,
      "Ahmetbey": true,
      "Ahmetpaşa": true,
      "Akpınar": true,
      "Aksungur": true,
      "Aktarhüssam": true,
      "Alaaddin": true,
      "Alacahırka": true,
      "Alacamescit": true,
      "Alaşarköy": true,
      "Alemdar": true,
      "Alipaşa": true,
      "Altınova": true,
      "Altıparmak": true,
      "Armutköy": true,
      "Atıcılar": true,
      "Avdancık": true,
      "Bağlarbaşı": true,
      "Bağlı": true,
      "Bahar": true,
      "Başaran": true,
      "Büyükdeliller": true,
      "Çağlayan": true,
      "Çaybaşı": true,
      "Çekirge": true,
      "Çeltikköy": true,
      "Çırpan": true,
      "Çiftehavuzlar": true,
      "Çirişhane": true,
      "Çukurcaköy": true,
      "Dağakça": true,
      "Demirkapı": true,
      "Demirtaş Barbaros": true,
      "Demirtaş Cumhuriyet": true,
      "Demirtaş Dumlupınar": true,
      "Demirtaş Sakarya": true,
      "Demirtaşpaşa": true,
      "Dereçavuşköy": true,
      "Dikkaldırım": true,
      "Doburca": true,
      "Doğanbey": true,
      "Doğancı": true,
      "Doğanevler": true,
      "Dürdane": true,
      "Ebu Ishak": true,
      "Elmaçukur": true,
      "Elmasbahçeler": true,
      "Emek Adnan Menderes": true,
      "Emek Fatih Sultan Mehmet": true,
      "Emek Zekai Gümüşdiş": true,
      "Fatih": true,
      "Gaziakdemir": true,
      "Geçit": true,
      "Gökçeören": true,
      "Gülbahçe": true,
      "Gündoğdu": true,
      "Güneştepe": true,
      "Güneybayır": true,
      "Güneybudaklar": true,
      "Hacı Ilyas": true,
      "Hamitler": true,
      "Hamzabey": true,
      "Hocaalizade": true,
      "Hocahasan": true,
      "Hüdavendigar": true,
      "Hürriyet": true,
      "Hüseyinalan": true,
      "İbrahimpaşa": true,
      "İnkaya": true,
      "İntizam": true,
      "İsmetiye": true,
      "İstiklal": true,
      "İvazpaşa": true,
      "Karabalçık": true,
      "Karaislah": true,
      "Kavaklı": true,
      "Kayıhan": true,
      "Kemerçeşme": true,
      "Kırcaali": true,
      "Kirazlı": true,
      "Kiremitçi": true,
      "Kocanaip": true,
      "Koğukçınar": true,
      "Kuruçeşme": true,
      "Küçükbalıklı": true,
      "Küçükdeliller": true,
      "Kükürtlü": true,
      "Küplüpınar": true,
      "Maksem": true,
      "Mehmet Akif": true,
      "Mollafenari": true,
      "Mollagürani": true,
      "Muradiye": true,
      "Mürseller": true,
      "Nalbantoğlu": true,
      "Namık Kemal": true,
      "Nilüferköy": true,
      "Orhanbey": true,
      "Osmangazi": true,
      "Ovaakça Çeşmebaşı": true,
      "Ovaakça Eğitim": true,
      "Ovaakça Merkez": true,
      "Ovaakça Santral": true,
      "Panayır": true,
      "Pınarbaşı": true,
      "Reyhan": true,
      "Sakarya": true,
      "Santral Garaj": true,
      "Seç": true,
      "Seferışıklar": true,
      "Selamet": true,
      "Selçukgazi": true,
      "Selimiye": true,
      "Sırameşeler": true,
      "Soğanlı": true,
      "Soğukkuyu": true,
      "Soğukpınar": true,
      "Şehabettinpaşa": true,
      "Şehreküstü": true,
      "Tahtakale": true,
      "Tayakadın": true,
      "Tuna": true,
      "Tuzaklı": true,
      "Tuzpazarı": true,
      "Ulu": true,
      "Uluçam": true,
      "Veysel Karani": true,
      "Yahşibey": true,
      "Yenibağlar": true,
      "Yeniceabat": true,
      "Yenikaraman": true,
      "Yenikent": true,
      "Yeşilova": true,
      "Yiğitali": true,
      "Yunuseli": true,
      "Zafer": true
    },
    "Yenişehir": {
      "Afşar": true,
      "Akbıyık": true,
      "Akçapınar": true,
      "Akdere": true,
      "Alaylı": true,
      "Ayaz": true,
      "Aydoğdu": true,
      "Barcın": true,
      "Beypınar": true,
      "Burcun": true,
      "Cihadiye": true,
      "Çamönü": true,
      "Çardak": true,
      "Çayır": true,
      "Çayırlı": true,
      "Çelebi": true,
      "Çeltikçi": true,
      "Çiçeközü": true,
      "Demirboğa": true,
      "Dereköy": true,
      "Ebeköy": true,
      "Eğerce": true,
      "Fethiye": true,
      "Gökçesu": true,
      "Gündoğan": true,
      "Günece": true,
      "Hayriye": true,
      "Hıdırbali": true,
      "İncirli": true,
      "Karaamca": true,
      "Karabahadır": true,
      "Karacaahmet": true,
      "Karacaali": true,
      "Karaköy": true,
      "Karasıl": true,
      "Kavaklı": true,
      "Kıblepınar": true,
      "Kızılhisar": true,
      "Kızılköy": true,
      "Kirazlıyayla": true,
      "Koyunhisar": true,
      "Kozdere": true,
      "Köprühisar": true,
      "Kurtuluş": true,
      "Mahmudiye": true,
      "Marmaracık": true,
      "Mecidiye": true,
      "Menteşe": true,
      "Orhaniye": true,
      "Osmaniye": true,
      "Papatya": true,
      "Paşayayla": true,
      "Reşadiye": true,
      "Selimiye": true,
      "Söylemiş": true,
      "Subaşı": true,
      "Süleymaniye": true,
      "Tabakhane": true,
      "Terziler": true,
      "Toprakdere": true,
      "Toprakocak": true,
      "Ulucami": true,
      "Yarhisar": true,
      "Yazılı": true,
      "Yeni": true,
      "Yenigün": true,
      "Yeniköy": true,
      "Yıldırım": true,
      "Yılmaz": true,
      "Yolören": true,
      "Yüzüncüyıl": true
    },
    "Yıldırım": {
      "152evler": true,
      "75.yıl": true,
      "Akçağlayan": true,
      "Anadolu": true,
      "Arabayatağı": true,
      "Bağlaraltı": true,
      "Balaban": true,
      "Baruthane": true,
      "Beyazıt": true,
      "Cumalıkızık": true,
      "Çelebi Mehmet": true,
      "Çınarönü": true,
      "Davutdede": true,
      "Davutkadı": true,
      "Değirmenlikızık": true,
      "Değirmenönü": true,
      "Demetevler": true,
      "Duaçınarı": true,
      "Eğitim": true,
      "Emirsultan": true,
      "Erikli": true,
      "Ertuğrulgazi": true,
      "Esenevler": true,
      "Fidyekızık": true,
      "Güllük": true,
      "Hacıseyfettin": true,
      "Hacivat": true,
      "Hamamlıkızık": true,
      "Hocataşkın": true,
      "İsabey": true,
      "Kaplıkaya": true,
      "Karaağaç": true,
      "Karamazak": true,
      "Karapınar": true,
      "Kazım Karabekir": true,
      "Kurtoğlu": true,
      "Maltepe": true,
      "Mehmetakifersoy": true,
      "Mevlana": true,
      "Meydancık": true,
      "Millet": true,
      "Mimarsinan": true,
      "Mollaarap": true,
      "Musababa": true,
      "Namazgah": true,
      "Ortabağlar": true,
      "Piremir": true,
      "Sakarya": true,
      "Samanlı": true,
      "Selçukbey": true,
      "Selimzade": true,
      "Sıracevizler": true,
      "Sinandede": true,
      "Siteler": true,
      "Şirinevler": true,
      "Şükraniye": true,
      "Teferrüç": true,
      "Ulus": true,
      "Umurbey": true,
      "Vakıf": true,
      "Vatan": true,
      "Yavuzselım": true,
      "Yediselviler": true,
      "Yenımahalle": true,
      "Yeşil": true,
      "Yeşilyayla": true,
      "Yıldırım": true,
      "Yiğitler": true,
      "Yunusemre": true,
      "Zeyniler": true,
      "Zümrütevler": true
    }
  },
  "Çanakkale": {
    "Ayvacık": {
      "Fatih": true,
      "Gökçetepe": true,
      "Hamdibey": true,
      "Mıhlı": true,
      "Sahil": true,
      "Ümmühan": true
    },
    "Bayramiç": {
      "Camicedit": true,
      "Camikebir": true,
      "Menderes": true,
      "Tepecik": true
    },
    "Biga": {
      "Cumhuriyet": true,
      "Çavuşköy": true,
      "Esentepe": true,
      "Gazikemal": true,
      "Hamdibey": true,
      "İğdelik": true,
      "İstiklal": true,
      "Sakarya": true,
      "Şirintepe": true,
      "Turan": true,
      "Ulucamii": true,
      "Yalı": true,
      "Yeniceköy": true,
      "Zeytinlik": true
    },
    "Bozcaada": {
      "Alaybey": true,
      "Cumhuriyet": true
    },
    "Çan": {
      "Atatürk": true,
      "Cumhuriyet": true,
      "Çakmakçayır": true,
      "Fatih": true,
      "İstiklal": true,
      "Karşıyaka": true,
      "Osmanefendi": true,
      "Seramik": true,
      "Süle": true
    },
    "Eceabat": {
      "İsmetpaşa": true,
      "Kemalpaşa": true
    },
    "Ezine": {
      "Camikebir": true,
      "Cumhuriyet": true,
      "Danişment": true,
      "Gazi": true,
      "Hürriyet": true,
      "Sarısöğüt": true,
      "Seferşah": true
    },
    "Gelibolu": {
      "Alaeddin": true,
      "Camiikebir": true,
      "Cumhuriyet": true,
      "Çeşme": true,
      "Gazi Süleyman Paşa": true,
      "Hoca Hamza": true,
      "Hürriyet": true,
      "Keşanoğlu": true,
      "Yazıcızade": true,
      "Yeni": true
    },
    "Gökçeada": {
      "Cumhuriyet": true,
      "Çınarlı": true,
      "Fatih": true,
      "Kuzulimanı": true,
      "Yeni": true
    },
    "Lapseki": {
      "Cumhuriyet": true,
      "Dalyan": true,
      "Gazi Süleyman Paşa": true,
      "Gaziyakupbey": true,
      "Tekke": true,
      "Umurbey Merkez": true
    },
    "Merkez": {
      "Barbaros": true,
      "Boğazkent": true,
      "Cevat Paşa": true,
      "Cumhuriyet": true,
      "Esenler": true,
      "Fevzipaşa": true,
      "Hamidiye": true,
      "İsmetpaşa": true,
      "Kemalpaşa": true,
      "Namık Kemal": true
    },
    "Yenice": {
      "Atatürk": true,
      "Cumhuriyet": true,
      "Eski Yenice": true,
      "Kışlalar": true,
      "Kurtuluş": true,
      "Yeni": true
    }
  },
  "Çankırı": {
    "Atkaracalar": {
      "Bozkuş": true,
      "Cumhuriyet": true,
      "Gazibey": true,
      "Hoca": true,
      "Hürriyet": true,
      "Ilıpınar": true,
      "İlker": true,
      "Kıran": true,
      "Mollaosman": true,
      "Mustafa Kemal": true,
      "Nevzat Ayaz": true
    },
    "Bayramören": {
      "Köprülübey": true,
      "Merkez": true,
      "Zübeyde Hanım": true
    },
    "Çerkeş": {
      "Cumhuriyet": true,
      "Güzelyurt": true,
      "İdris": true,
      "İstasyon": true,
      "Karalar": true,
      "Karamuklu": true,
      "Kayabaşı": true,
      "Kurtlar": true,
      "Okçular": true,
      "Ulusu": true,
      "Yalıözü": true,
      "Yeni": true,
      "Yeni Kent": true
    },
    "Eldivan": {
      "Bahçelievler": true,
      "Beydere": true,
      "Cami": true,
      "Çay": true,
      "Dere": true,
      "Topraklık": true
    },
    "Ilgaz": {
      "Fatih": true,
      "Gazi Dede": true,
      "Karataş": true,
      "Şentepe": true,
      "Ulupınar": true,
      "Yavuz": true,
      "Yeni": true,
      "Yukarı": true,
      "Ziraat": true
    },
    "Kızılırmak": {
      "Hüseyinli": true,
      "Osmanlı": true,
      "Yeni": true
    },
    "Korgun": {
      "Büyük": true,
      "Doğu": true,
      "Uludağ": true
    },
    "Kurşunlu": {
      "Beşpınar": true,
      "Cömertler": true,
      "Çal": true,
      "Çavundur": true,
      "Çiyni": true,
      "Erenler": true,
      "Hacı Bekir": true,
      "Kale": true,
      "Kalekapu": true,
      "Müslüm": true,
      "Yeni": true,
      "Yeşil": true
    },
    "Merkez": {
      "Abdulhalik Renda": true,
      "Aksu": true,
      "Alibey": true,
      "Buğday Pazarı": true,
      "Cumhuriyet": true,
      "Esentepe": true,
      "Fatih": true,
      "İncili  Çeşme": true,
      "Karataş": true,
      "Karatekin": true,
      "Kırkevler": true,
      "Mimar Sinan": true,
      "Tabakhane": true,
      "Yeni": true
    },
    "Orta": {
      "Cem Sultan": true,
      "Cumhuriyet": true,
      "Eski Yayla": true,
      "Hacı Hasan": true,
      "Hamamönü": true,
      "Hatipler": true,
      "Hürriyet": true,
      "İnkilap": true,
      "Kanarya": true,
      "Kanlıca": true,
      "Kayılar": true,
      "Naltepe": true,
      "Nevzat Ayaz": true,
      "Sultan Beyazıt": true,
      "Sünnetçiler": true
    },
    "Şabanözü": {
      "Cumhuriyet": true,
      "Gümerdiğin": true,
      "Gürpınar": true,
      "Karaören": true,
      "Mahmudiye": true,
      "Sağlık": true,
      "Yeni": true
    },
    "Yapraklı": {
      "Akyazı": true,
      "Aşağı": true,
      "Camikebir": true,
      "İğdir": true,
      "Kavak": true,
      "Yukarı": true
    }
  },
  "Çorum": {
    "Alaca": {
      "Ayhan": true,
      "Cengizhan": true,
      "Cumhuriyet": true,
      "Denizhan": true,
      "Günhan": true,
      "Özhan": true,
      "Yıldızhan": true
    },
    "Bayat": {
      "Dere": true,
      "Kayabaşı": true,
      "Tepebayat": true,
      "Yatukcu": true,
      "Yeni": true
    },
    "Boğazkale": {
      "Çarşı": true,
      "Hattusas": true,
      "Hisar": true,
      "Yekbas": true
    },
    "Dodurga": {
      "Çatar": true,
      "Doğu": true,
      "Esentepe": true,
      "Fatih": true,
      "Okul": true,
      "Ulucami": true
    },
    "İskilip": {
      "Bahabey": true,
      "Büyüktaş": true,
      "Çavuş": true,
      "Ekizoğlu": true,
      "Erenler": true,
      "Hacıpiri": true,
      "Kaleboğazı": true,
      "Meydan": true,
      "Mutaflar": true,
      "Sakarya": true,
      "Tabakhane": true,
      "Ulaştepe": true,
      "Uludere": true,
      "Yenicami": true
    },
    "Kargı": {
      "Bahçelievler": true,
      "Fatih": true,
      "İmambey": true,
      "Mihrihatun": true,
      "Orta": true,
      "Yeni": true
    },
    "Laçin": {
      "Bahçelievler": true,
      "Fatih": true,
      "Yeni": true
    },
    "Mecitözü": {
      "Bahçelievler": true,
      "Camikebir": true,
      "Doğu": true,
      "Hıdırlık": true,
      "Mescit": true,
      "Sarıdede": true,
      "Şehler": true,
      "Tutluk": true
    },
    "Merkez": {
      "Ak Kent": true,
      "Ataköy": true,
      "Bahçelievler": true,
      "Bayat": true,
      "Buharaevler": true,
      "Çepni": true,
      "Çöplü": true,
      "Fatih Sultan Mehmet": true,
      "Gedikbekir": true,
      "Gülabibey": true,
      "İkipınar": true,
      "Kale": true,
      "Karakeçili": true,
      "Kışladeresi": true,
      "Kultak": true,
      "Kunduzhan": true,
      "Mimarsinan": true,
      "Ulukavak": true,
      "Üçtutlar": true,
      "Yavruturna": true,
      "Yeniyol": true,
      "Yunusemre": true
    },
    "Oğuzlar": {
      "Asarçay": true,
      "Birtatlı": true,
      "Çarşı": true,
      "Çeşme": true,
      "Gölbaşı": true,
      "Karadonlu": true,
      "Kızılcapelit": true
    },
    "Ortaköy": {
      "Bahçelievler": true,
      "Cumhuriyet": true,
      "Suyolu": true,
      "Şirinevler": true
    },
    "Osmancık": {
      "Cumhuriyet": true,
      "Çay": true,
      "Çiftlikler": true,
      "Esentepe": true,
      "Eymir": true,
      "Gemici": true,
      "Güney": true,
      "Gürleyik": true,
      "Hıdırlık": true,
      "Karapınar": true,
      "Kızılırmak": true,
      "Koyunbaba": true,
      "Şenyurt": true,
      "Temençe": true,
      "Ulucamii": true,
      "Yazı": true,
      "Yeni": true,
      "Yeşilçatma": true
    },
    "Sungurlu": {
      "Akçakent": true,
      "Akçay": true,
      "Bahçelievler": true,
      "Başpınar": true,
      "Cevheri": true,
      "Çiftlik": true,
      "Fatih": true,
      "Fevzi Paşa": true,
      "Gürpınar": true,
      "Hacettepe": true,
      "İsmetpaşa": true,
      "Örnekevler": true,
      "Sunguroğlu": true,
      "Şekerpınar": true,
      "Turan": true,
      "Yenidoğan": true,
      "Yenihayat": true
    },
    "Uğurludağ": {
      "Karşıyaka": true,
      "Tutpınar": true,
      "Yenicamii": true,
      "Yeşilyurt": true,
      "Yüzgeç": true
    }
  },
  "Denizli": {
    "Acıpayam": {
      "Akalan": true,
      "Akşar": true,
      "Alaattin": true,
      "Alcı": true,
      "Aliveren": true,
      "Apa": true,
      "Aşağı": true,
      "Avşar": true,
      "Bademli": true,
      "Bedirbey": true,
      "Benlik": true,
      "Boğazdere": true,
      "Corum": true,
      "Çakır": true,
      "Çamlık": true,
      "Çiftlik": true,
      "Çubukçular": true,
      "Darıveren": true,
      "Dedebağı": true,
      "Dodurga": true,
      "Eskiköy": true,
      "Gedikli": true,
      "Gölcük": true,
      "Gümüş": true,
      "Güney": true,
      "Hacıkurtlar": true,
      "Hisar": true,
      "Karahüyük": true,
      "Karaismailler": true,
      "Kelekçi": true,
      "Kırca": true,
      "Köke": true,
      "Kumafşarı": true,
      "Kurtlar": true,
      "Kuyucak": true,
      "Kuzören": true,
      "Mevlütler": true,
      "Oğuz": true,
      "Olukbaşı": true,
      "Ovayurt": true,
      "Ören": true,
      "Pınarbaşı": true,
      "Pınaryazı": true,
      "Sandalcık": true,
      "Sırçalık": true,
      "Suçatı": true,
      "Ucarı": true,
      "Yassıhüyük": true,
      "Yazır": true,
      "Yeni": true,
      "Yeniköy": true,
      "Yeşildere": true,
      "Yeşilyuva": true,
      "Yolçatı": true,
      "Yukarı": true,
      "Yumrutaş": true
    },
    "Babadağ": {
      "Ahıllı": true,
      "Bekirler": true,
      "Cumhuriyet": true,
      "Demirli": true,
      "Gazi": true,
      "Gündoğdu": true,
      "İncilipınar": true,
      "Kelleci": true,
      "Kıranyer": true,
      "Mollaahmet": true,
      "Oğuzlar": true,
      "Yeniköy": true
    },
    "Baklan": {
      "Balca": true,
      "Beyelli": true,
      "Boğaziçi": true,
      "Çataloba": true,
      "Dağal": true,
      "Gökpınar": true,
      "Gürlük": true,
      "Hadim": true,
      "Hüsamettin Dede": true,
      "İcikli": true,
      "Kavaklar": true,
      "Kirazlı": true,
      "Konak": true,
      "Şenyayla": true
    },
    "Bekilli": {
      "Bahçeli": true,
      "Bükrüce": true,
      "Çamköy": true,
      "Çoğaşlı": true,
      "Deşdemir": true,
      "Ekizbaba": true,
      "Gömce": true,
      "Köselli": true,
      "Kutlubey": true,
      "Poyrazlı": true,
      "Sırıklı": true,
      "Üçkuyu": true,
      "Yahyalar": true,
      "Yeni": true,
      "Yeşiloba": true
    },
    "Beyağaç": {
      "Cumhuriyet": true,
      "Çamlık": true,
      "Eşenler": true,
      "Fatih": true,
      "Geriçam": true,
      "Hürriyet": true,
      "Kapuz": true,
      "Kızılcaağaç": true,
      "Pınarönü": true,
      "Sazak": true,
      "Subaşı": true,
      "Uzunoluk": true,
      "Yeni": true,
      "Yeniçeşme": true,
      "Zafer": true
    },
    "Bozkurt": {
      "Alikurt": true,
      "Armutalanı": true,
      "Avdan": true,
      "Baklankuyucak": true,
      "Barbaros": true,
      "Başçeşme": true,
      "Cumalı": true,
      "Çambaşı": true,
      "Fatih": true,
      "Hamdiye": true,
      "Hayrettinköy": true,
      "İnceler": true,
      "İncelertekkesi": true,
      "Mahmudiye": true,
      "Mecidiye": true,
      "Mehmetçik": true,
      "Mimar Sinan": true,
      "Sazköy": true,
      "Tutluca": true,
      "Yenibağlar": true
    },
    "Buldan": {
      "Aktaş": true,
      "Alacaoğlu": true,
      "Alandız": true,
      "Beyler": true,
      "Boğazçiftlik": true,
      "Bostanyeri": true,
      "Bozalan": true,
      "Bölmekaya": true,
      "Bursa": true,
      "Cumhuriyet": true,
      "Çamköy": true,
      "Çarşı": true,
      "Çatak": true,
      "Çaybaşı": true,
      "Derbent": true,
      "Dımbazlar": true,
      "Doğan": true,
      "Dört Eylül": true,
      "Düzalan": true,
      "Girne": true,
      "Gölbaşı": true,
      "Gülalan": true,
      "Güroluk": true,
      "Hasanbeyler": true,
      "Helvacılar": true,
      "Kadıköy": true,
      "Karaköy": true,
      "Karşıyaka": true,
      "Kaşıkcı": true,
      "Kırandamı": true,
      "Kovanoluk": true,
      "Kurtuluş": true,
      "Kurudere": true,
      "Mahmutlu": true,
      "Oğuz": true,
      "Sarımahmutlu": true,
      "Süleymanlı": true,
      "Turan": true,
      "Türlübey": true,
      "Yalçınkaya": true,
      "Yayla": true,
      "Yeni": true,
      "Yenicekent": true,
      "Yeniçam": true,
      "Yeşil Dere": true
    },
    "Çal": {
      "Akkent": true,
      "Alfaklar": true,
      "Aşağıseyit": true,
      "Bahadınlar": true,
      "Baklançakırlar": true,
      "Bayıralan": true,
      "Belevi": true,
      "Çalçakırlar": true,
      "Çalkuyucak": true,
      "Dağmarmara": true,
      "Dayılar": true,
      "Denizler": true,
      "Develler": true,
      "Gelinören": true,
      "Hançalar": true,
      "Hüseyinler": true,
      "İsabey": true,
      "İsmailler": true,
      "Kabalar": true,
      "Kaplanlar": true,
      "Karakaya": true,
      "Karapınar": true,
      "Kocaköy": true,
      "Mahmutgazi": true,
      "Ortaköy": true,
      "Peynirciler": true,
      "Sakızcılar": true,
      "Sazak": true,
      "Selcen": true,
      "Süller": true,
      "Şapcılar": true,
      "Yazır": true,
      "Yeşilyurt": true,
      "Yukarıseyit": true
    },
    "Çameli": {
      "Akpınar": true,
      "Arıkaya": true,
      "Ayvacık": true,
      "Belevi": true,
      "Bıçakçı": true,
      "Cevizli": true,
      "Cumaalanı": true,
      "Çamlıbel": true,
      "Çiğdemli": true,
      "Elmalı": true,
      "Emecik": true,
      "Ericek": true,
      "Gökçeyaka": true,
      "Gürsu": true,
      "Güzelyurt": true,
      "İmamlar": true,
      "Kalınkoz": true,
      "Karabayır": true,
      "Kınıkyeri": true,
      "Kızılyaka": true,
      "Kirazlıyayla": true,
      "Kocaova": true,
      "Kolak": true,
      "Sarıkavak": true,
      "Sofular": true,
      "Taşçılar": true,
      "Yaylapınar": true,
      "Yeni": true,
      "Yeşilyayla": true,
      "Yumrutaş": true,
      "Yunuspınarı": true
    },
    "Çardak": {
      "Ayvaz": true,
      "Bahçelievler": true,
      "Beylerli": true,
      "Cumhuriyet": true,
      "Çaltı": true,
      "Çınar": true,
      "Gemişli": true,
      "Gemişpınarı": true,
      "Gölcük": true,
      "Hayriye": true,
      "Hürriyet": true,
      "İstiklal": true,
      "Saray": true,
      "Söğütlü": true,
      "Söğütözü": true
    },
    "Çivril": {
      "Akçaköy": true,
      "Akpınar": true,
      "Aktaş": true,
      "Aşağı": true,
      "Balçıkhisar": true,
      "Bayat": true,
      "Bekirli": true,
      "Belence": true,
      "Beydilli": true,
      "Beyköy": true,
      "Bozdağ": true,
      "Bucak": true,
      "Bulgurlar": true,
      "Cabar": true,
      "Cumalar": true,
      "Çağlayan": true,
      "Çakallar": true,
      "Çandır": true,
      "Çapak": true,
      "Çarşı": true,
      "Çatlar": true,
      "Çayır": true,
      "Çetinler": true,
      "Çıtak": true,
      "Düzbel": true,
      "Emircik": true,
      "Gökgöl": true,
      "Gümüşsu": true,
      "Gürpınar": true,
      "Hamam": true,
      "Haydan": true,
      "Irgıllı": true,
      "Işıklı": true,
      "İğdir": true,
      "İmrallı": true,
      "İnceköy": true,
      "İshaklı": true,
      "Karabedirler": true,
      "Karahacılı": true,
      "Karalar": true,
      "Karamanlı": true,
      "Karayahşiler": true,
      "Kavakalanı": true,
      "Kavakköy": true,
      "Kıralan": true,
      "Kızılcasöğüt": true,
      "Kızılcayer": true,
      "Kocayaka": true,
      "Koçak": true,
      "Menteş": true,
      "Osmanköy": true,
      "Ömerli": true,
      "Özdemirci": true,
      "Reşadiye": true,
      "Saray": true,
      "Sarıbeyli": true,
      "Sarılar": true,
      "Savran": true,
      "Seraserli": true,
      "Somak": true,
      "Sökmen": true,
      "Stadyum": true,
      "Sundurlu": true,
      "Süngüllü": true,
      "Şehitler": true,
      "Şenköy": true,
      "Tekke": true,
      "Tokça": true,
      "Tuğlu": true,
      "Yahyalı": true,
      "Yakacık": true,
      "Yalınlı": true,
      "Yamanlar": true,
      "Yassıhüyük": true,
      "Yukarı": true,
      "Yukarı Çapak": true,
      "Yuvaköy": true
    },
    "Güney": {
      "Adıgüzeller": true,
      "Aşağıçeşme": true,
      "Aydoğdu": true,
      "Cindere": true,
      "Çamrak": true,
      "Çorbacılar": true,
      "Doğanlı": true,
      "Ertuğrul": true,
      "Eziler": true,
      "Fatih": true,
      "Hamidiye": true,
      "Haylamaz": true,
      "Karaağaçlı": true,
      "Karagözler": true,
      "Kerimler": true,
      "Koparan": true,
      "Orta": true,
      "Ortaçeşme": true,
      "Parmaksızlar": true,
      "Tilkilik": true,
      "Üç Eylül": true,
      "Yağcılar": true,
      "Yeni": true,
      "Yenikonak": true
    },
    "Honaz": {
      "Afşın Bey": true,
      "Akbaş": true,
      "Aşağıdağdere": true,
      "Aydınlar": true,
      "Cumhuriyet": true,
      "Dereçiftlik": true,
      "Emirazizli": true,
      "Gürleyik": true,
      "Haydar": true,
      "Hisar": true,
      "Hürriyet": true,
      "Kaklık": true,
      "Karaçay": true,
      "Karateke": true,
      "Kızılyer": true,
      "Kocabaş": true,
      "Menteşe": true,
      "Ovacık": true,
      "Sapaca": true,
      "Yeni": true,
      "Yokuşbaşı": true,
      "Yukarıdağdere": true
    },
    "Kale": {
      "Adamharmanı": true,
      "Alanyurt": true,
      "Belenköy": true,
      "Cevherpaşa": true,
      "Cumhuriyet": true,
      "Çakırbağ": true,
      "Çamlarca": true,
      "Demirciler": true,
      "Doğanköy": true,
      "Esenkaya": true,
      "Gökçeören": true,
      "Gölbaşı": true,
      "Gülbağlık": true,
      "Habipler": true,
      "Hürriyet": true,
      "İnceğiz": true,
      "Karaköy": true,
      "Karayayla": true,
      "Kayabaşı": true,
      "Kırköy": true,
      "Koçarboğazı": true,
      "Köprübaşı": true,
      "Künar": true,
      "Muslugüme": true,
      "Narlı": true,
      "Ortaköy": true,
      "Ortatepe": true,
      "Özlüce": true,
      "Toki": true,
      "Uluçam": true,
      "Yenidere": true,
      "Yeniköy": true
    },
    "Merkezefendi": {
      "1200 Evler": true,
      "Adalet": true,
      "Akçeşme": true,
      "Akkonak": true,
      "Alpaslan": true,
      "Altındere": true,
      "Altıntop": true,
      "Aşağışamlı": true,
      "Bahçelievler": true,
      "Barbaros": true,
      "Barutçular": true,
      "Başkarcı": true,
      "Bereketler": true,
      "Bozburun": true,
      "Çakmak": true,
      "Çeltikçi": true,
      "Değirmenönü": true,
      "Eskihisar": true,
      "Gerzele": true,
      "Göveçlik": true,
      "Gültepe": true,
      "Gümüşçay": true,
      "Hacıeyüplü": true,
      "Hallaçlar": true,
      "Hisar": true,
      "İlbade": true,
      "Kadılar": true,
      "Karahasanlı": true,
      "Karaman": true,
      "Kayalar": true,
      "Kumkısık": true,
      "Mehmet Akif Ersoy": true,
      "Merkez Efendı": true,
      "Muratdede": true,
      "Salihağa": true,
      "Saraylar": true,
      "Saruhan": true,
      "Selçuk Bey": true,
      "Servergazi": true,
      "Sevindik": true,
      "Sırakapılar": true,
      "Sümer": true,
      "Şemikler": true,
      "Şirinköy": true,
      "Üzerlik": true,
      "Yeni": true,
      "Yenişafak": true,
      "Yenişehir": true,
      "Yeşilyayla": true,
      "Zafer": true
    },
    "Pamukkale": {
      "15 Mayıs": true,
      "Akçapınar": true,
      "Akdere": true,
      "Akhan": true,
      "Akköy": true,
      "Aktepe": true,
      "Anafartalar": true,
      "Asmalıevler": true,
      "Atalar": true,
      "Bağbaşı": true,
      "Belenardıç": true,
      "Cankurtaran": true,
      "Cumhuriyet": true,
      "Çeşmebaşı": true,
      "Deliktaş": true,
      "Develi": true,
      "Dokuzkavaklar": true,
      "Eldenizli": true,
      "Eymir": true,
      "Fatih": true,
      "Fesleğen": true,
      "Goncalı": true,
      "Gökpınar": true,
      "Gölemezli": true,
      "Gözler": true,
      "Güzelköy": true,
      "Güzelpınar": true,
      "Hacıkaplanlar": true,
      "Haytabey": true,
      "Hürriyet": true,
      "Irlıganlı": true,
      "İncilipınar": true,
      "İstiklal": true,
      "Kale": true,
      "Karahayıt": true,
      "Karakova": true,
      "Karakurt": true,
      "Karataş": true,
      "Karşıyaka": true,
      "Kavakbaşı": true,
      "Kayıhan": true,
      "Kervansaray": true,
      "Kınıklı": true,
      "Kocadere": true,
      "Korucuk": true,
      "Kurtluca": true,
      "Kuşpınar": true,
      "Küçükdere": true,
      "Mehmetçik": true,
      "Pamukkale": true,
      "Pelitlibağ": true,
      "Pınarkent": true,
      "Siteler": true,
      "Tekke": true,
      "Topraklık": true,
      "Uzunpınar": true,
      "Yeniköy": true,
      "Yukarışamlı": true,
      "Yunusemre": true,
      "Zeytinköy": true,
      "Zümrüt": true
    },
    "Sarayköy": {
      "Acıdere": true,
      "Acısu": true,
      "Ada": true,
      "Ahmetli": true,
      "Altıntepe": true,
      "Aşağı": true,
      "Atatürk": true,
      "Bala": true,
      "Beylerbeyi": true,
      "Caber": true,
      "Cumhuriyet": true,
      "Duacılı": true,
      "Gerali": true,
      "Hasköy": true,
      "Hisar": true,
      "Kabaağaç": true,
      "Karakıran": true,
      "Karataş": true,
      "Köprübaşı": true,
      "Kumluca": true,
      "Sakarya": true,
      "Sazak": true,
      "Sığma": true,
      "Tekke": true,
      "Tepeköy": true,
      "Tırkaz": true,
      "Tosunlar": true,
      "Trafo": true,
      "Turan": true,
      "Uyanık": true,
      "Yakayurt": true,
      "Yeşilyurt": true
    },
    "Serinhisar": {
      "Aşağı": true,
      "Ayaz": true,
      "Cumhuriyet": true,
      "Kaya": true,
      "Kocapınar": true,
      "Orta": true,
      "Pınarcık": true,
      "Şair Eşref": true,
      "Yatağan": true,
      "Yenice": true,
      "Yüreğil": true
    },
    "Tavas": {
      "Akıncılar": true,
      "Akyar": true,
      "Alpa": true,
      "Altınova": true,
      "Avdan": true,
      "Aydoğdu": true,
      "Baharlar": true,
      "Bahçeköy": true,
      "Balkıca": true,
      "Çağırgan": true,
      "Çalıköy": true,
      "Çiftlikköy": true,
      "Damlacık": true,
      "Denizoluğu": true,
      "Dereağzı": true,
      "Derinkuyu": true,
      "Ebecik": true,
      "Garipköy": true,
      "Gökçeler": true,
      "Gümüşdere": true,
      "Güzelköy": true,
      "Hırka": true,
      "Horasanlı": true,
      "Karahisar": true,
      "Kayaca": true,
      "Kayapınar": true,
      "Keçeliler": true,
      "Kızılca": true,
      "Kızılcabölük": true,
      "Kozlar": true,
      "Medet": true,
      "Nikfer": true,
      "Orta": true,
      "Ovacık": true,
      "Pınarlar": true,
      "Pınarlık": true,
      "Samanlık": true,
      "Sarabat": true,
      "Seki": true,
      "Sofular": true,
      "Solmaz": true,
      "Tekkeköy": true,
      "Ulukent": true,
      "Vakıf": true,
      "Yahşiler": true,
      "Yaka": true,
      "Yeni": true,
      "Yeşilköy": true,
      "Yorga": true,
      "Yukarıboğaz": true
    }
  },
  "Diyarbakır": {
    "Bağlar": {
      "5 Nisan": true,
      "Ağaçgeçit": true,
      "Alankoz": true,
      "Alipınar": true,
      "Bağcılar": true,
      "Batıçanakçı": true,
      "Batıkarakoç": true,
      "Buçuktepe": true,
      "Buyuransu": true,
      "Çiçekliyurt": true,
      "Çiftlik": true,
      "Develi": true,
      "Ekince": true,
      "Fatih": true,
      "Gömmetaş": true,
      "Kabahıdır": true,
      "Kamışpınar": true,
      "Karacadağ": true,
      "Karahanköy": true,
      "Karamus": true,
      "Kaynartepe": true,
      "Kırkıncık": true,
      "Kırkkoyun": true,
      "Kolludere": true,
      "Körhat": true,
      "Körtepe": true,
      "Mevlana Halit": true,
      "Muradiye": true,
      "Oğlaklı": true,
      "Ortaören": true,
      "Övündüler": true,
      "Özdemir": true,
      "Pınaroğlu": true,
      "Sakallı": true,
      "Sarıdallı": true,
      "Selahattin Eyyubi": true,
      "Şeyh Şamil": true,
      "Tavşantepe": true,
      "Tellikaya": true,
      "Tokluca": true,
      "Topraktaş": true,
      "Topyolu": true,
      "Uzunbahçe": true,
      "Yeniköy": true,
      "Yeşildallı": true,
      "Yiğityolu": true,
      "Yukarı Mollaali": true,
      "Yukarıakdibek": true,
      "Yunus Emre": true
    },
    "Bismil": {
      "Ağılköy": true,
      "Ağıllı": true,
      "Ahmetli": true,
      "Akbaş": true,
      "Akçay": true,
      "Akköy": true,
      "Akpınar": true,
      "Alıncak": true,
      "Alibey": true,
      "Altıok": true,
      "Aluç": true,
      "Ambar": true,
      "Aralık": true,
      "Arapkent": true,
      "Arıkgöl": true,
      "Aslanoğlu": true,
      "Aşağıdolay": true,
      "Aşağıoba": true,
      "Ataköy": true,
      "Aygeçti": true,
      "Babahaki": true,
      "Bademli": true,
      "Baharlı": true,
      "Bahçe": true,
      "Balcılar": true,
      "Başhan": true,
      "Başköy": true,
      "Başören": true,
      "Belli": true,
      "Boyacı": true,
      "Bozçalı": true,
      "Bölümlü": true,
      "Çakallı": true,
      "Çakıllı": true,
      "Çatalköy": true,
      "Çavuşlu": true,
      "Çeltikli": true,
      "Çorapa": true,
      "Çölağan": true,
      "Çöltepe": true,
      "Derbent": true,
      "Dicle": true,
      "Doruk": true,
      "Dumlupınar": true,
      "Eliaçık": true,
      "Erler": true,
      "Esentepe": true,
      "Fatih": true,
      "Fırat": true,
      "Gedikbaşı": true,
      "Göksu": true,
      "Güngeçti": true,
      "Güroluk": true,
      "Güzelköy": true,
      "Harmanlı": true,
      "Hasanpınar": true,
      "Işıklar": true,
      "İsalı": true,
      "İsapınar": true,
      "Kağıtlı": true,
      "Kamberli": true,
      "Kamışlı": true,
      "Karabörk": true,
      "Karacık": true,
      "Karaçölya": true,
      "Karagöz": true,
      "Karapınar": true,
      "Karatepe": true,
      "Karayiğit": true,
      "Kavuşak": true,
      "Kayıköy": true,
      "Kazancı": true,
      "Keberli": true,
      "Kılavuztepe": true,
      "Koğuk": true,
      "Kooperatif": true,
      "Kopmaz": true,
      "Kopuzlu": true,
      "Korukçu": true,
      "Koyunlu": true,
      "Köprüköy": true,
      "Köseli": true,
      "Kumrulu": true,
      "Kurtuluş": true,
      "Kurudeğirmen": true,
      "Kurudere": true,
      "Merdan": true,
      "Meydanlık": true,
      "Mirzabey": true,
      "Obalı": true,
      "Ofköy": true,
      "Oğuzlar": true,
      "Pınarbaşı": true,
      "Sanayi": true,
      "Sarıköy": true,
      "Sarıtoprak": true,
      "Sazlı": true,
      "Seki": true,
      "Serçeler": true,
      "Seyit Hasan": true,
      "Seyrantepe": true,
      "Sinanköy": true,
      "Şahintepe": true,
      "Şentepe": true,
      "Tatlıçayır": true,
      "Tekel": true,
      "Tepe": true,
      "Tepecik": true,
      "Tilkilik": true,
      "Topraklı": true,
      "Türkmenhacı": true,
      "Uğrak": true,
      "Uğurlu": true,
      "Ulutürk": true,
      "Uyanık": true,
      "Üçtepe": true,
      "Yağmurköy": true,
      "Yamaçköy": true,
      "Yasince": true,
      "Yenice": true,
      "Yukarıdolay": true,
      "Yukarıharım": true,
      "Yukarısalat": true
    },
    "Çermik": {
      "Ağaçhan": true,
      "Akçörten": true,
      "Akkoyunlu": true,
      "Akpınar": true,
      "Alabuğday": true,
      "Alakoç": true,
      "Arabük": true,
      "Armağantaşı": true,
      "Armutlu": true,
      "Artuk": true,
      "Asmalı": true,
      "Aşağışeyhler": true,
      "Aşağıtaşmalı": true,
      "Aynalı": true,
      "Bademli": true,
      "Bahçe": true,
      "Balıksırtı": true,
      "Başarı": true,
      "Bayat": true,
      "Bayırbağı": true,
      "Baykal": true,
      "Bayrak": true,
      "Bintaş": true,
      "Bircemal": true,
      "Bulundu": true,
      "Ceylan": true,
      "Çalıtepe": true,
      "Çukur": true,
      "Çukurelma": true,
      "Değirmenli": true,
      "Dikyol": true,
      "Dilekpınar": true,
      "Elifuşağı": true,
      "Eskibağ": true,
      "Genceli": true,
      "Göktepe": true,
      "Gözerek": true,
      "Güçlütaş": true,
      "Günaşan": true,
      "Gürüz": true,
      "Güzel": true,
      "Haburman": true,
      "İkiçeltik": true,
      "İncili": true,
      "Kala": true,
      "Kalaç": true,
      "Kalecik": true,
      "Karacaviran": true,
      "Karakaya": true,
      "Karamusa": true,
      "Karataş": true,
      "Kartaltaşı": true,
      "Kayagediği": true,
      "Keklik": true,
      "Kırmatepe": true,
      "Konaklı": true,
      "Konuksever": true,
      "Korudağ": true,
      "Köksal": true,
      "Kömürcüler": true,
      "Kuşlukçayırı": true,
      "Kuyu": true,
      "Örenkuyu": true,
      "Pamuklu": true,
      "Petekkaya": true,
      "Pınarlı": true,
      "Recep": true,
      "Saltepe": true,
      "Saray": true,
      "Sarıbalta": true,
      "Sarıca": true,
      "Sine": true,
      "Şeyhandede": true,
      "Tepe": true,
      "Toplu": true,
      "Yabanardı": true,
      "Yayıklı": true,
      "Yaylacık": true,
      "Yeşilova": true,
      "Yiğitler": true,
      "Yoğun": true
    },
    "Çınar": {
      "Ağaçsever": true,
      "Akçomak": true,
      "Aktepe": true,
      "Alabaş": true,
      "Alancık": true,
      "Altınakar": true,
      "Arafat": true,
      "Aşağı Mollaali": true,
      "Aşağıkonak": true,
      "Avdalı": true,
      "Ayveri": true,
      "Bağacık": true,
      "Ballıbaba": true,
      "Başaklı": true,
      "Başalan": true,
      "Bayırkonağı": true,
      "Belenli": true,
      "Bellitaş": true,
      "Beneklitaş": true,
      "Beşpınar": true,
      "Bilmece": true,
      "Bira Mehmet Ağa": true,
      "Boğazören": true,
      "Bozçalı": true,
      "Bulutçeker": true,
      "Cumhuriyet": true,
      "Çakırkaya": true,
      "Çakırtutmaz": true,
      "Çataltarla": true,
      "Çatmadal": true,
      "Çeltikaltı": true,
      "Çınarköy": true,
      "Çömçeli": true,
      "Çukurbaşı": true,
      "Demirölçek": true,
      "Dikmencik": true,
      "Dişlibaşak": true,
      "Düğrük": true,
      "Düzova": true,
      "Ekinveren": true,
      "Eski": true,
      "Fatih": true,
      "Filizören": true,
      "Gazi": true,
      "Göktepe": true,
      "Görece": true,
      "Gümüştaş": true,
      "Gürses": true,
      "Halıören": true,
      "Halkapınar": true,
      "Harabe": true,
      "Hasköy": true,
      "Höyükdibi": true,
      "İnanöz": true,
      "İncirtepe": true,
      "Karababa": true,
      "Karabudak": true,
      "Karaçevre": true,
      "Karalar": true,
      "Karasungur": true,
      "Kazıktepe": true,
      "Kılıçkaya": true,
      "Kırkağaç": true,
      "Köksalan": true,
      "Kubacık": true,
      "Kuruyazı": true,
      "Kutluk": true,
      "Kuyuluhöyük": true,
      "Kürekli": true,
      "Leblebitaş": true,
      "Meydanköy": true,
      "Muratcık": true,
      "Ortaşar": true,
      "Ovabağ": true,
      "Öncülü": true,
      "Özgider": true,
      "Özyar": true,
      "Pembeviran": true,
      "Selyazı": true,
      "Sevindik": true,
      "Sırımkeser": true,
      "Soğansuyu": true,
      "Solmaz": true,
      "Sürendal": true,
      "Şekerören": true,
      "Şeyhçoban": true,
      "Şükürlü": true,
      "Taşhelvası": true,
      "Tekkaynak": true,
      "Tilver": true,
      "Toraman": true,
      "Yaprakbaşı": true,
      "Yarımkaş": true,
      "Yazçiçeği": true,
      "Yeni": true,
      "Yeşil": true,
      "Yeşilbağ": true,
      "Yeşiltaş": true,
      "Yıllarca": true,
      "Yukarıortaören": true,
      "Yuvacık": true
    },
    "Çüngüş": {
      "Akbaşak": true,
      "Aktaş": true,
      "Albayrak": true,
      "Arpadere": true,
      "Atalar": true,
      "Avut": true,
      "Aydınlı": true,
      "Balcılar": true,
      "Camii Kebir": true,
      "Camiisuk": true,
      "Çataldut": true,
      "Çaybaşı": true,
      "Değirmensuyu": true,
      "Deveboynu": true,
      "Elmadere": true,
      "Elyos": true,
      "Gökçepelit": true,
      "Güneydere": true,
      "Handere": true,
      "Hindibaba": true,
      "Hoya": true,
      "İbikkaya": true,
      "Karakaya": true,
      "Karşıyaka": true,
      "Kaynakköy": true,
      "Keleşevleri": true,
      "Koçören": true,
      "Norşin": true,
      "Ormançayı": true,
      "Oyuklu": true,
      "Polatuşağı": true,
      "Sağtepe": true,
      "Seferuşağı": true,
      "Türkmen": true,
      "Üçpınar": true,
      "Yaygınkonak": true,
      "Yazyağmuru": true,
      "Yenice": true,
      "Yeniköy": true,
      "Yukarışeyhler": true
    },
    "Dicle": {
      "15 Temmuz": true,
      "Acar": true,
      "Altayköy": true,
      "Arıköy": true,
      "Bademli": true,
      "Bağlarbaşı": true,
      "Bahçedere": true,
      "Bahçeköy": true,
      "Baltacı": true,
      "Başköy": true,
      "Baturköy": true,
      "Biçer": true,
      "Boğaz": true,
      "Boğazköy": true,
      "Bozoba": true,
      "Çavlı": true,
      "Çelebi": true,
      "Dedeköy": true,
      "Değirmenli": true,
      "Döğer": true,
      "Durabeyli": true,
      "Gelincik": true,
      "Gölbaşı": true,
      "Gündoğdu": true,
      "Gündüz": true,
      "Kaygısız": true,
      "Kayıköy": true,
      "Kelekçi": true,
      "Kırklar": true,
      "Kırkpınar": true,
      "Kocaalan": true,
      "Koruköy": true,
      "Kurşunlu": true,
      "Kurudere": true,
      "Meydan": true,
      "Pekmezciler": true,
      "Pınar": true,
      "Sergenli": true,
      "Süsümlü": true,
      "Taşağıl": true,
      "Tepe": true,
      "Tepebaşı": true,
      "Uğrak": true,
      "Ulubaş": true,
      "Uluçeşme": true,
      "Üzümlü": true,
      "Yeşilsırt": true,
      "Yeşiltepe": true,
      "Yokuşlu": true
    },
    "Eğil": {
      "Akalan": true,
      "Babalar": true,
      "Bahşilar": true,
      "Balaban": true,
      "Balım": true,
      "Baysu": true,
      "Dere": true,
      "Döşemeler": true,
      "Düzlük": true,
      "Gündoğuran": true,
      "Gürünlü": true,
      "Ilgın": true,
      "Kale": true,
      "Kalecik": true,
      "Kalkan": true,
      "Kaya": true,
      "Kazanlı": true,
      "Kırkkuyu": true,
      "Konak": true,
      "Meşeler": true,
      "Oyalı": true,
      "Sağlam": true,
      "Sarıca": true,
      "Sarmaşık": true,
      "Selman": true,
      "Taşdam": true,
      "Tepecik": true,
      "Yatır": true,
      "Yenişehir": true,
      "Yukarıhaydan": true
    },
    "Ergani": {
      "Adnan Menderes": true,
      "Ahmetli": true,
      "Akçakale": true,
      "Akçoban": true,
      "Alitaşı": true,
      "Armutova": true,
      "Aşağıbitikçi": true,
      "Aşağıkuyulu": true,
      "Azıklı": true,
      "Aziziye": true,
      "Bademli": true,
      "Bagür": true,
      "Bahçekaşı": true,
      "Bereketli": true,
      "Boğazköy": true,
      "Boncuklu": true,
      "Bozyer": true,
      "Buzluca": true,
      "Caferan": true,
      "Canveren": true,
      "Coşkun": true,
      "Cömert": true,
      "Çakartaş": true,
      "Çakırfakır": true,
      "Çayırdere": true,
      "Çayköy": true,
      "Çiçeközü": true,
      "Çimlihöyük": true,
      "Çukurdere": true,
      "Dağarası": true,
      "Dallıdağ": true,
      "Değirmendere": true,
      "Demirli": true,
      "Dereboyu": true,
      "Deringöze": true,
      "Develi": true,
      "Devletkuşu": true,
      "Dibektaş": true,
      "Dicle": true,
      "Doğanköy": true,
      "Fatih": true,
      "Fevzi Çakmak": true,
      "Giraylar": true,
      "Gökiçi": true,
      "Gözekaya": true,
      "Gözlü": true,
      "Gülerce": true,
      "Güneştepe": true,
      "Güzelyurt": true,
      "Hançerli": true,
      "Hendekköy": true,
      "Hilar": true,
      "İncehıdır": true,
      "İstasyon": true,
      "Karaburçak": true,
      "Karpuzlu": true,
      "Karşıbağlar": true,
      "Kavaklı": true,
      "Kavurmaküpü": true,
      "Kayan": true,
      "Kemaliye": true,
      "Kemertaş": true,
      "Kesentaş": true,
      "Kıralan": true,
      "Kocaali": true,
      "Kortaş": true,
      "Koyunalan": true,
      "Kömürtaş": true,
      "Kumçi": true,
      "Makam Dağı": true,
      "Morkoyun": true,
      "Namık Kemal": true,
      "Olgun": true,
      "Ortaağaç": true,
      "Ortayazı": true,
      "Otluca": true,
      "Özbilek": true,
      "Pamukpınar": true,
      "Pınarkaya": true,
      "Sabırlı": true,
      "Salihli": true,
      "Sallar": true,
      "Sallıca": true,
      "Sanayi": true,
      "Saray": true,
      "Savaş": true,
      "Selmanköy": true,
      "Sökündüzü": true,
      "Şirinevler": true,
      "Şölen": true,
      "Tevekli": true,
      "Usluca": true,
      "Üçkardeş": true,
      "Üzümlü": true,
      "Yakacık": true,
      "Yamaçlar": true,
      "Yapraklı": true,
      "Yayvantepe": true,
      "Yeniköy": true,
      "Yeşilköy": true,
      "Yolbulan": true,
      "Yolköprü": true,
      "Yoncalı": true,
      "Yukarıbitikçi": true,
      "Yukarıkarpuzlu": true,
      "Yukarıkuyulu": true,
      "Ziyaret": true
    },
    "Hani": {
      "Abacılar": true,
      "Akçayurt": true,
      "Anıl": true,
      "Belen": true,
      "Çardaklı": true,
      "Çarşı": true,
      "Çukurköy": true,
      "Dereli": true,
      "Gömeç": true,
      "Gürbüz": true,
      "Kalaba": true,
      "Kaledibi": true,
      "Kırım": true,
      "Kuyular": true,
      "Merkez": true,
      "Okurköy": true,
      "Serenköy": true,
      "Sergen": true,
      "Soylu": true,
      "Süslü": true,
      "Topçular": true,
      "Uzunlar": true,
      "Veziri": true,
      "Yayvan": true,
      "Yukarıturalı": true,
      "Zirve": true
    },
    "Hazro": {
      "Ağartı": true,
      "Bağyurdu": true,
      "Bahçe": true,
      "Bayırdüzü": true,
      "Cami": true,
      "Çitlibahçe": true,
      "Çökeksu": true,
      "Dadaş": true,
      "Elhuvan": true,
      "Gedikalan": true,
      "Gözlü": true,
      "Hürriyet": true,
      "İncekavak": true,
      "İşkar": true,
      "Kavaklıboğaz": true,
      "Kırkkaşık": true,
      "Kırmataş": true,
      "Koçbaba": true,
      "Kulaçtepe": true,
      "Meşebağları": true,
      "Mutluca": true,
      "Ormankaya": true,
      "Reşik": true,
      "Sarıçanak": true,
      "Sarıerik": true,
      "Terdöken": true,
      "Topalan": true,
      "Uzunargıt": true,
      "Ülgen": true,
      "Varınca": true,
      "Yazgı": true
    },
    "Kayapınar": {
      "Avcısuyu": true,
      "Barış": true,
      "Baykara": true,
      "Beneklitaş": true,
      "Cankatran": true,
      "Cumhuriyet": true,
      "Cücük": true,
      "Çölgüzeli": true,
      "Diclekent": true,
      "Esentepe": true,
      "Fırat": true,
      "Gözalan": true,
      "Gözegöl": true,
      "Güleçoba": true,
      "Harmanardı": true,
      "Hatipoğlu": true,
      "Huzurevleri": true,
      "Kaldırım": true,
      "Karayakup": true,
      "Keklik": true,
      "Kırkpınar": true,
      "Medya": true,
      "Mezopotamya": true,
      "Petek": true,
      "Peyas": true,
      "Sağkulak": true,
      "Sultantepe": true,
      "Taban": true,
      "Talaytepe": true,
      "Tişo": true,
      "Tosunlu": true,
      "Uyandık": true,
      "Yeniözerli": true,
      "Yolboyu Pirinçlik": true
    },
    "Kocaköy": {
      "Ambar": true,
      "Arkbaşı": true,
      "Boyunlu": true,
      "Bozbağlar": true,
      "Bozyer": true,
      "Çakmaklı": true,
      "Çayırlı": true,
      "Çaytepe": true,
      "Eyüpler": true,
      "Gökçen": true,
      "Gözebaşı": true,
      "Günalan": true,
      "Hacı Reşit": true,
      "Kaya": true,
      "Kokulupınar": true,
      "Suçıktı": true,
      "Şaklat": true,
      "Şerifoğulları": true,
      "Şeyh Şerafettin": true,
      "Tepecik": true,
      "Yazıköy": true,
      "Yenişehir": true
    },
    "Kulp": {
      "Ağaçkorur": true,
      "Ağaçlı": true,
      "Ağıllı": true,
      "Akbulak": true,
      "Akçesir": true,
      "Akdoruk": true,
      "Alaca": true,
      "Argün": true,
      "Aygün": true,
      "Ayhan": true,
      "Bağcılar": true,
      "Baloğlu": true,
      "Barın": true,
      "Başbuğ": true,
      "Bayır": true,
      "Çağlayan": true,
      "Çukurca": true,
      "Demirli": true,
      "Dolun": true,
      "Düzce": true,
      "Elmalı": true,
      "Güleç": true,
      "Güllük": true,
      "Hamzalı": true,
      "İnkaya": true,
      "İslamköy": true,
      "Kamışlı": true,
      "Karaağaç": true,
      "Karabulak": true,
      "Karaorman": true,
      "Karpuzlu": true,
      "Kayacık": true,
      "Kayahan": true,
      "Kaynak": true,
      "Koçkar": true,
      "Konuklu": true,
      "Kurudere": true,
      "Merkez Eski": true,
      "Merkez Yeni": true,
      "Narlıca": true,
      "Özbek": true,
      "Salkımlı": true,
      "Saltuk": true,
      "Taşköprü": true,
      "Temran": true,
      "Tepecik": true,
      "Turgut Özal": true,
      "Tuzla": true,
      "Uygur": true,
      "Uzunova": true,
      "Üçkuyu": true,
      "Ünal": true,
      "Yakıt": true,
      "Yayık": true,
      "Yaylak": true,
      "Yeşilköy": true,
      "Yuvacık": true,
      "Zeyrek": true
    },
    "Lice": {
      "Abalı": true,
      "Akçabudak": true,
      "Arıklı": true,
      "Bağlan": true,
      "Baharlar": true,
      "Bayırlı": true,
      "Birlik": true,
      "Budak": true,
      "Camikebir": true,
      "Çağdaş": true,
      "Çarşı": true,
      "Çavundur": true,
      "Çeper": true,
      "Çıralı": true,
      "Dallıca": true,
      "Damar": true,
      "Daralan": true,
      "Delvan": true,
      "Dernek": true,
      "Dibek": true,
      "Dolunay": true,
      "Duru": true,
      "Ecemiş": true,
      "Ergin": true,
      "Esenler": true,
      "Gökçe": true,
      "Güçlü": true,
      "Güldiken": true,
      "Gürbeyli": true,
      "Hedik": true,
      "Kabakaya": true,
      "Kali": true,
      "Karahasan": true,
      "Kelvan": true,
      "Kılıçlı": true,
      "Kıpçak": true,
      "Kıralan": true,
      "Kıyı": true,
      "Körtük": true,
      "Kumluca": true,
      "Kutlu": true,
      "Mulla": true,
      "Muradiye": true,
      "Müminağa": true,
      "Ortaç": true,
      "Oyuklu": true,
      "Örtülü": true,
      "Savat": true,
      "Saydamlı": true,
      "Serin": true,
      "Sığınak": true,
      "Şaar": true,
      "Şenlik": true,
      "Tepe": true,
      "Tuzla": true,
      "Türeli": true,
      "Uçarlı": true,
      "Ulucak": true,
      "Üçdamlar": true,
      "Yalaza": true,
      "Yalımlı": true,
      "Yamaçlı": true,
      "Yaprak": true,
      "Yenişehir": true,
      "Yeşilburç": true,
      "Yolçatı": true,
      "Yorulmaz": true,
      "Yünlüce": true,
      "Ziyaret": true,
      "Zümrüt": true
    },
    "Silvan": {
      "Akçayır": true,
      "Akçeltik": true,
      "Akdere": true,
      "Akyol": true,
      "Alibey": true,
      "Altınkum": true,
      "Arı": true,
      "Aşağıkaya": true,
      "Aşağıveysi": true,
      "Babakaya": true,
      "Bağdere": true,
      "Bağlar": true,
      "Bahçe": true,
      "Bahçelievler": true,
      "Başdeğirmen": true,
      "Başıbüyük": true,
      "Bayrambaşı": true,
      "Bellibahçe": true,
      "Bereketli": true,
      "Beypınar": true,
      "Boyunlu": true,
      "Camii": true,
      "Çakıltaşı": true,
      "Çaldere": true,
      "Çardak": true,
      "Çevriksu": true,
      "Çiğdemli": true,
      "Çiğil": true,
      "Çobantepe": true,
      "Dağcılar": true,
      "Darköprü": true,
      "Demirkuyu": true,
      "Dolapdere": true,
      "Doluçanak": true,
      "Duru": true,
      "Düzalan": true,
      "Erikyazı": true,
      "Eskiköy": true,
      "Eskiocak": true,
      "Eşme": true,
      "Feridun": true,
      "Gökçetevek": true,
      "Görentepe": true,
      "Görmez": true,
      "Güçlü": true,
      "Gündüz": true,
      "Gürpınar": true,
      "Güzderesi": true,
      "Heybelikonak": true,
      "İncesu": true,
      "Kale": true,
      "Karacalar": true,
      "Karahacı": true,
      "Karamus": true,
      "Kasımlı": true,
      "Kayadere": true,
      "Kazandağı": true,
      "Keklikdere": true,
      "Kıraçtepe": true,
      "Kızlal": true,
      "Konak": true,
      "Kumgölü": true,
      "Kumluk": true,
      "Kutlualan": true,
      "Malabadi": true,
      "Mescit": true,
      "Nohuttepe": true,
      "Onbaşılar": true,
      "Ormandışı": true,
      "Otluk": true,
      "Sağlık": true,
      "Sarıbuğday": true,
      "Selahattin": true,
      "Sulak": true,
      "Sulubağ": true,
      "Susuz": true,
      "Şanlı": true,
      "Taşpınar": true,
      "Tekel": true,
      "Tokluca": true,
      "Umur": true,
      "Üçbasamak": true,
      "Yenidoğan": true,
      "Yeniköy": true,
      "Yenişehir": true,
      "Yeşerdi": true,
      "Yeşilbahçe": true,
      "Yeşilköy": true,
      "Yolaç": true,
      "Yolarası": true,
      "Yukarıveysi": true,
      "Yuva": true,
      "Yüksek": true
    },
    "Sur": {
      "Abdaldede": true,
      "Ağaçlıdere": true,
      "Alabal": true,
      "Alcık": true,
      "Ali Paşa": true,
      "Alibardak": true,
      "Arpaderesi": true,
      "Bağıvar": true,
      "Bağpınar": true,
      "Bahçecik": true,
      "Baroğlu": true,
      "Beybulak": true,
      "Bostanpınar": true,
      "Bozdemir": true,
      "Büyükakören": true,
      "Büyükkadı": true,
      "Cami Kebir": true,
      "Cami Nebi": true,
      "Cemal Yılmaz": true,
      "Cevat Paşa": true,
      "Çarıklı": true,
      "Çataksu": true,
      "Çelikli": true,
      "Çubuklu": true,
      "Dabanoğlu": true,
      "Dervişhasan": true,
      "Doğanlı": true,
      "Doğu Çanakçı": true,
      "Dumrul": true,
      "Erimli": true,
      "Eryolu": true,
      "Esenbağ": true,
      "Fatihpaşa": true,
      "Fetih": true,
      "Fidanlar": true,
      "Gencan": true,
      "Gölpınar": true,
      "Gültepe": true,
      "Hacıosman": true,
      "Harmanlar": true,
      "Hasırlı": true,
      "Havacılar": true,
      "Hızır Ilyas": true,
      "İskenderpaşa": true,
      "Kabasakal": true,
      "Kapaklıpınar": true,
      "Karabaş": true,
      "Karacaören": true,
      "Karaçalı": true,
      "Karaçimen": true,
      "Kardeşler": true,
      "Karpuzlu": true,
      "Karpuztepe": true,
      "Kartaltepe": true,
      "Kavaklıbağ": true,
      "Kayayolu": true,
      "Kengerli": true,
      "Kervanpınar": true,
      "Kırmasırt": true,
      "Konacık": true,
      "Koyungüden": true,
      "Kozan": true,
      "Köprübaşı": true,
      "Köşk": true,
      "Kumluçat": true,
      "Kumrucak": true,
      "Kuşburnu": true,
      "Kuşlukbağı": true,
      "Küçükakören": true,
      "Küçükkadı": true,
      "Lalebey": true,
      "Melikahmet": true,
      "Mermer": true,
      "Mermeri": true,
      "Nefirtaş": true,
      "Özekli": true,
      "Pınardüzü": true,
      "Sağdıçlı": true,
      "Sapanca": true,
      "Sarıkamış": true,
      "Sarılar": true,
      "Sarıyazma": true,
      "Sati": true,
      "Savaş": true,
      "Sayarlar": true,
      "Soğanlı": true,
      "Süleyman Nazif": true,
      "Süngüler": true,
      "Tanoğlu": true,
      "Tezgeçer": true,
      "Yarımca": true,
      "Yenice": true,
      "Yenidoğan": true,
      "Yenievler": true,
      "Yeşilköy": true,
      "Yeşilli": true,
      "Yiğitçavuş": true,
      "Yukarıkılıçtaşı": true,
      "Ziya Gökalp": true,
      "Ziyaret": true
    },
    "Yenişehir": {
      "Al": true,
      "Alangör": true,
      "Alpu": true,
      "Aziziye": true,
      "Bahçelievler": true,
      "Başil": true,
      "Bozek": true,
      "Cumhuriyet": true,
      "Çakmak": true,
      "Çelikevler": true,
      "Çimenler": true,
      "Dicle": true,
      "Dikentepe": true,
      "Dokuzçeltik": true,
      "Dökmetaş": true,
      "Dönümlü": true,
      "Ekinciler": true,
      "Elidolu": true,
      "Eser": true,
      "Fabrika": true,
      "Ferit Köşk": true,
      "Geyiktepe": true,
      "Gürdoğan": true,
      "Güvendere": true,
      "Güvercinlik": true,
      "Güzelköy": true,
      "Hantepe": true,
      "İlbaş": true,
      "Kesikağaç": true,
      "Kooperatifler": true,
      "Sancar": true,
      "Sarıyatak": true,
      "Seyrantepe Sanayi": true,
      "Sivritepe": true,
      "Şehitlik": true,
      "Tanışık": true,
      "Üçkuyu": true,
      "Yaytaş": true,
      "Yenişehir": true,
      "Yolaltı": true,
      "Yukarı Nasırlar": true,
      "Yüksek": true
    }
  },
  "Düzce": {
    "Akçakoca": {
      "Ayazlı": true,
      "Cumhuriyet": true,
      "Hacı Yusuflar": true,
      "Orhangazi": true,
      "Osmaniye": true,
      "Yalı": true,
      "Yeni": true,
      "Yukarı": true
    },
    "Cumayeri": {
      "Çevrik": true,
      "Mehmet Akif": true,
      "Orta": true,
      "Yaka": true,
      "Yeni": true
    },
    "Çilimli": {
      "Arabacı": true,
      "Döngelli": true,
      "Mahirağa": true,
      "Şerefiye": true,
      "Topçular": true,
      "Ulucami": true,
      "Yeşil": true,
      "Yeşiltepe": true
    },
    "Gölyaka": {
      "Açma": true,
      "Cumakırı": true,
      "Esen": true,
      "Fatih": true,
      "İçmeler": true,
      "İmamlar": true,
      "Kuyudüzü": true,
      "Kültür": true,
      "Yazıpınar": true,
      "Yazlık": true,
      "Yeni": true,
      "Yeşil": true
    },
    "Gümüşova": {
      "Fatih": true,
      "Hacılar": true,
      "Kışla": true,
      "Kültür": true,
      "Merkez": true,
      "Yeni": true
    },
    "Kaynaşlı": {
      "Çele": true,
      "Eskiköy": true,
      "Karaçalı": true,
      "Kumluca": true,
      "Merkez": true,
      "Sarıyer": true,
      "Şimşir": true
    },
    "Merkez": {
      "Ağaköyü": true,
      "Akınlar": true,
      "Akpınar": true,
      "Akyazı": true,
      "Arapçiftliği": true,
      "Aziziye": true,
      "Azmimilli": true,
      "Bahçelievler": true,
      "Ballar": true,
      "Beyciler": true,
      "Beytepe": true,
      "Burhaniye": true,
      "Camikebir": true,
      "Cedidiye": true,
      "Cumhuriyet": true,
      "Çakırlar": true,
      "Çamköy": true,
      "Çamlıevler": true,
      "Çavuşlar": true,
      "Çay": true,
      "Çayırtarla": true,
      "Çiftepınarlar": true,
      "Darıcı": true,
      "Dedeler": true,
      "Değirmenbaşı": true,
      "Demetevler": true,
      "Derelitütüncü": true,
      "Dokuzpınar": true,
      "Esentepe": true,
      "Fatih": true,
      "Fevziçakmak": true,
      "Gökçe": true,
      "Güzelbahçe": true,
      "Hamidiye": true,
      "İstiklal": true,
      "Kabalak": true,
      "Karaca": true,
      "Karaca Hacımusa": true,
      "Kazukoğlu": true,
      "Kirazlı": true,
      "Kiremitocağı": true,
      "Koçyazı": true,
      "Körpeşler": true,
      "Kuyumcuhacıali": true,
      "Kültür": true,
      "Mamure": true,
      "Mergiç": true,
      "Nalbantoğlu": true,
      "Nusrettin": true,
      "Orhangazi": true,
      "Otluoğlu": true,
      "Ozanlar": true,
      "Sallar": true,
      "Sancaklar": true,
      "Sarayyeri": true,
      "Soğukpınar": true,
      "Şehit Bayram Gökmen": true,
      "Şehit Hüseyin Kıl": true,
      "Şehit Kemal Işıldak": true,
      "Şehit Murat Demir": true,
      "Şekerpınar": true,
      "Şerefiye": true,
      "Şıralık": true,
      "Taşköprü": true,
      "Terzialiler": true,
      "Tokuşlar": true,
      "Uzunmustafa": true,
      "Yahyalar": true,
      "Yazlık": true,
      "Yeni": true,
      "Yeşilköy": true,
      "Yeşiltepe": true,
      "Yukarı Yahyalar": true
    },
    "Yığılca": {
      "Ahmetçiler": true,
      "Atatürk": true,
      "Mareşal Fevzi Çakmak": true,
      "Orhangazi": true
    }
  },
  "Edirne": {
    "Enez": {
      "Çataltepe": true,
      "Gaziömerbey": true,
      "Yeni": true
    },
    "Havsa": {
      "Cumhuriyet": true,
      "Hacıgazi": true,
      "Hacıisa": true,
      "Helvacı": true,
      "Varoş": true,
      "Yeni": true
    },
    "İpsala": {
      "Atatürk": true,
      "Bayrambey": true,
      "Bozkurt": true,
      "Cumhuriyet": true,
      "Fatih": true,
      "Fevzi Çakmak": true,
      "Gazi": true,
      "İnönü": true,
      "Kapucu": true,
      "Köprü": true,
      "Kurtuluş": true,
      "Saraç Ilyas": true
    },
    "Keşan": {
      "Aşağı Zaferiye": true,
      "Atatürk": true,
      "Aydoğan": true,
      "Beykent": true,
      "Büyük Cami": true,
      "Cumhuriyet": true,
      "İnönü": true,
      "İspat Cami": true,
      "İstasyon": true,
      "İstiklal": true,
      "İzzetiye": true,
      "Kemalpaşa": true,
      "Mustafa Kemal Paşa": true,
      "Paşayiğit": true,
      "Yeni": true,
      "Yenimescit": true,
      "Yukarı Zaferiye": true
    },
    "Lalapaşa": {
      "Merkez": true
    },
    "Meriç": {
      "B.doğanca": true,
      "Gazi": true,
      "İzzet Paşa": true,
      "K. Doğanca": true,
      "Merkez": true,
      "Şehit Mehmet Aydın": true
    },
    "Merkez": {
      "1.murat": true,
      "100. Yıl": true,
      "Abdurrahman": true,
      "Atatürk": true,
      "Babademirtaş": true,
      "Barutluk": true,
      "Cumhuriyet": true,
      "Çavuşbey": true,
      "Dilaverbey": true,
      "Fatih": true,
      "İstasyon": true,
      "Karaağaç": true,
      "Koca Sinan": true,
      "Kurtuluş": true,
      "Medrese Ali Bey": true,
      "Menzilahır": true,
      "Meydan": true,
      "Mithat Paşa": true,
      "Nişancıpaşa": true,
      "Sabuni": true,
      "Sarıcapaşa": true,
      "Şükrüpaşa": true,
      "Talatpaşa": true,
      "Umurbey": true,
      "Yancıkçı Şahin": true,
      "Yeniimaret": true,
      "Yıldırım Beyazıt": true,
      "Yıldırım Hacı Sarraf": true
    },
    "Süloğlu": {
      "Cumhuriyet": true,
      "Merkez": true,
      "Şafak": true,
      "Yeni": true
    },
    "Uzunköprü": {
      "Aşçıoğlu": true,
      "Atatürk": true,
      "Balaban": true,
      "Büyük Şehsuvarbey": true,
      "Cumhuriyet": true,
      "Çöpköy": true,
      "Demirtaş": true,
      "Habib Hoca": true,
      "Halise Hatun": true,
      "İstiklal": true,
      "Kavak": true,
      "Küçük Şehsuvarbey": true,
      "Mareşal Fevzi Çakmak": true,
      "Mescit": true,
      "Muradiye": true,
      "Muradiye Cami": true,
      "Okullar": true,
      "Rızaefendi": true,
      "Yeniköy": true
    }
  },
  "Elazığ": {
    "Ağın": {
      "Akpınar": true,
      "Başpınar": true,
      "Merkez": true,
      "Şenpınar": true
    },
    "Alacakaya": {
      "Altınçanak": true,
      "Altıoluk": true,
      "Gülaman": true,
      "Gündoğdu": true,
      "Merkez": true,
      "Sularbaşı": true
    },
    "Arıcak": {
      "Bölükbaşı": true,
      "Cami": true,
      "Cumhuriyet": true,
      "Çay": true,
      "Güleç": true,
      "Gümüşyaka": true,
      "Güvenevler": true,
      "Haberci": true,
      "Halil Yavuz": true,
      "Hürriyet": true,
      "Kaplanbağ": true,
      "Kışla": true,
      "Kutlu Düğün": true,
      "Merkez": true,
      "Mustafa Çelebi": true,
      "Pınarbaşı": true,
      "Saman": true,
      "Serinevler": true,
      "Simserkis": true,
      "Vali Göktayoğlu": true,
      "Yaylabaşı": true,
      "Zeynet": true,
      "Ziyaret": true
    },
    "Baskil": {
      "Canbeyler": true,
      "Cumhuriyet": true,
      "Eskibaskil": true,
      "Mustafa Demirel": true,
      "Odabaşı": true,
      "Şefkat": true
    },
    "Karakoçan": {
      "Bahçelievler": true,
      "Gölpınar": true,
      "Gölyaylası": true,
      "Karşıyaka": true,
      "Kırkpınar": true,
      "Kulubaba": true,
      "Subaşı": true,
      "Tepe": true,
      "Yeni": true
    },
    "Keban": {
      "Baraj": true,
      "Değirmenbaşı": true,
      "Fırat": true,
      "Kallar": true
    },
    "Kovancılar": {
      "Bağlar": true,
      "Bahçelievler": true,
      "Çarşı Başı": true,
      "Çay Başı": true,
      "Fatih": true,
      "Gültepe": true,
      "Heybet": true,
      "İsmet Paşa": true,
      "Kapıaçmaz": true,
      "Karacimşit": true,
      "Toki": true,
      "Tuna": true,
      "Yeni": true
    },
    "Maden": {
      "Bahçelievler": true,
      "Camii Kebir": true
    },
    "Merkez": {
      "Abdullah Paşa": true,
      "Akmezra Sahil Önü": true,
      "Akpınar": true,
      "Aksaray": true,
      "Ala Yaprak": true,
      "Aşağıdemirtaş": true,
      "Ataşehir": true,
      "Bağlar": true,
      "Bahçekapı": true,
      "Cumhuriyet": true,
      "Çarşı": true,
      "Çatal Çeşme": true,
      "Çaydaçıra": true,
      "Doğu Kent": true,
      "Esen Tepe": true,
      "Fatih": true,
      "Fevzi Çakmak": true,
      "Göllü Bağ": true,
      "Gülpınar": true,
      "Gümüş Kavak": true,
      "Güneykent": true,
      "Güntaşı": true,
      "Hankendi": true,
      "Harput": true,
      "Hicret": true,
      "Hilalkent": true,
      "Hürriyet": true,
      "İcadiye": true,
      "İzzet Paşa": true,
      "Karşıbağ": true,
      "Karşıyaka": true,
      "Kıraç": true,
      "Kırklar": true,
      "Kızılay": true,
      "Konak": true,
      "Kültür": true,
      "Merkez": true,
      "Mollakendi": true,
      "Mustafa Paşa": true,
      "Nail Bey": true,
      "Olgunlar": true,
      "Org. Eşref Bitlis": true,
      "Paşalar": true,
      "Rızaiye": true,
      "Rüstem Paşa": true,
      "Safran": true,
      "Salı Baba": true,
      "Sanayi": true,
      "Sarayatik": true,
      "Sugözü": true,
      "Sürsürü": true,
      "Şahinkaya": true,
      "Ulu Kent": true,
      "Üniversite": true,
      "Yemişlik": true,
      "Yeni": true,
      "Yeni Bağlar": true,
      "Yenice": true,
      "Yeşilkuşak": true,
      "Yeşilyurt": true,
      "Yıldız Bağları": true,
      "Yüzbaşı": true,
      "Zafer": true
    },
    "Palu": {
      "Aşağı": true,
      "Cumhuriyet": true,
      "Çarşı": true,
      "Esentepe": true,
      "Girne": true,
      "Güney": true,
      "İstasyon": true,
      "Kalekent": true,
      "Karşıbahçeler": true,
      "Karşıyaka": true,
      "Kültür": true,
      "Numune": true,
      "Yenimahalle": true,
      "Yukarı Palu": true
    },
    "Sivrice": {
      "Akpınar": true,
      "Gölbaşı": true,
      "Hazar": true,
      "Karaçalı": true,
      "Kültür": true,
      "Olgunlar": true,
      "Sanayi": true
    }
  },
  "Erzincan": {
    "Çayırlı": {
      "Atatürk": true,
      "Barbaros": true,
      "Fatih": true
    },
    "İliç": {
      "Abdullah Paşa": true,
      "Fatih": true,
      "İbrahim Çeçen": true,
      "Kazım Karabekir": true
    },
    "Kemah": {
      "Aşağıgedik": true,
      "Beklimçay": true,
      "Cirgişin": true,
      "Çarşı": true,
      "Göğüsbağı": true,
      "Karşıbağ": true,
      "Mektepönü": true,
      "Ortagedik": true,
      "Pörhenkbaşı": true,
      "Yukarı": true
    },
    "Kemaliye": {
      "Ariki": true,
      "Bahçe": true,
      "Dörtyolağzı": true,
      "Esertepe": true,
      "Gençağa": true,
      "Hacı Yusuf": true,
      "Halilağa": true,
      "İshakpaşa": true,
      "Naip": true,
      "Sandıkbağı": true,
      "Taşdibi": true
    },
    "Merkez": {
      "Akşemsettin": true,
      "Aktoprak": true,
      "Akyazı": true,
      "Alsancak": true,
      "Arslanlı": true,
      "Atatürk": true,
      "Aziz Baba": true,
      "Bahçelievler": true,
      "Barbaros": true,
      "Barış": true,
      "Başbağlar": true,
      "Başpınar": true,
      "Bayrak": true,
      "Bozyazı": true,
      "Buğdaylı": true,
      "Bulutlu": true,
      "Büyükçakırman": true,
      "Cemal Gürsel": true,
      "Cumhuriyet": true,
      "Çarşı": true,
      "Çukurkuyu": true,
      "Davarlı": true,
      "Demetevler": true,
      "Demirkent": true,
      "Derebağ": true,
      "Dereyurt": true,
      "Erdene": true,
      "Ergenekon": true,
      "Ersevenler": true,
      "Ertuğrul Gazi": true,
      "Esentepe": true,
      "Fatih": true,
      "Gazi": true,
      "Gölcük": true,
      "Gülabibey": true,
      "Güllüce": true,
      "Halitpaşa": true,
      "Hamidiye": true,
      "Hancı": true,
      "Hoca Ahmet Yesevi": true,
      "Hocabey": true,
      "Hürrempalangası": true,
      "Işıkpınar": true,
      "İnönü": true,
      "İzzetpaşa": true,
      "Karaağaç": true,
      "Kavakyolu": true,
      "Kazım Karabekir": true,
      "Keklikkayası": true,
      "Kızılay": true,
      "Kurutilek": true,
      "Mahmutlu": true,
      "Menderes": true,
      "Mengüceli": true,
      "Mertekli": true,
      "Mimar Sinan": true,
      "Munzur": true,
      "Mustafa Kemal Paşa": true,
      "Osman Gazi": true,
      "Osmanlı": true,
      "Özgürlük": true,
      "Paşa": true,
      "Sancak": true,
      "Sarıgöl": true,
      "Selçuklu": true,
      "Şehit Cengiz Topel": true,
      "Şehit Serhat Yurtbaşı": true,
      "Şehitserhat": true,
      "Şelale": true,
      "Taksim": true,
      "Tepecik": true,
      "Terzibaba": true,
      "Ulalar": true,
      "Üçkonak": true,
      "Yalnızbağ": true,
      "Yamaçlı": true,
      "Yavuz Selim": true,
      "Yenidoğan": true,
      "Yenimahalle": true,
      "Yeşilyurt": true,
      "Yunus Emre": true
    },
    "Otlukbeli": {
      "Fatih": true,
      "Mehmet Akif Ersoy": true,
      "Şehitler": true
    },
    "Refahiye": {
      "Binali Yıldırım": true,
      "Camiişerif": true,
      "Hakoğlu": true,
      "Hökümet": true,
      "Yenidoğan": true
    },
    "Tercan": {
      "Ahmet Yesevi": true,
      "Akşemsettin": true,
      "Atatürk": true,
      "Camii Kebir": true,
      "Camii Şerif": true,
      "Fatih": true,
      "Gözeler": true,
      "İstasyon": true,
      "Kazım Karabekir": true,
      "Mamahatun": true,
      "Sucuali": true,
      "Şehit Ahmet Aytekin": true,
      "Yavuz Selim": true,
      "Yeni": true,
      "Yollarüstü": true
    },
    "Üzümlü": {
      "Babacan": true,
      "Bahçeşehir": true,
      "Büyük Kadağan": true,
      "Ciminli Baba": true,
      "Çavuşlu": true,
      "Çay": true,
      "Fatih": true,
      "Fırat": true,
      "Geyikli": true,
      "İstasyon": true,
      "Küçük Kadağan": true,
      "Mimar Sinan": true,
      "Muhsin Yazıcıoğlu": true,
      "Oruçlu": true,
      "Pınarbaşı": true,
      "Piri Sami": true,
      "Süleymanlı": true,
      "Terzibaba": true,
      "Üçler": true,
      "Yavuz Selim": true,
      "Yunus Emre": true
    }
  },
  "Erzurum": {
    "Aşkale": {
      "Abdalcık": true,
      "Akören": true,
      "Altıntaş": true,
      "Bahçelievler": true,
      "Ballıtaş": true,
      "Bozburun": true,
      "Büyükgeçit": true,
      "Cahit Aybar": true,
      "Çarşı": true,
      "Çatalbayır": true,
      "Çayköy": true,
      "Çiftlik": true,
      "Çiftlik Bucağı Çatören": true,
      "Dağyurdu": true,
      "Dallı": true,
      "Demirkıran": true,
      "Dereköy": true,
      "Düzyurt": true,
      "Emek": true,
      "Esentepe": true,
      "Eyüpoğlu": true,
      "Gökçebük": true,
      "Güllüdere": true,
      "Gümüşseren": true,
      "Güneyçam": true,
      "Gürkaynak": true,
      "Hacıbekir": true,
      "Hacıhamza": true,
      "Hacımahmut": true,
      "Hatuncuk": true,
      "Haydarhacı": true,
      "İstasyon": true,
      "Kandilli": true,
      "Kapıkale": true,
      "Karahasan": true,
      "Karasu": true,
      "Kavurmaçukuru": true,
      "Kıbrıs": true,
      "Koçbaba": true,
      "Koşapınar": true,
      "Kurtmahmut": true,
      "Küçükgeçit": true,
      "Küçükova": true,
      "Kükürtlü": true,
      "Merdivenköy": true,
      "Merkez Bucağı Çatören": true,
      "Merkez Bucağı Gölören": true,
      "Meydan": true,
      "Mezrea": true,
      "Musatanışman": true,
      "Nahiye Gölören": true,
      "Ocaklı": true,
      "Ovacık": true,
      "Özler": true,
      "Pırnakaban": true,
      "Saptıran": true,
      "Sarıbaba": true,
      "Sazlı": true,
      "Şafak": true,
      "Taşağıl": true,
      "Taşlıçayır": true,
      "Tecer": true,
      "Tepsicik": true,
      "Tokça": true,
      "Topalçavuş": true,
      "Tosunlu": true,
      "Tozluca": true,
      "Turaç": true,
      "Üç Mart": true,
      "Yaylaköy": true,
      "Yaylayolu": true,
      "Yaylımlı": true,
      "Yeni": true,
      "Yeniköy Halitpaşa": true,
      "Yeşilova": true,
      "Yumruveren": true
    },
    "Aziziye": {
      "Adaçay": true,
      "Ağcakent": true,
      "Ağören": true,
      "Ahırcık": true,
      "Akdağ": true,
      "Akyazı": true,
      "Alaca": true,
      "Alaybeyi": true,
      "Aşağı Yenice": true,
      "Aşağıcanören": true,
      "Atlıkonak": true,
      "Aynalıkale": true,
      "Başçakmak": true,
      "Başkent": true,
      "Başkurtdere": true,
      "Başovacık": true,
      "Beypınarı": true,
      "Bingöze": true,
      "Çamlıca": true,
      "Çatak": true,
      "Çavdarlı": true,
      "Çavuşoğlu": true,
      "Çıkrıklı": true,
      "Çiğdemli": true,
      "Dağdagül": true,
      "Demirgeçit": true,
      "Düztoprak": true,
      "Eğerti": true,
      "Elmalı": true,
      "Emrecik": true,
      "Eskipolat": true,
      "Eşkinkaya": true,
      "Gelinkaya": true,
      "Geyik": true,
      "Güllüce": true,
      "Halilkaya": true,
      "Ilıca": true,
      "Kabaktepe": true,
      "Kahramanlar": true,
      "Kapulu": true,
      "Karakale": true,
      "Kavaklıdere": true,
      "Kayapa": true,
      "Kızılkale": true,
      "Kumluyazı": true,
      "Kuşçu": true,
      "Kuzgun": true,
      "Kuzuluk": true,
      "Ocak": true,
      "Ömertepe": true,
      "Özbek": true,
      "Özbilen": true,
      "Paşayurdu": true,
      "Rizekent": true,
      "Sakalıkesik": true,
      "Saltuklu": true,
      "Sarıyayla": true,
      "Selçuklu": true,
      "Sırlı": true,
      "Sorkunlu": true,
      "Söğütlü": true,
      "Söğütlü (ovacık)": true,
      "Taşpınar": true,
      "Tebrizcik": true,
      "Tınazlı": true,
      "Toprakkale": true,
      "Üçköşe": true,
      "Yarımca": true,
      "Yeşilova": true,
      "Yeşilvadi": true,
      "Yoncalık": true,
      "Yukarıcanören": true
    },
    "Çat": {
      "Ağaköy": true,
      "Aşağıçat": true,
      "Babaderesi": true,
      "Bağlıca": true,
      "Bardakçı": true,
      "Başköy": true,
      "Bayındır": true,
      "Bozyazı": true,
      "Budaklar": true,
      "Çayırtepe": true,
      "Çimenözü": true,
      "Çirişli": true,
      "Çukurçayır": true,
      "Değirmenli": true,
      "Elmapınar": true,
      "Göbekören": true,
      "Gökçeşeyh": true,
      "Gölköy": true,
      "Hatunköy": true,
      "İşkinli": true,
      "Kaplıca": true,
      "Karabey": true,
      "Karaca": true,
      "Karaşeyh": true,
      "Kızılca": true,
      "Köseler": true,
      "Kumaşlı": true,
      "Kurbanlı": true,
      "Mollaömer": true,
      "Muratçayırı": true,
      "Oyuklu": true,
      "Parmaksız": true,
      "Saltaş": true,
      "Sarıkaşık": true,
      "Sarıkaya": true,
      "Soğukpınar": true,
      "Söbeçayır": true,
      "Şeyhhasan": true,
      "Taşağıl": true,
      "Tuzlataşı": true,
      "Tuzluca": true,
      "Yarmak": true,
      "Yavi": true,
      "Yaylasuyu": true,
      "Yukarıçat": true
    },
    "Hınıs": {
      "Acarköy": true,
      "Akbayır": true,
      "Akçamelik": true,
      "Akgelin": true,
      "Akgöze": true,
      "Akören": true,
      "Alaca": true,
      "Alagöz": true,
      "Alınteri": true,
      "Alikırı Abdalan": true,
      "Altınpınar": true,
      "Arpaderesi": true,
      "Aşağıkayabaşı": true,
      "Avcılar": true,
      "Bahçe": true,
      "Başköy": true,
      "Bayırköy": true,
      "Bellitaş": true,
      "Beyyurdu": true,
      "Burhanköy": true,
      "Çakmak": true,
      "Çamurlu": true,
      "Çatak": true,
      "Çilligöl": true,
      "Dağçayırı": true,
      "Demirci": true,
      "Derince": true,
      "Dervişali": true,
      "Dibekli": true,
      "Dikili": true,
      "Divanhüseyin": true,
      "Elmadalı": true,
      "Erbeyli": true,
      "Erduran": true,
      "Erence": true,
      "Esenli": true,
      "Göller": true,
      "Gülistan": true,
      "Güllüçimen": true,
      "Gürçayır": true,
      "Güzeldere": true,
      "Halilçavuş": true,
      "Hayran": true,
      "Ilıcaköy": true,
      "İsmail": true,
      "Kalecik": true,
      "Karaağaç": true,
      "Karabudak": true,
      "Karakula": true,
      "Karamolla": true,
      "Kazancı": true,
      "Ketenci": true,
      "Kısık": true,
      "Kızılahmet": true,
      "Kızmusa": true,
      "Kolhisar": true,
      "Kongur": true,
      "Köprübaşı": true,
      "Meydanköy": true,
      "Mezra": true,
      "Mollacelil": true,
      "Mollakulaç": true,
      "Mutluca": true,
      "Ortaköy": true,
      "Ovaçevirme": true,
      "Ovakozlu": true,
      "Parmaksız": true,
      "Pınarbaşı": true,
      "Pınarköy": true,
      "Saltepe": true,
      "Sanayi": true,
      "Sarılı": true,
      "Sıldız": true,
      "Söğütlü": true,
      "Sultanlı": true,
      "Suvaran": true,
      "Şahabettinköy": true,
      "Şahverdi": true,
      "Şalgamköy": true,
      "Tanır": true,
      "Tapuköy": true,
      "Taşbudak": true,
      "Tellitepe": true,
      "Tipideresi": true,
      "Toprakkale": true,
      "Toraman": true,
      "Uluçayır": true,
      "Uyanık": true,
      "Ünlüce": true,
      "Yamanlar": true,
      "Yaylakonak": true,
      "Yelpiz": true,
      "Yenikent": true,
      "Yeniköy": true,
      "Yeşilbahçe": true,
      "Yeşilyazı": true,
      "Yolüstü": true,
      "Yukarıkayabaşı": true
    },
    "Horasan": {
      "Adnan Menderes": true,
      "Ağıllı": true,
      "Akçataş": true,
      "Akçatoprak": true,
      "Alagöz": true,
      "Aliçeyrek": true,
      "Aras": true,
      "Ardı": true,
      "Arpaçayır": true,
      "Aşağıaktaş": true,
      "Aşağıbademözü": true,
      "Azap": true,
      "Bahçe": true,
      "Bulgurlu": true,
      "Camii Kebir": true,
      "Çamlıkale": true,
      "Çamurlu": true,
      "Çayırdüzü": true,
      "Çiftlik": true,
      "Dalbaşı": true,
      "Danişment": true,
      "Değirmenler": true,
      "Dikili": true,
      "Döllek": true,
      "Dönertaş": true,
      "Eğertaşlar": true,
      "Esentepe": true,
      "Fatih Sultan Mehmet": true,
      "Gerek": true,
      "Gündeğer": true,
      "Güzelyayla": true,
      "Hacıahmet": true,
      "Hacıhalil": true,
      "Harçlı": true,
      "Hasanbaba": true,
      "Hasanbey": true,
      "Haydarlı": true,
      "Hızardere": true,
      "Hızırilyas": true,
      "Iğırbığır": true,
      "İğdeli": true,
      "İncesu": true,
      "İnönü": true,
      "Kadıcelal": true,
      "Kalender": true,
      "Karabıyık": true,
      "Karacaören": true,
      "Karaçuha": true,
      "Karapınar": true,
      "Kaynarca": true,
      "Kazım Karabekir": true,
      "Kemerli": true,
      "Kepenek": true,
      "Kırık": true,
      "Kırkdikme": true,
      "Kırkgözeler": true,
      "Kırklar": true,
      "Kızılca": true,
      "Kızlarkale": true,
      "Küçükkonak": true,
      "Kükürtlü": true,
      "Mollaahmet": true,
      "Mollamelik": true,
      "Muratbağı": true,
      "Mümtaz Turan": true,
      "Pinarli": true,
      "Pirali": true,
      "Pirhasan": true,
      "Recep Tayyip Erdoğan": true,
      "Saçlık": true,
      "Sekman": true,
      "Şerefiye": true,
      "Şeyhyusuf": true,
      "Tahirhoca": true,
      "Tavşancık": true,
      "Teknecik": true,
      "Yarboğaz": true,
      "Yaylacık": true,
      "Yazılıtaş": true,
      "Yeşildere": true,
      "Yeşilöz": true,
      "Yıldıran": true,
      "Yukarıbademözü": true,
      "Yukarıhorum": true,
      "Yukarıtahirhoca": true,
      "Yürükatlı": true,
      "Yüzören": true
    },
    "İspir": {
      "Ahlatlı": true,
      "Akgüney": true,
      "Akpınar": true,
      "Akseki": true,
      "Aksu": true,
      "Aktaş": true,
      "Alacabük": true,
      "Araköy": true,
      "Ardıçlı": true,
      "Armutlu": true,
      "Aşağı Fındıklı": true,
      "Aşağı Özbağ": true,
      "Atürküten": true,
      "Avcıköy": true,
      "Bademli": true,
      "Bahçeli": true,
      "Başçeşme": true,
      "Başköy": true,
      "Başpınar": true,
      "Bostancı": true,
      "Bozan": true,
      "Cankurtaran": true,
      "Cibali": true,
      "Çakmaklı": true,
      "Çamlıca": true,
      "Çamlıkaya": true,
      "Çatakkaya": true,
      "Çayırbaşı": true,
      "Çayırözü": true,
      "Çiçekli": true,
      "Değirmendere": true,
      "Değirmenli": true,
      "Demirbilek": true,
      "Demirkaya": true,
      "Devedağı": true,
      "Duruköy": true,
      "Düzköy": true,
      "Elmalı": true,
      "Gaziler": true,
      "Geçitağzı": true,
      "Göçköy": true,
      "Gölyurt": true,
      "Gülhas": true,
      "Güllübağ": true,
      "Gündoğdu": true,
      "Güney": true,
      "Halilpaşa": true,
      "Irmakköy": true,
      "İkisu": true,
      "İncesu": true,
      "İyidere": true,
      "Karahan": true,
      "Karakale": true,
      "Karakamış": true,
      "Karakaya": true,
      "Karaseydi": true,
      "Karşıyaka": true,
      "Kavaklı": true,
      "Kaynakbaşı": true,
      "Kırık": true,
      "Kızılhasan": true,
      "Kirazlı": true,
      "Koç": true,
      "Köprüköy": true,
      "Kümetaş": true,
      "Leylekköy": true,
      "Madenköprübaşı": true,
      "Mescitli": true,
      "Meydanlı": true,
      "Moryayla": true,
      "Mülkköy": true,
      "Numanpaşa": true,
      "Ortaköy": true,
      "Ortaören": true,
      "Özlüce": true,
      "Öztoprak": true,
      "Petekli": true,
      "Pınarlı": true,
      "Sandıklı": true,
      "Sırakonak": true,
      "Soğuksu": true,
      "Şenköy": true,
      "Taşbaşı": true,
      "Taşlıca": true,
      "Tekpınar": true,
      "Tepecik": true,
      "Ulubel": true,
      "Ulutaş": true,
      "Üzümbağı": true,
      "Yağlı": true,
      "Yaylacık": true,
      "Yedigöl": true,
      "Yedigöze": true,
      "Yeşiltepe": true,
      "Yeşilyurt": true,
      "Yıldıztepe": true,
      "Yukarı": true,
      "Yukarı Fındıklı": true,
      "Yukarı Özbağ": true,
      "Yunusköy": true,
      "Zeyrek": true
    },
    "Karaçoban": {
      "Akkavak": true,
      "Bağlar": true,
      "Bahçeli": true,
      "Binpınar": true,
      "Bozyar": true,
      "Budaklı": true,
      "Burnaz": true,
      "Çatalgül": true,
      "Dedeören": true,
      "Doğanbey": true,
      "Duman": true,
      "Erenler": true,
      "Erhanlar": true,
      "Gündüz": true,
      "Hacılar": true,
      "Karagöz": true,
      "Karaköprü": true,
      "Karmış": true,
      "Kavaklı": true,
      "Kırımkaya": true,
      "Kopal": true,
      "Kuşluca": true,
      "Maruf": true,
      "Molladavut": true,
      "Ovayoncalı": true,
      "Sarıveli": true,
      "Seyhan": true
    },
    "Karayazı": {
      "Abdurrahmanköy": true,
      "Ağaçlı": true,
      "Akarsu": true,
      "Akpınar": true,
      "Alemdağı": true,
      "Aliküllek": true,
      "Anıtlı": true,
      "Aşağıincesu": true,
      "Aşağısöylemez": true,
      "Aydınsu": true,
      "Bayraktar": true,
      "Bezirhane": true,
      "Çakmaközü": true,
      "Çalışkan": true,
      "Çaltılı": true,
      "Çatalören": true,
      "Çavuşköy": true,
      "Çayırbeyli": true,
      "Çelikli": true,
      "Çepi": true,
      "Değirmenkaya": true,
      "Doruca": true,
      "Dörtpınar": true,
      "Duruca": true,
      "Dündar": true,
      "Elmaağaç": true,
      "Geventepe": true,
      "Göksu": true,
      "Göktepe": true,
      "Güllü": true,
      "Hacıbayram": true,
      "Hasanova": true,
      "Kapanlı": true,
      "Karaağıl": true,
      "Karabey": true,
      "Karakale": true,
      "Karakaya": true,
      "Karasu": true,
      "Karşıyaka": true,
      "Kayalar": true,
      "Kazbel": true,
      "Kırgındere": true,
      "Kırıkpınar": true,
      "Kösehasan": true,
      "Köyceğiz": true,
      "Kurupınar": true,
      "Molla Osman": true,
      "Mollabekir": true,
      "Muratlı": true,
      "Payveren": true,
      "Salyamaç": true,
      "Sancaktar": true,
      "Sarıçiçek": true,
      "Selenli": true,
      "Sukonak": true,
      "Sulutaş": true,
      "Şakirköy": true,
      "Taşan": true,
      "Tosunlu": true,
      "Turnagöl": true,
      "Uğurdalı": true,
      "Ulucanlar": true,
      "Üzengili": true,
      "Yahyaköy": true,
      "Yalındal": true,
      "Yeni": true,
      "Yeniköy": true,
      "Yeşilova": true,
      "Yeşilyurt": true,
      "Yiğityolu": true,
      "Yolgören": true,
      "Yukarıcihanbey": true,
      "Yukarıçığılgan": true,
      "Yukarısöylemez": true,
      "Yücelik": true
    },
    "Köprüköy": {
      "Ağcaşar": true,
      "Akçam": true,
      "Alaca": true,
      "Aşağıçakmak": true,
      "Aşağıkızılkale": true,
      "Ataköy": true,
      "Buğdaylı": true,
      "Camikebir": true,
      "Çullu": true,
      "Derebaşı": true,
      "Dilek": true,
      "Duatepe": true,
      "Dumankaya": true,
      "Eğirmez": true,
      "Emre": true,
      "Eyüpler": true,
      "Geyikli": true,
      "Gölçayır": true,
      "Güzelhisar": true,
      "Ilıcasu": true,
      "Karataşlar": true,
      "Kayabaşı": true,
      "Kıyıkonak": true,
      "Marifet": true,
      "Mescitli": true,
      "Ortaklar": true,
      "Örentaş": true,
      "Pekecik": true,
      "Sarıtaş": true,
      "Savatlı": true,
      "Soğuksu": true,
      "Şehitler": true,
      "Topçu": true,
      "Yağan": true,
      "Yapağılı": true,
      "Yemlik": true,
      "Yeşilöz": true,
      "Yılanlı": true,
      "Yukarıkızılca": true,
      "Yukarıkızılkale": true,
      "Yukarısöğütlü": true,
      "Ziyaret": true
    },
    "Narman": {
      "Alabalık": true,
      "Alacayar": true,
      "Araköy": true,
      "Aşağıyayla": true,
      "Başkale": true,
      "Beyler": true,
      "Boğakale": true,
      "Camiikebir": true,
      "Camiisağır": true,
      "Çamlıyayla": true,
      "Çimenli": true,
      "Dağyolu": true,
      "Demirdağ": true,
      "Ergazi": true,
      "Gökdağ": true,
      "Göllü": true,
      "Güllüdağ": true,
      "Güvenlik": true,
      "Kamışözü": true,
      "Karadağ": true,
      "Karapınar": true,
      "Kışlaköy": true,
      "Kilimli": true,
      "Koçkaya": true,
      "Koyunören": true,
      "Kuruçalı": true,
      "Mahmutçavuş": true,
      "Mercimekli": true,
      "Otlutepe": true,
      "Pınaryolu": true,
      "Samikale": true,
      "Sapanlı": true,
      "Savaşçılar": true,
      "Serinsu": true,
      "Seyyid Ali Baba": true,
      "Sülüklü": true,
      "Sütpınar": true,
      "Şehitler": true,
      "Şekerli": true,
      "Taşburun": true,
      "Telli": true,
      "Toygarlı": true,
      "Tuzla": true,
      "Yanıktaş": true,
      "Yoldere": true,
      "Yukarıyayla": true
    },
    "Oltu": {
      "Alatarla": true,
      "Arıtaş": true,
      "Aslanpaşa": true,
      "Aşağıçamlı": true,
      "Aşağıkumlu": true,
      "Ayvalı": true,
      "Ayyıldız": true,
      "Bahçecik": true,
      "Bahçelikışla": true,
      "Ballıca": true,
      "Başaklı": true,
      "Başbağlar": true,
      "Cumhuriyet": true,
      "Çamlıbel": true,
      "Çanakpınar": true,
      "Çatak": true,
      "Çatalsöğüt": true,
      "Çayüstü": true,
      "Çengelli": true,
      "Dağdibi": true,
      "Damarlıtaş": true,
      "Demirtaş": true,
      "Derebaşı": true,
      "Dokuzdeğirmen": true,
      "Duralar": true,
      "Elmadüzü": true,
      "Erdoğmuş": true,
      "Esenyamaç": true,
      "Gökçedere": true,
      "Günlüce": true,
      "Güryaprak": true,
      "Güzelsu": true,
      "Halitpaşa": true,
      "İğdeli": true,
      "İnanmış": true,
      "İnci": true,
      "İpekçayırı": true,
      "İriağaç": true,
      "Kaleboğazı": true,
      "Karabekir": true,
      "Karataş": true,
      "Kayaaltı": true,
      "Kemerkaya": true,
      "Konukseven": true,
      "Küçükorucuk": true,
      "Nüğürcük": true,
      "Obayayla": true,
      "Orucuk": true,
      "Özdere": true,
      "Sağlıcak": true,
      "Sarısaz": true,
      "Subatuk": true,
      "Süleymanlı": true,
      "Sülünkaya": true,
      "Şehitler": true,
      "Şendurak": true,
      "Tekeli": true,
      "Toklu": true,
      "Topkaynak": true,
      "Toprakkale": true,
      "Tutlu": true,
      "Tutmaç": true,
      "Tuzla": true,
      "Ünlükaya": true,
      "Vişneli": true,
      "Yarbaşı": true,
      "Yasin Haşimoğlu": true,
      "Yaylaçayır": true,
      "Yolboyu": true,
      "Yukarıçamlı": true,
      "Yukarıkumlu": true,
      "Yusuf Ziyabey": true
    },
    "Olur": {
      "Akbayır": true,
      "Aktepe": true,
      "Altunkaya": true,
      "Aşağıçayırlı": true,
      "Aşağıkaracasu": true,
      "Atlı": true,
      "Beğendik": true,
      "Beşkaya": true,
      "Boğazgören": true,
      "Bozdoğan": true,
      "Coşkunlar": true,
      "Çataksu": true,
      "Eğlek": true,
      "Ekinlik": true,
      "Filizli": true,
      "Güngöründü": true,
      "Hükkam": true,
      "Ilıkaynak": true,
      "Kaban": true,
      "Kaledibi": true,
      "Karakoçlar": true,
      "Keçili": true,
      "Kekikli": true,
      "Köprübaşı": true,
      "Merkez": true,
      "Merkez Yeşilbağlar": true,
      "Oğuzkent": true,
      "Olgun": true,
      "Olurdere": true,
      "Ormanağzı": true,
      "Sarıbaşak": true,
      "Soğukgöze": true,
      "Süngübayır": true,
      "Şalpazarı": true,
      "Taşgeçit": true,
      "Uzunharman": true,
      "Ürünlü": true,
      "Yaylabaşı": true,
      "Yeşilbağlar": true,
      "Yıldızkaya": true,
      "Yolgözler": true,
      "Yukarıçayırlı": true,
      "Yukarıkaracasu": true
    },
    "Palandöken": {
      "Abdurrahman Gazi": true,
      "Adnan Menderes": true,
      "Ali Bezirgan": true,
      "Aziziye": true,
      "Börekli": true,
      "Çeperli": true,
      "Dereboğazı": true,
      "Güllü": true,
      "Güzelyurt": true,
      "Hancığaz": true,
      "Hüseyin Avni Ulaş": true,
      "Konaklı": true,
      "Kümbet": true,
      "Müftü Solakzade": true,
      "Nene Hatun": true,
      "Sığırlı": true,
      "Şehitler": true,
      "Taşlıgüney": true,
      "Tekkederesi": true,
      "Tepeköy": true,
      "Toparlak": true,
      "Uzun Ahmet": true,
      "Yağmurcuk": true,
      "Yıkılgan": true,
      "Yukarıyenice": true,
      "Yunusemre": true
    },
    "Pasinler": {
      "Acı": true,
      "Ağaçminare": true,
      "Ağcalar": true,
      "Altınbaşak": true,
      "Alvar": true,
      "Ardıçlı": true,
      "Aşıtlar": true,
      "Bahçelievler": true,
      "Baldızı": true,
      "Başören": true,
      "Bulkasım": true,
      "Büyükdere": true,
      "Büyüktüy": true,
      "Camikebir": true,
      "Çakırtaş": true,
      "Çalıyazı": true,
      "Çamlıca": true,
      "Çiçekli": true,
      "Çöğender": true,
      "Demirdöven": true,
      "Emirşeyh": true,
      "Epsemce": true,
      "Erzurumkapı": true,
      "Esendere": true,
      "Gerdekkaya": true,
      "Gölciğez": true,
      "Hanahmet": true,
      "Hasandede": true,
      "Kaplıcalar": true,
      "Karakale": true,
      "Karavelet": true,
      "Kasımpaşa": true,
      "Kavuşturan": true,
      "Kethuda": true,
      "Kevenlik": true,
      "Kızılören": true,
      "Kotandüzü": true,
      "Kurbançayır": true,
      "Kurtuluş": true,
      "Küçüktüy": true,
      "Otlukkapı": true,
      "Ovaköy": true,
      "Övenler": true,
      "Paşabey": true,
      "Pelitli": true,
      "Porsuk": true,
      "Pusudere": true,
      "Reşadiye": true,
      "Saksı": true,
      "Serçeboğazı": true,
      "Sivas": true,
      "Sunak": true,
      "Şehit Burak Karakoç": true,
      "Taşağıl": true,
      "Taşkaynak": true,
      "Taşlıgüney": true,
      "Taşlıyurt": true,
      "Tepecik": true,
      "Timar": true,
      "Uzunark": true,
      "Üğümü": true,
      "Yamaç": true,
      "Yastıktepe": true,
      "Yavuzlu": true,
      "Yayla": true,
      "Yayladağ": true,
      "Yeni": true,
      "Yeniköy": true,
      "Yiğitpınarı": true,
      "Yiğittaşı": true,
      "Yukarıçakmak": true,
      "Yukarıdanişment": true
    },
    "Pazaryolu": {
      "21haziran": true,
      "Akbulut": true,
      "Alıçlı": true,
      "Ambaralan": true,
      "Ayçukuru": true,
      "Bayındır": true,
      "Burçaklı": true,
      "Büyükdere": true,
      "Cennetpınarı": true,
      "Cevizlidere": true,
      "Çatakbahçe": true,
      "Çaydere": true,
      "Çiftepınar": true,
      "Deliktaş": true,
      "Demirgöze": true,
      "Dikmetaş": true,
      "Esenyurt": true,
      "Gölyanı": true,
      "Göztepe": true,
      "Gülçimen": true,
      "Güneysu": true,
      "Hacılar": true,
      "Karakoç": true,
      "Karataş": true,
      "Kılıççı": true,
      "Konakyeri": true,
      "Korkutköy": true,
      "Kozlu": true,
      "Köşeyolu": true,
      "Kumaşkaya": true,
      "Kuymaklı": true,
      "Kümbettepe": true,
      "Laleli": true,
      "Merkez": true,
      "Meşebaşı": true,
      "Pamukludağ": true,
      "Sadaka": true,
      "Sergenkaya": true,
      "Süleymanbağı": true,
      "Şehitlik": true,
      "Yaylalı": true,
      "Yaylaözü": true,
      "Yeni": true,
      "Yiğitbaşı": true
    },
    "Şenkaya": {
      "Akşar": true,
      "Aktaş": true,
      "Alıcık": true,
      "Aşağı": true,
      "Aşağıbakraçlı": true,
      "Atyolu": true,
      "Aydoğdu": true,
      "Balkaya": true,
      "Bereketli": true,
      "Beşpınarlar": true,
      "Beykaynak": true,
      "Çamlıalan": true,
      "Çatalelma": true,
      "Değirmenlidere": true,
      "Deliktaş": true,
      "Doğanköy": true,
      "Dokuzelma": true,
      "Dolunay": true,
      "Dörtyol": true,
      "Esence": true,
      "Esenyurt": true,
      "Evbakan": true,
      "Gaziler": true,
      "Gezenek": true,
      "Göllet": true,
      "Göreşken": true,
      "Gözalan": true,
      "Gözebaşı": true,
      "Gülveren": true,
      "Hoşköy": true,
      "İçmesu": true,
      "İğdeli": true,
      "İkizpınar": true,
      "İnceçay": true,
      "Kayalısu": true,
      "Kaynak": true,
      "Kireçli": true,
      "Köroğlu": true,
      "Köşkköy": true,
      "Kürkçü": true,
      "Nişantaşı": true,
      "Ormanlı": true,
      "Oyuktaş": true,
      "Özyurt": true,
      "Paşalı": true,
      "Penek": true,
      "Sarıkayalar": true,
      "Sarıyar": true,
      "Sındıran": true,
      "Söğütler": true,
      "Susuz": true,
      "Şenpınar": true,
      "Tahtköy": true,
      "Tazeköy": true,
      "Teketaş": true,
      "Timurkışla": true,
      "Turnalı": true,
      "Tütenocak": true,
      "Uğurlu": true,
      "Yanıkkaval": true,
      "Yaymeşe": true,
      "Yazılı": true,
      "Yelkıran": true,
      "Yeşildemet": true,
      "Yeşilkaya": true,
      "Yoğurtçular": true,
      "Yukarı": true,
      "Yukarıbakraçlı": true,
      "Yünören": true,
      "Yürekli": true,
      "Zümrüt": true
    },
    "Tekman": {
      "Ağcakoca": true,
      "Akdağ": true,
      "Akdamar": true,
      "Akpınar": true,
      "Alabayır": true,
      "Aşağıhanbeyi": true,
      "Aşağıtepecik": true,
      "Aydınlı": true,
      "Aydınlık": true,
      "Beşdere": true,
      "Beyköy": true,
      "Cihan": true,
      "Çağlar": true,
      "Çatak": true,
      "Çatkale": true,
      "Çayırdağı": true,
      "Çevirme": true,
      "Çiçekdağı": true,
      "Çukuryayla": true,
      "Dalsöğüt": true,
      "Deliler": true,
      "Dengiz": true,
      "Düzyurt": true,
      "Erence": true,
      "Geçitköy": true,
      "Gökoğlan": true,
      "Gözlüce": true,
      "Gülveren": true,
      "Gümüşlük": true,
      "Gündamı": true,
      "Güneşli": true,
      "Gürgür": true,
      "Güzeldere": true,
      "Hacıömer": true,
      "Hamzalar": true,
      "Hürriyet": true,
      "Hüseyinağa": true,
      "Ilıgöze": true,
      "Işıklar": true,
      "İncesu": true,
      "İsmetpaşa": true,
      "Kalaycı": true,
      "Karapınar": true,
      "Karataş": true,
      "Karatepe": true,
      "Karlıca": true,
      "Katranlı": true,
      "Kayaboğaz": true,
      "Kazancık": true,
      "Kırıkan": true,
      "Koçyayla": true,
      "Körsu": true,
      "Kuruca": true,
      "Küllü": true,
      "Mescitli": true,
      "Mollamehmet": true,
      "Susuz": true,
      "Şakşak": true,
      "Taşkesen": true,
      "Toptepe": true,
      "Turnagöl": true,
      "Vatan": true,
      "Yalınca": true,
      "Yerköy": true,
      "Yeşilören": true,
      "Yiğitler": true,
      "Yoncalı": true,
      "Yukarıhanbeyi": true,
      "Yukarıtepecik": true,
      "Yuvaklı": true,
      "Yücepınar": true
    },
    "Tortum": {
      "Akbaba": true,
      "Aksu": true,
      "Aktaş": true,
      "Alapınar": true,
      "Alparslan": true,
      "Arılı": true,
      "Aşağı Serdarlı": true,
      "Bağbaşı": true,
      "Bahçeli": true,
      "Ballı": true,
      "Cihanlı": true,
      "Çakıllı": true,
      "Çamlıca": true,
      "Çardaklı": true,
      "Çataldere": true,
      "Çaylıca": true,
      "Çiftlik": true,
      "Çivilikaya": true,
      "Demirciler": true,
      "Derekapı": true,
      "Derinpınar": true,
      "Dikmen": true,
      "Doruklu": true,
      "Esendurak": true,
      "Gökdere": true,
      "Hamidiye": true,
      "İncedere": true,
      "Kaleboynu": true,
      "Kaledibi": true,
      "Kapıkaya": true,
      "Karlı": true,
      "Kazandere": true,
      "Kemerkaya": true,
      "Kırmalı": true,
      "Kireçli": true,
      "Konak": true,
      "Meydanlar": true,
      "Pehlivanlı": true,
      "Peynirli": true,
      "Serdarlı": true,
      "Söğütlü": true,
      "Suyatağı": true,
      "Şenyurt": true,
      "Taşbaşı": true,
      "Taşoluk": true,
      "Tatlısu": true,
      "Tipili": true,
      "Tortumkale": true,
      "Uzunkavak": true,
      "Vişneli": true,
      "Yağcılar": true,
      "Yamankaya": true,
      "Yavuz Sultan Selim": true,
      "Yazyurdu": true,
      "Yellitepe": true,
      "Yukarısivri": true,
      "Yumaklı": true,
      "Ziyaretli": true
    },
    "Uzundere": {
      "Altınçanak": true,
      "Balıklı": true,
      "Cevizli": true,
      "Cömertler": true,
      "Çağlayan": true,
      "Çamlıyamaç": true,
      "Çaybaşı": true,
      "Dikyar": true,
      "Erikli": true,
      "Gölbaşı": true,
      "Kirazlı": true,
      "Merkez": true,
      "Muratefendi": true,
      "Sapaca": true,
      "Seyitefendi": true,
      "Ulubağ": true,
      "Uzundere": true,
      "Yayla": true
    },
    "Yakutiye": {
      "Akdağ": true,
      "Aktoprak": true,
      "Altınbulak": true,
      "Altıntepe": true,
      "Arıbahçe": true,
      "Çayırca": true,
      "Çayırtepe": true,
      "Çiftlik": true,
      "Dadaşköy": true,
      "Değirmenler": true,
      "Dumlu": true,
      "Gökçeyamaç": true,
      "Gülpınar": true,
      "Güngörmez": true,
      "Güzelova": true,
      "Güzelyayla": true,
      "İbrahim Hakkı": true,
      "Karagöbek": true,
      "Karasu": true,
      "Kazım Karabekir Paşa": true,
      "Kırkgöze": true,
      "Kırmızıtaş": true,
      "Köse Mehmet": true,
      "Köşkköy": true,
      "Kurtuluş": true,
      "Lalapaşa": true,
      "Muratgeldi": true,
      "Muratpaşa": true,
      "Mülk": true,
      "Orta Düzü": true,
      "Ömer Nasuhi Bilmen": true,
      "Rabia Ana": true,
      "Soğukçermik": true,
      "Söğütyanı": true,
      "Şenyurt": true,
      "Şükrüpaşa": true,
      "Umudum": true,
      "Uzunyayla": true,
      "Üniversite": true,
      "Yazı Pınarı": true,
      "Yerli Su": true,
      "Yeşildere": true,
      "Yeşilova": true,
      "Yeşilyayla": true
    }
  },
  "Eskişehir": {
    "Alpu": {
      "Ağaçhisar": true,
      "Aktepe": true,
      "Alapınar": true,
      "Arıkaya": true,
      "Bahçecik": true,
      "Başören": true,
      "Belkese": true,
      "Bozan": true,
      "Büğdüz": true,
      "Çardakbaşı": true,
      "Çerkez Çukurhisar": true,
      "Dereköy": true,
      "Esence": true,
      "Fatih": true,
      "Fevzi Paşa": true,
      "Fevziye": true,
      "Gökçekaya": true,
      "Gökçeoğlu": true,
      "Güroluk": true,
      "Işıkören": true,
      "Karacaören": true,
      "Karakamış": true,
      "Kemalpaşa": true,
      "Koşmat": true,
      "Mamure": true,
      "Osmaniye": true,
      "Özdenk": true,
      "Sakarıkaracaören": true,
      "Sarıkavak": true,
      "Söğütçük": true,
      "Uyuzhamamköyü": true,
      "Yeşildon": true,
      "Yunusemre": true
    },
    "Beylikova": {
      "Akköprü": true,
      "Aşağıdudaş": true,
      "Aşağıiğdeağacı": true,
      "Ata": true,
      "Doğanoğlu": true,
      "Doğray": true,
      "Emircik": true,
      "Gökçeayva": true,
      "Halilbağı": true,
      "İkipınar": true,
      "İmikler": true,
      "Kızılcaören": true,
      "Köprübaşı": true,
      "Okçu": true,
      "Parsıbey": true,
      "Rahmiye": true,
      "Sultaniye": true,
      "Süleymaniye": true,
      "Uzunburun": true,
      "Yalınlı": true,
      "Yeni": true,
      "Yeniyurt": true,
      "Yukarıdudaş": true,
      "Yukarıiğdeağacı": true,
      "Yunus Emre": true
    },
    "Çifteler": {
      "Abbashalimpaşa": true,
      "Adalar": true,
      "Alikan": true,
      "Arslanlı": true,
      "Başkurt": true,
      "Belpınar": true,
      "Çatmapınar": true,
      "Çiftçi": true,
      "Dikilikaya": true,
      "Dikmen": true,
      "Doğanay": true,
      "Eminekin": true,
      "Erbap": true,
      "Hayriye": true,
      "Ilıcabaşı": true,
      "Kadıkuyusu": true,
      "Körhasan": true,
      "Orhaniye": true,
      "Ortaköy": true,
      "Osmaniye": true,
      "Sadıroğlu": true,
      "Saithalimpaşa": true,
      "Sakarya": true,
      "Sarıkavak": true,
      "Yeni": true,
      "Yenidoğan": true,
      "Yıldızören": true,
      "Zaferhamit": true
    },
    "Günyüzü": {
      "Atlas": true,
      "Ayvalı": true,
      "Bedil": true,
      "Beyyayla": true,
      "Çakmak": true,
      "Çardaközü": true,
      "Doğray": true,
      "Fatih": true,
      "Gecek": true,
      "Gümüşkonak": true,
      "Kavacık": true,
      "Kavuncu": true,
      "Kayakent": true,
      "Kuzören": true,
      "Mercan": true,
      "Özler": true,
      "Sümer": true,
      "Tutlu": true,
      "Yağrı": true,
      "Yazır": true,
      "Yenikent": true,
      "Yeşilyaka": true
    },
    "Han": {
      "Ağlarca": true,
      "Akdere": true,
      "Akhisar": true,
      "Başara": true,
      "Erten": true,
      "Gökçekuyu": true,
      "Gökçeyayla": true,
      "Hacılar": true,
      "Hankaraağaç": true,
      "Hüsrevpaşa": true,
      "İskankuyu": true,
      "Kayı": true,
      "Peçene": true,
      "Tepeköy": true,
      "Yazılı": true
    },
    "İnönü": {
      "Aşağıkuzfındık": true,
      "Çarşı": true,
      "Dereyalak": true,
      "Dutluca": true,
      "Erenköy": true,
      "Esnemez": true,
      "İsmetpaşa": true,
      "Kümbet": true,
      "Kümbetakpınar": true,
      "Kümbetyeniköy": true,
      "Oklubalı": true,
      "Orta": true,
      "Seyitaliköyü": true,
      "Yenice": true,
      "Yukarıkuzfındık": true,
      "Yürükyayla": true
    },
    "Mahmudiye": {
      "Akyurt": true,
      "Balçıkhisar": true,
      "Çal": true,
      "Doğanca": true,
      "Fahriye": true,
      "Güllüce": true,
      "Hamidiye": true,
      "Işıklar": true,
      "İsmetpaşa": true,
      "Kaymazyayla": true,
      "Mesudiye": true,
      "Orta": true,
      "Şerefiye": true,
      "Tokathan": true,
      "Topkaya": true,
      "Türkmenmecidiye": true,
      "Yeni": true,
      "Yeniköy": true,
      "Yeşilyurt": true
    },
    "Mihalgazi": {
      "Alpagut": true,
      "Bozaniç": true,
      "Cumhuriyet": true,
      "Demirciler": true,
      "Dokuz Mayıs": true,
      "Hürriyet": true,
      "İstiklal": true,
      "Karaoğlan": true,
      "Sakarıılıca": true
    },
    "Mihalıççık": {
      "Adahisar": true,
      "Ahur": true,
      "Ahurözü": true,
      "Akçaören": true,
      "Aydınlar": true,
      "Bahtiyar": true,
      "Belen": true,
      "Bey": true,
      "Camikebir": true,
      "Çalçı": true,
      "Çalkaya": true,
      "Çardak": true,
      "Çukurören": true,
      "Dağcı": true,
      "Diközü": true,
      "Dinek": true,
      "Dümrek": true,
      "Gözeler": true,
      "Güce": true,
      "Güreş": true,
      "Gürleyik": true,
      "Hamidiye": true,
      "Ilıcalar": true,
      "İğdecik": true,
      "İkizafer": true,
      "Karaçam": true,
      "Karageyikli": true,
      "Kavak": true,
      "Kayı": true,
      "Kızılbörüklü": true,
      "Korucu": true,
      "Koyunağılı": true,
      "Kozlu": true,
      "Lütfiye": true,
      "Mahmuthisar": true,
      "Medrese": true,
      "Narlı": true,
      "Obruk": true,
      "Otluk": true,
      "Ömer": true,
      "Saray": true,
      "Sazak": true,
      "Seki": true,
      "Sekiören": true,
      "Sorkun": true,
      "Süleler": true,
      "Tatarcık": true,
      "Uşakbükü": true,
      "Üçbaşlı": true,
      "Yalımkaya": true,
      "Yayla": true,
      "Yeşilyurt": true,
      "Yunusemre": true
    },
    "Odunpazarı": {
      "71 Evler": true,
      "75.yıl (sultandere)": true,
      "Ağapınar": true,
      "Akarbaşı": true,
      "Akcami": true,
      "Akçağlan": true,
      "Akçakaya": true,
      "Akkaya": true,
      "Akpınar": true,
      "Alanönü": true,
      "Arifiye": true,
      "Aşağı Çağlan": true,
      "Aşağıılıca": true,
      "Avdan": true,
      "Ayvacık": true,
      "Büyükdere": true,
      "Cunudiye": true,
      "Çamlıca": true,
      "Çankaya": true,
      "Çavlum": true,
      "Dede": true,
      "Deliklitaş": true,
      "Demirli": true,
      "Doğankaya": true,
      "Emek": true,
      "Erenköy": true,
      "Eşenkara": true,
      "Gökmeydan": true,
      "Göztepe": true,
      "Gülpınar": true,
      "Gültepe": true,
      "Gümele": true,
      "Gündoğdu": true,
      "Harmandalı": true,
      "Huzur": true,
      "Ihlamurkent": true,
      "İmişehir": true,
      "İstiklal": true,
      "Kalkanlı": true,
      "Kanlıpınar": true,
      "Karaalan": true,
      "Karacahöyük": true,
      "Karacaşehir": true,
      "Karaçay": true,
      "Karahüyük": true,
      "Karamustafa": true,
      "Karapazar": true,
      "Karapınar": true,
      "Karatepe": true,
      "Kargın": true,
      "Kayacık": true,
      "Kayapınar": true,
      "Kıravdan": true,
      "Kırmızıtoprak": true,
      "Kireç": true,
      "Kurtuluş": true,
      "Kuyucak": true,
      "Lütfiye": true,
      "Musalar": true,
      "Orhangazi": true,
      "Orta": true,
      "Osmangazi": true,
      "Paşa": true,
      "Sarısungur": true,
      "Seklice": true,
      "Sevinç": true,
      "Sultandere": true,
      "Sümer": true,
      "Süpüren": true,
      "Şarkiye": true,
      "Türkmentokat": true,
      "Uluçayır": true,
      "Vadişehir": true,
      "Vişnelik": true,
      "Yahnikapan": true,
      "Yassıhöyük": true,
      "Yenidoğan": true,
      "Yenikent": true,
      "Yenisofça": true,
      "Yıldıztepe": true,
      "Yukarıçağlan": true,
      "Yukarıılıca": true,
      "Yukarıkalabak": true,
      "Yürükkaracaören": true,
      "Yürükkırka": true
    },
    "Sarıcakaya": {
      "Beyköy": true,
      "Beyyayla": true,
      "Bilal Habeşi": true,
      "Camikebir": true,
      "Dağküplü": true,
      "Düzköy": true,
      "Fatih": true,
      "Güney": true,
      "İğdir": true,
      "Kapıkaya": true,
      "Laçin": true,
      "Mayıslar": true,
      "Sarıkaya": true,
      "Yeni": true
    },
    "Seyitgazi": {
      "Akin": true,
      "Aksaklı": true,
      "Aslanbeyli": true,
      "Aşağısöğüt": true,
      "Ayvalı": true,
      "Bardakçı": true,
      "Beşsaray": true,
      "Beykışla": true,
      "Büyükdere": true,
      "Büyükyayla": true,
      "Cevizli": true,
      "Çatören": true,
      "Çukurağıl": true,
      "Çukurca": true,
      "Çürüttüm": true,
      "Değişören": true,
      "Derebenek": true,
      "Doğançayır": true,
      "Fethiye": true,
      "Gemiç": true,
      "Göcenoluk": true,
      "Gökbahçe": true,
      "Gökçegüney": true,
      "Göknebi": true,
      "Gümüşbel": true,
      "İdrisyayla": true,
      "İkiçeşme": true,
      "İkizoluk": true,
      "Karacalık": true,
      "Karaören": true,
      "Kesenler": true,
      "Kırka": true,
      "Kümbet": true,
      "Numanoluk": true,
      "Oynaş": true,
      "Örencik": true,
      "Salihler": true,
      "Sancar": true,
      "Sandıközü": true,
      "Sarayören": true,
      "Sarıcailyas": true,
      "Şükranlı": true,
      "Taşlıkköy": true,
      "Üçsaray": true,
      "Yapıldak": true,
      "Yarbasan": true,
      "Yazıdere": true,
      "Yenikent": true,
      "Yeşiltepe": true,
      "Yukarısöğüt": true,
      "Yunus": true
    },
    "Sivrihisar": {
      "Ahiler": true,
      "Aktaş": true,
      "Aşağıkepen": true,
      "Aydınlı": true,
      "Babadat": true,
      "Bahçecik": true,
      "Ballıhisar": true,
      "Benlikuyu": true,
      "Benliyaver": true,
      "Beyyazı": true,
      "Biçer": true,
      "Böğürtlen": true,
      "Buhara": true,
      "Buzluca": true,
      "Camikebir": true,
      "Cumhuriyet": true,
      "Çandır": true,
      "Çaykoz": true,
      "Demirci": true,
      "Demirciköy": true,
      "Dinek": true,
      "Dumluca": true,
      "Dümrek": true,
      "Elcik": true,
      "Elmalı": true,
      "Ertuğrulköy": true,
      "Gedik": true,
      "Gerenli": true,
      "Göktepe": true,
      "Gülçayır": true,
      "Güvemli": true,
      "Hamamkarahisar": true,
      "Hızırbey": true,
      "Hüdavendigar": true,
      "İbikseydi": true,
      "İğdecik": true,
      "İlören": true,
      "İlyaspaşa": true,
      "İstiklalbağı": true,
      "Kadıncık": true,
      "Kaldırımköy": true,
      "Karabaşlı": true,
      "Karaburhan": true,
      "Karacakaya": true,
      "Karacalar": true,
      "Karacaören": true,
      "Karacaörenyaylası": true,
      "Karadat": true,
      "Karakaya": true,
      "Karkın": true,
      "Kaymaz": true,
      "Kertek": true,
      "Kılıç": true,
      "Kınık": true,
      "Koçaş": true,
      "Koltan": true,
      "Kubbeli": true,
      "Kurşunlu": true,
      "Kurtşeyh": true,
      "Memik": true,
      "Mülkköy": true,
      "Nasrettin Hoca": true,
      "Oğlakçı": true,
      "Ortaklar": true,
      "Paşakadın": true,
      "Sadıkbağı": true,
      "Sarıkavak": true,
      "Selimiye": true,
      "Sığırcık": true,
      "Tekören": true,
      "Yaverören": true,
      "Yenice": true,
      "Yenidoğan": true,
      "Yeniköy": true,
      "Yeşilköy": true,
      "Yukarıkepen": true,
      "Yunusemre": true,
      "Zeyköyü": true
    },
    "Tepebaşı": {
      "Ahılar": true,
      "Alınca": true,
      "Aşağı Söğütönü": true,
      "Aşağıkartal": true,
      "Atalan": true,
      "Atalantekke": true,
      "Avlamış": true,
      "Bahçelievler": true,
      "Batıkent": true,
      "Behçetiye": true,
      "Bektaşpınarı": true,
      "Beyazaltın": true,
      "Boyacıoğlu": true,
      "Bozdağ": true,
      "Buldukpınar": true,
      "Cumhuriye": true,
      "Cumhuriyet": true,
      "Çalkara": true,
      "Çamlıca": true,
      "Çanakkıran": true,
      "Çukurhisar Yeni": true,
      "Danişment": true,
      "Eğriöz": true,
      "Emirceoğlu": true,
      "Ertuğrulgazi": true,
      "Esentepe": true,
      "Eskibağlar": true,
      "Fatih": true,
      "Fevziçakmak": true,
      "Gazipaşa": true,
      "Gökçekısık": true,
      "Gökdere": true,
      "Güllük": true,
      "Gündüzler": true,
      "Hacı Ali Bey": true,
      "Hacı Seyit": true,
      "Hasanbey": true,
      "Hayriye": true,
      "Hekimdağ": true,
      "Hisar": true,
      "Hoşnudiye": true,
      "Işıklar": true,
      "İhsaniye": true,
      "Karaçobanpınarı": true,
      "Karadere": true,
      "Karagözler": true,
      "Kavacık": true,
      "Keskin": true,
      "Kızılcaören": true,
      "Kızılinler": true,
      "Kozkayı": true,
      "Kozlubel": true,
      "Kumlubel": true,
      "Mamure": true,
      "Merkez Yeni": true,
      "Mollaoğlu": true,
      "Musaözü": true,
      "Mustafa Kemal Paşa": true,
      "Muttalip Emirler": true,
      "Muttalip Koyunlar": true,
      "Muttalip Orta": true,
      "Nemli": true,
      "Ömerağa": true,
      "Sakintepe": true,
      "Satılmışoğlu": true,
      "Sazova": true,
      "Sulukaraağaç": true,
      "Sütlüce": true,
      "Şarhöyük": true,
      "Şeker": true,
      "Şirintepe": true,
      "Takmak": true,
      "Tandır": true,
      "Taycılar": true,
      "Tekeciler": true,
      "Tunalı": true,
      "Turgutlar": true,
      "Uludere": true,
      "Uluönder": true,
      "Yakakayı": true,
      "Yarımca": true,
      "Yaşamkent": true,
      "Yeniakçayır": true,
      "Yenibağlar": true,
      "Yeniincesu": true,
      "Yeşiltepe": true,
      "Yukarı Söğütönü": true,
      "Yukarıkartal": true,
      "Yusuflar": true,
      "Yürükakçayır": true,
      "Zafer": true,
      "Zincirlikuyu": true
    }
  },
  "Gaziantep": {
    "Araban": {
      "Akbudak": true,
      "Akkoç": true,
      "Altınpınar": true,
      "Aşağıkaravaiz": true,
      "Aşağıyufkalı": true,
      "Bağlıca": true,
      "Başpınar": true,
      "Beydili": true,
      "Çiftekoz": true,
      "Dağdancık": true,
      "Doğan": true,
      "Dumlupınar": true,
      "Elif": true,
      "Emirhaydar": true,
      "Erenbağ": true,
      "Esentepe": true,
      "Eskialtıntaş": true,
      "Fakılı": true,
      "Fevzi Çakmak": true,
      "Fıstıklıdağ": true,
      "Gelinbuğday": true,
      "Gökçepayam": true,
      "Güllüce": true,
      "Gümüşpınar": true,
      "Güzey": true,
      "Hasanoğlu": true,
      "Hisar": true,
      "Kale": true,
      "Karababa": true,
      "Karacaören": true,
      "Köklüce": true,
      "Körhacıobası": true,
      "Küçüklü": true,
      "Mehmet Gökçek": true,
      "Muratlı": true,
      "Nurettin": true,
      "Sarıkaya": true,
      "Sarıtepe": true,
      "Şerif Peri": true,
      "Tarlabaşı": true,
      "Taşdeğirmen": true,
      "Turgut Özal": true,
      "Yaylacık": true,
      "Yeni Altıntaş": true,
      "Yeşilova": true,
      "Yolveren": true,
      "Yukarıkaravaiz": true,
      "Yukarıyufkalı": true,
      "Ziyaret": true
    },
    "İslahiye": {
      "Ağabey": true,
      "Ağalarobası": true,
      "Akınyolu": true,
      "Alaca": true,
      "Altınüzüm": true,
      "Arpalı": true,
      "Atatürk": true,
      "Aydınlık": true,
      "Bahçelievler": true,
      "Bayraktepe": true,
      "Beyler": true,
      "Boğaziçi": true,
      "Burhaniye": true,
      "Burunsuzlar": true,
      "Cevdetpaşa": true,
      "Cumhuriyet": true,
      "Çamlıca": true,
      "Çerçili": true,
      "Çınarlı": true,
      "Çolaklar": true,
      "Çubuk": true,
      "Değirmencik": true,
      "Dervişpaşa": true,
      "Elbistanhüyüğü": true,
      "Erenler": true,
      "Esenler": true,
      "Fevzi Çakmak": true,
      "Fevzipaşa": true,
      "Göltepe": true,
      "Güllühüyük": true,
      "Güngören": true,
      "Haci Ali Öztürk": true,
      "Hanağzı": true,
      "Hasanlök": true,
      "Hürriyet": true,
      "İdilli": true,
      "Kabaklar": true,
      "Kalaycık": true,
      "Kale": true,
      "Karacaören": true,
      "Karakaya": true,
      "Karapınar": true,
      "Karapolat": true,
      "Kayabaşı": true,
      "Kazıklı": true,
      "Kırıkçalı": true,
      "Koçcağız": true,
      "Kozdere": true,
      "Köklü": true,
      "Kuşçumustafa": true,
      "Ortaklı": true,
      "Örtülü": true,
      "Pınarbaşı": true,
      "Serinevler": true,
      "Sulumağara": true,
      "Şahmaran": true,
      "Şerikanlı": true,
      "Tandır": true,
      "Telli": true,
      "Türkbahçe": true,
      "Yağızlar": true,
      "Yelliburun": true,
      "Yeni": true,
      "Yeniceli": true,
      "Yeniköy": true,
      "Yesemek": true,
      "Yeşilova": true,
      "Yeşilyurt": true,
      "Yolbaşı": true,
      "Yukarıbilenler": true,
      "Zincirli": true
    },
    "Karkamış": {
      "Akçaköy": true,
      "Alaçalı": true,
      "Alagöz": true,
      "Arıkdere": true,
      "Ayyıldız": true,
      "Balaban": true,
      "Beşkılıç": true,
      "Çarşı": true,
      "Çiftlik": true,
      "Eceler": true,
      "Elifoğlu": true,
      "Erenyolu": true,
      "Etiler": true,
      "Gürçay": true,
      "Karacurun": true,
      "Karanfil": true,
      "Karşıyaka": true,
      "Kelekli": true,
      "Kepirler": true,
      "Kıvırcık": true,
      "Korkmazlar": true,
      "Kuruyazı": true,
      "Lojmanlar": true,
      "Öncüler": true,
      "Örmetaş": true,
      "Savaş": true,
      "Soylu": true,
      "Subağı": true,
      "Şenlik": true,
      "Teketaşı": true,
      "Tosunlu": true,
      "Türkyurdu": true,
      "Yarımca": true,
      "Yaşar": true,
      "Yazır": true,
      "Yeşerti": true,
      "Yolağzı": true,
      "Yurtbağı": true,
      "Zührecik": true
    },
    "Nizip": {
      "Adaklı": true,
      "Akçakent": true,
      "Akkuyu": true,
      "Alahacı": true,
      "Altındağ": true,
      "Aşağıbayındır": true,
      "Aşağıçardak": true,
      "Atatürk": true,
      "Bağlıca": true,
      "Bahçeli": true,
      "Ballı": true,
      "Belkıs": true,
      "Belkıs (merkez)": true,
      "Boyluca": true,
      "Bozalioğlu": true,
      "Cumhuriyet": true,
      "Çakmaktepe": true,
      "Çanakçı": true,
      "Çatalca": true,
      "Dayıdağı": true,
      "Dazhüyük": true,
      "Dernek": true,
      "Doğrular": true,
      "Duraklı": true,
      "Dutlu": true,
      "Düzbayır": true,
      "Ekinci": true,
      "Erenköy": true,
      "Eskikonak": true,
      "Eyüp Sultan": true,
      "Fatih Sultan": true,
      "Fevkani": true,
      "Fevzi Paşa": true,
      "Fırat": true,
      "Gaziler": true,
      "Gevence": true,
      "Gökçeli": true,
      "Güder": true,
      "Gülkaya": true,
      "Gümüşgün": true,
      "Günaltı": true,
      "Gürbaşak": true,
      "Güzelköy": true,
      "Hafızpaşa": true,
      "Hancağız": true,
      "Hazımoğlu": true,
      "İkizce": true,
      "İntepe": true,
      "İstasyon": true,
      "İstiklal": true,
      "Kaleköy": true,
      "Kamışlı": true,
      "Karaburç": true,
      "Karşıyaka": true,
      "Kayalar": true,
      "Keklik": true,
      "Kesiktaş": true,
      "Kıbrıs": true,
      "Kıraçgülü": true,
      "Kıratlı": true,
      "Kızılcakent": true,
      "Kızılin": true,
      "Kocatepe": true,
      "Korucak": true,
      "Köseler": true,
      "Kumla": true,
      "Kurucahüyük": true,
      "Mağaracık": true,
      "Mehmetobası": true,
      "Menderes": true,
      "Mercanlı": true,
      "Mevlana": true,
      "Mihrap": true,
      "Mimar Sinan": true,
      "Nahırtepe": true,
      "Namık Kemal": true,
      "Özyurt": true,
      "Pazar Camii": true,
      "Saha": true,
      "Salkım": true,
      "Samandöken": true,
      "Samanlı": true,
      "Saray": true,
      "Sarıkoç": true,
      "Sekili": true,
      "Söğütlü": true,
      "Suboyu": true,
      "Sultan Abdülhamit": true,
      "Şahinbey": true,
      "Şıhlar": true,
      "Tahtani": true,
      "Tanır": true,
      "Tatlıcak": true,
      "Tosunlu": true,
      "Toydemir": true,
      "Tuluktaş": true,
      "Turlu": true,
      "Turnalı": true,
      "Uluyatır": true,
      "Yağcılar": true,
      "Yağmuralan": true,
      "Yarımtepe": true,
      "Yeniyapan": true,
      "Yeniyazı": true,
      "Yeşilevler": true,
      "Yolçatı": true,
      "Yukarıbayındır": true,
      "Yukarıçardak": true,
      "Yunus Emre": true,
      "Zeytinlik": true
    },
    "Nurdağı": {
      "Alpaslan Türkeş": true,
      "Altınova": true,
      "Aslanlı": true,
      "Ataköy": true,
      "Atatürk": true,
      "Atmalı": true,
      "Bademli": true,
      "Bahçelievler": true,
      "Balıkalan": true,
      "Başpınar": true,
      "Belpınar": true,
      "Çakmak": true,
      "Demirler": true,
      "Durmuşlar": true,
      "Emirler": true,
      "Esenyurt": true,
      "Fatih": true,
      "Gedikli": true,
      "Gökçedere": true,
      "Gözlühüyük": true,
      "Hamidiye": true,
      "Hisar": true,
      "İçerisu": true,
      "İkizkuyu": true,
      "İncegedik": true,
      "İncirli": true,
      "Karaburçlu": true,
      "Kartal": true,
      "Kırışkal": true,
      "Kırkpınar": true,
      "Kömürler": true,
      "Kurudere": true,
      "Kuzoluk": true,
      "Mehmet Akif Ersoy": true,
      "Mesthüyük": true,
      "Naimler": true,
      "Nogaylar": true,
      "Olucak": true,
      "Sakçagözü": true,
      "Sayburun": true,
      "Şatırhüyük": true,
      "Tandırlı": true,
      "Terken": true,
      "Torunlar": true,
      "Tüllüce": true,
      "Yavuzselim": true,
      "Yaylacık": true,
      "Yeni": true
    },
    "Oğuzeli": {
      "Acer": true,
      "Akçamezra": true,
      "Altınyurt": true,
      "Ambarcık": true,
      "Arslanlı": true,
      "Asmacık": true,
      "Aşağı Güneyse": true,
      "Aşağı Yeniyapan": true,
      "Aydınkaya": true,
      "Belören": true,
      "Beşdeli": true,
      "Bulduk": true,
      "Büyükkaracaviran": true,
      "Cumhuriyet": true,
      "Çatalçam": true,
      "Çatalsu": true,
      "Çavuşbaşı": true,
      "Çaybaşı": true,
      "Çaybeyi": true,
      "Demirkonak": true,
      "Dero Küçükkaracaviran": true,
      "Devehüyüğü": true,
      "Dibecik": true,
      "Dikmetaş": true,
      "Direkli": true,
      "Doğanpınar": true,
      "Dokuzyol": true,
      "Duruköy": true,
      "Dutluca": true,
      "Ekinveren": true,
      "Ermiş": true,
      "Fatih": true,
      "Gebe": true,
      "Gedik": true,
      "Güllük": true,
      "Gündoğan": true,
      "Gürsu": true,
      "Güveçli": true,
      "Güzelce": true,
      "Hacar": true,
      "Hatunlu": true,
      "Hötoğlu": true,
      "Hürriyet": true,
      "İkizkuyu": true,
      "İnceyol": true,
      "İnkılap": true,
      "İnönü": true,
      "Kabacaağaç": true,
      "Karaburun": true,
      "Karadibek": true,
      "Karaman": true,
      "Karataş": true,
      "Kaşyolu": true,
      "Kavunluk": true,
      "Kayacık": true,
      "Kayalıpınar": true,
      "Keçikuyusu": true,
      "Keçili": true,
      "Kersentaş": true,
      "Kılavuz": true,
      "Koçaklar": true,
      "Kovanlı": true,
      "Körkün": true,
      "Kurtuluş": true,
      "Kuruçay": true,
      "Mimar Sinan": true,
      "Oğuzlar": true,
      "Sazgın": true,
      "Sergili": true,
      "Sevindi": true,
      "Subaşı": true,
      "Sütlüce": true,
      "Şahinbey": true,
      "Şıh Küçükkaracaviran": true,
      "Taşçanak": true,
      "Taşlı": true,
      "Taşyazı": true,
      "Tınazdere": true,
      "Tüzel": true,
      "Uğurova": true,
      "Ulaşlı": true,
      "Üçdamlar": true,
      "Üçkubbe": true,
      "Yakacık": true,
      "Yalnızbağ": true,
      "Yazılı": true,
      "Yeni Cumhuriyet": true,
      "Yeniköy": true,
      "Yeşildere": true,
      "Yeşiltepe": true,
      "Yukarıgüneyse": true
    },
    "Şahinbey": {
      "23 Nisan": true,
      "25 Aralık": true,
      "60.yıl": true,
      "75.yıl": true,
      "Abdülhamid Han": true,
      "Akbayır": true,
      "Akbulut": true,
      "Akkent": true,
      "Akpınar": true,
      "Akyazı": true,
      "Akyol": true,
      "Alaybey": true,
      "Alibaba": true,
      "Alleben": true,
      "Almalı": true,
      "Aydınbaba": true,
      "Bağlarbaşı": true,
      "Bahçelievler": true,
      "Barak": true,
      "Bayramlı": true,
      "Bekirbey": true,
      "Bekişli": true,
      "Belenköy": true,
      "Beşkuyu": true,
      "Beştepe": true,
      "Bey": true,
      "Beyazlar": true,
      "Beydilli": true,
      "Binevler": true,
      "Bostancık": true,
      "Boyacı": true,
      "Bozca": true,
      "Bozoklar": true,
      "Burç Esentepe": true,
      "Burç Karakuyu": true,
      "Bülbülzade": true,
      "Cabi": true,
      "Cebeler": true,
      "Cengiz Topel": true,
      "Cevizli": true,
      "Cumhuriyet": true,
      "Çağdaş": true,
      "Çamlıca": true,
      "Çamtepe": true,
      "Çapalı": true,
      "Çevreli": true,
      "Çimenli": true,
      "Çöreklik": true,
      "Çubukdiken": true,
      "Damlacık": true,
      "Deniz": true,
      "Deredüzü": true,
      "Doğanca": true,
      "Dokur": true,
      "Dumlupınar": true,
      "Durantaş": true,
      "Düztepe": true,
      "Ekinli": true,
      "Ertuğrulgazi": true,
      "Fırat": true,
      "Fidanlık": true,
      "Gazitepe": true,
      "Geneyik": true,
      "Gerciğin": true,
      "Geylani": true,
      "Güllüce": true,
      "Gülpınar": true,
      "Gümüştekin": true,
      "Güneş": true,
      "Güneykent": true,
      "Güzelvadi": true,
      "Hacıköprü": true,
      "Hacıköy": true,
      "Hoşgör": true,
      "İbn-i Sina": true,
      "İnönü": true,
      "İstiklal": true,
      "Kabarcık": true,
      "Kahvelipınar": true,
      "Kale": true,
      "Kaleboynu": true,
      "Kapçağız": true,
      "Karaçomak": true,
      "Karagöz": true,
      "Karataş": true,
      "Karayılan": true,
      "Kavaklık": true,
      "Kavşak": true,
      "Kazıklı": true,
      "Kepenek": true,
      "Kerer": true,
      "Kıbrıs": true,
      "Kılınçoğlu": true,
      "Killik": true,
      "Kolejtepe": true,
      "Konak": true,
      "Kozluca": true,
      "Kumruhamurkesen": true,
      "Kurbanbaba": true,
      "Kuşçu": true,
      "Küçükkızılhisar": true,
      "Külecik": true,
      "Kürüm": true,
      "Malazgirt": true,
      "Mavikent": true,
      "Mimar Sinan": true,
      "Morcalı": true,
      "Muhacirosman": true,
      "Narlıca": true,
      "Narlıtepe": true,
      "Nuripazarbaşı": true,
      "Ocaklar": true,
      "Onur": true,
      "Ortaklar": true,
      "Osmanlı": true,
      "Ozanlı": true,
      "Öğretmenevleri": true,
      "Perilikaya": true,
      "Saçaklı": true,
      "Sarıbaşak": true,
      "Sarıkaya": true,
      "Sarısalkım": true,
      "Sarıt": true,
      "Savcılı": true,
      "Selçuklu": true,
      "Serince": true,
      "Serinevler": true,
      "Sırasöğüt": true,
      "Sultan Selim": true,
      "Suyabatmaz": true,
      "Şahinbey Mülk": true,
      "Şahintepe": true,
      "Şahveli": true,
      "Şenyurt": true,
      "Tekstilkent": true,
      "Tiyekli": true,
      "Töreli": true,
      "Türkmenler": true,
      "Türközü": true,
      "Türktepe": true,
      "Ufacık": true,
      "Uğurtepe": true,
      "Ulaş": true,
      "Üçoklar": true,
      "Ünaldı": true,
      "Vatan": true,
      "Yağdöver": true,
      "Yamaçtepe": true,
      "Yavuzlar": true,
      "Yaycı": true,
      "Yaylacık": true,
      "Yazıbağı": true,
      "Yazıcık": true,
      "Yeditepe": true,
      "Yeniköy": true,
      "Yeşilevler": true,
      "Yeşilkent": true,
      "Yeşilköy": true,
      "Yeşilpınar": true,
      "Yeşilyurt": true,
      "Yığmatepe": true,
      "Yoğuntaş": true,
      "Yukarıbayır": true,
      "Zeytinli": true
    },
    "Şehitkamil": {
      "15 Temmuz": true,
      "29 Ekim": true,
      "8 Şubat": true,
      "Acaroba": true,
      "Ağaçlıboyno": true,
      "Akçaburç": true,
      "Akçagöze": true,
      "Aktoprak": true,
      "Alpaslan": true,
      "Aşağı Arıl": true,
      "Atabek": true,
      "Atalar": true,
      "Atatürk": true,
      "Bağbaşı": true,
      "Batıkent": true,
      "Battal": true,
      "Bayatlı": true,
      "Bedirköy": true,
      "Belkız": true,
      "Beykent": true,
      "Beylerbeyi": true,
      "Beyreli": true,
      "Bilek": true,
      "Boyno": true,
      "Bozobası": true,
      "Burak": true,
      "Büyükpınar": true,
      "Cerityeniyapan": true,
      "Çağkuyu": true,
      "Çamlıtepe": true,
      "Çıksorut": true,
      "Değirmiçem": true,
      "Dımışkılı": true,
      "Durnalık": true,
      "Dülük": true,
      "Dündarlı": true,
      "Erikli": true,
      "Eskişarkaya": true,
      "Eydibaba": true,
      "Eyüpsultan": true,
      "Fıstıklık": true,
      "Gazikent": true,
      "Gaziler": true,
      "Göksüncük": true,
      "Göktürk": true,
      "Göllüce": true,
      "Günbulur": true,
      "Güngürge": true,
      "Güvenevler": true,
      "Hacıbaba": true,
      "Işıklı": true,
      "İbrahimli": true,
      "İbrahimşehir": true,
      "İncesu": true,
      "İskenderli": true,
      "Kabasakız": true,
      "Karacaahmet": true,
      "Karacaburç": true,
      "Karacaoğlan": true,
      "Karacaören": true,
      "Karadede": true,
      "Karahüyük": true,
      "Karakesek": true,
      "Karayusuflu": true,
      "Karpuzkaya": true,
      "Karşıyaka": true,
      "Kayaönü": true,
      "Kızık Karasakal": true,
      "Kızıkhamurkesen": true,
      "Koçlu": true,
      "Kozluyazı": true,
      "Köksalan": true,
      "Küllü": true,
      "Medegöz": true,
      "Merveşehir": true,
      "Mevlana": true,
      "Mücahitler": true,
      "Nesimi": true,
      "Onat Kutlar": true,
      "Osmangazi": true,
      "Öğümsöğüt": true,
      "Övündük": true,
      "Pancarlı": true,
      "Pirsultan": true,
      "Sacır": true,
      "Sam": true,
      "Sanayi": true,
      "Sancaktepe": true,
      "Sarıgüllük": true,
      "Sarılar": true,
      "Sefaşehir": true,
      "Selahattin Eyyubi": true,
      "Selimiye": true,
      "Serintepe": true,
      "Seymenli": true,
      "Seyrantepe": true,
      "Sinan": true,
      "Sofalıcı": true,
      "Suboğaz": true,
      "Sülüklü": true,
      "Şirinevler": true,
      "Taşlıca": true,
      "Tekirsin": true,
      "Tokdemir": true,
      "Tuğlu": true,
      "Türkyurdu": true,
      "Uğruca": true,
      "Umut": true,
      "Üçgöze": true,
      "Ülkerli": true,
      "Yalankoz": true,
      "Yamaçoba": true,
      "Yaprak": true,
      "Yayıktaş": true,
      "Yenişarkaya": true,
      "Yeşilce": true,
      "Yığınlı": true,
      "Yukarı Arıl": true,
      "Zülfikar": true
    },
    "Yavuzeli": {
      "Akbayır": true,
      "Aşağıhöçüklü": true,
      "Aşağıkayabaşı": true,
      "Aşağıkekliktepe": true,
      "Bağtepe": true,
      "Bakırca": true,
      "Ballık": true,
      "Beğendik": true,
      "Bülbül": true,
      "Büyükkarakuyu": true,
      "Cingife": true,
      "Cumhuriyet": true,
      "Çiltoprak": true,
      "Çimenli": true,
      "Değirmitaş": true,
      "Düzce": true,
      "Fevzi Çakmak": true,
      "Göçmez": true,
      "Gülpınar": true,
      "Hacımallı": true,
      "Havuz": true,
      "Hürriyet": true,
      "Ilıcak": true,
      "Karabey": true,
      "Karahan": true,
      "Karahüseyinli": true,
      "Kasaba": true,
      "Keşrobası": true,
      "Kuzuyatağı": true,
      "Küçükkarakuyu": true,
      "Örenli": true,
      "Saraymağara": true,
      "Sarıbuğday": true,
      "Sarılar": true,
      "Sultan Selim": true,
      "Süleymanobası": true,
      "Şenlikçe": true,
      "Tokaçlı": true,
      "Üçgöl": true,
      "Yarımca": true,
      "Yeniyurt": true,
      "Yöreli": true,
      "Yukarıkekliktepe": true,
      "Yukarıyeniköy": true
    }
  },
  "Giresun": {
    "Alucra": {
      "Babapınar": true,
      "Cumhuriyet": true,
      "Hoca Ahmed Yesevi": true,
      "Hüseyin Avni Alparslan": true,
      "Karaağaç": true,
      "Kemallı": true,
      "Mesudiye": true,
      "Topçam": true,
      "Veysel Karani": true,
      "Yunus Emre": true
    },
    "Bulancak": {
      "Acısu": true,
      "Ahurlu": true,
      "Alibey": true,
      "Arifli": true,
      "Aydınlar": true,
      "Bahçelievler": true,
      "Ballıca": true,
      "Bulancak": true,
      "Derecikalan": true,
      "Duacıoğlu": true,
      "Düz": true,
      "Güney": true,
      "Güzelyalı": true,
      "Güzelyurt": true,
      "İhsaniye": true,
      "İsmet Paşa": true,
      "Kızılot": true,
      "Merkez": true,
      "Pazarsuyu": true,
      "Pazarsuyu Emecen": true,
      "Sanayii": true,
      "Saraçlı": true,
      "Sisin": true,
      "Sofulu": true,
      "Soğuksu": true,
      "Şemsettin": true,
      "Toprakdeğirmeni": true,
      "Ucarlı": true,
      "Yeni": true
    },
    "Çamoluk": {
      "Dulundas": true,
      "Hürriyet": true,
      "Karşıyaka": true,
      "Köroğlu": true,
      "Kurtuluş": true,
      "Kurukol": true,
      "Yazılar": true,
      "Yuvacık": true
    },
    "Çanakçı": {
      "Beyli": true,
      "Cami Yanı": true,
      "Merkez": true,
      "Orta": true
    },
    "Dereli": {
      "Bahçeli": true,
      "Dereli": true,
      "Fatih": true,
      "Güzyurdu": true,
      "Hapan": true,
      "Kulakkaya": true,
      "Kuşluhan": true,
      "Kuzca": true,
      "Sütlüce": true,
      "Şıhlar": true,
      "Yeni": true,
      "Yuva": true
    },
    "Doğankent": {
      "Merkez": true,
      "Sadaklı": true,
      "Süttaşı": true,
      "Yeni": true,
      "Yeşiltepe": true
    },
    "Espiye": {
      "Adabük": true,
      "Ağalıkmadeni": true,
      "Cibril": true,
      "Çam": true,
      "Dikmen": true,
      "Esentepe": true,
      "Kaleboynu": true,
      "Karadere": true,
      "Kozköy": true,
      "Merkez": true,
      "Tuygun": true
    },
    "Eynesil": {
      "Altınlı": true,
      "Belen": true,
      "Boztepe": true,
      "Camidüzü": true,
      "Derebaşı": true,
      "Erzikıranı": true,
      "Gümüşçay": true,
      "Kıran": true,
      "Köseli": true,
      "Sokak": true,
      "Tamyanı": true,
      "Yakuplu": true
    },
    "Görele": {
      "Aydınlıkevler": true,
      "Bahçelievler": true,
      "Bahşiş": true,
      "Beyli": true,
      "Bozcaali": true,
      "Cillioğlu": true,
      "Çeşmebaşı": true,
      "Hendekbaşı": true,
      "Hürriyet": true,
      "Kaba": true,
      "Kumyalı": true,
      "Merkez": true,
      "Obakıran": true,
      "Orta": true,
      "Sayfiye": true,
      "Soğuksu": true,
      "Şahali": true,
      "Tepebaşı": true,
      "Ünlüce": true,
      "Yeniköy": true,
      "Yeşiltepe": true
    },
    "Güce": {
      "Fındıklı": true,
      "Giyimli": true,
      "Güce": true,
      "Kemaliye": true,
      "Soğukpınar": true,
      "Tevekli": true
    },
    "Keşap": {
      "Alakaş": true,
      "Bozkurt": true,
      "Fındıklı": true,
      "Karabedir": true,
      "Uğurca": true,
      "Yoliçi": true
    },
    "Merkez": {
      "Aksu": true,
      "Aydınlar": true,
      "Cumhuriyet": true,
      "Çağlayan": true,
      "Çaykara": true,
      "Çınarlar": true,
      "Çıtlakkale": true,
      "Demirci": true,
      "Erikliman": true,
      "Fevzi Çakmak": true,
      "Gaziler": true,
      "Gedikkaya": true,
      "Gemilerçekeği": true,
      "Güre": true,
      "Hacı Hüseyin": true,
      "Hacımiktat": true,
      "Hacısiyam": true,
      "Homurlu": true,
      "Kale": true,
      "Kapu": true,
      "Kavaklar": true,
      "Kayadibi": true,
      "Konacık": true,
      "Küçükköy": true,
      "Nizamiye": true,
      "Osmaniye": true,
      "Samanlıkkıranı": true,
      "Seldeğirmeni": true,
      "Sultan Selim": true,
      "Şeyhkeramettin": true,
      "Tekke": true,
      "Teyyaredüzü": true,
      "Yalı": true
    },
    "Piraziz": {
      "Aydere": true,
      "Eren": true,
      "Etlikkıran": true,
      "Kaleyanı": true,
      "Kargı": true,
      "Maden": true,
      "Şeyhli": true,
      "Şıhkıran": true,
      "Yeni": true
    },
    "Şebinkarahisar": {
      "Akbudak": true,
      "Avutmuş": true,
      "Biroğul": true,
      "Bülbül": true,
      "Çiftlik": true,
      "Fatih": true,
      "İkioğul": true,
      "Kavaklar": true,
      "Kırkgöz": true,
      "Kızılca": true,
      "Kütküt": true,
      "Müftü": true,
      "Tamzara": true,
      "Taş": true,
      "Yavuz Selim": true
    },
    "Tirebolu": {
      "Balçıkbelen": true,
      "Cintaşı": true,
      "Çarşı": true,
      "Demirci": true,
      "Hamam": true,
      "İstiklal": true,
      "Körliman": true,
      "Yeniköy": true,
      "Yılgın": true
    },
    "Yağlıdere": {
      "Ahallı": true,
      "Akdarı": true,
      "Akdoğan": true,
      "Bük": true,
      "Çağlayan": true,
      "Gültepe": true,
      "Günece": true,
      "Kızılelma": true,
      "Kozbükü": true,
      "Kurucalı": true,
      "Merkez": true,
      "Oruçbey": true,
      "Ömerli": true,
      "Palaklı": true,
      "Tepeköy": true,
      "Tuğlacık": true
    }
  },
  "Gümüşhane": {
    "Kelkit": {
      "Ahmet Yesevi": true,
      "Atatürk": true,
      "Bahçelievler": true,
      "Büyükcami": true,
      "Cumhuriyet": true,
      "Esentepe": true,
      "Fatih": true,
      "Göztepe": true,
      "Halkevi": true,
      "Hürriyet": true,
      "İnönü": true,
      "Karaçayır": true,
      "Küçükcami": true,
      "Mahmatlı": true,
      "Merkez": true,
      "Özyurt": true,
      "Yeşilova": true,
      "Yunus Emre": true
    },
    "Köse": {
      "Bahçelievler": true,
      "Cumhuriyet": true,
      "Fatih": true,
      "Yavuz Selim": true,
      "Yeni": true
    },
    "Kürtün": {
      "Aşağı Uluköy": true,
      "Cami Yanı": true,
      "Cayra": true,
      "Karaçukur": true,
      "Köyiçi": true,
      "Melikli": true,
      "Ortaköy": true,
      "Süme": true,
      "Yukarı Uluköy": true
    },
    "Merkez": {
      "Akçakale": true,
      "Bağlarbaşı": true,
      "Canca": true,
      "Çamlıca": true,
      "Ekinciler": true,
      "Esentepe": true,
      "Eskibağlar": true,
      "Fatih": true,
      "Gaziler": true,
      "Hacıemin": true,
      "Hasanbey": true,
      "İnönü": true,
      "Karaer": true,
      "Karşıyaka": true,
      "Mezire": true,
      "Oltanbey": true,
      "Osman Gazi": true,
      "Özcan": true,
      "Süleymaniye": true,
      "Yeni": true
    },
    "Şiran": {
      "Akyayla": true,
      "Alacahan": true,
      "Beydere": true,
      "Bilgili": true,
      "Erenkaya": true,
      "Fatih": true,
      "Karaca": true,
      "Konaklı": true,
      "Mertekli": true,
      "Örenkale": true,
      "Şehit Hakan": true,
      "Tekke": true,
      "Yeşilkent": true,
      "Yeşilyurt": true
    },
    "Torul": {
      "Bahçecik": true,
      "Çamlıca": true,
      "Kaledibi": true,
      "Köprübaşı": true,
      "Merkez": true,
      "Soğuksu": true,
      "Tufaniye": true,
      "Tuğrulbey": true
    }
  },
  "Hakkari": {
    "Çukurca": {
      "Cumhuriyet": true,
      "Emirşaban": true,
      "Yeşil Çeşme": true
    },
    "Derecik": {
      "Balkaya": true,
      "Güney": true,
      "Gürmeşe": true,
      "Hacıbey": true,
      "Merkez": true,
      "Orta": true,
      "Rize": true,
      "Üçyan": true,
      "Vapurtepe": true
    },
    "Merkez": {
      "Bağlar": true,
      "Bağlarbaşı": true,
      "Berçelan": true,
      "Biçenek": true,
      "Biçer": true,
      "Bulak": true,
      "Cumhuriyet": true,
      "Çaylıca": true,
      "Dağgöl": true,
      "Gazi": true,
      "Halife Derviş": true,
      "Karşıyaka": true,
      "Keklikpınar": true,
      "Kıran": true,
      "Köyiçi": true,
      "Medrese": true,
      "Merzan": true,
      "Pehlivan": true,
      "Pınarbaşı": true,
      "Sümbül": true,
      "Yeni": true
    },
    "Şemdinli": {
      "Beşevler": true,
      "Karşıyaka": true,
      "Moda": true,
      "Yayla": true,
      "Yeni": true
    },
    "Yüksekova": {
      "Akalın": true,
      "Aksu": true,
      "Altınoluk": true,
      "Beşbulak": true,
      "Bölük": true,
      "Cumhuriyet": true,
      "Dedeler": true,
      "Dize": true,
      "Esen Yurt": true,
      "Esentepe": true,
      "Eski Kışla": true,
      "Güçlü": true,
      "Güllüce": true,
      "Güngör": true,
      "Güvenli": true,
      "İnanlı": true,
      "İpek": true,
      "Kerem Zeydan": true,
      "Merkez": true,
      "Mezarlık": true,
      "Sarıyıldız": true,
      "Vezirli": true,
      "Yeni": true,
      "Yeşildere": true,
      "Yeşilova": true,
      "Yılmaz": true,
      "Yoncalık": true
    }
  },
  "Hatay": {
    "Altınözü": {
      "Akamber": true,
      "Akdarı": true,
      "Alakent": true,
      "Altınkaya": true,
      "Atayurdu": true,
      "Avuttepe": true,
      "Babatorun": true,
      "Boynuyoğun": true,
      "Büyükburç": true,
      "Çetenli": true,
      "Dokuzdal": true,
      "Enek": true,
      "Erbaşı": true,
      "Fatikli": true,
      "Gözecik": true,
      "Günvuran": true,
      "Hacıpaşa": true,
      "Hanyolu": true,
      "Kamberli": true,
      "Kansu": true,
      "Karbeyaz": true,
      "Karsu": true,
      "Kazancık": true,
      "Keskincik": true,
      "Kılıçtutan": true,
      "Kıyıgören": true,
      "Kolcular": true,
      "Kozkalesi": true,
      "Kurtmezraası": true,
      "Mayadalı": true,
      "Oymaklı": true,
      "Sarıbük": true,
      "Sarılar": true,
      "Seferli": true,
      "Sivrikavak": true,
      "Sofular": true,
      "Tepehan": true,
      "Tokaçlı": true,
      "Tokdemir": true,
      "Toprakhisar": true,
      "Türkmenmezraası": true,
      "Yanıkpınar": true,
      "Yarseli": true,
      "Yenihisar": true,
      "Yenişehir": true,
      "Yolağzı": true,
      "Yunushanı": true,
      "Zeytindalı": true,
      "Ziyaret": true
    },
    "Antakya": {
      "Açıkdere": true,
      "Akasya": true,
      "Akcurun": true,
      "Akçaova": true,
      "Akevler": true,
      "Akhisar": true,
      "Aksaray": true,
      "Alaattin": true,
      "Alahan": true,
      "Alazı": true,
      "Altınçay": true,
      "Anayazı": true,
      "Apaydın": true,
      "Arpahan": true,
      "Aşağıoba": true,
      "Avsuyu": true,
      "Aydınlıkevler": true,
      "Bağrıyanık": true,
      "Barbaros": true,
      "Biniciler": true,
      "Bitiren": true,
      "Bohşin": true,
      "Bozhöyük": true,
      "Büyükdalyan": true,
      "Cebrail": true,
      "Cumhuriyet": true,
      "Demirköprü": true,
      "Derince": true,
      "Dikmece": true,
      "Doğanköy": true,
      "Dutdibi": true,
      "Ekinci": true,
      "Emek": true,
      "Esenlik": true,
      "Esentepe": true,
      "Fevzi Çakmak": true,
      "Gazi": true,
      "Gazi Paşa": true,
      "General Şükrü Kanatlı": true,
      "Gökçegöz": true,
      "Gülderen": true,
      "Güllü Bahçe": true,
      "Günyazı": true,
      "Güzelburç": true,
      "Habib-i Neccar": true,
      "Hacı Ömer Alpagot": true,
      "Haraparası": true,
      "Hasanlı": true,
      "Havuzlar": true,
      "İplik Pazarı": true,
      "Kantara": true,
      "Karaali": true,
      "Karaali Bölüğü": true,
      "Kardeşler": true,
      "Karlısu": true,
      "Kışla Saray": true,
      "Kisecik": true,
      "Kocaabdi": true,
      "Kuruyer": true,
      "Kuyulu": true,
      "Kuzeytepe": true,
      "Küçükdalyan": true,
      "Madenboyu": true,
      "Mansurlu": true,
      "Maraşboğazı": true,
      "Maşuklu": true,
      "Melekli": true,
      "Meydan": true,
      "Narlıca": true,
      "Odabaşı": true,
      "Oğlakören": true,
      "Orhanlı": true,
      "Ovakent": true,
      "Paşaköy": true,
      "Saçaklı": true,
      "Saraycık": true,
      "Saraykent": true,
      "Serinyol": true,
      "Sofular": true,
      "Suvatlı": true,
      "Şehitler": true,
      "Şeyhali": true,
      "Şirince": true,
      "Tahtaköprü": true,
      "Tanışma": true,
      "Ulucamii": true,
      "Uzunaliç": true,
      "Üçgedik": true,
      "Ürgen Paşa": true,
      "Üzümdalı": true,
      "Yaylacık": true,
      "Yeni Camii": true,
      "Yeşilova": true,
      "Zenginler": true,
      "Zülüflühan": true
    },
    "Arsuz": {
      "Akçalı": true,
      "Arpaçiftlik": true,
      "Arpaderesi": true,
      "Arpagedik": true,
      "Aşağı Kepirce": true,
      "Avcılarsuyu": true,
      "Beyköyü": true,
      "Çetillik": true,
      "Derekuyu": true,
      "Gökmeydan": true,
      "Gözcüler": true,
      "Gülcihan": true,
      "Hacıahmetli": true,
      "Harlısu": true,
      "Haymaseki": true,
      "Helvalı": true,
      "Hüyük": true,
      "Işıklı": true,
      "Kale": true,
      "Karaağaç Cumhuriyet": true,
      "Karaağaç Konarlı": true,
      "Karaağaç Övündük": true,
      "Karaağaç Şarkonak": true,
      "Karagöz": true,
      "Karahüseyinli": true,
      "Kışla": true,
      "Konacık": true,
      "Kozaklı": true,
      "Kurtbağı": true,
      "Madenli": true,
      "Nardüzü": true,
      "Nergizlik": true,
      "Pirinçlik": true,
      "Tatarlı": true,
      "Tülek": true,
      "Uluçınar": true,
      "Üçgüllük": true,
      "Yukarıkepirce": true
    },
    "Belen": {
      "Atik": true,
      "Bakras": true,
      "Benlidere": true,
      "Cumhuriyet": true,
      "Çakallı": true,
      "Çerçikaya": true,
      "Derebahçe": true,
      "Fatih": true,
      "Halilbey": true,
      "İssume": true,
      "Kıcı": true,
      "Kömürçukuru": true,
      "Muhlisali": true,
      "Müftüler": true,
      "Ötençay": true,
      "Sarımazı": true,
      "Soğukoluk": true,
      "Şekere": true,
      "Şenbük": true
    },
    "Defne": {
      "Akdeniz": true,
      "Aknehir": true,
      "Armutlu": true,
      "Aşağıokçular": true,
      "Bahçeköy": true,
      "Balıklıdere": true,
      "Ballıöz": true,
      "Bostancık": true,
      "Büyükçat": true,
      "Çardaklı": true,
      "Çekmece": true,
      "Çınarlı": true,
      "Çökek": true,
      "Değirmenyolu": true,
      "Döver": true,
      "Dursunlu": true,
      "Elektrik": true,
      "Gümüşgöze": true,
      "Güneysöğüt": true,
      "Hancağız": true,
      "Harbiye": true,
      "Hüseyinli": true,
      "Karşıyaka": true,
      "Koçören": true,
      "Meydancık": true,
      "Orhanlı": true,
      "Özbek": true,
      "Samankaya": true,
      "Sinanlı": true,
      "Subaşı": true,
      "Sümerler": true,
      "Tavla": true,
      "Toygarlı": true,
      "Turunçlu": true,
      "Üzengili": true,
      "Yeniçağ": true,
      "Yeşilpınar": true
    },
    "Dörtyol": {
      "Altınçağ": true,
      "Çatköy": true,
      "Çaylı": true,
      "Kapılı": true,
      "Karakese": true,
      "Kışlalar": true,
      "Konaklı": true,
      "Kuzuculu": true,
      "Numune Evler": true,
      "Ocaklı": true,
      "Özerli": true,
      "Sanayi": true,
      "Yeniyurt": true,
      "Yeşil": true,
      "Yeşilköy": true
    },
    "Erzin": {
      "Aşağıburnaz": true,
      "Bahçelievler": true,
      "Başlamış": true,
      "Cumhuriyet": true,
      "Gökdere": true,
      "Gökgöl": true,
      "Hürriyet": true,
      "İsali": true,
      "İstiklal": true,
      "Karamustafalı": true,
      "Kızlarçayı": true,
      "Kuyuluk": true,
      "Mahmutlu": true,
      "Mustafalı": true,
      "Şükrü Paşa": true,
      "Turunçlu": true,
      "Yeni": true,
      "Yeşiltepe": true,
      "Yoncadüzü": true,
      "Yukarıburnaz": true
    },
    "Hassa": {
      "15 Kasım": true,
      "Akbez": true,
      "Akkülek": true,
      "Aktepe": true,
      "Ardıçlı": true,
      "Arpalıuşağı": true,
      "Aşağıkarafakılı": true,
      "Bademli": true,
      "Bintaş": true,
      "Buhara": true,
      "Çay": true,
      "Çınarbaşı": true,
      "Dedemli": true,
      "Demrek": true,
      "Derviş Paşa": true,
      "Eğribucak": true,
      "Gazeluşağı": true,
      "Girne": true,
      "Gülkent": true,
      "Gülpınar": true,
      "Güvenç": true,
      "Hacılar": true,
      "Haydarlar": true,
      "Katranlık": true,
      "Koruhüyük": true,
      "Küreci": true,
      "Mazmanlı": true,
      "Sapanözü": true,
      "Söğüt": true,
      "Sugediği": true,
      "Tepebaşı": true,
      "Tiyek": true,
      "Yeni": true,
      "Yeniyapan": true,
      "Yoluklar": true,
      "Yukarıbucak": true,
      "Yukarıkarafakılı": true,
      "Yuvalı": true,
      "Zeytinoba": true
    },
    "İskenderun": {
      "Akarca": true,
      "Akçay": true,
      "Aşkarbeyli": true,
      "Azganlık": true,
      "Barbaros": true,
      "Barıştepe": true,
      "Bekbele": true,
      "Bitişik": true,
      "Buluttepe": true,
      "Büyükdere": true,
      "Cebike": true,
      "Cırtıman": true,
      "Cumhuriyet": true,
      "Çay": true,
      "Çınarlı": true,
      "Denizciler": true,
      "Dumlupınar": true,
      "Esentepe": true,
      "Fatih Sultan Mehmet": true,
      "Gültepe": true,
      "Gürsel": true,
      "Güzelçay": true,
      "Hürriyet": true,
      "İsmet Inönü": true,
      "Kaledibi": true,
      "Karayılan": true,
      "Kavaklıoluk": true,
      "Kocatepe": true,
      "Kurtuluş": true,
      "Meydan": true,
      "Modernevler": true,
      "Muradiye": true,
      "Mustafa Kemal": true,
      "Numune": true,
      "Orhangazi": true,
      "Pınarbaşı": true,
      "Pirireis": true,
      "Sakarya": true,
      "Sarıseki": true,
      "Savaş": true,
      "Suçıkağı": true,
      "Süleymaniye": true,
      "Yenişehir": true,
      "Yıldırımtepe": true,
      "Yunus Emre": true
    },
    "Kırıkhan": {
      "408 Evler": true,
      "Abalaklı": true,
      "Adalar": true,
      "Alaybeyli": true,
      "Alibeyçağıllı": true,
      "Alparslan": true,
      "Alsancak": true,
      "Arkıtça": true,
      "Attutan": true,
      "Aydınlı": true,
      "Aygırgölü": true,
      "Bahçelievler": true,
      "Balarmudu": true,
      "Baldıran": true,
      "Barbaros": true,
      "Başpınar": true,
      "Bektaşlı": true,
      "Camuzkışlası": true,
      "Ceylanlı": true,
      "Cumhuriyet": true,
      "Çamsarı": true,
      "Çamseki": true,
      "Çankaya": true,
      "Çataltepe": true,
      "Çiloğlanhüyüğü": true,
      "Danaahmetli": true,
      "Dedeçınar": true,
      "Delibekirli": true,
      "Demirkonak": true,
      "Fatih": true,
      "Gazi": true,
      "Gölbaşı": true,
      "Gültepe": true,
      "Gündüz": true,
      "Güventaşı": true,
      "Güzelce": true,
      "Ilıkpınar": true,
      "İçada": true,
      "İncirli": true,
      "Kaletepe": true,
      "Kamberlikaya": true,
      "Kamışlar": true,
      "Kangallar": true,
      "Karaçağıl": true,
      "Karadurmuşlu": true,
      "Karaelmaslı": true,
      "Karamağara": true,
      "Karamankaşı": true,
      "Karataş": true,
      "Kazkeli": true,
      "Kızılkaya": true,
      "Kodallı": true,
      "Kurtlusarımazı": true,
      "Kurtlusoğuksu": true,
      "Kurtuluş": true,
      "Mahmutlu": true,
      "Menderes": true,
      "Mimar Sinan": true,
      "Muratpaşa": true,
      "Narlıhopur": true,
      "Özkızılkaya": true,
      "Özsoğuksu": true,
      "Özyörük": true,
      "Reşatlı": true,
      "Saylak": true,
      "Söğütlüöz": true,
      "Sucuköy": true,
      "Taşoluk": true,
      "Topboğazı": true,
      "Torun": true,
      "Yalangoz": true,
      "Yeni": true,
      "Yılanlı": true
    },
    "Kumlu": {
      "Akkerpiç": true,
      "Akkuyu": true,
      "Akpınar": true,
      "Aktaş": true,
      "Batıayrancı": true,
      "Cumhuriyet": true,
      "Doğuayrancı": true,
      "Fevzi Çakmak": true,
      "Gökçeoğlu": true,
      "Gülova": true,
      "Hamam": true,
      "Hatayhamamı": true,
      "Kaletepe": true,
      "Keli": true,
      "Kırcaoğlu": true,
      "Muharrem": true
    },
    "Payas": {
      "Bayraktepe": true,
      "Cumhuriyet": true,
      "Çağlalık": true,
      "Fatih": true,
      "İstiklal": true,
      "Karacami": true,
      "Karbeyaz": true,
      "Karşı": true,
      "Kozludere": true,
      "Kürtül": true,
      "Sincan": true,
      "Yenişehir": true,
      "Yıldırım Beyazıt": true
    },
    "Reyhanlı": {
      "Adabucak": true,
      "Ahmetbeyli": true,
      "Akyayla": true,
      "Alakuzu": true,
      "Bağlar": true,
      "Bahçelievler": true,
      "Bayır": true,
      "Beşaslan": true,
      "Bükülmez": true,
      "Cilvegözü": true,
      "Cumhuriyet": true,
      "Cüdeyde": true,
      "Çakıryiğit": true,
      "Davutpaşa": true,
      "Değirmenkaşı": true,
      "Esentepe": true,
      "Fevzipaşa": true,
      "Fidanlık": true,
      "Gazimürseltepesi": true,
      "Göktepe": true,
      "Gültepe": true,
      "Harran": true,
      "Karacanlık": true,
      "Karahüyük": true,
      "Karasüleymanlı": true,
      "Konuk": true,
      "Kuletepe": true,
      "Kumtepe": true,
      "Kurtuluş": true,
      "Kuşaklı": true,
      "Mehmetbeyli": true,
      "Mustafa Kemal": true,
      "Nergizli": true,
      "Oğulpınar": true,
      "Öz Kurtuluş": true,
      "Paşahüyük": true,
      "Paşaköy": true,
      "Pınarbaşı": true,
      "Suluköy": true,
      "Tayfursökmen": true,
      "Terzihüyük": true,
      "Uzunkavak": true,
      "Üçtepe": true,
      "Varışlı": true,
      "Yeni": true,
      "Yenişehir": true,
      "Yeşilova": true
    },
    "Samandağ": {
      "Ataköy": true,
      "Atatürk": true,
      "Avcılar": true,
      "Batıayaz": true,
      "Büyükoba": true,
      "Cemal Gürsel": true,
      "Ceylandere": true,
      "Cumhuriyet": true,
      "Çamlıyayla": true,
      "Çanakoluk": true,
      "Çiğdede": true,
      "Çöğürlü": true,
      "Çubuklu": true,
      "Değirmenbaşı": true,
      "Deniz": true,
      "Eriklikuyu": true,
      "Fidanlı": true,
      "General Şükrü Kanadlı": true,
      "Gözene": true,
      "Hıdırbey": true,
      "Huzurlu": true,
      "Kapısuyu": true,
      "Karaçay": true,
      "Koyunoğlu": true,
      "Kurtderesi": true,
      "Kuşalanı": true,
      "Mağaracık": true,
      "Meydan": true,
      "Mızraklı": true,
      "Seldiren": true,
      "Sutaşı": true,
      "Tekebaşı": true,
      "Tomruksuyu": true,
      "Uzunbağ": true,
      "Vakıfköy": true,
      "Yaylıca": true,
      "Yeni": true,
      "Yeniköy": true,
      "Yeşilada": true,
      "Yeşilköy": true,
      "Yeşilyazı": true,
      "Yoğunoluk": true
    },
    "Yayladağı": {
      "Arslanyazı": true,
      "Aşağıpulluyazı": true,
      "Aydınbahçe": true,
      "Ayışığı": true,
      "Bezge": true,
      "Bozlu": true,
      "Çabala": true,
      "Çakı": true,
      "Çaksına": true,
      "Çamaltı": true,
      "Çandır": true,
      "Çatbaşı": true,
      "Çayır": true,
      "Denizgören": true,
      "Dusduru": true,
      "Eğerci": true,
      "Görentaş": true,
      "Gözlüce": true,
      "Gürışık": true,
      "Güveççi": true,
      "Güzelyurt": true,
      "Hisarcık": true,
      "Karacurun": true,
      "Karaköse": true,
      "Kışlak": true,
      "Kızılçat": true,
      "Kösrelik": true,
      "Kulaç": true,
      "Kurtuluş": true,
      "Leylekli": true,
      "Olgunlar": true,
      "Sebenoba": true,
      "Sungur": true,
      "Sürütme": true,
      "Şakşak": true,
      "Şenköy": true,
      "Turfanda": true,
      "Tutlubahçe": true,
      "Uluyol": true,
      "Üçırmak": true,
      "Yalaz": true,
      "Yayıkdamlar": true,
      "Yenice": true,
      "Yeşiltepe": true,
      "Yoncakaya": true,
      "Yukarıokçular": true,
      "Yukarıpulluyazı": true
    }
  },
  "Iğdır": {
    "Aralık": {
      "Aras": true,
      "Karasu": true,
      "Karşıyaka": true,
      "Köprüler": true,
      "Ortaköy": true
    },
    "Karakoyunlu": {
      "Ergenekon": true,
      "Fatih": true
    },
    "Merkez": {
      "14 Kasım": true,
      "Ali Kamerli": true,
      "Atatürk": true,
      "Bağlar": true,
      "Bahçelievler": true,
      "Cumhuriyet": true,
      "Emek": true,
      "Faruktoka": true,
      "Hakveyis": true,
      "Hoca Ibrahim Güneş": true,
      "Karaağaç": true,
      "Karabağ": true,
      "Konaklı": true,
      "Mehmet Akif Ersoy": true,
      "Namık Kemal": true,
      "Özgür": true,
      "Özvatan": true,
      "Pir Sultan Abdal": true,
      "Said Nursi": true,
      "Söğütlü": true,
      "Topçular": true,
      "Turgut Özal": true,
      "Yeni": true,
      "Yunus Emre": true
    },
    "Tuzluca": {
      "Aşağı": true,
      "Cumhuriyet": true,
      "Orta": true,
      "Yeni": true,
      "Yukarı": true
    }
  },
  "Isparta": {
    "Aksu": {
      "Akçaşar": true,
      "Bahçeli": true,
      "Çay": true,
      "Hürriyet": true,
      "İstiklal": true,
      "Kurtuluş": true,
      "Orta": true,
      "Pazarcık": true,
      "Tepe": true
    },
    "Atabey": {
      "Altunba": true,
      "Çeşme": true,
      "Gezirler": true,
      "Müftü": true,
      "Onaç": true,
      "Pazar": true,
      "Sinan": true,
      "Sökmen": true,
      "Yeni": true
    },
    "Eğirdir": {
      "Ağa": true,
      "Altınkum": true,
      "Bağbuyan": true,
      "Bağlar": true,
      "Camii": true,
      "Demirkapı": true,
      "Dere": true,
      "Hacışeyh": true,
      "Hamam": true,
      "Hürriyet": true,
      "İmaret": true,
      "İstasyon": true,
      "İstiklal": true,
      "Kale": true,
      "Katip": true,
      "Kızılçubuk": true,
      "Konya Bucağı": true,
      "Kubbeli": true,
      "Menderes": true,
      "Pınar Pazarı": true,
      "Poyraz": true,
      "Sanayi": true,
      "Sekibağ": true,
      "Seydim": true,
      "Yazla": true,
      "Yeni": true,
      "Yeşilada": true
    },
    "Gelendost": {
      "17 Eylül": true,
      "Aşağı": true,
      "Bahçelievler": true,
      "Haydarpaşa": true,
      "Hüseyin Avni Paşa": true,
      "Kırevler": true,
      "Muharrem": true,
      "Orta": true,
      "Selçuk": true,
      "Yeni": true
    },
    "Gönen": {
      "Alaca Mescit": true,
      "Baladız": true,
      "Cami": true,
      "Göletevleri": true,
      "Kasap": true,
      "Musalla": true,
      "Orta": true,
      "Pazar": true,
      "Tekke": true,
      "Yenice": true
    },
    "Keçiborlu": {
      "Aşağı": true,
      "Cumhuriyet": true,
      "Hacı Köyü": true,
      "Hasanbey": true,
      "Kaya": true,
      "Kuşçular": true,
      "Kükürt": true,
      "Orta": true,
      "Tepecik": true,
      "Toki": true,
      "Tuzla": true,
      "Yeni": true,
      "Yenice": true,
      "Yukarı": true
    },
    "Merkez": {
      "Akkent": true,
      "Anadolu": true,
      "Aşağı": true,
      "Ayazmana": true,
      "Bağlar": true,
      "Bahçelievler": true,
      "Batıkent": true,
      "Binbirevler": true,
      "Çelebiler": true,
      "Çünür": true,
      "Davraz": true,
      "Dere": true,
      "Doğancı": true,
      "Emre": true,
      "Fatih": true,
      "Gazi Kemal": true,
      "Gülcü": true,
      "Gülevler": true,
      "Gülistan": true,
      "Halıkent": true,
      "Halife Sultan": true,
      "Hızırbey": true,
      "Hisar": true,
      "Işıkkent": true,
      "İskender": true,
      "İstiklal": true,
      "Karaağaç": true,
      "Keçeci": true,
      "Kemal": true,
      "Kepeci": true,
      "Kurtuluş": true,
      "Kutlubey": true,
      "Mehmet Tönge": true,
      "Modern Evler": true,
      "Muzaffer Türkeş": true,
      "Okul": true,
      "Pirimehmet": true,
      "Sanayi": true,
      "Sermet": true,
      "Sidre": true,
      "Sülübey": true,
      "Turan": true,
      "Vatan": true,
      "Yayla": true,
      "Yedişehitler": true,
      "Yenicami": true,
      "Yenice": true,
      "Yukarı": true,
      "Zafer": true
    },
    "Senirkent": {
      "16 Haziran": true,
      "Camii": true,
      "Cumhuriyet": true,
      "Dere": true,
      "Hamidiye": true,
      "İstiklal": true,
      "Karşı": true,
      "Kıbrıs": true,
      "Orta": true,
      "Sultan Süleyman": true,
      "Süleyman Demirel": true,
      "Şehler": true,
      "Taşmescit": true,
      "Turgutlar": true,
      "Zafer": true
    },
    "Sütçüler": {
      "Başkoz": true,
      "Belen": true,
      "Birlik": true,
      "Cami": true,
      "Erenler": true,
      "Yeşildere": true,
      "Yukarı": true
    },
    "Şarkikaraağaç": {
      "Alcıklar": true,
      "Asılkale": true,
      "Aşağı": true,
      "Aşağıkale": true,
      "Bölükler": true,
      "Camikebir": true,
      "Cumhuriyet": true,
      "Çördük": true,
      "Çukur": true,
      "Fatih": true,
      "Kerkük": true,
      "Orta": true,
      "Suvar": true,
      "Ulu": true,
      "Ulvikale": true
    },
    "Uluborlu": {
      "Güreşyeri": true,
      "Hamideli": true,
      "Kabaağaç": true,
      "Kösehasan": true,
      "Namazgah": true,
      "Pazar": true,
      "Selçuklu": true,
      "Serenler": true,
      "Taşköprü": true,
      "Topraklık": true,
      "Zincirli": true
    },
    "Yalvaç": {
      "Abacılar": true,
      "Akköprü": true,
      "Bağlar": true,
      "Bahçelievler": true,
      "Cumhuriyet": true,
      "Çarşı": true,
      "Debbağlar": true,
      "Eski": true,
      "Eskigeçit": true,
      "Fatih": true,
      "Görgü Bayram": true,
      "Görgü Camii": true,
      "Görgüorta": true,
      "Kaşaşağı": true,
      "Kaşcami": true,
      "Kaşhacıbey": true,
      "Kaşyukarı": true,
      "Kızılca": true,
      "Kuşku": true,
      "Leblebiciler": true,
      "Mescit": true,
      "Müderris": true,
      "Nalbant": true,
      "Pazar Aşağı": true,
      "Pazar Yukarı": true,
      "Salur": true,
      "Sanayi": true,
      "Saray": true,
      "Sofular": true,
      "Yanarık": true,
      "Yeni": true,
      "Zafer": true
    },
    "Yenişarbademli": {
      "Gündoğdu": true,
      "Pınarbaşı": true,
      "Yenicami": true,
      "Yenice": true
    }
  },
  "İstanbul": {
    "Adalar": {
      "Burgazada": true,
      "Heybeliada": true,
      "Kınalıada": true,
      "Maden": true,
      "Nizam": true
    },
    "Arnavutköy": {
      "Adnan Menderes": true,
      "Anadolu": true,
      "Arnavutköy Merkez": true,
      "Atatürk": true,
      "Baklalı": true,
      "Balaban": true,
      "Boğazköy Istiklal": true,
      "Bolluca": true,
      "Boyalık": true,
      "Çilingir": true,
      "Deliklikaya": true,
      "Dursunköy": true,
      "Durusu": true,
      "Fatih": true,
      "Hacımaşlı": true,
      "Hadımköy": true,
      "Haraççı": true,
      "Hastane": true,
      "Hicret": true,
      "İmrahor": true,
      "İslambey": true,
      "Karaburun": true,
      "Karlıbayır": true,
      "Mareşal Fevzi Çakmak": true,
      "Mavigöl": true,
      "Mehmet Akif Ersoy": true,
      "Mustafa Kemal Paşa": true,
      "Nenehatun": true,
      "Ömerli": true,
      "Sazlıbosna": true,
      "Taşoluk": true,
      "Tayakadın": true,
      "Terkos": true,
      "Yassıören": true,
      "Yavuz Selim": true,
      "Yeniköy": true,
      "Yeşilbayır": true,
      "Yunus Emre": true
    },
    "Ataşehir": {
      "Aşıkveysel": true,
      "Atatürk": true,
      "Barbaros": true,
      "Esatpaşa": true,
      "Ferhatpaşa": true,
      "Fetih": true,
      "İçerenköy": true,
      "İnönü": true,
      "Kayışdağı": true,
      "Küçükbakkalköy": true,
      "Mevlana": true,
      "Mimar Sinan": true,
      "Mustafa Kemal": true,
      "Örnek": true,
      "Yeni Çamlıca": true,
      "Yenisahra": true,
      "Yenişehir": true
    },
    "Avcılar": {
      "Ambarlı": true,
      "Cihangir": true,
      "Denizköşkler": true,
      "Firuzköy": true,
      "Gümüşpala": true,
      "Merkez": true,
      "Mustafa Kemalpaşa": true,
      "Tahtakale": true,
      "Üniversite": true,
      "Yeşilkent": true
    },
    "Bağcılar": {
      "100. Yıl": true,
      "15 Temmuz": true,
      "Bağlar": true,
      "Barbaros": true,
      "Çınar": true,
      "Demirkapı": true,
      "Fatih": true,
      "Fevzi Çakmak": true,
      "Göztepe": true,
      "Güneşli": true,
      "Hürriyet": true,
      "İnönü": true,
      "Kazım Karabekir": true,
      "Kemalpaşa": true,
      "Kirazlı": true,
      "Mahmutbey": true,
      "Merkez": true,
      "Sancaktepe": true,
      "Yavuz Selim": true,
      "Yenigün": true,
      "Yenimahalle": true,
      "Yıldıztepe": true
    },
    "Bahçelievler": {
      "Bahçelievler": true,
      "Cumhuriyet": true,
      "Çobançeşme": true,
      "Fevzi Çakmak": true,
      "Hürriyet": true,
      "Kocasinan Merkez": true,
      "Siyavuşpaşa": true,
      "Soğanlı": true,
      "Şirinevler": true,
      "Yenibosna Merkez": true,
      "Zafer": true
    },
    "Bakırköy": {
      "Ataköy 1. Kısım": true,
      "Ataköy 2-5-6. Kısım": true,
      "Ataköy 3-4-11. Kısım": true,
      "Ataköy 7-8-9-10. Kısım": true,
      "Basınköy": true,
      "Cevizlik": true,
      "Kartaltepe": true,
      "Osmaniye": true,
      "Sakızağacı": true,
      "Şenlikköy": true,
      "Yenimahalle": true,
      "Yeşilköy": true,
      "Yeşilyurt": true,
      "Zeytinlik": true,
      "Zuhuratbaba": true
    },
    "Başakşehir": {
      "Altınşehir": true,
      "Bahçeşehir 1. Kısım": true,
      "Bahçeşehir 2. Kısım": true,
      "Başak": true,
      "Başakşehir": true,
      "Güvercintepe": true,
      "Kayabaşı": true,
      "Şahintepe": true,
      "Şamlar": true,
      "Ziya Gökalp": true
    },
    "Bayrampaşa": {
      "Altıntepsi": true,
      "Cevatpaşa": true,
      "İsmet Paşa": true,
      "Kartaltepe": true,
      "Kocatepe": true,
      "Muratpaşa": true,
      "Orta": true,
      "Terazidere": true,
      "Vatan": true,
      "Yenidoğan": true,
      "Yıldırım": true
    },
    "Beşiktaş": {
      "Abbasağa": true,
      "Akat": true,
      "Arnavutköy": true,
      "Balmumcu": true,
      "Bebek": true,
      "Cihannüma": true,
      "Dikilitaş": true,
      "Etiler": true,
      "Gayrettepe": true,
      "Konaklar": true,
      "Kuruçeşme": true,
      "Kültür": true,
      "Levazım": true,
      "Levent": true,
      "Mecidiye": true,
      "Muradiye": true,
      "Nisbetiye": true,
      "Ortaköy": true,
      "Sinanpaşa": true,
      "Türkali": true,
      "Ulus": true,
      "Vişnezade": true,
      "Yıldız": true
    },
    "Beykoz": {
      "Acarlar": true,
      "Akbaba": true,
      "Alibahadır": true,
      "Anadolu Hisarı": true,
      "Anadolu Kavağı": true,
      "Anadolufeneri": true,
      "Baklacı": true,
      "Bozhane": true,
      "Cumhuriyet": true,
      "Çamlıbahçe": true,
      "Çengeldere": true,
      "Çiftlik": true,
      "Çiğdem": true,
      "Çubuklu": true,
      "Dereseki": true,
      "Elmalı": true,
      "Fatih": true,
      "Göksu": true,
      "Göllü": true,
      "Görele": true,
      "Göztepe": true,
      "Gümüşsuyu": true,
      "İncirköy": true,
      "İshaklı": true,
      "Kanlıca": true,
      "Kavacık": true,
      "Kaynarca": true,
      "Kılıçlı": true,
      "Mahmutşevketpaşa": true,
      "Merkez": true,
      "Ortaçeşme": true,
      "Öğümce": true,
      "Örnekköy": true,
      "Paşabahçe": true,
      "Paşamandıra": true,
      "Polonezköy": true,
      "Poyrazköy": true,
      "Riva": true,
      "Rüzgarlıbahçe": true,
      "Soğuksu": true,
      "Tokatköy": true,
      "Yalıköy": true,
      "Yavuz Selim": true,
      "Yeni Mahalle": true,
      "Zerzavatçı": true
    },
    "Beylikdüzü": {
      "Adnan Kahveci": true,
      "Barış": true,
      "Büyükşehir": true,
      "Cumhuriyet": true,
      "Dereağzı": true,
      "Gürpınar": true,
      "Kavaklı": true,
      "Marmara": true,
      "Sahil": true,
      "Yakuplu": true
    },
    "Beyoğlu": {
      "Arap Cami": true,
      "Asmalı Mescit": true,
      "Bedrettin": true,
      "Bereketzade": true,
      "Bostan": true,
      "Bülbül": true,
      "Camiikebir": true,
      "Cihangir": true,
      "Çatma Mescit": true,
      "Çukur": true,
      "Emekyemez": true,
      "Evliya Çelebi": true,
      "Fetihtepe": true,
      "Firuzağa": true,
      "Gümüşsuyu": true,
      "Hacıahmet": true,
      "Hacımimi": true,
      "Halıcıoğlu": true,
      "Hüseyinağa": true,
      "İstiklal": true,
      "Kadımehmet Efendi": true,
      "Kalyoncu Kulluğu": true,
      "Kamer Hatun": true,
      "Kaptanpaşa": true,
      "Katipmustafa Çelebi": true,
      "Keçeci Piri": true,
      "Kemankeş Karamustafapaşa": true,
      "Kılıçali Paşa": true,
      "Kocatepe": true,
      "Kulaksız": true,
      "Kuloğlu": true,
      "Küçük Piyale": true,
      "Müeyyetzade": true,
      "Ömer Avni": true,
      "Örnektepe": true,
      "Piripaşa": true,
      "Piyalepaşa": true,
      "Pürtelaş Hasan Efendi": true,
      "Sururi Mehmet Efendi": true,
      "Sütlüce": true,
      "Şahkulu": true,
      "Şehit Muhtar": true,
      "Tomtom": true,
      "Yahya Kahya": true,
      "Yenişehir": true
    },
    "Büyükçekmece": {
      "19 Mayıs": true,
      "Ahmediye": true,
      "Alkent 2000": true,
      "Atatürk": true,
      "Bahçelievler": true,
      "Celaliye": true,
      "Cumhuriyet": true,
      "Çakmaklı": true,
      "Dizdariye": true,
      "Ekinoba": true,
      "Fatih": true,
      "Güzelce": true,
      "Hürriyet": true,
      "Kamiloba": true,
      "Karaağaç": true,
      "Kumburgaz": true,
      "Mimaroba": true,
      "Mimarsinan": true,
      "Murat Çesme": true,
      "Pınartepe": true,
      "Sinanoba": true,
      "Türkoba": true,
      "Ulus": true,
      "Yenimahalle": true
    },
    "Çatalca": {
      "Akalan": true,
      "Atatürk": true,
      "Aydınlar": true,
      "Bahşayiş": true,
      "Başak": true,
      "Belgrat": true,
      "Celepköy": true,
      "Çakıl": true,
      "Çanakça": true,
      "Çiftlikköy": true,
      "Dağyenice": true,
      "Elbasan": true,
      "Fatih": true,
      "Ferhatpaşa": true,
      "Gökçeali": true,
      "Gümüşpınar": true,
      "Hallaçlı": true,
      "Hisarbeyli": true,
      "İhsaniye": true,
      "İnceğiz": true,
      "İzzettin": true,
      "Kabakça": true,
      "Kaleiçi": true,
      "Kalfa": true,
      "Karacaköy Merkez": true,
      "Karamandere": true,
      "Kestanelik": true,
      "Kızılcaali": true,
      "Muratbey Merkez": true,
      "Nakkaş": true,
      "Oklalı": true,
      "Ormanlı": true,
      "Ovayenice": true,
      "Örcünlü": true,
      "Örencik": true,
      "Subaşı": true,
      "Yalıköy": true,
      "Yaylacık": true,
      "Yazlık": true
    },
    "Çekmeköy": {
      "Alemdağ": true,
      "Aydınlar": true,
      "Cumhuriyet": true,
      "Çamlık": true,
      "Çatalmeşe": true,
      "Ekşioğlu": true,
      "Güngören": true,
      "Hamidiye": true,
      "Hüseyinli": true,
      "Kirazlıdere": true,
      "Koçullu": true,
      "Mehmet Akif": true,
      "Merkez": true,
      "Mimar Sinan": true,
      "Nişantepe": true,
      "Ömerli": true,
      "Reşadiye": true,
      "Sırapınar": true,
      "Soğukpınar": true,
      "Sultançiftliği": true,
      "Taşdelen": true
    },
    "Esenler": {
      "15 Temmuz": true,
      "Birlik": true,
      "Çifte Havuzlar": true,
      "Davutpaşa": true,
      "Fatih": true,
      "Fevzi Çakmak": true,
      "Havaalanı": true,
      "Kazım Karabekir": true,
      "Kemer": true,
      "Menderes": true,
      "Mimar Sinan": true,
      "Namık Kemal": true,
      "Nine Hatun": true,
      "Oruçreis": true,
      "Tuna": true,
      "Turgut Reis": true,
      "Yavuz Selim": true
    },
    "Esenyurt": {
      "Akçaburgaz": true,
      "Akevler": true,
      "Akşemseddin": true,
      "Ardıçlı": true,
      "Aşık Veysel": true,
      "Atatürk": true,
      "Bağlarçeşme": true,
      "Balıkyolu": true,
      "Barbaros Hayrettin Paşa": true,
      "Battalgazi": true,
      "Cumhuriyet": true,
      "Çınar": true,
      "Esenkent": true,
      "Fatih": true,
      "Gökevler": true,
      "Güzelyurt": true,
      "Hürriyet": true,
      "İncirtepe": true,
      "İnönü": true,
      "İstiklal": true,
      "Koza": true,
      "Mehmet Akif Ersoy": true,
      "Mehterçeşme": true,
      "Mevlana": true,
      "Namık Kemal": true,
      "Necip Fazıl Kısakürek": true,
      "Orhan Gazi": true,
      "Osmangazi": true,
      "Örnek": true,
      "Pınar": true,
      "Piri Reis": true,
      "Saadetdere": true,
      "Selahaddin Eyyubi": true,
      "Sultaniye": true,
      "Süleymaniye": true,
      "Şehitler": true,
      "Talatpaşa": true,
      "Turgut Özal": true,
      "Üçevler": true,
      "Yenikent": true,
      "Yeşilkent": true,
      "Yunus Emre": true,
      "Zafer": true
    },
    "Eyüpsultan": {
      "5.levent": true,
      "Ağaçlı": true,
      "Akpınar": true,
      "Akşemsettin": true,
      "Alibeyköy": true,
      "Çırçır": true,
      "Çiftalan": true,
      "Defterdar": true,
      "Düğmeciler": true,
      "Emniyettepe": true,
      "Esentepe": true,
      "Göktürk Merkez": true,
      "Güzeltepe": true,
      "Işıklar": true,
      "İhsaniye": true,
      "İslambey": true,
      "Karadolap": true,
      "Merkez": true,
      "Mimar Sinan": true,
      "Mithatpaşa": true,
      "Nişancı": true,
      "Odayeri": true,
      "Pirinççi": true,
      "Rami Cuma": true,
      "Rami Yeni": true,
      "Sakarya": true,
      "Silahtarağa": true,
      "Topçular": true,
      "Yeşilpınar": true
    },
    "Fatih": {
      "Aksaray": true,
      "Akşemsettin": true,
      "Alemdar": true,
      "Ali Kuşçu": true,
      "Atikali": true,
      "Ayvansaray": true,
      "Balabanağa": true,
      "Balat": true,
      "Beyazıt": true,
      "Binbirdirek": true,
      "Cankurtaran": true,
      "Cerrahpaşa": true,
      "Cibali": true,
      "Demirtaş": true,
      "Derviş Ali": true,
      "Emin Sinan": true,
      "Hacı Kadın": true,
      "Haseki Sultan": true,
      "Hırka-i Şerif": true,
      "Hobyar": true,
      "Hoca Gıyasettin": true,
      "Hocapaşa": true,
      "İskenderpaşa": true,
      "Kalenderhane": true,
      "Karagümrük": true,
      "Katip Kasım": true,
      "Kemalpaşa": true,
      "Koca Mustafapaşa": true,
      "Küçük Ayasofya": true,
      "Mercan": true,
      "Mesihpaşa": true,
      "Mevlanakapı": true,
      "Mimar Hayrettin": true,
      "Mimar Kemalettin": true,
      "Molla Fenari": true,
      "Molla Gürani": true,
      "Molla Hüsrev": true,
      "Muhsine Hatun": true,
      "Nişanca": true,
      "Rüstempaşa": true,
      "Saraç Ishak": true,
      "Seyyid Ömer": true,
      "Silivrikapı": true,
      "Sultan Ahmet": true,
      "Sururi": true,
      "Süleymaniye": true,
      "Sümbül Efendi": true,
      "Şehremini": true,
      "Şehsuvar Bey": true,
      "Tahtakale": true,
      "Taya Hatun": true,
      "Topkapı": true,
      "Yavuz Sinan": true,
      "Yavuz Sultan Selim": true,
      "Yedikule": true,
      "Zeyrek": true
    },
    "Gaziosmanpaşa": {
      "Bağlarbaşı": true,
      "Barbaros Hayrettin Paşa": true,
      "Fevzi Çakmak": true,
      "Hürriyet": true,
      "Karadeniz": true,
      "Karayolları": true,
      "Karlıtepe": true,
      "Kazım Karabekir": true,
      "Merkez": true,
      "Mevlana": true,
      "Pazariçi": true,
      "Sarıgöl": true,
      "Şemsipaşa": true,
      "Yeni Mahalle": true,
      "Yenidoğan": true,
      "Yıldıztabya": true
    },
    "Güngören": {
      "Abdurrahman Nafiz Gürman": true,
      "Akıncılar": true,
      "Gençosman": true,
      "Güneştepe": true,
      "Güven": true,
      "Haznedar": true,
      "Mareşal Çakmak": true,
      "Mehmet Nesih Özmen": true,
      "Merkez": true,
      "Sanayi": true,
      "Tozkoparan": true
    },
    "Kadıköy": {
      "19 Mayıs": true,
      "Acıbadem": true,
      "Bostancı": true,
      "Caddebostan": true,
      "Caferağa": true,
      "Dumlupınar": true,
      "Eğitim": true,
      "Erenköy": true,
      "Fenerbahçe": true,
      "Feneryolu": true,
      "Fikirtepe": true,
      "Göztepe": true,
      "Hasanpaşa": true,
      "Koşuyolu": true,
      "Kozyatağı": true,
      "Merdivenköy": true,
      "Osmanağa": true,
      "Rasimpaşa": true,
      "Sahrayıcedit": true,
      "Suadiye": true,
      "Zühtüpaşa": true
    },
    "Kağıthane": {
      "Çağlayan": true,
      "Çeliktepe": true,
      "Emniyet Evleri": true,
      "Gültepe": true,
      "Gürsel": true,
      "Hamidiye": true,
      "Harmantepe": true,
      "Hürriyet": true,
      "Mehmet Akif Ersoy": true,
      "Merkez": true,
      "Nurtepe": true,
      "Ortabayır": true,
      "Seyrantepe": true,
      "Sultan Selim": true,
      "Şirintepe": true,
      "Talatpaşa": true,
      "Telsizler": true,
      "Yahya Kemal": true,
      "Yeşilce": true
    },
    "Kartal": {
      "Atalar": true,
      "Cevizli": true,
      "Cumhuriyet": true,
      "Çavuşoğlu": true,
      "Esentepe": true,
      "Gümüşpınar": true,
      "Hürriyet": true,
      "Karlıktepe": true,
      "Kordonboyu": true,
      "Orhantepe": true,
      "Orta": true,
      "Petrol Iş": true,
      "Soğanlık Yeni": true,
      "Topselvi": true,
      "Uğur Mumcu": true,
      "Yakacık Çarşı": true,
      "Yakacık Yeni": true,
      "Yalı": true,
      "Yukarı": true,
      "Yunus": true
    },
    "Küçükçekmece": {
      "Atakent": true,
      "Atatürk": true,
      "Beşyol": true,
      "Cennet": true,
      "Cumhuriyet": true,
      "Fatih": true,
      "Fevzi Çakmak": true,
      "Gültepe": true,
      "Halkalı Merkez": true,
      "İnönü": true,
      "İstasyon": true,
      "Kanarya": true,
      "Kartaltepe": true,
      "Kemalpaşa": true,
      "Mehmet Akif": true,
      "Söğütlü Çeşme": true,
      "Sultan Murat": true,
      "Tevfikbey": true,
      "Yarımburgaz": true,
      "Yeni Mahalle": true,
      "Yeşilova": true
    },
    "Maltepe": {
      "Altayçeşme": true,
      "Altıntepe": true,
      "Aydınevler": true,
      "Bağlarbaşı": true,
      "Başıbüyük": true,
      "Büyükbakkalköy": true,
      "Cevizli": true,
      "Çınar": true,
      "Esenkent": true,
      "Feyzullah": true,
      "Fındıklı": true,
      "Girne": true,
      "Gülensu": true,
      "Gülsuyu": true,
      "İdealtepe": true,
      "Küçükyalı Merkez": true,
      "Yalı": true,
      "Zümrütevler": true
    },
    "Pendik": {
      "Ahmet Yesevi": true,
      "Bahçelievler": true,
      "Ballıca": true,
      "Batı": true,
      "Çamçeşme": true,
      "Çamlık": true,
      "Çınardere": true,
      "Doğu": true,
      "Dumlupınar": true,
      "Emirli": true,
      "Ertuğrul Gazi": true,
      "Esenler": true,
      "Esenyalı": true,
      "Fatih": true,
      "Fevzi Çakmak": true,
      "Göçbeyli": true,
      "Güllü Bağlar": true,
      "Güzelyalı": true,
      "Harmandere": true,
      "Kavakpınar": true,
      "Kaynarca": true,
      "Kurna": true,
      "Kurtdoğmuş": true,
      "Kurtköy": true,
      "Orhangazi": true,
      "Orta": true,
      "Ramazanoğlu": true,
      "Sanayi": true,
      "Sapan Bağları": true,
      "Sülüntepe": true,
      "Şeyhli": true,
      "Velibaba": true,
      "Yayalar": true,
      "Yeni": true,
      "Yenişehir": true,
      "Yeşilbağlar": true
    },
    "Sancaktepe": {
      "Abdurrahmangazi": true,
      "Akpınar": true,
      "Atatürk": true,
      "Emek": true,
      "Eyüp Sultan": true,
      "Fatih": true,
      "Hilal": true,
      "İnönü": true,
      "Kemal Türkler": true,
      "Meclis": true,
      "Merve": true,
      "Mevlana": true,
      "Osmangazi": true,
      "Paşaköy": true,
      "Safa": true,
      "Sarıgazi": true,
      "Veysel Karani": true,
      "Yenidoğan": true,
      "Yunus Emre": true
    },
    "Sarıyer": {
      "Ayazağa": true,
      "Bahçeköy Kemer": true,
      "Bahçeköy Merkez": true,
      "Bahçeköy Yeni": true,
      "Baltalimanı": true,
      "Büyükdere": true,
      "Cumhuriyet": true,
      "Çamlıtepe": true,
      "Çayırbaşı": true,
      "Darüşşafaka": true,
      "Demirciköy": true,
      "Emirgan": true,
      "Fatih Sultan Mehmet": true,
      "Ferahevler": true,
      "Garipçe": true,
      "Gümüşdere": true,
      "Huzur": true,
      "İstinye": true,
      "Kazım Karabekir Paşa": true,
      "Kısırkaya": true,
      "Kireçburnu": true,
      "Kocataş": true,
      "Kumköy (kilyos)": true,
      "Maden": true,
      "Maslak": true,
      "Pınar": true,
      "Poligon": true,
      "Ptt Evleri": true,
      "Reşitpaşa": true,
      "Rumelifeneri": true,
      "Rumelihisarı": true,
      "Rumelikavağı": true,
      "Sarıyer Merkez": true,
      "Tarabya": true,
      "Uskumruköy": true,
      "Yeni": true,
      "Yeniköy": true,
      "Zekeriyaköy": true
    },
    "Silivri": {
      "Akören": true,
      "Alibey": true,
      "Alipaşa": true,
      "Bekirli": true,
      "Beyciler": true,
      "Büyük Çavuşlu": true,
      "Büyük Kılıçlı": true,
      "Büyük Sinekli": true,
      "Cumhuriyet": true,
      "Çanta Balaban": true,
      "Çanta Sancaktepe": true,
      "Çayırdere": true,
      "Çeltik": true,
      "Danamandıra": true,
      "Değirmenköy Fevzipaşa": true,
      "Değirmenköy Ismetpaşa": true,
      "Fatih": true,
      "Fener": true,
      "Gazitepe": true,
      "Gümüşyaka": true,
      "Kadıköy": true,
      "Kavaklı Hürriyet": true,
      "Kavaklı Istiklal": true,
      "Kurfallı": true,
      "Küçük Kılıçlı": true,
      "Küçük Sinekli": true,
      "Mimar Sinan": true,
      "Ortaköy": true,
      "Piri Mehmet Paşa": true,
      "Sayalar": true,
      "Selimpaşa": true,
      "Semizkumlar": true,
      "Seymen": true,
      "Yeni": true,
      "Yolçatı": true
    },
    "Sultanbeyli": {
      "Abdurrahmangazi": true,
      "Adil": true,
      "Ahmet Yesevi": true,
      "Akşemsettin": true,
      "Battalgazi": true,
      "Fatih": true,
      "Hamidiye": true,
      "Hasanpaşa": true,
      "Mecidiye": true,
      "Mehmet Akif": true,
      "Mimar Sinan": true,
      "Necip Fazıl": true,
      "Orhangazi": true,
      "Turgut Reis": true,
      "Yavuz Selim": true
    },
    "Sultangazi": {
      "50. Yıl": true,
      "75. Yıl": true,
      "Cebeci": true,
      "Cumhuriyet": true,
      "Esentepe": true,
      "Eski Habipler": true,
      "Gazi": true,
      "Habibler": true,
      "İsmetpaşa": true,
      "Malkoçoğlu": true,
      "Sultançiftliği": true,
      "Uğur Mumcu": true,
      "Yayla": true,
      "Yunus Emre": true,
      "Zübeyde Hanım": true
    },
    "Şile": {
      "Ağaçdere": true,
      "Ağva Merkez": true,
      "Ahmetli": true,
      "Akçakese": true,
      "Alacalı": true,
      "Avcıkoru": true,
      "Balibey": true,
      "Bıçkıdere": true,
      "Bozgoca": true,
      "Bucaklı": true,
      "Çataklı": true,
      "Çavuş": true,
      "Çayırbaşı": true,
      "Çelebi": true,
      "Çengilli": true,
      "Darlık": true,
      "Değirmençayırı": true,
      "Doğancılı": true,
      "Erenler": true,
      "Esenceli": true,
      "Geredeli": true,
      "Göçe": true,
      "Gökmaşlı": true,
      "Göksu": true,
      "Hacı Kasım": true,
      "Hacıllı": true,
      "Hasanlı": true,
      "İmrendere": true,
      "İmrenli": true,
      "İsaköy": true,
      "Kabakoz": true,
      "Kadıköy": true,
      "Kalem": true,
      "Karabeyli": true,
      "Karacaköy": true,
      "Karakiraz": true,
      "Karamandere": true,
      "Kervansaray": true,
      "Kızılca": true,
      "Korucu": true,
      "Kömürlük": true,
      "Kumbaba": true,
      "Kurfallı": true,
      "Kurna": true,
      "Meşrutiyet": true,
      "Oruçoğlu": true,
      "Osmanköy": true,
      "Ovacık": true,
      "Sahilköy": true,
      "Satmazlı": true,
      "Sofular": true,
      "Soğullu": true,
      "Sortullu": true,
      "Şuayipli": true,
      "Teke": true,
      "Ulupelit": true,
      "Üvezli": true,
      "Yaka": true,
      "Yaylalı": true,
      "Yazımanayır": true,
      "Yeniköy": true,
      "Yeşilvadi": true
    },
    "Şişli": {
      "19 Mayıs": true,
      "Bozkurt": true,
      "Cumhuriyet": true,
      "Duatepe": true,
      "Ergenekon": true,
      "Esentepe": true,
      "Eskişehir": true,
      "Feriköy": true,
      "Fulya": true,
      "Gülbahar": true,
      "Halaskargazi": true,
      "Halide Edip Adıvar": true,
      "Halil Rıfat Paşa": true,
      "Harbiye": true,
      "İnönü": true,
      "İzzet Paşa": true,
      "Kaptanpaşa": true,
      "Kuştepe": true,
      "Mahmut Şevket Paşa": true,
      "Mecidiyeköy": true,
      "Merkez": true,
      "Meşrutiyet": true,
      "Paşa": true,
      "Teşvikiye": true,
      "Yayla": true
    },
    "Tuzla": {
      "Akfırat": true,
      "Anadolu": true,
      "Aydınlı": true,
      "Aydıntepe": true,
      "Cami": true,
      "Evliya Çelebi": true,
      "Fatih": true,
      "İçmeler": true,
      "İstasyon": true,
      "Mescit": true,
      "Mimar Sinan": true,
      "Orhanlı": true,
      "Orta": true,
      "Postane": true,
      "Şifa": true,
      "Tepeören": true,
      "Yayla": true
    },
    "Ümraniye": {
      "Adem Yavuz": true,
      "Altınşehir": true,
      "Armağanevler": true,
      "Aşağı Dudullu": true,
      "Atakent": true,
      "Atatürk": true,
      "Cemil Meriç": true,
      "Çakmak": true,
      "Çamlık": true,
      "Dumlupınar": true,
      "Elmalıkent": true,
      "Esenevler": true,
      "Esenkent": true,
      "Esenşehir": true,
      "Fatih Sultan Mehmet": true,
      "Finanskent": true,
      "Hekimbaşı": true,
      "Huzur": true,
      "Ihlamurkuyu": true,
      "İnkılap": true,
      "İstiklal": true,
      "Kazım Karabekir": true,
      "Madenler": true,
      "Mehmet Akif": true,
      "Namık Kemal": true,
      "Necip Fazıl": true,
      "Parseller": true,
      "Site": true,
      "Şerifali": true,
      "Tantavi": true,
      "Tatlısu": true,
      "Tepeüstü": true,
      "Topağacı": true,
      "Yamanevler": true,
      "Yukarı Dudullu": true
    },
    "Üsküdar": {
      "Acıbadem": true,
      "Ahmediye": true,
      "Altunizade": true,
      "Aziz Mahmut Hüdayi": true,
      "Bahçelievler": true,
      "Barbaros": true,
      "Beylerbeyi": true,
      "Bulgurlu": true,
      "Burhaniye": true,
      "Cumhuriyet": true,
      "Çengelköy": true,
      "Ferah": true,
      "Güzeltepe": true,
      "İcadiye": true,
      "Kandilli": true,
      "Kısıklı": true,
      "Kirazlıtepe": true,
      "Kuleli": true,
      "Kuzguncuk": true,
      "Küçük Çamlıca": true,
      "Küçüksu": true,
      "Küplüce": true,
      "Mehmet Akif Ersoy": true,
      "Mimar Sinan": true,
      "Muratreis": true,
      "Salacak": true,
      "Selami Ali": true,
      "Selimiye": true,
      "Sultantepe": true,
      "Ünalan": true,
      "Valide-i Atik": true,
      "Yavuztürk": true,
      "Zeynep Kamil": true
    },
    "Zeytinburnu": {
      "Beştelsiz": true,
      "Çırpıcı": true,
      "Gökalp": true,
      "Kazlıçeşme": true,
      "Maltepe": true,
      "Merkezefendi": true,
      "Nuripaşa": true,
      "Seyitnizam": true,
      "Sümer": true,
      "Telsiz": true,
      "Veliefendi": true,
      "Yenidoğan": true,
      "Yeşiltepe": true
    }
  },
  "İzmir": {
    "Aliağa": {
      "Aşağışakran": true,
      "Atatürk": true,
      "B.hayrettin Paşa": true,
      "Bahçedere": true,
      "Bozköy": true,
      "Çakmaklı": true,
      "Çaltılıdere": true,
      "Çıtak": true,
      "Çoraklar": true,
      "Fatih": true,
      "Güzelhisar": true,
      "Hacıömerli": true,
      "Horozgediği": true,
      "Kalabak": true,
      "Kapukaya": true,
      "Karaköy": true,
      "Karakuzu": true,
      "Kazım Dirik": true,
      "Kurtuluş": true,
      "Kültür": true,
      "Mimar Sinan": true,
      "Örnekkent": true,
      "Samurlu": true,
      "Siteler": true,
      "Şakran Hasbi Efendi": true,
      "Şakran Sayfiye": true,
      "Şehitkemal": true,
      "Uzunhasanlar": true,
      "Yalı": true,
      "Yeni": true,
      "Yukarı Şehitkemal": true,
      "Yüksekköy": true
    },
    "Balçova": {
      "Bahçelerarası": true,
      "Çetin Emeç": true,
      "Eğitim": true,
      "Fevzi Çakmak": true,
      "İnciraltı": true,
      "Korutürk": true,
      "Onur": true,
      "Teleferik": true
    },
    "Bayındır": {
      "Alankıyı": true,
      "Alanköy": true,
      "Arıkbaşı": true,
      "Atatürk": true,
      "Balcılar": true,
      "Bıyıklar": true,
      "Buruncuk": true,
      "Camii": true,
      "Cumhuriyet": true,
      "Çamlıbel": true,
      "Çenikler": true,
      "Çınar": true,
      "Çınardibi": true,
      "Çırpı Cami": true,
      "Çiftçigediği": true,
      "Demircilik": true,
      "Dereköy": true,
      "Dernekli": true,
      "Elifli": true,
      "Ergenli": true,
      "Fatih": true,
      "Fırınlı": true,
      "Gaziler": true,
      "Hacı Beşir": true,
      "Hacı Ibrahim": true,
      "Hasköy": true,
      "Hatay": true,
      "Havuzbaşı": true,
      "Hisarlık": true,
      "İbrahimçavuş": true,
      "Kabaağaç": true,
      "Karahalilli": true,
      "Karahayıt": true,
      "Karapınar": true,
      "Karaveliler": true,
      "Kızılcaağaç": true,
      "Kızılcaova": true,
      "Kızılkeçili": true,
      "Kızıloba": true,
      "Kurt": true,
      "Lütuflar": true,
      "Mektep": true,
      "Mithatpaşa": true,
      "Necati Uza": true,
      "Orta": true,
      "Osmanlar": true,
      "Pınarlı": true,
      "Sadıkpaşa": true,
      "Sarıyurt": true,
      "Söğütören": true,
      "Tokatbaşı": true,
      "Turan": true,
      "Yakacık": true,
      "Yakapınar": true,
      "Yeni": true,
      "Yenice": true,
      "Yeşilova": true,
      "Yusuflu": true,
      "Zeytinova": true
    },
    "Bayraklı": {
      "75. Yıl": true,
      "Adalet": true,
      "Alpaslan": true,
      "Bayraklı": true,
      "Cengizhan": true,
      "Çay": true,
      "Çiçek": true,
      "Doğançay": true,
      "Emek": true,
      "Fuat Edip Baksı": true,
      "Gümüşpala": true,
      "Körfez": true,
      "Manavkuyu": true,
      "Mansuroğlu": true,
      "Muhittin Erener": true,
      "Onur": true,
      "Org.nafiz Gürman": true,
      "Osmangazi": true,
      "Postacılar": true,
      "R.şevket Ince": true,
      "Soğukkuyu": true,
      "Tepekule": true,
      "Turan": true,
      "Yamanlar": true
    },
    "Bergama": {
      "Ahmetbeyler": true,
      "Akçenger": true,
      "Alacalar": true,
      "Alhatlı": true,
      "Alibeyli": true,
      "Armağanlar": true,
      "Aşağıbey": true,
      "Aşağıcuma": true,
      "Aşağıılgındere": true,
      "Aşağıkırıklar": true,
      "Atatürk": true,
      "Atçılar": true,
      "Atmaca": true,
      "Avunduk": true,
      "Avunduruk": true,
      "Ayaskent": true,
      "Ayvatlar": true,
      "Aziziye": true,
      "Bahçelievler": true,
      "Balaban": true,
      "Barbaros": true,
      "Bayramcılar": true,
      "Bekirler": true,
      "Bozköy": true,
      "Bozyerler": true,
      "Bölcek": true,
      "Cevaplı": true,
      "Çakırlar": true,
      "Çalıbahçe": true,
      "Çaltıkoru": true,
      "Çamavlu": true,
      "Çamköy": true,
      "Çamoba": true,
      "Çeltikçi": true,
      "Çitköy": true,
      "Çobanlar": true,
      "Çürükbağlar": true,
      "Dağıstan": true,
      "Demircidere": true,
      "Dereköy": true,
      "Doğancı": true,
      "Durmuşlar": true,
      "Eğiller": true,
      "Eğrigöl": true,
      "Ertuğrul": true,
      "Fatih": true,
      "Ferizler": true,
      "Fevzipaşa": true,
      "Gaylan": true,
      "Gaziosmanpaşa": true,
      "Gazipaşa": true,
      "Göbeller": true,
      "Göçbeyli": true,
      "Gökçeyurt": true,
      "Gültepe": true,
      "Güneşli": true,
      "Hacıhamzalar": true,
      "Hacılar (dereköy Bucağı)": true,
      "Hacılar (ismailli Bucağı)": true,
      "Halilağalar": true,
      "Hamzalısüleymaniye": true,
      "Hisarköy": true,
      "Ilgıncaber": true,
      "İkizler": true,
      "İncecikler": true,
      "İneşir": true,
      "İnkılap": true,
      "İslamsaray": true,
      "İsmailli": true,
      "Kadıköy": true,
      "Kaleardı": true,
      "Kaplan (göçbeyli Bucağı)": true,
      "Kaplan (yukarıbey Bucağı)": true,
      "Kapukaya": true,
      "Karahıdırlı": true,
      "Karalar": true,
      "Karaveliler": true,
      "Kaşıkçı": true,
      "Katrancı": true,
      "Kıranlı": true,
      "Kırcalar": true,
      "Kızıltepe": true,
      "Kocahaliller": true,
      "Kocaköy": true,
      "Koyuneli": true,
      "Kozluca": true,
      "Kurfallı": true,
      "Kurtuluş": true,
      "Küçükkaya": true,
      "Mahmudiye": true,
      "Maltepe": true,
      "Maruflar": true,
      "Muratlar": true,
      "Narlıca": true,
      "Okçular": true,
      "Oruşlar": true,
      "Ovacık": true,
      "Öksüzler": true,
      "Örenli": true,
      "Örlemiş": true,
      "Paşaköy": true,
      "Pınarköy": true,
      "Pirveliler": true,
      "Rahmanlar": true,
      "Sağancı": true,
      "Sarıcalar": true,
      "Sarıcaoğlu": true,
      "Sarıdere": true,
      "Seklik": true,
      "Selçuk": true,
      "Sindel": true,
      "Süleymanlı": true,
      "Talatpaşa": true,
      "Tavukçukuru": true,
      "Tekkedere": true,
      "Tepeköy": true,
      "Terzihaliller": true,
      "Tırmanlar": true,
      "Tiyelti": true,
      "Topallar": true,
      "Turabey": true,
      "Ulucamii": true,
      "Üçtepe": true,
      "Ürkütler": true,
      "Yalnızdam": true,
      "Yalnızev": true,
      "Yenikent": true,
      "Yeniler": true,
      "Yerlitahtacı": true,
      "Yortanlı": true,
      "Yukarıada": true,
      "Yukarıbey": true,
      "Yukarıcuma": true,
      "Yukarıkırıklar": true,
      "Zafer": true,
      "Zağnoz": true,
      "Zeytindağ": true
    },
    "Beydağ": {
      "Adaküre": true,
      "Aktepe": true,
      "Alakeçili": true,
      "Atatürk": true,
      "Bakırköy": true,
      "Beyköy": true,
      "Cumhuriyet": true,
      "Çamlık": true,
      "Çiftlikköy": true,
      "Çomaklar": true,
      "Eğridere": true,
      "Erikli": true,
      "Halıköy": true,
      "Karaoba": true,
      "Kurudere": true,
      "Menderes": true,
      "Mutaflar": true,
      "Palamutçuk": true,
      "Sarıkaya": true,
      "Tabaklar": true,
      "Yağcılar": true,
      "Yeniyurt": true,
      "Yeşiltepe": true,
      "Yukarıaktepe": true,
      "Yukarıtosunlar": true
    },
    "Bornova": {
      "Atatürk": true,
      "Barbaros": true,
      "Beşyol": true,
      "Birlik": true,
      "Çamiçi": true,
      "Çamkule": true,
      "Çınar": true,
      "Çiçekli": true,
      "Doğanlar": true,
      "Egemenlik": true,
      "Eğridere": true,
      "Ergene": true,
      "Erzene": true,
      "Evka 3": true,
      "Evka 4": true,
      "Gazi Osman Paşa": true,
      "Gökdere": true,
      "Gürpınar": true,
      "Işıklar": true,
      "İnönü": true,
      "Karacaoğlan": true,
      "Karaçam": true,
      "Kavaklıdere": true,
      "Kayadibi": true,
      "Kazımdirik": true,
      "Kemalpaşa": true,
      "Kızılay": true,
      "Koşukavak": true,
      "Kurudere": true,
      "Laka": true,
      "Meriç": true,
      "Merkez": true,
      "Mevlana": true,
      "Naldöken": true,
      "Rafet Paşa": true,
      "Sarnıçköy": true,
      "Serintepe": true,
      "Tuna": true,
      "Ümit": true,
      "Yakaköy": true,
      "Yeşilçam": true,
      "Yeşilova": true,
      "Yıldırım Beyazıt": true,
      "Yunus Emre": true,
      "Zafer": true
    },
    "Buca": {
      "29 Ekim": true,
      "Adatepe": true,
      "Akıncılar": true,
      "Atatürk": true,
      "Aydoğdu": true,
      "Barış": true,
      "Belenbaşı": true,
      "Buca Koop": true,
      "Cumhuriyet": true,
      "Çağdaş": true,
      "Çaldıran": true,
      "Çamlık": true,
      "Çamlıkule": true,
      "Çamlıpınar": true,
      "Dicle": true,
      "Doğancılar": true,
      "Dumlupınar": true,
      "Efeler": true,
      "Fırat": true,
      "Gaziler": true,
      "Göksu": true,
      "Güven": true,
      "Hürriyet": true,
      "İnkılap": true,
      "İnönü": true,
      "İzkent": true,
      "Karacaağaç": true,
      "Karanfil": true,
      "Kaynaklar Merkez": true,
      "Kırklar": true,
      "Kozağaç": true,
      "Kuruçeşme": true,
      "Laleli": true,
      "Menderes": true,
      "Murathan": true,
      "Mustafa Kemal": true,
      "Seyhan": true,
      "Şirinkapı": true,
      "Ufuk": true,
      "Vali Rahmi Bey": true,
      "Yaylacık": true,
      "Yenigün": true,
      "Yeşilbağlar": true,
      "Yıldız": true,
      "Yıldızlar": true,
      "Yiğitler": true,
      "Zafer": true
    },
    "Çeşme": {
      "16 Eylül": true,
      "Alaçatı": true,
      "Altınkum": true,
      "Altınyunus": true,
      "Ardıç": true,
      "Boyalık": true,
      "Celal Bayar": true,
      "Cumhuriyet": true,
      "Çakabey": true,
      "Çiftlik": true,
      "Dalyan": true,
      "Fahrettinpaşa": true,
      "Germiyan": true,
      "Ildır": true,
      "Ilıca": true,
      "İsmet Inönü": true,
      "Karaköy": true,
      "Musalla": true,
      "Ovacık": true,
      "Reisdere": true,
      "Sakarya": true,
      "Şehit Mehmet": true,
      "Şifne": true,
      "Üniversite": true,
      "Yalı": true
    },
    "Çiğli": {
      "Ahmet Efendi": true,
      "Ahmet Taner Kışlalı": true,
      "Ataşehir": true,
      "Atatürk": true,
      "Aydınlıkevler": true,
      "Balatçık": true,
      "Cumhuriyet": true,
      "Çağdaş": true,
      "Egekent": true,
      "Esentepe": true,
      "Evka-2": true,
      "Evka-5": true,
      "Evka-6": true,
      "Güzeltepe": true,
      "Harmandalı Gazi Mustafa Kemal Atatürk": true,
      "İnönü": true,
      "İzkent": true,
      "Kaklıç": true,
      "Köyiçi": true,
      "Küçük Çiğli": true,
      "Maltepe": true,
      "Sasalı Merkez": true,
      "Şirintepe": true,
      "Uğur Mumcu": true,
      "Yakakent": true,
      "Yenimahalle": true
    },
    "Dikili": {
      "Bademli": true,
      "Bahçeli": true,
      "Cumhuriyet": true,
      "Çağlan": true,
      "Çandarlı": true,
      "Çukuralanı": true,
      "Deliktaş": true,
      "Demirtaş": true,
      "Denizköy": true,
      "Esentepe": true,
      "Gazipaşa": true,
      "Gökçeağıl": true,
      "İslamlar": true,
      "İsmetpaşa": true,
      "Kabakum": true,
      "Katıralanı": true,
      "Kıratlı": true,
      "Kıroba": true,
      "Kızılçukur": true,
      "Kocaoba": true,
      "Mazılı": true,
      "Merdivenli": true,
      "Nebiler": true,
      "Salihler": true,
      "Salimbey": true,
      "Samanlıkköy": true,
      "Uzunburun": true,
      "Yahşibey": true,
      "Yaylayurt": true,
      "Yenice": true
    },
    "Foça": {
      "Atatürk": true,
      "Cumhuriyet": true,
      "Fatih": true,
      "Fevzi Çakmak": true,
      "Fevzipaşa": true,
      "Hacıveli": true,
      "Ilıpınar": true,
      "İsmetpaşa": true,
      "Kazım Dirik": true,
      "Kemal Atatürk": true,
      "Koca Mehmetler": true,
      "Kozbeyli": true,
      "Mareşal Fevzi Çakmak": true,
      "Mustafa Kemal Atatürk": true,
      "Yenibağarası": true,
      "Yeniköy": true
    },
    "Gaziemir": {
      "Aktepe": true,
      "Atatürk": true,
      "Atıfbey": true,
      "Beyazevler": true,
      "Binbaşı Reşatbey": true,
      "Dokuz Eylül": true,
      "Emrez": true,
      "Fatih": true,
      "Gazi": true,
      "Gazikent": true,
      "Hürriyet": true,
      "Irmak": true,
      "Menderes": true,
      "Sevgi": true,
      "Yeşil": true,
      "Zafer": true
    },
    "Güzelbahçe": {
      "Atatürk": true,
      "Çamlı": true,
      "Çelebi": true,
      "Kahramandere": true,
      "Küçükkaya": true,
      "Maltepe": true,
      "Mustafa Kemal Paşa": true,
      "Payamlı": true,
      "Siteler": true,
      "Yaka": true,
      "Yalı": true,
      "Yelki": true
    },
    "Karabağlar": {
      "Abdi Ipekçi": true,
      "Adnan Süvari": true,
      "Ali Fuat Cebesoy": true,
      "Ali Fuat Erden": true,
      "Arap Hasan": true,
      "Aşık Veysel": true,
      "Aydın": true,
      "Bahar": true,
      "Bahçelievler": true,
      "Bahriye Üçok": true,
      "Barış": true,
      "Basın Sitesi": true,
      "Bozyaka": true,
      "Cennetçeşme": true,
      "Cennetoğlu": true,
      "Çalıkuşu": true,
      "Devrim": true,
      "Doğanay": true,
      "Esenlik": true,
      "Esentepe": true,
      "Esenyalı": true,
      "Fahrettin Altay": true,
      "Gazi": true,
      "General Asım Gündüz": true,
      "General Kazım Özalp": true,
      "Gülyaka": true,
      "Günaltay": true,
      "İhsan Alyanak": true,
      "Karabağlar": true,
      "Kavacık": true,
      "Kazım Karabekir": true,
      "Kibar": true,
      "Limontepe": true,
      "Maliyeciler": true,
      "Metin Oktay": true,
      "Muammer Akar": true,
      "Osman Aksüner": true,
      "Özgür": true,
      "Peker": true,
      "Poligon": true,
      "Refet Bele": true,
      "Reis": true,
      "Salih Omurtak": true,
      "Sarıyer": true,
      "Selvili": true,
      "Sevgi": true,
      "Şehitler": true,
      "Tahsin Yazıcı": true,
      "Tırazlı": true,
      "Uğur Mumcu": true,
      "Umut": true,
      "Uzundere": true,
      "Üçkuyular": true,
      "Vatan": true,
      "Yaşar Kemal": true,
      "Yunus Emre": true,
      "Yurdoğlu": true,
      "Yüzbaşı Şerafettin": true
    },
    "Karaburun": {
      "Anbarseki": true,
      "Bozköy": true,
      "Eğlenhoca": true,
      "Hasseki": true,
      "İnecik": true,
      "İskele": true,
      "Kösedere": true,
      "Küçükbahçe": true,
      "Merkez": true,
      "Mordoğan": true,
      "Parlak": true,
      "Saip": true,
      "Salman": true,
      "Sarpıncık": true,
      "Tepeboz": true,
      "Yayla": true
    },
    "Karşıyaka": {
      "Aksoy": true,
      "Alaybey": true,
      "Atakent": true,
      "Bahariye": true,
      "Bahçelievler": true,
      "Bahriye Üçok": true,
      "Bostanlı": true,
      "Cumhuriyet": true,
      "Dedebaşı": true,
      "Demirköprü": true,
      "Donanmacı": true,
      "Fikri Altay": true,
      "Goncalar": true,
      "İmbatlı": true,
      "İnönü": true,
      "Latife Hanım": true,
      "Mavişehir": true,
      "Mustafa Kemal": true,
      "Nergiz": true,
      "Örnekköy": true,
      "Sancaklı": true,
      "Şemikler": true,
      "Tersane": true,
      "Tuna": true,
      "Yalı": true,
      "Yamanlar": true,
      "Zübeyde Hanım": true
    },
    "Kemalpaşa": {
      "Akalan": true,
      "Ansızca": true,
      "Armutlu 85.yıl Cumhuriyet": true,
      "Armutlu Hürriyet": true,
      "Aşağı Yenmiş": true,
      "Aşağıkızılca": true,
      "Atatürk": true,
      "Bağyurdu 29 Ekim": true,
      "Bağyurdu Kazımpaşa": true,
      "Bağyurdu Kemal Atatürk": true,
      "Bağyurdu Yeni": true,
      "Bayramlı": true,
      "Beşpınar": true,
      "Cumalı": true,
      "Çambel": true,
      "Çınarköy": true,
      "Çiniliköy": true,
      "Damlacık": true,
      "Dereköy": true,
      "Gökçeyurt": true,
      "Gökyaka": true,
      "Halilbeyli": true,
      "Hamzababa": true,
      "Kamberler": true,
      "Kızılüzüm": true,
      "Kuyucak": true,
      "Mehmet Akif Ersoy": true,
      "Nazarköy": true,
      "Ovacık": true,
      "Ören 75.yıl Cumhuriyet": true,
      "Ören Egemen": true,
      "Örnekköy": true,
      "Sarıçalı": true,
      "Sarılar": true,
      "Sekiz Eylül": true,
      "Sinancılar": true,
      "Soğukpınar": true,
      "Sütçüler": true,
      "Ulucak Cumhuriyet": true,
      "Ulucak Istiklal": true,
      "Ulucak Mustafa Kemal Atatürk": true,
      "Vişneli": true,
      "Yenikurudere": true,
      "Yenmiş": true,
      "Yeşilköy": true,
      "Yeşilyurt": true,
      "Yiğitler": true,
      "Yukarıkızılca Merkez": true,
      "Zeamet": true
    },
    "Kınık": {
      "Arpadere": true,
      "Arpaseki": true,
      "Aşağı": true,
      "Aziziye": true,
      "Bademalan": true,
      "Bağalan": true,
      "Balaban": true,
      "Büyükoba": true,
      "Cumalı": true,
      "Çaltı": true,
      "Çanköy": true,
      "Çiftlikköy": true,
      "Değirmencieli": true,
      "Dündarlı": true,
      "Elmadere": true,
      "Fatih": true,
      "Hamzahocalı": true,
      "Işıklar": true,
      "İbrahimağa": true,
      "Kalemköy": true,
      "Karadere": true,
      "Karatekeli": true,
      "Kocaömer": true,
      "Kodukburun": true,
      "Köseler": true,
      "Mıstıklar": true,
      "Musacalı": true,
      "Osmaniye": true,
      "Örtülü": true,
      "Poyracık": true,
      "Sucahlı": true,
      "Taştepe": true,
      "Türkcedit": true,
      "Yayakent": true,
      "Yaylaköy": true,
      "Yeni": true,
      "Yukarı": true
    },
    "Kiraz": {
      "Ahmetler": true,
      "Akpınar": true,
      "Altınoluk": true,
      "Arkacılar": true,
      "Avunduruk": true,
      "Aydoğdu": true,
      "Bahçearası": true,
      "Başaran": true,
      "Ceritler": true,
      "Cevizli": true,
      "Cumhuriyet": true,
      "Çanakçı": true,
      "Çatak": true,
      "Çayağzı": true,
      "Çömlekçi": true,
      "Doğancılar": true,
      "Dokuzlar": true,
      "Emenler": true,
      "Gedik": true,
      "Haliller": true,
      "Hisar": true,
      "İğdeli": true,
      "İstiklal": true,
      "Kaleköy": true,
      "Karabağ": true,
      "Karabulu": true,
      "Karaburç": true,
      "Karaman": true,
      "Kırköy": true,
      "Kibar": true,
      "Mavidere": true,
      "Mersinlidere": true,
      "Olgunlar": true,
      "Ovacık": true,
      "Ören": true,
      "Örencik": true,
      "Pınarbaşı": true,
      "Saçlı": true,
      "Sarıkaya": true,
      "Sarısu": true,
      "Sırımlı": true,
      "Solaklar": true,
      "Suludere": true,
      "Şemsiler": true,
      "Taşlıyatak": true,
      "Tekbıçaklar": true,
      "Tumbullar": true,
      "Umurcalı": true,
      "Umurlu": true,
      "Uzunköy": true,
      "Veliler": true,
      "Yağlar": true,
      "Yeni": true,
      "Yeniköy": true,
      "Yenişehir": true,
      "Yeşildere": true
    },
    "Konak": {
      "1.kadriye": true,
      "19 Mayıs": true,
      "2.kadriye": true,
      "26 Ağustos": true,
      "Akarcalı": true,
      "Akdeniz": true,
      "Akın Simav": true,
      "Akıncı": true,
      "Ali Reis": true,
      "Alsancak": true,
      "Altay": true,
      "Altınordu": true,
      "Altıntaş": true,
      "Anadolu": true,
      "Atamer": true,
      "Atilla": true,
      "Aziziye": true,
      "Ballıkuyu": true,
      "Barbaros": true,
      "Boğaziçi": true,
      "Bozkurt": true,
      "Cengiz Topel": true,
      "Çahabey": true,
      "Çankaya": true,
      "Çınarlı": true,
      "Çınartepe": true,
      "Çimentepe": true,
      "Dayıemir": true,
      "Dolaplıkuyu": true,
      "Duatepe": true,
      "Ege": true,
      "Emir Sultan": true,
      "Etiler": true,
      "Faik Paşa": true,
      "Fatih": true,
      "Ferahlı": true,
      "Fevzi Paşa": true,
      "Göztepe": true,
      "Güneş": true,
      "Güneşli": true,
      "Güney": true,
      "Güngör": true,
      "Güzelyalı": true,
      "Güzelyurt": true,
      "Halkapınar": true,
      "Hasan Özdemir": true,
      "Hilal": true,
      "Hurşidiye": true,
      "Huzur": true,
      "İmariye": true,
      "İsmet Kaptan": true,
      "İsmet Paşa": true,
      "Kadifekale": true,
      "Kahraman Mescit": true,
      "Kahramanlar": true,
      "Kemal Reis": true,
      "Kestelli": true,
      "Kılıç Reis": true,
      "Kocakapı": true,
      "Kocatepe": true,
      "Konak": true,
      "Kosova": true,
      "Kubilay": true,
      "Kurtuluş": true,
      "Küçükada": true,
      "Kültür": true,
      "Lale": true,
      "Levent": true,
      "Mecidiye": true,
      "Mehmet Akif": true,
      "Mehmet Ali Akman": true,
      "Mehtap": true,
      "Mersinli": true,
      "Millet": true,
      "Mimar Sinan": true,
      "Mirali": true,
      "Mithatpaşa": true,
      "Murat": true,
      "Murat Reis": true,
      "Namık Kemal": true,
      "Odunkapı": true,
      "Oğuzlar": true,
      "Pazaryeri": true,
      "Piri Reis": true,
      "Sakarya": true,
      "Saygı": true,
      "Selçuk": true,
      "Sümer": true,
      "Süvari": true,
      "Şehit Nedim Tuğaltay": true,
      "Tan": true,
      "Tınaztepe": true,
      "Trakya": true,
      "Turgut Reis": true,
      "Tuzcu": true,
      "Türkyılmaz": true,
      "Uğur": true,
      "Ulubatlı": true,
      "Umurbey": true,
      "Ülkü": true,
      "Vezirağa": true,
      "Yavuz Selim": true,
      "Yeni": true,
      "Yenidoğan": true,
      "Yenigün": true,
      "Yenişehir": true,
      "Yeşildere": true,
      "Yeşiltepe": true,
      "Yıldız": true,
      "Zafertepe": true,
      "Zeybek": true,
      "Zeytinlik": true
    },
    "Menderes": {
      "Ahmetbeyli": true,
      "Akçaköy": true,
      "Altıntepe": true,
      "Ata": true,
      "Ataköy": true,
      "Barbaros": true,
      "Bulgurca": true,
      "Cüneytbey": true,
      "Çakaltepe": true,
      "Çamönü": true,
      "Çatalca": true,
      "Çile": true,
      "Çileme": true,
      "Çukuraltı": true,
      "Değirmendere": true,
      "Dereköy": true,
      "Develi": true,
      "Efemçukuru": true,
      "Gazipaşa": true,
      "Gölcükler": true,
      "Gölova": true,
      "Görece Cumhuriyet": true,
      "Gümüldür Atatürk": true,
      "Gümüldür Cumhuriyet": true,
      "Gümüldür Fevzi Çakmak": true,
      "Gümüldür Inönü": true,
      "Hürriyet": true,
      "Karakuyu": true,
      "Kasımpaşa": true,
      "Keler": true,
      "Kemalpaşa": true,
      "Kısık": true,
      "Kuyucak": true,
      "Küner": true,
      "Mithatpaşa": true,
      "Oğlananası Atatürk": true,
      "Oğlananası Cumhuriyet": true,
      "Orta": true,
      "Özdere Cumhuriyet": true,
      "Sancaklı": true,
      "Şaşal": true,
      "Tekeli Atatürk": true,
      "Tekeli Fevzi Çakmak": true,
      "Yeniköy": true
    },
    "Menemen": {
      "29 Ekim": true,
      "30 Ağustos": true,
      "75.yıl Cumhuriyet": true,
      "85.yıl Cumhuriyet": true,
      "9 Eylül": true,
      "Ahıhıdır": true,
      "Alaniçi": true,
      "Atatürk": true,
      "Ayvacık": true,
      "Bağcılar": true,
      "Belen": true,
      "Bozalan": true,
      "Buruncuk": true,
      "Camiikebir": true,
      "Cumhuriyet": true,
      "Çaltı": true,
      "Çavuş": true,
      "Çukurköy": true,
      "Değirmendere": true,
      "Doğa": true,
      "Emiralem Merkez": true,
      "Esatpaşa": true,
      "Fatih": true,
      "Gaybi": true,
      "Gazi": true,
      "Gazi Mustafa Kemal": true,
      "Göktepe": true,
      "Gölcük": true,
      "Görece": true,
      "Günerli": true,
      "Hasanlar": true,
      "Hatundere": true,
      "Haykıran": true,
      "Irmak": true,
      "İğnedere": true,
      "İncirli Pınar": true,
      "İnönü": true,
      "İsmet Inönü": true,
      "İstiklal": true,
      "Karaorman": true,
      "Kasımpaşa": true,
      "Kazımpaşa": true,
      "Kemal Atatürk": true,
      "Kesik": true,
      "Kır": true,
      "Mermerli": true,
      "Musabey": true,
      "Mustafa Kemal Atatürk": true,
      "Seydinnasrullah": true,
      "Süleymanlı": true,
      "Süzbeyli": true,
      "Telekler": true,
      "Turgutlar": true,
      "Tuzçullu": true,
      "Tülbentli": true,
      "Uğur Mumcu": true,
      "Ulus": true,
      "Villakent": true,
      "Yahşelli": true,
      "Yanıkköy": true,
      "Yayla": true,
      "Yeşil Pınar": true,
      "Yıldırım": true,
      "Zafer": true,
      "Zeytinlik": true
    },
    "Narlıdere": {
      "2. Inönü": true,
      "Altıevler": true,
      "Atatürk": true,
      "Çamtepe": true,
      "Çatalkaya": true,
      "Huzur": true,
      "Ilıca": true,
      "Limanreis": true,
      "Narlı": true,
      "Sahilevleri": true,
      "Yenikale": true
    },
    "Ödemiş": {
      "Akıncılar": true,
      "Alaşarlı": true,
      "Anafartalar": true,
      "Artıcak": true,
      "Atatürk": true,
      "Bademli": true,
      "Balabanlı": true,
      "Bayırlı": true,
      "Bebekler": true,
      "Bengisu": true,
      "Beyazıtlar": true,
      "Bıçakçı": true,
      "Birgi": true,
      "Bozcayaka": true,
      "Bozdağ": true,
      "Bucak": true,
      "Bülbüller": true,
      "Büyükavulcuk": true,
      "Cevizalan": true,
      "Cumhuriyet": true,
      "Çağlayan": true,
      "Çamlıca": true,
      "Çamyayla": true,
      "Çayır": true,
      "Çaylı": true,
      "Çobanlar": true,
      "Demircili": true,
      "Demirdere": true,
      "Dereuzunyer": true,
      "Dolaylar": true,
      "Emirli": true,
      "Emmioğlu": true,
      "Ertuğrul": true,
      "Gerçekli": true,
      "Gereli": true,
      "Gölcük": true,
      "Güney": true,
      "Günlüce": true,
      "Hacıhasan": true,
      "Hamam": true,
      "Horzum": true,
      "Hürriyet": true,
      "Işık": true,
      "İlkkurşun": true,
      "İnönü": true,
      "Karadoğan": true,
      "Karakova": true,
      "Kayaköy": true,
      "Kaymakçı": true,
      "Kazanlı": true,
      "Kemenler": true,
      "Kemer": true,
      "Kerpiçlik": true,
      "Kışla": true,
      "Kızılca": true,
      "Kızılcaavlu": true,
      "Konaklı": true,
      "Köfündere": true,
      "Köseler": true,
      "Kurucuova": true,
      "Kutlubeyler": true,
      "Kuvvetli": true,
      "Küçükavulcuk": true,
      "Küçükören": true,
      "Küre": true,
      "Mescitli": true,
      "Meşrutiyet": true,
      "Mimar Sinan": true,
      "Mursallı": true,
      "Ocaklı": true,
      "Oğuzlar": true,
      "Orhangazi": true,
      "Ortaköy": true,
      "Ovacık": true,
      "Ovakent": true,
      "Pirinççi": true,
      "Sekiköy": true,
      "Seyrekli": true,
      "Suçıktı": true,
      "Süleyman Demirel": true,
      "Süleymanlar": true,
      "Şirinköy": true,
      "Tekke": true,
      "Tosunlar": true,
      "Türkmen": true,
      "Türkönü": true,
      "Umurbey": true,
      "Uzundere": true,
      "Üç Eylül": true,
      "Üçkonak": true,
      "Üzümlü": true,
      "Veliler": true,
      "Yeniceköy": true,
      "Yeniköy": true,
      "Yeşilköy": true,
      "Yılanlı": true,
      "Yolüstü": true,
      "Yusufdere": true,
      "Zafer": true
    },
    "Seferihisar": {
      "Akarca": true,
      "Atatürk": true,
      "Bengiler": true,
      "Beyler": true,
      "Camikebir": true,
      "Cumhuriyet": true,
      "Çamtepe": true,
      "Çolak Ibrahim Bey": true,
      "Düzce": true,
      "Gödence": true,
      "Gölcük": true,
      "Hıdırlık": true,
      "İhsaniye": true,
      "Kavakdere": true,
      "Mersin Alanı": true,
      "Orhanlı": true,
      "Payamlı": true,
      "Sığacık": true,
      "Tepecik": true,
      "Turabiye": true,
      "Turgut": true,
      "Ulamış": true
    },
    "Selçuk": {
      "14 Mayıs": true,
      "Acarlar": true,
      "Atatürk": true,
      "Barutçu": true,
      "Belevi": true,
      "Cumhuriyet": true,
      "Çamlık": true,
      "Gökçealan": true,
      "Havutçulu": true,
      "İsa Bey": true,
      "Sultaniye": true,
      "Şirince": true,
      "Zafer": true,
      "Zeytinköy": true
    },
    "Tire": {
      "4 Eylül": true,
      "Adnan Menderes": true,
      "Akçaşehir": true,
      "Akkoyunlu": true,
      "Akmescit": true,
      "Akyurt": true,
      "Alacalı": true,
      "Alaylı": true,
      "Armutlu": true,
      "Atatürk": true,
      "Ayaklıkırı": true,
      "Bahariye": true,
      "Başköy": true,
      "Boynuyoğun": true,
      "Büyükkale": true,
      "Büyükkemerdere": true,
      "Büyükkömürcü": true,
      "Cambazlı": true,
      "Cumhuriyet": true,
      "Çayırlı": true,
      "Çeriközü": true,
      "Çiniyeri": true,
      "Çobanköy": true,
      "Çukurköy": true,
      "Dağdere": true,
      "Dallık": true,
      "Dere": true,
      "Derebaşı": true,
      "Dereli": true,
      "Dibekçi": true,
      "Doyranlı": true,
      "Duatepe": true,
      "Dumlupınar": true,
      "Dündarlı": true,
      "Eğridere": true,
      "Ertuğrul": true,
      "Eskioba": true,
      "Fatih": true,
      "Gökçen": true,
      "Halkapınar": true,
      "Hasançavuşlar": true,
      "Hisarlık": true,
      "Hürriyet": true,
      "Işıklar": true,
      "Işıklı": true,
      "İbni Melek": true,
      "İhsaniye": true,
      "İpekçiler": true,
      "İstiklal": true,
      "Kahrat": true,
      "Kaplan": true,
      "Karaca Ali": true,
      "Karateke": true,
      "Ketenci": true,
      "Kırtepe": true,
      "Kızılcahavlu": true,
      "Kireli": true,
      "Kocaaliler": true,
      "Kurşak": true,
      "Kurtuluş": true,
      "Küçükburun": true,
      "Küçükkale": true,
      "Küçükkemerdere": true,
      "Küçükkömürcü": true,
      "Kürdüllü": true,
      "Mahmutlar": true,
      "Mehmetler": true,
      "Musalar": true,
      "Ortaköy": true,
      "Osmancık": true,
      "Paşa": true,
      "Peşrefli": true,
      "Sarılar": true,
      "Saruhanlı": true,
      "Somak": true,
      "Toki": true,
      "Topalak": true,
      "Toparlar": true,
      "Turan": true,
      "Turgutlu": true,
      "Üzümler": true,
      "Yamandere": true,
      "Yeğenli": true,
      "Yemişler": true,
      "Yeni": true,
      "Yeniçiftlik": true,
      "Yenioba": true,
      "Yenişehir": true
    },
    "Torbalı": {
      "19 Mayıs": true,
      "Ahmetli": true,
      "Alpkent": true,
      "Arslanlar": true,
      "Atalan": true,
      "Atatürk": true,
      "Ayrancılar": true,
      "Bahçelievler": true,
      "Bozköy": true,
      "Bülbüldere": true,
      "Cumhuriyet": true,
      "Çakırbeyli": true,
      "Çamlıca": true,
      "Çapak": true,
      "Çaybaşı": true,
      "Dağkızılca": true,
      "Dağteke": true,
      "Demirci": true,
      "Dirmil": true,
      "Düverlik": true,
      "Eğerci": true,
      "Ertuğrul": true,
      "Fevzi Çakmak": true,
      "Gazi Mustafa Kemal": true,
      "Göllüce": true,
      "Helvacı": true,
      "İnönü": true,
      "İstiklal": true,
      "Kaplancık": true,
      "Karakızlar": true,
      "Karakuyu": true,
      "Karaot": true,
      "Karşıyaka": true,
      "Kazım Karabekir": true,
      "Kırbaş": true,
      "Kuşçuburun": true,
      "Muratbey": true,
      "Mustafa Kemal Atatürk": true,
      "Naime": true,
      "Ormanköy": true,
      "Ortaköy": true,
      "Özbey": true,
      "Pamukyazı": true,
      "Pancar": true,
      "Sağlık": true,
      "Saipler": true,
      "Subaşı": true,
      "Şehitler": true,
      "Taşkesik": true,
      "Tepeköy": true,
      "Torbalı": true,
      "Tulum": true,
      "Türkmenköy": true,
      "Yazıbaşı": true,
      "Yedi Eylül": true,
      "Yemişlik": true,
      "Yeni": true,
      "Yeniköy": true,
      "Yeşilköy": true,
      "Yoğurtçular": true
    },
    "Urla": {
      "Altıntaş": true,
      "Atatürk": true,
      "Bademler": true,
      "Balıklıova": true,
      "Barbaros": true,
      "Birgi": true,
      "Camiatik": true,
      "Çamlıçay": true,
      "Demircili": true,
      "Denizli": true,
      "Gülbahçe": true,
      "Güvendik": true,
      "Hacı Isa": true,
      "İçmeler": true,
      "İskele": true,
      "Kadıovacık": true,
      "Kalabak": true,
      "Kuşçular": true,
      "M.fevzi Çakmak": true,
      "Naipli": true,
      "Nohutalan": true,
      "Ovacık": true,
      "Özbek": true,
      "Rüstem": true,
      "Sıra": true,
      "Şirinkent": true,
      "Torasan": true,
      "Uzunkuyu": true,
      "Yağcılar": true,
      "Yaka": true,
      "Yelaltı": true,
      "Yeni": true,
      "Yenice": true,
      "Yenikent": true,
      "Zeytinalanı": true,
      "Zeytineli": true,
      "Zeytinler": true
    }
  },
  "Kahramanmaraş": {
    "Afşin": {
      "Afşinbey": true,
      "Ağcaşar": true,
      "Alemdar": true,
      "Alimpınar": true,
      "Alpaslan": true,
      "Altaş": true,
      "Altınelma": true,
      "Anzorey": true,
      "Arıtaş": true,
      "Armutalan": true,
      "Bakraç": true,
      "Başüstü": true,
      "Berçenek": true,
      "Beyceğiz": true,
      "Binboğa": true,
      "Büget": true,
      "Büyüksevin": true,
      "Büyüktatlı": true,
      "Çağılhan": true,
      "Çobanbeyli": true,
      "Çoğulhan": true,
      "Çomudüz": true,
      "Çukurpınar": true,
      "Dedebaba": true,
      "Deveboynu": true,
      "Dokuztay": true,
      "Efsus Turan": true,
      "Emirilyas": true,
      "Emirli": true,
      "Erçene": true,
      "Esence": true,
      "Gaziosmanpaşa": true,
      "Gerger": true,
      "Gözpınarı": true,
      "Haticepınarı": true,
      "Hurman": true,
      "Hüyüklü": true,
      "İğdemlik": true,
      "İnci": true,
      "İncirli": true,
      "Kabaağaç": true,
      "Kale": true,
      "Kangal": true,
      "Karagöz": true,
      "Kaşanlı": true,
      "Koçovası": true,
      "Kötüre": true,
      "Kuşkayası": true,
      "Marabuz": true,
      "Mehre": true,
      "Nadır": true,
      "Oğlakkayası": true,
      "Ördek": true,
      "Örenderesi": true,
      "Örenli": true,
      "Pınarbaşı": true,
      "Soğucak": true,
      "Söğütderesi": true,
      "Tanır": true,
      "Tatlar": true,
      "Topaktaş": true,
      "Türkçayırı": true,
      "Türksevin": true,
      "Yazıdere": true,
      "Yazıköy": true,
      "Yeşilyurt": true
    },
    "Andırın": {
      "Akçakoyunlu": true,
      "Akgümüş": true,
      "Akifiye": true,
      "Alameşe": true,
      "Alanlı": true,
      "Alınoluk": true,
      "Altınboğa": true,
      "Altınyayla": true,
      "Anacık": true,
      "Arıklar": true,
      "Başdoğan": true,
      "Bektaşlı": true,
      "Beşbucak": true,
      "Boğazören": true,
      "Bostanlı": true,
      "Boynuyoğunlu": true,
      "Boztopraklı": true,
      "Bulgurkaya": true,
      "Cambaz": true,
      "Camuzluk": true,
      "Çiçekli": true,
      "Çiğşar": true,
      "Çokak": true,
      "Çuhadarlı": true,
      "Darıovası": true,
      "Efirağızlı": true,
      "Emirler": true,
      "Erenler": true,
      "Geben": true,
      "Gökahmetli": true,
      "Gökçeli": true,
      "Gökgedik": true,
      "Hacıveliuşağı": true,
      "Kabaağaç": true,
      "Kabaklar": true,
      "Kaleboynu": true,
      "Karapınar": true,
      "Kargaçayırı": true,
      "Kıyıkçı": true,
      "Kızık": true,
      "Köklü": true,
      "Köleli": true,
      "Kumarlı": true,
      "Kuzgun": true,
      "Orhaniye": true,
      "Osmancık": true,
      "Pınarbaşı": true,
      "Rifatiye": true,
      "Sumaklı": true,
      "Tatarlı": true,
      "Torun": true,
      "Tufan Paşa": true,
      "Yeni": true,
      "Yeniköy": true,
      "Yeşilova": true,
      "Yeşiltepe": true,
      "Yeşilyurt": true
    },
    "Çağlayancerit": {
      "Akdere": true,
      "Aksu": true,
      "Bayırlı": true,
      "Boylu": true,
      "Bozlar": true,
      "Bölükdamlar": true,
      "Emiruşağı": true,
      "Engizek": true,
      "Fatih": true,
      "Helete Cumhuriyet": true,
      "Helete Karadağ": true,
      "Helete Yeşiloba": true,
      "İstiklal": true,
      "Kale": true,
      "Küçükcerit": true,
      "Küçüküngüt": true,
      "Oruçpınar": true,
      "Soğukpınar": true,
      "Zeynepuşağı": true
    },
    "Dulkadiroğlu": {
      "Abbaslar": true,
      "Ağabeyli": true,
      "Aksu": true,
      "Akyar": true,
      "Alibeyuşağı": true,
      "Arslanbey Çiftliği": true,
      "Aslan Bey": true,
      "Ayaklıcaoluk": true,
      "Bağlarbaşı": true,
      "Bahçeli": true,
      "Bahçeli Evler": true,
      "Ballıca": true,
      "Başdevrişli": true,
      "Bayazıtlı": true,
      "Baydemirli": true,
      "Beşenli": true,
      "Boyalı": true,
      "Budaklı": true,
      "Bulanık": true,
      "Çatmayayla": true,
      "Çınarlı": true,
      "Çiğli": true,
      "Çobanlı": true,
      "Çokyaşar": true,
      "Demirciler": true,
      "Denizli": true,
      "Dereköy": true,
      "Dereli": true,
      "Divanlı": true,
      "Doğanlıkarahasan": true,
      "Doğu Kent": true,
      "Dulkadiroğlu": true,
      "Duraklı": true,
      "Egemenlik": true,
      "Ekberoğlu": true,
      "Ekmekçi": true,
      "Elmalar": true,
      "Erkenez": true,
      "Eskinarlı": true,
      "Eyüp Sultan": true,
      "Fevzi Paşa": true,
      "Gaffarlı": true,
      "Gazi Paşa": true,
      "Genç Osman": true,
      "Göllü": true,
      "Gültepe": true,
      "Güneşevler": true,
      "Güzelyurt": true,
      "Hacıeyüplü": true,
      "Halkaçayırı": true,
      "İsa Divanlı": true,
      "İsmet Paşa": true,
      "İstasyon": true,
      "Kabasakal": true,
      "Kanuni": true,
      "Kapıçam": true,
      "Karacasu Ferhuş": true,
      "Karacasu Karaziyaret": true,
      "Karacasu Karşıyaka": true,
      "Karacasu Kırım": true,
      "Karacasu Mamaraş": true,
      "Karamanlı": true,
      "Karataş": true,
      "Kartal": true,
      "Kayabaşı": true,
      "Kazanlıpınar": true,
      "Kemallı": true,
      "Kılağlı": true,
      "Kocolar": true,
      "Kozludere": true,
      "Kurtuluş": true,
      "Kuzucak": true,
      "Küçüknacar": true,
      "Küpelikız": true,
      "Maksutuşağı": true,
      "Mehmet Akif": true,
      "Menderes": true,
      "Namık Kemal": true,
      "Navruzlu": true,
      "Osmanbey": true,
      "Öksüzlü": true,
      "Peynirdere": true,
      "Pınarbaşı": true,
      "Sakarya": true,
      "Sarıkaya": true,
      "Senem Ayşe": true,
      "Seyrantepe": true,
      "Sivricehüyük": true,
      "Söğütlü": true,
      "Sümer": true,
      "Sütçü Imam": true,
      "Şerefoğlu": true,
      "Şeyh Adil": true,
      "Şeyh Şamil": true,
      "Tevekkelli": true,
      "Turan": true,
      "Ulutaş": true,
      "Yahya Kemal": true,
      "Yavuz Selim": true,
      "Yeni Şehir": true,
      "Yenikent": true,
      "Yenipınar": true,
      "Yeniyurt": true,
      "Yeşiltepe": true,
      "Yusufhacılı": true
    },
    "Ekinözü": {
      "Akpınar": true,
      "Alişar": true,
      "Altunyaprak": true,
      "Anbar": true,
      "Ataköy": true,
      "Çiftlik": true,
      "Çiftlikkale": true,
      "Demirlik": true,
      "Gaziler": true,
      "Gözpınar": true,
      "İçmeler": true,
      "Kabaktepe": true,
      "Kandil": true,
      "Kürtül": true,
      "Maarif": true,
      "Ortaören": true,
      "Öztürk": true,
      "Soysallı": true,
      "Türkeli": true,
      "Türkmenler": true,
      "Yeniköy": true
    },
    "Elbistan": {
      "Ağlıca": true,
      "Akarca": true,
      "Akbayır": true,
      "Akören": true,
      "Aksakal": true,
      "Alembey": true,
      "Alkayaoğlu": true,
      "Armutalan": true,
      "Atmalıkaşanlı": true,
      "Bahçelievler": true,
      "Bakış": true,
      "Balıkçıl": true,
      "Battalgazi": true,
      "Beştepe": true,
      "Beyyurdu": true,
      "Büyükyapalak": true,
      "Ceyhan": true,
      "Cumhuriyet": true,
      "Çalış": true,
      "Çatova": true,
      "Çıtlık": true,
      "Çiçek": true,
      "Demircilik": true,
      "Dervişçimli": true,
      "Doğan": true,
      "Eldelek": true,
      "Elmalı": true,
      "Esentepe": true,
      "Evcihüyük": true,
      "Fakıoğlu": true,
      "Geçit": true,
      "Gökçek": true,
      "Güblüce": true,
      "Gücük": true,
      "Gümüşdöven": true,
      "Günaltı": true,
      "Gündere": true,
      "Güneşli": true,
      "Güvercinlik": true,
      "Hacıhasanlı": true,
      "Hasanalili": true,
      "Hasankendi": true,
      "Horhor": true,
      "Izgın": true,
      "İğde": true,
      "İkizpınar": true,
      "İncecik": true,
      "Kalaycık": true,
      "Kalealtı": true,
      "Kangal": true,
      "Kantarma": true,
      "Karaelbistan": true,
      "Karahasanuşağı": true,
      "Karahüyük": true,
      "Karamağara": true,
      "Kavaktepe": true,
      "Kayageçit": true,
      "Keçemağara": true,
      "Kışla": true,
      "Kızılcaoba": true,
      "Köprübaşı": true,
      "Körücek": true,
      "Köseyahya": true,
      "Köşk": true,
      "Küçükyapalak": true,
      "Kümbet": true,
      "Orhangazi": true,
      "Ovacık": true,
      "Özbek": true,
      "Özcanlı": true,
      "Pınarbaşı": true,
      "Sarıyatak": true,
      "Sevdilli": true,
      "Söğütlü": true,
      "Sünnet": true,
      "Tapkıran": true,
      "Tapkırankale": true,
      "Taşburun": true,
      "Tepebaşı": true,
      "Tepebaşı (gücük)": true,
      "Topallı": true,
      "Toprakhisar": true,
      "Türkören": true,
      "Uncular": true,
      "Uzunpınar": true,
      "Yalak": true,
      "Yalıntaş": true,
      "Yapılı": true,
      "Yapılıpınar": true,
      "Yapraklı": true,
      "Yeşilyurt": true,
      "Yoğunsöğüt": true,
      "Yunus Emre": true
    },
    "Göksun": {
      "Acıelma": true,
      "Ahmetcik": true,
      "Alıçlıbucak": true,
      "Altınoba": true,
      "Apıklar": true,
      "Aslanbeyçiftliği": true,
      "Bahçelievler": true,
      "Berit": true,
      "Bozarmut": true,
      "Bozhüyük": true,
      "Büyükçamurlu": true,
      "Büyükkızılcık": true,
      "Cumhuriyet": true,
      "Çağlayan": true,
      "Çamdere": true,
      "Çardak": true,
      "Değirmendere": true,
      "Devlettepe": true,
      "Doğankonak": true,
      "Elmalı": true,
      "Ericek": true,
      "Esenköy": true,
      "Fındık": true,
      "Fındıklıkoyak": true,
      "Gölpınar": true,
      "Göynük": true,
      "Gücüksu": true,
      "Güldağı": true,
      "Güller": true,
      "Hacıkodal": true,
      "Hacımirza": true,
      "Hacıömer": true,
      "Harbiye": true,
      "Huğtaş": true,
      "Kale": true,
      "Kaleboynu": true,
      "Kamışcık": true,
      "Kanlıkavak": true,
      "Karaahmet": true,
      "Karaömer": true,
      "Karatut": true,
      "Kavşut": true,
      "Kayabaşı": true,
      "Kazandere": true,
      "Keklikoluk": true,
      "Kemalpaşa": true,
      "Kınıkkoz": true,
      "Kızılöz": true,
      "Kireç": true,
      "Korkmaz": true,
      "Kömür": true,
      "Köprübaşı": true,
      "Kurtuluş": true,
      "Küçükçamurlu": true,
      "Mahmutbey": true,
      "Mehmetbey": true,
      "Mürsel": true,
      "Ortatepe": true,
      "Payamburnu": true,
      "Pınarbaşı": true,
      "Saraycık": true,
      "Sırmalı": true,
      "Soğukpınar": true,
      "Tahirbey": true,
      "Taşoluk": true,
      "Temürağa": true,
      "Tepebaşı": true,
      "Tombak": true,
      "Yağmurlu": true,
      "Yantepe": true,
      "Yeni": true,
      "Yeniyapan": true,
      "Yeşilköy": true,
      "Yiricek": true,
      "Yoğunoluk": true
    },
    "Nurhak": {
      "Ağcaşar": true,
      "Alçiçek Değirmenkaya": true,
      "Barış": true,
      "Biçin": true,
      "Eskiköy": true,
      "Gürsel": true,
      "Hüyük": true,
      "Karaçar": true,
      "Karşıyaka": true,
      "Kıyılar": true,
      "Kullar": true,
      "Pınarbaşı": true,
      "Seyitaliler": true,
      "Tatlar": true,
      "Umutlu": true,
      "Yeni": true
    },
    "Onikişubat": {
      "5 Nisan": true,
      "Abdülhamid Han": true,
      "Ağcalı": true,
      "Akçakoyunlu": true,
      "Akif Inan": true,
      "Altınova": true,
      "Avcılar": true,
      "Avgasır": true,
      "Avşar": true,
      "Ayşepınarı": true,
      "Barbaros": true,
      "Beşbağlar": true,
      "Beşen": true,
      "Bin Evler": true,
      "Boğaziçi": true,
      "Bulutoğlu": true,
      "Büyüksır": true,
      "Celilli Dedeler": true,
      "Ceyhan": true,
      "Cumhuriyet": true,
      "Cüceli": true,
      "Çağırkan": true,
      "Çağlayan": true,
      "Çakırdere": true,
      "Çakırlar": true,
      "Çamlıbel": true,
      "Çamlıca": true,
      "Çamlık": true,
      "Çevrepınar": true,
      "Çokran": true,
      "Çukurhisar": true,
      "Dadağlı": true,
      "Demrek": true,
      "Dereboğazı": true,
      "Döngel": true,
      "Döngele": true,
      "Dönüklü": true,
      "Dumlupınar": true,
      "Ertuğrul Gazi": true,
      "Fatih": true,
      "Fatmalı": true,
      "Gayberli": true,
      "Gedemen": true,
      "Gölpınar": true,
      "Hacı Bayram Veli": true,
      "Hacıağlar": true,
      "Hacıbudak": true,
      "Hacıibrahimuşağı": true,
      "Hacılar": true,
      "Hacımustafa": true,
      "Hacınınoğlu": true,
      "Hartlap": true,
      "Hasancıklı": true,
      "Haydar Bey": true,
      "Hayrullah": true,
      "Hürriyet": true,
      "Ilıca": true,
      "İsmailli": true,
      "İstiklal": true,
      "Kalakaya": true,
      "Kale": true,
      "Kapıkaya": true,
      "Karacaoğlan": true,
      "Karadere": true,
      "Karamanlı": true,
      "Kavlaklı": true,
      "Kaynar": true,
      "Kazım Karabekir": true,
      "Kerimli": true,
      "Kertmen": true,
      "Kılavuzlu": true,
      "Kısıklı": true,
      "Kızıldamlar": true,
      "Kızılseki": true,
      "Kozcağız": true,
      "Köseli": true,
      "Köşürge": true,
      "Kumarlı": true,
      "Kumaşır": true,
      "Kurtlar": true,
      "Kurucaova": true,
      "Küçüksır": true,
      "Kümperli": true,
      "Kürtül": true,
      "Maarif": true,
      "Mağralı": true,
      "Maksutlu": true,
      "Malik Ejder": true,
      "Mercimektepe": true,
      "Mevlana": true,
      "Mimar Sinan": true,
      "Molla Gürani": true,
      "Muratlı": true,
      "Necip Fazıl": true,
      "Orhangazi": true,
      "Oruç Reis": true,
      "Osman Gazi": true,
      "Önsen": true,
      "Öşlü": true,
      "Öztürk": true,
      "Payamlı": true,
      "Piri Reis": true,
      "Rahmacılar": true,
      "Rasim Özdenören": true,
      "Reyhanlı": true,
      "Saçaklızade": true,
      "Sadıklı": true,
      "Sarıçukur": true,
      "Sarıgüzel": true,
      "Sarımollalı": true,
      "Saygılı": true,
      "Selçuklu": true,
      "Selimiye": true,
      "Serintepe": true,
      "Suçatı": true,
      "Suluyayla": true,
      "Süleymanlı": true,
      "Süleymanşah": true,
      "Şahinkayası": true,
      "Şazi Bey": true,
      "Şehit Abdullah Çavuş": true,
      "Şehit Evliya": true,
      "Tavşan Tepe": true,
      "Tekerek": true,
      "Tekir": true,
      "Topçalı": true,
      "Uludaz": true,
      "Üngüt": true,
      "Vadi": true,
      "Yamaçtepe": true,
      "Yavşanova": true,
      "Yenicekale": true,
      "Yenidemir": true,
      "Yeniyapan": true,
      "Yeşilyurt": true,
      "Yirmiikigün": true,
      "Yolyanı": true,
      "Yunus Emre": true,
      "Yusuflar": true,
      "Yürükselim": true,
      "Zeytindere": true
    },
    "Pazarcık": {
      "15 Temmuz": true,
      "Ahmet Bozdağ": true,
      "Akcakoyunlu": true,
      "Akçalar": true,
      "Akdemir": true,
      "Armutlu": true,
      "Aşağımülk": true,
      "Bağdınısağır": true,
      "Beşçeşme": true,
      "Bölükçam": true,
      "Büyüknacar Fatih": true,
      "Büyüknacar Kocadere": true,
      "Büyüknacar Merkez": true,
      "Cengiz Topel": true,
      "Cimikanlı": true,
      "Çamlıca": true,
      "Çamlıtepe": true,
      "Çiçek": true,
      "Çiçekalanı": true,
      "Çiğdemtepe": true,
      "Çöçelli": true,
      "Damlataş": true,
      "Dedepaşa": true,
      "Eğlen": true,
      "Eğrice": true,
      "Emiroğlu": true,
      "Evri Pınarbaşı": true,
      "Evri Taşbiçme": true,
      "Fatih": true,
      "Ganidağıketiler": true,
      "Göçer": true,
      "Göynük": true,
      "Hanobası": true,
      "Harmancık": true,
      "Hasankoca": true,
      "Hürriyet": true,
      "İncirli": true,
      "Kadıncık": true,
      "Karaağaç": true,
      "Karabıyıklı": true,
      "Karaçay": true,
      "Karagöl": true,
      "Karahüyük": true,
      "Keleş": true,
      "Kızkapanlı": true,
      "Kizirli": true,
      "Kuzeykent": true,
      "Mehmet Emin Arıkoğlu": true,
      "Memiş Özdal": true,
      "Memişkahya": true,
      "Menderes": true,
      "Mezere": true,
      "Musolar": true,
      "Narlı Bahçelievler": true,
      "Narlı Cumhuriyet": true,
      "Narlı Ismetpaşa": true,
      "Nefsidoğanlı": true,
      "Osmandede": true,
      "Ördekdede": true,
      "Sadakalar": true,
      "Sakarkaya": true,
      "Sallıuşağı": true,
      "Salmanıpak": true,
      "Salmanlı": true,
      "Sarıerik": true,
      "Sarıl": true,
      "Soku Milyanlı": true,
      "Sultanlar": true,
      "Şahintepe": true,
      "Şehit Nurettin Ademoğlu": true,
      "Taşdemir": true,
      "Tetirlik": true,
      "Tilkiler": true,
      "Turunçlu": true,
      "Ufacıklı": true,
      "Ulubahçe": true,
      "Yarbaşı": true,
      "Yeşilkent": true,
      "Yiğitler": true,
      "Yolboyu": true,
      "Yukarıhöcüklü": true,
      "Yukarımülk": true,
      "Yumaklıcerit Bağlar": true,
      "Yumaklıcerit Cumhuriyet": true
    },
    "Türkoğlu": {
      "Akçalı": true,
      "Avşarlı": true,
      "Aydınkavak": true,
      "Bayramgazi": true,
      "Beyoğlu": true,
      "Ceceli": true,
      "Cennetpınarı": true,
      "Cumhuriyet": true,
      "Çakallıçullu": true,
      "Çakallıhasanağa": true,
      "Çakıroğlu": true,
      "Çobantepe": true,
      "Dedeler": true,
      "Doluca": true,
      "Fatih": true,
      "Gaziler": true,
      "Gaziosmanpaşa": true,
      "Güllühüyük": true,
      "Hacıbebek": true,
      "Hopurlu": true,
      "İmalı": true,
      "İstasyon": true,
      "Kadıoğluçiftliği": true,
      "Kaledibi": true,
      "Kelibişler": true,
      "Kılılı": true,
      "Kırmakaya": true,
      "Kızıleniş": true,
      "Kumçatı": true,
      "Kuyumcular": true,
      "Küçükimalı": true,
      "Minehüyük": true,
      "Önsenhopuru": true,
      "Özbek": true,
      "Pınarhüyük": true,
      "Şekeroba": true,
      "Tahtalıdedeler": true,
      "Uzunsöğüt": true,
      "Yavuzlar": true,
      "Yeniköy": true,
      "Yenipınar": true,
      "Yeşilyöre": true,
      "Yeşilyurt": true,
      "Yolderesi": true
    }
  },
  "Karabük": {
    "Eflani": {
      "Candaroğulları": true,
      "Çalışlar": true,
      "Çelebiler": true,
      "Kayadibi": true,
      "Tabaklar": true,
      "Yalacık": true
    },
    "Eskipazar": {
      "Bahçepınar": true,
      "İstasyon": true,
      "Kıranköy": true,
      "Merkez": true,
      "Mermer": true,
      "Yamanlar": true,
      "Yeni": true
    },
    "Merkez": {
      "100.yıl": true,
      "5000 Evler 75.yıl": true,
      "5000 Evler Bahçelievler": true,
      "5000 Evler Cumhuriyet": true,
      "Adatepe": true,
      "Atatürk": true,
      "Aydınlıkevler": true,
      "Bayır": true,
      "Belenköy": true,
      "Çerçiler": true,
      "Ergenekon": true,
      "Fatih": true,
      "Fevzi Çakmak": true,
      "Hürriyet": true,
      "Kapullu": true,
      "Karabük": true,
      "Kartaltepe": true,
      "Kayabaşı": true,
      "Kılavuzlar": true,
      "Kurtuluş": true,
      "Namık Kemal": true,
      "Öğlebeli": true,
      "Soğuksu": true,
      "Şirinevler": true,
      "Üniversite": true,
      "Yeni": true,
      "Yenişehir": true,
      "Yeşil": true
    },
    "Ovacık": {
      "Merkez": true
    },
    "Safranbolu": {
      "15 Temmuz": true,
      "Akçasu": true,
      "Aşağı Tokatlı": true,
      "Atatürk": true,
      "Babasultan": true,
      "Bağlarbaşı": true,
      "Barış": true,
      "Camikebir": true,
      "Cemalcaymaz": true,
      "Çavuş": true,
      "Çeşme": true,
      "Emek": true,
      "Esentepe": true,
      "Hacıhalil": true,
      "Hüseyinçelebi": true,
      "İsmetpaşa": true,
      "İzzetpaşa": true,
      "Karaali": true,
      "Kirkille": true,
      "Musalla": true,
      "Yenimahalle": true
    },
    "Yenice": {
      "Atatürk": true,
      "Çengeller": true,
      "Dere": true,
      "Döngeller": true,
      "Fatih": true,
      "İsmetpaşa": true,
      "Kalaycılar": true,
      "Karakırıklar": true,
      "Karaömerler": true,
      "Karşıyaka": true,
      "Menderes": true,
      "Merkez": true,
      "Özal": true,
      "Sipahiler": true,
      "Yirmibeşler": true
    }
  },
  "Karaman": {
    "Ayrancı": {
      "Dede": true,
      "Musa": true,
      "Ulu": true,
      "Yeni": true
    },
    "Başyayla": {
      "Başköy": true,
      "Göztepe": true,
      "Kirazlıyayla": true,
      "Şirindere": true,
      "Yenimahalle": true
    },
    "Ermenek": {
      "Akcamescit": true,
      "Aralık": true,
      "Başpınar": true,
      "Bucak": true,
      "Cami": true,
      "Çatalbadem": true,
      "Çınarlısu": true,
      "Değirmenlik": true,
      "Gökceler": true,
      "Güllük": true,
      "Gülpazar": true,
      "Habib": true,
      "Karalar": true,
      "Kebendibi": true,
      "Keçipazar": true,
      "Keşillik": true,
      "Kışlacık": true,
      "Merkez": true,
      "Meydan": true,
      "Oda": true,
      "Orta": true,
      "Pınargözü": true,
      "Sandıklı": true,
      "Seyran": true,
      "Susaklı": true,
      "Taşbaşı": true,
      "Tepecik": true,
      "Türbeseki": true,
      "Uluköy": true,
      "Yenimahalle": true,
      "Yukarı": true
    },
    "Kazımkarabekir": {
      "Boyacı": true,
      "Eminettin": true,
      "Emsalhayat": true,
      "Oba": true,
      "Pazar": true,
      "Selçuklu": true,
      "Subaşı": true,
      "Timsal": true
    },
    "Merkez": {
      "Abbas": true,
      "Ahiosman": true,
      "Ahmet Yesevi": true,
      "Alacasuluk": true,
      "Alişahane": true,
      "Atatürk": true,
      "Bahçelievler": true,
      "Başakşehir": true,
      "Beyazkent": true,
      "Cedit": true,
      "Cumhuriyet": true,
      "Çeltek": true,
      "Elmaşehir": true,
      "Fatih": true,
      "Fenari": true,
      "Gazi": true,
      "Gazidükkan": true,
      "Gevher Hatun": true,
      "Hacıcelal": true,
      "Hamidiye": true,
      "Hisar": true,
      "Hürriyet": true,
      "İbrahim Hakkı Konyalı": true,
      "İmaret": true,
      "Karamanoğlu Mehmet Bey": true,
      "Kazım Karabekir Paşa": true,
      "Ketenci": true,
      "Kırbağı": true,
      "Kirişçi": true,
      "Koçakdede": true,
      "Külhan": true,
      "Larende": true,
      "Mahmudiye": true,
      "Mansurdede": true,
      "Mehmet Akif Ersoy": true,
      "Mümine Hatun": true,
      "Nefise Sultan": true,
      "Osmangazi": true,
      "Pirireis": true,
      "Rauf Denktaş": true,
      "Sakabaşı": true,
      "Sekiçeşme": true,
      "Siyahser": true,
      "Sümer": true,
      "Şeyh Edebali": true,
      "Şeyh Şamil": true,
      "Tabduk Emre": true,
      "Tahsin Ünal": true,
      "Topucak": true,
      "Urgan": true,
      "Üniversite": true,
      "Valide Sultan": true,
      "Yenimahalle": true,
      "Yenişehir": true,
      "Yeşilada": true,
      "Yunus Emre": true,
      "Yunuskent": true,
      "Zembilli Ali Efendi": true,
      "Ziya Gökalp": true
    },
    "Sarıveliler": {
      "Adiller": true,
      "Baş": true,
      "Cumhuriyet": true,
      "Çakıllar": true,
      "Çukurbağ": true,
      "Esentepe": true,
      "Göksu": true,
      "Gülpazar": true,
      "Günder": true,
      "Karakaya": true,
      "Küçük Karapınar": true,
      "Mençek": true,
      "Merkez": true,
      "Ortaköy": true,
      "Turcalar": true,
      "Ulucami": true,
      "Yeşilyurt": true,
      "Yıldız": true
    }
  },
  "Kars": {
    "Akyaka": {
      "İstasyon": true,
      "Tepe": true,
      "Topkaya": true
    },
    "Arpaçay": {
      "Bahçeler": true,
      "Orta": true,
      "Yalınçayır": true,
      "Yeni": true
    },
    "Digor": {
      "Merkez": true
    },
    "Kağızman": {
      "Aşağı Kümbet": true,
      "Aşağıdere": true,
      "Bayam": true,
      "Haznedar": true,
      "Şahindere": true,
      "Toprakkale": true,
      "Yukarı Dere": true,
      "Yukarı Kümbet": true,
      "Zuvar": true
    },
    "Merkez": {
      "30 Ekim": true,
      "Alpaslan": true,
      "Atatürk": true,
      "Aydınlıkevler": true,
      "Bahçelievler": true,
      "Bayrampaşa": true,
      "Bülbül": true,
      "Cumhuriyet": true,
      "Fevziçakmak": true,
      "Hafızpaşa": true,
      "Halitpaşa": true,
      "İstasyon": true,
      "Kaleiçi": true,
      "Karadağ": true,
      "Merkez": true,
      "Ortakapı": true,
      "Örnek": true,
      "Paşaçayırı": true,
      "Sukapı": true,
      "Şehitler": true,
      "Yeni": true,
      "Yenişehir": true,
      "Yusufpaşa": true
    },
    "Sarıkamış": {
      "Cumhuriyet": true,
      "Erenler": true,
      "İnönü": true,
      "İstasyon": true,
      "İstiklal": true,
      "Kazımkarabekir": true,
      "Şehitler": true,
      "Tepe": true,
      "Yeni": true
    },
    "Selim": {
      "Cumhuriyet": true,
      "Çarşı": true,
      "Köprübaşı": true
    },
    "Susuz": {
      "Cumhuriyet": true,
      "İnkılap": true,
      "İnönü": true,
      "Kazım Karabekir": true
    }
  },
  "Kastamonu": {
    "Abana": {
      "Bağlık": true,
      "Çayırcık": true,
      "Hacıveli": true,
      "Konakören": true,
      "Merkez": true
    },
    "Ağlı": {
      "Alınca": true,
      "Danacı": true,
      "Dikmen": true,
      "Ketenciler": true,
      "Kırlardere": true,
      "Merkez": true,
      "Örencik": true,
      "Selmanlı": true,
      "Sinan": true,
      "Yağlıca": true
    },
    "Araç": {
      "Çay": true,
      "İnönü": true,
      "Mesudiye": true,
      "Yeni": true,
      "Yeşil": true,
      "Yukarıaraç": true
    },
    "Azdavay": {
      "Bahçelievler": true,
      "Karşıyaka": true,
      "Merkez": true,
      "Yeni": true
    },
    "Bozkurt": {
      "Hamza": true,
      "Merkez": true,
      "Şen": true,
      "Yeni": true,
      "Yüksek": true
    },
    "Cide": {
      "Bağyurdu": true,
      "Cumhuriyet": true,
      "Ece": true,
      "Gebeş": true,
      "Irmak": true,
      "Kalafat": true,
      "Kasaba": true,
      "Kasım": true,
      "Kemerli": true,
      "Kırcı": true,
      "Kumluca": true,
      "Memiş": true,
      "Nasuh": true,
      "Sipahi": true,
      "Sofular": true,
      "Tarakçı": true
    },
    "Çatalzeytin": {
      "Çelebiler": true,
      "Merkez": true
    },
    "Daday": {
      "Bey": true,
      "Kalem": true,
      "Kelebek": true,
      "Merkez": true
    },
    "Devrekani": {
      "Ahiçelebi": true,
      "Çayırcık": true,
      "Etçiler": true,
      "İsmailbey": true,
      "Kadirbey": true,
      "Kurtşeyh": true,
      "Mütevelli": true,
      "Sazyaka": true
    },
    "Doğanyurt": {
      "Hocaköyü": true,
      "Merkez": true
    },
    "Hanönü": {
      "Gelinbükü": true,
      "Hanönü": true,
      "Vakıf Geymene": true
    },
    "İhsangazi": {
      "Afşar": true,
      "Çay": true,
      "Elçelebi": true,
      "İsalar": true,
      "Kalfat": true,
      "Kuşçular": true,
      "Sevindik": true,
      "Sipahiler": true,
      "Yeni": true,
      "Yeşil": true
    },
    "İnebolu": {
      "Aşağıhatipbağı": true,
      "Avara": true,
      "Boyran": true,
      "Camikebir": true,
      "Cünürye": true,
      "Çamlıca": true,
      "Karaca": true,
      "Karadeniz": true,
      "Kızılkara": true,
      "Musa": true,
      "Yakaboyu": true,
      "Yeni": true,
      "Yeşilöz": true,
      "Yukarıhatipbağı": true
    },
    "Küre": {
      "Camievsat": true,
      "Camikebir": true,
      "Müderris": true,
      "Saman": true
    },
    "Merkez": {
      "Akmescit": true,
      "Aktekke": true,
      "Atabeygazi": true,
      "Beyçelebi": true,
      "Budamış": true,
      "Candaroğulları": true,
      "Cebrail": true,
      "Esentepe": true,
      "Hepkebirler": true,
      "Hisarardı": true,
      "Honsalar": true,
      "İnönü": true,
      "İsfendiyar": true,
      "İsmailbey": true,
      "Kırkçeşme": true,
      "Kuzeykent": true,
      "Mehmet Akif Ersoy": true,
      "Saraçlar": true,
      "Topçuoğlu": true,
      "Yavuzselim": true
    },
    "Pınarbaşı": {
      "Atatürk": true,
      "Cumhuriyet": true,
      "Çalkaya": true,
      "Çamkışla": true,
      "Fatih": true,
      "Uzunçam": true
    },
    "Seydiler": {
      "Aşağıarslanlı": true,
      "Ayvatlar": true,
      "Batıörcünler": true,
      "Delihacılar": true,
      "Demirciözü": true,
      "Hacıkayalar": true,
      "Merkez": true,
      "Yağlar": true,
      "Yayla": true,
      "Yukarıarslanlı": true
    },
    "Şenpazar": {
      "Çevrik": true,
      "Dibekli": true,
      "Güneytekke": true,
      "Karaman": true,
      "Korucak": true,
      "Kuztekke": true,
      "Merkez": true
    },
    "Taşköprü": {
      "Ağcıkişi": true,
      "Bahçelievler": true,
      "Camikebir": true,
      "Ethem": true,
      "Gizlice": true,
      "Gökırmak": true,
      "Harmancık": true,
      "Karasait": true,
      "Musalla": true,
      "Pulcular": true,
      "Sümer": true,
      "Tabakhane": true,
      "Tekke": true,
      "Üstatlar": true
    },
    "Tosya": {
      "Bahçelievler": true,
      "Camiatik": true,
      "Cumhuriyet": true,
      "Çatma": true,
      "Dere": true,
      "Dilküşa": true,
      "Fevzipaşa": true,
      "Hacı Kemal": true,
      "Hacıpir": true,
      "Harsat": true,
      "Hocafakı": true,
      "Hocaimat": true,
      "İbni Selim": true,
      "İlyasbey": true,
      "Kargı": true,
      "Karşıyaka": true,
      "Kuzyaka": true,
      "Mimar Sinan": true,
      "Pınarbaşı": true,
      "Şeh": true,
      "Şehreküstü": true,
      "Yavuz Selim": true,
      "Yunus Emre": true
    }
  },
  "Kayseri": {
    "Akkışla": {
      "Akin": true,
      "Alevkışla": true,
      "Ganişeyh": true,
      "Girinci": true,
      "Gömürgen": true,
      "Gömürgen Yeni": true,
      "Gümüşsu": true,
      "Kululu": true,
      "Manavuz": true,
      "Ortaköy": true,
      "Şen": true,
      "Uğurlu": true,
      "Yeni": true,
      "Yeşil": true,
      "Yukarı": true
    },
    "Bünyan": {
      "Ağcalı": true,
      "Akçatı": true,
      "Akmescit": true,
      "Asmakaya": true,
      "Bayramlı": true,
      "Burhaniye": true,
      "Büyüktuzhisar": true,
      "Camiicedit": true,
      "Camiikebir": true,
      "Cumhuriyet": true,
      "Dağardı": true,
      "Dervişağa": true,
      "Doğanlar": true,
      "Ekinciler": true,
      "Elbaşı": true,
      "Emirören": true,
      "Fatih": true,
      "Gergeme": true,
      "Girveli": true,
      "Güllüce": true,
      "Hazarşah": true,
      "İbrahimbey": true,
      "İğdecik": true,
      "Kahveci": true,
      "Karacaören": true,
      "Karahıdır": true,
      "Karakaya": true,
      "Karatay": true,
      "Kardeşler": true,
      "Koyunabdal": true,
      "Köprübaşı": true,
      "Kösehacılı": true,
      "Musaşeyh": true,
      "Pirahmet": true,
      "Sağlık": true,
      "Samağır": true,
      "Sıvgın": true,
      "Sultanhanı": true,
      "Sümer": true,
      "Topsöğüt": true,
      "Yağmurbey": true,
      "Yakutiye": true,
      "Yavuz Selim": true,
      "Yeni Süksün": true,
      "Yenice": true,
      "Yünören": true
    },
    "Develi": {
      "Abdulbaki": true,
      "Alpaslan": true,
      "Aşağıeverek": true,
      "Aşık Seyrani": true,
      "Ayşepınar": true,
      "Ayvazhacı": true,
      "Bahçebaşı": true,
      "Bahçelievler": true,
      "Büyükkünye": true,
      "Camiicedit": true,
      "Cumhuriyet": true,
      "Çadıryeri": true,
      "Çataloluk": true,
      "Çayırözü": true,
      "Çaylıca": true,
      "Çomaklı": true,
      "Çöten": true,
      "Çukuryurt": true,
      "Derebaşı": true,
      "Dereşimli": true,
      "Develi Camikebir": true,
      "E.camiikebir": true,
      "Epçe": true,
      "Eşelik": true,
      "Fatih": true,
      "Feneseaşağı": true,
      "Feneseyukarı": true,
      "Gazi": true,
      "Gömedi": true,
      "Gümüşören": true,
      "Güneyaşağı": true,
      "Güneyyukarı": true,
      "Harman": true,
      "Havadan": true,
      "Hoşça": true,
      "Hüseyinli": true,
      "İbrahimağa": true,
      "İncesu": true,
      "İzmirli": true,
      "Kabaklı": true,
      "Kaleköy": true,
      "Karacaören": true,
      "Kılıçkaya": true,
      "Kızık": true,
      "Kopçullu": true,
      "Kozluca": true,
      "Köseler": true,
      "Kulpak": true,
      "Küçükkünye": true,
      "Mehmet Akif Ersoy": true,
      "Millidere": true,
      "Mustafa Asım Köksal": true,
      "Öksüt": true,
      "Reşadiye": true,
      "Saraycık": true,
      "Sarıca": true,
      "Sarıkaya": true,
      "Satı": true,
      "Sindelhöyük Camikebir": true,
      "Sindelhöyük Fatih": true,
      "Sindelhöyük Yenice": true,
      "Soysallı": true,
      "Şahmelik": true,
      "Şht.üstğm.hasan Şahan": true,
      "Şıhlı": true,
      "Taşcı Bucak Merkezi": true,
      "Tombak": true,
      "Yaylacık": true,
      "Yazıbaşı": true,
      "Yedek": true,
      "Yeni": true,
      "Yenice": true,
      "Yenihayat": true,
      "Yeniköy": true,
      "Yeşilyurt": true,
      "Yüzevler": true,
      "Zile": true
    },
    "Felahiye": {
      "Acırlı": true,
      "Alparslan": true,
      "Beyler": true,
      "Büyüktoraman Hürriyet": true,
      "Büyüktoraman Istiklal": true,
      "Cumhuriyet": true,
      "Darılı": true,
      "İsabey": true,
      "Kale": true,
      "Karaşeyh": true,
      "Kayapınar Cumhuriyet": true,
      "Kayapınar Fatih Sultan Mehmet": true,
      "Kepiç": true,
      "Kuruhüyük": true,
      "Menteşe": true,
      "Silahtar": true,
      "Yeni": true
    },
    "Hacılar": {
      "Akdam": true,
      "Akyazı": true,
      "Aşağı": true,
      "Beğendik": true,
      "Erciyes": true,
      "Hürmetci": true,
      "Karpuzsekisi": true,
      "Orta": true,
      "Sakarçiftliği": true,
      "Yediağaç": true,
      "Yeni": true,
      "Yukarı": true
    },
    "İncesu": {
      "Bahçelievler": true,
      "Bahçesaray": true,
      "Bulgurcu": true,
      "Çardaklı": true,
      "Dokuzpınar": true,
      "Fırınönü": true,
      "Garipçe": true,
      "Gönenkent": true,
      "Hamurcu": true,
      "Karahüyük": true,
      "Karakoyunlu": true,
      "Karamustafapaşa": true,
      "Kızılören Aşağı": true,
      "Kızılören Ötebatan": true,
      "Kızılören Tabaklı": true,
      "Küllü": true,
      "Örenşehir": true,
      "Saraycık": true,
      "Sarıkürklü": true,
      "Semerkent": true,
      "Subaşı": true,
      "Süksün Cumhuriyet": true,
      "Süksün Hürriyet": true,
      "Süksün Zafer": true,
      "Şeyhşaban": true,
      "Tahirinli": true,
      "Üçkuyu": true,
      "Vali Ihsan Aras": true,
      "Yarım": true,
      "Yeni Camii": true
    },
    "Kocasinan": {
      "Ahi Evran": true,
      "Akcatepe": true,
      "Akin": true,
      "Alsancak": true,
      "Amarat": true,
      "Argıncık": true,
      "Barbaros": true,
      "Barsama": true,
      "Bayramhacı": true,
      "Beyazşehir": true,
      "Beydeğirmeni": true,
      "Boğazköprü": true,
      "Boyacı": true,
      "Boztepe": true,
      "Buğdaylı": true,
      "Camikebir": true,
      "Cırgalan": true,
      "Çevril": true,
      "Dadağı": true,
      "Doruklu": true,
      "Düver": true,
      "Ebiç": true,
      "Elagöz": true,
      "Elmalı": true,
      "Emmiler": true,
      "Erciyesevler": true,
      "Erkilet": true,
      "Ertuğrul Gazi": true,
      "Eskiömerler": true,
      "Eyim": true,
      "Fevzi Çakmak": true,
      "Fevzioğlu": true,
      "General Emir": true,
      "Gevher Nesibe": true,
      "Gömeç": true,
      "Güneşli": true,
      "Hasan Arpa": true,
      "Hasancı": true,
      "Hırkaköy": true,
      "Himmetdede": true,
      "Hoca Ahmet Yesevi": true,
      "Höbek": true,
      "Kalkancık": true,
      "Karahöyük": true,
      "Karakimse": true,
      "Kaşköy": true,
      "Kayabaşı": true,
      "Kemer": true,
      "Kızık": true,
      "Kuşcağız": true,
      "Kuşçu": true,
      "Mahzemin": true,
      "Mevlana": true,
      "Mimarsinan": true,
      "Mithatpaşa": true,
      "Mollahacı": true,
      "Molu": true,
      "Obruk": true,
      "Oruçreis": true,
      "Osmangazi": true,
      "Oymaağaç": true,
      "Sahabiye": true,
      "Salur": true,
      "Sanayi": true,
      "Sancaktepe": true,
      "Saray Bosna": true,
      "Saraycık": true,
      "Seyrani": true,
      "Sümer Yeni": true,
      "Şeker": true,
      "Talatpaşa": true,
      "Taşhan": true,
      "Turgut Reis": true,
      "Uğurevler": true,
      "Vatan": true,
      "Yakut": true,
      "Yavuz Selim": true,
      "Yazır": true,
      "Yemliha": true,
      "Yenidoğan": true,
      "Yenişehir": true,
      "Yeşil": true,
      "Yukarıhasinli": true,
      "Yunus Emre": true,
      "Yuvalı": true,
      "Yüreğil": true,
      "Ziyagökalp": true,
      "Zümrüt": true
    },
    "Melikgazi": {
      "19 Mayıs": true,
      "30 Ağustos": true,
      "Ağırnas": true,
      "Alpaslan": true,
      "Altınoluk": true,
      "Anafartalar": true,
      "Anbar": true,
      "Aydınlıkevler": true,
      "Bağpınar": true,
      "Bahçelievler": true,
      "Battalgazi": true,
      "Becen": true,
      "Büyük Bürüngüz": true,
      "Cumhuriyet": true,
      "Danişmentgazi": true,
      "Demokrasi": true,
      "Eğribucak": true,
      "Erenköy": true,
      "Esentepe": true,
      "Esenyurt": true,
      "Fatih": true,
      "Germir": true,
      "Gesi": true,
      "Gesi Fatih": true,
      "Gökkent": true,
      "Gültepe": true,
      "Gülük": true,
      "Gürpınar": true,
      "Güzelköy": true,
      "Hisarcık": true,
      "Hunat": true,
      "Hürriyet": true,
      "İldem Cumhuriyet": true,
      "Kayabağ": true,
      "Kazımkarabekir": true,
      "Keykubat": true,
      "Kılıçaslan": true,
      "Kıranardı": true,
      "Kocatepe": true,
      "Köşk": true,
      "Küçük Bürüngüz": true,
      "Mimarsinan": true,
      "Osman Kavuncu": true,
      "Osmanlı": true,
      "Sakarya": true,
      "Sarımsaklı": true,
      "Selçuklu": true,
      "Selimiye": true,
      "Subaşı": true,
      "Şirintepe": true,
      "Tacettinveli": true,
      "Tavlusun": true,
      "Tınaztepe": true,
      "Turan": true,
      "Vekse": true,
      "Yeniköy": true,
      "Yeşilyurt": true,
      "Yıldırım Beyazıt": true
    },
    "Özvatan": {
      "Alparslan": true,
      "Aşağı Boğaziçi": true,
      "Bahçeli Evler": true,
      "Cumhuriyet": true,
      "Güney": true,
      "Kale": true,
      "Kavaklı": true,
      "Kermelik": true,
      "Küpeli": true,
      "Taşlık": true,
      "Tuğlaşah": true,
      "Yeni": true,
      "Yukarı Boğaziçi": true
    },
    "Pınarbaşı": {
      "Akören": true,
      "Akpınar": true,
      "Alagazili": true,
      "Alamescit": true,
      "Altıkesek": true,
      "Arslanbeyli": true,
      "Artmak": true,
      "Aşağıbeyçayırı": true,
      "Aşağıborandere": true,
      "Aşağıkaragöz": true,
      "Aşağıkızılçevlik": true,
      "Avşarpotuklu": true,
      "Aygörmez": true,
      "Bahçecik": true,
      "Beserek": true,
      "Büyükgümüşgün": true,
      "Büyükgürleğen": true,
      "Büyükkabaktepe": true,
      "Büyükkaramanlı": true,
      "Büyükkaramuklu": true,
      "Büyükkömarmut": true,
      "Büyükpotuklu": true,
      "Cabe": true,
      "Cinahmet": true,
      "Cinliören": true,
      "Çakılkaya": true,
      "Çaybaşı": true,
      "Çördüklü": true,
      "Çukuryurt": true,
      "Demircili": true,
      "Demirciören": true,
      "Devederesi": true,
      "Dikilitaş": true,
      "Dilciler": true,
      "Eğrisöğüt": true,
      "Elmalı": true,
      "Emeğil": true,
      "Esenköy": true,
      "Eskitekke": true,
      "Eskiyassıpınar": true,
      "Fakıekinciliği": true,
      "Gebelek": true,
      "Gölcük": true,
      "Gültepe": true,
      "Gümüşgün": true,
      "Güney": true,
      "Halitbeyören": true,
      "Han": true,
      "Hasırcı": true,
      "Hassa": true,
      "Hayriye": true,
      "Hilmiye": true,
      "Hürriyet": true,
      "İğdelipayaslı": true,
      "İnliören": true,
      "İnönü": true,
      "Kadılı": true,
      "Kaftangiyen": true,
      "Kaman": true,
      "Karaboğaz": true,
      "Karahacılı": true,
      "Karahalka": true,
      "Karakuyu": true,
      "Kavakköy": true,
      "Kavlaklar": true,
      "Kayaaltı": true,
      "Kayabaşı": true,
      "Kayaönü": true,
      "Kaynar": true,
      "Kazancık": true,
      "Kerimoğlu": true,
      "Kılıçkışla": true,
      "Kılıçmehmet": true,
      "Kırkgeçit": true,
      "Kırkpınar": true,
      "Kızıldere": true,
      "Kızılhan": true,
      "Kızılören": true,
      "Köşkerli": true,
      "Kurbağalık": true,
      "Kurttepe": true,
      "Kuşçular": true,
      "Küçükkömarmut": true,
      "Küçükpotuklu": true,
      "Malakköy": true,
      "Melikgazi": true,
      "Methiye": true,
      "Olukkaya": true,
      "Oruçoğlu": true,
      "Örenşehir Bucak Merkezi": true,
      "Panlı": true,
      "Paşalı": true,
      "Pazarören": true,
      "Pazarsu": true,
      "Pulpınar": true,
      "Saçayağı": true,
      "Saçlı": true,
      "Serinyurt": true,
      "Solaklar": true,
      "Söğütlü": true,
      "Şabanlı": true,
      "Şerefiye": true,
      "Tahtaköprü": true,
      "Taşlıgeçit": true,
      "Taşlıoğlu": true,
      "Taşoluk": true,
      "Tersakan": true,
      "Tözgün": true,
      "Uzunpınar": true,
      "Uzunyol": true,
      "Üçpınar": true,
      "Yağlıpınar": true,
      "Yahyabey": true,
      "Yarımtepe": true,
      "Yenicami": true,
      "Yeniocak": true,
      "Yeregeçen": true,
      "Yukarıbeyçayırı": true,
      "Yukarıborandere": true,
      "Yukarıkaragöz": true,
      "Yukarıkızılçevlik": true,
      "Yusuflar": true
    },
    "Sarıoğlan": {
      "Alamettin": true,
      "Bakarcak": true,
      "Burunören": true,
      "Çiftlik": true,
      "Düzencik": true,
      "Ebülhayır": true,
      "Gaziler": true,
      "Güzelyazı": true,
      "Hürriyet": true,
      "Ilıca": true,
      "İğdeli": true,
      "Kadılı": true,
      "Kaleköy": true,
      "Karaözü": true,
      "Karpınar": true,
      "Keklikoğlu": true,
      "Kızılpınar": true,
      "Muratbeyli": true,
      "Ömerhacılı": true,
      "Ömürlü": true,
      "Palas": true,
      "Sofumahmut": true,
      "Şenyurt": true,
      "Tatılı": true,
      "Üzerlik": true,
      "Yahyalı": true,
      "Yerlikuyu": true,
      "Yıldırım": true
    },
    "Sarız": {
      "Akoluk": true,
      "Altısöğüt": true,
      "Avşarobası": true,
      "Ayranlık": true,
      "Bahçeli": true,
      "Büyük Örtülü": true,
      "Büyük Söbeçimen": true,
      "Çağşak": true,
      "Çatalpınar": true,
      "Çavdar": true,
      "Çörekdere": true,
      "Dallıkavak": true,
      "Damızlık": true,
      "Darıdere": true,
      "Dayoluk": true,
      "Değirmentaş": true,
      "Fettahdere": true,
      "Gümüşali": true,
      "Günesen": true,
      "İmirzaağa": true,
      "İncedere": true,
      "İncemağara": true,
      "Karapınar": true,
      "Karayurt": true,
      "Kemer": true,
      "Kırkısrak": true,
      "Kıskaçlı": true,
      "Kızılpınar": true,
      "Kurdini": true,
      "Kurudere": true,
      "Kuşçu": true,
      "Küçük Kabaktepe": true,
      "Küçük Örtülü": true,
      "Küçük Söbeçimen": true,
      "Mollahüseyinler": true,
      "Oğlakkaya": true,
      "Ördekli": true,
      "Sancakağıl": true,
      "Tavla": true,
      "Tekneli": true,
      "Yaylacı": true,
      "Yedioluk": true,
      "Yeni": true,
      "Yeşilkent": true
    },
    "Talas": {
      "Akçakaya": true,
      "Alaybeyli": true,
      "Ardıç": true,
      "Bahçelievler": true,
      "Başakpınar": true,
      "Cebir": true,
      "Çatakdere": true,
      "Çevlik": true,
      "Çömlekçi": true,
      "Endürlük": true,
      "Han": true,
      "Harman": true,
      "Kamber": true,
      "Kepez": true,
      "Kiçiköy": true,
      "Koçcağız": true,
      "Kuruköprü": true,
      "Mengücek": true,
      "Mevlana": true,
      "Örencik": true,
      "Reşadiye": true,
      "Sakaltutan": true,
      "Sosun": true,
      "Süleymanlı": true,
      "Tablakaya": true,
      "Yamaçlı": true,
      "Yazyurdu": true,
      "Yenidoğan": true,
      "Yukarı": true,
      "Zincidere": true
    },
    "Tomarza": {
      "Akdere": true,
      "Akmezar": true,
      "Arslantaş": true,
      "Avşarsöğütlü": true,
      "Bektaş": true,
      "Bostanlık": true,
      "Böke": true,
      "Büyükcanlı": true,
      "Culha": true,
      "Cumhuriyet": true,
      "Cücün": true,
      "Çanakpınar": true,
      "Çayinli": true,
      "Çukurağaç": true,
      "Dadaloğlu": true,
      "Dağyurdu": true,
      "Ekinli": true,
      "Emiruşağı": true,
      "Göktepe": true,
      "Gülveren": true,
      "Güzelce": true,
      "Güzelsu": true,
      "Hacıpaşa": true,
      "Işıklar": true,
      "İcadiye": true,
      "İmamkullu": true,
      "İncili": true,
      "Kale": true,
      "Kapukaya": true,
      "Karamuklu": true,
      "Karaören": true,
      "Kesir": true,
      "Kevenağıl": true,
      "Kızılören": true,
      "Kömür": true,
      "Köprübaşı": true,
      "Kurtuluş": true,
      "Kuşcağız": true,
      "Küçükcanlı": true,
      "Melikören": true,
      "Pusatlı": true,
      "Sarımehmetli": true,
      "Söğütlü": true,
      "Süvegenler": true,
      "Şıhbarak": true,
      "Şiraz": true,
      "Tahtakemer": true,
      "Tatar": true,
      "Toklar": true,
      "Turanlı": true,
      "Üçkonak": true,
      "Yavuzselim": true,
      "Yeni": true,
      "Yeşilbağ": true
    },
    "Yahyalı": {
      "100.yıl": true,
      "75.yıl": true,
      "Ağcaşar": true,
      "Avlağa": true,
      "Balcıçakırı": true,
      "Burhaniye": true,
      "Büyükçakır": true,
      "Camikebir": true,
      "Çamlıca": true,
      "Çavdaruşağı": true,
      "Çiğilli": true,
      "Çubukharmanı": true,
      "Çubuklu": true,
      "Delialiuşağı": true,
      "Denizovası": true,
      "Derebağ": true,
      "Dikme": true,
      "Fetullah": true,
      "Fevziçakmak": true,
      "Gazibeyli": true,
      "İlyaslı": true,
      "İsmet": true,
      "Kapuzbaşı": true,
      "Karaköy": true,
      "Kavacık": true,
      "Kirazlı": true,
      "Kocahacılı": true,
      "Kopçu": true,
      "Kuzoluk": true,
      "Madazı": true,
      "Mustafabeyli": true,
      "Sazak": true,
      "Senirköy": true,
      "Seydili": true,
      "Süleymanfakılı": true,
      "Taşhan": true,
      "Ulupınar": true,
      "Yenice": true,
      "Yerköy": true,
      "Yeşilköy": true,
      "Yuları": true
    },
    "Yeşilhisar": {
      "Akköy": true,
      "Araplı": true,
      "Başköy": true,
      "Beyleryukarı": true,
      "Büget": true,
      "Camikebir": true,
      "Cumhuriyet": true,
      "Çadırkaya": true,
      "Derbentbaşı": true,
      "Doğanlı": true,
      "Erdemli": true,
      "Fatih": true,
      "Fevzioğlu": true,
      "Gülbayır": true,
      "Güney": true,
      "Güzelöz": true,
      "İçmece": true,
      "İdris": true,
      "Kale": true,
      "Karacabey": true,
      "Kavak": true,
      "Kayadibi": true,
      "Keler": true,
      "Keşlik": true,
      "Kovalı": true,
      "Köşk": true,
      "Kuşçu": true,
      "Kuzey": true,
      "Mahmudiye": true,
      "Musahacılı": true,
      "Ovaçiftlik": true,
      "Soğanlı": true,
      "Yavuz Selim": true,
      "Yenişehir": true,
      "Yeşilova": true
    }
  },
  "Kırıkkale": {
    "Bahşılı": {
      "Atadönmez": true,
      "Doğanay": true,
      "Halim Şenses": true,
      "Hidayet Doğruer": true,
      "Hüseyin Onbaşı": true
    },
    "Balışeyh": {
      "Ballı": true,
      "Oba": true,
      "Toki": true,
      "Yeni": true
    },
    "Çelebi": {
      "Barbaros": true,
      "Fatih": true,
      "Gülveren": true,
      "Yeni": true
    },
    "Delice": {
      "Aktepe": true,
      "Cumhuriyet": true,
      "Fatih": true,
      "Gökçebel": true,
      "Karabekir": true,
      "Merkez": true,
      "Mimar Sinan": true,
      "Sakarya": true,
      "Yeni": true,
      "Yerlikent": true
    },
    "Karakeçili": {
      "Fatih Sultan Mehmet": true,
      "Hoca Ahmet Yesevi": true,
      "Karşıyaka": true,
      "Kurtuluş": true,
      "Mareşal Fevzi Çakmak": true,
      "Yavuz Sultan Selim": true,
      "Yeşilevler": true,
      "Zafer": true
    },
    "Keskin": {
      "Altuntaş": true,
      "Bozkurt": true,
      "Gündoğdu": true,
      "Maden": true,
      "Yeni": true,
      "Yenice": true
    },
    "Merkez": {
      "Akşemsettin": true,
      "Altınova": true,
      "Aşağımahmutlar": true,
      "Bağlarbaşı": true,
      "Bahçelievler": true,
      "Çalılıöz": true,
      "Çullu": true,
      "Etiler": true,
      "Fabrikalar": true,
      "Fatih": true,
      "Gündoğdu": true,
      "Gürler": true,
      "Güzeltepe": true,
      "Hacıbey": true,
      "Hüseyin Kahya": true,
      "Kaletepe": true,
      "Karşıyaka": true,
      "Kırıkköyü": true,
      "Kızılırmak": true,
      "Kimeski": true,
      "Kurtuluş": true,
      "Osmangazi": true,
      "Ovacık": true,
      "Sağlık": true,
      "Sanayi": true,
      "Selim Özer": true,
      "Tepebaşı": true,
      "Yaylacık": true,
      "Yenidoğan": true,
      "Yenimahalle": true,
      "Yuva": true
    },
    "Sulakyurt": {
      "Cumhuriyet": true,
      "Yayla": true,
      "Yeni": true,
      "Yenihayat": true,
      "Yeşilyurt": true,
      "Yıldız": true,
      "Yükselen": true
    },
    "Yahşihan": {
      "Alaaddin": true,
      "Bayraktepe": true,
      "Doğanlık": true,
      "Emirler": true,
      "Erenler": true,
      "Hacıbey": true,
      "Kadıoğlu": true,
      "Seyrantepe": true,
      "Yenişehir": true,
      "Yeşil Vadi": true
    }
  },
  "Kırklareli": {
    "Babaeski": {
      "Atatürk": true,
      "Birlik": true,
      "Cumhuriyet": true,
      "Demirkapı": true,
      "Dindoğru": true,
      "Fevzi Çakmak": true,
      "Gazikemal": true,
      "Gaziosmanpaşa": true,
      "Gülbahçe": true,
      "Hacıhasan": true,
      "Halilpaşa": true,
      "Hamidiye": true,
      "Hatip": true,
      "Hürriyet": true,
      "Kemal Paşa": true,
      "Kurtuluş": true,
      "Paşa": true,
      "Şamdani": true,
      "Şeker": true,
      "Yeni": true
    },
    "Demirköy": {
      "Deniz": true,
      "Hamdibey": true,
      "Orhaniye": true,
      "Yeni": true
    },
    "Kofçaz": {
      "Yeni": true,
      "Yeşillik": true
    },
    "Lüleburgaz": {
      "8 Kasım": true,
      "Atatürk": true,
      "Barış": true,
      "Cumhuriyet": true,
      "Dere": true,
      "Durak": true,
      "Fatih": true,
      "Gençlik": true,
      "Gündoğu": true,
      "Güneş": true,
      "Hürriyet": true,
      "İnönü": true,
      "İstiklal": true,
      "Karşıyaka": true,
      "Kırcaali": true,
      "Kocasinan": true,
      "Kurtuluş": true,
      "Küçükkarıştıran": true,
      "Özerler": true,
      "Sarımsaklı": true,
      "Sevgi": true,
      "Siteler": true,
      "Yeni": true,
      "Yıldırım": true,
      "Yıldız": true,
      "Yılmaz": true,
      "Zafer": true
    },
    "Merkez": {
      "Akalar": true,
      "Atatürk": true,
      "Bademlik": true,
      "Celaliye": true,
      "Cevat Paşa": true,
      "Cumhuriyet": true,
      "Çarşı": true,
      "Demirtaş": true,
      "Doğu": true,
      "Gündoğdu": true,
      "İstasyon": true,
      "Karacaibrahim": true,
      "Karahıdır": true,
      "Karakaş": true,
      "Kazımpaşa": true,
      "Kemal Paşa": true,
      "Kemalpaşa": true,
      "Kocahıdır": true,
      "Mehmet Çavuş": true,
      "Pınar": true,
      "Turist": true,
      "Ulukonak": true,
      "Yayla": true,
      "Yeni": true,
      "Yeni Okullar": true
    },
    "Pehlivanköy": {
      "Ergene": true,
      "Kazımdirik": true,
      "Kurtuluş": true
    },
    "Pınarhisar": {
      "Akarlar": true,
      "Beylik": true,
      "Camiikebir": true,
      "Dere": true,
      "Işıklar": true,
      "Orta": true,
      "Yenicamii": true
    },
    "Vize": {
      "Cumhuriyet": true,
      "Devlet": true,
      "Evren": true,
      "Gazi": true,
      "Güven": true,
      "Hürriyet": true,
      "Kale": true,
      "Mehmet Akif": true,
      "Namık Kemal": true,
      "Zafer": true
    }
  },
  "Kırşehir": {
    "Akçakent": {
      "Şehricedid": true,
      "Yenikent": true,
      "Yeniyapan": true
    },
    "Akpınar": {
      "Alipaşa": true,
      "Cumhuriyet": true,
      "Hacı Hüseyin Efendi": true,
      "Kaleyazı": true,
      "Şirinevler": true,
      "Yenidoğan": true
    },
    "Boztepe": {
      "Bağbaşı": true,
      "Orta": true,
      "Yeni": true
    },
    "Çiçekdağı": {
      "Bağlarbaşı": true,
      "Bahçelievler": true,
      "Boyalık": true,
      "Cumhuriyet": true,
      "Çiçek": true,
      "Çiftlik": true,
      "Devreceli": true,
      "Fatih": true,
      "Fevzi Çakmak": true,
      "Osman Şevki": true,
      "Yeni": true,
      "Yenişehir": true
    },
    "Kaman": {
      "Bahçelievler": true,
      "Cuma": true,
      "Cumhuriyet": true,
      "Çiftlikli": true,
      "Darıözü": true,
      "Gaffar": true,
      "Hacıpınar": true,
      "Müderris": true,
      "Orta": true,
      "Sarıuşağı": true,
      "Yeni": true,
      "Ziyarettepe": true
    },
    "Merkez": {
      "Ahievran": true,
      "Aşıkpaşa": true,
      "Bağbaşı": true,
      "Bahçelievler": true,
      "Çukurçayır": true,
      "Gölhisar": true,
      "Güldiken": true,
      "Helvacılar": true,
      "Karşıyaka": true,
      "Kayabaşı": true,
      "Kervansaray": true,
      "Kındam": true,
      "Kışlapınar": true,
      "Kızılca": true,
      "Kuşdilli": true,
      "Medrese": true,
      "Nasuhdede": true,
      "Örcün": true,
      "Saraylar": true,
      "Yeni": true,
      "Yenice": true
    },
    "Mucur": {
      "Acıöz": true,
      "Hamidiye": true,
      "Karşıyaka": true,
      "Osmangazi": true,
      "Solaklı": true,
      "Şatıroğlu": true,
      "Yenice": true
    }
  },
  "Kilis": {
    "Elbeyli": {
      "Hürriyet": true,
      "İnönü": true,
      "Necmettin Erbakan": true,
      "Yalçın Nane": true
    },
    "Merkez": {
      "Abdioymağı": true,
      "Akpınar": true,
      "Albay Ibrahim Karaoğlanoğlu": true,
      "Altınüzüm": true,
      "Aslan": true,
      "Aşıt": true,
      "Atatürk": true,
      "Barış": true,
      "Bilali Habeş": true,
      "Bölük": true,
      "Büyükkütah": true,
      "Canpolat Paşa": true,
      "Cumhuriyet": true,
      "Çaylak": true,
      "Demirciler": true,
      "Deveciler": true,
      "Doğan Güreş Paşa": true,
      "Ebulüle": true,
      "Ekrem Çetin": true,
      "Fatih Sultan Mehmet": true,
      "Gaziler": true,
      "Hacı Gümüş": true,
      "Hacı Ilyas": true,
      "Hakverdi": true,
      "Hasan Kamil Demirbaş": true,
      "Helvacıoğlu": true,
      "Hindioğlu": true,
      "Hürriyet": true,
      "İnnaplı Kütah": true,
      "İslambey": true,
      "İsmet Paşa": true,
      "Kanuni Sultan Süleyman": true,
      "Karaali": true,
      "Kartalbey": true,
      "Kazım Karabekir": true,
      "Ketenciler": true,
      "Maraşal Fevzi Çakmak": true,
      "Mehmet Abdi Bulut": true,
      "Mehmet Rıfat Kazancıoğlu": true,
      "Mehmet Sanlı": true,
      "Mercidabık": true,
      "Meşetlik": true,
      "Mıhali": true,
      "Muallim Rıfat Bilge": true,
      "Mullahamit": true,
      "Mücahitler": true,
      "Müslümanbey": true,
      "Nacaroğlu": true,
      "Namık Kemal": true,
      "Namık Ünler Paşa": true,
      "Necmettin Erbakan": true,
      "Nedim Ökmen": true,
      "Nurettin": true,
      "Okçular": true,
      "Osman Gazi": true,
      "Oylum": true,
      "Öncü Pınar": true,
      "Polat Paşa": true,
      "Saraç Mehmet Çavuş": true,
      "Şehit Sakıp": true,
      "Şehitler": true,
      "Şıh Abdullah": true,
      "Şıh Ahmet": true,
      "Şıh Mehmet": true,
      "Şıhlar": true,
      "Şörhabil": true,
      "Tabakhane": true,
      "Tekye": true,
      "Tırıklı": true,
      "Tosyalı": true,
      "Vaiz": true,
      "Yaşar Aktürk": true,
      "Yavuz Sultan Selim": true,
      "Yedi Aralık": true,
      "Yeni": true,
      "Zeytinli": true
    },
    "Musabeyli": {
      "Cumhuriyet": true,
      "Murathüyüğü": true,
      "Pınar": true
    },
    "Polateli": {
      "Atatürk": true,
      "Cumhuriyet": true,
      "Ekrem Çetin": true,
      "Kaymakam Kürşat Ağca": true,
      "Sosyal Konutlar": true,
      "Şehit Ali": true
    }
  },
  "Kocaeli": {
    "Başiskele": {
      "Aksığın": true,
      "Altınkent": true,
      "Atakent": true,
      "Aydınkent": true,
      "Barbaros": true,
      "Camidüzü": true,
      "Damlar": true,
      "Doğantepe": true,
      "Döngel": true,
      "Fatih": true,
      "Havuzlubahçe": true,
      "Karadenizliler": true,
      "Karşıyaka": true,
      "Kazandere": true,
      "Kılıçarslan": true,
      "Körfez": true,
      "Kullar Tepecik": true,
      "Kullar Yakacık": true,
      "Mahmutpaşa": true,
      "Mehmetağa": true,
      "Ovacık": true,
      "Paşadağ": true,
      "Sahil": true,
      "Sepetlipınar": true,
      "Serdar": true,
      "Serindere": true,
      "Servetiye Cami": true,
      "Servetiye Karşı": true,
      "Seymen": true,
      "Şehitekrem": true,
      "Tepecik": true,
      "Vezirçiftliği": true,
      "Yaylacık": true,
      "Yeniköy Merkez": true,
      "Yeşilkent": true,
      "Yeşilyurt": true,
      "Yuvacık Yakacık": true
    },
    "Çayırova": {
      "Akse": true,
      "Atatürk": true,
      "Cumhuriyet": true,
      "Çayırova": true,
      "Emek": true,
      "İnönü": true,
      "Özgürlük": true,
      "Şekerpınar": true,
      "Yeni": true
    },
    "Darıca": {
      "Abdi Ipekçi": true,
      "Bağlarbaşı": true,
      "Bayramoğlu": true,
      "Cami": true,
      "Emek": true,
      "Fevziçakmak": true,
      "Kazımkarabekir": true,
      "Nenehatun": true,
      "Osmangazi": true,
      "Piri Reis": true,
      "Sırasöğütler": true,
      "Yalı": true,
      "Yeni": true,
      "Zincirlikuyu": true
    },
    "Derince": {
      "Çavuşlu": true,
      "Çenedağ": true,
      "Çınarlı": true,
      "Deniz": true,
      "Dumlupınar": true,
      "Fatih Sultan": true,
      "Geredeli": true,
      "İbnisina": true,
      "Karagöllü": true,
      "Kaşıkçı": true,
      "Mersincik": true,
      "Sırrıpaşa": true,
      "Tahtalı": true,
      "Terziler": true,
      "Toylar": true,
      "Yavuz Sultan": true,
      "Yenikent": true
    },
    "Dilovası": {
      "Cumhuriyet": true,
      "Çerkeşli": true,
      "Demirciler": true,
      "Diliskelesi": true,
      "Fatih": true,
      "Kayapınar": true,
      "Köseler": true,
      "Mimar Sinan": true,
      "Orhangazi": true,
      "Tavşancıl": true,
      "Tepecik": true,
      "Turgut Özal": true
    },
    "Gebze": {
      "Adem Yavuz": true,
      "Ahatlı": true,
      "Arapçeşme": true,
      "Balçık": true,
      "Barış": true,
      "Beylikbağı": true,
      "Cumaköy": true,
      "Cumhuriyet": true,
      "Denizli": true,
      "Duraklı": true,
      "Elbizli": true,
      "Eskihisar": true,
      "Gaziler": true,
      "Güzeller": true,
      "Hacıhalil": true,
      "Hatipler": true,
      "Hürriyet": true,
      "İnönü": true,
      "İstasyon": true,
      "Kadıllı": true,
      "Kargalı": true,
      "Kirazpınar": true,
      "Köşklü Çeşme": true,
      "Mevlana": true,
      "Mimar Sinan": true,
      "Mollafenari": true,
      "Muallimköy": true,
      "Mudarlı": true,
      "Mustafapaşa": true,
      "Osman Yılmaz": true,
      "Ovacık": true,
      "Pelitli": true,
      "Sultan Orhan": true,
      "Tatlıkuyu": true,
      "Tavşanlı": true,
      "Tepemanayır": true,
      "Ulus": true,
      "Yağcılar": true,
      "Yavuz Selim": true,
      "Yenikent": true
    },
    "Gölcük": {
      "Atatürk": true,
      "Ayvazpınarı": true,
      "Cumhuriyet": true,
      "Çiftlik": true,
      "Değirmendere Merkez": true,
      "Değirmendere Yalı": true,
      "Deniz Evler": true,
      "Donanma": true,
      "Dumlupınar": true,
      "Düzağaç": true,
      "Eskiferhadiye": true,
      "Ferhadiye": true,
      "Halıdere Yalı": true,
      "Halıdere Yeni": true,
      "Hamidiye": true,
      "Hasaneyn": true,
      "Hisareyn Merkez": true,
      "İcadiye": true,
      "İhsaniye Merkez": true,
      "İpek Yolu": true,
      "İrşadiye": true,
      "Karaköprü": true,
      "Kavaklı": true,
      "Körfez": true,
      "Lütfiye": true,
      "Mamuriye": true,
      "Merkez": true,
      "Mesruriye": true,
      "Nimetiye": true,
      "Nüzhetiye": true,
      "Örcün": true,
      "Panayır": true,
      "Piyalepaşa": true,
      "Saraylı": true,
      "Selimiye": true,
      "Siyretiye": true,
      "Sofular": true,
      "Şehitler": true,
      "Şevketiye": true,
      "Şirinköy": true,
      "Topçular": true,
      "Ulaşlı Yalı": true,
      "Ulaşlı Yavuz Sultan Selim": true,
      "Ümmiye": true,
      "Yazlık Merkez": true,
      "Yazlık Yeni": true,
      "Yeni": true,
      "Yukarı": true,
      "Yunus Emre": true,
      "Yüzbaşılar": true
    },
    "İzmit": {
      "28 Haziran": true,
      "Akarca": true,
      "Akçakoca": true,
      "Akmeşe Atatürk": true,
      "Akmeşe Cumhuriyet": true,
      "Akpınar": true,
      "Alikahya Atatürk": true,
      "Alikahya Cumhuriyet": true,
      "Alikahya Fatih": true,
      "Alikahya Merkez": true,
      "Ambarcı": true,
      "Arızlı": true,
      "Arpalıkihsaniye": true,
      "Ayazma": true,
      "Bağlıca": true,
      "Balören": true,
      "Bayraktar": true,
      "Bekirdere": true,
      "Biberoğlu": true,
      "Böğürgen": true,
      "Bulduk": true,
      "Cedit": true,
      "Cumhuriyet": true,
      "Çağırgan": true,
      "Çavuşoğlu": true,
      "Çayırköy": true,
      "Çubuklubala": true,
      "Çubukluosmaniye": true,
      "Çukurbağ": true,
      "Dağköy": true,
      "Doğan": true,
      "Durhasan": true,
      "Düğmeciler": true,
      "Emirhan": true,
      "Erenler": true,
      "Eseler": true,
      "Fatih": true,
      "Fethiye": true,
      "Fevzi Çakmak": true,
      "Gedikli": true,
      "Gökçeören": true,
      "Gülbahçe Kadriye": true,
      "Gültepe": true,
      "Gündoğdu": true,
      "Güvercinlik": true,
      "Hacıhasan": true,
      "Hacıhızır": true,
      "Hakaniye": true,
      "Hasancıklar": true,
      "Hatipköy": true,
      "Kabaoğlu": true,
      "Kadıköy": true,
      "Karaabdülbaki": true,
      "Karabaş": true,
      "Karadenizliler": true,
      "Kaynarca": true,
      "Kemalpaşa": true,
      "Kısalar": true,
      "Kocatepe": true,
      "Kozluca": true,
      "Kozluk": true,
      "Körfez": true,
      "Kulfallı": true,
      "Kulmahmut": true,
      "Kurtdere": true,
      "Kuruçeşme Fatih": true,
      "M.alipaşa": true,
      "Malta": true,
      "Mecidiye": true,
      "Nebihoca": true,
      "Orhan": true,
      "Orhaniye": true,
      "Ortaburun": true,
      "Ömerağa": true,
      "Sanayi": true,
      "Sapakpınar": true,
      "Sarışeyh": true,
      "Sekbanlı": true,
      "Sepetçi": true,
      "Serdar": true,
      "Sultaniye": true,
      "Süleymaniye": true,
      "Süverler": true,
      "Şahinler": true,
      "Şirintepe": true,
      "Tavşantepe": true,
      "Tepecik": true,
      "Tepeköy": true,
      "Terzibayırı": true,
      "Topçular": true,
      "Turgut": true,
      "Tüysüzler": true,
      "Veliahmet": true,
      "Yahyakaptan": true,
      "Yassıbağ": true,
      "Yeni": true,
      "Yenice": true,
      "Yenidoğan": true,
      "Yenişehir": true,
      "Yeşilova": true,
      "Zabıtan": true,
      "Zeytinburnu": true
    },
    "Kandıra": {
      "Ağaçağıl": true,
      "Ahmethacılar": true,
      "Akbal": true,
      "Akçabeyli": true,
      "Akçakese": true,
      "Akçaova": true,
      "Akdurak": true,
      "Akıncı": true,
      "Alaybey": true,
      "Alefli": true,
      "Antaplı": true,
      "Avdan": true,
      "Aydınlık": true,
      "Babaköy": true,
      "Babalı": true,
      "Bağırganlı": true,
      "Balaban": true,
      "Balcı": true,
      "Ballar": true,
      "Beyce": true,
      "Beylerbeyi": true,
      "Bolu": true,
      "Bozburun": true,
      "Cebeci": true,
      "Çakırcaali": true,
      "Çakmaklar": true,
      "Çalca": true,
      "Çalköy": true,
      "Çalyer": true,
      "Çamkonak": true,
      "Çarşı": true,
      "Çerçili": true,
      "Dalca": true,
      "Deliveli": true,
      "Doğancılı": true,
      "Döngelli": true,
      "Duraklı": true,
      "Eğercili": true,
      "Elmacık": true,
      "Esentepe": true,
      "Ferizli": true,
      "Gebeşler": true,
      "Goncaaydın": true,
      "Hacılar": true,
      "Hacımazlı": true,
      "Hacışeyh": true,
      "Hediyeli": true,
      "Hıdırlar": true,
      "Hüdaverdiler": true,
      "İncecik": true,
      "Kabaağaç": true,
      "Kanatlar": true,
      "Karaağaç": true,
      "Karadivan": true,
      "Karlı": true,
      "Kaymaz": true,
      "Kaymaz Erikli": true,
      "Kefken": true,
      "Kerpe": true,
      "Kırkarmut": true,
      "Kızılcapınar": true,
      "Kocakaymas": true,
      "Kubuzcu": true,
      "Kurtyeri": true,
      "Lokmanlı": true,
      "Mancarlar": true,
      "Merkez Erikli": true,
      "Mülküşehsuvar": true,
      "Nasuhlar": true,
      "Orhan": true,
      "Ömerli": true,
      "Özbey": true,
      "Pelitpınarı": true,
      "Pınardüzü": true,
      "Pınarlı": true,
      "Pirceler": true,
      "Safalı": true,
      "Sarıahmetler": true,
      "Sarıcaali": true,
      "Sarıgazi": true,
      "Sarnıçlar": true,
      "Selametli": true,
      "Selimköy": true,
      "Sepetçi": true,
      "Seyitaliler": true,
      "Sinanlıbilallı": true,
      "Sucuali": true,
      "Süllü": true,
      "Şerefsungur": true,
      "Tatarahmet": true,
      "Teksen": true,
      "Terziler": true,
      "Topluca": true,
      "Üğümce": true,
      "Yağcılar": true,
      "Yusufça": true
    },
    "Karamürsel": {
      "4 Temmuz": true,
      "Akçat": true,
      "Akpınar": true,
      "Avcıköy": true,
      "Çamçukur": true,
      "Çamdibi": true,
      "Dereköy": true,
      "Ereğli": true,
      "Fulacık": true,
      "Hayriye": true,
      "İhsaniye": true,
      "İnebeyli": true,
      "Kadriye": true,
      "Karaahmetli": true,
      "Karapınar": true,
      "Kayacık": true,
      "Kızderbent": true,
      "Oluklu": true,
      "Osmaniye": true,
      "Pazarköy": true,
      "Safiye": true,
      "Semetler": true,
      "Senaiye": true,
      "Suludere": true,
      "Tahtalı": true,
      "Tepeköy": true,
      "Yalakdere": true
    },
    "Kartepe": {
      "Acısu": true,
      "Arslanbey": true,
      "Ataevler": true,
      "Ataşehir": true,
      "Balaban": true,
      "Çepni": true,
      "Derbent": true,
      "Dumlupınar": true,
      "Emekevler": true,
      "Ertuğrul Gazi": true,
      "Eşme": true,
      "Eşmeahmediye": true,
      "Fatih Sultan Mehmet": true,
      "Havluburun": true,
      "İbrikdere": true,
      "İstasyon": true,
      "Karatepe": true,
      "Ketenciler": true,
      "Köseköy": true,
      "Maşukiye": true,
      "Nusretiye": true,
      "Pazarçayırı": true,
      "Rahmiye": true,
      "Sarımeşe": true,
      "Serinlik": true,
      "Suadiye": true,
      "Sultaniye": true,
      "Şevkatiye": true,
      "Şirinsulhiye": true,
      "Uzunbey": true,
      "Uzunçiftlik": true,
      "Uzuntarla": true
    },
    "Körfez": {
      "17 Ağustos": true,
      "Agah Ateş": true,
      "Alihocalar": true,
      "Atalar": true,
      "Barbaros": true,
      "Belen": true,
      "Cuma": true,
      "Cumhuriyet": true,
      "Çamlıtepe": true,
      "Çıraklı": true,
      "Dere": true,
      "Dikenli": true,
      "Elmacık": true,
      "Esentepe": true,
      "Fatih": true,
      "Güney": true,
      "Hacı Akif": true,
      "Hacı Osman": true,
      "Himmetli": true,
      "İlimtepe": true,
      "Kalburcu": true,
      "Karayakuplu": true,
      "Kışladüzü": true,
      "Kirazlıyalı": true,
      "Kutluca": true,
      "Kuzey": true,
      "Mimar Sinan": true,
      "Naip": true,
      "Osmanlı": true,
      "Sevindikli": true,
      "Sipahiler": true,
      "Şemsettin": true,
      "Şirinyalı": true,
      "Yavuz Sultan Selim": true,
      "Yeniyalı": true,
      "Yukarı Hereke": true
    }
  },
  "Konya": {
    "Ahırlı": {
      "Akkise": true,
      "Aliçerçi": true,
      "Bademli": true,
      "Balıklava": true,
      "Büyüköz": true,
      "Çiftlik": true,
      "Çukurbucak": true,
      "Erdoğan": true,
      "Hamzalar": true,
      "Hengeme": true,
      "Karacakuyu": true,
      "Kayacık": true,
      "Kuruçay": true,
      "Küçüköz": true,
      "Merkez": true
    },
    "Akören": {
      "Ağalar": true,
      "Ahmediye": true,
      "Alanköy": true,
      "Avdan": true,
      "Belkuyu": true,
      "Çatören": true,
      "Dutlu": true,
      "Hacılar": true,
      "Karahüyük": true,
      "Kayasu": true,
      "Orhaniye": true,
      "Süleymaniye": true,
      "Tülce": true,
      "Yeni": true
    },
    "Akşehir": {
      "Adsız": true,
      "Ahicelal": true,
      "Alanyurt": true,
      "Altunkalem": true,
      "Altuntaş": true,
      "Anıt": true,
      "Atakent": true,
      "Bozlağan": true,
      "Cankurtaran": true,
      "Çakıllar": true,
      "Çamlı": true,
      "Çay": true,
      "Çimendere": true,
      "Çimenli": true,
      "Değirmenköy": true,
      "Doğrugöz": true,
      "Engili": true,
      "Eskikale": true,
      "Gazi": true,
      "Gedil": true,
      "Gölçayır": true,
      "Gözpınarı": true,
      "Ilıcak": true,
      "İstasyon": true,
      "Karabulut": true,
      "Karahüyük": true,
      "Kızılca": true,
      "Kileci": true,
      "Kozağaç": true,
      "Kuruçay": true,
      "Kuşçu": true,
      "Meydan": true,
      "Nasreddin Hoca": true,
      "Ortaca": true,
      "Ortaköy": true,
      "Reis": true,
      "Saray": true,
      "Savaş": true,
      "Selçuk": true,
      "Seyran": true,
      "Sorkun": true,
      "Söğütlü": true,
      "Tekkeköy": true,
      "Tipi": true,
      "Tipiköy": true,
      "Ulupınar": true,
      "Üçhüyük": true,
      "Yarenler": true,
      "Yaşarlar": true,
      "Yaylabelen": true,
      "Yazla": true,
      "Yeni": true,
      "Yeniköy": true,
      "Yeşilköy": true,
      "Yıldırım Bayezid": true
    },
    "Altınekin": {
      "Akçaşar": true,
      "Akıncılar": true,
      "Akköy": true,
      "Ayışığı": true,
      "Borukkuyu": true,
      "Dedeler": true,
      "Hacınuman": true,
      "Kale": true,
      "Karakaya": true,
      "Koçaş": true,
      "Koçyaka": true,
      "Mantar": true,
      "Oğuzeli": true,
      "Ölmez": true,
      "Sarnıç": true,
      "Topraklık": true,
      "Yeni Ölmez": true,
      "Yenice": true,
      "Yenikuyu": true,
      "Yeniyayla": true
    },
    "Beyşehir": {
      "Adaköy": true,
      "Ağılönü": true,
      "Akburun": true,
      "Avdancık": true,
      "Avşar": true,
      "Bademli": true,
      "Bahçelievler": true,
      "Başgöze": true,
      "Bayat": true,
      "Bayavşar": true,
      "Bayındır": true,
      "Bekdemir": true,
      "Beytepe": true,
      "Çetmi": true,
      "Çiçekler": true,
      "Çiftlik": true,
      "Çivril": true,
      "Çukurağıl": true,
      "Dalyan": true,
      "Damlapınar": true,
      "Doğanbey": true,
      "Doğancık": true,
      "Dumanlı": true,
      "Eğirler": true,
      "Emen": true,
      "Esence": true,
      "Esentepe": true,
      "Evsat": true,
      "Eylikler": true,
      "Fasıllar": true,
      "Göçü": true,
      "Gökçekuyu": true,
      "Gökçimen": true,
      "Gölkaşı": true,
      "Gölyaka": true,
      "Gönen": true,
      "Gündoğdu": true,
      "Hacıakif": true,
      "Hacıarmağan": true,
      "Hamidiye": true,
      "Huğlu": true,
      "Hüseyinler": true,
      "İçerişehir": true,
      "İsaköy": true,
      "Karaali": true,
      "Karabayat": true,
      "Karadiken": true,
      "Karahisar": true,
      "Kayabaşı": true,
      "Kurucuova": true,
      "Kuşluca": true,
      "Küçükavşar": true,
      "Mesutlar": true,
      "Müftü": true,
      "Sadıkhacı": true,
      "Sarıköy": true,
      "Sevindik": true,
      "Şamlar": true,
      "Üçpınar": true,
      "Üstünler": true,
      "Üzümlü": true,
      "Yazyurdu": true,
      "Yeni": true,
      "Yenidoğan": true,
      "Yeşildağ": true,
      "Yukarıesence": true,
      "Yunuslar": true
    },
    "Bozkır": {
      "Akçapınar": true,
      "Armutlu": true,
      "Arslantaş": true,
      "Aydınkışla": true,
      "Ayvalca": true,
      "Bağyurdu": true,
      "Baybağan": true,
      "Bozdam": true,
      "Cumhuriyet": true,
      "Çağlayan": true,
      "Demirasaf": true,
      "Dereiçi": true,
      "Dereköy": true,
      "Elmaağaç": true,
      "Hacılar": true,
      "Hacıyunuslar": true,
      "Hamzalar": true,
      "Harmanpınar": true,
      "Hisarlık": true,
      "Işıklar": true,
      "Karabayır": true,
      "Karacaardıç": true,
      "Karacahisar": true,
      "Karayahya": true,
      "Kayacılar": true,
      "Kayapınar": true,
      "Kınık": true,
      "Kızılçakır": true,
      "Kildere": true,
      "Kovanlık": true,
      "Kozağaç": true,
      "Kuşca": true,
      "Kuzören": true,
      "Küçükhisarlık": true,
      "Pınarcık": true,
      "Sarıoğlan": true,
      "Sazlı": true,
      "Soğucak": true,
      "Sorkun": true,
      "Söğüt": true,
      "Tarlabaşı": true,
      "Taşbaşı": true,
      "Tepearası": true,
      "Tepelice": true,
      "Ulupınar": true,
      "Üçpınar": true,
      "Yalnızca": true,
      "Yazdamı": true,
      "Yelbeği": true,
      "Yeniköy": true,
      "Yolören": true,
      "Yukarı": true
    },
    "Cihanbeyli": {
      "Ağabeyli": true,
      "Ahirigüzel": true,
      "Atçeken": true,
      "Bahçelievler": true,
      "Beyliova": true,
      "Böğrüdelik": true,
      "Bulduk": true,
      "Büyükbeşkavak": true,
      "Cumhuriyet": true,
      "Çimen": true,
      "Çöl": true,
      "Damlakuyu": true,
      "Gemecik": true,
      "Göktepe": true,
      "Gölyazı": true,
      "Günyüzü": true,
      "Hodoğlu": true,
      "İnsuyu": true,
      "Kale": true,
      "Kandil": true,
      "Karabağ": true,
      "Karatepe": true,
      "Karşıyaka": true,
      "Kayı": true,
      "Kelhasan": true,
      "Kırkışla": true,
      "Kocatepe": true,
      "Korkmazlar": true,
      "Köprübaşı": true,
      "Kuşça": true,
      "Küçükbeşkavak": true,
      "Kütükuşağı": true,
      "Mutlukonak": true,
      "Pınarbaşı": true,
      "Sağlık": true,
      "Sığırcık": true,
      "Taşpınar": true,
      "Turanlar": true,
      "Tüfekçipınar": true,
      "Uzuncayayla": true,
      "Üzerliktepe": true,
      "Yapalı": true,
      "Yeniceoba": true,
      "Yeniyayla": true,
      "Yeşilöz": true,
      "Yünlükuyu": true,
      "Zaferiye": true
    },
    "Çeltik": {
      "Adakasım": true,
      "Bahçe Saray": true,
      "Bahçelievler": true,
      "Doğanyurt": true,
      "Fatih": true,
      "Gökpınar": true,
      "Honamlı": true,
      "İshakuşağı": true,
      "Karşıyaka": true,
      "Kaşören": true,
      "Küçükhasan": true,
      "Selçuk": true,
      "Torunlar": true,
      "Yukarı Aliçomak": true
    },
    "Çumra": {
      "Abditolu": true,
      "Adakale": true,
      "Afşar": true,
      "Alemdar": true,
      "Alıssa": true,
      "Alibeyhüyüğü": true,
      "Apa": true,
      "Apasaraycık": true,
      "Arıkören": true,
      "Avdul": true,
      "Bağlar": true,
      "Bakkalbaşı": true,
      "Balçıkhisar": true,
      "Baraj": true,
      "Bardakçı": true,
      "Beylerce": true,
      "Büyükaşlama": true,
      "Cumhuriyet": true,
      "Çaybaşı": true,
      "Çiçekköy": true,
      "Çukurkavak": true,
      "Dedemoğlu": true,
      "Dinek": true,
      "Dineksaray": true,
      "Dinlendik": true,
      "Doğanlı": true,
      "Erentepe": true,
      "Fethiye": true,
      "Gökhüyük": true,
      "Güvercinlik": true,
      "Hürriyet": true,
      "İçeriçumra": true,
      "İnli": true,
      "İstiklal": true,
      "İzzetbey": true,
      "Karkın": true,
      "Kuzucu": true,
      "Küçükköy": true,
      "Meydan": true,
      "Okçu": true,
      "Seçme": true,
      "Sürgüç": true,
      "Tahtalı": true,
      "Taşağıl": true,
      "Türkmencamili": true,
      "Türkmenkarahüyük": true,
      "Uzunkuyu": true,
      "Üçhüyük": true,
      "Ürünlü": true,
      "Yeni": true,
      "Yenidoğan": true,
      "Yenisu": true,
      "Yörükcamili": true
    },
    "Derbent": {
      "Arapözü": true,
      "Camiikebir": true,
      "Çiftliközü": true,
      "Değiş": true,
      "Derbenttekke": true,
      "Güney": true,
      "Güneyköy": true,
      "Hacı Ahmet": true,
      "Karalar": true,
      "Mülayim": true,
      "Saraypınar": true,
      "Süleyman": true,
      "Yukarı": true
    },
    "Derebucak": {
      "Çamlık": true,
      "Durak": true,
      "Gencek": true,
      "Göynem": true,
      "Kenankuyu": true,
      "Musalla": true,
      "Pınarbaşı": true,
      "Sarayönü": true,
      "Taşlıpınar": true,
      "Tepearası": true,
      "Uğurlu": true,
      "Yeni": true
    },
    "Doğanhisar": {
      "Ağa": true,
      "Ayaslar": true,
      "Baş": true,
      "Başköy": true,
      "Cuma": true,
      "Çınaroba": true,
      "Deştiğin": true,
      "Fırınlı": true,
      "Güvendik": true,
      "Harman": true,
      "İlyaslar": true,
      "Karaağa": true,
      "Kemer": true,
      "Koçaş": true,
      "Konakkale": true,
      "Kuz": true,
      "Pazar": true,
      "Şıh": true,
      "Tekkeköy": true,
      "Uncular": true,
      "Yazır": true,
      "Yazlıca": true,
      "Yeğin": true,
      "Yenice": true
    },
    "Emirgazi": {
      "Akmescit": true,
      "Besci": true,
      "Camikebir": true,
      "Cumhuriyet": true,
      "Demirci": true,
      "Ekizli": true,
      "Fatih": true,
      "Gölören": true,
      "Işıklar": true,
      "Kale": true,
      "Karaören": true,
      "Meşeli": true,
      "Öbektaş": true,
      "Türbe": true,
      "Yamaç": true,
      "Yeni": true
    },
    "Ereğli": {
      "500 Evler": true,
      "Acıkuyu": true,
      "Acıpınar": true,
      "Adabağ": true,
      "Akhüyük": true,
      "Alhan": true,
      "Alpaslan": true,
      "Aşağıgöndelen": true,
      "Aşıklar": true,
      "Atakent": true,
      "Aydınlar": true,
      "Aziziye": true,
      "Bahçeli": true,
      "Barbaros": true,
      "Batıalagözlü": true,
      "Belceağaç": true,
      "Belkaya": true,
      "Beyköy": true,
      "Beyören": true,
      "Boyacıali": true,
      "Bulgurluk": true,
      "Burhaniye": true,
      "Büyükdede": true,
      "Cahı": true,
      "Camikebir": true,
      "Cumhuriyet": true,
      "Çakmak": true,
      "Çayhan": true,
      "Çiller": true,
      "Çimencik": true,
      "Çömlekçi": true,
      "Dalmaz": true,
      "Dogualagözlü": true,
      "Eti": true,
      "Fatih": true,
      "Gaybi": true,
      "Gökçeyazı": true,
      "Göktöme": true,
      "Gülbahçe": true,
      "Hacımemiş": true,
      "Hacımustafa": true,
      "Hacımutahir": true,
      "Hamidiye": true,
      "Hıdırlı": true,
      "Hortu": true,
      "Kamışlıkuyu": true,
      "Karaburun": true,
      "Kargacı": true,
      "Kazancı": true,
      "Kızılgedik": true,
      "Kuskuncuk": true,
      "Kutören": true,
      "Kuzukuyu": true,
      "Mehmet Akif": true,
      "Melicek": true,
      "Mimar Sinan": true,
      "Namık Kemal": true,
      "Orhangazi": true,
      "Orhaniye": true,
      "Özgürler": true,
      "Pınarözü": true,
      "Pirömer": true,
      "Sarıca": true,
      "Sarıtopallı": true,
      "Selçuklu": true,
      "Servili": true,
      "Sümer": true,
      "Şinasi": true,
      "Talatpaşa": true,
      "Taşağıl": true,
      "Taşbudak": true,
      "Tatlıkuyu": true,
      "Toros": true,
      "Türbe": true,
      "Türkmen": true,
      "Ulumeşe": true,
      "Üçgöz": true,
      "Yazlık": true,
      "Yellice": true,
      "Yenibağlar": true,
      "Yeniköy": true,
      "Yıldırımbeyazıt": true,
      "Yıldızlı": true,
      "Yukarıgöndelen": true,
      "Yunuslu": true,
      "Zengen": true,
      "Ziya Gökalp": true
    },
    "Güneysınır": {
      "Ağras": true,
      "Avcıtepe": true,
      "Aydoğmuş": true,
      "Bardas": true,
      "Durayda": true,
      "Emirhan": true,
      "Güneybağ": true,
      "Gürağaç": true,
      "Habiller": true,
      "Karasınır": true,
      "Kayaağzı": true,
      "Kızılöz": true,
      "Kurukavak": true,
      "Mehmet Ali": true,
      "Mevlana": true,
      "Ömeroğlu": true,
      "Örenboyalı": true,
      "Sarıhacı": true
    },
    "Hadim": {
      "Armağanlar": true,
      "Aşağı Hadim": true,
      "Aşağı Mernek": true,
      "Aşağıeşenler": true,
      "Bademli": true,
      "Beyreli": true,
      "Bolat": true,
      "Çiftepınar": true,
      "Dedemli": true,
      "Dolhanlar": true,
      "Dülgerler": true,
      "Eğiste": true,
      "Fakılar": true,
      "Gaziler": true,
      "Gerez": true,
      "Gezlevi": true,
      "Göynükkışla": true,
      "Hocalar": true,
      "İğdeören": true,
      "Kalınağıl": true,
      "Kaplanlı": true,
      "Küplüce": true,
      "Mernek": true,
      "Oduncu": true,
      "Sarnıç": true,
      "Selahattin": true,
      "Taşpınar": true,
      "Umurlar": true,
      "Yağcı": true,
      "Yelmez": true,
      "Yenikonak": true,
      "Yukarıeşenler": true
    },
    "Halkapınar": {
      "Bahçelievler": true,
      "Büyükdoğan": true,
      "Cumhuriyet": true,
      "Çakıllar": true,
      "Dedeli": true,
      "Delimahmutlu": true,
      "Eskihisar": true,
      "İvriz": true,
      "Karayusuflu": true,
      "Kayasaray": true,
      "Körlü": true,
      "Küsere": true,
      "Nernek": true,
      "Osmanköseli": true,
      "Seydifakılı": true,
      "Yassıkaya": true,
      "Yeşilyurt": true
    },
    "Hüyük": {
      "Akdağ": true,
      "Bahçeli Evler": true,
      "Başlamış": true,
      "Budak": true,
      "Burunsuz": true,
      "Cumhuriyet": true,
      "Çamlıca": true,
      "Çavuş": true,
      "Çukurkent": true,
      "Değirmenaltı": true,
      "Göçeri": true,
      "Görünmez": true,
      "İlmen": true,
      "İmrenler": true,
      "Kıreli": true,
      "Köşk": true,
      "Mutlu": true,
      "Pınarbaşı": true,
      "Selki": true,
      "Suludere": true,
      "Tolca": true,
      "Ulupınar": true,
      "Yenice": true
    },
    "Ilgın": {
      "Ağalar": true,
      "Argıthanı": true,
      "Avdan": true,
      "Ayvatdede": true,
      "Balkı": true,
      "Barakmuslu": true,
      "Behlülbey": true,
      "Belekler": true,
      "Beykonak": true,
      "Boğazkent": true,
      "Bulcuk": true,
      "Büyükoba": true,
      "Camiiatik": true,
      "Çatak": true,
      "Çavuşçugöl": true,
      "Çiğil": true,
      "Çobankaya": true,
      "Çömlekçi": true,
      "Dereköy": true,
      "Dığrak": true,
      "Düğer": true,
      "Eldeş": true,
      "Esentepe": true,
      "Fahrettin Altay": true,
      "Fatih": true,
      "Geçitköy": true,
      "Gedikören": true,
      "Gökbudak": true,
      "Gökçeyurt": true,
      "Gölyaka": true,
      "Göstere": true,
      "Güneypınar": true,
      "Harmanyazı": true,
      "Ilıca": true,
      "İhsaniye": true,
      "İstasyon": true,
      "Kaleköy": true,
      "Kapaklı": true,
      "Karaköy": true,
      "Mahmuthisar": true,
      "Mecidiye": true,
      "Milli Egemenlik": true,
      "Misafirli": true,
      "Olukpınar": true,
      "Orhaniye": true,
      "Ormanözü": true,
      "Sadıkköy": true,
      "Sahip Ata": true,
      "Sebiller": true,
      "Şıhbedrettin": true,
      "Şıhcarullah": true,
      "Tekeler": true,
      "Ucarı": true,
      "Yorazlar": true,
      "Yukarıçiğil": true,
      "Zaferiye": true
    },
    "Kadınhanı": {
      "Afşarlı": true,
      "Alabağ": true,
      "Atlantı": true,
      "Bakırpınar": true,
      "Başkuyu": true,
      "Bayramlı": true,
      "Beykavağı": true,
      "Bulgurpınarı": true,
      "Çavdar": true,
      "Çeşmecik": true,
      "Çubuk": true,
      "Demiroluk": true,
      "Doğanlar": true,
      "Güngören": true,
      "Hacımehmetli": true,
      "Hacıoflazlar": true,
      "Hacıpirli": true,
      "İstiklal": true,
      "Kabacalı": true,
      "Kamışlıözü": true,
      "Karahisarlı": true,
      "Karakaya": true,
      "Karakurtlu": true,
      "Karasevinç": true,
      "Karayürüklü": true,
      "Kayabaşı": true,
      "Kızılkuyu": true,
      "Kolukısa Beratlı": true,
      "Kolukısa Mescit": true,
      "Konurören": true,
      "Kökez": true,
      "Köylütolu": true,
      "Kurthasanlı": true,
      "Küçükkuyu": true,
      "Mahmudiye": true,
      "Meydanlı": true,
      "Osmancık": true,
      "Örnek": true,
      "Pınarbaşı": true,
      "Pirali": true,
      "Pusat": true,
      "Saçıkara": true,
      "Sarıkaya": true,
      "Söğütözü": true,
      "Şahören": true,
      "Tepebaşı": true,
      "Tosunoğlu": true,
      "Turgutlu": true,
      "Ünveren": true,
      "Yağlıca": true,
      "Yaylayaka": true,
      "Yeni": true,
      "Zafer": true
    },
    "Karapınar": {
      "Adalet": true,
      "Akçayazı": true,
      "Akören": true,
      "Alaaddin": true,
      "Apak": true,
      "Cumhuriyet": true,
      "Çetmi": true,
      "Çiğil": true,
      "Fatih": true,
      "Fevzi Paşa": true,
      "Gazi Osman Paşa": true,
      "Hacı Isa": true,
      "Hacı Ömerli": true,
      "Hankapı": true,
      "Hasanoba": true,
      "Hotamış": true,
      "İpekçi": true,
      "İslik": true,
      "İsmet Paşa": true,
      "Kale": true,
      "Karakışla": true,
      "Kayacık": true,
      "Kayalı": true,
      "Kazanhüyüğü": true,
      "Kesmez": true,
      "Küçükaşlama": true,
      "Küllü": true,
      "Ortaoba": true,
      "Oymalı": true,
      "Pınarbaşı": true,
      "Reşadiye": true,
      "Sandıklı": true,
      "Sazlıpınar": true,
      "Selimiye": true,
      "Türüdiye": true,
      "Ulus": true,
      "Yağmapınar": true,
      "Yeni": true,
      "Yenikuyu": true,
      "Yeşilyurt": true,
      "Yunus Emre": true,
      "Zafer": true
    },
    "Karatay": {
      "Acıdort": true,
      "Ağsaklı": true,
      "Akabe": true,
      "Akbaş": true,
      "Akörenkışla": true,
      "Araplar": true,
      "Aziziye": true,
      "Bakırtolu": true,
      "Başak": true,
      "Başgötüren": true,
      "Beşağıl": true,
      "Büyükburnak": true,
      "Çatalhüyük": true,
      "Çengilti": true,
      "Çimenlik": true,
      "Divanlar": true,
      "Emirgazi": true,
      "Erenler": true,
      "Erler": true,
      "Esentepe": true,
      "Fetih": true,
      "Fevziçakmak": true,
      "Gaziosmanpaşa": true,
      "Göçü": true,
      "Hacıveyiszade": true,
      "Hamzaoğlu": true,
      "Hayıroğlu": true,
      "İpekler": true,
      "İsmil": true,
      "İstiklal": true,
      "İşgalaman": true,
      "Kalenderhane": true,
      "Karaaslan": true,
      "Karadona": true,
      "Karakaya": true,
      "Katrancı": true,
      "Keçeciler": true,
      "Kızören": true,
      "Köseali": true,
      "Kumköprü": true,
      "Mengene": true,
      "Nakipoğlu": true,
      "Obruk": true,
      "Ortakonak": true,
      "Ovakavağı": true,
      "Sakyatan": true,
      "Saraçoğlu": true,
      "Sarıyakup": true,
      "Sedirler": true,
      "Selimsultan": true,
      "Sultan Mesud": true,
      "Sürüç": true,
      "Şatır": true,
      "Şemsitebrizi": true,
      "Tatlıcak": true,
      "Ulubatlıhasan": true,
      "Yağlıbayat": true,
      "Yarma": true,
      "Yavşankuyu": true,
      "Yediler": true,
      "Yenice": true,
      "Yenikent": true,
      "Zincirli": true
    },
    "Kulu": {
      "Acıkuyu": true,
      "Alparslan": true,
      "Altılar": true,
      "Arşıncı": true,
      "Bahadırlı": true,
      "Beşkardeş": true,
      "Bozan": true,
      "Burunağıl": true,
      "Camikebir": true,
      "Canımana": true,
      "Celep": true,
      "Cumhuriyet": true,
      "Değirmenözü": true,
      "Dinek": true,
      "Dipdede": true,
      "Doğutepe": true,
      "Fatih Sultan Mehmet": true,
      "Fevziye": true,
      "Gökler": true,
      "Güzelyayla": true,
      "Hisarköy": true,
      "Karacadağ": true,
      "Karacadere": true,
      "Karapınar": true,
      "Karşıyaka": true,
      "Kemaliye": true,
      "Kırkkuyu": true,
      "Kırkpınar": true,
      "Kozanlı": true,
      "Kömüşini": true,
      "Köstengil": true,
      "Köşker": true,
      "Mandıra": true,
      "Ömeranlı": true,
      "Sarıyayla": true,
      "Seyitahmetli": true,
      "Soğukkuyu": true,
      "Şerefli": true,
      "Tavlıören": true,
      "Tuzyaka": true,
      "Yaraşlı": true,
      "Yazıçayır": true,
      "Yeni": true,
      "Yeşiltepe": true,
      "Yeşilyurt": true,
      "Zincirlikuyu": true
    },
    "Meram": {
      "Alakova": true,
      "Alavardı": true,
      "Ali Ulvi Kurucu": true,
      "Alpaslan": true,
      "Aşkan": true,
      "Ateşbaz Veli": true,
      "Ayanbey": true,
      "Aydoğdu": true,
      "Aymanas": true,
      "Bahçeşehir": true,
      "Bayat": true,
      "Boruktolu": true,
      "Botsa": true,
      "Boyalı": true,
      "Çarıklar": true,
      "Çaybaşı": true,
      "Çayırbağı": true,
      "Çomaklar": true,
      "Çomaklı": true,
      "Çukurçimen": true,
      "Dere": true,
      "Durunday": true,
      "Erenkaya": true,
      "Evliyatekke": true,
      "Gödene": true,
      "Hadimi": true,
      "Harmancık": true,
      "Hasanşeyh": true,
      "Hatıp": true,
      "Hatunsaray": true,
      "Havzan": true,
      "İkipınar": true,
      "İnlice": true,
      "Karaağaç": true,
      "Karadiğin": true,
      "Karadiğinderesi": true,
      "Karahüyük": true,
      "Kaşınhanı": true,
      "Kavak": true,
      "Kayadibi": true,
      "Kayalı": true,
      "Kayıhüyük": true,
      "Kızılören": true,
      "Kilistra": true,
      "Konevi": true,
      "Kovanağzı": true,
      "Kozağaç": true,
      "Köyceğiz": true,
      "Kumralı": true,
      "Lalebahçe": true,
      "Melikşah": true,
      "Osman Gazi": true,
      "Pamukcu": true,
      "Pirebi": true,
      "Sadıklar": true,
      "Sağlık": true,
      "Sahibata": true,
      "Sarıkız": true,
      "Sefaköy": true,
      "Uluğbey": true,
      "Uluırmak": true,
      "Uzunharmanlar": true,
      "Yaka": true,
      "Yatağan": true,
      "Yaylapınar": true,
      "Yenibahçe": true,
      "Yenişehir": true,
      "Yeşildere": true,
      "Yeşiltekke": true
    },
    "Sarayönü": {
      "Bahçesaray": true,
      "Başhüyük": true,
      "Batı Istasyon": true,
      "Boyalı": true,
      "Büyükzengi": true,
      "Çeşmelisebil": true,
      "Değirmenli": true,
      "Doğu Istasyon": true,
      "Ertuğrul": true,
      "Fatih": true,
      "Gözlü": true,
      "Hatip": true,
      "İnli": true,
      "Kadıoğlu": true,
      "Karabıyık": true,
      "Karatepe": true,
      "Kayıören": true,
      "Konar": true,
      "Kurşunlu": true,
      "Kuyulusebil": true,
      "Ladik": true,
      "Özkent": true,
      "Saraç": true,
      "Selimiye": true,
      "Yenicekaya": true,
      "Yukarı": true
    },
    "Selçuklu": {
      "Akademi": true,
      "Akıncılar": true,
      "Akpınar": true,
      "Akşemsettin": true,
      "Ardıçlı": true,
      "Aşağıpınarbaşı": true,
      "Aydınlıkevler": true,
      "Bağrıkurt": true,
      "Başarakavak": true,
      "Bedir": true,
      "Beyhekim": true,
      "Biçer": true,
      "Bilecik": true,
      "Binkonutlar": true,
      "Bosna Hersek": true,
      "Buhara": true,
      "Büyükkayacık": true,
      "Cumhuriyet": true,
      "Çaldere": true,
      "Çaltı": true,
      "Çandır": true,
      "Dağdere": true,
      "Dokuz": true,
      "Dumlupınar": true,
      "Eğribayat": true,
      "Erenköy": true,
      "Esenler": true,
      "Fatih": true,
      "Ferhuniye": true,
      "Feritpaşa": true,
      "Güvenç": true,
      "Hacıkaymak": true,
      "Hanaybaşı": true,
      "Hocacihan": true,
      "Horozluhan": true,
      "Hüsamettin Çelebi": true,
      "Işıklar": true,
      "İhsaniye": true,
      "Kaleköy": true,
      "Karaömerler": true,
      "Kervan": true,
      "Kılınçarslan": true,
      "Kınık": true,
      "Kızılcakuyu": true,
      "Kosova": true,
      "Küçükmuhsine": true,
      "Malazgirt": true,
      "Mehmet Akif": true,
      "Meydanköy": true,
      "Musalla Bağları": true,
      "Nişantaş": true,
      "Parsana": true,
      "Sakarya": true,
      "Salahattin": true,
      "Sancak": true,
      "Sarayköy": true,
      "Sarıcalar": true,
      "Selahaddini Eyyubi": true,
      "Selçuk": true,
      "Sızma": true,
      "Sille": true,
      "Sille Ak": true,
      "Sulutas": true,
      "Şeker": true,
      "Şeyh Şamil": true,
      "Tatköy": true,
      "Tepekent": true,
      "Tömek": true,
      "Ulumuhsine": true,
      "Yazıbelen": true,
      "Yazır": true,
      "Yukarıpınarbaşı": true
    },
    "Seydişehir": {
      "Akçalar": true,
      "Aktaş": true,
      "Alaylar Bir": true,
      "Alaylar Iki": true,
      "Anabağlar": true,
      "Aşağıkaraören": true,
      "Bahçelievler": true,
      "Başkaraören": true,
      "Bostandere": true,
      "Boyalı": true,
      "Bükçe": true,
      "Çat": true,
      "Çatmakaya": true,
      "Çavuş": true,
      "Değirmenci": true,
      "Dikilitaş": true,
      "Gevrekli": true,
      "Gökçehüyük": true,
      "Gökhüyük": true,
      "Gölyüzü": true,
      "Hacıseyitali": true,
      "Irmaklı": true,
      "İncesu": true,
      "Karabulak": true,
      "Karacaören": true,
      "Karakavak": true,
      "Kavak": true,
      "Kesecik": true,
      "Ketenli": true,
      "Kızılca": true,
      "Kızılcalar": true,
      "Kozlu": true,
      "Kumluca": true,
      "Kuran": true,
      "Madenli": true,
      "Mesudiye": true,
      "Muradiye": true,
      "Oğlakçı": true,
      "Ortakaraören": true,
      "Pınarbaşı": true,
      "Saadetler": true,
      "Saraycık": true,
      "Seyitharun": true,
      "Sofuhane": true,
      "Stat": true,
      "Susuz": true,
      "Taraşcı": true,
      "Taşağıl": true,
      "Tepecik": true,
      "Tol": true,
      "Ufacık": true,
      "Ulukapı": true,
      "Yaylacık": true,
      "Yenicami": true,
      "Yenice": true
    },
    "Taşkent": {
      "Afşar Tepecik": true,
      "Afşar Yukarı": true,
      "Balcılar Orta": true,
      "Balcılar Veliler": true,
      "Balcılar Yukarı": true,
      "Bektaş": true,
      "Bolay": true,
      "Çetmi Cömeşpınar": true,
      "Çetmi Yeni": true,
      "Hıra": true,
      "Ilıcapınar": true,
      "Kecimen": true,
      "Kongul": true,
      "Sazak": true,
      "Şıhlar": true
    },
    "Tuzlukçu": {
      "Aşağı": true,
      "Çöğürlü": true,
      "Erdoğdu": true,
      "Gürsu": true,
      "Konarı": true,
      "Koraşı": true,
      "Köklüce": true,
      "Kundullu": true,
      "Mevlütlü": true,
      "Orta": true,
      "Pazar": true,
      "Pazarkaya": true,
      "Subatan": true,
      "Tursunlu": true,
      "Yukarı": true
    },
    "Yalıhüyük": {
      "Arasöğüt": true,
      "Aşağı": true,
      "Sarayköy": true,
      "Yukarı": true
    },
    "Yunak": {
      "Altınöz": true,
      "Ayrıtepe": true,
      "Beşışıklı": true,
      "Böğrüdelik": true,
      "Cebrail": true,
      "Çayırbaşı": true,
      "Eğrikuyu": true,
      "Esentepe": true,
      "Eşme": true,
      "Fatih": true,
      "Hacıfakılı": true,
      "Hacıömeroğlu": true,
      "Harunlar": true,
      "Hatırlı": true,
      "Hursunlu": true,
      "İmamoğlu": true,
      "Karataş": true,
      "Karayayla": true,
      "Kargalı": true,
      "Kıllar": true,
      "Koçyazı": true,
      "Kurtuşağı": true,
      "Kuyubaşı": true,
      "Kuzören": true,
      "Meşelik": true,
      "Odabaşı": true,
      "Ortakışla": true,
      "Özyayla": true,
      "Piribeyli": true,
      "Saray": true,
      "Selçuk": true,
      "Sertler": true,
      "Sevinç": true,
      "Sıram": true,
      "Sinanlı": true,
      "Sülüklü": true,
      "Turgut": true,
      "Yavaşlı": true,
      "Yeni": true,
      "Yeşiloba": true,
      "Yeşilyayla": true,
      "Yığar": true
    }
  },
  "Kütahya": {
    "Altıntaş": {
      "Bozbay": true,
      "Cumhuriyet": true,
      "Hürriyet": true,
      "İstiklal": true,
      "Yeni": true
    },
    "Aslanapa": {
      "Cumhuriyet": true,
      "Hürriyet": true,
      "Pınarbaşı": true,
      "Yalnızsaray": true
    },
    "Çavdarhisar": {
      "Cereller": true,
      "Kemaller": true,
      "Meydan": true,
      "Yukarı": true
    },
    "Domaniç": {
      "Cumhuriyet": true,
      "Hasantepe": true,
      "Hisar": true,
      "Ilıcaksu": true,
      "Karşıyaka": true,
      "Küçükler": true,
      "Osmanlı": true
    },
    "Dumlupınar": {
      "Cafergazi": true,
      "Cumhuriyet": true,
      "Turgut Özal": true,
      "Zafer": true
    },
    "Emet": {
      "Akpınar": true,
      "Cumhuriyet": true,
      "Çalcağıl": true,
      "Dere": true,
      "Esentepe": true,
      "Hamam": true,
      "Kapaklıca": true,
      "Kaynarca": true
    },
    "Gediz": {
      "Akçaalan": true,
      "Camikebir": true,
      "Dayınlar": true,
      "Ergenekon": true,
      "Gazikemal": true,
      "Gölcük": true,
      "Güney": true,
      "Hacıbaba": true,
      "Hamzabey": true,
      "Hisar": true,
      "İbrahimkahya": true,
      "İsmetpaşa": true,
      "Kızıltepe": true,
      "Kumtaş": true,
      "Kurtuluş": true,
      "Kuzey": true,
      "Muhipler": true,
      "Özyurt": true,
      "Park": true,
      "Sabırgazi": true,
      "Salur": true,
      "Saygılar": true,
      "Uluoymak": true,
      "Umurbey": true,
      "Yeni": true
    },
    "Hisarcık": {
      "82.yıl": true,
      "Cumhuriyet": true,
      "Karşıyaka": true,
      "Şehitler": true,
      "Yenidoğan": true,
      "Yeşilhisar": true
    },
    "Merkez": {
      "100. Yıl": true,
      "30 Ağustos": true,
      "75. Yıl": true,
      "Ağaçköy": true,
      "Akkent": true,
      "Alayunt": true,
      "Alipaşa": true,
      "Andız": true,
      "Aydoğdu": true,
      "Bahçelievler": true,
      "Balıklı": true,
      "Bozcahöyük": true,
      "Bölücek": true,
      "Börekçiler": true,
      "Cedit": true,
      "Cemalettin": true,
      "Civli": true,
      "Cumhuriyet": true,
      "Çalca": true,
      "Dumlupınar": true,
      "Enne": true,
      "Evliya Çelebi": true,
      "Fatih": true,
      "Fuatpaşa": true,
      "G. Kemal": true,
      "Gaybiefendi": true,
      "Geven": true,
      "Gültepe": true,
      "Güveççi": true,
      "Hacıazizler": true,
      "Hamidiye": true,
      "Hilalkent": true,
      "İkizüyük": true,
      "İnköy": true,
      "İshak Seydi": true,
      "İstiklal": true,
      "Kırgıllı": true,
      "Kirazpınar": true,
      "Kumarı": true,
      "Lala Hüseyin Paşa": true,
      "Maltepe": true,
      "Maruf": true,
      "Mecidiye": true,
      "Mehmet Akif Ersoy": true,
      "Meydan": true,
      "Müderris": true,
      "Ok Meydanı": true,
      "Okçu": true,
      "Osmangazi": true,
      "Parmakören": true,
      "Paşam Sultan": true,
      "Perli": true,
      "Pirler": true,
      "Saray": true,
      "Servi": true,
      "Seyitler": true,
      "Siner": true,
      "Sofu": true,
      "Sultanbağı": true,
      "Şair Şeyhi Dumlupınar": true,
      "Vefa": true,
      "Yeni Bosna": true,
      "Yenidoğan": true,
      "Yıldırım Beyazıt": true,
      "Yoncalı": true,
      "Yunusemre": true,
      "Zafertepe": true,
      "Ziğra": true,
      "Ziraat": true
    },
    "Pazarlar": {
      "Adnanmenderes": true,
      "Atatürk": true,
      "Ayvalı": true,
      "Fatih": true,
      "Hocaahmetyesevi": true,
      "Turgut Özal": true,
      "Yakuplar Atatürk": true,
      "Yakuplar Fatih": true
    },
    "Simav": {
      "101 Evler": true,
      "4 Eylül": true,
      "Beyce": true,
      "Camii Kebir": true,
      "Cevizlik": true,
      "Cuma": true,
      "Cumhuriyet": true,
      "Çavdır": true,
      "Çaysimav": true,
      "Değirmenciler": true,
      "Demirci": true,
      "Dere": true,
      "Esenevler": true,
      "Fatih": true,
      "Hacıahmetoğlu": true,
      "Hamzabey": true,
      "Hisarardı": true,
      "Kadılar": true,
      "Karacalar": true,
      "Karakür": true,
      "Karşıyaka": true,
      "Kaya": true,
      "Kekliktepe": true,
      "Kınık": true,
      "Muradınlar": true,
      "Öreyler": true,
      "Savcılar": true,
      "Sırapayam": true,
      "Tabakhane": true,
      "Tepecik": true,
      "Yeni": true,
      "Yeşilova": true
    },
    "Şaphane": {
      "Hacı Hasanlar": true,
      "Kalabak": true,
      "Karaağıl": true,
      "Karacaderbent": true,
      "Pazar": true,
      "Subaşı": true,
      "Türegün": true
    },
    "Tavşanlı": {
      "Ada": true,
      "Bağlık": true,
      "Balıköy-çıvgalar": true,
      "Balıköy-kadı": true,
      "Balıköy-karaşehir": true,
      "Balıköy-kışla": true,
      "Balıköy-merkez": true,
      "Beyköy": true,
      "Çardaklı": true,
      "Çırçırçeşme": true,
      "Çukurköy": true,
      "Dağçeşme": true,
      "Dedeler": true,
      "Durak": true,
      "Gürağaç Cevizli": true,
      "Gürağaç Çınar": true,
      "Hanımçeşme": true,
      "İstasyon": true,
      "Karakova": true,
      "Kavaklı": true,
      "Kuruçay-güzelyurt": true,
      "Kuruçay-kocapınar": true,
      "Kuruçay-ören": true,
      "Moymul": true,
      "Ömerbey": true,
      "Soluganlar": true,
      "Subaşı": true,
      "Tepecik-aşağı": true,
      "Tepecik-orta": true,
      "Tepecik-yukarı": true,
      "Tunçbilek Merkez": true,
      "Tunçbilek-çamaltı": true,
      "Tunçbilek-demirbilek": true,
      "Tunçbilek-hamitabat": true,
      "Tunçbilek-ışık": true,
      "Tunçbilek-köprübaşı": true,
      "Ulucami": true,
      "Yeni": true,
      "Yıldırım Beyazıt": true
    }
  },
  "Malatya": {
    "Akçadağ": {
      "Aksaray": true,
      "Aksüt": true,
      "Aktepe": true,
      "Aliçeri": true,
      "Altunlu": true,
      "Ancar": true,
      "Aşağıörükçü": true,
      "Aydınlar": true,
      "Bağköy": true,
      "Bahri": true,
      "Başpınar": true,
      "Bayramuşağı": true,
      "Bekiruşağı": true,
      "Bölüklü": true,
      "Büyükçimiş": true,
      "Büyükköy": true,
      "Çakıllıpınar": true,
      "Çatalbahçe": true,
      "Çevirme": true,
      "Çobanuşağı": true,
      "Darıca": true,
      "Dedeköy": true,
      "Demirciler": true,
      "Develi": true,
      "Doğanlar": true,
      "Doğantepe": true,
      "Doğu": true,
      "Durulova": true,
      "Dutlu": true,
      "Dümüklü": true,
      "Eğin": true,
      "Esenbey": true,
      "Esenli": true,
      "Fatih": true,
      "Gölpınar": true,
      "Güneşli": true,
      "Gürkaynak": true,
      "Hançerli": true,
      "Hartut": true,
      "Harunuşağı": true,
      "Ilıcak": true,
      "İkinciler": true,
      "Kadıibrahim": true,
      "Kahyalı": true,
      "Karamağara": true,
      "Karapınar": true,
      "Kasımuşağı": true,
      "Kayadibi": true,
      "Keklikpınarı": true,
      "Keller": true,
      "Kepez": true,
      "Kolköy": true,
      "Kotangölü": true,
      "Kozluca": true,
      "Kömekavak": true,
      "Kurtuşağı": true,
      "Küçükkürne": true,
      "Kültür": true,
      "Levent": true,
      "Mezra": true,
      "Mihmanlı": true,
      "Muratlı": true,
      "Ortaköy": true,
      "Ören": true,
      "Resuluşağı": true,
      "Sahilköy": true,
      "Sakalıuzun": true,
      "Sarıhacı": true,
      "Şeyhler": true,
      "Taşevler": true,
      "Taşolar": true,
      "Tataruşağı": true,
      "Yağmurlu": true,
      "Yalınbudak": true,
      "Yalınkaya": true,
      "Yaylımlı": true,
      "Yukarıörükçü": true
    },
    "Arapgir": {
      "Aktaş": true,
      "Alıçlı": true,
      "Aşağıçörenge": true,
      "Aşağıulupınar": true,
      "Aşağıyenice": true,
      "Berenge": true,
      "Boğazlı": true,
      "Bostancık": true,
      "Budak": true,
      "Cömertli": true,
      "Çakırsu": true,
      "Çarşı": true,
      "Çaybaşı": true,
      "Çiğnir": true,
      "Çimen": true,
      "Çobanlı": true,
      "Deregezen": true,
      "Düzce": true,
      "Eğnir": true,
      "Esikli": true,
      "Eskiarapgir": true,
      "Gebeli": true,
      "Göz": true,
      "Gözeli": true,
      "Günyüzü": true,
      "Hezenek": true,
      "Hocaali": true,
      "Kayakesen": true,
      "Kaynak": true,
      "Kazanç": true,
      "Kılıçlı": true,
      "Konducak": true,
      "Koru": true,
      "Köseoğlu": true,
      "Mehmetakif": true,
      "Meşeli": true,
      "Onar": true,
      "Ormansırtı": true,
      "Osmanpaşa": true,
      "Pacalı": true,
      "Pirali": true,
      "Sekizsu": true,
      "Selamlı": true,
      "Serge": true,
      "Sinikli": true,
      "Sipahiuşağı": true,
      "Suceyin": true,
      "Sugeçti": true,
      "Şağıluşağı": true,
      "Şıhlar": true,
      "Tarhan": true,
      "Taşdelen": true,
      "Taşdibek": true,
      "Ulaçlı": true,
      "Yaylacık": true,
      "Yazılı": true,
      "Yeni": true,
      "Yeşilyayla": true,
      "Yukarıçörenge": true,
      "Yukarıulupınar": true,
      "Yukarıyabanlı": true,
      "Yukarıyenice": true,
      "Zöhrap": true
    },
    "Arguvan": {
      "Akören": true,
      "Alhasuşağı": true,
      "Armutlu": true,
      "Asar": true,
      "Asmaca": true,
      "Aşağısülmenli": true,
      "Bahçeli": true,
      "Bahçelievler": true,
      "Bozan": true,
      "Çakmak": true,
      "Çavuşköy": true,
      "Çayırlı": true,
      "Çevreli": true,
      "Çiftlik": true,
      "Dolaylı": true,
      "Doydum": true,
      "Ermişli": true,
      "Eymir": true,
      "Göçeruşağı": true,
      "Gökağaç": true,
      "Gümüşlü": true,
      "Güngören": true,
      "Gürge": true,
      "Güveçli": true,
      "Hakverdi": true,
      "İçmece": true,
      "İsaköy": true,
      "Karababa": true,
      "Karahüyük": true,
      "Kızık": true,
      "Kızıluşağı": true,
      "Koçak": true,
      "Konakbaşı": true,
      "Kömürlük": true,
      "Kuruttaş": true,
      "Kuyudere": true,
      "Morhamam": true,
      "Narmikan": true,
      "Parçikan": true,
      "Şotik": true,
      "Tarlacık": true,
      "Tatkınık": true,
      "Tepebağ": true,
      "Yamaç": true,
      "Yeni": true,
      "Yeniköy": true,
      "Yoncalı": true,
      "Yukarısülmenli": true,
      "Yürektaşı": true
    },
    "Battalgazi": {
      "Adagören": true,
      "Ağılyazı": true,
      "Akpınar": true,
      "Alacakapı": true,
      "Alhanuşağı": true,
      "Alişar": true,
      "Aslanbey": true,
      "Ataköy": true,
      "B.hüseyinbey": true,
      "B.mustafa Paşa": true,
      "Bağtepe": true,
      "Bahçelievler": true,
      "Bahri": true,
      "Başharık": true,
      "Battalgazi": true,
      "Beydağı": true,
      "Beylerbaşı": true,
      "Boran": true,
      "Bulgurlu": true,
      "Bulutlu": true,
      "Cevherizade": true,
      "Cirikpınar": true,
      "Çamurlu": true,
      "Çolaklı": true,
      "Çolakoğlu": true,
      "Çöşnük": true,
      "Dabakhane": true,
      "Dolamantepe": true,
      "Düzyol": true,
      "Ferhadiye": true,
      "Fırat": true,
      "Fırıncı": true,
      "Göller": true,
      "Göztepe": true,
      "Gülümuşağı": true,
      "Hacı Abdi": true,
      "Hacıhaliloğluçiftliği": true,
      "Hacıyusuflar": true,
      "Halfettin": true,
      "Hamidiye": true,
      "Hanımınçiftliği": true,
      "Hasan Varol": true,
      "Hasırcılar": true,
      "Hatunsuyu": true,
      "Hidayet": true,
      "Hisartepe": true,
      "İskender": true,
      "İsmetiye": true,
      "İstiklal": true,
      "İzzetiye": true,
      "K.hüseyinbey": true,
      "K.mustafa Paşa": true,
      "Kadıçayırı": true,
      "Kamıştaş": true,
      "Kapıkaya": true,
      "Karabağlar": true,
      "Karagöz": true,
      "Karahan": true,
      "Karakaşçiftliğiköyü": true,
      "Karaköy": true,
      "Karatepe": true,
      "Kavaklıbağ": true,
      "Kemerköprü": true,
      "Kernek": true,
      "Kıraç": true,
      "Kırçuval": true,
      "Kuluşağı": true,
      "Merdivenler": true,
      "Merkez Beydağı": true,
      "Meydanbaşı": true,
      "Meydancık": true,
      "Niyazi": true,
      "Nuriye": true,
      "Orduzu": true,
      "Paşaköşkü": true,
      "Pelitli": true,
      "Sancaktar": true,
      "Saray": true,
      "Sarıcıoğlu": true,
      "Selçuklu": true,
      "Serintepe": true,
      "Sevildağ": true,
      "Şehitfevzi": true,
      "Şıkşık": true,
      "Şifa": true,
      "Şişman": true,
      "Tandoğan": true,
      "Tanışık": true,
      "Taştepe": true,
      "Tokluca": true,
      "Toptaş": true,
      "Toygar": true,
      "Uluköy": true,
      "Üçbağlar": true,
      "Üniversite": true,
      "Üzümlü": true,
      "Yamaç": true,
      "Yarımcahan": true,
      "Yaygın": true,
      "Yenice": true,
      "Yenihamam": true,
      "Yeniköy": true,
      "Yıldıztepe": true,
      "Zafer": true
    },
    "Darende": {
      "Ağılbaşı": true,
      "Ağılyazı": true,
      "Akbaba": true,
      "Akçatoprak": true,
      "Akova": true,
      "Aşağıulupınar": true,
      "Ayvalı": true,
      "Balaban": true,
      "Barındır": true,
      "Başkaya": true,
      "Baytarbağı": true,
      "Beybağı": true,
      "Çaybaşı": true,
      "Çınar": true,
      "Çukurkaya": true,
      "Gaziköy": true,
      "Gökçeören": true,
      "Gökyar": true,
      "Göllüce": true,
      "Güdül": true,
      "Günerli": true,
      "Günpınar": true,
      "Hacıderviş": true,
      "Hacılar Sıragöz": true,
      "Hacılar Şeyhli": true,
      "Hacolar": true,
      "Heyiketeği": true,
      "Hisarcık": true,
      "Hisarkale": true,
      "Ilıca": true,
      "Irmaklı": true,
      "İbrahimpaşa": true,
      "Kaldırım": true,
      "Karabacak": true,
      "Karabayır": true,
      "Karaoğuz": true,
      "Kavak": true,
      "Kaynak": true,
      "Kerimli": true,
      "Kılıçbağı": true,
      "Kölükler": true,
      "Kurudere": true,
      "Kuzpınar": true,
      "Medişeyh": true,
      "Mehmet Paşa": true,
      "Mollauşağı": true,
      "Nadir": true,
      "Nurkuyusu": true,
      "Ozan": true,
      "Palanga": true,
      "Sakarya": true,
      "Sandıkkaya": true,
      "Sayfiye": true,
      "Sungur": true,
      "Şendere": true,
      "Şuğul": true,
      "Uzunhasan": true,
      "Üçpınar": true,
      "Yarımca": true,
      "Yavuzlar": true,
      "Yazıköy": true,
      "Yenice": true,
      "Yeniköy": true,
      "Yenipınar": true,
      "Yeşiltaş": true,
      "Yukarıulupınar": true,
      "Zaviye": true
    },
    "Doğanşehir": {
      "Altıntop": true,
      "Beğre": true,
      "Bıçakçı": true,
      "Çavuşlu": true,
      "Çığlık": true,
      "Çömlekoba": true,
      "Dedeyazı": true,
      "Doğu": true,
      "Elmalı": true,
      "Erkenek": true,
      "Esentepe": true,
      "Eskiköy": true,
      "Fındık": true,
      "Gövdeli": true,
      "Günedoğru": true,
      "Gürobası": true,
      "Güzelköy": true,
      "Hudut": true,
      "Kadılı": true,
      "Kapıdere": true,
      "Karanlıkdere": true,
      "Karaterzi": true,
      "Karşıyaka": true,
      "Kelhalil": true,
      "Kurucaova": true,
      "Küçüklü": true,
      "Örencik": true,
      "Polat": true,
      "Polatdere": true,
      "Reşadiye": true,
      "Savaklı": true,
      "Söğüt": true,
      "Suçatı": true,
      "Sürgü": true,
      "Şatıroba": true,
      "Topraktepe": true,
      "Yeni": true,
      "Yolkoru": true,
      "Yuvalı": true
    },
    "Doğanyol": {
      "Akkent": true,
      "Behramlı": true,
      "Burçköy": true,
      "Çolak": true,
      "Damlı": true,
      "Gevheruşağı": true,
      "Gökçe": true,
      "Gümüşsu": true,
      "İsak": true,
      "Koldere": true,
      "Konurtay": true,
      "Mezraa": true,
      "Poyraz": true,
      "Ulutaş": true,
      "Yalınca": true,
      "Yeşilköy": true
    },
    "Hekimhan": {
      "Akmağara": true,
      "Aksütlü": true,
      "Aşağısazlıca": true,
      "Bağyolu": true,
      "Bahçedamı": true,
      "Bahçelievler": true,
      "Ballıkaya": true,
      "Basak": true,
      "Başkavak": true,
      "Başkınık": true,
      "Beykent": true,
      "Boğazgören": true,
      "Budaklı": true,
      "Çanakpınar": true,
      "Çimenlik": true,
      "Çulhalı": true,
      "Davulgu": true,
      "Delihasanyurdu": true,
      "Dereköy": true,
      "Deveci": true,
      "Dikenli": true,
      "Dikili": true,
      "Dumlu": true,
      "Dursunlu": true,
      "Fatih": true,
      "Girmana": true,
      "Güçlü": true,
      "Güvenç": true,
      "Güzelyayla": true,
      "Güzelyurt": true,
      "Hacılar": true,
      "Hasançelebi": true,
      "Haydaroğlu": true,
      "Işıklı": true,
      "İğdir": true,
      "Karadere": true,
      "Karaköçek": true,
      "Karapınar": true,
      "Karslılar": true,
      "Karşıyaka": true,
      "Kavacık": true,
      "Kocaözü": true,
      "Kozdere": true,
      "Köprülü Mehmet Paşa": true,
      "Köylüköyü": true,
      "Kurşunlu": true,
      "Mimar Sinan": true,
      "Mollaibrahim": true,
      "Salıcık": true,
      "Saraylı": true,
      "Sarıkız": true,
      "Sazlıca": true,
      "Söğüt": true,
      "Şehit Mehmet Fethi Akyüz": true,
      "Taşbaşı": true,
      "Taşoluk": true,
      "Turgut Özal": true,
      "Uğurlu": true,
      "Yağca": true,
      "Yayladam": true,
      "Yeni": true,
      "Yeşilkale": true,
      "Yeşilköy": true,
      "Yeşilpınar": true,
      "Yukarıselimli": true
    },
    "Kale": {
      "Abuşoğlu": true,
      "Akça": true,
      "Akuşağı": true,
      "Bağlıca": true,
      "Bentköy": true,
      "Çanakçı": true,
      "Darıpınar": true,
      "Dedeköy": true,
      "Düztarla": true,
      "Erdemli": true,
      "Gülenköy": true,
      "Güneyce": true,
      "İkizpınar": true,
      "Kaleköy": true,
      "Karaağaç": true,
      "Karahüseyin": true,
      "Kıyıcak": true,
      "Kozluk": true,
      "Kumluyazı": true,
      "Mahmut Dursun": true,
      "Salkımlı": true,
      "Sarıot": true,
      "Soğukpınar": true,
      "Tepebaşı": true,
      "Uyanık": true,
      "Uzunhüseyin": true,
      "Üçdeğirmen": true,
      "Yenidamlar": true
    },
    "Kuluncak": {
      "Alvar": true,
      "Aşağıselimli": true,
      "Bahçelievler": true,
      "Başören": true,
      "Bıyıkboğazı": true,
      "Bicir": true,
      "Boğaziçi": true,
      "Ciritbelen": true,
      "Çayköy": true,
      "Çörmü": true,
      "Göğebakan": true,
      "İlisuluk": true,
      "İsmetpaşa": true,
      "İstiklal": true,
      "Karabük": true,
      "Karaçayır": true,
      "Karıncalık": true,
      "Karlık": true,
      "Kaynarca": true,
      "Kızılhisar": true,
      "Kızılmağara": true,
      "Konaktepe": true,
      "Kömüklü": true,
      "Ortapınar": true,
      "Sofular": true,
      "Sultanlı": true,
      "Temüklü": true,
      "Yeni": true
    },
    "Pütürge": {
      "Ağalar": true,
      "Aktarla": true,
      "Aliçeri": true,
      "Alihan": true,
      "Arınlı": true,
      "Arıtoprak": true,
      "Arslankent": true,
      "Bakımlı": true,
      "Balpınarı": true,
      "Başmezra": true,
      "Bayırköy": true,
      "Belenköy": true,
      "Bölükkaya": true,
      "Bölünmez": true,
      "Büyüköz": true,
      "Çamlıdere": true,
      "Çayköy": true,
      "Çengelli": true,
      "Çığırlı": true,
      "Çukuroymağı": true,
      "Deredüzü": true,
      "Erdemler": true,
      "Ersele": true,
      "Esencik": true,
      "Esenlik": true,
      "Gertan": true,
      "Gözlüce": true,
      "Gündeğer": true,
      "Gündüz": true,
      "Hatip": true,
      "Karakaya": true,
      "Karşıyaka": true,
      "Kavaklıdere": true,
      "Kayadere": true,
      "Koçköy": true,
      "Korucak": true,
      "Kozluk": true,
      "Köklükaya": true,
      "Körme": true,
      "Köylü": true,
      "Meşedibi": true,
      "Nohutlu": true,
      "Ormaniçi": true,
      "Örencik": true,
      "Örmeli": true,
      "Örnekköy": true,
      "Pazarcık": true,
      "Poskıran": true,
      "Sahilköy": true,
      "Söğütlü": true,
      "Şiro Taraksu": true,
      "Şükan": true,
      "Taşbaşı": true,
      "Taşmış": true,
      "Taştepe": true,
      "Tatlıcak": true,
      "Tekederesi": true,
      "Teluşağı": true,
      "Tepehan": true,
      "Ulutaş": true,
      "Uzunkoru": true,
      "Uzuntaş": true,
      "Üçyaka": true,
      "Yamaç": true,
      "Yandere": true,
      "Yazıca": true,
      "Yediyol": true,
      "Yeşildere": true
    },
    "Yazıhan": {
      "Akyazı": true,
      "Alican": true,
      "Ambarcık": true,
      "Bahçelievler": true,
      "Balaban": true,
      "Bereketli": true,
      "Boyaca": true,
      "Boztepe": true,
      "Böğürtlen": true,
      "Buzluk": true,
      "Çavuş": true,
      "Çivril": true,
      "Dedekargın": true,
      "Doğuş": true,
      "Durucasu": true,
      "Eğribük": true,
      "Epreme": true,
      "Erecek": true,
      "Fethiye": true,
      "Gayret": true,
      "Gövük": true,
      "Hamidiye": true,
      "İriağaç": true,
      "Karaca": true,
      "Koşar": true,
      "Kömüşhan": true,
      "Mısırdere": true,
      "Sadıklı": true,
      "Sinanlı": true,
      "Sürür": true,
      "Tahtalı": true,
      "Tecirli": true,
      "Yeni": true
    },
    "Yeşilyurt": {
      "Abdulgaffar": true,
      "Aşağı Bağlar": true,
      "Aşağıköy": true,
      "Atalar": true,
      "Atatürk": true,
      "Banazı": true,
      "Bentbaşı": true,
      "Bindal": true,
      "Bostanbaşı": true,
      "Cafana": true,
      "Cemalgürsel": true,
      "Cevatpaşa": true,
      "Cumhuriyet": true,
      "Cumhuriyet (yeşilyurt)": true,
      "Çarmuzu": true,
      "Çavuşoğlu": true,
      "Çayırköy": true,
      "Çilesiz": true,
      "Çukurdere": true,
      "Dilek": true,
      "Duranlar": true,
      "Duruldu": true,
      "Fatih": true,
      "Gazi": true,
      "Gedik": true,
      "Göktarla": true,
      "Gözene": true,
      "Gündüzbey": true,
      "Hamidiye": true,
      "Hıroğlu": true,
      "Hoca Ahmet Yesevi": true,
      "Horata": true,
      "İkizce": true,
      "İlyas": true,
      "İnönü": true,
      "Kadiruşağı": true,
      "Karahan": true,
      "Karakavak": true,
      "Kaynarca": true,
      "Kendirli": true,
      "Kırkpınar": true,
      "Kırlangıç": true,
      "Kiltepe": true,
      "Konak": true,
      "Koşu": true,
      "Koyunoğlu": true,
      "Kozluk": true,
      "Kuşdoğan": true,
      "Kuyulu": true,
      "Mahmutlu": true,
      "Melekbaba": true,
      "Merkez Fatih": true,
      "Mullakasım": true,
      "Oluklu": true,
      "Ortaköy": true,
      "Öncü": true,
      "Özal": true,
      "Özalper": true,
      "Salkonak": true,
      "Salköprü": true,
      "Samanköy": true,
      "Samanlı": true,
      "Seyituşağı": true,
      "Seyran": true,
      "Suluköy": true,
      "Sütlüce": true,
      "Şahnahan": true,
      "Şeyh Bayram": true,
      "Tecde": true,
      "Tepeköy": true,
      "Tohma": true,
      "Topraktepe": true,
      "Topsöğüt": true,
      "Turgut Özal": true,
      "Üçgöze": true,
      "Yaka": true,
      "Yakınca": true,
      "Yalınkaya": true,
      "Yavuz Selim": true,
      "Yeşilkaynak": true,
      "Zaviye": true
    }
  },
  "Manisa": {
    "Ahmetli": {
      "Alahıdır": true,
      "Altıeylül": true,
      "Ataköy": true,
      "Bahçecik": true,
      "Barbaros": true,
      "Canbazlı": true,
      "Dereköy": true,
      "Derici": true,
      "Dibekdere": true,
      "Gökkaya": true,
      "Güldede": true,
      "Hacıköseli": true,
      "Halilkahya": true,
      "Karaköy": true,
      "Kargın": true,
      "Kendirlik": true,
      "Kestelli": true,
      "Kurtuluş": true,
      "Mandallı": true,
      "Seydiköy": true,
      "Ulu Cami": true,
      "Yaraşlı": true,
      "Zafer": true
    },
    "Akhisar": {
      "Akçaalan": true,
      "Akçeşme": true,
      "Akkocalı": true,
      "Akselendi": true,
      "Arabacıbozköy": true,
      "Aşağıdolma": true,
      "Atatürk": true,
      "Ballıca": true,
      "Başlamış": true,
      "Bekirler": true,
      "Beyoba": true,
      "Boyalılar": true,
      "Büknüş": true,
      "Bünyanosmaniye": true,
      "Cumhuriyet": true,
      "Çamönü": true,
      "Çanakçı": true,
      "Çıtak": true,
      "Çobanhasan": true,
      "Çoruk": true,
      "Dağdere": true,
      "Dayıoğlu": true,
      "Dereköy": true,
      "Dingiller": true,
      "Doğankaya": true,
      "Doğuca": true,
      "Dolmadeğirmen": true,
      "Durasıl": true,
      "Efendi": true,
      "Erdelli": true,
      "Eroğlu": true,
      "Evkafteke": true,
      "Göcek": true,
      "Gökçeahmet": true,
      "Gökçeler": true,
      "Hacı Ishak": true,
      "Hacıibrahimler": true,
      "Hacıosmanlar": true,
      "Hamidiye": true,
      "Hamitköy": true,
      "Hanpaşa": true,
      "Harmandalı": true,
      "Has Hoca": true,
      "Hasköy": true,
      "Hürriyet": true,
      "Işıkköy": true,
      "İnönü": true,
      "İsaca": true,
      "Kabaağaçkıran": true,
      "Kadıdağı": true,
      "Kapaklı": true,
      "Karabörklü": true,
      "Karaköy": true,
      "Karayağcı": true,
      "Kavakalan": true,
      "Kayalıoğlu": true,
      "Kayganlı": true,
      "Kethüda": true,
      "Kızlaralanı": true,
      "Kobaşdere": true,
      "Kocakağan": true,
      "Kömürcü": true,
      "Kulaksızlar": true,
      "Kurtulmuş": true,
      "Mecidiye": true,
      "Medar": true,
      "Moralılar": true,
      "Musaca": true,
      "Musalar": true,
      "Muştullar": true,
      "Paşa": true,
      "Pekmezci": true,
      "Pınarcık": true,
      "Ragıp Bey": true,
      "Rahmiye": true,
      "Reşat Bey": true,
      "Sabancılar": true,
      "Sağrakçı": true,
      "Sakarkaya": true,
      "Sarıçalı": true,
      "Sarılar": true,
      "Sarnıçköy": true,
      "Sazoba": true,
      "Seğirdim": true,
      "Selçikli": true,
      "Selvili": true,
      "Seyit Ahmet": true,
      "Sırtköy": true,
      "Sindelli": true,
      "Söğütlü": true,
      "Süleymanköy": true,
      "Süleymanlı": true,
      "Sünnetçiler": true,
      "Şehitler": true,
      "Şeyhisa": true,
      "Taşçılar": true,
      "Topluca": true,
      "Tütenli": true,
      "Ulu Camii": true,
      "Ulupınar": true,
      "Üçavlu": true,
      "Yatağan": true,
      "Yayakırıldık": true,
      "Yaykın": true,
      "Yeğenoba": true,
      "Yenice": true,
      "Yenidoğan": true,
      "Zeytinlibağ": true,
      "Zeytinliova": true
    },
    "Alaşehir": {
      "Akkeçili": true,
      "Alhan": true,
      "Aydoğdu": true,
      "Azıtepe": true,
      "Badınca": true,
      "Bahadır": true,
      "Bahçedere": true,
      "Bahçeliköy": true,
      "Baklacı": true,
      "Barış": true,
      "Belenyaka": true,
      "Beşeylül": true,
      "Caberburhan": true,
      "Caberfakılı": true,
      "Caberkonaklı": true,
      "Çağlayan": true,
      "Çakırcaali": true,
      "Çamlıbel": true,
      "Çarıkbozdağ": true,
      "Çarıkkaralar": true,
      "Çarıktekke": true,
      "Çeşneli": true,
      "Dağarlar": true,
      "Dağhacıyusuf": true,
      "Delemenler": true,
      "Erenköy": true,
      "Esen Tepe": true,
      "Evrenli": true,
      "Fatih": true,
      "Girelli": true,
      "Göbekli": true,
      "Gülenyaka": true,
      "Gülpınar": true,
      "Gümüşçay": true,
      "Gürsu": true,
      "Hacıaliler": true,
      "Hacıbey": true,
      "Horzumalayaka": true,
      "Horzumembelli": true,
      "Horzumkeserler": true,
      "Horzumsazdere": true,
      "Ilgın": true,
      "Ilıca": true,
      "Işıklar": true,
      "İsmailbey": true,
      "İsmetiye": true,
      "İstasyon": true,
      "Karacalar": true,
      "Karadağ": true,
      "Kasaplı": true,
      "Kavaklıdere": true,
      "Kemaliye": true,
      "Kestanederesi": true,
      "Killik": true,
      "Kozluca": true,
      "Kurtuluş": true,
      "Kurudere": true,
      "Matarlı": true,
      "Menderes": true,
      "Narlıdere": true,
      "Osmaniye": true,
      "Örencik": true,
      "Örnekköy": true,
      "Piyadeler": true,
      "Sakarya": true,
      "Sarıpınar": true,
      "Sarısu": true,
      "Selce": true,
      "Serinköy": true,
      "Serinyayla": true,
      "Sobran": true,
      "Soğanlı": true,
      "Soğuksu": true,
      "Soğukyurt": true,
      "Subaşı": true,
      "Şahyar": true,
      "Şeyh Sinan": true,
      "Tepeköy": true,
      "Toygar": true,
      "Türkmen": true,
      "Uluderbent": true,
      "Üzümlü": true,
      "Yeni": true,
      "Yenice": true,
      "Yeniköy": true,
      "Yeşilyurt": true,
      "Yuvacalı": true
    },
    "Demirci": {
      "Ahatlar": true,
      "Ahmetler": true,
      "Akdere": true,
      "Akıncılar": true,
      "Alaağaç": true,
      "Armutlu": true,
      "Ayvaalan": true,
      "Azizbey": true,
      "Bahçeler": true,
      "Bardakçı": true,
      "Bayramşah": true,
      "Beyazıt": true,
      "Boyacık": true,
      "Bozçatlı": true,
      "Bozköy": true,
      "Büyükkıran": true,
      "Camii Atik": true,
      "Cumhuriyet": true,
      "Çağıllar": true,
      "Çamköy": true,
      "Çamlıca": true,
      "Çanakçı": true,
      "Çandır": true,
      "Çardaklı": true,
      "Çataloluk": true,
      "Danişmentler": true,
      "Demirci": true,
      "Doktor Mehmet Akarsu": true,
      "Durhasan": true,
      "Elek": true,
      "Esenyurt": true,
      "Eskihisar": true,
      "Fatih": true,
      "Gömeçler": true,
      "Gümele": true,
      "Gürçeşme": true,
      "Güveli": true,
      "Hacıbaba": true,
      "Hacıhamza": true,
      "Hacıhasan": true,
      "Hacıtürbek": true,
      "Hırkalı": true,
      "Hoşçalar": true,
      "Hüdük": true,
      "Iklıkçı": true,
      "İcikler": true,
      "İçhisar": true,
      "İmceler": true,
      "İmrenler": true,
      "İrişler": true,
      "İsmailler": true,
      "Karaisalar": true,
      "Kargınışıklar": true,
      "Kasımfakı": true,
      "Kayaköy": true,
      "Kayranokçular": true,
      "Kazancı": true,
      "Kerpiçlik": true,
      "Kılavuzlar": true,
      "Kışlak": true,
      "Kovancı": true,
      "Köylüce": true,
      "Kulalar": true,
      "Kuzeyir": true,
      "Kuzuköy": true,
      "Küçükkıran": true,
      "Küçükoba": true,
      "Küpeler": true,
      "Mahmutlar": true,
      "Marmaracık": true,
      "Mezitler": true,
      "Minnetler": true,
      "Mithatpaşa": true,
      "Öksüzlü": true,
      "Ören": true,
      "Örücüler": true,
      "Pazar": true,
      "Rahmanlar": true,
      "Sağnıç": true,
      "Sayık": true,
      "Secaattin": true,
      "Serçeler": true,
      "Sevişler": true,
      "Sinan": true,
      "Sofular": true,
      "Söğütçük": true,
      "Şehreküstü": true,
      "Talas": true,
      "Taşokçular": true,
      "Tekeler": true,
      "Teperik": true,
      "Ulacık": true,
      "Üşümüş": true,
      "Yağmur": true,
      "Yarbasan": true,
      "Yavaşlar": true,
      "Yenice": true,
      "Yeşildere": true,
      "Yeşiloba": true,
      "Yiğenler": true,
      "Yiğitler": true
    },
    "Gölmarmara": {
      "Atatürk": true,
      "Ayanlar": true,
      "Beyler": true,
      "Çamköy": true,
      "Çömlekçi": true,
      "Değnekler": true,
      "Eski Camii": true,
      "Hacıbaştanlar": true,
      "Hacıveliler": true,
      "Hıroğlu": true,
      "İhsaniye": true,
      "İsmetpaşa": true,
      "Kayaaltı": true,
      "Kayapınar": true,
      "Kılcanlar": true,
      "Ozanca": true,
      "Taşkuyucak": true,
      "Tiyenli": true,
      "Yeni Camii": true,
      "Yeniköy": true,
      "Yunuslar": true
    },
    "Gördes": {
      "Adnan Menderes": true,
      "Akpınar": true,
      "Atatürk": true,
      "Balıklı": true,
      "Bayat": true,
      "Beğel": true,
      "Beğenler": true,
      "Benlieli": true,
      "Beşeylül": true,
      "Boyalı": true,
      "Börez": true,
      "Cuma": true,
      "Çağlayan": true,
      "Çatalarmut": true,
      "Çiçekli": true,
      "Çiğiller": true,
      "Dalkara": true,
      "Dargıl": true,
      "Deliçoban": true,
      "Dereçiftlik": true,
      "Dikilitaş": true,
      "Divan": true,
      "Doğanpınar": true,
      "Dutluca": true,
      "Efendili": true,
      "Evciler": true,
      "Fundacık": true,
      "Gülpınar": true,
      "Güneşli": true,
      "Hüseyni Baba": true,
      "Kabakoz": true,
      "Kalemoğlu": true,
      "Karaağaç": true,
      "Karakeçili": true,
      "Karayağcı": true,
      "Karayakup": true,
      "Kaşıkçı": true,
      "Kayacık": true,
      "Kılcanlar": true,
      "Kıranköy": true,
      "Kıymık": true,
      "Kızıldam": true,
      "Kobaklar": true,
      "Korubaşı": true,
      "Köseler": true,
      "Kuşlukköy": true,
      "Kuyucakkarapınar": true,
      "Kürekçi": true,
      "Malaz": true,
      "Malkoca": true,
      "Nakıpağa": true,
      "Oğulduruk": true,
      "Pınarbaşı": true,
      "Salur": true,
      "Sarıaliler": true,
      "Şahinkaya": true,
      "Şeyhyayla": true,
      "Tepeköy": true,
      "Tüpüler": true,
      "Ulgar": true,
      "Uzunçam": true,
      "Yakaköy": true,
      "Yeniköy": true,
      "Yeşilyurt": true
    },
    "Kırkağaç": {
      "Alacalar": true,
      "Alifakı": true,
      "Bademli": true,
      "Bakır": true,
      "Boduroğlu": true,
      "Bostancı": true,
      "Cinosman": true,
      "Çaltıcak": true,
      "Çiftlik": true,
      "Çobanlar": true,
      "Demirtaş": true,
      "Dualar": true,
      "Fırdanlar": true,
      "Gebeler": true,
      "Gelenbe": true,
      "Gökçukur": true,
      "Güvendik": true,
      "Hacet": true,
      "Hacıhimmet": true,
      "Halkahavlu": true,
      "Hamidiye": true,
      "Hamitli": true,
      "Hıdırağa": true,
      "Işıklar": true,
      "İlyaslar": true,
      "Kadriye": true,
      "Karaali": true,
      "Karakurt": true,
      "Kayadibi": true,
      "Kınık": true,
      "Kocaiskan": true,
      "Kocamehmetağa": true,
      "Kuyucak": true,
      "Küçükyaya": true,
      "Memiş": true,
      "Musahoca": true,
      "Musalar": true,
      "Öveçli": true,
      "Sakarlı": true,
      "Sarıağa": true,
      "Siledik": true,
      "Söğütalan": true,
      "Şair Eşref": true,
      "Tevfikiye": true,
      "Yağmurlu": true,
      "Yeni": true,
      "Zorağa": true
    },
    "Köprübaşı": {
      "Akçaalan": true,
      "Alanyolu": true,
      "Armağan": true,
      "Arpacı": true,
      "Atatürk": true,
      "Azimli": true,
      "Borlu": true,
      "Bozburun": true,
      "Cıcıklı": true,
      "Çarıklar": true,
      "Çavullar": true,
      "Çayköy": true,
      "Döğüşeren": true,
      "Esat": true,
      "Gökveliler": true,
      "Gölbaşı": true,
      "Gülpınar": true,
      "Gündoğdu": true,
      "İkizkuyu": true,
      "Karaelmacık": true,
      "Karyağdı": true,
      "Kasar": true,
      "Kavakyeri": true,
      "Kemhallı": true,
      "Kıdırcık": true,
      "Kınık": true,
      "Kıranşeyh": true,
      "Killik": true,
      "Kozaklı": true,
      "Kulalı": true,
      "Kurtlar": true,
      "Mehmet Akif Ersoy": true,
      "Mestanlı": true,
      "Namık Kemal": true,
      "Rağıllar": true,
      "Saraycık": true,
      "Sargaç": true,
      "Selviler": true,
      "Temrek": true,
      "Tokmaklı": true,
      "Uğurlu": true,
      "Yabacı": true,
      "Yardere": true,
      "Yenice": true,
      "Yeşilköy": true,
      "Yumuklar": true
    },
    "Kula": {
      "4 Eylül": true,
      "Ahmetli": true,
      "Akgün": true,
      "Aktaş": true,
      "Ayazören": true,
      "Ayvatlar": true,
      "Balıbey": true,
      "Başıbüyük": true,
      "Battalmustafa": true,
      "Bayramşah": true,
      "Bebekli": true,
      "Bey": true,
      "Börtlüce": true,
      "Camii Cedit": true,
      "Çarıkballı": true,
      "Çarıkmahmutlu": true,
      "Çiftçiibrahim": true,
      "Dereköy": true,
      "Emre": true,
      "Encekler": true,
      "Erenbağı": true,
      "Eroğlu": true,
      "Esenyazı": true,
      "Evciler": true,
      "Gökçeören": true,
      "Gökdere": true,
      "Gölbaşı": true,
      "Güvercinlik": true,
      "Hacıtufan": true,
      "Hamidiye": true,
      "Hayalli": true,
      "İbrahimağa": true,
      "İncesu": true,
      "Kalınharman": true,
      "Karaoba": true,
      "Kavacık": true,
      "Kenger": true,
      "Kızılkaya": true,
      "Konurca": true,
      "Körez": true,
      "Narıncalıpıtrak": true,
      "Narıncalısüleyman": true,
      "Ortaköy": true,
      "Papuçlu": true,
      "Sandal": true,
      "Saraçlar": true,
      "Sarnıç": true,
      "Seyitali": true,
      "Söğütdere": true,
      "Şehitlioğlu": true,
      "Şeremet": true,
      "Şeritli": true,
      "Şıhlı": true,
      "Tatlıçeşme": true,
      "Topuzdamları": true,
      "Yağbastı": true,
      "Yeniköy": true,
      "Yeşilyayla": true,
      "Yurtbaşı": true,
      "Zaferiye": true
    },
    "Salihli": {
      "Adala": true,
      "Akçaköy": true,
      "Akören": true,
      "Aksoy": true,
      "Akyar": true,
      "Allahdiyen": true,
      "Atatürk": true,
      "Bağcılar": true,
      "Bahçecik": true,
      "Barış": true,
      "Başlıoğlu": true,
      "Beşeylül": true,
      "Beylikli": true,
      "Burhan": true,
      "Caferbey": true,
      "Cumhuriyet": true,
      "Çakaldoğanlar": true,
      "Çaltılı": true,
      "Çamurhamamı": true,
      "Çapaklı": true,
      "Çavlu": true,
      "Çayköy": true,
      "Çaypınar": true,
      "Çelikli": true,
      "Çökelek": true,
      "Çukuroba": true,
      "Damatlı": true,
      "Dedetaşı": true,
      "Delibaşlı": true,
      "Derbent": true,
      "Dombaylı": true,
      "Durasıllı": true,
      "Eldelek": true,
      "Eminbey": true,
      "Emirhacılı": true,
      "Eski Cami": true,
      "Gaffar Okkan": true,
      "Gaziler": true,
      "Gökçeköy": true,
      "Gökeyüp": true,
      "Gökköy": true,
      "Gümüş": true,
      "Güneş": true,
      "Hacıbektaşlı": true,
      "Hacıhıdır": true,
      "Hacıköseli": true,
      "Hacılı": true,
      "Hasalan": true,
      "İğdecik": true,
      "Kabazlı": true,
      "Kale": true,
      "Kapancı": true,
      "Kaplan": true,
      "Karaağaç": true,
      "Karaoğlanlı": true,
      "Karapınar": true,
      "Karasavcı": true,
      "Karayahşi": true,
      "Keli": true,
      "Kemer": true,
      "Kemerdamları": true,
      "Kırdamları": true,
      "Kırveli": true,
      "Kızılhavlu": true,
      "Kocaçeşme": true,
      "Kordon": true,
      "Köseali": true,
      "Kurttutan": true,
      "Kurtuluş": true,
      "Mamatlı": true,
      "Mersindere": true,
      "Mersinli": true,
      "Mevlutlu": true,
      "Mitatpaşa": true,
      "Namık Kemal": true,
      "Oraklar": true,
      "Ortaköy": true,
      "Özyurt": true,
      "Pazarköy": true,
      "Poyraz": true,
      "Poyrazdamları": true,
      "Sağlık": true,
      "Sarıpınar": true,
      "Sart": true,
      "Seyrantepe": true,
      "Sindel": true,
      "Süleymaniye": true,
      "Şehitler": true,
      "Şirinyer": true,
      "Taytan": true,
      "Tekelioğlu": true,
      "Torunlu": true,
      "Üçtepe": true,
      "Yağbasan": true,
      "Yağmurlar": true,
      "Yeniköy": true,
      "Yenipazar": true,
      "Yeşilkavak": true,
      "Yeşilova": true,
      "Yeşilyurt": true,
      "Yılmaz": true,
      "Yörük": true,
      "Zafer": true
    },
    "Sarıgöl": {
      "Afşar": true,
      "Ahmetağa": true,
      "Alemşahlı": true,
      "Aşağı Koçaklar": true,
      "Ayan": true,
      "Bağlıca": true,
      "Bahadırlar": true,
      "Baharlar": true,
      "Bereketli": true,
      "Beyharmanı": true,
      "Cumhuriyet": true,
      "Çanakçı": true,
      "Çavuşlar": true,
      "Çimentepe": true,
      "Dadağlı": true,
      "Dindarlı": true,
      "Doğuşlar": true,
      "Emcelli": true,
      "Güneydamları": true,
      "Günyaka": true,
      "Kahramanlar": true,
      "Karacaali": true,
      "Kızılçukur": true,
      "Konak": true,
      "Mimar Sinan": true,
      "Özpınar": true,
      "Selimiye": true,
      "Sığırtmaçlı": true,
      "Siteler": true,
      "Şeyhdavutlar": true,
      "Tırazlar": true,
      "Yeniköy": true,
      "Yeşiltepe": true,
      "Yukarıkoçaklar": true,
      "Ziyanlar": true
    },
    "Saruhanlı": {
      "Adiloba": true,
      "Alibeyli": true,
      "Apak": true,
      "Atatürk": true,
      "Aydınlar": true,
      "Azimli": true,
      "Bahadır": true,
      "Bedeller": true,
      "Büyükbelen": true,
      "Cengiz Topel": true,
      "Cumhuriyet": true,
      "Çakmaklı": true,
      "Çaltepe": true,
      "Çamlıyurt": true,
      "Çerkez Osmaniye": true,
      "Çınaroba": true,
      "Çullugörece": true,
      "Develi": true,
      "Dilek": true,
      "Gökçeköy": true,
      "Gözlet": true,
      "Gümülceli": true,
      "Hacımusa": true,
      "Hacırahmanlı": true,
      "Halitpaşa": true,
      "Hatıplar": true,
      "Heybeli": true,
      "İshakçelebi": true,
      "İstasyon": true,
      "Kayışlar": true,
      "Kemiklidere": true,
      "Kepenekli": true,
      "Koldere": true,
      "Koyuncu": true,
      "Kumkuyucak": true,
      "Kurtuluş": true,
      "Lütfiye": true,
      "Mütevelli": true,
      "Nuriye": true,
      "Paşaköy": true,
      "Pınarbaşı": true,
      "Sarıçam": true,
      "Sarısığırlı": true,
      "Saruhan": true,
      "Seyitoba": true,
      "Şatırlar": true,
      "Şehitler": true,
      "Taşdibi": true,
      "Tirkeş": true,
      "Yılmaz": true
    },
    "Selendi": {
      "Akçakertil": true,
      "Altınköy": true,
      "Aşağıtefen": true,
      "Avlaşa": true,
      "Bekirağalar": true,
      "Beypınar": true,
      "Çalıklı": true,
      "Çamköy": true,
      "Çamlıca": true,
      "Çampınar": true,
      "Çamyayla": true,
      "Çanşa": true,
      "Çıkrıkçı": true,
      "Çinan": true,
      "Çortak": true,
      "Dedeler": true,
      "Dumanlar": true,
      "Eskicami": true,
      "Eskin": true,
      "Fatih": true,
      "Gölbaşı": true,
      "Hacıhaliller": true,
      "Hacılar": true,
      "Halılar": true,
      "Havaoğlu": true,
      "İnnice": true,
      "Kabaklar": true,
      "Karabeyler": true,
      "Karakozan": true,
      "Karaselendi": true,
      "Karataşterziler": true,
      "Karşıova": true,
      "Kayranlar": true,
      "Kazıklı": true,
      "Kınık": true,
      "Kurşunlu": true,
      "Kurtuluş": true,
      "Kürkçü": true,
      "Mıdıklı": true,
      "Mollaahmetler": true,
      "Omurlar": true,
      "Pınarlar": true,
      "Rahmanlar": true,
      "Selmanhacılar": true,
      "Şehirlioğlu": true,
      "Şerefiye": true,
      "Tavak": true,
      "Tepeynihan": true,
      "Turpçu": true,
      "Yağcı": true,
      "Yenicami": true,
      "Yenice": true,
      "Yeşil": true,
      "Yıldız": true,
      "Yukarıtefen": true,
      "Zafer": true,
      "Zıramanlar": true
    },
    "Soma": {
      "Adil": true,
      "Akçaavlu": true,
      "Atatürk": true,
      "Avdan": true,
      "Bayat": true,
      "Beyce": true,
      "Boncuklu": true,
      "Bozarmut": true,
      "Büyük Güney": true,
      "Büyük Işıklar": true,
      "Cenkyeri": true,
      "Cuma": true,
      "Cumhuriyet": true,
      "Çatalçam": true,
      "Çavdır": true,
      "Çevircek": true,
      "Darkale": true,
      "Deniş": true,
      "Dereköy": true,
      "Devlethan": true,
      "Dualar": true,
      "Duğla": true,
      "Eğnez": true,
      "Evciler": true,
      "Göktaş": true,
      "Hacıyusuf": true,
      "Hamidiye": true,
      "Hamidiye (merkez)": true,
      "Hatun": true,
      "Heciz": true,
      "Hürriyet": true,
      "İnönü": true,
      "İstasyon": true,
      "Kaplan": true,
      "Karacahisar": true,
      "Karacakaş": true,
      "Karaçam": true,
      "Karamanlı": true,
      "Kayrakaltı": true,
      "Kızılören": true,
      "Kiraz": true,
      "Kobaklar": true,
      "Koyundere": true,
      "Kozanlı": true,
      "Kozluören": true,
      "Kum": true,
      "Kurtuluş": true,
      "Küçük Güney": true,
      "Menteşe": true,
      "Naldöken": true,
      "Namazgah": true,
      "Nihat Danışman": true,
      "Onüç Eylül": true,
      "Pirahmet": true,
      "Samsacı": true,
      "Sarıkaya": true,
      "Sevişler": true,
      "Söğütçük": true,
      "Sultaniye": true,
      "Tabanlar": true,
      "Tekeli Işıklar": true,
      "Turgutalp": true,
      "Türkali": true,
      "Türkpiyala": true,
      "Ularca": true,
      "Uruzlar": true,
      "Vakıflı": true,
      "Yağcılı": true,
      "Yayladalı": true,
      "Yırca": true,
      "Zafer": true
    },
    "Şehzadeler": {
      "1.anafartalar": true,
      "2.anafartalar": true,
      "Adakale": true,
      "Adnan Menderes": true,
      "Ahmet Bedevi": true,
      "Akıncılar": true,
      "Akpınar": true,
      "Alaybey": true,
      "Arda": true,
      "Aşağıçobanisa": true,
      "Ayvacık": true,
      "Bayındırlık": true,
      "Belenyenice": true,
      "Çamköy": true,
      "Çarşı": true,
      "Çavuşoğlu": true,
      "Çerkezmahmudiye": true,
      "Çınarlıkuyu": true,
      "Dere": true,
      "Dilşikar": true,
      "Dinçer": true,
      "Ege": true,
      "Gediz": true,
      "Gökbel": true,
      "Göktaşlı": true,
      "Güzelköy": true,
      "Hacıhaliller": true,
      "Halıtlı": true,
      "Hamzabeyli": true,
      "İbrahimçelebi": true,
      "İshakçelebı": true,
      "Kağan": true,
      "Kaleköy": true,
      "Kalemli": true,
      "Karaağaçlı": true,
      "Karaoğlanlı": true,
      "Karayenice": true,
      "Kazım Karabekir": true,
      "Kırançiftliği": true,
      "Kocatepe": true,
      "Kuşlubahçe": true,
      "Mimarsinan": true,
      "Nişancıpaşa": true,
      "Nurlupınar": true,
      "Peker": true,
      "Sakarya": true,
      "Sancaklıbozköy": true,
      "Sancaklıçeşmebaşı": true,
      "Sancaklıiğdecik": true,
      "Sancaklıkayadibi": true,
      "Sancaklıuzunçınar": true,
      "Sarıalan": true,
      "Saruhan": true,
      "Selimşahlar": true,
      "Şehitler": true,
      "Tekeliler": true,
      "Tepecik": true,
      "Tilkisüleymaniye": true,
      "Tunca": true,
      "Turgut Özal": true,
      "Utku": true,
      "Veziroğlu": true,
      "Yarhasanlar": true,
      "Yeniharmandalı": true,
      "Yeniköy": true,
      "Yeşilköy": true,
      "Yukarıçobanisa": true
    },
    "Turgutlu": {
      "Acarlar": true,
      "Akçapınar": true,
      "Akköy": true,
      "Albayrak": true,
      "Altay": true,
      "Aşağıbozkır": true,
      "Atatürk": true,
      "Avşar": true,
      "Ayvacık": true,
      "Baktırlı": true,
      "Bozkır": true,
      "Bozkurt": true,
      "Cumhuriyet": true,
      "Çampınar": true,
      "Çatalköprü": true,
      "Çepnibektaş": true,
      "Çepnidere": true,
      "Çıkrıkçı": true,
      "Dağyeniköy": true,
      "Dalbahçe": true,
      "Derbent": true,
      "Ergenekon": true,
      "Gökgedik": true,
      "Güney": true,
      "Hacıisalar": true,
      "Irlamaz": true,
      "İstasyonaltı": true,
      "İstiklal": true,
      "İzzettin": true,
      "Kabaçınar": true,
      "Karaköy": true,
      "Karaoluk": true,
      "Kayrak": true,
      "Kurtuluş": true,
      "Kurudere": true,
      "Kuşlar": true,
      "Musacalı": true,
      "Musalaryeniköy": true,
      "Mustafa Kemal": true,
      "Osmancık": true,
      "Ören": true,
      "Özyurt": true,
      "Sarıbey": true,
      "Selvilitepe": true,
      "Sinirli": true,
      "Sivrice": true,
      "Subaşı": true,
      "Şehitler": true,
      "Temrek": true,
      "Turan": true,
      "Turgutlar": true,
      "Urganlı": true,
      "Yakuplar": true,
      "Yayla": true,
      "Yedi Eylül": true,
      "Yeni": true,
      "Yeniköy": true,
      "Yıldırım": true,
      "Yılmazlar": true,
      "Yiğitler": true,
      "Yunusdere": true
    },
    "Yunusemre": {
      "50.yıl": true,
      "75. Yıl": true,
      "Akçaköy": true,
      "Akgedik": true,
      "Akmescit": true,
      "Asmacık": true,
      "Atatürk": true,
      "Avdal": true,
      "Ayni Ali": true,
      "Bağyolu": true,
      "Barbaros": true,
      "Beydere": true,
      "Bostanlar": true,
      "Büyüksümbüller": true,
      "Cumhuriyet": true,
      "Çamlıca": true,
      "Davutlar": true,
      "Dazyurt": true,
      "Demirci": true,
      "Durasıllı": true,
      "Düzlen": true,
      "Emlakdere": true,
      "Evrenos": true,
      "Fatih": true,
      "Gökçeler": true,
      "Gülbahçe": true,
      "Gürle": true,
      "Güzelyurt": true,
      "Hafsa Sultan": true,
      "İlyasçılar": true,
      "Karaahmetli": true,
      "Karaali": true,
      "Karahüseyinli": true,
      "Karakılıçlı": true,
      "Karakoca": true,
      "Karaveliler": true,
      "Karayağcıhacılar": true,
      "Kayapınar": true,
      "Kaynak": true,
      "Keçili Köy": true,
      "Kışlaköy": true,
      "Kocakoru": true,
      "Koruköy": true,
      "Kozaklar": true,
      "Kuyualan": true,
      "Küçükbelen": true,
      "Küçüksümbüller": true,
      "Lalapaşa": true,
      "Laleli": true,
      "Maldan": true,
      "Mareşal Fevzi Çakmak": true,
      "Merkez Efendi": true,
      "Mesir": true,
      "Mollasüleymanlı": true,
      "Muradiye": true,
      "Mutlu": true,
      "Müslih": true,
      "Ortaköy": true,
      "Osmancalı": true,
      "Otmanlar": true,
      "Örencik": true,
      "Örselli": true,
      "Pelitalan": true,
      "Pınarköy": true,
      "Recepli": true,
      "Sakallı": true,
      "Sarıahmetli": true,
      "Sarınasuhlar": true,
      "Sarma": true,
      "Seyitli": true,
      "Spil": true,
      "Sümbültepe": true,
      "Süngüllü": true,
      "Şamar": true,
      "Tevfikiye": true,
      "Topçuasım": true,
      "Turgutalp": true,
      "Türkmen": true,
      "Uncubozköy": true,
      "Uzunburun": true,
      "Uzunlar": true,
      "Üçpınar": true,
      "Yağcılar": true,
      "Yaylaköy": true,
      "Yenimahalle": true,
      "Yuntdağıköseler": true,
      "Yuntdağyenice": true
    }
  },
  "Mardin": {
    "Artuklu": {
      "13 Mart": true,
      "Acar": true,
      "Ahmetli": true,
      "Akbağ": true,
      "Akıncı": true,
      "Alakuş": true,
      "Alımlı": true,
      "Ambar": true,
      "Aran": true,
      "Arpatepe": true,
      "Aşağıyeniköy": true,
      "Avcılar": true,
      "Aytepe": true,
      "Bağlıca": true,
      "Boztepe": true,
      "Buğday": true,
      "Cevizlik": true,
      "Cevizpınarı": true,
      "Cumhuriyet": true,
      "Çabuk": true,
      "Çağlar": true,
      "Çalışlı": true,
      "Çatak": true,
      "Çayırpınar": true,
      "Çıplaktepe": true,
      "Çiftlikköy": true,
      "Çukuryurt": true,
      "Dara": true,
      "Dibektaş": true,
      "Diyarbakır Kapı": true,
      "Düzlük": true,
      "Elmabahçe": true,
      "Eminettin": true,
      "Ensar": true,
      "Eroğlu": true,
      "Eryeri": true,
      "Esentepe": true,
      "Eskikale": true,
      "Gökçe": true,
      "Göllü": true,
      "Gül": true,
      "Güneyli": true,
      "Gürağaç": true,
      "Hamzabey": true,
      "Hatunlu": true,
      "Haydar": true,
      "Hüyüklü": true,
      "İstasyon": true,
      "Kabala": true,
      "Karademir": true,
      "Kayacan": true,
      "Konaklı": true,
      "Kotek": true,
      "Kumlu": true,
      "Kuyulu": true,
      "Küçükköy": true,
      "Latifiye": true,
      "Medrese": true,
      "Necmettin": true,
      "Nur": true,
      "Nur (akıncı)": true,
      "Ofis": true,
      "Ortaköy": true,
      "Özlüce": true,
      "Sakalar": true,
      "Saraçoğlu": true,
      "Savurkapı": true,
      "Sulak": true,
      "Sultanköy": true,
      "Şar": true,
      "Şehidiye": true,
      "Tandır": true,
      "Teker": true,
      "Tilkitepe": true,
      "Tozan": true,
      "Ulucami": true,
      "Yalım": true,
      "Yardere": true,
      "Yayla": true,
      "Yaylabaşı": true,
      "Yaylacık": true,
      "Yaylı": true,
      "Yenice": true,
      "Yenikapı": true,
      "Yeniköy": true,
      "Yenişehir": true,
      "Yolbaşı": true,
      "Yukarıaydınlı": true,
      "Yukarıhatunlu": true,
      "Yukarıyeniköy": true,
      "Yüce": true
    },
    "Dargeçit": {
      "Akçaköy": true,
      "Akyol": true,
      "Alayunt": true,
      "Altınoluk": true,
      "Altıyol": true,
      "Bağözü": true,
      "Bahçebaşı": true,
      "Batur": true,
      "Baysun": true,
      "Beğendi": true,
      "Belen": true,
      "Bostanlı": true,
      "Çatalan": true,
      "Çatalçam": true,
      "Çavuşlu": true,
      "Çelikköy": true,
      "Çukurdere": true,
      "Değerli": true,
      "Gürgen": true,
      "Gürışık": true,
      "Ilısu": true,
      "Karabayır": true,
      "Kartalkaya": true,
      "Kılavuz": true,
      "Kısmetli": true,
      "Korucu": true,
      "Kumdere": true,
      "Kuşluca": true,
      "Safa": true,
      "Saray": true,
      "Suçatı": true,
      "Sümer": true,
      "Tanyeri": true,
      "Tavşanlı": true,
      "Temelli": true,
      "Tepebaşı": true,
      "Ulaş": true,
      "Yanılmaz": true,
      "Yılmaz": true,
      "Yoncalı": true
    },
    "Derik": {
      "Adak": true,
      "Adakent": true,
      "Ahmetli": true,
      "Akçay": true,
      "Akıncılar": true,
      "Alagöz": true,
      "Alanlı": true,
      "Alibey": true,
      "Ambarlı": true,
      "Aşağımezra": true,
      "Atlı": true,
      "Aydınlar": true,
      "Bağarası": true,
      "Bahçelievler": true,
      "Ballı": true,
      "Balova": true,
      "Başaran": true,
      "Bayırköy": true,
      "Bayraklı": true,
      "Beşbudak": true,
      "Boyaklı": true,
      "Bozbayır": true,
      "Bozok": true,
      "Böğrek": true,
      "Burçköy": true,
      "Cevizpınar": true,
      "Çadırlı": true,
      "Çağıl": true,
      "Çataltepe": true,
      "Çayköy": true,
      "Çukursu": true,
      "Dağ": true,
      "Demirli": true,
      "Denktaş": true,
      "Derinsu": true,
      "Dikmen": true,
      "Doğancı": true,
      "Dumanlı": true,
      "Dumluca": true,
      "Düztaş": true,
      "Göktaş": true,
      "Gölbaşı": true,
      "Hayırlı": true,
      "Hisaraltı": true,
      "Ilıca": true,
      "Issız": true,
      "İncesu": true,
      "Kale": true,
      "Kanatlı": true,
      "Karaburun": true,
      "Karataş": true,
      "Kayacık": true,
      "Kocatepe": true,
      "Koçyiğit": true,
      "Konak": true,
      "Konuk": true,
      "Kovalı": true,
      "Kovanlı": true,
      "Köseveli": true,
      "Kuruçay": true,
      "Kuşçu": true,
      "Kutluca": true,
      "Kuyulu": true,
      "Küçükpınar": true,
      "Meşeli": true,
      "Ortaca": true,
      "Pınarcık": true,
      "Pirinçli": true,
      "Soğukkuyu": true,
      "Söğütözü": true,
      "Subaşı": true,
      "Şahverdi": true,
      "Şerefli": true,
      "Taşıt": true,
      "Tepebağ": true,
      "Üçkuyu": true,
      "Üçtepe": true,
      "Yazıcık": true,
      "Yukarımezra": true,
      "Zeytinpınar": true
    },
    "Kızıltepe": {
      "Akalın": true,
      "Akça": true,
      "Akçapınar": true,
      "Akdoğan": true,
      "Akkoç": true,
      "Aktepe": true,
      "Aktulga": true,
      "Akyazı": true,
      "Akyüz": true,
      "Akziyaret": true,
      "Alakuş": true,
      "Alemdar": true,
      "Alipaşa": true,
      "Altıntoprak": true,
      "Arakapı": true,
      "Araköy": true,
      "Arıklı": true,
      "Arıtepe": true,
      "Aslanlı": true,
      "Aşağıazıklı": true,
      "Ataköy": true,
      "Atatürk": true,
      "Atmaca": true,
      "Ayaz": true,
      "Bağrıbütün": true,
      "Bahçelievler": true,
      "Barış": true,
      "Başak": true,
      "Bektaş": true,
      "Belli": true,
      "Beşdeğirmen": true,
      "Beşevler": true,
      "Beşik": true,
      "Bozhöyük": true,
      "Büyükayrık": true,
      "Büyükboğaziye": true,
      "Büyükdere": true,
      "Büyüktepe": true,
      "Cantaşı": true,
      "Cumhuriyet": true,
      "Çağıl": true,
      "Çakır": true,
      "Çamlıca": true,
      "Çamlıdere": true,
      "Çanaklı": true,
      "Çatalca": true,
      "Çaybaşı": true,
      "Çetinkaya": true,
      "Çetinler": true,
      "Çınarcık": true,
      "Çıplak": true,
      "Çimenli": true,
      "Çitlibağ": true,
      "Damlalı": true,
      "Demet": true,
      "Demirci": true,
      "Demirkapı": true,
      "Demirler": true,
      "Dikmen": true,
      "Doğanlı": true,
      "Dora": true,
      "Doyuran": true,
      "Dörtyol": true,
      "Dunaysır": true,
      "Düğürk": true,
      "Ekinlik": true,
      "Elbeyli": true,
      "Elmalı": true,
      "Erdem": true,
      "Erikli": true,
      "Eroğlu": true,
      "Ersoylu": true,
      "Esenli": true,
      "Eskin": true,
      "Eşme": true,
      "Eymirli": true,
      "Fındıktepe": true,
      "Fırat": true,
      "Göllü": true,
      "Gözlüce": true,
      "Güçlü": true,
      "Gümüşdere": true,
      "Güneştepe": true,
      "Güngören": true,
      "Günlüce": true,
      "Gürmeşe": true,
      "Hacıhasan": true,
      "Hacıyusuf": true,
      "Hakverdi": true,
      "Halkalı": true,
      "Harmandüzü": true,
      "Haznedar": true,
      "Hocaköy": true,
      "Ilıcak": true,
      "Işıklar": true,
      "Işıkören": true,
      "İkikuyu": true,
      "İkizler": true,
      "İnandı": true,
      "İpek": true,
      "Kahraman": true,
      "Kalaycık": true,
      "Karabent": true,
      "Karakulak": true,
      "Karakuyu": true,
      "Karaman": true,
      "Kaşıklı": true,
      "Katarlı": true,
      "Kayapınar": true,
      "Kaynarca": true,
      "Kengerli": true,
      "Kılduman": true,
      "Kırkkuyu": true,
      "Kilimli": true,
      "Kocalar": true,
      "Koçhisar": true,
      "Koçlu": true,
      "Konuklu": true,
      "Köprübaşı": true,
      "Körsu": true,
      "Küçükayrık": true,
      "Küçükboğaziye": true,
      "Küplüce": true,
      "Mevlana": true,
      "Mezopotamya": true,
      "Odaköy": true,
      "Ofis": true,
      "Ortaköy": true,
      "Otluk": true,
      "Örencik": true,
      "Rıhani": true,
      "Sanayi": true,
      "Sancarlı": true,
      "Sandıklı": true,
      "Sarıca": true,
      "Saruhan": true,
      "Selahattin Eyyubi": true,
      "Sevimli": true,
      "Soğanlı": true,
      "Sürekli": true,
      "Şahkulubey": true,
      "Şenyurt": true,
      "Tanrıverdi": true,
      "Tarlabaşı": true,
      "Taşlıca": true,
      "Tatlıca": true,
      "Tepebaşı": true,
      "Tıraşlı": true,
      "Timurçiftliği": true,
      "Tosunlu": true,
      "Turgut Özal": true,
      "Tuzla": true,
      "Tuzluca": true,
      "Ulaşlı": true,
      "Uluköy": true,
      "Uzunkaya": true,
      "Üçevler": true,
      "Ülker": true,
      "Yalınkılıç": true,
      "Yamaç": true,
      "Yamanlar": true,
      "Yarımca": true,
      "Yaşarköy": true,
      "Yayıklı": true,
      "Yaylım": true,
      "Yedikardeş": true,
      "Yeni": true,
      "Yenikent": true,
      "Yeşilköy": true,
      "Yeşiller": true,
      "Yolaldı": true,
      "Yoldere": true,
      "Yolüstü": true,
      "Yoncalı": true,
      "Yukarıazıklı": true,
      "Yumrutaş": true,
      "Yumurcak": true,
      "Yurtderi": true,
      "Yurtözü": true,
      "Yüceli": true,
      "Yüksektepe": true,
      "Zergan": true,
      "Ziyaret": true
    },
    "Mazıdağı": {
      "Aksu": true,
      "Arıköy": true,
      "Arısu": true,
      "Aşağıocak": true,
      "Atalar": true,
      "Atlıca": true,
      "Aykut": true,
      "Bahçecik": true,
      "Balpınar": true,
      "Bilge": true,
      "Çankaya": true,
      "Çayönü": true,
      "Derecik": true,
      "Dikyamaç": true,
      "Duraklı": true,
      "Ekinciler": true,
      "Engin": true,
      "Erdalı": true,
      "Evciler": true,
      "Gümüşpınar": true,
      "Gümüşyuva": true,
      "Gündoğan": true,
      "Gürgöze": true,
      "Işıkyaka": true,
      "İkisu": true,
      "Karaalani": true,
      "Karataş": true,
      "Karşıyaka": true,
      "Kayalar": true,
      "Kebapçı": true,
      "Kemerli": true,
      "Kışlak": true,
      "Kocakent": true,
      "Konur": true,
      "Meşeli": true,
      "Ortaklı": true,
      "Ömürlü": true,
      "Poyraz": true,
      "Sağmal": true,
      "Sakızlı": true,
      "Şanlı": true,
      "Şenyuva": true,
      "Tanrıyolu": true,
      "Tarlacık": true,
      "Ulutaş": true,
      "Ürünlü": true,
      "Yağmur": true,
      "Yalınağaç": true,
      "Yeşilköy": true,
      "Yetkinler": true,
      "Yukarıkonak": true,
      "Yukarıocak": true,
      "Yücebağ": true
    },
    "Midyat": {
      "Acırlı": true,
      "Adaklı": true,
      "Akçakaya": true,
      "Altıntaş": true,
      "Anıtlı": true,
      "Bağlar": true,
      "Bağlarbaşı": true,
      "Bahçelievler": true,
      "Bardakçı": true,
      "Barıştepe": true,
      "Başyurt": true,
      "Bethkustan": true,
      "Budaklı": true,
      "Cumhuriyet": true,
      "Çaldere": true,
      "Çalpınar": true,
      "Çamyurt": true,
      "Çandarlı": true,
      "Çavuşlu": true,
      "Çayırlı": true,
      "Danışman": true,
      "Doğançay": true,
      "Doğanyazı": true,
      "Dolunay": true,
      "Düzgeçit": true,
      "Düzoba": true,
      "Eğlence": true,
      "Elbeğendi": true,
      "Erişti": true,
      "Gelinkaya": true,
      "Gölcük": true,
      "Gülgöze": true,
      "Gülveren": true,
      "Güngören": true,
      "Güven": true,
      "Hanlar": true,
      "Harmanlı": true,
      "Işıklar": true,
      "İkizdere": true,
      "İzbırak": true,
      "Kayabaşı": true,
      "Kayalar": true,
      "Kayalıpınar": true,
      "Kutlubey": true,
      "Mercimekli": true,
      "Narlı": true,
      "Ortaca": true,
      "Ortaçarşı": true,
      "Oyuklu": true,
      "Pelitli": true,
      "Sanayi": true,
      "Sarıkaya": true,
      "Sarıköy": true,
      "Seyitler": true,
      "Sivrice": true,
      "Söğütlü": true,
      "Şenköy": true,
      "Taşlıburç": true,
      "Tepeli": true,
      "Toptepe": true,
      "Tulgalı": true,
      "Ulucami": true,
      "Üçağıl": true,
      "Yayvantepe": true,
      "Yemişli": true,
      "Yeni": true,
      "Yenice": true,
      "Yeşilöz": true,
      "Yolbaşı": true,
      "Yunus Emre": true,
      "Yuvalı": true,
      "Ziyaret": true
    },
    "Nusaybin": {
      "8 Mart": true,
      "Abdulkadirpaşa": true,
      "Açıkköy": true,
      "Açıkyol": true,
      "Akağıl": true,
      "Akarsu": true,
      "Akçatarla": true,
      "Bahçebaşı": true,
      "Bakacık": true,
      "Balaban": true,
      "Barış": true,
      "Beylik": true,
      "Büyükkardeş": true,
      "Çağlar": true,
      "Çalı": true,
      "Çatalözü": true,
      "Çiğdem": true,
      "Çilesiz": true,
      "Çölova": true,
      "Dağiçi": true,
      "Dallıağaç": true,
      "Demirtepe": true,
      "Devrim": true,
      "Dibek": true,
      "Dicle": true,
      "Dirim": true,
      "Doğanlı": true,
      "Doğuş": true,
      "Durakbaşı": true,
      "Duruca": true,
      "Düzce": true,
      "Eskihisar": true,
      "Eskimağara": true,
      "Eskiyol": true,
      "Fırat": true,
      "Gırnavas": true,
      "Girmeli": true,
      "Görentepe": true,
      "Günebakan": true,
      "Güneli": true,
      "Günyurdu": true,
      "Gürün": true,
      "Güvenli": true,
      "Hasantepe": true,
      "Heybeli": true,
      "İkiztepe": true,
      "İlkadım": true,
      "İpekyolu": true,
      "Kalecik": true,
      "Kantar": true,
      "Karaca": true,
      "Kayadibi": true,
      "Kışla": true,
      "Kocadağ": true,
      "Kuruköy": true,
      "Kuyular": true,
      "Küçükkardeş": true,
      "Mor-yakup": true,
      "Nergizli": true,
      "Odabaşı": true,
      "Pazar": true,
      "Selahaddin Eyyubi": true,
      "Sınırtepe": true,
      "Söğütlü": true,
      "Taşköy": true,
      "Tekağaç": true,
      "Tepealtı": true,
      "Tepeören": true,
      "Tepeüstü": true,
      "Turgutköy": true,
      "Üçköy": true,
      "Üçyol": true,
      "Yandere": true,
      "Yavruköy": true,
      "Yazyurdu": true,
      "Yenişehir": true,
      "Yenituran": true,
      "Yerköy": true,
      "Yeşilkent": true,
      "Yolbilen": true,
      "Yolindi": true,
      "Zeynelabidin": true
    },
    "Ömerli": {
      "Akyokuş": true,
      "Alıçlı": true,
      "Anıttepe": true,
      "Beşikkaya": true,
      "Cumhuriyet": true,
      "Çalışan": true,
      "Çatalyurt": true,
      "Çayıralanı": true,
      "Çınaraltı": true,
      "Çimenlik": true,
      "Duygulu": true,
      "Fıstıklı": true,
      "Göllü": true,
      "Güzelağaç": true,
      "Harmankaya": true,
      "Havuzbaşı": true,
      "Işıkdere": true,
      "İkipınar": true,
      "İkitepe": true,
      "Kayabalı": true,
      "Kayadere": true,
      "Kayagöze": true,
      "Kayaüstü": true,
      "Kaynakkaya": true,
      "Kocakuyu": true,
      "Kocasırt": true,
      "Kovanlı": true,
      "Kömürlü": true,
      "Mutluca": true,
      "Ovabaşı": true,
      "Öztaş": true,
      "Pınarcık": true,
      "Salihköy": true,
      "Sivritepe": true,
      "Sulakdere": true,
      "Şafak": true,
      "Taşgedik": true,
      "Taşlıca": true,
      "Tavuklu": true,
      "Tekkuyu": true,
      "Tokdere": true,
      "Topağaç": true,
      "Ünsallı": true,
      "Yaylatepe": true,
      "Yeni": true
    },
    "Savur": {
      "Akyürek": true,
      "Armutalan": true,
      "Bağyaka": true,
      "Başağaç": true,
      "Başkavak": true,
      "Bengisu": true,
      "Çınarönü": true,
      "Dereiçi": true,
      "Durusu": true,
      "Erkuran": true,
      "Gölbaşı": true,
      "Harmantepe": true,
      "Hisarkaya": true,
      "İçören": true,
      "İşgören": true,
      "Kaplan": true,
      "Karaköy": true,
      "Kayacıklar": true,
      "Kayatepe": true,
      "Kırbalı": true,
      "Kırkdirek": true,
      "Kocahüyük": true,
      "Koşuyolu": true,
      "Köprülü": true,
      "Ormancık": true,
      "Pınardere": true,
      "Safa": true,
      "Sancaklı": true,
      "Serenli": true,
      "Seydin": true,
      "Soylu": true,
      "Sürgücü": true,
      "Şenocak": true,
      "Taşlık": true,
      "Tokluca": true,
      "Üçerli": true,
      "Üçkavak": true,
      "Yaylayanı": true,
      "Yazır": true,
      "Yenilmez": true,
      "Yeşilalan": true
    },
    "Yeşilli": {
      "Alıçlı": true,
      "Bahçebaşı": true,
      "Bülbül": true,
      "Dereyanı": true,
      "Gül": true,
      "Karşıyaka": true,
      "Koyunlu": true,
      "Kütüklü": true,
      "Ovaköy": true,
      "Sancar": true,
      "Şirinevler": true,
      "Tepebaşı": true,
      "Uzunköy": true,
      "Zeytinli": true
    }
  },
  "Mersin": {
    "Akdeniz": {
      "Abdullah Şahutoğlu": true,
      "Adanalıoğlu": true,
      "Adanalıoğlu Limonlu": true,
      "Adnan Menderes": true,
      "Akdam": true,
      "Akdeniz": true,
      "Anadolu": true,
      "Bağcılar-ihsaniye": true,
      "Bağlarbaşı": true,
      "Bahçe": true,
      "Bahçeli Aşağıburhan": true,
      "Bahçeli Kürkçü": true,
      "Bahçeli Yukarıburhan": true,
      "Bahşiş": true,
      "Barış": true,
      "Bekirde": true,
      "Cami Şerif": true,
      "Camili": true,
      "Civanyaylağı": true,
      "Cumhuriyet": true,
      "Çankaya": true,
      "Çay": true,
      "Çilek": true,
      "Demirhisar": true,
      "Dikilitaş": true,
      "Esenli": true,
      "Evci": true,
      "Gazi": true,
      "Gündoğdu": true,
      "Güneş": true,
      "Hal": true,
      "Hamidiye": true,
      "Hebilli": true,
      "Hürriyet": true,
      "Iğdır": true,
      "İhsaniye": true,
      "Karacailyas": true,
      "Karacailyas Emek": true,
      "Karacailyas Evren": true,
      "Karaduvar": true,
      "Kazanlı": true,
      "Kiremithane": true,
      "Köselerli": true,
      "Kulak": true,
      "Kültür": true,
      "Mahmudiye": true,
      "Mesudiye": true,
      "Mithatpaşa": true,
      "Müfide Ilhan": true,
      "Nacarlı": true,
      "Nusratiye": true,
      "Özgürlük": true,
      "Parmakkurdu": true,
      "Puğkaracadağ": true,
      "Sarıibrahimli": true,
      "Siteler": true,
      "Şakirgülmen": true,
      "Şevketsümer": true,
      "Toroslar": true,
      "Turgutreis": true,
      "Üçocak": true,
      "Yanpar": true,
      "Yeni": true,
      "Yeşilçimen": true,
      "Yeşilova": true
    },
    "Anamur": {
      "Akarca": true,
      "Akdeniz": true,
      "Akine": true,
      "Alataş": true,
      "Anıtlı": true,
      "Aşağıkükür": true,
      "Bahçe": true,
      "Bahçelievler": true,
      "Boğuntu": true,
      "Bozdoğan": true,
      "Çaltıbükü": true,
      "Çamlıpınar": true,
      "Çamlıpınaralanı": true,
      "Çarıklar": true,
      "Çataloluk": true,
      "Çeltikçi": true,
      "Çukurabanoz": true,
      "Demirören": true,
      "Emirşah": true,
      "Esentepe": true,
      "Evciler": true,
      "Fatih": true,
      "Gercebahşiş": true,
      "Göktaş": true,
      "Güleç": true,
      "Güneybahşiş": true,
      "Güngören": true,
      "Güzelyurt": true,
      "İskele": true,
      "Kalınören": true,
      "Karaağa": true,
      "Karaçukur": true,
      "Karadere": true,
      "Karalarbahşiş": true,
      "Kaşdişlen": true,
      "Kılıç": true,
      "Kızılaliler": true,
      "Korucuk": true,
      "Köprübaşı": true,
      "Lale": true,
      "Malaklar": true,
      "Ormancık": true,
      "Ovabaşı": true,
      "Ören": true,
      "Sağlık": true,
      "Saray": true,
      "Sarıağaç": true,
      "Sarıdana": true,
      "Sugözü": true,
      "Sultan Alaaddin": true,
      "Toroslar": true,
      "Uçarı": true,
      "Yalıevleri": true,
      "Yeşilyurt": true,
      "Yıldırım Beyazıt": true,
      "Yukarı Kükür": true
    },
    "Aydıncık": {
      "Atatürk": true,
      "Cumhuriyet": true,
      "Duruhan": true,
      "Eskiyürük": true,
      "Hacıbahattin": true,
      "Hürriyet": true,
      "Karadere": true,
      "Karaseki": true,
      "Merkez": true,
      "Pembecik": true,
      "Teknecik": true,
      "Yeni": true,
      "Yenikaş": true,
      "Yeniyürük": true,
      "Yeniyürükkaş": true
    },
    "Bozyazı": {
      "Akcami": true,
      "Ardıçlıtaş": true,
      "Bahçekoyağı": true,
      "Beyreli": true,
      "Çopurlu": true,
      "Çubukkoyağı": true,
      "Denizciler": true,
      "Derebaşı": true,
      "Dereköy": true,
      "Elmakuzu": true,
      "Gözce": true,
      "Gözsüzce": true,
      "Gürlevik": true,
      "Kaledibi": true,
      "Karaisalı": true,
      "Kızılca": true,
      "Kömürlü": true,
      "Kötekler": true,
      "Lenger": true,
      "Merkez": true,
      "Narince": true,
      "Sıcakyurt": true,
      "Tekedüzü": true,
      "Tekeli": true,
      "Tekmen": true,
      "Ustalar": true
    },
    "Çamlıyayla": {
      "Bağçatağı": true,
      "Belçınar": true,
      "Cumayakası": true,
      "Çayırekinliği": true,
      "Darıpınarı": true,
      "Fakılar": true,
      "Giden": true,
      "Kale": true,
      "Kesecik": true,
      "Korucak": true,
      "Körmenlik": true,
      "Sarıkavak": true,
      "Sarıkoyak": true,
      "Sebil": true
    },
    "Erdemli": {
      "Adnan Menderes": true,
      "Akdeniz": true,
      "Akpınar": true,
      "Alata": true,
      "Alibeyli": true,
      "Arpaçbahşiş": true,
      "Arslanlı": true,
      "Ayaş": true,
      "Aydınlar": true,
      "Barbaros": true,
      "Batısandal": true,
      "Çamlı": true,
      "Çerçili": true,
      "Çeşmeli": true,
      "Çiftepınar": true,
      "Çiriş": true,
      "Dağlı": true,
      "Doğusandal": true,
      "Elbeyli": true,
      "Elvanlı": true,
      "Esenpınar": true,
      "Evdilek": true,
      "Fakılı": true,
      "Fatih": true,
      "Gücüş": true,
      "Güneyli": true,
      "Güzeloluk": true,
      "Hacıalanı": true,
      "Hacıhalilarpaç": true,
      "Harfilli": true,
      "Hüsametli": true,
      "İlemin": true,
      "Karaahmetli": true,
      "Karahıdırlı": true,
      "Karakeşli": true,
      "Karayakup": true,
      "Kargıcak": true,
      "Kargıpınarı": true,
      "Kayacı": true,
      "Kızılen": true,
      "Kızkalesi": true,
      "Kocahasanlı": true,
      "Koramşalı": true,
      "Koyuncu": true,
      "Kösbucağı": true,
      "Kösereli": true,
      "Kuşluca": true,
      "Küstülü": true,
      "Limonlu": true,
      "Merkez": true,
      "Pınarbaşı": true,
      "Sarıkaya": true,
      "Sarıyer": true,
      "Sıraç": true,
      "Sinap": true,
      "Sorgun": true,
      "Şahna": true,
      "Tabiye": true,
      "Tapureli": true,
      "Tırtar": true,
      "Toros": true,
      "Tozlu": true,
      "Tömük": true,
      "Türbe": true,
      "Üçtepe": true,
      "Üzümlü": true,
      "Veyselli": true,
      "Yağda": true,
      "Yarenler": true,
      "Yeniyurt": true,
      "Yüksek": true
    },
    "Gülnar": {
      "Akdeniz": true,
      "Akova": true,
      "Ardıçpınarı": true,
      "Arıkuyusu": true,
      "Ayvalı": true,
      "Bereket": true,
      "Beydili": true,
      "Bolyaran": true,
      "Bozağaç": true,
      "Büyükeceli": true,
      "Çavuşlar": true,
      "Çukurasma": true,
      "Çukurkonak": true,
      "Dayıcık": true,
      "Dedeler": true,
      "Delikkaya": true,
      "Demirözü": true,
      "Emirhacı": true,
      "Gezende": true,
      "Göktürk": true,
      "Hacıpınar": true,
      "Halifeler": true,
      "Ilısu": true,
      "İshaklar": true,
      "Kavakoluğu": true,
      "Kayrak": true,
      "Koçaşlı": true,
      "Konur": true,
      "Korucuk": true,
      "Köseçobanlı": true,
      "Kurbağa": true,
      "Kuskan": true,
      "Mollaömerli": true,
      "Örenpınar": true,
      "Örtülü": true,
      "Saray": true,
      "Sarıkavak": true,
      "Sipahili": true,
      "Şeyhömer": true,
      "Taşoluk": true,
      "Tepe": true,
      "Tırnak": true,
      "Tozkovan": true,
      "Ulupınar": true,
      "Üçoluk": true,
      "Yanışlı": true,
      "Yarmasu": true,
      "Yassıbağ": true,
      "Yenice": true,
      "Zeyne": true
    },
    "Mezitli": {
      "75.yıl": true,
      "Akarca": true,
      "Akdeniz": true,
      "Anayurt": true,
      "Atatürk": true,
      "Bozön": true,
      "Cemilli": true,
      "Cumhuriyet": true,
      "Çamlıca": true,
      "Çankaya": true,
      "Çevlik": true,
      "Davultepe": true,
      "Demirışık": true,
      "Deniz": true,
      "Doğançay": true,
      "Doğlu": true,
      "Esenbağlar": true,
      "Eski Mezitli": true,
      "Fatih": true,
      "Fındıkpınarı": true,
      "Hürriyet": true,
      "İstiklal": true,
      "Kaleköy": true,
      "Kocayer": true,
      "Kuyuluk": true,
      "Kuzucu": true,
      "Kuzucubelen": true,
      "Menderes": true,
      "Merkez": true,
      "Pelitkoyağı": true,
      "Sarılar": true,
      "Seymenli": true,
      "Şahin Tepesi": true,
      "Takanlı": true,
      "Tece": true,
      "Tepeköy": true,
      "Tol": true,
      "Viranşehir": true,
      "Yeni": true,
      "Zeybekler": true
    },
    "Mut": {
      "Alaçam": true,
      "Aşağıköselerli": true,
      "Aydınoğlu": true,
      "Bağcağız": true,
      "Ballı": true,
      "Barabanlı": true,
      "Bozdoğan": true,
      "Burunköy": true,
      "Ceritler": true,
      "Cumhuriyet": true,
      "Çağlayangedik": true,
      "Çaltılı": true,
      "Çamlıca": true,
      "Çampınar": true,
      "Çatakbağ": true,
      "Çatalharman": true,
      "Çınarlı": true,
      "Çivi": true,
      "Çortak": true,
      "Çömelek": true,
      "Çukurbağ": true,
      "Dağpazarı": true,
      "Demirkapı": true,
      "Dereköy": true,
      "Derinçay": true,
      "Deveci": true,
      "Diştaş": true,
      "Doğancı": true,
      "Elbeyli": true,
      "Elmapınar": true,
      "Esençay": true,
      "Evren": true,
      "Fakırca": true,
      "Geçimli": true,
      "Gençali": true,
      "Göcekler": true,
      "Gökçetaş": true,
      "Göksu": true,
      "Güllük": true,
      "Güme": true,
      "Güzelköy": true,
      "Güzelyurt": true,
      "Hacıahmetli": true,
      "Hacıilyaslı": true,
      "Hacınuhlu": true,
      "Hacısait": true,
      "Hamam": true,
      "Haydarköy": true,
      "Hisarköy": true,
      "Hocalı": true,
      "Ilıca": true,
      "Irmaklı": true,
      "Işıklar": true,
      "İbrahimli": true,
      "Kadıköy": true,
      "Kale": true,
      "Karacaoğlan": true,
      "Karadiken": true,
      "Karşıyaka": true,
      "Kavaklı": true,
      "Kavaközü": true,
      "Kayabaşı": true,
      "Kayaönü": true,
      "Kelceköy": true,
      "Kemenli": true,
      "Kırkkavak": true,
      "Kışlaköy": true,
      "Kızılalan": true,
      "Köselerli": true,
      "Kumaçukuru": true,
      "Kurtsuyu": true,
      "Kurtuluş": true,
      "Kültür": true,
      "Kürkçü": true,
      "Meydan": true,
      "Mirahor": true,
      "Mucuk": true,
      "Narlı": true,
      "Narlıdere": true,
      "Ortaköy": true,
      "Özköy": true,
      "Özlü": true,
      "Palantepe": true,
      "Pamuklu": true,
      "Pınarbaşı": true,
      "Sakız": true,
      "Sarıveliler": true,
      "Selamlı": true,
      "Suçatı": true,
      "Tekeli": true,
      "Topkaya": true,
      "Topluca": true,
      "Tuğrul": true,
      "Yalnızcabağ": true,
      "Yapıntı": true,
      "Yatırtaş": true,
      "Yazalanı": true,
      "Yeşilköy": true,
      "Yeşilyurt": true,
      "Yıldızköy": true,
      "Yukarıköselerli": true,
      "Zeytinçukuru": true
    },
    "Silifke": {
      "Akdere": true,
      "Arkum": true,
      "Atakent": true,
      "Atayurt": true,
      "Atik": true,
      "Ayaştürkmenli": true,
      "Bahçe": true,
      "Bahçederesi": true,
      "Balandız": true,
      "Bayındır": true,
      "Bolacalıkoyuncu": true,
      "Bucaklı": true,
      "Burunucu": true,
      "Bükdeğirmeni": true,
      "Camiikebir": true,
      "Canbazlı": true,
      "Cılbayır": true,
      "Çadırlı": true,
      "Çaltıbozkır": true,
      "Çamlıbel": true,
      "Çamlıca": true,
      "Çatak": true,
      "Çeltikçi": true,
      "Demircili": true,
      "Ekşiler": true,
      "Evkafçiftliği": true,
      "Gazi": true,
      "Gedikpınarı": true,
      "Gökbelen": true,
      "Göksu": true,
      "Gülümpaşalı": true,
      "Gündüzler": true,
      "Hırmanlı": true,
      "Hüseyinler": true,
      "Işıklı": true,
      "İmambekirli": true,
      "İmamlı": true,
      "İmamuşağı": true,
      "Kabasakallı": true,
      "Karahacılı": true,
      "Karakaya": true,
      "Kargıcak": true,
      "Kavak": true,
      "Keben": true,
      "Kepez": true,
      "Keşlitürkmenli": true,
      "Kıca": true,
      "Kırtıl": true,
      "Kızılgeçit": true,
      "Kocaoluk": true,
      "Kocapınar": true,
      "Kurtuluş": true,
      "Mara": true,
      "Mukaddem": true,
      "Narlıkuyu": true,
      "Nasrullah": true,
      "Nuru": true,
      "Ortaören": true,
      "Ovacık": true,
      "Ören": true,
      "Özboynuinceli": true,
      "Öztürkmenli": true,
      "Pazarkaşı": true,
      "Pelitpınarı": true,
      "Sabak": true,
      "Saray": true,
      "Sarıaydın": true,
      "Sarıcalar": true,
      "Say": true,
      "Sayağzı": true,
      "Senir": true,
      "Seydili": true,
      "Seyranlık": true,
      "Sökün": true,
      "Sömek": true,
      "Şahmurlu": true,
      "Taşucu": true,
      "Toros": true,
      "Tosmurlu": true,
      "Türkmenuşağı": true,
      "Ulugöz": true,
      "Uşakpınarı": true,
      "Uzuncaburç": true,
      "Yeğenli": true,
      "Yeni": true,
      "Yenibahçe": true,
      "Yenisu": true,
      "Yeşilovacık": true
    },
    "Tarsus": {
      "82evler": true,
      "Ağzıdelik": true,
      "Akarsu": true,
      "Akçakocalı": true,
      "Akgedik": true,
      "Akşemsettin": true,
      "Aladağ": true,
      "Aliağa": true,
      "Alibeyli": true,
      "Aliefendioğlu": true,
      "Alifakı": true,
      "Altaylılar": true,
      "Anıt": true,
      "Ardıçlı": true,
      "Arıklı": true,
      "Atalar": true,
      "Atatürk": true,
      "Avadan": true,
      "Bağlar": true,
      "Baharlı": true,
      "Bahçe": true,
      "Bahşiş": true,
      "Ballıca": true,
      "Baltalı": true,
      "Barbaros": true,
      "Belen": true,
      "Beydeğirmeni": true,
      "Beylice": true,
      "Boğazpınar": true,
      "Bolatlı": true,
      "Boztepe": true,
      "Böğrüeğri": true,
      "Büyükkösebalcı": true,
      "Camilimanda": true,
      "Caminur": true,
      "Cırbıklar": true,
      "Cin": true,
      "Cumhuriyet": true,
      "Çağbaşı": true,
      "Çağlayan": true,
      "Çakırlı": true,
      "Çamalan B.m": true,
      "Çamtepe": true,
      "Çatalca": true,
      "Çavdarlı": true,
      "Çavuşlu": true,
      "Çevreli": true,
      "Çiçekli": true,
      "Çiftlik": true,
      "Çiriştepe": true,
      "Çokak": true,
      "Çöplü": true,
      "Çukurbağ": true,
      "Dadalı": true,
      "Damlama": true,
      "Dedeler": true,
      "Dorak": true,
      "Duatepe": true,
      "Egemen": true,
      "Eminlik": true,
      "Emirler": true,
      "Ergenekon": true,
      "Esenler": true,
      "Eski Ömerli": true,
      "Eskişehir": true,
      "Fahrettin Paşa": true,
      "Fatih": true,
      "Ferahimşalvuz": true,
      "Fevzi Çakmak": true,
      "Gaziler": true,
      "Gazipaşa": true,
      "Girne": true,
      "Göçük": true,
      "Gömmece": true,
      "Gözlükule": true,
      "Gülek": true,
      "Günyurdu": true,
      "Hacıbozan": true,
      "Hacıhamzalı": true,
      "Halitağa": true,
      "Hasanağa": true,
      "Heleke": true,
      "Hürriyet": true,
      "İbrişim": true,
      "İncirgediği": true,
      "İncirlikuyu": true,
      "İnköy": true,
      "İsmetpaşa": true,
      "Kaburgediği": true,
      "Kadelli": true,
      "Kaklıktaşı": true,
      "Kaleburcu": true,
      "Kanberhüyüğü": true,
      "Karaçerçili": true,
      "Karadiken": true,
      "Karadirlik": true,
      "Karakütük": true,
      "Karayayla": true,
      "Kargılı": true,
      "Karsavran": true,
      "Kavaklı": true,
      "Kayadibi": true,
      "Kefeli": true,
      "Kelahmet": true,
      "Kemalpaşa": true,
      "Kerimler": true,
      "Keşli": true,
      "Kırıt": true,
      "Kırklarsırtı": true,
      "Kızılçukur": true,
      "Kızılmurat": true,
      "Kocaköy": true,
      "Koçmarlı": true,
      "Konaklar": true,
      "Kozoluk": true,
      "Körlü Beyi": true,
      "Kösebalcı": true,
      "Köselerli": true,
      "Kulak": true,
      "Kumdere": true,
      "Kurbanlı": true,
      "Kurtçukuru": true,
      "Kuşçular": true,
      "Kütüklü": true,
      "Mahmutağa": true,
      "Mantaş": true,
      "Meşelik": true,
      "Mithatpaşa": true,
      "Muratlı": true,
      "Nemiroğlu": true,
      "Olukkoyağı": true,
      "Öğretmenler": true,
      "Özbek": true,
      "Özlüce": true,
      "Pirömerli": true,
      "Reşadiye": true,
      "Sağlıklı": true,
      "Sandal": true,
      "Sanlıca": true,
      "Sarıveli": true,
      "Sayköy": true,
      "Sıraköy": true,
      "Simithacılı": true,
      "Sucular": true,
      "Şahin": true,
      "Şehitishak": true,
      "Şehitkerim": true,
      "Şehitler Tepesi": true,
      "Şehitmustafa": true,
      "Takbaş": true,
      "Taşçılı": true,
      "Taşkuyu": true,
      "Taşobası": true,
      "Tekeliören": true,
      "Tekke": true,
      "Tepeçaylak": true,
      "Tepeköy": true,
      "Tepetaşpınar": true,
      "Topaklı": true,
      "Topçu": true,
      "Tozkoparan Zahit": true,
      "Ulaş": true,
      "Verimli": true,
      "Yalamık": true,
      "Yanıkkışla": true,
      "Yaramış": true,
      "Yarbay Şemsettin": true,
      "Yazlık": true,
      "Yeni": true,
      "Yeni Ömerli": true,
      "Yenice": true,
      "Yeniçay": true,
      "Yeniköy": true,
      "Yeşil": true,
      "Yeşilevler": true,
      "Yeşiltepe": true,
      "Yeşilyurt": true,
      "Yunus Emre": true,
      "Yunusoğlu": true,
      "Yüksek": true
    },
    "Toroslar": {
      "Akbelen": true,
      "Aladağ": true,
      "Alanyalı": true,
      "Alsancak": true,
      "Arpaçsakarlar": true,
      "Arslanköy": true,
      "Ayvagediği": true,
      "Bekiralanı": true,
      "Buluklu": true,
      "Çağdaşkent": true,
      "Çağlarca": true,
      "Çamlıdere": true,
      "Çandır": true,
      "Çavuşlu": true,
      "Çelebili": true,
      "Çopurlu": true,
      "Çukurova": true,
      "Dalakdere": true,
      "Darısekisi": true,
      "Değirmendere": true,
      "Değnek": true,
      "Demirtaş": true,
      "Doruklu": true,
      "Düğdüören": true,
      "Evrenli": true,
      "Gözne": true,
      "Güneykent": true,
      "Güzelyayla": true,
      "Halkkent": true,
      "Hamzabeyli": true,
      "Horozlu": true,
      "Hüseyin Okan Merzeci": true,
      "Işıktepe": true,
      "Karaisalı": true,
      "Kaşlı": true,
      "Kavaklıpınar": true,
      "Kayrakkeşli": true,
      "Kepirli": true,
      "Kerimler": true,
      "Kızılkaya": true,
      "Korucular": true,
      "Korukent": true,
      "Kurdali": true,
      "Kurudere": true,
      "Mevlana": true,
      "Mithat Toroğlu": true,
      "Musalı": true,
      "Mustafa Kemal": true,
      "Osmaniye": true,
      "Portakal": true,
      "Resulköy": true,
      "Sadiye": true,
      "Sağlık": true,
      "Selçuklar": true,
      "Soğucak": true,
      "Şahinpınarı": true,
      "Tırtar": true,
      "Toroslar": true,
      "Tozkoparan": true,
      "Turgut Türkalp": true,
      "Turunçlu": true,
      "Yalınayak": true,
      "Yavca": true,
      "Yeniköy": true,
      "Yusuf Kılıç": true,
      "Yüksekoluk": true,
      "Zeki Ayan": true
    },
    "Yenişehir": {
      "50. Yıl": true,
      "Akkent": true,
      "Aydınlıkevler": true,
      "Bahçelievler": true,
      "Barbaros": true,
      "Batıkent": true,
      "Cumhuriyet": true,
      "Çavak": true,
      "Çiftlikköy": true,
      "Çukurkeşli": true,
      "Değirmençay": true,
      "Deniz": true,
      "Dumlupınar": true,
      "Eğriçam": true,
      "Emirler": true,
      "Fuatmorel": true,
      "Gazi": true,
      "Gökçebelen": true,
      "Güvenevler": true,
      "Hürriyet": true,
      "İnönü": true,
      "İnsu": true,
      "Karahacılı": true,
      "Kocahamzalı": true,
      "Kocavilayet": true,
      "Kuzeykent": true,
      "Limonluk": true,
      "Menteş": true,
      "Palmiye": true,
      "Pirireis": true,
      "Turunçlu": true,
      "Uzunkaş": true
    }
  },
  "Muğla": {
    "Bodrum": {
      "Akçaalan": true,
      "Akyarlar": true,
      "Bahçelievler": true,
      "Bahçeyaka": true,
      "Bitez": true,
      "Cevat Şakir": true,
      "Cumhuriyet": true,
      "Çamarası": true,
      "Çamlık": true,
      "Çarşı": true,
      "Çırkan": true,
      "Çiftlik": true,
      "Çömlekçi": true,
      "Dağbelen": true,
      "Dereköy": true,
      "Dirmil": true,
      "Eskiçeşme": true,
      "Farilya": true,
      "Geriş": true,
      "Gökpınar": true,
      "Gölbaşı": true,
      "Gölköy": true,
      "Gümbet": true,
      "Gümüşlük": true,
      "Gündoğan": true,
      "Gürece": true,
      "Güvercinlik": true,
      "İslamhaneleri": true,
      "Karabağ": true,
      "Karaova": true,
      "Kemer": true,
      "Kızılağaç": true,
      "Konacık": true,
      "Koyunbaba": true,
      "Kumbahçe": true,
      "Kumköy": true,
      "Küçükbük": true,
      "Mazıköy": true,
      "Mumcular": true,
      "Müskebi": true,
      "Peksimet": true,
      "Pınarlıbelen": true,
      "Sazköy": true,
      "Tepecik": true,
      "Tepecik (karaova)": true,
      "Torba": true,
      "Turgutreis": true,
      "Türkbükü": true,
      "Türkkuyusu": true,
      "Umurca": true,
      "Yahşi": true,
      "Yakaköy": true,
      "Yalıkavak": true,
      "Yeniköy": true,
      "Yeniköy (karaova)": true,
      "Yokuşbaşı": true
    },
    "Dalaman": {
      "Akçataş": true,
      "Altıntas": true,
      "Atakent": true,
      "Bezkese": true,
      "Bozbel": true,
      "Çöğmen": true,
      "Darıyeri": true,
      "Ege": true,
      "Elcik": true,
      "Gürköy": true,
      "Gürleyk": true,
      "Hürriyet": true,
      "Kapukargın": true,
      "Karacaağaç": true,
      "Karaçalı": true,
      "Kargınkürü": true,
      "Kavacık": true,
      "Kayadibi": true,
      "Kızılkaya": true,
      "Merkez": true,
      "Narlı": true,
      "Sabunlu": true,
      "Söğütlüyurt": true,
      "Şerefler": true,
      "Taşbaşı": true
    },
    "Datça": {
      "Cumalı": true,
      "Datça": true,
      "Emecik": true,
      "Hızırşah": true,
      "İskele": true,
      "Karaköy": true,
      "Kızlan": true,
      "Mesudiye": true,
      "Reşadiye": true,
      "Sındı": true,
      "Yaka": true,
      "Yazı": true
    },
    "Fethiye": {
      "Akarca": true,
      "Babataşı": true,
      "Bozyer": true,
      "Cami": true,
      "Cumhuriyet": true,
      "Çamköy": true,
      "Çatalarık": true,
      "Çenger": true,
      "Çiftlik": true,
      "Eldirek": true,
      "Esenköy": true,
      "Faralya": true,
      "Foça": true,
      "Göcek": true,
      "Gökben": true,
      "Gökçeovacık": true,
      "İncirköy": true,
      "İnlice": true,
      "Karaağaç": true,
      "Karacaören": true,
      "Karaçulha": true,
      "Karagedik": true,
      "Karagözler": true,
      "Karakeçililer": true,
      "Kargı": true,
      "Kayaköy": true,
      "Kesikkapı": true,
      "Kızılbel": true,
      "Koruköy": true,
      "Menteşeoğlu": true,
      "Nif": true,
      "Ölüdeniz": true,
      "Patlangıç": true,
      "Pazaryeri": true,
      "Söğütlü": true,
      "Taşyaka": true,
      "Tuzla": true,
      "Yakacık": true,
      "Yanıklar": true,
      "Yeni": true,
      "Yeşilüzümlü": true
    },
    "Kavaklıdere": {
      "Bakırcılar": true,
      "Cumhuriyet": true,
      "Çamlıbel": true,
      "Çamlıyurt": true,
      "Çatak": true,
      "Çavdır": true,
      "Çayboyu": true,
      "Derebağ": true,
      "Kurucuova": true,
      "Menteşe": true,
      "Nebiler": true,
      "Ortaköy": true,
      "Salkım": true,
      "Yeni": true,
      "Yeşilköy": true
    },
    "Köyceğiz": {
      "Akköprü": true,
      "Balcılar": true,
      "Beyobası": true,
      "Çandır": true,
      "Çayhisar": true,
      "Döğüşbelen": true,
      "Ekincik": true,
      "Gelişim": true,
      "Gülpınar": true,
      "Hamitköy": true,
      "Karaçam": true,
      "Kavakarası": true,
      "Köyceğiz": true,
      "Otmanlar": true,
      "Pınar": true,
      "Sazak": true,
      "Sultaniye": true,
      "Toparlar": true,
      "Ulucami": true,
      "Yangı": true,
      "Yayla": true,
      "Yeni": true,
      "Yeşilköy": true,
      "Zaferler": true,
      "Zeytinalanı": true
    },
    "Marmaris": {
      "Adaköy": true,
      "Armutalan": true,
      "Bayır": true,
      "Beldibi": true,
      "Bozburun": true,
      "Camiavlu": true,
      "Çamdibi": true,
      "Çamlı": true,
      "Çetibeli": true,
      "Çıldır": true,
      "Gölenye": true,
      "Hatipirimi": true,
      "Hisarönü": true,
      "İçmeler": true,
      "Karaca": true,
      "Karşıyaka": true,
      "Kemeraltı": true,
      "Orhaniye": true,
      "Osmaniye": true,
      "Sarıana": true,
      "Selimiye": true,
      "Sinan": true,
      "Siteler": true,
      "Söğüt": true,
      "Taşlıca": true,
      "Tepe": true,
      "Turgut": true,
      "Turunç": true,
      "Yeşilbelde": true,
      "Yeşilova": true
    },
    "Menteşe": {
      "Akçaova": true,
      "Akkaya": true,
      "Akyer": true,
      "Algı": true,
      "Avcılar": true,
      "Balıbey": true,
      "Bayır": true,
      "Bozyer": true,
      "Camikebir": true,
      "Çakmak": true,
      "Çamoluk": true,
      "Çatakbağyaka": true,
      "Çaybükü": true,
      "Çırpı": true,
      "Çiftlik": true,
      "Dağdibi": true,
      "Dağpınar": true,
      "Denizova": true,
      "Derinkuyu": true,
      "Doğan": true,
      "Dokuzçam": true,
      "Düğerek": true,
      "Emirbeyazıt": true,
      "Esençay": true,
      "Fadıl": true,
      "Gazeller": true,
      "Göktepe": true,
      "Gülağzı": true,
      "Günlüce": true,
      "Hacırüstem": true,
      "İkizce": true,
      "Kafaca": true,
      "Karacaören": true,
      "Karamehmet": true,
      "Karşıyaka": true,
      "Kıran": true,
      "Kiramettin": true,
      "Kozağaç": true,
      "Kötekli": true,
      "Kuyucak": true,
      "Kuzluk": true,
      "Meke": true,
      "Muratlar": true,
      "Muslihittin": true,
      "Müştakbey": true,
      "Orhaniye": true,
      "Orta": true,
      "Ortaköy": true,
      "Özlüce": true,
      "Paşapınarı": true,
      "Salihpaşalar": true,
      "Sarnıç": true,
      "Sungur": true,
      "Şenyayla": true,
      "Şeyh": true,
      "Taşlı": true,
      "Yaraş": true,
      "Yemişendere": true,
      "Yenibağyaka": true,
      "Yenice": true,
      "Yeniköy": true,
      "Yeniköy (yerkesik)": true,
      "Yerkesik": true,
      "Yeşilyurt": true,
      "Yörükoğlu": true,
      "Zeytin": true
    },
    "Milas": {
      "Ağaçlıhüyük": true,
      "Ahmetçavuş-hayıtlı": true,
      "Akçakaya": true,
      "Akçalı": true,
      "Akkovanlık": true,
      "Akyol": true,
      "Alaçam": true,
      "Alatepe": true,
      "Aslanyaka": true,
      "Avşar": true,
      "Aydınlıkevler": true,
      "Bafa": true,
      "Bağdamları": true,
      "Baharlı": true,
      "Bahçe": true,
      "Bahçeburun": true,
      "Balcılar": true,
      "Bayır": true,
      "Beçin": true,
      "Beyciler": true,
      "Boğaziçi": true,
      "Bozalan": true,
      "Bozbük": true,
      "Burgaz": true,
      "Cumhuriyet": true,
      "Çakıralan": true,
      "Çallı": true,
      "Çamköy": true,
      "Çamlıbelen": true,
      "Çamlıca": true,
      "Çamlıyurt": true,
      "Çamovalı": true,
      "Çandır": true,
      "Çınarlı": true,
      "Çiftlik": true,
      "Çomakdağkızılağaç": true,
      "Çökertme": true,
      "Çukur": true,
      "Damlıboğaz": true,
      "Danişment": true,
      "Demirciler": true,
      "Dere": true,
      "Derince": true,
      "Dibekdere": true,
      "Dörttepe": true,
      "Eğridere": true,
      "Ekinanbarı": true,
      "Ekindere": true,
      "Ekizköy": true,
      "Ekiztaş": true,
      "Emek": true,
      "Epçe": true,
      "Etrenli": true,
      "Fesleğen": true,
      "Firuzpaşa-gazipaşa": true,
      "Gökbel": true,
      "Gökçeler": true,
      "Göldere": true,
      "Gölyaka": true,
      "Güllük": true,
      "Gümüşlük": true,
      "Güneş": true,
      "Günlük": true,
      "Gürceğiz": true,
      "Gürçamlar": true,
      "Hacı Ilyas": true,
      "Hacıabti": true,
      "Hacıahmetler": true,
      "Hasanlar": true,
      "Hisarbaşı-hoca Bedrettin": true,
      "Hisarcık": true,
      "Hüsamlar": true,
      "İçme": true,
      "İsmet Paşa": true,
      "Kafaca": true,
      "Kalem": true,
      "Kalınağıl": true,
      "Kandak": true,
      "Kapıkırı": true,
      "Karacaağaç": true,
      "Karacahisar": true,
      "Karahayıt": true,
      "Karakuyu": true,
      "Karapınar": true,
      "Kargıcak": true,
      "Karşıyaka": true,
      "Kayabaşı": true,
      "Kayabükü": true,
      "Kayadere": true,
      "Kazıklı": true,
      "Kemikler": true,
      "Ketendere": true,
      "Kılavuz": true,
      "Kırcağız": true,
      "Kısırlar": true,
      "Kıyıkışlacık": true,
      "Kızılağaç": true,
      "Kızılcakuyu": true,
      "Kızılcayıkık": true,
      "Konak": true,
      "Koru": true,
      "Korucuk": true,
      "Köşk": true,
      "Kultak": true,
      "Kurudere": true,
      "Kuzyaka": true,
      "Küçükdibekdere": true,
      "Menteş": true,
      "Meşelik": true,
      "Narhisar": true,
      "Olukbaşı": true,
      "Ortaköy": true,
      "Ovakışlacık": true,
      "Ören": true,
      "Pınararası": true,
      "Pınarcık": true,
      "Pinar": true,
      "Sakarkaya": true,
      "Sarıkaya": true,
      "Savran": true,
      "Sek": true,
      "Selimiye": true,
      "Söğütçük": true,
      "Şenköy": true,
      "Şevketiye": true,
      "Tuzabat": true,
      "Türkevleri": true,
      "Ulaş": true,
      "Yaka": true,
      "Yaşyer": true,
      "Yoğunoluk": true,
      "Yusufca": true
    },
    "Ortaca": {
      "Akıncı": true,
      "Arıkbaşı": true,
      "Atatürk": true,
      "Bahçelievler": true,
      "Beşköprü": true,
      "Cumhuriyet": true,
      "Çaylı": true,
      "Dalaklı": true,
      "Dalyan": true,
      "Dereköy": true,
      "Dikmekavak": true,
      "Ekşiliyurt": true,
      "Eskiköy": true,
      "Fevziye": true,
      "Gökbel": true,
      "Gölbaşı": true,
      "Güzelyurt": true,
      "Karaburun": true,
      "Karadonlar": true,
      "Kemaliye": true,
      "Mergenli": true,
      "Okçular": true,
      "Sarıgerme": true,
      "Tepearası": true,
      "Terzialiler": true,
      "Yerbelen": true,
      "Yeşilyurt": true
    },
    "Seydikemer": {
      "Alaçat": true,
      "Arifler": true,
      "Arsaköy": true,
      "Atlıdere": true,
      "Bağlıağaç": true,
      "Bayırköy": true,
      "Bekçiler": true,
      "Belen": true,
      "Boğalar": true,
      "Boğaziçi": true,
      "Ceylan": true,
      "Cumhuriyet": true,
      "Çaltılar": true,
      "Çaltıözü": true,
      "Çamurköy": true,
      "Çatak": true,
      "Çayan": true,
      "Çaykenarı": true,
      "Çobanisa": true,
      "Çobanlar": true,
      "Çökek": true,
      "Çukurincir": true,
      "Demirler": true,
      "Dereköy": true,
      "Dodurga": true,
      "Doğanlar": true,
      "Dont": true,
      "Döğer": true,
      "Eşen": true,
      "Gerişburnu": true,
      "Girmeler": true,
      "Gölbent": true,
      "Güneşli": true,
      "Hacıosmanlar": true,
      "İzzettinköy": true,
      "Kabaağaç": true,
      "Kadıköy": true,
      "Karadere": true,
      "Karaköy": true,
      "Kayabaşı": true,
      "Kayacık": true,
      "Kayadibi": true,
      "Kıncılar": true,
      "Kınık": true,
      "Korubükü": true,
      "Kumluova": true,
      "Menekşe": true,
      "Minare": true,
      "Ortaköy": true,
      "Ören": true,
      "Paşalı": true,
      "Sahilceylan": true,
      "Sarıyer": true,
      "Seki": true,
      "Seydiler": true,
      "Söğütlüdere": true,
      "Temel": true,
      "Uğurlu": true,
      "Yakabağ": true,
      "Yakaköy": true,
      "Yayla Eldirek": true,
      "Yayla Gökben": true,
      "Yayla Karaçulha": true,
      "Yaylapatlangıç": true,
      "Zorlar": true
    },
    "Ula": {
      "Akçapınar": true,
      "Akyaka": true,
      "Alparslan": true,
      "Arıcılar": true,
      "Armutcuk": true,
      "Ataköy": true,
      "Ayazkıyı": true,
      "Çıtlık": true,
      "Çiçekli": true,
      "Çörüş": true,
      "Demirtaş": true,
      "Elmalı": true,
      "Esentepe": true,
      "Gökçe": true,
      "Gökova": true,
      "Gölcük": true,
      "Karabörtlen": true,
      "Kavakçalı": true,
      "Kıra": true,
      "Kızılağaç": true,
      "Kızılyaka": true,
      "Köprübaşı": true,
      "Örnekköy": true,
      "Portakallık": true,
      "Sarayyanı": true,
      "Şirinköy": true,
      "Turgut": true,
      "Yaylasöğüt": true,
      "Yeşilçam": true,
      "Yeşilova": true
    },
    "Yatağan": {
      "Akgedik": true,
      "Akyol": true,
      "Alaşar": true,
      "Atatürk": true,
      "Bağyaka": true,
      "Bahçeyaka": true,
      "Bencik": true,
      "Bozarmut": true,
      "Bozüyük": true,
      "Cazkırlar": true,
      "Cumhuriyet": true,
      "Çakırlar": true,
      "Çamlıca": true,
      "Çukuröz": true,
      "Dere": true,
      "Deştin": true,
      "Doğanköy": true,
      "Elmacık": true,
      "Esenköy": true,
      "Eskihisar": true,
      "Gökgedik": true,
      "Gökpınar": true,
      "Hacıbayramlar": true,
      "Hacıveliler": true,
      "Hisarardı": true,
      "Kadıköy": true,
      "Kafacakaplancık": true,
      "Kapubağ": true,
      "Katrancı": true,
      "Kavak": true,
      "Kırıkköy": true,
      "Konak": true,
      "Kozağaç": true,
      "Köklük": true,
      "Madenler": true,
      "Mesken": true,
      "Nebiköy": true,
      "Şahinler": true,
      "Şeref": true,
      "Turgut": true,
      "Turgutlar": true,
      "Yava": true,
      "Yayla": true,
      "Yeni": true,
      "Yenikarakuyu": true,
      "Yeniköy": true,
      "Yeşilbağcılar": true,
      "Yeşilköy": true,
      "Yukarıyayla": true,
      "Zeytinköy": true
    }
  },
  "Muş": {
    "Bulanık": {
      "Abdalbeyazıt": true,
      "Alagez": true,
      "Arı": true,
      "Bağlar": true,
      "Bahçelievler": true,
      "Cumhuriyet": true,
      "Çimen": true,
      "Fatih": true,
      "Gazi": true,
      "Gülçimen": true,
      "Güllüova": true,
      "Hanedan": true,
      "Hürriyet": true,
      "İnönü": true,
      "Kale": true,
      "Karşıyaka": true,
      "Kültür": true,
      "Mescitli": true,
      "Pınar": true,
      "Sinan": true,
      "Şehitlik": true,
      "Yeni": true,
      "Zafer": true
    },
    "Hasköy": {
      "15 Temmuz": true,
      "Bahçelievler": true,
      "Hürriyet": true,
      "İstiklal": true,
      "Kültür": true,
      "Sayanlar": true,
      "Sunay": true,
      "Vatan": true,
      "Yeni": true,
      "Zafer": true
    },
    "Korkut": {
      "Adnan Menderes": true,
      "Aydınlar": true,
      "Bahçelievler": true,
      "Kültür": true,
      "Merkez": true,
      "Şehitler": true,
      "Turgut Özal": true,
      "Yeni": true
    },
    "Malazgirt": {
      "Adalar": true,
      "Afşin": true,
      "Aksungur": true,
      "Alişan": true,
      "Altuntaş": true,
      "Atatürk": true,
      "Danışmentgazi": true,
      "Mengüçgazi": true,
      "Murat": true,
      "Saftekingazi": true,
      "Saltukgazi": true,
      "Selçuklu": true,
      "Şekerbulak": true,
      "Yeni": true,
      "Ziyaret": true
    },
    "Merkez": {
      "15 Temmuz Milli Irade": true,
      "Aydıngün": true,
      "Bağlar": true,
      "Bahçelievler": true,
      "Bakırcılar": true,
      "Çağdaş": true,
      "Çubuklu": true,
      "Dagarası": true,
      "Dere": true,
      "Düz": true,
      "Fetullahağa": true,
      "Güzeltepe": true,
      "Hürriyet": true,
      "Kale": true,
      "Kardesler": true,
      "Karsıyaka": true,
      "Karşıyaka": true,
      "Körpeağaç": true,
      "Kültür": true,
      "Merkez": true,
      "Minare": true,
      "Muratpaşa": true,
      "Saray": true,
      "Sunay": true,
      "Sütlüce": true,
      "Şehit Naim Çiftçi": true,
      "Şehit Yücel Kurtoğlu": true,
      "Şirinevler": true,
      "Yeni": true,
      "Yeroluk": true,
      "Yeşilce": true,
      "Yeşilyurt": true,
      "Zafer": true
    },
    "Varto": {
      "Alagöz": true,
      "Bahçelievler": true,
      "Gümgüm": true,
      "Hürriyet": true,
      "İnönü": true,
      "Kültür": true,
      "Yeni": true
    }
  },
  "Nevşehir": {
    "Acıgöl": {
      "Bahçeli": true,
      "Bahçeli Evler": true,
      "Ballık": true,
      "Cumhuriyet": true,
      "Çayırlık": true,
      "Kale": true,
      "Mustafapaşa": true,
      "Yukarı": true
    },
    "Avanos": {
      "50.yıl": true,
      "Alaaddin": true,
      "Aşağı": true,
      "Bahçelievler": true,
      "Cami-kebir": true,
      "Camicedit": true,
      "Cumhuriyet": true,
      "Hürriyet": true,
      "Karaseki": true,
      "Karayusuf": true,
      "Orta": true,
      "Yeni": true,
      "Yukarı": true
    },
    "Derinkuyu": {
      "Alparslan": true,
      "Baş": true,
      "Bayramlı": true,
      "Bozkır": true,
      "Cumhuriyet": true,
      "Demirci": true,
      "Esentepe": true,
      "Fatih": true,
      "Göktürk": true,
      "Namık Kemal": true,
      "Polatkan": true,
      "Yeni": true
    },
    "Gülşehir": {
      "Açıksaray": true,
      "Cumhuriyet": true,
      "Çalışanlar": true,
      "Çayır": true,
      "Erol Ünlüsoy": true,
      "Fatih": true,
      "Karacaşar": true,
      "Karavezir": true,
      "Oruçreis": true,
      "Tuzköyü": true
    },
    "Hacıbektaş": {
      "Bala": true,
      "Savat": true,
      "Zir": true
    },
    "Kozaklı": {
      "Altunsu": true,
      "Bağlıca": true,
      "Bahçelievler": true,
      "Buruncuk": true,
      "Emek": true,
      "Hamamorta": true,
      "Hoca Ahmet Yesevi": true,
      "Kızılkoyunlu": true,
      "Yabanlı": true,
      "Yeni": true
    },
    "Merkez": {
      "15 Temmuz": true,
      "20 Temmuz": true,
      "2000 Evler": true,
      "350 Evler": true,
      "Afetevleri": true,
      "Aşağı": true,
      "Aydınlı-orta": true,
      "Bahçelievler": true,
      "Baş": true,
      "Bekdik": true,
      "Bekirağa": true,
      "Camicedit": true,
      "Camikebir": true,
      "Cevher Dudayev": true,
      "Cumhuriyet": true,
      "Emek": true,
      "Esentepe": true,
      "Fatih Sultan Mehmet": true,
      "Güzelyurt": true,
      "Hacırüştü": true,
      "Hatipoğlu": true,
      "Herikli": true,
      "İbrahimpaşa": true,
      "İsali-gaferli-avcılar": true,
      "İstiklal": true,
      "Kapucubaşı": true,
      "Karasoku": true,
      "Kasapoğlu": true,
      "Kıratlıoğlu": true,
      "M.akif Ersoy": true,
      "Orta": true,
      "Raşitbey": true,
      "Sultan Aladdin": true,
      "Sümer": true,
      "Tekelli": true,
      "Yeni": true,
      "Yukarı": true
    },
    "Ürgüp": {
      "15 Temmuz": true,
      "Aksalur Ağcaşar": true,
      "Aksalur Salur": true,
      "Bahçelievler": true,
      "Cumhuriyet": true,
      "Duayeri": true,
      "Esentepe": true,
      "Eski": true,
      "Evka": true,
      "Fatih": true,
      "Kavaklıönü": true,
      "Temenni": true,
      "Yeni": true
    }
  },
  "Niğde": {
    "Altunhisar": {
      "Aşağı": true,
      "Cumhuriyet": true,
      "Erenler": true,
      "İstiklal": true,
      "Orta": true,
      "Sağlık": true,
      "Selçuk": true,
      "Yaka": true,
      "Yeni": true,
      "Yukarı": true
    },
    "Bor": {
      "Acıgöl": true,
      "Ahmet Kuddusi": true,
      "Başpınar": true,
      "Bektik": true,
      "Buğdüz": true,
      "Cami": true,
      "Cığızoğlu Osman Efendi": true,
      "Cumhuriyet": true,
      "Çayır": true,
      "Fatih": true,
      "Han": true,
      "İftiyan": true,
      "Kemer": true,
      "Saray": true,
      "Selçuk": true,
      "Şeker": true,
      "Tepe": true,
      "Toplu Konut": true,
      "Türkmen Yurdu": true,
      "Yeni Harım": true,
      "Zafer": true
    },
    "Çamardı": {
      "Bereketli": true,
      "Maden": true
    },
    "Çiftlik": {
      "Alpaslan": true,
      "Asmasız": true,
      "Çarşı": true,
      "Çayır": true,
      "Çiftçi": true,
      "Fatih": true,
      "Küllüce": true,
      "Sağırgöl": true,
      "Yeni": true,
      "Yenice": true,
      "Yenikent": true,
      "Yeşilkent": true,
      "Yeşilyurt": true
    },
    "Merkez": {
      "Aşağı": true,
      "Aşağı Kayabaşı": true,
      "Bahçelievler": true,
      "Cumhuriyet": true,
      "Devlet": true,
      "Dumlupınar": true,
      "Efendibey": true,
      "Eski Gümüş": true,
      "Fatih": true,
      "Fertek": true,
      "Fevzipaşa": true,
      "Hürriyet": true,
      "Hüyük": true,
      "İlhanlı": true,
      "İnönü": true,
      "Kale": true,
      "Kayaardı": true,
      "Kumluca": true,
      "Milliyet": true,
      "Nar": true,
      "Orta": true,
      "Sarıköprü": true,
      "Selçuk": true,
      "Şahsüleyman": true,
      "Şehitler": true,
      "Yavuz": true,
      "Yeni": true,
      "Yeni Gümüş": true,
      "Yenice": true,
      "Yukarı": true,
      "Yukarı Kayabaşı": true,
      "Zafer": true
    },
    "Ulukışla": {
      "Alpağut": true,
      "Kemalpaşa": true
    }
  },
  "Ordu": {
    "Akkuş": {
      "Akpınar": true,
      "Alan": true,
      "Ambargürgen": true,
      "Ceyhanlı": true,
      "Çaldere": true,
      "Çamalan": true,
      "Çamlıca": true,
      "Çavdar": true,
      "Çayıralan": true,
      "Çökek": true,
      "Çukurköy": true,
      "Dağyolu": true,
      "Damyeri": true,
      "Düğencili": true,
      "Esentepe": true,
      "Gedikli": true,
      "Gökçebayır": true,
      "Gürgenliyatak": true,
      "Haliluşağı": true,
      "Karaçal": true,
      "Kargı": true,
      "Kemikgeriş": true,
      "Ketendere": true,
      "Kızılelma": true,
      "Koçcuvaz": true,
      "Kurtboğaz": true,
      "Kuşçulu": true,
      "Külekçili": true,
      "Merkez": true,
      "Meyvalı": true,
      "Muratlı": true,
      "Ormancık": true,
      "Ortabölme": true,
      "Salman": true,
      "Seferli": true,
      "Subaşı": true,
      "Şahinköy": true,
      "Tuzakköy": true,
      "Yazlıkbelen": true,
      "Yeni": true,
      "Yeşilgüneycik": true,
      "Yeşilköy": true,
      "Yolbaşı": true,
      "Yukarıdüğencili": true
    },
    "Altınordu": {
      "Akçatepe": true,
      "Akkise": true,
      "Akyazı": true,
      "Alembey": true,
      "Alınca": true,
      "Alisayvan": true,
      "Altunyurt": true,
      "Arpaköy": true,
      "Artıklı": true,
      "Ataköy": true,
      "Aydınlık": true,
      "Aziziye": true,
      "Bahariye": true,
      "Bahçelievler": true,
      "Bayadı": true,
      "Bayramlı": true,
      "Boztepe": true,
      "Bucak": true,
      "Burhanettinköy": true,
      "Cumhuriyet": true,
      "Cumhuriyet (köy)": true,
      "Çavuşlar": true,
      "Dedeli": true,
      "Delikkaya": true,
      "Dikence": true,
      "Durugöl": true,
      "Düz": true,
      "Düzköy": true,
      "Emen": true,
      "Erenli": true,
      "Eskipazar": true,
      "Eyüplü": true,
      "Gerce": true,
      "Gökömer": true,
      "Gümüşköy": true,
      "Günören": true,
      "Güzelyalı": true,
      "Güzelyalı (uzunisa)": true,
      "Hacılar": true,
      "Hatipli": true,
      "Hürriyet": true,
      "Işıklı": true,
      "Karaağaç": true,
      "Karacaömer": true,
      "Karaoluk": true,
      "Karapınar": true,
      "Karşıyaka": true,
      "Kayabaşı": true,
      "Kayadibi": true,
      "Kısacık": true,
      "Kızılhisar": true,
      "Kirazlimanı": true,
      "Kovancı": true,
      "Kökenli": true,
      "Kumbaşı": true,
      "Kurtulmuş": true,
      "Kuylu": true,
      "Mubarek": true,
      "Nizamettin": true,
      "Oğmaca": true,
      "Orhaniye": true,
      "Ortaköy": true,
      "Osmaniye": true,
      "Öceli": true,
      "Örencik": true,
      "Övündük": true,
      "Pelitli": true,
      "Sağırlı": true,
      "Saray": true,
      "Saraycık": true,
      "Selimiye": true,
      "Subaşı": true,
      "Şahincili": true,
      "Şarkiye": true,
      "Şenköy": true,
      "Şenocak": true,
      "Şirinevler": true,
      "Taşbaşı": true,
      "Terzili": true,
      "Teyneli": true,
      "Topluca": true,
      "Uzunisa": true,
      "Uzunmusa": true,
      "Yağızlı": true,
      "Yaraşlı": true,
      "Yemişli": true,
      "Yeni": true,
      "Yeşilköy": true,
      "Yıldızlı": true,
      "Yukarıtepe": true,
      "Zafer": true,
      "Zaferimilli": true
    },
    "Aybastı": {
      "Alacalar": true,
      "Armutlu": true,
      "Beştam": true,
      "Çakırlı": true,
      "Çukur": true,
      "Esenli": true,
      "Fatih": true,
      "Hisarcık": true,
      "Karamanlı": true,
      "Kayabaşı": true,
      "Koyunculu": true,
      "Kutlular": true,
      "Küçükyaka": true,
      "Ortaköy": true,
      "Pelitözü": true,
      "Sağlık": true,
      "Sarıyar": true,
      "Sefalık": true,
      "Toygar": true,
      "Uzundere": true,
      "Zaferimilli": true
    },
    "Çamaş": {
      "Akköy": true,
      "Akpınar": true,
      "Budak": true,
      "Burhan Güneyi": true,
      "Çavuşbaşı": true,
      "Danışman": true,
      "Edirli": true,
      "Giden": true,
      "Gümüşlü": true,
      "Hisarbey": true,
      "Kemal Paşa": true,
      "Kestaneyokuşu": true,
      "Kocaman": true,
      "Örmeli": true,
      "Sakargeriş": true,
      "Sarıyakup": true,
      "Söken": true,
      "Sucuali": true,
      "Taşoluk": true,
      "Tepeli": true,
      "Uzunali": true,
      "Yeni": true,
      "Yeşilvadi": true
    },
    "Çatalpınar": {
      "Akkaya": true,
      "Dere": true,
      "Elmaköy": true,
      "Göller": true,
      "Gündoğdu": true,
      "Güney": true,
      "Güneyce": true,
      "Haşal": true,
      "Hatipler": true,
      "İncirli": true,
      "Karahamza": true,
      "Karahasan": true,
      "Karşıyaka": true,
      "Kayatepe": true,
      "Keçili": true,
      "Kıran": true,
      "Madenköy": true,
      "Merkez": true,
      "Ortaköy": true,
      "Sayacatürk": true,
      "Şirinköy": true,
      "Terimli": true,
      "Yeni": true
    },
    "Çaybaşı": {
      "Akbaba": true,
      "Aşıklı Çakıllı": true,
      "Boras": true,
      "Cemallı": true,
      "Cevizliyatak": true,
      "Çağlayan": true,
      "Çandır": true,
      "Çay": true,
      "Çayır": true,
      "Çınar": true,
      "Eğribel": true,
      "Göksu": true,
      "Gürcek": true,
      "Hacıali": true,
      "İçeribükü": true,
      "İlküvez": true,
      "Kapılı": true,
      "Kargalı": true,
      "Köklük": true,
      "Kurudere": true,
      "Kuşlu": true,
      "Mollalı": true,
      "Namazlı": true,
      "Taşkesiği": true,
      "Tekke": true,
      "Yenicuma": true
    },
    "Fatsa": {
      "Ahmetler": true,
      "Arpalık": true,
      "Aslancami": true,
      "Aşağıardıç": true,
      "Aşağıtepe": true,
      "Aşağıyavaş": true,
      "Ayazlı": true,
      "Bacanak": true,
      "Bağlarca": true,
      "Bahçeler": true,
      "Başköy": true,
      "Beyceli": true,
      "Bolaman": true,
      "Bozdağı": true,
      "Bucaklı": true,
      "Buhari": true,
      "Bülbül": true,
      "Büyükkoç": true,
      "Çömlekli": true,
      "Çötelü": true,
      "Demirci": true,
      "Dereyurt": true,
      "Dolunay": true,
      "Duayeri": true,
      "Dumlupınar": true,
      "Düğünlük": true,
      "Eskiordu": true,
      "Evkaf": true,
      "Fatih": true,
      "Geyikçeli": true,
      "Gölköy": true,
      "Güvercinlik": true,
      "Hacıköy": true,
      "Hamlık": true,
      "Hatipli": true,
      "Hıdırbeyli": true,
      "Hoylu": true,
      "Ilıca": true,
      "İnönü": true,
      "İslamdağ": true,
      "Kabakdağı": true,
      "Kaleönü": true,
      "Karataş": true,
      "Kargucak": true,
      "Karşıyaka": true,
      "Kavraz": true,
      "Kayaca": true,
      "Kayaköy Akçakese": true,
      "Kılavuzömer": true,
      "Kılıçlı": true,
      "Konakbaşı": true,
      "Kösebucağı": true,
      "Kulak": true,
      "Kurtuluş": true,
      "Küçükkoç": true,
      "Küpdüşen": true,
      "Mehmetakif": true,
      "Meşebükü": true,
      "Mustafakemalpaşa": true,
      "Oluklu": true,
      "Örencik": true,
      "Palazlı Kömürlük": true,
      "Sakarya": true,
      "Salihli": true,
      "Saraytepe": true,
      "Sazcılar": true,
      "Sefaköy": true,
      "Sudere": true,
      "Şerefiye": true,
      "Tahtabaş": true,
      "Taşlıca": true,
      "Tayalı": true,
      "Tepecik": true,
      "Uzundere": true,
      "Yalıköy": true,
      "Yapraklı": true,
      "Yassıbahçe": true,
      "Yassıtaş": true,
      "Yavaş": true,
      "Yenidoğan": true,
      "Yenikent": true,
      "Yenipazar": true,
      "Yeniyurt": true,
      "Yeşilköy": true,
      "Yeşiltepe": true,
      "Yukarıardıç": true,
      "Yukarıbahçeler": true,
      "Yukarıtepe": true,
      "Yusuflu": true
    },
    "Gölköy": {
      "Ahmetli": true,
      "Akçalı": true,
      "Alanyurt": true,
      "Aydoğan": true,
      "Bayıralan": true,
      "Bulut": true,
      "Cihadiye": true,
      "Çatak": true,
      "Çetilli": true,
      "Damarlı": true,
      "Direkli": true,
      "Düzyayla": true,
      "Emirler": true,
      "Gölköy": true,
      "Güzelyayla": true,
      "Güzelyurt": true,
      "Haruniye": true,
      "Hürriyet": true,
      "İçyaka": true,
      "Kale": true,
      "Karagöz": true,
      "Karahasan": true,
      "Konak": true,
      "Kozören": true,
      "Kuşluvan": true,
      "Özlü": true,
      "Paşapınar": true,
      "Sarıca": true,
      "Süleymaniye": true,
      "Yuvapınar": true
    },
    "Gülyalı": {
      "Alibey": true,
      "Ambarcılı": true,
      "Ayrılık": true,
      "Gülistan": true,
      "Hoşköy": true,
      "Kestane": true,
      "Mustafalı": true,
      "Sayaca": true,
      "Taşlıçay": true,
      "Tepealtı": true,
      "Turnasuyu": true,
      "Ürümbey": true,
      "Yeniköy": true
    },
    "Gürgentepe": {
      "Ağızlar": true,
      "Akmescit": true,
      "Akören": true,
      "Akyurt": true,
      "Alaseher": true,
      "Bahtiyarlar": true,
      "Cumhuriyet": true,
      "Çatalağaç": true,
      "Döşek": true,
      "Eskiköy": true,
      "Göller": true,
      "Gülbelen": true,
      "Gültepe": true,
      "Hasancık": true,
      "Işıktepe": true,
      "Muratçık": true,
      "Okçabel": true,
      "Şirinköy": true,
      "Tepeköy": true,
      "Tikenlice": true,
      "Tuzla": true,
      "Yurtseven": true,
      "Yurtyeri": true
    },
    "İkizce": {
      "Ağcaalan": true,
      "Aşağı Karlıtepe": true,
      "Aşağı Kaynartaş": true,
      "Başönü": true,
      "Beylerce": true,
      "Bolluk": true,
      "Derebaşı": true,
      "Devecik": true,
      "Diyek": true,
      "Dumantepe": true,
      "Düzmeşe": true,
      "Düzpelit": true,
      "Enağızlı": true,
      "Esentepe": true,
      "Fatih": true,
      "Gaziler": true,
      "Kale": true,
      "Kervansaray": true,
      "Kiraztepe": true,
      "Kocaman": true,
      "Kurtköy": true,
      "Kurtluca": true,
      "Merkez": true,
      "Özpınar": true,
      "Seymenli": true,
      "Şentepe": true,
      "Tombaşlı": true,
      "Yenice": true,
      "Yoğunoluk": true,
      "Yukarı Karlıtepe": true,
      "Yukarı Kaynartaş": true,
      "Yunuskırığı": true
    },
    "Kabadüz": {
      "Akgüney": true,
      "Başköy": true,
      "Derinçay": true,
      "Dişkaya": true,
      "Esenyurt": true,
      "Gelinkaya": true,
      "Gülpınar": true,
      "Gümüşdere": true,
      "Harami": true,
      "Kabadüz": true,
      "Karakiraz": true,
      "Kirazdere": true,
      "Musakırık": true,
      "Özlükent": true,
      "Turnalık": true,
      "Yeşilada": true,
      "Yeşilyurt": true,
      "Yokuşdibi": true,
      "Yukarı Kirazdere": true
    },
    "Kabataş": {
      "Alanbaşı": true,
      "Alankent": true,
      "Ardıç": true,
      "Belen": true,
      "Beylerli": true,
      "Çukurcak": true,
      "Düz": true,
      "Eceli": true,
      "Elbeyi": true,
      "Hoşkadem": true,
      "Ilıcak": true,
      "Kabataş Yeni": true,
      "Kayıncık": true,
      "Kuzköy": true,
      "Merkez": true,
      "Şifa Suyu": true,
      "Yakacık": true,
      "Yeniceli": true
    },
    "Korgan": {
      "Aşağıkozpınar": true,
      "Aşağıyaylacık": true,
      "Belalan": true,
      "Beypınarı": true,
      "Büyükakçakese": true,
      "Çamlı": true,
      "Çayırkent": true,
      "Çiftlik": true,
      "Çitlice": true,
      "Dip": true,
      "Durali": true,
      "Karakışla": true,
      "Karakoyunlu": true,
      "Koçcuğaz": true,
      "Sarıalıç": true,
      "Soğukpınar": true,
      "Tatarcık": true,
      "Tepe": true,
      "Tepealan": true,
      "Terzili": true,
      "Yazıcı": true,
      "Yazlık": true,
      "Yeniköy": true,
      "Yenipınar": true,
      "Yeşilalan": true,
      "Yeşildere": true,
      "Yeşilyurt": true,
      "Yukarıkozpınar": true,
      "Yukarıyaylacık": true
    },
    "Kumru": {
      "Ağcaalantürk": true,
      "Akçadere": true,
      "Avdullu": true,
      "Ayvalı": true,
      "Balı": true,
      "Ballık": true,
      "Çatılı": true,
      "Demircili": true,
      "Derbent": true,
      "Dereköy": true,
      "Divanıtürk": true,
      "Duman": true,
      "Ergentürk": true,
      "Erikçeli": true,
      "Esence": true,
      "Eskiçokdeğirmen": true,
      "Fatih": true,
      "Fizme": true,
      "Gökçeli": true,
      "Güneycik": true,
      "Kadıncık": true,
      "Karaağaç": true,
      "Karacalar": true,
      "Karacalı": true,
      "Kayabaşı": true,
      "Konaklı": true,
      "Kovancılı": true,
      "Kurtuluş": true,
      "Küçükakçakese": true,
      "Ortaca": true,
      "Ortaçokdeğirmen": true,
      "Samur": true,
      "Şenyurt": true,
      "Tekkeköy": true,
      "Yalnızdam": true,
      "Yemişken": true,
      "Yeniakçaalan": true,
      "Yenidivan": true,
      "Yeniergen": true,
      "Yukarıdamlalı": true
    },
    "Mesudiye": {
      "Abdili": true,
      "Akkırık": true,
      "Akpınar": true,
      "Alan": true,
      "Arıcılar": true,
      "Arıkmusa": true,
      "Armutkolu": true,
      "Arpaalan": true,
      "Aşağıgökçe": true,
      "Aşıklı": true,
      "Bahçe": true,
      "Balıklı": true,
      "Bayırköy": true,
      "Bayraklı": true,
      "Beşpınar": true,
      "Beyağaç": true,
      "Beyseki": true,
      "Birebir": true,
      "Celal": true,
      "Çaltepe": true,
      "Çardaklı": true,
      "Çavdar": true,
      "Çerçi": true,
      "Çitliksarıca": true,
      "Çukuralan": true,
      "Darıcabaşı": true,
      "Dayılı": true,
      "Derebaşı": true,
      "Doğançam": true,
      "Dursunlu": true,
      "Erikköy": true,
      "Esatlı": true,
      "Göçbeyi": true,
      "Gölbaşı": true,
      "Gülpınar": true,
      "Güneyce": true,
      "Güvenli": true,
      "Güzelce": true,
      "Güzle": true,
      "Hamzalı": true,
      "Herközü": true,
      "Ilışar": true,
      "Kale": true,
      "Karabayır": true,
      "Karacaören": true,
      "Kavaklıdere": true,
      "Kayadibi": true,
      "Kışlacık": true,
      "Konacık": true,
      "Köşe": true,
      "Mahmudiye": true,
      "Maksutalan": true,
      "Merkez": true,
      "Musalı": true,
      "Müslüm Sarıca": true,
      "Pınarlı": true,
      "Sarıca": true,
      "Sarıyayla": true,
      "Topçam": true,
      "Türkköyü": true,
      "Üçyol": true,
      "Yağmurlar": true,
      "Yardere": true,
      "Yavşan": true,
      "Yenimahalle": true,
      "Yeşilce": true,
      "Yeşilçit": true,
      "Yeveli": true,
      "Yukarıgökçe": true,
      "Yuvalı": true
    },
    "Perşembe": {
      "Alınca": true,
      "Anaç": true,
      "Aziziye": true,
      "Babalı": true,
      "Bekirli": true,
      "Beyli": true,
      "Boğazcık": true,
      "Bolatlı": true,
      "Çamarası": true,
      "Çandır": true,
      "Çaytepe": true,
      "Çerli": true,
      "Çınar": true,
      "Dereiçi": true,
      "Doğan": true,
      "Düz": true,
      "Efirli": true,
      "Ekinciler": true,
      "Gündoğdu": true,
      "Güzelyurt": true,
      "Hacılar": true,
      "Hamidiye": true,
      "İmeçli": true,
      "İstanbulboğazı": true,
      "Kacalı": true,
      "Kaleyaka": true,
      "Kazancılı": true,
      "Kırlı": true,
      "Kovanlı": true,
      "Kozağzı": true,
      "Kurtuluş": true,
      "Kutluca": true,
      "Kuyluca": true,
      "Medreseönü": true,
      "Mersin": true,
      "Neneli": true,
      "Okçulu": true,
      "Ortatepe": true,
      "Ramazan": true,
      "Saray": true,
      "Selimiye": true,
      "Sırakovancı": true,
      "Soğukpınar": true,
      "Şenyurt": true,
      "Tarlacık": true,
      "Tepecik": true,
      "Tepeköy": true,
      "Töngeldüzü": true,
      "Yarlı": true,
      "Yazlık": true,
      "Yeniköy": true,
      "Yeniöz": true,
      "Yeşilköy": true,
      "Yumrutaş": true
    },
    "Ulubey": {
      "Akoluk": true,
      "Akpınar": true,
      "Aydınlar": true,
      "Başçardak": true,
      "Belenyurt": true,
      "Cevizlik": true,
      "Çağlayan": true,
      "Çatallı": true,
      "Çubuklu": true,
      "Çukur": true,
      "Doğlu": true,
      "Durak": true,
      "Elmaçukur": true,
      "Eymür": true,
      "Fındıklı": true,
      "Gündüzlü": true,
      "Güvenköy": true,
      "Güvenyurt": true,
      "Güzelyurt": true,
      "Hocaoğlu": true,
      "Kadıncık": true,
      "Kalıcak": true,
      "Karakoca": true,
      "Kardeşler": true,
      "Kıranyağmur": true,
      "Kirazlık": true,
      "Koşaca": true,
      "Kumanlar": true,
      "Kumrulu": true,
      "Ohtamış": true,
      "Oyumgürgen": true,
      "Ören": true,
      "Refahiye": true,
      "Şahinkaya": true,
      "Şekeroluk": true,
      "Şıhlar": true,
      "Uzunmahmut": true,
      "Yenimahalle": true,
      "Yenisayaca": true,
      "Yolbaşı": true,
      "Yukarıkızılen": true
    },
    "Ünye": {
      "Ağıdere": true,
      "Ataköy": true,
      "Atatürk": true,
      "Aydıntepe": true,
      "Başköy": true,
      "Bayramca": true,
      "Beylerce": true,
      "Burunucu": true,
      "Cevizdere": true,
      "Çakmak": true,
      "Çamurlu": true,
      "Çatak": true,
      "Çatalpınar": true,
      "Çataltepe": true,
      "Çınarcık": true,
      "Çınarlık": true,
      "Çiğdem": true,
      "Denizbükü": true,
      "Dereköy": true,
      "Dizdar": true,
      "Döşemedibi": true,
      "Düzköy": true,
      "Düzsaylan": true,
      "Elmalık": true,
      "Erenyurt": true,
      "Esenkale": true,
      "Eskikızılcakese": true,
      "Fatih": true,
      "Fevzi Çakmak": true,
      "Göbü": true,
      "Gölcüğez": true,
      "Gölevi": true,
      "Günpınarı": true,
      "Gürecülü": true,
      "Güzelkale": true,
      "Güzelyalı": true,
      "Hamidiye": true,
      "Hanyanı": true,
      "Hızabaşıgünlük": true,
      "Hızarbaşıkumarlı": true,
      "İnkur": true,
      "İpekyolu": true,
      "Kadılar": true,
      "Kale": true,
      "Kaledere": true,
      "Kaledibi": true,
      "Karşıyaka": true,
      "Keş": true,
      "Killik": true,
      "Kocuklu": true,
      "Kuşçulu": true,
      "Kuşdoğan": true,
      "Liseler": true,
      "Nadırlı": true,
      "Nurettin": true,
      "Nuriye": true,
      "Orta Yılmazlar": true,
      "Ortaköy": true,
      "Pelitliyatak": true,
      "Pınarbaşı": true,
      "Sahilköy": true,
      "Saraçlı": true,
      "Saraycık": true,
      "Sarıhalil": true,
      "Saylan": true,
      "Sofutepesi": true,
      "Şenyurt": true,
      "Taflancık": true,
      "Taşça": true,
      "Tekkiraz": true,
      "Tepeköy": true,
      "Uğurlu": true,
      "Üçpınar": true,
      "Yavı": true,
      "Yaycı": true,
      "Yaylalı": true,
      "Yazkonağı": true,
      "Yenikent": true,
      "Yenikızılcakese": true,
      "Yeniköy": true,
      "Yeşilada": true,
      "Yeşilkent": true,
      "Yiğitler": true,
      "Yunus Emre": true,
      "Yüceler": true
    }
  },
  "Osmaniye": {
    "Bahçe": {
      "Aslanlı": true,
      "Bahçeli Evler": true,
      "Cumhuriyet": true,
      "Çamlıca": true,
      "Esentepe": true,
      "İslam": true,
      "İstiklal": true,
      "Kale": true,
      "Karşıyaka": true,
      "Yenı": true,
      "Yeşil Yurt": true
    },
    "Düziçi": {
      "Aydınlar": true,
      "Boğaziçi": true,
      "Boyalı": true,
      "Celiller": true,
      "Cumhuriyet": true,
      "Çamiçi": true,
      "Çevlik": true,
      "Çiftlik": true,
      "Çiraz": true,
      "Çukuroba": true,
      "Demirciler": true,
      "Dümbürdek": true,
      "Ellek": true,
      "Gökyıldız": true,
      "Hürriyet": true,
      "İrfanlı": true,
      "İstiklal": true,
      "Karacaoğlan": true,
      "Karacaören": true,
      "Karaçarlı": true,
      "Karkın": true,
      "Karlıca": true,
      "Karşıyaka": true,
      "Katobası": true,
      "Kurtbeyoğlu": true,
      "Kurtuluş": true,
      "Kürt Mahmutlar": true,
      "Merkez": true,
      "Peçenek": true,
      "Soylar": true,
      "Şehit Ali Gökçe": true,
      "Şehit Asker Kemal Keskin": true,
      "Şehit Hüseyin Sarı": true,
      "Uzun Banı": true,
      "Üzümlü": true,
      "Yenice Haruniye": true,
      "Yeşil Yurt": true,
      "Yeşilova": true,
      "Yukarı Hacılar": true,
      "Yüzüncü Yıl": true
    },
    "Hasanbeyli": {
      "Cumhuriyet": true,
      "Hürriyet": true,
      "Merkez": true,
      "Yeşilyurt": true
    },
    "Kadirli": {
      "7 Mart": true,
      "Bağ": true,
      "Cemalpaşa": true,
      "Cengiz Topel": true,
      "Dere": true,
      "Dervişpaşa": true,
      "Kurtuluş": true,
      "Pazar": true,
      "Savrun": true,
      "Şehit Halis Şişman": true,
      "Şehit Ibrahim Kundakçı": true,
      "Şehit Kansu Küçükateş": true,
      "Şehit Mehmet Delikuş": true,
      "Şehit Mehmet Hallaç": true,
      "Şehit Mustafa Yağız": true,
      "Şehit Orhan Gök": true,
      "Şehit Vedat  Kocadallı": true,
      "Tufanpaşa": true,
      "Yeni": true,
      "Yeşiltepe": true
    },
    "Merkez": {
      "Adnan Menderes": true,
      "Ahmet Yesevi": true,
      "Akyar": true,
      "Ali Bekirli": true,
      "Alibeyli": true,
      "Baş": true,
      "Cumhuriyet": true,
      "Dr.ihsan Göknal": true,
      "Dumlupınar": true,
      "Esenevler": true,
      "Eyüp Sultan": true,
      "Fakıuşağı": true,
      "Fatih": true,
      "Gebeli": true,
      "Hacı Osmanlı": true,
      "Haraz": true,
      "İstiklal": true,
      "Karacay": true,
      "Karataş": true,
      "Kazım Karabekir": true,
      "Kocatepe": true,
      "Korkut Ata": true,
      "Kurtuluş": true,
      "M.akif Ersoy": true,
      "M.fevzi Çakmak": true,
      "Mevlana": true,
      "Mimar Sinan": true,
      "Rahime Hatun": true,
      "Raufbey": true,
      "Rızaiye": true,
      "Selimiye": true,
      "Şirinevler": true,
      "Ulaşlı": true,
      "Vatan": true,
      "Yaverpaşa": true,
      "Yedi Ocak": true,
      "Yeni": true,
      "Yeşil Yurt": true,
      "Yeşiltepe": true,
      "Yıldırım Beyazıt": true,
      "Yunus Emre": true
    },
    "Sumbas": {
      "Armağanlı": true,
      "Cumhuriyet": true,
      "Döğenli": true,
      "Karaömerli": true,
      "Yeni": true
    },
    "Toprakkale": {
      "Büyüktüysüz": true,
      "Cumhuriyet": true,
      "Çamlıkevler": true,
      "Dagıstan": true,
      "Fatıh Sultan Mehmet": true,
      "Fatih": true,
      "Göçmenler": true,
      "Karataş": true,
      "Kışla": true,
      "Kumarlı": true,
      "Sazlık": true,
      "Tepe": true
    }
  },
  "Rize": {
    "Ardeşen": {
      "Ada": true,
      "Bahar": true,
      "Barış": true,
      "Baş": true,
      "Cami": true,
      "Cumhuriyet": true,
      "Çiftekavak": true,
      "Deniz": true,
      "Düz": true,
      "Elmalık": true,
      "Esentepe": true,
      "Fatih": true,
      "Fırtına": true,
      "Işıklı": true,
      "Kahveciler": true,
      "Kavaklıdere": true,
      "Konak": true,
      "Konaktepe": true,
      "Kuzey": true,
      "Merkez": true,
      "Müftü": true,
      "Orta": true,
      "Şentepe": true,
      "Şenyuva": true,
      "Taşbaşı": true,
      "Yavuz Selim": true,
      "Yayla": true,
      "Yeni": true
    },
    "Çamlıhemşin": {
      "Aşağıçamlıca": true,
      "Aşağışimşirli": true,
      "Kadıköy": true,
      "Kaplıca": true,
      "Kavak": true,
      "Konaklar": true,
      "Merkez": true,
      "Sırt": true,
      "Yağmurlu": true,
      "Yukarıçamlıca": true
    },
    "Çayeli": {
      "Adalar": true,
      "Aloğlu": true,
      "Altıntaş": true,
      "Arkadere": true,
      "Büyükcaferpaşa": true,
      "Büyüktaşhane": true,
      "Çamlıca": true,
      "Çataklıhoca": true,
      "Çavuşlu": true,
      "Çaycılar": true,
      "Demirciler": true,
      "Eskipazar": true,
      "Gümüştaş": true,
      "Gürçam": true,
      "Habiboğlu": true,
      "Hassadıklar": true,
      "İncesırt": true,
      "Kazancılar": true,
      "Kesmetaş": true,
      "Küçükcaferpaşa": true,
      "Küçüktaşhane": true,
      "Limanköy": true,
      "Maden": true,
      "Merkez": true,
      "Sabuncular": true,
      "Seslidere": true,
      "Soğuksu": true,
      "Şairler": true,
      "Taşhane": true,
      "Topkaya": true,
      "Yaka": true,
      "Yalı": true,
      "Yazıcılar": true,
      "Yeni": true,
      "Yenicami": true,
      "Yenipazar": true
    },
    "Derepazarı": {
      "Çalışkanlar": true,
      "Eriklimanı": true,
      "Fıçıcılar": true,
      "Merkez": true,
      "Sarıyer": true,
      "Subaşı": true,
      "Tersane": true,
      "Yanıktaş": true
    },
    "Fındıklı": {
      "Aksu": true,
      "Hürriyet": true,
      "Ilıca": true,
      "Liman": true,
      "Merkez": true,
      "Sahil": true,
      "Tatlısu": true,
      "Yeni": true
    },
    "Güneysu": {
      "Adacami": true,
      "Aşağı Kiremit": true,
      "Başaran": true,
      "Birlik": true,
      "Eskicami": true,
      "Güneli": true,
      "Kiremit": true,
      "Küçükcamii": true,
      "Merkez": true,
      "Selamet": true,
      "Ulucamii": true,
      "Yenicami": true
    },
    "Hemşin": {
      "Bahar": true,
      "Mutlu": true,
      "Ortaköy": true,
      "Yeniköy": true
    },
    "İkizdere": {
      "Çağrankaya": true,
      "Çarşı": true,
      "Gündoğdu": true,
      "Güney": true,
      "Kirazlı": true,
      "Yeşilyurt": true,
      "Zafer": true
    },
    "İyidere": {
      "Çanakçeşme": true,
      "Fethiye": true,
      "Fıçıtaşı": true,
      "Hazar": true,
      "Merkez": true,
      "Sarayköy": true,
      "Üstüpiler": true,
      "Yalıköy": true,
      "Yapraklar": true
    },
    "Kalkandere": {
      "Adalar": true,
      "Aksu": true,
      "Aşağı Tatlısu": true,
      "Cevizlik": true,
      "Dağdibi": true,
      "Kızıltoprak": true,
      "Kuruköy": true,
      "Medrese": true,
      "Soğuksu": true,
      "Taşçılar": true,
      "Yeni": true,
      "Yukarı Tatlısu": true
    },
    "Merkez": {
      "Alipaşa": true,
      "Asmalık": true,
      "Atmeydanı": true,
      "Bağdatlı": true,
      "Balsu": true,
      "Boğaz": true,
      "Bozkale": true,
      "Camiönü": true,
      "Canpolat": true,
      "Çamlıbel": true,
      "Çarşı": true,
      "Çiftekavak": true,
      "Çorapçılar": true,
      "Dağınıksu": true,
      "Dağsu": true,
      "Değirmendere": true,
      "Dereüstü": true,
      "Düz": true,
      "Ekmekçiler": true,
      "Ekrem Orhon": true,
      "Eminettin": true,
      "Engindere": true,
      "Fatih": true,
      "Fener": true,
      "Gülbahar": true,
      "Güneşli": true,
      "Güneştepe": true,
      "Halaslar": true,
      "Halatçılar": true,
      "Hamidiye": true,
      "Hamzabey": true,
      "Hayrat": true,
      "İslampaşa": true,
      "Kale": true,
      "Kanbursırt": true,
      "Kaplıca": true,
      "Kasarcılar": true,
      "Kavaklı": true,
      "Kireçhane": true,
      "Kokulukaya": true,
      "Kömürcüler": true,
      "Köprübaşı": true,
      "Mermerdelen": true,
      "Mesudiye": true,
      "Mezra": true,
      "Müderrisler": true,
      "Müftü": true,
      "Orta": true,
      "Orta Muradiye": true,
      "Paşakuyu": true,
      "Pehlivan": true,
      "Pehlivantaşı": true,
      "Pilavdağı": true,
      "Piriçelebi": true,
      "Portakallık": true,
      "Reşadiye": true,
      "Sırt": true,
      "Sırt Kasarcılar": true,
      "Soğuksu": true,
      "Taşlıdere": true,
      "Tophane": true,
      "Üzümlü": true,
      "Yağlıtaş": true,
      "Yeniköy": true,
      "Yeşildere": true,
      "Yeşilılıca": true
    },
    "Pazar": {
      "Beyaztaş": true,
      "Cumhuriyet": true,
      "Gazi": true,
      "Güzelyalı": true,
      "İkiztepe": true,
      "Kirazlık": true,
      "Kocaköprü": true,
      "Ocak": true,
      "Pazar": true,
      "Soğuksu": true,
      "Yukarı Soğuksu": true,
      "Zafer": true
    }
  },
  "Sakarya": {
    "Adapazarı": {
      "15 Temmuz Camili": true,
      "Abalı": true,
      "Acıelmalık": true,
      "Akıncılar": true,
      "Alandüzü": true,
      "Aşırlar": true,
      "Bağlar": true,
      "Bayraktar": true,
      "Bileciler": true,
      "Budaklar": true,
      "Büyükhataplı": true,
      "Cumhuriyet": true,
      "Çağlayan": true,
      "Çaltıcak": true,
      "Çamyolu": true,
      "Çelebiler": true,
      "Çerçiler": true,
      "Çökekler": true,
      "Çukurahmediye": true,
      "Dağdibi": true,
      "Demirbey": true,
      "Doğancılar": true,
      "Elmalı": true,
      "Evrenköy": true,
      "Göktepe": true,
      "Güllük": true,
      "Güneşler Merkez": true,
      "Güneşler Yeni": true,
      "Hacılar": true,
      "Hacıramazanlar": true,
      "Harmantepe": true,
      "Hızırtepe": true,
      "Işıklar": true,
      "İkizce Müslim": true,
      "İkizce Osmaniye": true,
      "İlyaslar": true,
      "İstiklal": true,
      "Karadavutlu": true,
      "Karadere": true,
      "Karakamış": true,
      "Karaköy": true,
      "Karaman": true,
      "Karaosman": true,
      "Karapınar": true,
      "Kasımlar": true,
      "Kavaklıorman": true,
      "Kayrancık": true,
      "Kışla": true,
      "Korucuk": true,
      "Kömürlük": true,
      "Köprübaşı": true,
      "Kurtbeyler": true,
      "Kurtuluş": true,
      "Küçükhataplı": true,
      "Mahmudiye": true,
      "Maltepe": true,
      "Mithatpaşa": true,
      "Nasuhlar": true,
      "Orta": true,
      "Ozanlar": true,
      "Örentepe": true,
      "Papuççular": true,
      "Poyrazlar": true,
      "Rüstemler": true,
      "Sakarya": true,
      "Salmanlı": true,
      "Semerciler": true,
      "Solaklar": true,
      "Süleymanbey": true,
      "Şeker": true,
      "Şirinevler": true,
      "Taşkısığı": true,
      "Taşlık": true,
      "Tekeler": true,
      "Tepekum": true,
      "Tığcılar": true,
      "Turnadere": true,
      "Tuzla": true,
      "Yağcılar": true,
      "Yahyalar": true,
      "Yenicami": true,
      "Yenidoğan": true,
      "Yenigün": true,
      "Yeşilyurt": true
    },
    "Akyazı": {
      "Akbalık": true,
      "Alaağaç": true,
      "Altındere Cumhuriyet": true,
      "Altındere Gündoğan": true,
      "Altındere Osmanağa": true,
      "Ballıkaya": true,
      "Batakköy": true,
      "Bedil Kazancı": true,
      "Bedilkadırbey": true,
      "Bediltahirbey": true,
      "Beldibi": true,
      "Bıçkıdere": true,
      "Boztepe": true,
      "Buğdaylı": true,
      "Cumhuriyet": true,
      "Çakıroğlu": true,
      "Çatalköprü": true,
      "Çıldırlar": true,
      "Dedeler": true,
      "Dokurcun Çaylar Yeni": true,
      "Dokurcun Çengeller": true,
      "Dokurcun Kuloğlu": true,
      "Durmuşlar": true,
      "Düzyazı": true,
      "Erdoğdu": true,
      "Eskibedil": true,
      "Fatih": true,
      "Gazi Süleyman Paşa": true,
      "Gebeş": true,
      "Gökçeler": true,
      "Güvençler": true,
      "Güzlek": true,
      "Hanyatak": true,
      "Harunusta": true,
      "Hasanbey": true,
      "Hastahane": true,
      "Haydarlar": true,
      "İnönü": true,
      "Kabakulak": true,
      "Karaçalılık": true,
      "Kepekli": true,
      "Kızılcıkorman": true,
      "Konuralp": true,
      "Kumköprü": true,
      "Kuzuluk Ortamahalle": true,
      "Kuzuluk Şose": true,
      "Kuzuluk Topçusırtı": true,
      "Küçücek Cumhuriyet": true,
      "Küçücek Istiklal": true,
      "Madenler": true,
      "Mansurlar": true,
      "Merkezyeniköy": true,
      "Osmanbey": true,
      "Ömercikler": true,
      "Pazarköy": true,
      "Reşadiye": true,
      "Salihiye": true,
      "Seyfeler": true,
      "Sukenarı": true,
      "Şerefiye": true,
      "Taşağıl": true,
      "Taşburun": true,
      "Taşyatak": true,
      "Topağaç": true,
      "Türkormanköy": true,
      "Uzunçınar": true,
      "Vakıf": true,
      "Yağcılar": true,
      "Yahyalı": true,
      "Yeni": true,
      "Yenidoğan": true,
      "Yeniorman": true,
      "Yongalık": true,
      "Yörükyeri": true,
      "Yunus Emre": true,
      "Yuvalak": true
    },
    "Arifiye": {
      "Adliye": true,
      "Ahmediye": true,
      "Arifbey": true,
      "Aşağı Kirazca": true,
      "Boğazköy": true,
      "Cumhuriyet": true,
      "Çaybaşı Fuadiye": true,
      "Çınardibi": true,
      "Fatih": true,
      "Hacıköy": true,
      "Hanlı Merkez": true,
      "Hanlı Sakarya": true,
      "Hanlıköy": true,
      "Karaaptiler": true,
      "Karaçomaklar": true,
      "Kemaliye": true,
      "Kışlaçay": true,
      "Kirazca": true,
      "Kumbaşı": true,
      "Mollaköy": true,
      "Neviye": true,
      "Semerciler": true,
      "Türkçaybaşı": true,
      "Yukarıkirazca": true
    },
    "Erenler": {
      "Alancuma": true,
      "Bağlar": true,
      "Bekirpaşa": true,
      "Büyükesence": true,
      "Çaybaşıyeniköy": true,
      "Çaykışla": true,
      "Değirmendere": true,
      "Dilmen": true,
      "Ekinli": true,
      "Emirler": true,
      "Epçeller": true,
      "Erenler": true,
      "Hacıoğlu": true,
      "Hasanbey": true,
      "Horozlar": true,
      "Hürriyet": true,
      "Kamışlı": true,
      "Kayalarmemduhiye": true,
      "Kayalarreşitbey": true,
      "Kozluk": true,
      "Küçükesence": true,
      "Küpçüler": true,
      "Nakışlar": true,
      "Pirahmetler": true,
      "Sarıcalar": true,
      "Şeyhköy": true,
      "Şükriye": true,
      "Tabakhane": true,
      "Tepe": true,
      "Tuapsalar": true,
      "Yazılı": true,
      "Yeni": true,
      "Yeşiltepe": true
    },
    "Ferizli": {
      "Abdürrezzak": true,
      "Ağacık": true,
      "Akçukur": true,
      "Bakırlı": true,
      "Ceylandere": true,
      "Damlık": true,
      "Değirmencik": true,
      "Devlet": true,
      "Doğancı": true,
      "Gölkent": true,
      "Hocaoğlu": true,
      "İnönü": true,
      "İstiklal": true,
      "Karadiken": true,
      "Kemalpaşa": true,
      "Kusca": true,
      "Nalköy": true,
      "Osmanağa Çiftliği": true,
      "Sarıahmetler": true,
      "Seyifler": true,
      "Sinanoğlu": true,
      "Teberik": true,
      "Tokat": true,
      "Yeni": true
    },
    "Geyve": {
      "Ahibaba": true,
      "Akdoğan": true,
      "Akıncı": true,
      "Akkaya": true,
      "Alıplar": true,
      "Alifuatpaşa": true,
      "Aydınlar": true,
      "Bağcaz": true,
      "Bağlarbaşı": true,
      "Bayat": true,
      "Belpınar": true,
      "Bozören": true,
      "Burhaniye": true,
      "Camikebir": true,
      "Ceceler": true,
      "Çamlık": true,
      "Çayköy": true,
      "Çeltikler": true,
      "Çengel": true,
      "Çine": true,
      "Çukurköy": true,
      "Demirler": true,
      "Dereköy": true,
      "Doğancıl": true,
      "Doğançay": true,
      "Doğantepe": true,
      "Düzakçaşehir": true,
      "Epçeler": true,
      "Esenköy": true,
      "Eşme": true,
      "Fındıksuyu": true,
      "Gazi Süleyman Paşa": true,
      "Güney": true,
      "Günhoşlar": true,
      "Hacılar": true,
      "Hacıosmanlar": true,
      "Halidiye": true,
      "Hırka": true,
      "Hisarlık": true,
      "Ilıca": true,
      "İhsaniye": true,
      "İlimbey": true,
      "İnciksuyu": true,
      "Kamışlı": true,
      "Karacaören": true,
      "Karaçam": true,
      "Kızılkaya": true,
      "Koru": true,
      "Kozan": true,
      "Köprübaşı": true,
      "Kulfallar": true,
      "Maksudiye": true,
      "Melekşeoruç": true,
      "Melekşesolak": true,
      "Nuruosmaniye": true,
      "Orhaniye": true,
      "Örencik": true,
      "Poydular": true,
      "Sabırlar": true,
      "Safibey": true,
      "Saraçlı": true,
      "Sarıgazi": true,
      "Sekiharman": true,
      "Setçe": true,
      "Suçatı": true,
      "Sütalan": true,
      "Şehren": true,
      "Şerefiye": true,
      "Taşoluk": true,
      "Tepecikler": true,
      "Umurbey": true,
      "Yaylak": true,
      "Yörükler": true
    },
    "Hendek": {
      "Akarca": true,
      "Akçayır": true,
      "Akova": true,
      "Akpınar": true,
      "Aksu": true,
      "Aktefek": true,
      "Aşağıçalıca": true,
      "Bakacak": true,
      "Balıklıihsaniye": true,
      "Başpınar": true,
      "Bayraktepe": true,
      "Beyköy": true,
      "Beylice": true,
      "Bıçkıatik": true,
      "Büyükdere": true,
      "Çağlayan": true,
      "Çakallık": true,
      "Çamlıca": true,
      "Çamlıca Haraklı": true,
      "Çayırbaşı": true,
      "Çiftlik": true,
      "Çobanyatak": true,
      "Çukurhan": true,
      "Dereboğazı": true,
      "Dereköy": true,
      "Dikmen": true,
      "Esentepe": true,
      "Eskibıçkı": true,
      "Göksu": true,
      "Güldibi": true,
      "Gündoğan": true,
      "Güney": true,
      "Hacıkışla": true,
      "Hacimbey": true,
      "Halaç": true,
      "Hamitli": true,
      "Harmantepe": true,
      "Hicriye": true,
      "Hüseyinşeyh": true,
      "İkbaliye": true,
      "İkramiye": true,
      "Kadifekale": true,
      "Kahraman": true,
      "Kalayık": true,
      "Karadere": true,
      "Karatoprak": true,
      "Kargalı Hanbaba": true,
      "Kargalıyeniköy": true,
      "Kazımiye": true,
      "Kemaliye": true,
      "Kırktepe": true,
      "Kızanlık": true,
      "Kocaahmetler": true,
      "Kocatöngel": true,
      "Köprübaşı": true,
      "Kurtköy": true,
      "Kurtuluş": true,
      "Lütfiyeköşk": true,
      "Mahmutbey": true,
      "Martinler": true,
      "Muradiye": true,
      "Nuriye": true,
      "Paşaköy": true,
      "Pınarlı": true,
      "Puna Ortaköy": true,
      "Rasimpaşa": true,
      "Sarıdede": true,
      "Sarıyer": true,
      "Servetiye": true,
      "Sivritepe": true,
      "Sofular": true,
      "Soğuksu": true,
      "Sukenarı": true,
      "Süleymaniye": true,
      "Sümbüllü": true,
      "Şeyhler": true,
      "Turanlar": true,
      "Tuzak": true,
      "Türbe": true,
      "Uzuncaorman": true,
      "Uzunçarşı": true,
      "Yağbasan": true,
      "Yarıca": true,
      "Yayalar": true,
      "Yeni": true,
      "Yeniköy": true,
      "Yeniyayla": true,
      "Yeşilköy": true,
      "Yeşilvadi": true,
      "Yeşilyurt": true,
      "Yukarıçalıca": true,
      "Yukarıhüseyinşeyh": true
    },
    "Karapürçek": {
      "Ahmediye": true,
      "Ahmetler": true,
      "Cumhuriyet": true,
      "Çeşmebaşı": true,
      "Hocaköy": true,
      "İnönü": true,
      "Kanlıçay": true,
      "Kızılbayır": true,
      "Küçükkarapürçek": true,
      "Mecidiye": true,
      "Mesudiye": true,
      "Meşepınarı": true,
      "Yazılıgürgen": true,
      "Yüksel": true
    },
    "Karasu": {
      "Adatepe": true,
      "Akkum": true,
      "Ardıçbeli": true,
      "Aziziye": true,
      "Camitepe": true,
      "Çatalövez": true,
      "Darıçayırı": true,
      "Denizköy": true,
      "Gölköprü": true,
      "Hürriyet": true,
      "İhsaniye": true,
      "İncilli": true,
      "Kabakoz": true,
      "Kancalar": true,
      "Karamüezzinler": true,
      "Karanlıkdere": true,
      "Karapınar": true,
      "Karasu": true,
      "Kızılcık": true,
      "Konacık": true,
      "Kurudere": true,
      "Kurumeşe": true,
      "Kuyumcullu": true,
      "Kuzuluk": true,
      "Limandere": true,
      "Manavpınarı": true,
      "Ortaköy": true,
      "Paralı": true,
      "Resuller": true,
      "Subatağı": true,
      "Taşlıgeçit": true,
      "Tepetarla": true,
      "Tuzla": true,
      "Üçoluk": true,
      "Yalı": true,
      "Yassıgeçit": true,
      "Yeni": true,
      "Yenidoğan": true,
      "Yeşilköy": true,
      "Yuvalıdere": true
    },
    "Kaynarca": {
      "Akbaşlı": true,
      "Arifağa": true,
      "Başoğlu": true,
      "Birlik": true,
      "Büyükyanık": true,
      "Cebek": true,
      "Duduköy": true,
      "Eğrioğlu": true,
      "Gaziler": true,
      "Gölce": true,
      "Gürpınar": true,
      "Güven": true,
      "Hatipler": true,
      "İmamlar": true,
      "İşaret": true,
      "Kalburcu": true,
      "Karaçalı": true,
      "Karamanlar": true,
      "Kayacık": true,
      "Kertil": true,
      "Kırktepe": true,
      "Kızılcaali": true,
      "Konak": true,
      "Kulaklı": true,
      "Küçükkaynarca": true,
      "Küçükkışla": true,
      "Merkez": true,
      "Müezzinler": true,
      "Okçular": true,
      "Orta": true,
      "Ortaköy": true,
      "Osmanlı": true,
      "Ömerağa": true,
      "Sabırlı": true,
      "Sarıbeyli": true,
      "Şeyhtımarı": true,
      "Taşoluk": true,
      "Topçu": true,
      "Turnalı": true,
      "Uğurlu": true,
      "Uzakkışla": true,
      "Uzunalan": true,
      "Yeniçam": true,
      "Yeşilova": true,
      "Ziahmet": true
    },
    "Kocaali": {
      "Açmabaşı": true,
      "Ağalar": true,
      "Akpınar": true,
      "Aktaş": true,
      "Alandere": true,
      "Aydoğan": true,
      "Beyler": true,
      "Bezirgan": true,
      "Caferiye": true,
      "Çakmaklı": true,
      "Çukurköy": true,
      "Demiraçma": true,
      "Görele": true,
      "Gümüşoluk": true,
      "Hızar": true,
      "Kadıköy": true,
      "Karalar": true,
      "Karapelit": true,
      "Karşı": true,
      "Kestanepınarı": true,
      "Kızılüzüm": true,
      "Kirazlı": true,
      "Koğutpelit": true,
      "Kozluk": true,
      "Köyyeri": true,
      "Küplük": true,
      "Melen": true,
      "Merkez": true,
      "Selahiye": true,
      "Süngüt": true,
      "Şerbetpınar": true,
      "Yalı": true,
      "Yalpankaya": true,
      "Yanıksayvant": true,
      "Yayla": true,
      "Yeni": true
    },
    "Pamukova": {
      "Ağaççılar": true,
      "Ahılar": true,
      "Akçakaya": true,
      "Bacıköy": true,
      "Bakacak": true,
      "Bayırakçaşehir": true,
      "Cihadiye": true,
      "Cumhuriyet": true,
      "Çardak": true,
      "Çilekli": true,
      "Eğriçay": true,
      "Elperek": true,
      "Eskiyayla": true,
      "Fevziye": true,
      "Gonca": true,
      "Gökgöz": true,
      "Hayrettin": true,
      "Hüseyinli": true,
      "İsabalı": true,
      "Kadıköy": true,
      "Karapınar": true,
      "Kazımiye": true,
      "Kemaliye": true,
      "Mekece": true,
      "Oruçlu": true,
      "Özbek": true,
      "Paşalar": true,
      "Pınarlı": true,
      "Şahmelek": true,
      "Şeyhvarmaz": true,
      "Teşvikiye": true,
      "Turgutlu": true,
      "Yenice": true
    },
    "Sapanca": {
      "Akçay": true,
      "Balkaya": true,
      "Camicedit": true,
      "Çayiçi": true,
      "Fevziye": true,
      "Gazipaşa": true,
      "Göl": true,
      "Güldibi": true,
      "Hacımercan": true,
      "İkramiye": true,
      "İlmiye": true,
      "İstanbuldere": true,
      "Kırkpınar Hasanpaşa": true,
      "Kırkpınar Soğuksu": true,
      "Kırkpınar Tepebaşı": true,
      "Kurtköy Dibektaş": true,
      "Kurtköy Fatih": true,
      "Kurtköy Yavuzselim": true,
      "Kuruçeşme": true,
      "Mahmudiye": true,
      "Memnuniye": true,
      "Muradiye": true,
      "Nailiye": true,
      "Rüstempaşa": true,
      "Şükriye": true,
      "Uzunkum": true,
      "Ünlüce": true,
      "Yanık": true,
      "Yeni": true
    },
    "Serdivan": {
      "Arabacıalanı": true,
      "Aralık": true,
      "Aşağıdereköy": true,
      "Bahçelievler": true,
      "Beşevler": true,
      "Beşköprü": true,
      "Çubuklu": true,
      "Dağyoncalı": true,
      "Esentepe": true,
      "Hamitabat": true,
      "İstiklal": true,
      "Kazımpaşa": true,
      "Kemalpaşa": true,
      "Kızılcıklı": true,
      "Köprübaşı": true,
      "Kuruçeşme": true,
      "Meşeli": true,
      "Otuziki Evler": true,
      "Reşadiye": true,
      "Selahiye": true,
      "Uzunköy": true,
      "Vatan": true,
      "Yazlık": true,
      "Yukarıdereköy": true
    },
    "Söğütlü": {
      "Akarca": true,
      "Akçakamış": true,
      "Akgöl": true,
      "Beşdeğirmen": true,
      "Cami Cedit": true,
      "Fındıklı": true,
      "Gündoğan": true,
      "Hasanfakı": true,
      "İmamlar": true,
      "Kantar": true,
      "Karateke": true,
      "Kurudil": true,
      "Küçük Söğütlü": true,
      "Levent": true,
      "Mağara": true,
      "Maksudiye": true,
      "Orta": true,
      "Rüstemler": true,
      "Sıraköy": true,
      "Soğucak": true,
      "Tokmaklıdere": true,
      "Türkbeylikkışla": true,
      "Yeniköy": true
    },
    "Taraklı": {
      "Akçapınar": true,
      "Aksu": true,
      "Alballar": true,
      "Avdan": true,
      "Çamtepe": true,
      "Dışdedeler": true,
      "Duman": true,
      "Esenyurt": true,
      "Hacıaliler": true,
      "Hacımurat": true,
      "Hacıyakup": true,
      "Harkköy": true,
      "İçdedeler": true,
      "Kemaller": true,
      "Mahdumlar": true,
      "Pirler": true,
      "Tuzla": true,
      "Uğurlu": true,
      "Ulucamii": true,
      "Yenidoğan": true,
      "Yeniköy": true,
      "Yusufbey": true
    }
  },
  "Samsun": {
    "19 Mayıs": {
      "Aydınpınar": true,
      "Bahçelievler": true,
      "Ballıca": true,
      "Beylik": true,
      "Cerekli": true,
      "Cumhuriyet": true,
      "Çamlıca": true,
      "Çandır": true,
      "Çepinler": true,
      "Çetirlipınar": true,
      "Çiftlikköy": true,
      "Dağköy": true,
      "Dereköy": true,
      "Düzköy": true,
      "Engiz": true,
      "Esentepe": true,
      "Esenyer": true,
      "Fındıklı": true,
      "Hibe": true,
      "İstiklal": true,
      "Karacaoğlu": true,
      "Karagöl": true,
      "Karşıyaka": true,
      "Kertme": true,
      "Kösedik": true,
      "Kumcağız": true,
      "Kuşkayası": true,
      "Mimar Sinan": true,
      "Ormancık": true,
      "Pazar": true,
      "Tepeköy": true,
      "Yeni": true,
      "Yeşilköy": true,
      "Yeşilova": true,
      "Yeşilyurt": true,
      "Yörükler": true,
      "Yukarıengiz": true,
      "Yükseliş": true
    },
    "Alaçam": {
      "Akbulut": true,
      "Akgüney": true,
      "Alidedebölmesi": true,
      "Alparslan": true,
      "Aşağı Akgüney": true,
      "Aşağıısırganlı": true,
      "Aşağıkoçlu": true,
      "Bahşioymağı": true,
      "Bekiroğlu": true,
      "Çeşme": true,
      "Demircideresi": true,
      "Doğankent": true,
      "Doyran": true,
      "Esentepe": true,
      "Etyemez": true,
      "Fatih": true,
      "Göçkün": true,
      "Gökçeağaçoymağı": true,
      "Gökçeboğaz": true,
      "Gülkaya": true,
      "Gültepe": true,
      "Gümüşova": true,
      "Güvenli": true,
      "Habilli": true,
      "Harmancık": true,
      "İncirli": true,
      "Kadıköy": true,
      "Kalıkdemirci": true,
      "Kapaklı": true,
      "Karaçukur": true,
      "Karahüseyinli": true,
      "Karlı": true,
      "Karşıyaka": true,
      "Kışlakonak": true,
      "Kızlan": true,
      "Killik": true,
      "Köseköy": true,
      "Madenler": true,
      "Ortaköy": true,
      "Örenli": true,
      "Pelitbükü": true,
      "Pelitbüküsekecek": true,
      "Sancar": true,
      "Sarılık": true,
      "Soğukçam": true,
      "Şirinköy": true,
      "Taşkelik": true,
      "Tefekli": true,
      "Tepebölmesi": true,
      "Terskırık": true,
      "Toplu": true,
      "Umutlu": true,
      "Uzunkıraç": true,
      "Vicikler": true,
      "Yakacık": true,
      "Yenicami": true,
      "Yenice": true,
      "Yeniköy": true,
      "Yeşilköy": true,
      "Yoğunpelit": true,
      "Yukarıelma": true,
      "Yukarıısırganlı": true,
      "Yukarıkoçlu": true,
      "Yukarısoğukçam": true,
      "Zeytin": true
    },
    "Asarcık": {
      "Acısu": true,
      "Akyazı": true,
      "Alan": true,
      "Alişar": true,
      "Arıcak": true,
      "Armutlu": true,
      "Aşuru": true,
      "Atatürk": true,
      "Ayaklıalan": true,
      "Aydınköy": true,
      "Biçincik": true,
      "Çulhaoğlu": true,
      "Dağcılar": true,
      "Emirmusa": true,
      "Esentepe": true,
      "Gökgöl": true,
      "Gülveren": true,
      "Gündoğdu": true,
      "Hisariye": true,
      "İmamlı": true,
      "Kesealan": true,
      "Kılavuzlu": true,
      "Koşaca": true,
      "Kuyumcuoğlu": true,
      "Musaağa": true,
      "Sakızlık": true,
      "Uluköy": true,
      "Yarımca": true,
      "Yaylaköy": true,
      "Yeniömerli": true,
      "Yeşildere": true,
      "Yeşilköy": true
    },
    "Atakum": {
      "Akalan": true,
      "Aksu": true,
      "Alanlı": true,
      "Aslandamı": true,
      "Atakent": true,
      "Atatepe": true,
      "Ayvalı": true,
      "Balaç": true,
      "Beypınar": true,
      "Büyükkolpınar": true,
      "Büyükoyumca": true,
      "Camii": true,
      "Cumhurıyet": true,
      "Çakırlar": true,
      "Çakırlar Yalı": true,
      "Çamlıyazı": true,
      "Çatmaoluk": true,
      "Çobanlı": true,
      "Çobanözü": true,
      "Denizevleri": true,
      "Elmaçukuru": true,
      "Erikli": true,
      "Esenevler": true,
      "Güneyköy": true,
      "Güzelyalı": true,
      "Güzelyurt": true,
      "İncesu": true,
      "İncesu Yalı": true,
      "İstiklal": true,
      "Kabadüz": true,
      "Kamalı": true,
      "Karakavuk": true,
      "Karaoyumca": true,
      "Kasnakçımermer": true,
      "Kayagüney": true,
      "Kesili": true,
      "Körfez": true,
      "Köseli": true,
      "Kulacadağ": true,
      "Kurugökçe": true,
      "Küçükkolpınar": true,
      "Mevlana": true,
      "Meyvalı": true,
      "Mimarsinan": true,
      "Özören": true,
      "Sarayköy": true,
      "Sarıışık": true,
      "Sarıtaş": true,
      "Sarıyusuf": true,
      "Şenyurt": true,
      "Taflan Merkez": true,
      "Yalı": true,
      "Yenimahalle": true,
      "Yeşildere": true,
      "Yeşiltepe": true,
      "Yeşilyurt": true,
      "Yukarıaksu": true
    },
    "Ayvacık": {
      "Ardıç": true,
      "Başalan": true,
      "Çamalan": true,
      "Çamlıkale": true,
      "Çarşıköy": true,
      "Çökekli": true,
      "Döngel": true,
      "Döngelyatak": true,
      "Esenyurt": true,
      "Eynel": true,
      "Eyüpsultan": true,
      "Fatih Sultan Mehmet": true,
      "Gülpınar": true,
      "Gültepe": true,
      "Gürçam": true,
      "Güzelyurt": true,
      "Kabaklık": true,
      "Kapıkaya": true,
      "Karaağaç": true,
      "Karşıdöngel": true,
      "Kazancılı": true,
      "Keskinoğlu": true,
      "Koçyurdu": true,
      "Meşelidüz": true,
      "Orhangazi": true,
      "Orta": true,
      "Ortaköy": true,
      "Osmanlı": true,
      "Örencik": true,
      "Sahilköy": true,
      "Söğütpınar": true,
      "Şenpınar": true,
      "Tepealtı": true,
      "Terice": true,
      "Tiryakioğlu": true,
      "Uğurlu": true,
      "Yenice": true,
      "Yeniköy": true,
      "Yeşilçam": true,
      "Yeşildere": true,
      "Yeşilpınar": true,
      "Yunus Emre": true,
      "Zafer": true
    },
    "Bafra": {
      "Adaköy": true,
      "Ağcaalan": true,
      "Ağıllar": true,
      "Akalan": true,
      "Aktekke": true,
      "Alaçam": true,
      "Alparslan": true,
      "Altınay": true,
      "Altınkaya": true,
      "Altınova": true,
      "Altınyaprak": true,
      "Asar": true,
      "Asmaçam": true,
      "Azay": true,
      "Bahçeler": true,
      "Bakırpınarı": true,
      "Balıklar": true,
      "Barış": true,
      "Başaran": true,
      "Başkaya": true,
      "Bengü": true,
      "Boğazkaya": true,
      "Burunca": true,
      "Büyükcami": true,
      "Cumhuriyet": true,
      "Çalköy": true,
      "Çamaltı": true,
      "Çatak": true,
      "Çataltepe": true,
      "Çetinkaya": true,
      "Çilhane": true,
      "Çulhakoca": true,
      "Darboğaz": true,
      "Dededağı": true,
      "Dedeli": true,
      "Derbent": true,
      "Dereler": true,
      "Dikencik": true,
      "Doğanca": true,
      "Doğankaya": true,
      "Düzköy": true,
      "Elalan": true,
      "Eldavut": true,
      "Elifli": true,
      "Emenli": true,
      "Emirefendi": true,
      "Esençay": true,
      "Evrenuşağı": true,
      "Eynegazi": true,
      "Fatih": true,
      "Fener": true,
      "Fevzi Çakmak": true,
      "Gazibeyli": true,
      "Gaziosmanpaşa": true,
      "Gazipaşa": true,
      "Gerzeliler": true,
      "Gökalan": true,
      "Gökçeağaç": true,
      "Gökçekent": true,
      "Gökçesu": true,
      "Göltepe": true,
      "Gümüşyaprak": true,
      "Hacınabi": true,
      "Hacıoğlu": true,
      "Harız": true,
      "Hıdırellez": true,
      "Hüseyinbeyli": true,
      "İğdir": true,
      "İkizpınar": true,
      "İkiztepe": true,
      "İlyaslı": true,
      "İnözükoşaca": true,
      "İshaklı": true,
      "İsmetpaşa": true,
      "Kahraman": true,
      "Kalaycılı": true,
      "Kamberli": true,
      "Kanlıgüney": true,
      "Kapıkaya": true,
      "Karaburç": true,
      "Karakütük": true,
      "Karıncak": true,
      "Karpuzlu": true,
      "Kavakpınar": true,
      "Kaygusuz": true,
      "Kelikler": true,
      "Kemalpaşa": true,
      "Keresteci": true,
      "Kızılırmak": true,
      "Kolay": true,
      "Komşupınar": true,
      "Koruluk": true,
      "Koşu": true,
      "Kozağzı": true,
      "Köseli": true,
      "Kuşçular": true,
      "Kuşluğan": true,
      "Kuzalan": true,
      "Küçükkavakpınar": true,
      "Lengerli": true,
      "Meşelitürkmenler": true,
      "Mevlana": true,
      "Müstecep": true,
      "Ortadurak": true,
      "Osmanbeyli": true,
      "Ozan": true,
      "Örencik": true,
      "Paşaşeyh": true,
      "Sahilkent": true,
      "Sarıçevre": true,
      "Sarıkaya": true,
      "Sarıköy": true,
      "Sarpın": true,
      "Selemelik": true,
      "Sürmeli": true,
      "Şahinkaya": true,
      "Şeyhören": true,
      "Şeyhulaş": true,
      "Şirinköy": true,
      "Tabakhane": true,
      "Taşköprü": true,
      "Tepebaşı": true,
      "Tepecik": true,
      "Terzili": true,
      "Türbe": true,
      "Türkköyü": true,
      "Tütüncüler": true,
      "Uluağaç": true,
      "Üçpınar": true,
      "Yağmurca": true,
      "Yaka": true,
      "Yakıntaş": true,
      "Yenialan": true,
      "Yeniköy": true,
      "Yeraltı": true,
      "Yeşilköy": true,
      "Yeşilyazı": true,
      "Yiğitalan": true,
      "Yörgüç": true
    },
    "Canik": {
      "Adatepe": true,
      "Alibeyli": true,
      "Ambarpınar": true,
      "Atatürk": true,
      "Avluca": true,
      "Başalan": true,
      "Başkonak": true,
      "Belediye Evleri": true,
      "Çağlayan": true,
      "Çamalan": true,
      "Demirci": true,
      "Dereler": true,
      "Devgeriş": true,
      "Düvecik": true,
      "Düzardıç": true,
      "Düzören": true,
      "Gaziosmanpaşa": true,
      "Gecehan": true,
      "Gödekli": true,
      "Gökçepınar": true,
      "Gölalan": true,
      "Gültepe": true,
      "Gürgenyatak": true,
      "Hacı Ismail": true,
      "Hacınaipli": true,
      "Hasköy": true,
      "Hilaltepe": true,
      "İkiyüz Evler": true,
      "İmamlar": true,
      "Kaleboğazı": true,
      "Karşıyaka": true,
      "Kaşyayla": true,
      "Kestanepınar": true,
      "Kızıloğlak": true,
      "Kozlu": true,
      "Kuzey Yıldızı": true,
      "Muratlı": true,
      "Sarıbıyık": true,
      "Soğuksu": true,
      "Tekkiraz": true,
      "Teknepınar": true,
      "Toptepe": true,
      "Toygar": true,
      "Tuzaklı": true,
      "Uluçayır": true,
      "Uludağ": true,
      "Üçpınar": true,
      "Yavuz Selim": true,
      "Yayla": true,
      "Yeniköy": true,
      "Yenimahalle": true,
      "Yeşilpınar": true
    },
    "Çarşamba": {
      "Acıklı": true,
      "Ağcagüney": true,
      "Ahubaba": true,
      "Akçaltı": true,
      "Akçatarla": true,
      "Akkuzulu": true,
      "Ali Fuat Başgil": true,
      "Alibeyli": true,
      "Allı": true,
      "Arım Köseli": true,
      "Aşağı Dikencik": true,
      "Aşağı Donurlu": true,
      "Aşağı Esenli": true,
      "Aşağı Kavacık": true,
      "Aşağı Musalla": true,
      "Aşağı Turgutlu": true,
      "Aşıklı": true,
      "Ataköy": true,
      "Bafracalı": true,
      "Bahçelievler": true,
      "Bayramlı": true,
      "Beylerce": true,
      "Beyyenice": true,
      "Bezirgan": true,
      "Boyacılı": true,
      "Bölmeçayır": true,
      "Canlı": true,
      "Cumhuriyet": true,
      "Çaltı": true,
      "Çamlıca": true,
      "Çatak": true,
      "Çay": true,
      "Çayvar": true,
      "Çelikli": true,
      "Çerçiler": true,
      "Çınarlık": true,
      "Dalbahçe": true,
      "Damlataş": true,
      "Demiraslan": true,
      "Demircili": true,
      "Demirli": true,
      "Denizler": true,
      "Deyincek": true,
      "Dikbıyık": true,
      "Durakbaşı": true,
      "Durusu": true,
      "Eğercili": true,
      "Eğridere": true,
      "Eğrikum": true,
      "Epçeli": true,
      "Esençay": true,
      "Esentepe": true,
      "Gazi": true,
      "Gökçeçakmak": true,
      "Gökçeli": true,
      "Güldere": true,
      "Gülören": true,
      "Gülyazı": true,
      "Güneşli": true,
      "Güzpınar": true,
      "Hacılıçay": true,
      "Hasbahçe": true,
      "Helvacalı": true,
      "Hürriyet": true,
      "Irmaksırtı": true,
      "İstiklal": true,
      "Kabaceviz": true,
      "Karaağaç": true,
      "Karabahçe": true,
      "Karacalı": true,
      "Karakaya": true,
      "Karakulak": true,
      "Karamustafalı": true,
      "Kaydan": true,
      "Kemer": true,
      "Kestanepınar": true,
      "Kızılot": true,
      "Kirazbucağı": true,
      "Kirazlıkçay": true,
      "Kocakavak": true,
      "Koldere": true,
      "Konukluk": true,
      "Köklük": true,
      "Köroğlu": true,
      "Kumköy": true,
      "Kumtepe": true,
      "Kurtahmetli": true,
      "Kurtuluş": true,
      "Kuşçulu": true,
      "Kuşhane": true,
      "Kürtün": true,
      "Mahmutlu": true,
      "Melik": true,
      "Musçalı": true,
      "Namazlı": true,
      "Ordu": true,
      "Ordubaşı": true,
      "Orta": true,
      "Otluk": true,
      "Ovacık": true,
      "Oymalı": true,
      "Ömerli": true,
      "Paşayazı": true,
      "Porsuk": true,
      "Sahil": true,
      "Saraçlı": true,
      "Sarıcalı": true,
      "Sefalı": true,
      "Selimiye": true,
      "Sığırtmaç": true,
      "Soğucak": true,
      "Suğluca": true,
      "Sungurlu": true,
      "Şenyurt": true,
      "Şeyhgüven": true,
      "Şeyhhabil": true,
      "Taşdemir": true,
      "Tatarlı": true,
      "Tilkili": true,
      "Turgutlu": true,
      "Uluköy": true,
      "Ulupınar": true,
      "Umut": true,
      "Ustacalı": true,
      "Uzunlu": true,
      "Üçköprü": true,
      "Vakıfköprü": true,
      "Yalı": true,
      "Yamanlı": true,
      "Yaycılar": true,
      "Yeni Karacalı": true,
      "Yeni Kışla": true,
      "Yeni Köseli": true,
      "Yeşildere": true,
      "Yeşilırmak": true,
      "Yeşilova": true,
      "Yukarı Ağcagüney": true,
      "Yukarı Dikencik": true,
      "Yukarı Donurlu": true,
      "Yukarı Esenli": true,
      "Yukarı Karabahçe": true,
      "Yukarı Kavacık": true,
      "Zümrüt": true
    },
    "Havza": {
      "19 Mayıs": true,
      "25 Mayıs": true,
      "Ağcamahmut": true,
      "Ağdırhasan": true,
      "Arslançayırı": true,
      "Aşağı Yavucak": true,
      "Aşağısusuz": true,
      "Bahçelievler": true,
      "Başpelit": true,
      "Bekdiğin": true,
      "Belalan": true,
      "Beyköy": true,
      "Beyören": true,
      "Boyalı": true,
      "Boyalıca": true,
      "Celil": true,
      "Cevizlik": true,
      "Çakıralan": true,
      "Çamyatağı": true,
      "Çay": true,
      "Çayırözü": true,
      "Çelikalan": true,
      "Çeltek": true,
      "Çiftlikköy": true,
      "Değirmenüstü": true,
      "Demiryurt": true,
      "Dereköy": true,
      "Doğançayır": true,
      "Dündarlı": true,
      "Ekinpınarı": true,
      "Elmacık": true,
      "Ereli": true,
      "Erikbelen": true,
      "Ersandık": true,
      "Esenbey": true,
      "Eymir": true,
      "Gelincik": true,
      "Gidirli": true,
      "Göçmenler": true,
      "Güvercinlik": true,
      "Hacıbattal": true,
      "Hacıdede": true,
      "Hecinli": true,
      "Hilmiye": true,
      "Ilıca": true,
      "İcadiye": true,
      "İmaret": true,
      "İmircik": true,
      "İnönü": true,
      "Kaleköy": true,
      "Kamlık": true,
      "Karabük": true,
      "Karageçmiş": true,
      "Karahalil": true,
      "Karameşe": true,
      "Karga": true,
      "Karşıyaka": true,
      "Kayabaşı": true,
      "Kayacık": true,
      "Kemaliye": true,
      "Kıroğlu": true,
      "Kirenlik": true,
      "Kocaoğlu": true,
      "Kocapınar": true,
      "Kuşkonağı": true,
      "Küflek": true,
      "Medrese": true,
      "Memduhiye": true,
      "Meryemdere": true,
      "Mesudiye": true,
      "Mısmılağaç": true,
      "Mürsel": true,
      "Orhaniye": true,
      "Ortaklar": true,
      "Paşapınarı": true,
      "Pınarçay": true,
      "Sivrikese": true,
      "Sofular": true,
      "Sondaj": true,
      "Şerifali": true,
      "Şeyhali": true,
      "Şeyhkoyun": true,
      "Şeyhler": true,
      "Şeyhsafi": true,
      "Taşkaracaören": true,
      "Tekkeköy": true,
      "Tuzla": true,
      "Uluçal": true,
      "Üniversite": true,
      "Yağcımahmut": true,
      "Yaylaçatı": true,
      "Yazıkışla": true,
      "Yeni": true,
      "Yenice": true,
      "Yenimescit": true,
      "Yeşilalan": true,
      "Yukarısusuz": true,
      "Yukarıyavucak": true
    },
    "İlkadım": {
      "19 Mayıs": true,
      "Adalet": true,
      "Ahulu": true,
      "Akgöl": true,
      "Anadolu": true,
      "Aşağıavdan": true,
      "Ataköy": true,
      "Avdan": true,
      "Bahçelievler": true,
      "Baruthane": true,
      "Bilmece": true,
      "Cedit": true,
      "Çanakçı": true,
      "Çandır": true,
      "Çatalarmut": true,
      "Çay": true,
      "Çelikalan": true,
      "Çiftlik": true,
      "Çivril": true,
      "Derebahçe": true,
      "Derecik": true,
      "Fatih": true,
      "Fevzi Çakmak": true,
      "Gürgendağ": true,
      "Güzeldere": true,
      "Hançerli": true,
      "Hastane": true,
      "Hürriyet": true,
      "İlyasköy": true,
      "İstasyon": true,
      "Kadamut": true,
      "Kadıköy": true,
      "Kadifekale": true,
      "Kale": true,
      "Kalkancı": true,
      "Kapaklı": true,
      "Karadeniz": true,
      "Karasamsun": true,
      "Kavacık": true,
      "Kazım Karabekir": true,
      "Kılıçdede": true,
      "Kıran": true,
      "Kışla": true,
      "Kökçüoğlu": true,
      "Kusçulu": true,
      "Liman": true,
      "Pazar": true,
      "Rasathane": true,
      "Reşadiye": true,
      "Saitbey": true,
      "Selahiye": true,
      "Tepecik": true,
      "Toybelen": true,
      "Ulugazi": true,
      "Unkapanı": true,
      "Uzgur": true,
      "Yaşardoğu": true,
      "Yenidoğan": true,
      "Yeşiltepe": true,
      "Zafer": true,
      "Zeytinlik": true
    },
    "Kavak": {
      "19 Mayıs": true,
      "Ağcakise": true,
      "Ahurlu": true,
      "Akbelen": true,
      "Alaçam": true,
      "Alagömlek": true,
      "Aşağıçirişli": true,
      "Atayurt": true,
      "Azaklı": true,
      "Bahçelievler": true,
      "Başalan": true,
      "Bayındır": true,
      "Bayraklı": true,
      "Bekdemir": true,
      "Belalan": true,
      "Beybesli": true,
      "Beyköy": true,
      "Boğaziçi": true,
      "Bükceğiz": true,
      "Büyükçukur": true,
      "Celallı": true,
      "Çakallı": true,
      "Çalbaşı": true,
      "Çarıklıbaşı": true,
      "Çataltepe": true,
      "Çayırlı": true,
      "Çiçekyazı": true,
      "Çiğdem": true,
      "Çivril": true,
      "Çukurbük": true,
      "Değirmencili": true,
      "Demirci": true,
      "Dereköy": true,
      "Divanbaşı": true,
      "Doruk": true,
      "Duman": true,
      "Dura": true,
      "Emirli": true,
      "Germiyan": true,
      "Göçebe": true,
      "Güneyce": true,
      "Hacılı": true,
      "Ilıcaköy": true,
      "İdrisli": true,
      "İkizdere": true,
      "Kapuhayat": true,
      "Karaaslan": true,
      "Karacalar": true,
      "Karadağ": true,
      "Karantu": true,
      "Karapınar": true,
      "Karayusuflu": true,
      "Karlı": true,
      "Kartepe": true,
      "Kayabaşı": true,
      "Kayaköy": true,
      "Kazancı": true,
      "Kethüda": true,
      "Kozansıkı": true,
      "Köseli": true,
      "Kurşunlu": true,
      "Kuzalan": true,
      "Küçükçukur": true,
      "Mahmutbeyli": true,
      "Mahmutlu": true,
      "Mehmetpaşa": true,
      "Mert": true,
      "Muhsinli": true,
      "Muratbeyli": true,
      "Ortaköy": true,
      "Saralan": true,
      "Seyitali": true,
      "Sıralı": true,
      "Soğuksu": true,
      "Susuz": true,
      "Şeyhli": true,
      "Şeyhresul": true,
      "Tabaklı": true,
      "Talışman": true,
      "Tatarmuslu": true,
      "Tekkeköy": true,
      "Tepecik": true,
      "Toptepe": true,
      "Üçhanlar": true,
      "Yaşar Doğu": true,
      "Yenicami": true,
      "Yenigün": true,
      "Yeralan": true,
      "Yosunlu": true,
      "Yukarı Dereköy": true,
      "Yukarıçirişli": true
    },
    "Ladik": {
      "Ağcakaya": true,
      "Ahmetsaray": true,
      "Akpınar": true,
      "Aktaş": true,
      "Akyar": true,
      "Alayurt": true,
      "Alıçlı": true,
      "Arslantaş": true,
      "Aşağıgölyazı": true,
      "Ayvalı": true,
      "Ayvalısokağı": true,
      "Bahşi": true,
      "Başlamış": true,
      "Bolat": true,
      "Budakdere": true,
      "Büyükalan": true,
      "Büyükkızoğlu": true,
      "Cüce": true,
      "Çadırkaya": true,
      "Çakırgümüş": true,
      "Çamlıköy": true,
      "Daldere": true,
      "Deliahmetoğlu": true,
      "Derinöz": true,
      "Doğankaş": true,
      "Eynekaraca": true,
      "Günkoru": true,
      "Gürün": true,
      "Güvenli": true,
      "Hacıalipınar": true,
      "Hamamayağı": true,
      "Hamitköy": true,
      "Hasırcı": true,
      "Hızarbaşı": true,
      "İbi": true,
      "İsasofta": true,
      "İskaniye": true,
      "Kabacagöz": true,
      "Karaabdal": true,
      "Kıranboğaz": true,
      "Kızılsini": true,
      "Kirazpınar": true,
      "Koğa": true,
      "Köseoğlu": true,
      "Kuyucak": true,
      "Küçükkızoğlu": true,
      "Küpecik": true,
      "Mazlumoğlu": true,
      "Meşepınarı": true,
      "Nusratlı": true,
      "Oymapınar": true,
      "Salur": true,
      "Sanayi": true,
      "Saray": true,
      "Sarıgazel": true,
      "Sarıksızoğlu": true,
      "Soğanlı": true,
      "Söğütlü": true,
      "Şehreküstü": true,
      "Şıhlı": true,
      "Tatlıcak": true,
      "Teberoğlu": true,
      "Tüfekçidere": true,
      "Yenicami": true,
      "Yukarıgölyazı": true,
      "Yumaklı": true,
      "Yuvacık": true
    },
    "Salıpazarı": {
      "Alan": true,
      "Alanyaykın": true,
      "Albak": true,
      "Avut": true,
      "Bereket": true,
      "Biçme": true,
      "Cevizli": true,
      "Çağlayan": true,
      "Çiçekli": true,
      "Dikencik": true,
      "Düzköy": true,
      "Esatçiftliği": true,
      "Fatsalılar": true,
      "Fındıklı": true,
      "Fidancık": true,
      "Gökçebaşı": true,
      "Gökçeli": true,
      "Güzelvatan": true,
      "Kalfalı": true,
      "Karacalar": true,
      "Karacaören": true,
      "Karadere": true,
      "Karaman": true,
      "Karayonca": true,
      "Kırgıl": true,
      "Kızılot": true,
      "Kocalar": true,
      "Konakören": true,
      "Kuşcuğaz": true,
      "Merkez Kocalar": true,
      "Mumlu": true,
      "Muslubey": true,
      "Orta": true,
      "Sarıhasan": true,
      "Suluca": true,
      "Tacalan": true,
      "Tahnal": true,
      "Tepealtı": true,
      "Yavaşbey": true,
      "Yayla": true,
      "Yeni": true,
      "Yenidoğan": true,
      "Yeşil": true,
      "Yukarıkestanepınar": true
    },
    "Tekkeköy": {
      "19 Mayıs": true,
      "23 Nisan": true,
      "Akbaşlar": true,
      "Altınkaya": true,
      "Antyeri": true,
      "Asarağaç": true,
      "Bakacak": true,
      "Balcalı": true,
      "Başköy": true,
      "Beyoğlu": true,
      "Büyüklü": true,
      "Cumhuriyet": true,
      "Çay": true,
      "Çayırçökek": true,
      "Çayleyik": true,
      "Çınaralan": true,
      "Çırakman": true,
      "Çiftlik": true,
      "Çimenli": true,
      "Çinik": true,
      "Erenköy": true,
      "Fındıcak": true,
      "Gökçe": true,
      "Gökçedere": true,
      "Gölceğiz": true,
      "Güzelyurt": true,
      "Hamzalı": true,
      "Hürriyet": true,
      "İstiklal": true,
      "Kababürük": true,
      "Kahyalı": true,
      "Karaoğlan": true,
      "Karaperçin": true,
      "Kargılı": true,
      "Karışlar": true,
      "Kerimbey": true,
      "Kerpiçli": true,
      "Kışla": true,
      "Kibarlar": true,
      "Kirazlık": true,
      "Köprübaşı": true,
      "Kurtuluş": true,
      "Kutlukent": true,
      "Ovabaşı": true,
      "Pınar": true,
      "Sanayi": true,
      "Sarıyurt": true,
      "Selyeri": true,
      "Seymenler": true,
      "Sıtmasuyu": true,
      "Şabanoğlu": true,
      "Yağbasan": true,
      "Yavuzlar": true,
      "Yaylageriş": true,
      "Yazılar": true,
      "Yeni Büyüklü": true,
      "Yenidoğan": true,
      "Yeniköy": true,
      "Yeşilalan": true,
      "Yeşildere": true,
      "Yeşilyurt": true,
      "Yukarıçinik": true,
      "Zafer": true
    },
    "Terme": {
      "Ahmetbey": true,
      "Akbucak": true,
      "Akçagün": true,
      "Akçay": true,
      "Akçaykaracalı": true,
      "Altunlu": true,
      "Ambartepe": true,
      "Aşağıhüseyinmescit": true,
      "Aybeder": true,
      "Bafracalı": true,
      "Bağsaray": true,
      "Bahçelievler": true,
      "Bazlamaç": true,
      "Beşikli": true,
      "Cılar": true,
      "Cumhuriyet": true,
      "Çağlayan": true,
      "Çamlıca": true,
      "Çanaklı": true,
      "Çangallar": true,
      "Çardak": true,
      "Çay": true,
      "Dağdıralı": true,
      "Dereyol": true,
      "Dibekli": true,
      "Dutluk": true,
      "Eğercili": true,
      "Elmaköy": true,
      "Elmalık": true,
      "Emiryusuf": true,
      "Erenköy": true,
      "Etyemezli": true,
      "Evci": true,
      "Fenk": true,
      "Geçmiş": true,
      "Gökçeağaç": true,
      "Gölyazı": true,
      "Gündoğdu": true,
      "Hüseyinmescit": true,
      "İlimdağ": true,
      "İmanalisi": true,
      "Karacaköy": true,
      "Karacalı": true,
      "Karamahmut": true,
      "Karkucak": true,
      "Kazımkarabekirpaşa": true,
      "Kesikkaya": true,
      "Kocaman": true,
      "Kocamanbaşı": true,
      "Kozluk": true,
      "Köybucağı": true,
      "Kumcığaz": true,
      "Kuşca": true,
      "Kuşculu": true,
      "Mescitli": true,
      "Meşeyazı": true,
      "Muratlı": true,
      "Oğuzlu": true,
      "Ortasöğütlü": true,
      "Örencik": true,
      "Özyurt": true,
      "Sakarlı": true,
      "Sancaklı": true,
      "Sarayköy": true,
      "Sivaslılar": true,
      "Söğütlü": true,
      "Sütözü": true,
      "Şeyhli": true,
      "Şuayip": true,
      "Taşlık": true,
      "Taşpınar": true,
      "Uludere": true,
      "Uzungazi": true,
      "Yalı": true,
      "Yeni": true,
      "Yenicami": true,
      "Yenidoğan": true,
      "Yerli": true,
      "Yukarısöğütlü": true,
      "Yukarıtaşpınar": true,
      "Yunus Emre": true,
      "Yüksekyayla": true
    },
    "Vezirköprü": {
      "Abdulgani": true,
      "Adatepe": true,
      "Ağcaalan": true,
      "Ağcayazı": true,
      "Ahmetbaba": true,
      "Akören": true,
      "Alan": true,
      "Alanbaşı": true,
      "Alancık": true,
      "Alanşeyhi": true,
      "Altınkaya": true,
      "Arıca": true,
      "Atatürk": true,
      "Avdan": true,
      "Aydınlı": true,
      "Aydoğdu": true,
      "Ayvalı": true,
      "Bahçekonak": true,
      "Bahçelievler": true,
      "Bahçesaray": true,
      "Bakla": true,
      "Başalan": true,
      "Başfakı": true,
      "Bayram": true,
      "Bektaş": true,
      "Belalan": true,
      "Beşpınar": true,
      "Boğa": true,
      "Boğazkoru": true,
      "Boruk": true,
      "Burhaniye": true,
      "Büyükkale": true,
      "Cebeli": true,
      "Cumhuriyet": true,
      "Çakırtaş": true,
      "Çal": true,
      "Çalman": true,
      "Çaltu": true,
      "Çamlıca": true,
      "Çamlıdere": true,
      "Çamlıkonak": true,
      "Çanaklı": true,
      "Çayırbaşı": true,
      "Çekalan": true,
      "Çekmeden": true,
      "Çeltek": true,
      "Çorakdere": true,
      "Darıçay": true,
      "Darıçayalanı": true,
      "Değirmenbaşı": true,
      "Devalan": true,
      "Doyran": true,
      "Duruçay": true,
      "Elaldı": true,
      "Elbeği": true,
      "Elmalı": true,
      "Esen": true,
      "Esentepe": true,
      "Esenyurt": true,
      "Fazıl Ahmet Paşa": true,
      "Göl": true,
      "Göl Yeni": true,
      "Göllüalan": true,
      "Gömlekhisar": true,
      "Güder": true,
      "Güldere": true,
      "Habibfakı": true,
      "Hacılı": true,
      "Halilbaba": true,
      "Halkahavlı": true,
      "Hayranlı": true,
      "Hıdırlık": true,
      "İmircik": true,
      "İncesu": true,
      "İnkaya": true,
      "Kabalı": true,
      "Kadıçayırı": true,
      "Kadıoğlu": true,
      "Kapaklı": true,
      "Kapaklıeşme": true,
      "Kaplancık": true,
      "Karabük": true,
      "Karacaören": true,
      "Karadoruk": true,
      "Karaköy": true,
      "Karanar": true,
      "Karapınar": true,
      "Karkucak": true,
      "Karlı": true,
      "Kavakpınarı": true,
      "Kılıçgüney": true,
      "Kıranalan": true,
      "Kıratbükü": true,
      "Kırma": true,
      "Kızılcakoru": true,
      "Kızılcaören": true,
      "Kızılkese": true,
      "Kocakaya": true,
      "Kovalı": true,
      "Köprübaşı": true,
      "Kumral": true,
      "Kuruçay": true,
      "Kuşcular": true,
      "Kuyaş": true,
      "Kuyumcu": true,
      "Küçükkale": true,
      "Kületek": true,
      "Mahmatlı": true,
      "Mehmet Paşa": true,
      "Melikli": true,
      "Meşeli": true,
      "Mezraa": true,
      "Nalbantlı": true,
      "Narlısaray": true,
      "Orta": true,
      "Ortacami": true,
      "Oruç": true,
      "Ovacık": true,
      "Oymaağaç": true,
      "Öğürlü": true,
      "Örencik": true,
      "Özesentepe": true,
      "Özgüney": true,
      "Özkuruçay": true,
      "Özyörük": true,
      "Paşa": true,
      "Pazarcı": true,
      "Samukalan": true,
      "Samur": true,
      "Saraycık": true,
      "Saraylı": true,
      "Sarıalan": true,
      "Sarıdibek": true,
      "Sarıyar": true,
      "Sırbaşmak": true,
      "Sofular": true,
      "Soğucak": true,
      "Susuz": true,
      "Şentepe": true,
      "Tabakhane": true,
      "Tahtaköprü": true,
      "Taşkale": true,
      "Taşlıyük": true,
      "Tatarkale": true,
      "Teberük": true,
      "Tekkekıran": true,
      "Tepeören": true,
      "Tikenli": true,
      "Türkmen": true,
      "Yağcı": true,
      "Yağınözü": true,
      "Yarbaşı": true,
      "Yeni": true,
      "Yeniçelik": true,
      "Yenidüzce": true,
      "Yeşilada": true,
      "Yeşiltepe": true,
      "Yolpınar": true,
      "Yukarınarlı": true,
      "Yurtdağı": true,
      "Yürükçal": true
    },
    "Yakakent": {
      "Asmapınar": true,
      "Büyükkırık": true,
      "Çamalan": true,
      "Çepni": true,
      "Gündüzlü": true,
      "Karaaba": true,
      "Kayalı": true,
      "Kozköy": true,
      "Kuzören": true,
      "Küplüağzı": true,
      "Kürüz": true,
      "Liman": true,
      "Merkez": true,
      "Mutaflı": true,
      "Sarıgöl": true,
      "Yassıdağ": true,
      "Yeşilköy": true
    }
  },
  "Siirt": {
    "Baykan": {
      "Atabağı": true,
      "Atatürk": true,
      "Cefan": true,
      "Çay": true,
      "Havel": true,
      "İnönü": true,
      "Karşıyaka": true,
      "Şeyhosman": true,
      "Yenidoğan": true
    },
    "Eruh": {
      "Dih": true,
      "Fatih": true,
      "Sarıgül": true
    },
    "Kurtalan": {
      "Bağlar": true,
      "Bahçelievler": true,
      "Cumhuriyet": true,
      "Çeşme": true,
      "Dicle": true,
      "Fırat": true,
      "Garzan": true,
      "Güney": true,
      "Kayalı": true,
      "Kültür": true,
      "Seyrantepe": true,
      "Sümer": true,
      "Tekel": true,
      "Yayıkdere": true,
      "Yeni": true,
      "Yenidoğan": true
    },
    "Merkez": {
      "Afetevleri": true,
      "Alan": true,
      "Algül": true,
      "Bağlar": true,
      "Bahçelievler": true,
      "Barış": true,
      "Batı": true,
      "Conkbayır": true,
      "Çal": true,
      "Doğan": true,
      "Dumlupınar": true,
      "Halenze": true,
      "İnönü": true,
      "Karakol": true,
      "Koçpınar": true,
      "Kooperatif": true,
      "Sakarya": true,
      "Tınaztepe": true,
      "Ulus": true,
      "Ülkü": true,
      "Veysel Karani": true,
      "Yeni": true
    },
    "Pervari": {
      "Aydın": true,
      "Gazi": true,
      "Kale": true,
      "Şakiran": true
    },
    "Şirvan": {
      "Bağcılar": true,
      "Fatih": true,
      "Kırtepe": true,
      "Küfre": true,
      "Sit": true
    },
    "Tillo": {
      "Fakirullah": true,
      "Mücahit": true,
      "Saydanlar": true
    }
  },
  "Sinop": {
    "Ayancık": {
      "Beşiktaş": true,
      "Cevizli": true,
      "Çayiçi": true,
      "Denizciler": true,
      "Yalı": true
    },
    "Boyabat": {
      "Camiikebir": true,
      "Çamlıca": true,
      "Esentepe": true,
      "Gökdere": true,
      "Kumluk": true,
      "Sefa": true,
      "Yeni": true,
      "Yıldız": true,
      "Zincirlikuyu": true
    },
    "Dikmen": {
      "Babalıoğlu": true,
      "Çorak": true,
      "Kırçal": true
    },
    "Durağan": {
      "Altınkaya": true,
      "Buzluk": true,
      "Gökırmak": true,
      "Merkez": true,
      "Yandak": true,
      "Yeşilyurt": true
    },
    "Erfelek": {
      "Kınık": true,
      "Merkez": true,
      "Salavat": true
    },
    "Gerze": {
      "19 Mayıs": true,
      "Atatürk": true,
      "Cumhuriyet": true,
      "Çarşı": true,
      "Hamidiye": true,
      "Köşk": true,
      "Yeni": true
    },
    "Merkez": {
      "Ada": true,
      "Bostancılı": true,
      "Camikebir": true,
      "Gelincik": true,
      "İncedayı": true,
      "Kaleyazısı": true,
      "Kefevi": true,
      "Korucuk": true,
      "Meydankapı": true,
      "Ordu": true,
      "Osmaniye": true,
      "Yeni": true,
      "Zeytinlik": true
    },
    "Saraydüzü": {
      "Merkez": true
    },
    "Türkeli": {
      "Gemiyanı": true,
      "Güzelyurt": true,
      "Tümerkan": true,
      "Yalı": true
    }
  },
  "Sivas": {
    "Akıncılar": {
      "Altıntepe": true,
      "Cumhuriyet": true,
      "Gönen": true,
      "İkizyurt": true,
      "Yayla": true,
      "Yeni": true,
      "Yeşilyazı": true,
      "Yukarı": true
    },
    "Altınyayla": {
      "Altınyurt": true,
      "Aydın": true,
      "Başören": true,
      "Gaziosmanpaşa": true,
      "Güzeloğlan": true,
      "Kale": true,
      "Merkez": true,
      "Rıfat Öçten": true,
      "Serinyayla": true,
      "Şafak": true,
      "Yassıpınar": true,
      "Yeşilyurt": true
    },
    "Divriği": {
      "Abuçimen": true,
      "Ahmetpaşa": true,
      "Arhusu": true,
      "Aşağıhamam": true,
      "Ceditpaşa": true,
      "Demirdağ": true,
      "Dillioğlu": true,
      "Gökçecamii": true,
      "Güllübağ": true,
      "Hacıkumru": true,
      "Hacıosmanmescidi": true,
      "İmamoğlu": true,
      "Kale": true,
      "Kalealtı": true,
      "Karamahmut": true,
      "Karayusuf": true,
      "Kayacık": true,
      "Kemenkeş": true,
      "Kocapaşa": true,
      "Küçük Hüseyin": true,
      "Kültürlü": true,
      "Maden": true,
      "Mercantepe": true,
      "Purunsur": true,
      "Süleymanağa": true,
      "Turabali": true,
      "Ulucamii": true,
      "Zeliha Hatun": true
    },
    "Doğanşar": {
      "Camikebir": true,
      "Cinci": true,
      "Çay": true,
      "Devrişağa": true,
      "Kale": true,
      "Ömerağa": true
    },
    "Gemerek": {
      "Alaybey": true,
      "Ali Kemali Efendi": true,
      "Alperen": true,
      "Arpaözü": true,
      "Bahçeli": true,
      "Fevziçakmak": true,
      "Gaziosmanpaşa": true,
      "Horuk": true,
      "Kalebaşı": true,
      "Karacalar": true,
      "Köprübaşı": true,
      "Muhsin Yazıcıoğlu": true,
      "Subaşı": true,
      "Ş.binbaşı Mehmet Aras": true,
      "Uğur Mumcu": true,
      "Yeni": true,
      "Yenidoğan": true,
      "Yenihayat": true,
      "Yukarı": true
    },
    "Gölova": {
      "A.camii": true,
      "Alsancak": true,
      "Çalkaya": true,
      "Fevzi Çakmak": true
    },
    "Gürün": {
      "Aksu": true,
      "Boğaziçi": true,
      "Burçevi": true,
      "Çayboyu": true,
      "Çörten": true,
      "Gökpınar": true,
      "Hacılar": true,
      "Işıtan": true,
      "Karatepe": true,
      "Karayar": true,
      "Karşıyaka": true,
      "Ketençayır": true,
      "Kirazlık": true,
      "Kurultay": true,
      "Pınarönü": true,
      "Şuğul": true,
      "Yassıcatepe": true,
      "Yeni": true,
      "Yeşilyurt": true
    },
    "Hafik": {
      "Çay": true,
      "Fatih": true,
      "Günyamaç": true,
      "Koç": true,
      "Tepe": true,
      "Yeni": true
    },
    "İmranlı": {
      "Çarşıbaşı": true,
      "Durcan": true,
      "Karatekin": true,
      "Karşıyaka": true,
      "Kızılırmak": true,
      "Valituncel": true,
      "Yaylacık": true,
      "Yeni": true,
      "Yenidoğan": true
    },
    "Kangal": {
      "Göze": true,
      "Gürsel": true,
      "Hürriyet": true,
      "Karşıyaka": true,
      "Reşadiye": true,
      "Sularbaşı": true,
      "Yeni": true,
      "Zafer": true
    },
    "Koyulhisar": {
      "Aşağıkale": true,
      "Camiikebir": true,
      "Orta": true,
      "Subaşı": true,
      "Şeyhler": true,
      "Tuğladağı": true,
      "Yukarıkale": true
    },
    "Merkez": {
      "Abdulvahabigazi": true,
      "Ahmet Turangazi": true,
      "Akdeğirmen": true,
      "Alibaba": true,
      "Altuntabak": true,
      "Aydoğan": true,
      "Bahtiyarbostan": true,
      "Cami-i Kebir": true,
      "Çarşıbaşı": true,
      "Çayboyu": true,
      "Çayyurt": true,
      "Çiçekli": true,
      "Danişmentgazi": true,
      "Dedebalı": true,
      "Demircilerardı": true,
      "Diriliş": true,
      "Dörteylül": true,
      "Ece": true,
      "Eğriköprü": true,
      "Emek": true,
      "Esentepe": true,
      "Esenyurt": true,
      "Eskikale": true,
      "Fatih": true,
      "Ferhatbostan": true,
      "Fevziçakmak": true,
      "Gökçebostan": true,
      "Gökmedrese": true,
      "Gültepe": true,
      "Gülyurt": true,
      "Halil Rıfatpaşa": true,
      "Huzur": true,
      "İnönü": true,
      "İstiklal": true,
      "Kadı Burhanettin": true,
      "Kaleardı": true,
      "Kardeşler": true,
      "Karşıyaka": true,
      "Kılavuz": true,
      "Kızılırmak": true,
      "Küçükminare": true,
      "Kümbet": true,
      "Mehmet Akif Ersoy": true,
      "Mehmetpaşa": true,
      "Meraküm": true,
      "Mevlana": true,
      "Mısmılırmak": true,
      "Mimar Sinan": true,
      "Orhangazi": true,
      "Örtülüpınar": true,
      "Paşabey": true,
      "Pulur": true,
      "Selçuklu": true,
      "Seyrantepe": true,
      "Sularbaşı": true,
      "Şehitömeryıldırım": true,
      "Şeyh Şamil": true,
      "Tuzlugöl": true,
      "Üçlerbey": true,
      "Yahyabey": true,
      "Yeni": true,
      "Yenidoğan": true,
      "Yenişehir": true,
      "Yeşilyurt": true,
      "Yiğitler": true,
      "Yunusemre": true,
      "Yüceyurt": true
    },
    "Suşehri": {
      "Avculu": true,
      "Camiiorta": true,
      "Cumhuriyet": true,
      "Göllüköy": true,
      "Gönüloğlu": true,
      "Karşıyaka": true,
      "Kemalpaşa": true,
      "Kışlalar": true,
      "Öksülü": true,
      "Taşköprü": true,
      "Tepeardı": true,
      "Yalnızbağlar": true,
      "Yeni": true
    },
    "Şarkışla": {
      "Bahçelievler": true,
      "Çiçekli": true,
      "Damlaca": true,
      "Doğu": true,
      "Esentepe": true,
      "Gültekin": true,
      "İstiklal": true,
      "Kale": true,
      "Kandemir": true,
      "Karşıyaka": true,
      "Kayalıyokuş": true,
      "Pınarönü": true,
      "Sağır": true,
      "Yeni": true,
      "Yıldırım": true,
      "Yukarı": true
    },
    "Ulaş": {
      "Esentepe": true,
      "Hürriyet": true,
      "Yenikarahisar": true,
      "Yeşilyurt": true
    },
    "Yıldızeli": {
      "Aydın": true,
      "Camii": true,
      "Cumhuriyet": true,
      "Çamlıbel": true,
      "Fatihsultanmehmet": true,
      "Fevzi Çakmak": true,
      "Kargın": true,
      "Karşıyaka": true,
      "Mehmetakifersoy": true,
      "Reşadiye": true,
      "Salihiye": true,
      "Selamet": true,
      "Yenicamii": true,
      "Yeşilyurt": true
    },
    "Zara": {
      "Ahmetbaşyurt": true,
      "Çarşıbaşı": true,
      "Hatip": true,
      "Karşıyaka": true,
      "Kızılırmak": true,
      "Reşitpaşa": true,
      "Şehitler": true,
      "Şeyhmerzuban": true,
      "Yenicamii": true
    }
  },
  "Şanlıurfa": {
    "Akçakale": {
      "Acıkuyu": true,
      "Adnan Menderes": true,
      "Akbilek": true,
      "Akçaköy": true,
      "Akçalı": true,
      "Akdiken": true,
      "Akkeçi": true,
      "Aksahrınç": true,
      "Alatlar": true,
      "Alıncık": true,
      "Arıcan": true,
      "Aslanlı": true,
      "Aşağıbeydaş": true,
      "Aşağıçinpolat": true,
      "Aşağıderen": true,
      "Atatürk": true,
      "Aydınlı": true,
      "Ayranlı": true,
      "Ayyıldız": true,
      "Baykuş": true,
      "Bilece": true,
      "Bolatlar": true,
      "Boybeyi": true,
      "Buket": true,
      "Bulutlu": true,
      "Büyücek": true,
      "Büyüknaneli": true,
      "Büyüktaş": true,
      "Büyüktokaç": true,
      "Cevher": true,
      "Ceylanlı": true,
      "Çakırlar": true,
      "Çokalan": true,
      "Çömlekçi": true,
      "Çukurca": true,
      "Deniz": true,
      "Dibek": true,
      "Donandı": true,
      "Dorumali": true,
      "Düzce": true,
      "Edebey": true,
      "Eke": true,
      "Ekinyazı": true,
      "Erdemler": true,
      "Erecek": true,
      "Fatih Sultan Mehmet": true,
      "Fevzi Çakmak": true,
      "Fişenge": true,
      "Geçittepe": true,
      "Gölbaşı": true,
      "Gülveren": true,
      "Gündaş": true,
      "Güneren": true,
      "Güvenç": true,
      "Hacıekber": true,
      "Hürriyet": true,
      "İkizce": true,
      "İncedere": true,
      "Karatepe": true,
      "Kayaca": true,
      "Kayalık": true,
      "Keçili": true,
      "Kelebek": true,
      "Kepezli": true,
      "Kılıçlı": true,
      "Kırmıtlı": true,
      "Koruklu": true,
      "Köseören": true,
      "Kurudere": true,
      "Küçük Hacıekber": true,
      "Mavitaş": true,
      "Menzil": true,
      "Mermer": true,
      "Mil": true,
      "Narlıova": true,
      "Nimet": true,
      "Nusretiye": true,
      "Ohali": true,
      "Okaylar": true,
      "Onortak": true,
      "Ortaderen": true,
      "Ortaören": true,
      "Osmanlı": true,
      "Öncül": true,
      "Pekmezli": true,
      "Sakça": true,
      "Salihler": true,
      "Sevimli": true,
      "Seyrantepe": true,
      "Sınırgören": true,
      "Süleymanşah": true,
      "Şahinler": true,
      "Şahinsoylu": true,
      "Şanlı": true,
      "Şefkat": true,
      "Şehitnusretbey": true,
      "Taşkınlar": true,
      "Tatlıca": true,
      "Topçu": true,
      "Turgut Özal": true,
      "Tuzluca": true,
      "Uğraklı": true,
      "Uğurhan": true,
      "Uğurtaş": true,
      "Vize": true,
      "Yağmuralan": true,
      "Yalınlı": true,
      "Yazlıca": true,
      "Yediyol": true,
      "Yeni": true,
      "Yenişehir": true,
      "Yeşerti": true,
      "Yukarı Çukurca": true,
      "Yukarıbeydaş": true,
      "Yukarıçinpolat": true,
      "Yukarıderen": true,
      "Yusufbey": true,
      "Zenginova": true,
      "Zeytindalı": true,
      "Zorlu": true
    },
    "Birecik": {
      "Abdallı": true,
      "Akarçay": true,
      "Akpınar": true,
      "Almaşar": true,
      "Altınova": true,
      "Arslanlı": true,
      "Aşağı Fatmacık": true,
      "Aşağı Habip": true,
      "Aşağı Karkutlu": true,
      "Aşağı Kuyucak": true,
      "Aşağıalmaşar": true,
      "Aşağıeşme": true,
      "Ayran": true,
      "Bağlarbaşı": true,
      "Bahçeönü": true,
      "Bentbahçesi": true,
      "Bozdere": true,
      "Boztepe": true,
      "Böğürtlen": true,
      "Cibinören": true,
      "Cumhuriyet": true,
      "Çiçekalan": true,
      "Çiftlik": true,
      "Çoğan": true,
      "Dağören": true,
      "Dalocak": true,
      "Damlıca": true,
      "Dışlık": true,
      "Diktepe": true,
      "Divriği": true,
      "Dorucak": true,
      "Duyduk": true,
      "Düzlüce": true,
      "Ekenek": true,
      "Geçittepe": true,
      "Göktepe": true,
      "Günışığı": true,
      "Güvenir": true,
      "Güzelyurt": true,
      "Han": true,
      "Haydarahmet": true,
      "Hoca Şerif": true,
      "Ilgar": true,
      "İnceler": true,
      "İncirli": true,
      "İncirlidere": true,
      "İnnaplı": true,
      "Karababa": true,
      "Karşıyaka": true,
      "Keskince": true,
      "Kocaali": true,
      "Konak": true,
      "Kömağıl": true,
      "Kural": true,
      "Kurtuluş": true,
      "Kurucahöyük": true,
      "Mengelli": true,
      "Merkez": true,
      "Meteler": true,
      "Meyanca": true,
      "Meydan": true,
      "Mezra": true,
      "Orta Fatmacık": true,
      "Özveren": true,
      "Saha": true,
      "Sancak": true,
      "Sekili": true,
      "Söğürtlen": true,
      "Sumaklı": true,
      "Surtepe": true,
      "Şekerköy": true,
      "Tüten": true,
      "Uğurcuk": true,
      "Ünsal": true,
      "Yaylacık": true,
      "Yeniakpınar": true,
      "Yılmaz": true,
      "Yukarı Karabaş": true,
      "Yukarıhabib": true,
      "Yukarıincirli": true,
      "Yukarıyeniçağ": true,
      "Yuvacık": true,
      "Ziyaret": true
    },
    "Bozova": {
      "75.yıl": true,
      "Akmağara": true,
      "Altınlı": true,
      "Argıncık": true,
      "Arıkök": true,
      "Arpalı": true,
      "Avlak": true,
      "Aylan": true,
      "Bağlıca": true,
      "Baltaş": true,
      "Binekli": true,
      "Biris": true,
      "Boztepe": true,
      "Budaklı": true,
      "Buğluca": true,
      "Bulancak": true,
      "Büyükhan": true,
      "Çakmaklı": true,
      "Çatak": true,
      "Deliler": true,
      "Denizbacı": true,
      "Dutluca": true,
      "Dutluk": true,
      "Eskin": true,
      "Fevzi Çakmak": true,
      "Gerdek": true,
      "Gökören": true,
      "Gölbaşı": true,
      "Göynik": true,
      "Gözenek": true,
      "Hacıköy": true,
      "Hacılar": true,
      "Hisarlar": true,
      "İkizköy": true,
      "İncirli": true,
      "Kabacık": true,
      "Karaca": true,
      "Karacaören": true,
      "Karakaş": true,
      "Karapınar": true,
      "Kargılı": true,
      "Kepirce": true,
      "Kesmetaş": true,
      "Kevik": true,
      "Kılçık": true,
      "Kılıçören": true,
      "Kındırali": true,
      "Kırağılı": true,
      "Kırmızıpınar": true,
      "Kızlar": true,
      "Killik": true,
      "Koçhisar": true,
      "Koçveran": true,
      "Konuksever": true,
      "Köseşahin": true,
      "Küpeli": true,
      "Maşuk": true,
      "Mülkören": true,
      "Narsait": true,
      "Norçin": true,
      "Ortaören": true,
      "Ortatepe": true,
      "Örgülü": true,
      "Özgören": true,
      "Pirhalil": true,
      "Sağırlı": true,
      "Saluc": true,
      "Seyitören": true,
      "Sığırcık": true,
      "Sızan": true,
      "Soğukkuyu": true,
      "Söğütlü": true,
      "Şanlıavşar": true,
      "Şıhlar": true,
      "Taşan": true,
      "Tatarhüyük": true,
      "Tozluca": true,
      "Tunalı": true,
      "Türkmenören": true,
      "Uzunburç": true,
      "Üçdirek": true,
      "Ürünlü": true,
      "Yalıntaş": true,
      "Yaslıca": true,
      "Yavuz Selim": true,
      "Yaylak": true,
      "Yeşil Ova": true,
      "Zivanlı": true
    },
    "Ceylanpınar": {
      "15 Temmuz": true,
      "Adnan Menderes": true,
      "Akbulut": true,
      "Aktepe": true,
      "Alaca": true,
      "Altınköy": true,
      "Aşağıdoruklu": true,
      "Aşağıdurmuş": true,
      "Aşağıkarataş": true,
      "Avcılı": true,
      "Aydın": true,
      "Aydoğdu": true,
      "Bahçelievler": true,
      "Boğalı": true,
      "Büyükçaylı": true,
      "Büyükyenice": true,
      "Büyükyıldız": true,
      "Ceylan": true,
      "Cumhuriyet": true,
      "Damlacık": true,
      "Dikili": true,
      "Düzova": true,
      "Ensar": true,
      "Fatih Sultan Mehmet": true,
      "Gellegöç": true,
      "Gültepe": true,
      "Gümüş": true,
      "Han": true,
      "Işıklar": true,
      "Maden": true,
      "Mehmet Akif Ersoy": true,
      "Mevlana": true,
      "Muratlı": true,
      "Özbek": true,
      "Saraççeşme": true,
      "Selahaddin Eyyübi": true,
      "Seydo Atilla": true,
      "Sufra": true,
      "Tekinler": true,
      "Turgut Özal": true,
      "Ulucami": true,
      "Yalçınkaya": true,
      "Yeniköy": true,
      "Yenişehir": true,
      "Yeşiltepe": true,
      "Yoncalı": true,
      "Yukarıdoruklu": true,
      "Yukarıdurmuş": true,
      "Yukarıesence": true,
      "Yukarıkarataş": true,
      "Yukarıtaşlıdere": true,
      "Yüksektepe": true
    },
    "Eyyübiye": {
      "15 Temmuz": true,
      "Abdurrahmandede": true,
      "Açmalı": true,
      "Akabe": true,
      "Akçamescit": true,
      "Akdilek": true,
      "Akmağara": true,
      "Akmeşhet": true,
      "Akören": true,
      "Akşemsettin": true,
      "Alkanlı": true,
      "Altın": true,
      "Altınbaşak": true,
      "Altıntepe": true,
      "Ambartepe": true,
      "Apalı": true,
      "Asya": true,
      "Aşağıhemedan": true,
      "Aşağıkoçlu": true,
      "Aşağıyazıcı": true,
      "Atlıkonak": true,
      "Ayrancı": true,
      "Bağış": true,
      "Bakırtaş": true,
      "Bakışlar": true,
      "Banarlı": true,
      "Başgök": true,
      "Başgöze": true,
      "Başören": true,
      "Batıkent": true,
      "Bayraklı": true,
      "Beşat": true,
      "Beyazyaprak": true,
      "Beykapusu": true,
      "Bıçakçı": true,
      "Bildim": true,
      "Bozhöyük": true,
      "Buhara": true,
      "Bulduk": true,
      "Büyükdüzlük": true,
      "Büyükhan": true,
      "Büyükhancağız": true,
      "Büyükotluca": true,
      "Camikebir": true,
      "Çalışkanlar": true,
      "Çamurlu": true,
      "Dedeosman": true,
      "Dernek": true,
      "Dilimli": true,
      "Direkli": true,
      "Dolutepe": true,
      "Duruca": true,
      "Eyüpkent": true,
      "Eyyübiye": true,
      "Eyyüp Nebi": true,
      "Gelincik": true,
      "Göl": true,
      "Göldere": true,
      "Görenler": true,
      "Gözeller": true,
      "Gümüşkuşak": true,
      "Gümüşören": true,
      "Günbalı": true,
      "Güneş": true,
      "Güngören": true,
      "Güzelkuyu": true,
      "Hacıbayram": true,
      "Hacılar": true,
      "Hakimdede": true,
      "Haleplibahçe": true,
      "Hamzababa": true,
      "Hancığaz": true,
      "Hayati Harrani": true,
      "Horozköy": true,
      "İkizce": true,
      "Kadıkendi": true,
      "Kadıoğlu": true,
      "Kap": true,
      "Kaplanköy": true,
      "Karaali": true,
      "Karahisar": true,
      "Karakoyunlu": true,
      "Karaman": true,
      "Keberli": true,
      "Keçikıran": true,
      "Kendirci": true,
      "Keserdede": true,
      "Keskin": true,
      "Kınalı": true,
      "Kırçiçeği": true,
      "Kırkmağara": true,
      "Kızılkuyu": true,
      "Koçören": true,
      "Köprülük": true,
      "Kubacık": true,
      "Kurtuluş": true,
      "Kurucuk": true,
      "Küçük Çamurlu": true,
      "Küçükdüzlük": true,
      "Küçükhan": true,
      "Külünçe": true,
      "Küpeli": true,
      "Mance": true,
      "Mihraplı": true,
      "Muradiye": true,
      "Mutlukaya": true,
      "Nadire": true,
      "Olgunlar": true,
      "Olukyanı": true,
      "Onikiler": true,
      "Ortahemedan": true,
      "Osmanlı": true,
      "Ovabeyli": true,
      "Ozanlar": true,
      "Örenli": true,
      "Özlü": true,
      "Payamlı": true,
      "Pınarbaşı": true,
      "Ruha": true,
      "Sağlık": true,
      "Seksenören": true,
      "Selçuklu": true,
      "Selman": true,
      "Sultantepe": true,
      "Süleymanşah": true,
      "Şahinalan": true,
      "Şahinler": true,
      "Şıh Maksut": true,
      "Tarlabaşı": true,
      "Taşlıca": true,
      "Tekyamaç": true,
      "Tepe": true,
      "Topdağı": true,
      "Turluk": true,
      "Tuzluca": true,
      "Türkmeydanı": true,
      "Uğurlu": true,
      "Ulak": true,
      "Ulucanlar": true,
      "Uluköy": true,
      "Umuroba": true,
      "Üzerlik": true,
      "Vergili": true,
      "Yağmurlu": true,
      "Yakubiye": true,
      "Yamaçaltı": true,
      "Yanıkçöğür": true,
      "Yardımcı": true,
      "Yaşar": true,
      "Yaykılıç": true,
      "Yediyol": true,
      "Yeni": true,
      "Yenice": true,
      "Yeşildere": true,
      "Yolbaşı": true,
      "Yolbilir": true,
      "Yukarıçaykuyu": true,
      "Yukarıhemedan": true,
      "Yukarıkoçlu": true,
      "Yukarıyazıcı": true,
      "Yusuf": true,
      "Yusufpaşa": true,
      "Zeynepköy": true
    },
    "Halfeti": {
      "Altınova": true,
      "Argaç": true,
      "Argıl": true,
      "Aşağı Göklü": true,
      "Balaban": true,
      "Beyburcu": true,
      "Bitek": true,
      "Bozyazı": true,
      "Bulaklı": true,
      "Cumhuriyet": true,
      "Çakallı": true,
      "Çebekoğlu": true,
      "Dergili": true,
      "Durak": true,
      "Dutluca": true,
      "Erikli": true,
      "Fırat": true,
      "Fıstıközü": true,
      "Gözeli": true,
      "Gülaçan": true,
      "Günece": true,
      "Gürkuyu": true,
      "Gürlüce": true,
      "Hilalli": true,
      "Kalkan": true,
      "Kantarma": true,
      "Karaotlak": true,
      "Kavaklıca": true,
      "Kayalar": true,
      "Kınık": true,
      "Kurugöl": true,
      "Macunlu": true,
      "Narlık": true,
      "Ortayol": true,
      "Ömerli": true,
      "Özmüş": true,
      "Rüştiye": true,
      "Salmanlı": true,
      "Savaşan": true,
      "Saylakkaya": true,
      "Seldek": true,
      "Sırataşlar": true,
      "Siyahgül": true,
      "Sütveren": true,
      "Şimaliye": true,
      "Tavşanören": true,
      "Yeni": true,
      "Yeşilözen": true,
      "Yukarıgöklü": true
    },
    "Haliliye": {
      "Acaryurt": true,
      "Açıkyazı": true,
      "Ahmet Yesevi": true,
      "Akçalı": true,
      "Akdoğan": true,
      "Akpınar": true,
      "Aktaş": true,
      "Altındamla": true,
      "Altıntepe": true,
      "Anaz": true,
      "Aslanlı": true,
      "Asri": true,
      "Aşağı Içkara": true,
      "Aşağıakören": true,
      "Aşağıkoymat": true,
      "Aşağıvarlıca": true,
      "Atatürk": true,
      "Ayazca": true,
      "Bağlar": true,
      "Bağlarbaşı": true,
      "Bahçelievler": true,
      "Bakımlı": true,
      "Balkatan": true,
      "Ballıca": true,
      "Bamyasuyu": true,
      "Boncuk": true,
      "Boydere": true,
      "Büyükmirdesi": true,
      "Cengiz Topel": true,
      "Çamlıdere": true,
      "Çanakçı": true,
      "Çatallı": true,
      "Çekçek": true,
      "Çiçekli": true,
      "Çiçektepesi": true,
      "Çukurdoruç": true,
      "Dağeteği": true,
      "Dağyanı": true,
      "Dalbaşı": true,
      "Denizci": true,
      "Derinkuyu": true,
      "Derman": true,
      "Devteyşti": true,
      "Dikme": true,
      "Diktaş": true,
      "Diphisar": true,
      "Eğerkıran": true,
      "Emirler": true,
      "Ernebi": true,
      "Ertuğrul Gazi": true,
      "Esenyayla": true,
      "Göktepe": true,
      "Güçlü": true,
      "Gülveren": true,
      "Gümüştaş": true,
      "Gürpınar": true,
      "Güvenli": true,
      "Güzelköy": true,
      "Güzelyurt": true,
      "Halime": true,
      "Hamidiye": true,
      "Havşanlı": true,
      "Hızmalı": true,
      "İbrik": true,
      "İkiağız": true,
      "İmam Bakır": true,
      "İnci": true,
      "İncirağacı": true,
      "İncirli": true,
      "İpekyol": true,
      "İrice": true,
      "Kahraman": true,
      "Kalecik": true,
      "Kalınbayat": true,
      "Kamberiye": true,
      "Kanatlı": true,
      "Kanoğlu": true,
      "Kapaklı": true,
      "Karatepe": true,
      "Kargalı": true,
      "Karpuzlu": true,
      "Karsıyaka": true,
      "Kavakbaşı": true,
      "Kayalı": true,
      "Kaygılı": true,
      "Kaynaklı": true,
      "Keçili": true,
      "Kengerli": true,
      "Kepez": true,
      "Kepirli": true,
      "Keremli": true,
      "Kesme": true,
      "Kısas": true,
      "Kızılpınar": true,
      "Koçak": true,
      "Konaç": true,
      "Konak": true,
      "Konuklu": true,
      "Körkuyu": true,
      "Kösecik": true,
      "Köseköy": true,
      "Küçüksenemağara": true,
      "Mağaracık": true,
      "Mamuca": true,
      "Mehmetçik": true,
      "Mil": true,
      "Mimar Sinan": true,
      "Mutluca": true,
      "Nokta": true,
      "Oğulbey": true,
      "Ortaören": true,
      "Osman Gazi": true,
      "Osmanbey": true,
      "Örencik": true,
      "Parmakkapı": true,
      "Paşabağı": true,
      "Payamlı": true,
      "Perşembe": true,
      "Refahiye": true,
      "Sancaktar": true,
      "Sarışeyh": true,
      "Sarıtaş": true,
      "Sarpdere": true,
      "Sefalı": true,
      "Selahaddin Eyyübi": true,
      "Sendebelen": true,
      "Seyrantepe": true,
      "Sırrın": true,
      "Sultan Fatih": true,
      "Sumaklı": true,
      "Susuz": true,
      "Süleymaniye": true,
      "Şair Nabi": true,
      "Şair Şevket": true,
      "Şehitlik": true,
      "Şenocak": true,
      "Şeyhçoban": true,
      "Taşlıca": true,
      "Tekerli": true,
      "Tepedibi": true,
      "Tepeköy": true,
      "Terzi": true,
      "Topraklı": true,
      "Ulubağ": true,
      "Ulubatlı": true,
      "Uluhan": true,
      "Umut": true,
      "Uzunköy": true,
      "Üçgöze": true,
      "Üçkonak": true,
      "Üçkuyu": true,
      "Üzümkara": true,
      "Veysel Karani": true,
      "Yarımsu": true,
      "Yavuz Selim": true,
      "Yazılıkavak": true,
      "Yedikuyu": true,
      "Yenice": true,
      "Yeniköy": true,
      "Yenisu": true,
      "Yenişehir": true,
      "Yeroluk": true,
      "Yeşildirek": true,
      "Yeşilköy": true,
      "Yeşiltepe": true,
      "Yeşilyurt": true,
      "Yıldız": true,
      "Yolyazı": true,
      "Yukarıakören": true,
      "Yukarıkoymat": true
    },
    "Harran": {
      "15 Temmuz": true,
      "Ağcıl": true,
      "Ahmetkara": true,
      "Akkuş": true,
      "Alacalı": true,
      "Algılı": true,
      "Altılı": true,
      "Aralı": true,
      "Arın": true,
      "Aslankuyusu": true,
      "Aşağı Yeşilova": true,
      "Aşağıkesmekaya": true,
      "Aşağıyakınyol": true,
      "Aşağıyarımca": true,
      "Avlak": true,
      "Aydıncık": true,
      "Aydınlar": true,
      "Aydüştü": true,
      "Balkat": true,
      "Balkır": true,
      "Başak": true,
      "Başkaragöz": true,
      "Batıkonacık": true,
      "Bellitaş": true,
      "Bilgili": true,
      "Binekli": true,
      "Birelismet": true,
      "Bozceylan": true,
      "Bozyazı": true,
      "Buğdaytepe": true,
      "Buldum": true,
      "Bulgurlu": true,
      "Bükdere": true,
      "Büyüktaşlıca": true,
      "Büyüktürbe": true,
      "Cevizli": true,
      "Ceylangözü": true,
      "Cumhuriyet": true,
      "Çağbaşı": true,
      "Çaltılı": true,
      "Çatalhurma": true,
      "Çepkenli": true,
      "Çiçek": true,
      "Çiftçiler": true,
      "Çolpan": true,
      "Damlasu": true,
      "Dayanıklı": true,
      "Demirli": true,
      "Diriliş": true,
      "Doğukesmekaya": true,
      "Doğukonacık": true,
      "Doruç": true,
      "Duran": true,
      "Emekli": true,
      "Eskiharran": true,
      "Gazlıkuyu": true,
      "Giyimli": true,
      "Gögeç": true,
      "Gökçe": true,
      "Göktaş": true,
      "Gözcü": true,
      "Gürgelen": true,
      "Hazreti Imambakır": true,
      "Huzurlu": true,
      "Hz. Yakup": true,
      "İbni Teymiye": true,
      "İmambakır (merkez)": true,
      "Kabataş": true,
      "Karataş": true,
      "Kaymaklı": true,
      "Kılıçlı": true,
      "Kırmıtlı": true,
      "Koyunluca": true,
      "Kökenli": true,
      "Kuruyer": true,
      "Kuyukent": true,
      "Küçük Ekinli": true,
      "Küçükminare": true,
      "Küçükyıldız": true,
      "Küplüce": true,
      "Kütüklü": true,
      "Meydankapı": true,
      "Minare": true,
      "Miyanlı": true,
      "Oğulcuk": true,
      "Ortakonacık": true,
      "Öncüler": true,
      "Özbay": true,
      "Özlüce": true,
      "Öztaş": true,
      "Öztürk": true,
      "Parapara": true,
      "Sadak": true,
      "Sade": true,
      "Saide": true,
      "Savacık": true,
      "Seferköy": true,
      "Sehrince": true,
      "Selahaddin Eyyubi": true,
      "Selalmaz": true,
      "Soylu": true,
      "Sugeldi": true,
      "Süleyman Demirel": true,
      "Sütlüce": true,
      "Şehit Ali Aydar": true,
      "Şeyh Hayati Harrani": true,
      "Şuayipşehri": true,
      "Şükürali": true,
      "Tahılalan": true,
      "Tanınmış": true,
      "Tantana": true,
      "Taylıca": true,
      "Tekdal": true,
      "Tekneli": true,
      "Toytepe": true,
      "Tozluca": true,
      "Tüccariye": true,
      "Türkoğlu": true,
      "Uluağaç": true,
      "Uzunyol": true,
      "Üçdirek": true,
      "Ünlü": true,
      "Varlıalan": true,
      "Yakacık": true,
      "Yardımlı": true,
      "Yaygılı": true,
      "Yayvandoruk": true,
      "Yenice": true,
      "Yenidoğan": true,
      "Yeşilova": true,
      "Yolgider": true,
      "Yukarıkesmekaya": true,
      "Yukarıyakınyol": true,
      "Yukarıyarımca": true,
      "Yünlüce": true,
      "Zeytindalı": true
    },
    "Hilvan": {
      "Ağılmus": true,
      "Ağveren": true,
      "Akçakebir": true,
      "Akçaören": true,
      "Alpı": true,
      "Arabuk": true,
      "Arıca": true,
      "Arınık": true,
      "Arpalı": true,
      "Aslanlı": true,
      "Aşağıçatak": true,
      "Aşağıekece": true,
      "Aşağıkamış": true,
      "Aşağıkülünçe": true,
      "Aydınlı": true,
      "Bağlar": true,
      "Bahçecik": true,
      "Bahçelievler": true,
      "Balkı": true,
      "Barğaç": true,
      "Bölükbaşı": true,
      "Buğur": true,
      "Çağıllı": true,
      "Çakmak": true,
      "Çat": true,
      "Çimdeli": true,
      "Doğrular": true,
      "Faik": true,
      "Gelenek": true,
      "Göktepe": true,
      "Gölcük": true,
      "Gölebakan": true,
      "Gülaldı": true,
      "Güluşağı": true,
      "Gürgür": true,
      "Hanmağara": true,
      "Hayrat": true,
      "Hoşin": true,
      "İncirli": true,
      "Kadıkent": true,
      "Karaburç": true,
      "Karacurun": true,
      "Karakucak": true,
      "Karapınar": true,
      "Kavalık": true,
      "Kepirhisar": true,
      "Kepirkucak": true,
      "Kırbaşı": true,
      "Korgun": true,
      "Kovancı": true,
      "Kuskunlu": true,
      "Küçükgölcük": true,
      "Malören": true,
      "Mantarlı": true,
      "Orgız": true,
      "Ovacık": true,
      "Oymaağaç": true,
      "Ömerli": true,
      "Özbaş": true,
      "Özveren": true,
      "Saluca": true,
      "Söğütlü": true,
      "Sucuhan": true,
      "Ustahasan": true,
      "Uzuncuk": true,
      "Üçüzler": true,
      "Yakınyurt": true,
      "Yeni": true,
      "Yeşerdi": true,
      "Yuvacalı": true
    },
    "Karaköprü": {
      "Ağılcık": true,
      "Ağızhan": true,
      "Akbayır": true,
      "Akçahisar": true,
      "Akıncı": true,
      "Akpınar": true,
      "Akpıyar": true,
      "Ali Baba": true,
      "Apaydın": true,
      "Aşağıçiftlik": true,
      "Aşıkköy": true,
      "Atakent": true,
      "Ayanlar": true,
      "Bahçeli": true,
      "Başören": true,
      "Batıkent": true,
      "Bezirci": true,
      "Bozköy": true,
      "Bölücek": true,
      "Buğdayhüyük": true,
      "Büyük Akziyaret": true,
      "Büyükalanlı": true,
      "Büyükçömlekçi": true,
      "Büyükkargılı": true,
      "Büyükördek": true,
      "Büyüksalkım": true,
      "Cemal": true,
      "Çakmak": true,
      "Çamlıyayla": true,
      "Çankaya": true,
      "Çıralı": true,
      "Çiftekemer": true,
      "Demircik": true,
      "Doğukent": true,
      "Dolunay": true,
      "Doyumlu": true,
      "Düğer": true,
      "Ergünköy": true,
      "Esemkulu": true,
      "Esentepe": true,
      "Estağfurullah": true,
      "Gazibey": true,
      "Geçitköy": true,
      "Gelibolu": true,
      "Göbekli": true,
      "Gölgen": true,
      "Gölpınar": true,
      "Güllübağ": true,
      "Günışık": true,
      "Hamurkesen": true,
      "Horzum": true,
      "Hüyüklü": true,
      "İlhan": true,
      "İsaören": true,
      "Karataş": true,
      "Karşıyaka": true,
      "Kasımkuyu": true,
      "Kırkpınar": true,
      "Kızılburç": true,
      "Kızlar": true,
      "Korukezen": true,
      "Köksüren": true,
      "Kuşluca": true,
      "Kuyucak": true,
      "Küçük Akziyaret": true,
      "Küçükalanlı": true,
      "Küçüktülmen": true,
      "Külaflı": true,
      "Lüleci": true,
      "Maşuk": true,
      "Mehmetçik": true,
      "Millisaray": true,
      "Mustafacık": true,
      "Narlıkuyu": true,
      "Otlukalan": true,
      "Öğütçü": true,
      "Örcünlü": true,
      "Överler": true,
      "Özgedik": true,
      "Pınarbaşı": true,
      "Sakça": true,
      "Sancak": true,
      "Sarım": true,
      "Seyrantepe": true,
      "Şahin": true,
      "Şeker": true,
      "Şenevler": true,
      "Şeyhzeliha": true,
      "Tatburcu": true,
      "Tülmen": true,
      "Türkmen": true,
      "Uzuncuk": true,
      "Yarımtepe": true,
      "Yaylacık": true,
      "Yedikuyu": true,
      "Yemişli": true,
      "Yığınak": true,
      "Yoğunburç": true,
      "Yukarıkoşma": true,
      "Yusufkuyu": true
    },
    "Siverek": {
      "Abdalağa": true,
      "Alagün": true,
      "Alanyurt": true,
      "Altaylı": true,
      "Altınahır": true,
      "Altınlı": true,
      "Altınpınar": true,
      "Anacak": true,
      "Armağanlı": true,
      "Aşağıalınca": true,
      "Aşağıkarabahçe": true,
      "Aşağıkaracaören": true,
      "Aşağıyalankoz": true,
      "Aşlıca": true,
      "Atmaca": true,
      "Avurtepe": true,
      "Ayrancı": true,
      "Ayvanat": true,
      "Azıklı": true,
      "Bağcı": true,
      "Bağlar": true,
      "Bahçe": true,
      "Bahçelievler": true,
      "Bakırca": true,
      "Baki": true,
      "Bakmaç": true,
      "Bardakçı": true,
      "Başbük": true,
      "Başdeğirmen": true,
      "Batı": true,
      "Bayırözü": true,
      "Benek": true,
      "Beyali": true,
      "Beybaba": true,
      "Beyçeri": true,
      "Beydeş": true,
      "Bozkuyu": true,
      "Bozlak": true,
      "Böğürtlen": true,
      "Bürüncek": true,
      "Büyükgöl": true,
      "Büyükkazanlı": true,
      "Büyükoba": true,
      "Büyüktepe": true,
      "Büyükyakıtlı": true,
      "Camikebir": true,
      "Canpolat": true,
      "Cinhisar": true,
      "Çağa": true,
      "Çağdaş": true,
      "Çanakçı": true,
      "Çatlı": true,
      "Çavuşlu": true,
      "Çaylarbaşı": true,
      "Çeltik": true,
      "Çepni": true,
      "Çevirme": true,
      "Çiftçibaşı": true,
      "Çubuklu": true,
      "Dağbaşı": true,
      "Damlıca": true,
      "Dardağan": true,
      "Darıcalı": true,
      "Deliktaş": true,
      "Dicle": true,
      "Dilekli": true,
      "Direkli": true,
      "Divan": true,
      "Doğukent": true,
      "Dönemeç": true,
      "Düğerin": true,
      "Ediz": true,
      "Eğriçay": true,
      "Endarlı": true,
      "Erbey": true,
      "Ergen": true,
      "Erkonağı": true,
      "Ertem": true,
      "Eskihan": true,
      "Esmer Çayı": true,
      "Fırat": true,
      "Fırın": true,
      "Gaziköy": true,
      "Gedik": true,
      "Gerçek": true,
      "Göğerçin": true,
      "Gözcek": true,
      "Gözelek": true,
      "Gözeli": true,
      "Gülabibey": true,
      "Güllice": true,
      "Gülpınar": true,
      "Güney": true,
      "Güney Karabahçe": true,
      "Gürakar": true,
      "Güvenli": true,
      "Güzelpınar": true,
      "Hacı Ömer": true,
      "Haliliye": true,
      "Hamamören": true,
      "Hamidiye": true,
      "Hasan Çelebi": true,
      "Hasırlı": true,
      "Hayriye": true,
      "İleri": true,
      "İnanlı": true,
      "Kale": true,
      "Kalemli": true,
      "Kalınağaç": true,
      "Kamışlı": true,
      "Kapıkaya": true,
      "Karabahçe": true,
      "Karacadağ": true,
      "Karadibek": true,
      "Karahisar": true,
      "Karakeçi": true,
      "Karakoyun": true,
      "Kargalı": true,
      "Karkaşı": true,
      "Karpuzcu": true,
      "Kavaklıdere": true,
      "Kavalık": true,
      "Kayalı": true,
      "Kayseri": true,
      "Keçiburcu": true,
      "Keçikıran": true,
      "Kesmekaya": true,
      "Keş": true,
      "Kıvançlı": true,
      "Konurtepe": true,
      "Kulaksız": true,
      "Kurbağalı": true,
      "Kuşlugöl": true,
      "Küçükgöl": true,
      "Küptepe": true,
      "Mezra": true,
      "Narlıkaya": true,
      "Nohut": true,
      "Ofis": true,
      "Oluklu": true,
      "Onar": true,
      "Ortanca": true,
      "Oyman": true,
      "Oyuktaş": true,
      "Önder": true,
      "Örgülü": true,
      "Özgöğercin": true,
      "Peynirci": true,
      "Sabancı": true,
      "Salor": true,
      "Sarıdam": true,
      "Sarıkaya": true,
      "Sarıören": true,
      "Savucak": true,
      "Selim Pınar": true,
      "Sislice": true,
      "Soydan": true,
      "Söylemez": true,
      "Sumaklı": true,
      "Şair Ibrahim Rafet": true,
      "Şekerli": true,
      "Şirinkuyu": true,
      "Tanrıverdi": true,
      "Taşağıl": true,
      "Taşhan": true,
      "Taşıkara": true,
      "Taşlı": true,
      "Turna": true,
      "Uzunpınar": true,
      "Uzunziyaret": true,
      "Ülkülü": true,
      "Üstüntaş": true,
      "Yeleken": true,
      "Yeniceli": true,
      "Yenişehir": true,
      "Yoğunca": true,
      "Yoğurtçu": true,
      "Yumrutepe": true,
      "Yuvar": true,
      "Yücelen": true,
      "Zincirliçay": true
    },
    "Suruç": {
      "Ağırtaş": true,
      "Akören": true,
      "Alanyurt": true,
      "Aligör": true,
      "Aşağıkarıncalı": true,
      "Aşağıoylum": true,
      "Aybastı": true,
      "Aydın": true,
      "Ayhan": true,
      "Balaban": true,
      "Barış": true,
      "Bellik": true,
      "Bilge": true,
      "Binatlı": true,
      "Boztepe": true,
      "Bozyokuş": true,
      "Büyükağacı": true,
      "Büyüksergen": true,
      "Büyükziyaret": true,
      "Cumhuriyet": true,
      "Çanakçı": true,
      "Çaykara": true,
      "Çengelli": true,
      "Çomak": true,
      "Demokrasi": true,
      "Dikili": true,
      "Dinlence": true,
      "Dumlukuyu": true,
      "Ekili": true,
      "Eskice": true,
      "Eskiören": true,
      "Ezgil": true,
      "Fıstıklı": true,
      "Göleç": true,
      "Gölen": true,
      "Günebakan": true,
      "Hacılı": true,
      "Harmanalan": true,
      "Hürriyet": true,
      "Hüyükyanı": true,
      "İzci": true,
      "Kalkanlı": true,
      "Kapucu": true,
      "Kara": true,
      "Karaca": true,
      "Karadut": true,
      "Karahüyük": true,
      "Karakuyu": true,
      "Karataş": true,
      "Keberli": true,
      "Kesmecik": true,
      "Kırmıt": true,
      "Kızılhüyük": true,
      "Köseler": true,
      "Köseveli": true,
      "Kurutepe": true,
      "Küçükköprü": true,
      "Küçükova": true,
      "Küçüksergen": true,
      "Küçükziyaret": true,
      "Mertismail": true,
      "Mollahamza": true,
      "Mürşitpınar": true,
      "Orta Bostancı": true,
      "Oymaklı": true,
      "Ölçektepe": true,
      "Özgören": true,
      "Özlüce": true,
      "Sarayaltı": true,
      "Saygın": true,
      "Taşlıkuyu": true,
      "Tavşanköy": true,
      "Tokçalı": true,
      "Topçular": true,
      "Uludüz": true,
      "Uysallı": true,
      "Üçpınar": true,
      "Ürkütlü": true,
      "Üveçli": true,
      "Yağışlı": true,
      "Yalınca": true,
      "Yalpı": true,
      "Yanaloba": true,
      "Yatırtepe": true,
      "Yaylatepe": true,
      "Yazıköy": true,
      "Yeğen": true,
      "Yenişehir": true,
      "Yıldırım": true,
      "Yıldız": true,
      "Yönlü": true,
      "Yukarıbostancı": true,
      "Yumurtalık": true,
      "Yurtçiçeği": true,
      "Zeyrek": true
    },
    "Viranşehir": {
      "Abalar": true,
      "Adaköy": true,
      "Akçataş": true,
      "Akkese": true,
      "Alakonak": true,
      "Altınbaşak": true,
      "Anıt": true,
      "Arısu": true,
      "Arıtır": true,
      "Aslanbaba": true,
      "Aşağıtınaz": true,
      "Atatürk": true,
      "Atıcılar": true,
      "Ayaklı": true,
      "Ayrıdüşen": true,
      "Azadi": true,
      "Bahçelievler": true,
      "Bakımlı": true,
      "Ballıca": true,
      "Başaran": true,
      "Başköy": true,
      "Beğrük": true,
      "Binekli": true,
      "Bozca": true,
      "Burç": true,
      "Büyükbardakçı": true,
      "Büyükçavuş": true,
      "Büyükgörümlü": true,
      "Büyükmutlu": true,
      "Ceylan": true,
      "Cumhuriyet": true,
      "Çalıcık": true,
      "Çamurlu": true,
      "Çiftçiler": true,
      "Çiftekuyu": true,
      "Çokran": true,
      "Dedeköy": true,
      "Defterdar": true,
      "Değim": true,
      "Demirci": true,
      "Dikili": true,
      "Dinçer": true,
      "Dinçkök": true,
      "Ekinciler": true,
      "Ekindöver": true,
      "Elbeğendi": true,
      "Elgün": true,
      "Emiroğlu": true,
      "Engelli": true,
      "Eser": true,
      "Eskikale": true,
      "Esvetoğlu": true,
      "Eşkin": true,
      "Evcimen": true,
      "Eyyüpnebi": true,
      "Germen": true,
      "Göğerli": true,
      "Göktepe": true,
      "Gölbaşı": true,
      "Gölcük": true,
      "Gömülü": true,
      "Gönüllü": true,
      "Gözeli": true,
      "Gözler": true,
      "Güleryüz": true,
      "Gürpınar": true,
      "Güzlek": true,
      "Hürriyet": true,
      "Işıldar": true,
      "İncirli": true,
      "İsa Harabesi": true,
      "Kadıköy": true,
      "Kale": true,
      "Karakuzu": true,
      "Karataş": true,
      "Karatepe": true,
      "Kargalı": true,
      "Karınca": true,
      "Kavurga": true,
      "Keçeli": true,
      "Kemerli": true,
      "Kervansarayı": true,
      "Kınalıtepe": true,
      "Kırbalı": true,
      "Kırkgöz": true,
      "Kışla": true,
      "Kızlarsarayı": true,
      "Kolağası": true,
      "Konakyeri": true,
      "Koşulu": true,
      "Kucak": true,
      "Kumçeşme": true,
      "Kurtulmuş": true,
      "Kururoğlu": true,
      "Küçükmutlu": true,
      "Küçüktopça": true,
      "Malta": true,
      "Mehmetçik": true,
      "Nergizli": true,
      "Oğlakçı": true,
      "Övüncük": true,
      "Özal": true,
      "Pınarlar": true,
      "Reyhanlı": true,
      "Sağırtaş": true,
      "Sakalar": true,
      "Samanlı": true,
      "Sarıbal": true,
      "Satıcık": true,
      "Sayoba": true,
      "Selahaddin Eyyubi": true,
      "Sepetli": true,
      "Sergen": true,
      "Sevgili": true,
      "Sözeri": true,
      "Süleymaniye": true,
      "Şahinli": true,
      "Şarkpınar": true,
      "Şehit": true,
      "Şırnak": true,
      "Tanyeli": true,
      "Taşönü": true,
      "Taşyaka": true,
      "Tekke": true,
      "Tekneli": true,
      "Tepedüzü": true,
      "Toklu": true,
      "Tunçbilek": true,
      "Türkeli": true,
      "Uğurlu": true,
      "Ulaklı": true,
      "Üçgül": true,
      "Yaban": true,
      "Yağızlar": true,
      "Yarpuz": true,
      "Yayık": true,
      "Yazgüneşi": true,
      "Yeni": true,
      "Yenişehir": true,
      "Yeşilalıç": true,
      "Yeşildurak": true,
      "Yıldız": true,
      "Yolbilen": true,
      "Yollarbaşı": true,
      "Yukarıbağ": true,
      "Yukarıdilimli": true,
      "Yukarışölenli": true,
      "Yüceler": true
    }
  },
  "Şırnak": {
    "Beytüşşebap": {
      "Aliçavuş": true,
      "Elki": true,
      "Karşıyaka": true,
      "Pınarbaşı": true
    },
    "Cizre": {
      "Ali Bey": true,
      "Caferi Sadık": true,
      "Cudi": true,
      "Cumhuriyet": true,
      "Çatal": true,
      "Dağ Kapı": true,
      "Dicle": true,
      "Dirsekli": true,
      "Fatih": true,
      "Kale": true,
      "Konak": true,
      "Kurtuluş": true,
      "Kuştepe": true,
      "Nur": true,
      "Sur": true,
      "Şah": true,
      "Vatan": true,
      "Yafes": true
    },
    "Güçlükonak": {
      "Bağlar": true,
      "Bahçelievler": true,
      "Cumhuriyet": true,
      "Gümüşyazı": true,
      "Karşıyaka": true,
      "Yeni": true
    },
    "İdil": {
      "Aşağı": true,
      "Atakent": true,
      "Dicle": true,
      "Fırat": true,
      "Şamil": true,
      "Temel": true,
      "Turgut Özal": true,
      "Yeni": true,
      "Yukarı": true
    },
    "Merkez": {
      "Aşağı": true,
      "Atatürk": true,
      "Aydınlar": true,
      "Aydınlıkevler": true,
      "Bahçelievler": true,
      "Boğaz": true,
      "Cumhuriyet": true,
      "Çadırlı": true,
      "Çavuşhan": true,
      "Dicle": true,
      "Gazi Paşa": true,
      "Gündoğdu": true,
      "Hatipler": true,
      "İsmet Paşa": true,
      "Nasırhan": true,
      "Şafak": true,
      "Şehrinuh": true,
      "Vakıfkent": true,
      "Yayla": true,
      "Yeni": true,
      "Yeşilyurt": true
    },
    "Silopi": {
      "Atatürk": true,
      "Bahçelievler": true,
      "Barbaros": true,
      "Başak": true,
      "Boğaz": true,
      "Cudi": true,
      "Cumhuriyet": true,
      "Dicle": true,
      "Fatih": true,
      "Karşıyaka": true,
      "Köprübaşı": true,
      "Nuh": true,
      "Ofis": true,
      "Şht. Harun Boy": true,
      "Vatan": true,
      "Yeni": true,
      "Yenişehir": true,
      "Yeşiltepe": true,
      "Yolağızı": true
    },
    "Uludere": {
      "Ayyıldız": true,
      "Başkaya": true,
      "Bulakbaşı": true,
      "Cumhuriyet.": true,
      "Gazi": true,
      "Gündoğdu": true,
      "Güneşli": true,
      "Kılaban": true,
      "Küçükçay": true,
      "Ödül": true,
      "Özelli": true,
      "Pınarbaşı": true,
      "Şehan": true,
      "Tanin": true,
      "Yenişehir": true,
      "Yeşilyova": true,
      "Yıldız": true
    }
  },
  "Tekirdağ": {
    "Çerkezköy": {
      "Bağlık": true,
      "Cumhuriyet": true,
      "Fatih": true,
      "Fevzi Paşa": true,
      "Gazi Mustafa Kemalpaşa": true,
      "Gazi Osman Paşa": true,
      "İstasyon": true,
      "Kızılpınar Atatürk": true,
      "Kızılpınar Gültepe": true,
      "Kızılpınar Namık Kemal": true,
      "Veliköy": true,
      "Yıldırım Beyazıt": true
    },
    "Çorlu": {
      "Alipaşa": true,
      "Cemaliye": true,
      "Cumhuriyet": true,
      "Çobançeşme": true,
      "Deregündüzlü": true,
      "Esentepe": true,
      "Hatip": true,
      "Havuzlar": true,
      "Hıdırağa": true,
      "Hürriyet": true,
      "Kazımiye": true,
      "Kemalettin": true,
      "Maksutlu": true,
      "Muhittin": true,
      "Nusratiye": true,
      "Önerler": true,
      "Reşadiye": true,
      "Rumeli": true,
      "Sarılar": true,
      "Seymen": true,
      "Silahtarağa": true,
      "Şahpaz": true,
      "Şeyhsinan": true,
      "Türkgücü": true,
      "Yenice": true,
      "Zafer": true
    },
    "Ergene": {
      "Ahimehmet": true,
      "Bakırca": true,
      "Cumhuriyet": true,
      "Esenler": true,
      "İğneler": true,
      "Karamehmet": true,
      "Kırkgöz": true,
      "Marmaracık": true,
      "Misinli": true,
      "Paşaköy": true,
      "Pınarbaşı": true,
      "Sağlık": true,
      "Ulaş": true,
      "Vakıflar": true,
      "Velimeşe": true,
      "Yeşiltepe": true,
      "Yulaflı": true
    },
    "Hayrabolu": {
      "Ataköy": true,
      "Avluobası": true,
      "Aydınevler": true,
      "Aydınlar": true,
      "Bayramşah": true,
      "Buzağcı": true,
      "Büyükkarakarlı": true,
      "Cambazdere": true,
      "Canhıdır": true,
      "Çene": true,
      "Çerkezmüsellim": true,
      "Çıkrıkçı": true,
      "Dambaslar": true,
      "Danişment": true,
      "Delibedir": true,
      "Duğcalı": true,
      "Emiryakup": true,
      "Fahrioğlu": true,
      "Hacıllı": true,
      "Hasköy": true,
      "Hedeyli": true,
      "Hisar": true,
      "İlyas": true,
      "İsmailli": true,
      "Kabahöyük": true,
      "Kadriye": true,
      "Kahya": true,
      "Kandamış": true,
      "Karababa": true,
      "Karabürçek": true,
      "Karakavak": true,
      "Karayahşi": true,
      "Kemallar": true,
      "Kılıçlar": true,
      "Kurtdere": true,
      "Kutlugün": true,
      "Küçükkarakarlı": true,
      "Lahna": true,
      "Muzruplu": true,
      "Örey": true,
      "Övenler": true,
      "Parmaksız": true,
      "Soylu": true,
      "Subaşı": true,
      "Susuzmüsellim": true,
      "Şalgamlı": true,
      "Tatarlı": true,
      "Temrezli": true,
      "Umurbey": true,
      "Umurçu": true,
      "Yörgüç": true,
      "Yörükler": true
    },
    "Kapaklı": {
      "19 Mayıs": true,
      "Adnan Menderes": true,
      "Atatürk": true,
      "Bahçeağıl": true,
      "Bahçelievler": true,
      "Cumhuriyet": true,
      "Fatih": true,
      "İnönü": true,
      "İsmet Paşa": true,
      "Karaağaç": true,
      "Karlı": true,
      "Kazım Karabekir": true,
      "Mevlana": true,
      "Mimar Sinan": true,
      "Ömer Halisdemir": true,
      "Pınarca": true,
      "Uzunhacı": true,
      "Vatan": true,
      "Yanıkağıl": true,
      "Yıldızkent": true,
      "Yunus Emre": true
    },
    "Malkara": {
      "Ahievren": true,
      "Ahmetpaşa": true,
      "Aksakal": true,
      "Alaybey": true,
      "Allıışık": true,
      "Bağpınarı": true,
      "Balabancık": true,
      "Ballı": true,
      "Ballısüle": true,
      "Batkın": true,
      "Bayramtepe": true,
      "Cami Atik": true,
      "Çavuşköy": true,
      "Çınaraltı": true,
      "Çınarlıdere": true,
      "Çimendere": true,
      "Danişment": true,
      "Davuteli": true,
      "Deliller": true,
      "Demircili": true,
      "Dereköy": true,
      "Deveci": true,
      "Develi": true,
      "Doğanköy": true,
      "Dolu": true,
      "Elmalı": true,
      "Emirali": true,
      "Esendik": true,
      "Evrenbey": true,
      "Gazibey": true,
      "Gönence": true,
      "Gözsüz": true,
      "Güneşli": true,
      "Hacıevhat": true,
      "Hacısungur": true,
      "Halıç": true,
      "Hasköy": true,
      "Hemit": true,
      "Hereke": true,
      "Izgar": true,
      "İbribey": true,
      "İbrice": true,
      "İshakça": true,
      "Kadıköy": true,
      "Kalaycı": true,
      "Karacagür": true,
      "Karacahalil": true,
      "Karaiğdemir": true,
      "Karamurat": true,
      "Kavakçeşme": true,
      "Kermeyan": true,
      "Kırıkali": true,
      "Kiremitlik": true,
      "Kozyörük": true,
      "Kuyucu": true,
      "Küçükhıdır": true,
      "Kürtüllü": true,
      "Mestanlar": true,
      "Müstecep": true,
      "Pirinççeşme": true,
      "Sağlamtaş": true,
      "Sarıpolat": true,
      "Sarıyar": true,
      "Sarnıç": true,
      "Sırtbey": true,
      "Şahin": true,
      "Tekkeköy": true,
      "Teteköy": true,
      "Vakıfiğdemir": true,
      "Yaylagöne": true,
      "Yaylaköy": true,
      "Yeni": true,
      "Yenice": true,
      "Yenidibek": true,
      "Yılanlı": true,
      "Yörücek": true,
      "Yörük": true
    },
    "Marmaraereğlisi": {
      "Bahçelievler": true,
      "Cedit Ali Paşa": true,
      "Çeşmeli": true,
      "Dereağzı": true,
      "Kamaradere": true,
      "Mustafa Kemal Paşa": true,
      "Sultanköy": true,
      "Türkmenli": true,
      "Yakuplu": true,
      "Yeniçiftlik": true
    },
    "Muratlı": {
      "Arzulu": true,
      "Aşağısevindikli": true,
      "Aydınköy": true,
      "Balabanlı": true,
      "Ballıhoca": true,
      "Çevrimkaya": true,
      "Fatih": true,
      "Hanoğlu": true,
      "İnanlı": true,
      "İstiklal-kurtpınar": true,
      "Kazım Dirik-turan": true,
      "Kepenekli": true,
      "Kırkkepenekli": true,
      "Muradiye": true,
      "Müsellim": true,
      "Yavaşça": true,
      "Yeşilsırt": true,
      "Yukarısevindikli": true,
      "Yukarısırt": true,
      "Yurtbekler": true
    },
    "Saray": {
      "Atatürk": true,
      "Ayaspaşa": true,
      "Ayvacık": true,
      "Aziziye": true,
      "Bahçedere": true,
      "Bahçeköy": true,
      "Beyazköy": true,
      "Bozoba": true,
      "Büyükyoncalı Merkez": true,
      "Cumhuriyet": true,
      "Çayla": true,
      "Çukuryurt": true,
      "Demirler": true,
      "Edirköy": true,
      "Göçerler": true,
      "Güngörmez": true,
      "Kadıköy": true,
      "Karabürçek": true,
      "Kavacık": true,
      "Kemalpaşa": true,
      "Kurtdere": true,
      "Küçükyoncalı": true,
      "Osmanlı": true,
      "Pazarcık": true,
      "Sefaalan": true,
      "Sinanlı": true,
      "Sofular": true,
      "Yeni": true,
      "Yuvalı": true
    },
    "Süleymanpaşa": {
      "100. Yıl": true,
      "Ahmedikli": true,
      "Ahmetçe": true,
      "Akçahalil": true,
      "Altınova": true,
      "Araphacı": true,
      "Aşağıkılıçlı": true,
      "Atatürk": true,
      "Avşar": true,
      "Aydoğdu": true,
      "Bahçelievler": true,
      "Banarlı": true,
      "Barbaros": true,
      "Bıyıkali": true,
      "Cumhuriyet": true,
      "Çanakçı": true,
      "Çınarlı": true,
      "Çiftlikönü": true,
      "Dedecik": true,
      "Değirmenaltı": true,
      "Demirli": true,
      "Doğrukaracamurat": true,
      "Ertuğrul": true,
      "Evciler": true,
      "Ferhadanlı": true,
      "Gazioğlu": true,
      "Generli": true,
      "Gündüzlü": true,
      "Güveçli": true,
      "Hacıköy": true,
      "Husunlu": true,
      "Hürriyet": true,
      "Işıklar": true,
      "İnecik": true,
      "İstiklal": true,
      "Karabezirgan": true,
      "Karacakılavuz": true,
      "Karaçalı": true,
      "Karadeniz": true,
      "Karaevli": true,
      "Karahalil": true,
      "Karahisarlı": true,
      "Karansıllı": true,
      "Kaşıkçı": true,
      "Kayı": true,
      "Kazandere": true,
      "Kılavuzlu": true,
      "Kınıklar": true,
      "Köseilyas": true,
      "Kumbağ": true,
      "Mahramlı": true,
      "Naipköy": true,
      "Namık Kemal": true,
      "Nusratfakı": true,
      "Nusratlı": true,
      "Oğuzlu": true,
      "Ormanlı": true,
      "Ortaca": true,
      "Ortacami": true,
      "Oruçbeyli": true,
      "Osmanlı": true,
      "Otmanlı": true,
      "Selçuk": true,
      "Semetli": true,
      "Seymenli": true,
      "Taşumurca": true,
      "Tatarlı": true,
      "Topağaç": true,
      "Vatan": true,
      "Yağcı": true,
      "Yavuz": true,
      "Yayabaşı": true,
      "Yazır": true,
      "Yenice": true,
      "Yeniköy": true,
      "Yukarıkılıçlı": true,
      "Yuva": true,
      "Zafer": true
    },
    "Şarköy": {
      "Aşağıkalamış": true,
      "Beyoğlu": true,
      "Bulgur": true,
      "Camikebir": true,
      "Cumhuriyet": true,
      "Çengelli": true,
      "Çınarlı": true,
      "Eriklice": true,
      "Gaziköy": true,
      "Gölcük": true,
      "Güzelköy": true,
      "Hoşköy": true,
      "İğdebağları": true,
      "İshaklı": true,
      "İstiklal": true,
      "Kızılcaterzi": true,
      "Kirazlı": true,
      "Kocaali": true,
      "Mursallı": true,
      "Mürefte": true,
      "Palamut": true,
      "Sofuköy": true,
      "Şenköy": true,
      "Tepeköy": true,
      "Uçmakdere": true,
      "Ulaman": true,
      "Yayaağaç": true,
      "Yayaköy": true,
      "Yeniköy": true,
      "Yörgüç": true,
      "Yukarıkalamış": true
    }
  },
  "Tokat": {
    "Almus": {
      "Akarçay Armutalan": true,
      "Akarçay Istiklal": true,
      "Akarçay Şehit Turan Yıldız": true,
      "Akarçay Şenyurt": true,
      "Ata": true,
      "Atatürk": true,
      "Aydınlar": true,
      "Bahçeköy": true,
      "Birlik": true,
      "Cumhuriyet": true,
      "Çambulak": true,
      "Erek": true,
      "Esentepe": true,
      "Gevrek": true,
      "Hürriyet": true,
      "İnönü": true,
      "İstiklal": true,
      "Katranlık": true,
      "Kurtuluş": true,
      "Kuruseki": true,
      "Ötükent": true,
      "Sağırlar": true,
      "Salkavak": true,
      "Siteler": true,
      "Şehit Tuncay Çoban": true,
      "Yeni": true,
      "Yuvaköy": true
    },
    "Artova": {
      "Alpaslan": true,
      "Altınova": true,
      "Çelikli": true,
      "Gaziosmanpaşa": true,
      "İğdir": true,
      "İstasyon": true,
      "Kızılca": true
    },
    "Başçiftlik": {
      "Cumhuriyet": true,
      "Fatih": true,
      "Gençosman": true,
      "Karacaören Alibaba": true,
      "Karacaören Aşıroğlu": true,
      "Karacaören Gaziosmanpaşa": true,
      "Sinanpaşa": true
    },
    "Erbaa": {
      "Ahmet Yesevi": true,
      "Akkoç": true,
      "Alacabal": true,
      "Alparslan": true,
      "Bahçelievler": true,
      "Cumhuriyet": true,
      "Çankaya": true,
      "Çermik Kaplıca": true,
      "Erek": true,
      "Ertuğrulgazi": true,
      "Evyaba": true,
      "Fatih Sultan Mehmet": true,
      "Fatihsultanmehmet": true,
      "Fevzipaşa": true,
      "Gazi Osman Paşa": true,
      "Gaziosmanpaşa": true,
      "Gazipaşa": true,
      "Güldere": true,
      "Gündoğdu": true,
      "Gürpınar": true,
      "Hürmüzlü": true,
      "İsmetpaşa": true,
      "Karşıyaka": true,
      "Kelkit": true,
      "Kuruçay": true,
      "Mehmet Akif": true,
      "Mevlana": true,
      "Mimarsinan": true,
      "Orta": true,
      "Osmangazi": true,
      "Sütlüce": true,
      "Tepe": true,
      "Yavuz Sultan Selim": true,
      "Yavuzsultanselim": true,
      "Yeni": true,
      "Yeşilyurt": true,
      "Yıldırımbeyazıt": true,
      "Yukarı": true,
      "Yunusemre": true,
      "Ziyagökalp": true
    },
    "Merkez": {
      "Akdeğirmen": true,
      "Akın": true,
      "Aktepe": true,
      "Ali Yücel": true,
      "Alipaşa": true,
      "Altıyüzevler": true,
      "Bahçelievler": true,
      "Bedestenlioğlu": true,
      "Behram": true,
      "Bozatalan": true,
      "Büyük Beybağı": true,
      "Camiikebir": true,
      "Cemalettin": true,
      "Cumhuriyet": true,
      "Çay": true,
      "Çekerek": true,
      "Derbent": true,
      "Devegörmez": true,
      "Doğancıbağları": true,
      "Doğukent": true,
      "Erenler": true,
      "Esentepe": true,
      "Geyras": true,
      "Gezirlik": true,
      "Gülbaharhatun": true,
      "Güneşli": true,
      "Hocaahmet": true,
      "Kabe-i Mescid": true,
      "Kaleardı": true,
      "Kanalaltı": true,
      "Karasu": true,
      "Karşıyaka": true,
      "Kaşıkcıbağları": true,
      "Kemer": true,
      "Küçükbey Bağı": true,
      "Küçükyıldız": true,
      "Kümbet": true,
      "Mahmutpaşa": true,
      "Mehmetpaşa": true,
      "Merkez": true,
      "Oğulbey": true,
      "Örtmeliönü": true,
      "Perakende": true,
      "Semerkant": true,
      "Seyitnecmettin": true,
      "Soğukpınar": true,
      "Şht.abdullah Özer": true,
      "Topçam": true,
      "Topçubağı": true,
      "Yarahmet": true,
      "Yeni": true,
      "Yeniyurt": true,
      "Yeşilırmak": true,
      "Yeşilova": true,
      "Yunusemre": true
    },
    "Niksar": {
      "50.yıl": true,
      "Akpınar": true,
      "Aydınlıkevler": true,
      "Ayvaköy": true,
      "Ayvaz": true,
      "Bağlar": true,
      "Bahçelievler": true,
      "Ballıca": true,
      "Bengiler": true,
      "Beyazıt": true,
      "Buz": true,
      "Cedit": true,
      "Cepnibey": true,
      "Çengelli": true,
      "Dönekse": true,
      "Eskidir": true,
      "Fatih": true,
      "G.osmanpaşa": true,
      "Gazi Osman Paşa": true,
      "Gaziahmet": true,
      "Gözpınar": true,
      "Hamidiye": true,
      "Hasyer": true,
      "Hayderbey": true,
      "İsmetpaşa": true,
      "Katipgölü": true,
      "Kayapaşa": true,
      "Kılıçarslan": true,
      "Kırkkızlar": true,
      "Kumçiftlik": true,
      "Kültür": true,
      "Melikgazi": true,
      "Merkez": true,
      "Şafak": true,
      "Şair Emrah": true,
      "Tamlar": true,
      "Yakınca": true,
      "Yapraklı": true,
      "Yeni": true,
      "Yeşilçam": true,
      "Yeşilyurt": true,
      "Yusufşah": true
    },
    "Pazar": {
      "Erkilet": true,
      "Esentepe": true,
      "Fatih": true,
      "Gazi Osman Paşa": true,
      "Kazova": true,
      "Mehmet Akif Ersoy": true,
      "Merkez": true,
      "Mrş.fevzi Çakmak": true,
      "Seyitali": true,
      "Sinanpaşa": true,
      "Tekke": true,
      "Yeşildere": true
    },
    "Reşadiye": {
      "Akçakolay": true,
      "Alpler": true,
      "Altıparmak": true,
      "Arzupınar": true,
      "Cimisadi": true,
      "Çakraz": true,
      "Çamlıca": true,
      "Çamlık": true,
      "Çermik": true,
      "Emirşeyhyakup": true,
      "Erenler": true,
      "Eskituraç": true,
      "Gerdengeç": true,
      "Gökcesüleymanlı": true,
      "Gündoğan": true,
      "Gündoğdu": true,
      "Gürpınar": true,
      "Hacı Abidin": true,
      "Halaçlı": true,
      "Hasangazi": true,
      "Hebüllü": true,
      "Işıklar": true,
      "Kavaklıdere": true,
      "Kayalık": true,
      "Keçiköy": true,
      "Keteniği": true,
      "Kurtuluş": true,
      "Medrese": true,
      "Merkez": true,
      "Nizam": true,
      "Orta": true,
      "Osmaniye": true,
      "Şeyhlioğlu": true,
      "Tahirbey": true,
      "Uluköy": true,
      "Yavuzselim": true,
      "Yeni": true,
      "Yükseliş": true,
      "Zafer": true
    },
    "Sulusaray": {
      "Fatih": true,
      "Gaziosmanpaşa": true,
      "Malum Seyit Tekke": true,
      "Menderes": true
    },
    "Turhal": {
      "Asarcık": true,
      "Bahar": true,
      "Borsa": true,
      "Boyacılar": true,
      "Camikebir": true,
      "Celal": true,
      "Cumhuriyet": true,
      "Çevlikler": true,
      "Emek": true,
      "Fatih": true,
      "Gazi Osman Paşa": true,
      "Gündoğdu": true,
      "Güneş": true,
      "Gürsel": true,
      "Hacılar": true,
      "Hamam": true,
      "Karaevli": true,
      "Kayacık": true,
      "Kazım Karabekir": true,
      "Kova": true,
      "Maraşal Fevzi Çakmak": true,
      "Mevlana": true,
      "Meydan": true,
      "Mimar Sinan": true,
      "Müftü": true,
      "Nurkavak": true,
      "Ortaköy": true,
      "Osmangazi": true,
      "Pazar": true,
      "Ray": true,
      "Üçgözen": true,
      "Varvara": true,
      "Yavuz Selim": true,
      "Yeşilırmak": true,
      "Yunus Emre": true
    },
    "Yeşilyurt": {
      "100. Yıl": true,
      "Çıkrık": true,
      "Çırdak": true,
      "Gaziosmanpaşa": true,
      "Kuşçu": true,
      "Şehitler": true,
      "Türkmenler": true
    },
    "Zile": {
      "Alacamescitzir": true,
      "Alamescitbala": true,
      "Alikadı": true,
      "Bahçelievler": true,
      "Cedit": true,
      "Dinçerler": true,
      "Dutlupınar": true,
      "Hacımehmet": true,
      "İstasyon": true,
      "Kahya": true,
      "Kislik": true,
      "Minareikebir": true,
      "Minareisağır": true,
      "Nakkaş": true,
      "Orta": true,
      "Şeyhali": true,
      "Şeyhkolu": true,
      "Yunusemre": true,
      "Zincirli Ülya": true,
      "Zincirlisüfla": true
    }
  },
  "Trabzon": {
    "Akçaabat": {
      "Acısu": true,
      "Adacık": true,
      "Ağaçlı": true,
      "Akçakale": true,
      "Akçaköy": true,
      "Akdamar": true,
      "Akören": true,
      "Akpınar": true,
      "Alsancak": true,
      "Ambarcık": true,
      "Arpacılı": true,
      "Aydınköy": true,
      "Benlitaş Baltacı": true,
      "Bozdoğan": true,
      "Cevizli": true,
      "Cevizlik": true,
      "Çamlıca": true,
      "Çamlıdere": true,
      "Çınarlık": true,
      "Çiçeklidüz": true,
      "Çilekli": true,
      "Çolaklı": true,
      "Çukurca": true,
      "Darıca": true,
      "Demirci": true,
      "Demirkapı": true,
      "Demirtaş": true,
      "Derecik": true,
      "Doğanköy": true,
      "Dörtyol": true,
      "Dürbinar": true,
      "Erikli": true,
      "Esentepe": true,
      "Eskiköy": true,
      "Fındıklı": true,
      "Fıstıklı": true,
      "Gümüşlü": true,
      "Helvacı": true,
      "Işıklar": true,
      "Kaleönü": true,
      "Karaçayır": true,
      "Karaman": true,
      "Karpınar": true,
      "Kavaklı": true,
      "Kayalar": true,
      "Kemaliye": true,
      "Kirazlık": true,
      "Koçlu": true,
      "Kuruçam": true,
      "Maden": true,
      "Mersin": true,
      "Meşeli": true,
      "Meydankaya": true,
      "Nefsipulathane": true,
      "Oğulkaya Yolbaşı": true,
      "Orta": true,
      "Ortaalan": true,
      "Ortaköy": true,
      "Osmanbaba": true,
      "Özakdamar": true,
      "Özdemirci": true,
      "Salacık": true,
      "Sarıca": true,
      "Sarıtaş": true,
      "Sertkaya": true,
      "Söğütlü": true,
      "Şinik": true,
      "Tatlısu": true,
      "Tütüncüler": true,
      "Uçarsu": true,
      "Uğurlu": true,
      "Yaylacık": true,
      "Yeni": true,
      "Yeniköy": true,
      "Yeşiltepe": true,
      "Yeşilyurt": true,
      "Yıldızlı": true,
      "Zaferli": true
    },
    "Araklı": {
      "Aytaş": true,
      "Ayvadere": true,
      "Bahçecik": true,
      "Bereketli": true,
      "Birlik": true,
      "Buzluca": true,
      "Çamlıca": true,
      "Çamlıktepe": true,
      "Çankaya": true,
      "Çiftepınar": true,
      "Çukurçayır": true,
      "Değirmencik": true,
      "Erenler": true,
      "Erikli": true,
      "Halilli": true,
      "Hasköy": true,
      "Hürriyet": true,
      "İyisu": true,
      "Kalecik": true,
      "Karatepe": true,
      "Karşıyaka": true,
      "Kayacık": true,
      "Kayaiçi": true,
      "Kaymaklı": true,
      "Kestanelik": true,
      "Köprüüstü": true,
      "Kükürtlü": true,
      "Merkez": true,
      "Merkezköy": true,
      "Ortaköy": true,
      "Özgen": true,
      "Pervane": true,
      "Sulakyurt": true,
      "Sularbaşı": true,
      "Taşgeçit": true,
      "Taşönü": true,
      "Taştepe": true,
      "Turnalı": true,
      "Türkeli": true,
      "Yalıboyu": true,
      "Yassıkaya": true,
      "Yeniköy": true,
      "Yeşilce": true,
      "Yeşilköy": true,
      "Yeşilyurt": true,
      "Yıldızlı": true,
      "Yiğitözü": true,
      "Yolgören": true,
      "Yoncalı": true,
      "Yüceyurt": true
    },
    "Arsin": {
      "Atayurt": true,
      "Başdurak": true,
      "Cudibey": true,
      "Cumhuriyet": true,
      "Çardaklı": true,
      "Çiçekli": true,
      "Çubuklu": true,
      "Dilek": true,
      "Elmaalan": true,
      "Fatih": true,
      "Fındıklı": true,
      "Gölcük": true,
      "Gölgelik": true,
      "Güneyce": true,
      "Güzelyalı": true,
      "Harmanlı": true,
      "Işıklı": true,
      "İşhan": true,
      "Karaca": true,
      "Konak": true,
      "Kuzguncuk": true,
      "Nuroğlu": true,
      "Oğuz": true,
      "Örnek": true,
      "Özlü": true,
      "Şenkaya": true,
      "Üçpınar": true,
      "Yalı": true,
      "Yeni": true,
      "Yeniköy": true,
      "Yeşilce": true,
      "Yeşilköy": true,
      "Yeşiltepe": true,
      "Yeşilyalı": true,
      "Yolaç": true,
      "Yolüstü": true
    },
    "Beşikdüzü": {
      "Adacık": true,
      "Ağaçlı": true,
      "Akkese": true,
      "Aksaklı": true,
      "Anbarlı": true,
      "Ardıçatak": true,
      "Bayırköy": true,
      "Beşikdağ": true,
      "Bozlu": true,
      "Cumhuriyet": true,
      "Çakırlı": true,
      "Çeşmeönü": true,
      "Çıtlaklı": true,
      "Dağlıca": true,
      "Denizli": true,
      "Dolanlı": true,
      "Duygulu": true,
      "Fatih": true,
      "Gürgenli": true,
      "Hünerli": true,
      "Kalegüney": true,
      "Korkuthan": true,
      "Kutluca": true,
      "Nefsişarlı": true,
      "Oğuz": true,
      "Resullü": true,
      "Sayvancık": true,
      "Seyitahmet": true,
      "Şahmelik": true,
      "Takazlı": true,
      "Vardallı": true,
      "Yenicami": true,
      "Yeşilköy": true,
      "Zemberek": true
    },
    "Çarşıbaşı": {
      "Burunbaşı": true,
      "Büyükdere": true,
      "Çallı": true,
      "Erenköy": true,
      "Fenerköy": true,
      "Gülbahçe": true,
      "Kadıköy": true,
      "Kaleköy": true,
      "Kavaklı": true,
      "Kerem": true,
      "Kovanlı": true,
      "Küçükköy": true,
      "Merkez": true,
      "Pınarlı": true,
      "Salova": true,
      "Samsun": true,
      "Serpilköy": true,
      "Şahinli": true,
      "Taşlıtepe": true,
      "Veliköy": true,
      "Yavuz": true,
      "Yeniköy": true,
      "Zeytinlik": true
    },
    "Çaykara": {
      "Akdoğan": true,
      "Arpaözü": true,
      "Aşağıkumlu": true,
      "Ataköy": true,
      "Baltacılı": true,
      "Çambaşı": true,
      "Çamlıbel": true,
      "Çayıroba": true,
      "Demirkapı": true,
      "Demirli": true,
      "Derindere": true,
      "Eğridere": true,
      "Işıklı": true,
      "Kabataş": true,
      "Karaçam": true,
      "Kayran": true,
      "Koldere": true,
      "Köknar": true,
      "Köseli": true,
      "Maraşlı": true,
      "Soğanlı": true,
      "Şahinkaya": true,
      "Şekersu": true,
      "Taşkıran": true,
      "Taşlıgedik": true,
      "Taşören": true,
      "Ulucami": true,
      "Uzungöl": true,
      "Uzuntarla": true,
      "Yaylaönü": true,
      "Yeşilalan": true,
      "Yukarıkumlu": true
    },
    "Dernekpazarı": {
      "Akköse": true,
      "Çalışanlar": true,
      "Çayırbaşı": true,
      "Gülen": true,
      "Günebakan": true,
      "Güney": true,
      "Kondu": true,
      "Merkez": true,
      "Ormancık": true,
      "Taşçılar": true,
      "Tüfekçi": true,
      "Yenicami": true,
      "Yenice": true,
      "Zincirlitaş": true
    },
    "Düzköy": {
      "Alazlı": true,
      "Aykut": true,
      "Büyük": true,
      "Cevizlik": true,
      "Çal Camili": true,
      "Çal Çeşmeler": true,
      "Çal Orta": true,
      "Çayırbağı Doğankaya": true,
      "Çayırbağı Gülcana": true,
      "Çayırbağı Orta": true,
      "Çayırbağı Yusuflu": true,
      "Çayırbağı Zeliha": true,
      "Çiğdemli": true,
      "Düzalan": true,
      "Gökçeler": true,
      "Gürgendağ": true,
      "Küçüktepeköy": true,
      "Orta": true,
      "Taşocağı": true,
      "Tepecik": true,
      "Yeni": true,
      "Yerlice": true
    },
    "Hayrat": {
      "Ağaçlı Düz": true,
      "Balaban": true,
      "Balaban Merkez": true,
      "Cumhuriyet": true,
      "Çağlayan": true,
      "Çamlıtepe": true,
      "Çaycılar": true,
      "Dağönü": true,
      "Dereyurt": true,
      "Fatih": true,
      "Geçitli": true,
      "Göksel": true,
      "Görgülü": true,
      "Gülderen Fatih": true,
      "Gülderen Merkez": true,
      "Hamzalı": true,
      "Hürriyet": true,
      "Kılavuz": true,
      "Köyceğiz": true,
      "Kurtuluş": true,
      "Merkez": true,
      "Meydanlı": true,
      "Onur": true,
      "Pazarönü": true,
      "Pınarca": true,
      "Sarmaşık": true,
      "Şehitli": true,
      "Şişli": true,
      "Taflancık": true,
      "Topaklı": true,
      "Yarlı": true,
      "Yeni": true,
      "Yeniköy": true,
      "Yıldırımlar": true,
      "Yırca": true
    },
    "Köprübaşı": {
      "Akpınar": true,
      "Arpalı": true,
      "Beşköy": true,
      "Büyükdoğanlı": true,
      "Çifteköprü": true,
      "Fidanlı": true,
      "Gündoğan": true,
      "Güneşli": true,
      "Pınarbaşı": true,
      "Yağmurlu": true
    },
    "Maçka": {
      "Akarsu": true,
      "Akmescit": true,
      "Alaçam": true,
      "Alataş": true,
      "Altındere": true,
      "Anayurt": true,
      "Ardıçlıyayla": true,
      "Armağan": true,
      "Atasu": true,
      "Bağışlı": true,
      "Bahçekaya": true,
      "Bakımlı": true,
      "Bakırcılar": true,
      "Barışlı": true,
      "Başar": true,
      "Coşandere": true,
      "Çamlıdüz": true,
      "Çatak": true,
      "Çayırlar": true,
      "Çeşmeler": true,
      "Çıralı": true,
      "Dikkaya": true,
      "Erginköy": true,
      "Esiroğlu": true,
      "Fatih": true,
      "Gayretli": true,
      "Günay": true,
      "Güney": true,
      "Gürgenağaç": true,
      "Güzelce": true,
      "Güzelyayla": true,
      "Hamsiköy": true,
      "Hızarlı": true,
      "Kapıköy": true,
      "Kaynarca": true,
      "Kırantaş": true,
      "Kiremitli": true,
      "Konak": true,
      "Kozağaç": true,
      "Köprüyanı": true,
      "Kuşçu": true,
      "Mataracı": true,
      "Merkez": true,
      "Ocaklı": true,
      "Oğulağaç": true,
      "Ormaniçi": true,
      "Ormanüstü": true,
      "Ortaköy": true,
      "Öğütlü": true,
      "Örnekalan": true,
      "Reşadiye": true,
      "Sevinç": true,
      "Sındıran": true,
      "Sukenarı": true,
      "Şimşirli": true,
      "Temelli": true,
      "Üçgedik": true,
      "Yaylabaşı": true,
      "Yazılıtaş": true,
      "Yazlık": true,
      "Yeni Atasu": true,
      "Yeniköy": true,
      "Yeşiltepe": true,
      "Yeşilyurt": true,
      "Yukarıköy": true,
      "Yüzüncüyıl": true,
      "Zaferli": true
    },
    "Of": {
      "Ağaçbaşı": true,
      "Ağaçseven": true,
      "Aşağıkışlacık": true,
      "Ballıca": true,
      "Barış": true,
      "Başköy": true,
      "Bayırca": true,
      "Birlik": true,
      "Bölümlü": true,
      "Cumapazarı": true,
      "Cumhuriyet": true,
      "Çaltılı": true,
      "Çamlı": true,
      "Çamlıtepe": true,
      "Çataldere": true,
      "Çatalsöğüt": true,
      "Çukurova": true,
      "Dağalan": true,
      "Darılı": true,
      "Dereköy": true,
      "Doğançay": true,
      "Dumlusu": true,
      "Erenköy": true,
      "Esenköy": true,
      "Eskipazar": true,
      "Fındıkoba": true,
      "Gökçeoba": true,
      "Gümüşören": true,
      "Güresen": true,
      "Gürpınar": true,
      "İkidere": true,
      "İrfanlı": true,
      "Kaban": true,
      "Karabudak": true,
      "Kavakpınar": true,
      "Kazançlı": true,
      "Keler": true,
      "Kıyıboyu": true,
      "Kıyıcık": true,
      "Kiraz": true,
      "Kireçli": true,
      "Korkut": true,
      "Korucuk": true,
      "Kumludere": true,
      "Ovacık": true,
      "Örtülü": true,
      "Pınaraltı": true,
      "Saraçlı": true,
      "Sarayköy": true,
      "Sarıbey": true,
      "Sarıkaya": true,
      "Sefaköy": true,
      "Serince": true,
      "Sıraağaç": true,
      "Sivrice": true,
      "Soğukpınar": true,
      "Söğütlü": true,
      "Sugeldi": true,
      "Sulaklı": true,
      "Tavşanlı": true,
      "Tekoba": true,
      "Uğurlu": true,
      "Uluağaç": true,
      "Yanıktaş": true,
      "Yazlık": true,
      "Yemişalan": true,
      "Yeni": true,
      "Yukarı Kışlacık": true
    },
    "Ortahisar": {
      "1 Nolu Beşirli": true,
      "1 Nolu Bostancı": true,
      "1 Nolu Erdoğdu": true,
      "2 Nolu Beşirli": true,
      "2 Nolu Bostancı": true,
      "2 Nolu Erdoğdu": true,
      "3 Nolu Erdoğdu": true,
      "Ağıllı": true,
      "Akkaya": true,
      "Akoluk": true,
      "Aktoprak": true,
      "Akyazı": true,
      "Aydınlıkevler": true,
      "Ayvalı": true,
      "Bahçecik": true,
      "Bengisu": true,
      "Beştaş": true,
      "Boztepe": true,
      "Bulak": true,
      "Cumhuriyet": true,
      "Çağlayan": true,
      "Çamoba": true,
      "Çarşı": true,
      "Çilekli": true,
      "Çimenli": true,
      "Çömlekçi": true,
      "Çukurçayır": true,
      "Değirmendere": true,
      "Doğançay": true,
      "Dolaylı": true,
      "Düzyurt": true,
      "Esentepe": true,
      "Esenyurt": true,
      "Fatih": true,
      "Fatih Sultan": true,
      "Gazipaşa": true,
      "Geçit": true,
      "Gölçayır": true,
      "Gözalan": true,
      "Gülbaharhatun": true,
      "Gündoğdu": true,
      "Gürbulak": true,
      "Hızırbey": true,
      "İncesu": true,
      "İnönü": true,
      "İskenderpaşa": true,
      "Kalkınma": true,
      "Kamışlı": true,
      "Kanuni": true,
      "Karakaya": true,
      "Karlık": true,
      "Karşıyaka": true,
      "Kavala": true,
      "Kaymaklı": true,
      "Kemerkaya": true,
      "Kireçhane": true,
      "Konaklar": true,
      "Kozluca": true,
      "Kurtuluş": true,
      "Kutlugün": true,
      "Okçular": true,
      "Ortahisar": true,
      "Özbirlik": true,
      "Pazarkapı": true,
      "Pelitli": true,
      "Pınaraltı": true,
      "Sanayi": true,
      "Sayvan": true,
      "Sevimli": true,
      "Soğuksu": true,
      "Subaşı": true,
      "Toklu": true,
      "Tosköy": true,
      "Uğurlu": true,
      "Üniversite": true,
      "Yalı": true,
      "Yalıncak": true,
      "Yenicuma": true,
      "Yeniköy": true,
      "Yenimahalle": true,
      "Yeşilbük": true,
      "Yeşilhisar": true,
      "Yeşilköy": true,
      "Yeşilova": true,
      "Yeşiltepe": true,
      "Yeşilvadi": true,
      "Yeşilyurt": true
    },
    "Sürmene": {
      "Aksu": true,
      "Armutlu": true,
      "Aşağıovalı": true,
      "Balıklı": true,
      "Birlik": true,
      "Çamburnu": true,
      "Çamlıca": true,
      "Çarşı": true,
      "Çavuşlu": true,
      "Çiftesu": true,
      "Çimenli": true,
      "Dirlik": true,
      "Fındıcak": true,
      "Gültepe": true,
      "Güneyköy": true,
      "Kahraman": true,
      "Karacakaya": true,
      "Konak": true,
      "Koyuncular": true,
      "Küçükdere": true,
      "Muratlı": true,
      "Ormanseven": true,
      "Orta": true,
      "Ortaköy": true,
      "Oylum": true,
      "Petekli": true,
      "Soğuksu": true,
      "Üstündal": true,
      "Üzümlü": true,
      "Yazıoba": true,
      "Yemişli": true,
      "Yeniay": true,
      "Yeşilköy": true,
      "Yokuşbaşı": true,
      "Yukarıçavuşlu": true,
      "Yukarıovalı": true,
      "Zeytinli": true
    },
    "Şalpazarı": {
      "Ağırtaş": true,
      "Akçiriş": true,
      "Çamkiriş": true,
      "Çamlıca": true,
      "Çarlaklı": true,
      "Çetrik": true,
      "Dereköy": true,
      "Doğancı": true,
      "Dorukkiriş": true,
      "Düzköy": true,
      "Fidanbaşı": true,
      "Geyikli": true,
      "Gökçeköy": true,
      "Gölkiriş": true,
      "Güdün": true,
      "Kabasakal": true,
      "Kalecik": true,
      "Karakaya": true,
      "Kasımağzı": true,
      "Kireç": true,
      "Kuzuluk": true,
      "Pelitçik": true,
      "Sayvançatak": true,
      "Simenli": true,
      "Sinlice": true,
      "Sugören": true,
      "Sütpınar": true,
      "Tepeağzı": true,
      "Turalıuşağı": true,
      "Üzümözü": true
    },
    "Tonya": {
      "Biçinlik": true,
      "Büyük": true,
      "Çamlı": true,
      "Çayıriçi": true,
      "Hoşarlı": true,
      "İskenderli": true,
      "Kalemli": true,
      "Kaleönü": true,
      "Kalınçam": true,
      "Karaağaçlı": true,
      "Karasu": true,
      "Karşular": true,
      "Kayacan": true,
      "Kozluca": true,
      "Kösecik": true,
      "Melikşah": true,
      "Orta": true,
      "Sağrı": true,
      "Sayraç": true,
      "Turalı": true,
      "Yakçukur": true,
      "Yeni": true
    },
    "Vakfıkebir": {
      "Açıkalan": true,
      "Akköy": true,
      "Aydoğdu": true,
      "Bahadırlı": true,
      "Ballı": true,
      "Bozalan": true,
      "Büyükliman": true,
      "Caferli": true,
      "Cumhuriyet": true,
      "Çamlık": true,
      "Çamlık Sahil": true,
      "Çarşı": true,
      "Çavuşlu": true,
      "Demirci": true,
      "Deregözü": true,
      "Düzlük": true,
      "Esentepe": true,
      "Fethiye": true,
      "Fevziye": true,
      "Güneyköy": true,
      "Güneysu": true,
      "Hacıköy": true,
      "Hamzalı": true,
      "Hürriyet": true,
      "İlyaslı": true,
      "İshaklı": true,
      "Karatepe": true,
      "Kemaliye": true,
      "Kıranköy": true,
      "Kirazlık": true,
      "Kirazlıkyeni": true,
      "Köprücek": true,
      "Körez": true,
      "Küçükdere": true,
      "Mahmutlu": true,
      "Mısırlı": true,
      "Ortaköy": true,
      "Rıdvanlı": true,
      "Sekmenli": true,
      "Sinanlı": true,
      "Soğuksu": true,
      "Şenocak": true,
      "Tarlacık": true,
      "Yalıköy": true,
      "Yaylacık": true,
      "Yıldız": true
    },
    "Yomra": {
      "Çamlıca": true,
      "Çamlıyurt": true,
      "Çınarlı": true,
      "Demirciler": true,
      "Gülyurdu": true,
      "Gürsel": true,
      "İkisu": true,
      "Kaşüstü": true,
      "Kayabaşı": true,
      "Kılıçlı": true,
      "Kıratlı": true,
      "Kömürcü": true,
      "Maden": true,
      "Namıkkemal": true,
      "Ocak": true,
      "Oymalı": true,
      "Özdil": true,
      "Pınarlı": true,
      "Sancak": true,
      "Şanlı": true,
      "Tandırlı": true,
      "Taşdelen": true,
      "Tepeköy": true,
      "Yenice": true,
      "Yokuşlu": true
    }
  },
  "Tunceli": {
    "Çemişgezek": {
      "Çukur": true,
      "Hacı Cami": true,
      "Hamamatik": true,
      "Kale": true,
      "Mescit": true,
      "Tepebaşı": true,
      "Yenimahalle": true
    },
    "Hozat": {
      "Diyap Ağa": true,
      "Fikripaşa": true,
      "Köprübaşı": true,
      "Yeni": true
    },
    "Mazgirt": {
      "Çarşıbaşı": true,
      "Elmalık": true,
      "Eltihatun": true,
      "Güneşdere": true,
      "Güneyharman": true,
      "Karabulut": true,
      "Kepektaşı": true,
      "Kuşçu": true,
      "Örs": true,
      "Yeni": true
    },
    "Merkez": {
      "Aktuluk": true,
      "Alibaba": true,
      "Atatürk": true,
      "Cumhuriyet": true,
      "Esentepe": true,
      "İsmet Inönü": true,
      "Moğultay": true,
      "Yeni": true
    },
    "Nazımiye": {
      "Merkez": true
    },
    "Ovacık": {
      "94 Mahallesi": true,
      "Kandolar": true,
      "Pulur": true
    },
    "Pertek": {
      "Camikebir": true,
      "Derebaşı": true,
      "İstiklal": true,
      "Kaledibi": true,
      "Soğukpınar": true
    },
    "Pülümür": {
      "Atatürk": true,
      "Ecevit": true,
      "Hiver": true,
      "Merkez": true,
      "Meydanlar": true
    }
  },
  "Uşak": {
    "Banaz": {
      "31 Ağustos": true,
      "Barış": true,
      "Cumhuriyet": true,
      "Dilek": true,
      "Emek": true,
      "Hamamboğazı": true,
      "İslam": true,
      "Şehitler": true
    },
    "Eşme": {
      "Cumhuriyet": true,
      "Elvanlar": true,
      "Hürriyet": true,
      "İstasyon": true,
      "İstiklal": true,
      "Kemer": true,
      "Şehitalibey": true,
      "Üçeylül": true,
      "Yenikent": true,
      "Yıldırımlar": true
    },
    "Karahallı": {
      "Boğaz": true,
      "Buğdaylı": true,
      "Dere": true,
      "Karbasan": true,
      "Konak": true,
      "Yeni": true
    },
    "Merkez": {
      "Atatürk": true,
      "Aybey": true,
      "Bozkurt": true,
      "Bölme": true,
      "Cumhuriyet": true,
      "Çevre": true,
      "Dikilitaş": true,
      "Durak": true,
      "Elmalıdere": true,
      "Fatih": true,
      "Fevzi Çakmak": true,
      "Hacıkadem": true,
      "Işık": true,
      "İkisaray": true,
      "İslice": true,
      "Kalfa": true,
      "Karaağaç": true,
      "Kemalöz": true,
      "Köme": true,
      "Kurşunluk": true,
      "Kurtuluş": true,
      "Kuyucak": true,
      "Mehmet Akif Ersoy": true,
      "Muharremşah": true,
      "Ovademirler": true,
      "Özdemir": true,
      "Sarayaltı": true,
      "Ünalan": true,
      "Yeşil Karaağaç": true
    },
    "Sivaslı": {
      "Akıncılar": true,
      "Atatürk": true,
      "Dedeballar": true,
      "Evrenli": true,
      "Fatih": true,
      "Fevzi Çakmak": true,
      "Gölbahçe": true,
      "Gülbey": true,
      "Konak": true,
      "Pınar": true,
      "Yıldıztepe": true
    },
    "Ulubey": {
      "Aşağı": true,
      "Avgan": true,
      "Camikebir": true,
      "Dilaver": true,
      "Emirler": true,
      "Gölbaşı": true,
      "Üyükbaşı": true
    }
  },
  "Van": {
    "Bahçesaray": {
      "Akyayla": true,
      "Altındere": true,
      "Altıntas": true,
      "Arvas": true,
      "Bağcılar": true,
      "Cevizlibelen": true,
      "Çatbayır": true,
      "Çiçekli": true,
      "Çömlekçi": true,
      "Elmayaka": true,
      "Fekiye Teyran": true,
      "Güneyyamaç": true,
      "İslam": true,
      "Kaşıkçılar": true,
      "Paşaköy": true,
      "Şişli": true,
      "Ulubeyli": true,
      "Ünlüce": true,
      "Yaşlıkavak": true,
      "Yaylakonak": true
    },
    "Başkale": {
      "Açıkağıl": true,
      "Akçalı": true,
      "Albayrak": true,
      "Aşağıküme": true,
      "Aşalan": true,
      "Atlılar": true,
      "Aydemir": true,
      "Azıklı": true,
      "Barış": true,
      "Belencik": true,
      "Beşocak": true,
      "Bilgeç": true,
      "Böğrüpek": true,
      "Bölekli": true,
      "Büklümdere": true,
      "Çakırdoğan": true,
      "Çaldıran": true,
      "Dereiçi": true,
      "Deringeçit": true,
      "Ekecek": true,
      "Erek": true,
      "Erkonağı": true,
      "Esenyamaç": true,
      "Eşmepınar": true,
      "Evbakan": true,
      "Gedikbaşı": true,
      "Gelenler": true,
      "Güleçler": true,
      "Güroluk": true,
      "Güvendik": true,
      "Hafiziye": true,
      "Hasanbey": true,
      "Ilıcak": true,
      "Işıklı": true,
      "Kaşkol": true,
      "Kavurgalı": true,
      "Keçilioba": true,
      "Kızılca": true,
      "Kocaköy": true,
      "Koçdağı": true,
      "Konuksayar": true,
      "Kovalıpınar": true,
      "Köprüağzı": true,
      "Mahmutabat": true,
      "Oğulveren": true,
      "Ortayazı": true,
      "Ortayol": true,
      "Ömerdağı": true,
      "Öncüler": true,
      "Örencik": true,
      "Örenkale": true,
      "Örmetaş": true,
      "Özpınar": true,
      "Saçan": true,
      "Sallıdere": true,
      "Savaşköy": true,
      "Sualtı": true,
      "Tahıl": true,
      "Tepebaşı": true,
      "Tınazlı": true,
      "Uğurlu": true,
      "Yanal": true,
      "Yavuzlar": true,
      "Yeni": true,
      "Yolmaçayır": true,
      "Yukarıdallı": true,
      "Yukarıdarıca": true,
      "Yukarıdikmen": true,
      "Yurttepe": true
    },
    "Çaldıran": {
      "Akbaşak": true,
      "Alakaya": true,
      "Alikelle": true,
      "Altıyol": true,
      "Aşağıçanak": true,
      "Aşağıdikme": true,
      "Aşağıgülderen": true,
      "Aşağıkuyucak": true,
      "Aşağımutlu": true,
      "Aşağıyanıktaş": true,
      "Avcıbaşı": true,
      "Ayrancılar": true,
      "Başeğmez": true,
      "Beyazıt": true,
      "Beydoğan": true,
      "Bezirhane": true,
      "Buğulukaynak": true,
      "Burçakalan": true,
      "Cumhuriyet": true,
      "Çayırköy": true,
      "Çubuklu": true,
      "Demircik": true,
      "Direkli": true,
      "Doyumalan": true,
      "Erginler": true,
      "Evciler": true,
      "Fatih Sultan Mehmet": true,
      "Gülyolu": true,
      "Güngören": true,
      "Hangediği": true,
      "Hanköy": true,
      "İncealan": true,
      "İsmailbaba": true,
      "Kalkandelen": true,
      "Karadulda": true,
      "Kaşım": true,
      "Kılavuz": true,
      "Kilimli": true,
      "Koçovası": true,
      "Kurtoğlan": true,
      "Kuskunkıran": true,
      "Osmanlı": true,
      "Recep Tayyip Erdoğan": true,
      "Salahane": true,
      "Sarıçimen": true,
      "Sarıharman": true,
      "Sellik": true,
      "Serpmetaş": true,
      "Soğuksu": true,
      "Sungur": true,
      "Şehit Jandarma Binbaşı Kıvanç Cesur": true,
      "Tekindere": true,
      "Temrenli": true,
      "Toprakseven": true,
      "Umuttepe": true,
      "Yağıbasan": true,
      "Yassıtepe": true,
      "Yavuz Selim": true,
      "Yaykılıç": true,
      "Yeniyaka": true,
      "Yukarıçanak": true,
      "Yukarıdikme": true,
      "Yukarıgülderen": true,
      "Yukarıkuyucak": true,
      "Yukarımutlu": true,
      "Yukarısağmallı": true,
      "Yukarıyanıktaş": true,
      "Yuvacık": true,
      "Yücelen": true,
      "Zülfibulak": true
    },
    "Çatak": {
      "Adnan Menderes": true,
      "Ağaçlık": true,
      "Akçabük": true,
      "Alacayar": true,
      "Aşağınarlıca": true,
      "Atlıhan": true,
      "Bahçelievler": true,
      "Bilgi": true,
      "Boyunpınar": true,
      "Cumhuriyet": true,
      "Çılga": true,
      "Dalbastı": true,
      "Derebaşı": true,
      "Dokuzdam": true,
      "Eliaçık": true,
      "Görentaş": true,
      "Hacıosman": true,
      "Işınlı": true,
      "Kaçıt": true,
      "Karşıyaka": true,
      "Konalga": true,
      "Korulu": true,
      "Narlı": true,
      "Onağıl": true,
      "Övecek": true,
      "Selçuklu": true,
      "Sırmalı": true,
      "Sözveren": true,
      "Sugeldi": true,
      "Teknecik": true,
      "Toyga": true,
      "Uzuntekne": true,
      "Yukarınarlıca": true
    },
    "Edremit": {
      "Akın": true,
      "Andaç": true,
      "Ayazpınar": true,
      "Bakacık": true,
      "Bakımlı": true,
      "Çayırbaşı": true,
      "Dilkaya": true,
      "Doğanlar": true,
      "Dönemeç": true,
      "Elmalık": true,
      "Eminpaşa": true,
      "Enginsu": true,
      "Erdemkent": true,
      "Erenkent": true,
      "Esentepe": true,
      "Eski Cami": true,
      "Gölkaşı": true,
      "Kavurma": true,
      "Kıyıcak": true,
      "Köklü": true,
      "Köprüler": true,
      "Köşkköy": true,
      "Kurubaş": true,
      "Mülk": true,
      "Selahattin Eyyubi": true,
      "Süphan": true,
      "Şabaniye": true,
      "Taşkonak": true,
      "Yeni": true,
      "Yeni Cami": true
    },
    "Erciş": {
      "Abdalmezrası": true,
      "Adnan Menderes": true,
      "Ağaçören": true,
      "Ağırkaya": true,
      "Akbaş": true,
      "Akçayuva": true,
      "Aksakal": true,
      "Alkanat": true,
      "Aşağıakçagedik": true,
      "Aşağıçökek": true,
      "Aşağıgöze": true,
      "Aşağıışıklı": true,
      "Aşağıkozluca": true,
      "Bayramlı": true,
      "Beyazıt": true,
      "Bozyaka": true,
      "Bucakönü": true,
      "Bulamaç": true,
      "Camiikebir": true,
      "Çakırbey": true,
      "Çatakdibi": true,
      "Çataltepe": true,
      "Çelebibağı": true,
      "Çetintaş": true,
      "Çınarlı": true,
      "Çimen": true,
      "Çobandüzü": true,
      "Çubuklu": true,
      "Deliçay": true,
      "Derekent": true,
      "Derimevi": true,
      "Dinlence": true,
      "Doğancı": true,
      "Doluca": true,
      "Duracak": true,
      "Düvenci": true,
      "Ekiciler": true,
      "Ergücü": true,
      "Evbeyli": true,
      "Gedikdibi": true,
      "Gergili": true,
      "Gökoğlan": true,
      "Gölağzı": true,
      "Görüşlü": true,
      "Gözütok": true,
      "Gültepe": true,
      "Gümüşoluk": true,
      "Hacıkaş": true,
      "Hasanabdal": true,
      "Haydarbey": true,
      "Hocaali": true,
      "İkizçalı": true,
      "İşbaşı": true,
      "Kadirasker": true,
      "Karatavuk": true,
      "Kardoğan": true,
      "Karlıyayla": true,
      "Kasımbağı": true,
      "Kayaboyun": true,
      "Kekiksırtı": true,
      "Keklikova": true,
      "Kırkdeğirmen": true,
      "Kırkpınar": true,
      "Kışla": true,
      "Kızılören": true,
      "Kocapınar": true,
      "Koçköprü": true,
      "Köycük": true,
      "Latifiye": true,
      "Mağara": true,
      "Nişancı": true,
      "Ortayayla": true,
      "Oyalı": true,
      "Örene": true,
      "Payköy": true,
      "Pınarlı": true,
      "Sabanbüken": true,
      "Sahil Kent": true,
      "Salihiye": true,
      "Salmanağa": true,
      "Söğütlü": true,
      "Şehirpazar": true,
      "Şerefli": true,
      "Taşevler": true,
      "Taşkapı": true,
      "Taşlıçay": true,
      "Tekevler": true,
      "Tekler": true,
      "Topraklı": true,
      "Ulupamir": true,
      "Uncular": true,
      "Vanyolu": true,
      "Yalındam": true,
      "Yankıtepe": true,
      "Yeşilova": true,
      "Yetişen": true,
      "Yılanlı": true,
      "Yoldere": true,
      "Yöreli": true,
      "Yukarıakçagedik": true,
      "Yukarıışıklı": true,
      "Yünören": true
    },
    "Gevaş": {
      "Abalı": true,
      "Aladüz": true,
      "Altınsaç": true,
      "Anaköy": true,
      "Atalan": true,
      "Aydınocak": true,
      "Bağlama": true,
      "Bahçelievler": true,
      "Barışık": true,
      "Dağyöre": true,
      "Daldere": true,
      "Değirmitaş": true,
      "Dereağzı": true,
      "Dilmetaş": true,
      "Dokuzağaç": true,
      "Elmalı": true,
      "Göründü": true,
      "Gündoğan": true,
      "Güzelkonak": true,
      "Hasbey": true,
      "Hişet": true,
      "İkizler": true,
      "İnköy": true,
      "Karşıyaka": true,
      "Kayalar": true,
      "Kazanç": true,
      "Kızıltaş": true,
      "Koçak": true,
      "Kurultu": true,
      "Kuşluk": true,
      "Orta": true,
      "Pınarbaşı": true,
      "Selimiye": true,
      "Timar": true,
      "Töreli": true,
      "Uğurveren": true,
      "Uysal": true,
      "Yanıkçay": true,
      "Yemişlik": true,
      "Yoldöndü": true,
      "Yuva": true
    },
    "Gürpınar": {
      "Akbulut": true,
      "Akdoğu": true,
      "Akpınar": true,
      "Alnıak": true,
      "Arındı": true,
      "Aşağıkaymaz": true,
      "Bağrıyanık": true,
      "Beşbudak": true,
      "Bozyiğit": true,
      "Bölmeçalı": true,
      "Bükeç": true,
      "Cevizalan": true,
      "Cumhuriyet": true,
      "Çakınlı": true,
      "Çatakdibi": true,
      "Çavuştepe": true,
      "Çepkenli": true,
      "Çörekli": true,
      "Dağseven": true,
      "Değirmendüzü": true,
      "Dikbıyık": true,
      "Dolaylı": true,
      "Doluçıkın": true,
      "Elaçmaz": true,
      "Erkaldı": true,
      "Geçerli": true,
      "Geziyurt": true,
      "Giyimli": true,
      "Gölardı": true,
      "Güleçler": true,
      "Günbaşı": true,
      "Hacıköy": true,
      "Hoşab": true,
      "Işıkpınar": true,
      "Kalkanlı": true,
      "Kapçık": true,
      "Karakoç": true,
      "Kılıçtutan": true,
      "Kırkgeçit": true,
      "Koçgüden": true,
      "Koyunyatağı": true,
      "Kuşdağı": true,
      "Mollahüseyin": true,
      "Murataldı": true,
      "Oğuldamı": true,
      "Ongun": true,
      "Ortaköy": true,
      "Otbiçer": true,
      "Örmeli": true,
      "Öveçli": true,
      "Özlüce": true,
      "Parmakkapı": true,
      "Sakalar": true,
      "Sapakonak": true,
      "Savacık": true,
      "Sevindik": true,
      "Sıcaksu": true,
      "Sütlüce": true,
      "Taşdöndüren": true,
      "Taşlıyazı": true,
      "Tepegören": true,
      "Topçudeğirmeni": true,
      "Topsakal": true,
      "Topyıldız": true,
      "Tutak": true,
      "Tutmaç": true,
      "Umut": true,
      "Uzungedik": true,
      "Üçdoğan": true,
      "Üçgen": true,
      "Yalınca": true,
      "Yaramış": true,
      "Yatağan": true,
      "Yedisalkım": true,
      "Yolaşan": true,
      "Yoldüştü": true,
      "Yukarıkaymaz": true,
      "Yurtbaşı": true,
      "Zernek": true
    },
    "İpekyolu": {
      "Ağzıkara": true,
      "Aktaş": true,
      "Alipaşa": true,
      "Arıtoprak": true,
      "Aşağıçitli": true,
      "Aşağıgölalan": true,
      "Bahçıvan": true,
      "Baklatepe": true,
      "Bakraçlı": true,
      "Beşçatak": true,
      "Bostaniçi": true,
      "Buzhane": true,
      "Cevdet Paşa": true,
      "Cumhuriyet": true,
      "Çalımlı": true,
      "Değirmenarkı": true,
      "Değirmenköy": true,
      "Dereüstü": true,
      "Dibekli": true,
      "Erçek": true,
      "Esenler": true,
      "Gövelek": true,
      "Hacıbekir": true,
      "Hafiziye": true,
      "Halilağa": true,
      "Hatuniye": true,
      "Ilıkaynak": true,
      "Irgat": true,
      "Karagündüz": true,
      "Karakoç": true,
      "Karpuzalanı": true,
      "Karşıyaka": true,
      "Kavuncu": true,
      "Kaymaklı": true,
      "Kevenli": true,
      "Kıratlı": true,
      "Köşebaşı": true,
      "Ortanca": true,
      "Sarmaç": true,
      "Selimbey": true,
      "Serhat": true,
      "Seyit Fehim Arvasi": true,
      "Şerefiye": true,
      "Vali Mithat Bey": true,
      "Yalı": true,
      "Yalınağaç": true,
      "Yatıksırt": true,
      "Yeni": true,
      "Yukarıgölalan": true,
      "Yukarıgüneyce": true
    },
    "Muradiye": {
      "Açıkyol": true,
      "Adaklı": true,
      "Akbulak": true,
      "Akçaçay": true,
      "Alkasnak": true,
      "Aşağıargıt": true,
      "Babacan": true,
      "Balaklı": true,
      "Beşparmak": true,
      "Beydağı": true,
      "Çakmak": true,
      "Çiçekli": true,
      "Dağören": true,
      "Devetaş": true,
      "Doğangün": true,
      "Dürükkaş": true,
      "Erişen": true,
      "Esenkoç": true,
      "Fatih": true,
      "Fevzi Çakmak": true,
      "Gönderme": true,
      "Görecek": true,
      "Güllüçimen": true,
      "Gültepe": true,
      "Gümüştepe": true,
      "Kandahar": true,
      "Karahan": true,
      "Karaoğlan": true,
      "Keçikıran": true,
      "Kemerköprü": true,
      "Kocasaban": true,
      "Köşk": true,
      "Kuşçu": true,
      "Otlakbaşı": true,
      "Ovapınar": true,
      "Sarımemet": true,
      "Sürüyolu": true,
      "Şehitmehmetbey": true,
      "Tansu": true,
      "Topuzarpa": true,
      "Uluşar": true,
      "Ünseli": true,
      "Yakıncak": true,
      "Yalındüz": true,
      "Yavuzselim": true,
      "Yenişehir": true,
      "Yukarıargıt": true,
      "Yumaklı": true
    },
    "Özalp": {
      "Aksorguç": true,
      "Altınboğa": true,
      "Aşağıakçagül": true,
      "Aşağıbalçıklı": true,
      "Aşağıkoçkıran": true,
      "Aşağımollahasan": true,
      "Aşağıtulgalı": true,
      "Aşağıyorganlı": true,
      "Bağrıaçık": true,
      "Bodurağaç": true,
      "Boğazkesen": true,
      "Boyaldı": true,
      "Cumhuriyet": true,
      "Çamurlu": true,
      "Çavuşlar": true,
      "Çırakköy": true,
      "Çubuklu": true,
      "Dağdeviren": true,
      "Damlacık": true,
      "Dorutay": true,
      "Dönerdere": true,
      "Eğribelen": true,
      "Emek": true,
      "Eski Emek": true,
      "Gözdeğmez": true,
      "Gültepe": true,
      "Günyüzlü": true,
      "Hacıali": true,
      "Hacıkışlak": true,
      "Hazine": true,
      "İstasyon": true,
      "Kalecik": true,
      "Kargalı": true,
      "Karlıyamaç": true,
      "Kaşıkara": true,
      "Kırkçalı": true,
      "Mahmudiye": true,
      "Mehmetalan": true,
      "Mollatopuz": true,
      "Oymaklı": true,
      "Sağmalı": true,
      "Sarıköy": true,
      "Savatlı": true,
      "Seydibey": true,
      "Sugeçer": true,
      "Şehittepe": true,
      "Şemsettin": true,
      "Tepedam": true,
      "Yarımkaya": true,
      "Yavuzlar": true,
      "Yukarıayazca": true,
      "Yukarıbalçıklı": true,
      "Yukarıçavdarlık": true,
      "Yukarımollahasan": true,
      "Yukarıtulgalı": true,
      "Yukarıyorganlı": true,
      "Yumruklu": true,
      "Yünkuşak": true
    },
    "Saray": {
      "Atatürk": true,
      "Bakışık": true,
      "Baltepe": true,
      "Beyarslan": true,
      "Çakmakköy": true,
      "Çartak": true,
      "Çaybağı": true,
      "Değirmigöl": true,
      "Dolutaş": true,
      "Feritmelen": true,
      "Kapıköy": true,
      "Karahisar": true,
      "Kargalı": true,
      "Kazımpaşa": true,
      "Kazlıgöl": true,
      "Keçikayası": true,
      "Kekikdüzü": true,
      "Kepir": true,
      "Koçbaşı": true,
      "Kurucan": true,
      "Mahmudiye": true,
      "Örenburç": true,
      "Sırımlı": true,
      "Turanköy": true,
      "Yamanyurt": true,
      "Yeşilağaç": true,
      "Zincirkıran": true
    },
    "Tuşba": {
      "Abdurrahman Gazi": true,
      "Adıgüzel": true,
      "Akçaören": true,
      "Akçift": true,
      "Akköprü": true,
      "Alabayır": true,
      "Alaköy": true,
      "Altıntepe": true,
      "Arısu": true,
      "Aşıt": true,
      "Atmaca": true,
      "Ayanıs": true,
      "Bağdaşan": true,
      "Bardakçı": true,
      "Beyüzümü": true,
      "Canik": true,
      "Çakırbey": true,
      "Çitören": true,
      "Çobanoğlu": true,
      "Çolpan": true,
      "Çomaklı": true,
      "Dağönü": true,
      "Değirmenözü": true,
      "Derebey": true,
      "Dibekdüzü": true,
      "Dilimli": true,
      "Ermişler": true,
      "Esenpınar": true,
      "Gedelova": true,
      "Göllü": true,
      "Gölyazı": true,
      "Gülsünler": true,
      "Güvençli": true,
      "Halkalı": true,
      "Hıdırköy": true,
      "İskele": true,
      "İstasyon": true,
      "Kalecik": true,
      "Karaağaç": true,
      "Kasımoğlu": true,
      "Kelle": true,
      "Koçköy": true,
      "Kolsatan": true,
      "Kozluca": true,
      "Kumluca": true,
      "Meydancık": true,
      "Mollakasım": true,
      "Ocaklı": true,
      "Otluca": true,
      "Özkaynak": true,
      "Özyurt": true,
      "Pirgarip": true,
      "Sağlamtaş": true,
      "Satıbey": true,
      "Seyrantepe": true,
      "Şahgeldi": true,
      "Şemsibey": true,
      "Tabanlı": true,
      "Tevekli": true,
      "Topaktaş": true,
      "Yalnızağaç": true,
      "Yaylıyaka": true,
      "Yemlice": true,
      "Yeniköşk": true,
      "Yeşilköy": true,
      "Yeşilsu": true,
      "Yumrutepe": true
    }
  },
  "Yalova": {
    "Altınova": {
      "Altınkent": true,
      "Cumhuriyet": true,
      "Denizgören": true,
      "Fatih": true,
      "Hersek": true,
      "Hürriyet": true,
      "Merkez": true,
      "Şehitlik": true
    },
    "Armutlu": {
      "50. Yıl": true,
      "Bayır": true,
      "Karşıyaka": true
    },
    "Çınarcık": {
      "Aliye Hanım": true,
      "Atakent": true,
      "Cumhuriyet": true,
      "Çamlık": true,
      "Harmanlar": true,
      "Hasanbaba": true,
      "Hürriyet": true,
      "İstiklal": true,
      "Karpuzdere": true,
      "Karşıyaka": true,
      "Liman": true,
      "Taşliman": true
    },
    "Çiftlikköy": {
      "500 Evler": true,
      "Çiftlik": true,
      "Mehmet Akif Ersoy": true,
      "Sahil": true,
      "Siteler": true,
      "Sultaniye": true,
      "Taşköprü Merkez": true,
      "Taşköprü Yeni": true
    },
    "Merkez": {
      "Adnan Menderes": true,
      "Bağlarbaşı": true,
      "Bahçelievler": true,
      "Bayraktepe": true,
      "Dere": true,
      "Fevzi Çakmak": true,
      "Gazi Osman Paşa": true,
      "İsmet Paşa": true,
      "Kazım Karabekir": true,
      "Merkez": true,
      "Mustafa Kemal Paşa": true,
      "Özden": true,
      "Paşakent": true,
      "Rüstem Paşa": true,
      "Seyrantepe": true,
      "Süleyman Bey": true
    },
    "Termal": {
      "Gökçedere": true,
      "Üvezpınar": true
    }
  },
  "Yozgat": {
    "Akdağmadeni": {
      "Ahishavi": true,
      "Çamlık": true,
      "Emek": true,
      "Gültepe": true,
      "Güneyli": true,
      "İbrahim Ağa": true,
      "İstanbulluoğlu": true,
      "Kale": true,
      "Karaçokrak": true,
      "Karahisartatlısı": true,
      "Konacı": true,
      "Merkez": true,
      "Olucak": true,
      "Örenkale": true,
      "Seyrantepe": true,
      "Umut": true,
      "Yeni": true,
      "Yeşildere": true,
      "Yeşiltepe": true
    },
    "Aydıncık": {
      "Baştürk": true,
      "Danlıdağ": true,
      "Merkez": true,
      "Yeni": true,
      "Yenice": true
    },
    "Boğazlıyan": {
      "Aşağı": true,
      "Aşağı Karakoç": true,
      "Aşağıhasinli": true,
      "Aşağısarıkaya": true,
      "Bağlarbaşı": true,
      "Bahçeler": true,
      "Bahçelievler": true,
      "Camii Kebir": true,
      "Çarşı": true,
      "Eğlence": true,
      "Esentepe": true,
      "Fatih": true,
      "Karşıyaka": true,
      "Kaymakam Kemal Bey": true,
      "Kemaliye": true,
      "Koç": true,
      "Mevlana": true,
      "Namık Kemal": true,
      "Ömerli": true,
      "Selanik": true,
      "Yaraş": true,
      "Yeni": true,
      "Yenidoğan": true,
      "Yeşil": true,
      "Yukarı": true,
      "Yukarı Karakoç": true,
      "Zafer": true
    },
    "Çandır": {
      "Abdullah Efendi": true,
      "Atatürk": true,
      "Bahçelievler": true,
      "Barboros": true,
      "Cumhuriyet": true,
      "Eşrefpaşa": true,
      "Kılıçlar": true,
      "Nabioğlu": true,
      "Şah Sultan": true,
      "Yenimeydan": true
    },
    "Çayıralan": {
      "Avcılar": true,
      "Bağlarbaşı": true,
      "Cumhuriyet": true,
      "Çokradan": true,
      "Fatih": true,
      "İshaklı": true,
      "Yavuz Sultan Selim": true,
      "Yeni": true,
      "Yıldırım Beyazıt": true
    },
    "Çekerek": {
      "Bağlarbaşı": true,
      "Bahçelievler": true,
      "Gültepe": true,
      "Mevlana": true,
      "Seyit Ahmet": true,
      "Yeniyol": true,
      "Yunus Emre": true
    },
    "Kadışehri": {
      "Akçakale": true,
      "Bahçeli Evler": true,
      "Belören": true,
      "Çaypınar": true,
      "Elmalı": true,
      "Fatih": true,
      "Gümüşdiğin": true,
      "Kadıoğlu": true,
      "Lütfullah Kayalar": true,
      "Üçağaç": true,
      "Vasfıbey": true,
      "Yakacık": true,
      "Yangı": true,
      "Yeni": true,
      "Yoncalık": true,
      "Yukarıkızılöz": true
    },
    "Merkez": {
      "Agahefendi": true,
      "Aşağı Çatak": true,
      "Aşağınohutlu": true,
      "Azizlibağları": true,
      "Bahçeşehir": true,
      "Bilal Şahin": true,
      "Çapanoğlu": true,
      "Develik": true,
      "Divanlı": true,
      "Erdoğan Akdağ": true,
      "Eskipazar": true,
      "Fatih": true,
      "İstanbulluoğlu": true,
      "Karatepe": true,
      "Köseoğlu": true,
      "Medrese": true,
      "Mehmet Hulusi Efendi": true,
      "Mutafoğlu": true,
      "Sarıhacılı": true,
      "Şeyh Ahmet Efendi": true,
      "Şeyhosman": true,
      "Taşköprü": true,
      "Tekke": true,
      "Tuzkaya": true,
      "Yenicami": true,
      "Yukarıçatak": true,
      "Yukarınohutlu": true
    },
    "Saraykent": {
      "Balkaya": true,
      "Büyük Camii": true,
      "Cumhuriyet": true,
      "Dedefakılı Merkez": true,
      "Divanlı": true,
      "Fatih Sultan Mehmet": true,
      "Güldibi": true,
      "Karapınar": true,
      "Karşıyaka": true,
      "M.fevzi Çakmak": true,
      "Merkez": true,
      "Saray": true,
      "Sarayözü": true,
      "Yeni": true
    },
    "Sarıkaya": {
      "Bahçelievler": true,
      "Battalgazi": true,
      "Beyazıt": true,
      "Cumhuriyet": true,
      "Çıkrıkçı": true,
      "Fatih": true,
      "Fevzi Çakmak": true,
      "Hürriyet": true,
      "İstiklal": true,
      "Kaplıca": true,
      "Karayakup": true,
      "Karşıyaka": true,
      "Kayapınar": true,
      "Kazım Karabekir": true,
      "Köprücek": true,
      "Osman Gazi": true,
      "Şekerpınar": true,
      "Terzili": true,
      "Yenidoğan": true
    },
    "Sorgun": {
      "Agahefendi": true,
      "Ahmetefendi": true,
      "Ahmetfakılı": true,
      "Akocak": true,
      "Aksaray": true,
      "Aydınlar": true,
      "Aydınlıkevler": true,
      "Bahçelievler": true,
      "Bedirbaba": true,
      "Burunören": true,
      "Camiikebir": true,
      "Çarşıbaşı": true,
      "Çavuşlu": true,
      "Çay": true,
      "Çötelli": true,
      "Duralidayılı": true,
      "Faraşlı": true,
      "Gülveren": true,
      "Gümüşkavak": true,
      "Güzel Yurt": true,
      "Güzelyurt": true,
      "Hanbaşı": true,
      "Hoşumlu": true,
      "Hürriyet": true,
      "İsmailhacılı": true,
      "Kale": true,
      "Karakız": true,
      "Karşıyaka": true,
      "Kayabaşı": true,
      "Kayakışla": true,
      "Keser": true,
      "Mahmatlı": true,
      "Merkez": true,
      "Musu Baba": true,
      "Mükremin": true,
      "Mülazım": true,
      "Osmançavuş": true,
      "Salur": true,
      "Sorgun Tatlısı": true,
      "Sungur": true,
      "Yaycılar": true,
      "Yazlak": true,
      "Yeni": true,
      "Yenidoğan": true,
      "Yeşilöz": true
    },
    "Şefaatli": {
      "Bağlarbaşı": true,
      "Bahçelievler": true,
      "Cumhuriyet": true,
      "Fatih": true,
      "H.bayram Karabulut": true,
      "İnceşehir": true,
      "Kale": true,
      "Karalar": true,
      "Konaklı": true,
      "Yaylapınar": true,
      "Yeni": true
    },
    "Yenifakılı": {
      "Altındağ": true,
      "Cankurtaran": true,
      "Mehmet Akif Ersoy": true,
      "Yazlak": true,
      "Yeni": true
    },
    "Yerköy": {
      "100.yıl": true,
      "Ali Galip Gençoğlu": true,
      "Altmış Evler": true,
      "Ayanoğlu": true,
      "Bağlarbaşı": true,
      "Erzurum": true,
      "Gültepe": true,
      "Haşim Kılıç": true,
      "Hüyük": true,
      "Kale": true,
      "Karacaşar": true,
      "Selçuk": true,
      "Şentepe": true,
      "Vefi Pandır": true
    }
  },
  "Zonguldak": {
    "Alaplı": {
      "Aşağıdoğancılar": true,
      "Erenköy": true,
      "Fındıklı Ağılı": true,
      "Kale": true,
      "Karşıyaka": true,
      "Merkez": true,
      "Tepeköy": true,
      "Yeni Siteler": true,
      "Yenimahalle": true
    },
    "Çaycuma": {
      "Abacık": true,
      "Aşağı Çukur": true,
      "Ayvazlar": true,
      "Çay": true,
      "Durmuşlar": true,
      "Düz": true,
      "Gemiciler": true,
      "Geriş": true,
      "Hacı Kadı": true,
      "Hisarönü": true,
      "İstasyon": true,
      "Karaevligeriş": true,
      "Karalar": true,
      "Karamusa": true,
      "Karboğaz": true,
      "Kayıkçılar": true,
      "Keçecioğlu": true,
      "Kocaali": true,
      "Kokaksu": true,
      "Merkez": true,
      "Öteyüz": true,
      "Pehlivanlar": true,
      "Sarı Kadı": true,
      "Sarıkum": true,
      "Sefercik": true,
      "Sofular": true,
      "Terziler": true,
      "Tilkiler": true,
      "Torlaklar": true,
      "Velioğlu": true,
      "Yazıbaşı": true,
      "Yeni": true,
      "Yeni Mahalle": true,
      "Yeni Pazar": true,
      "Yeşiltepe": true,
      "Yeşilyurt": true,
      "Yukarı Çukur": true
    },
    "Devrek": {
      "Ağalar": true,
      "Çay": true,
      "Eski": true,
      "Hümmetoğlu": true,
      "İsmet Paşa": true,
      "Karşıyaka": true,
      "Kemerler": true,
      "Merkez": true,
      "Recep Tayyip Erdoğan": true,
      "Yeni": true
    },
    "Ereğli": {
      "Akarca": true,
      "Armutçuk": true,
      "Bağlık": true,
      "Balı": true,
      "Bekyeri": true,
      "Belen": true,
      "Belenyeni": true,
      "Bölücek": true,
      "Çengel": true,
      "Dağlar": true,
      "Elma Tepe": true,
      "Geyikbeli": true,
      "Gökçeler": true,
      "Göktepe": true,
      "Güldere": true,
      "Hamzafakılı": true,
      "Kavaklık": true,
      "Kepez": true,
      "Kestaneci": true,
      "Kırmacı": true,
      "Kışla": true,
      "Kıyıcak": true,
      "Kirmanlı": true,
      "Kocaali": true,
      "Korubaşı": true,
      "Köseler": true,
      "Merkez": true,
      "Murtaza": true,
      "Müftü": true,
      "Orhanlar": true,
      "Ömerli": true,
      "Ören": true,
      "Örencik": true,
      "Sarıkaya": true,
      "Sarıkokmaz": true,
      "Seyit Ahmetli": true,
      "Sinitli": true,
      "Süleymanlar": true,
      "Şehitlik": true,
      "Topçalı": true,
      "Uzunçayır": true,
      "Uzunmehmet": true,
      "Yeni": true
    },
    "Gökçebey": {
      "Çarşı": true,
      "Çay": true,
      "Çukur": true,
      "İstasyon": true,
      "Kadıoğlu": true,
      "Merkez": true,
      "Onmayıs": true,
      "Satıbeyler": true,
      "Üçburgu": true,
      "Yeni": true
    },
    "Kilimli": {
      "Ayiçi": true,
      "Ayiçi Merkez": true,
      "Belediye Sitesi": true,
      "Bölüm": true,
      "Cuma Yanı": true,
      "Cumhuriyet": true,
      "Çamlık": true,
      "Damarlı": true,
      "Doğancılar": true,
      "Emirler": true,
      "Esen": true,
      "Gelik Merkez": true,
      "Güney": true,
      "Hacıoğlu": true,
      "Hisar Arkası": true,
      "Karadon": true,
      "Kırat": true,
      "Kırımsa": true,
      "Kokurdan": true,
      "Kuzyaka": true,
      "Merkez": true,
      "Subatan": true
    },
    "Kozlu": {
      "19 Mayıs": true,
      "Esenköy": true,
      "Fatih": true,
      "Güney": true,
      "İhsaniye": true,
      "Kılıç": true,
      "Merkez": true,
      "Taşbaca": true,
      "Yahma": true
    },
    "Merkez": {
      "Asma": true,
      "Bağlık": true,
      "Bahçelievler": true,
      "Baştarla": true,
      "Beytepe": true,
      "Birlik": true,
      "Celepçioğlu": true,
      "Cumhuriyet": true,
      "Çalca": true,
      "Çamlık": true,
      "Çaydamar": true,
      "Çınartepe": true,
      "Dilaver": true,
      "Elvan": true,
      "Hayat": true,
      "İnağzı": true,
      "İncivez": true,
      "Kadı": true,
      "Karaelmas": true,
      "Karamanlar": true,
      "Kasımlar": true,
      "Merkez": true,
      "Meşrutiyet": true,
      "Mithatpaşa": true,
      "Muratlı": true,
      "On Temmuz": true,
      "Satıklı": true,
      "Tasmacı": true,
      "Tepebaşı": true,
      "Terakki": true,
      "Yayla": true,
      "Yeni": true,
      "Yeşil": true
    }
  }
};


(function () {
  function findTrimmedKey(obj, wanted) {
    const w = String(wanted ?? '').trim();
    return Object.keys(obj || {}).find(k => String(k).trim() === w) || null;
  }

  function transformInputToSelect(inputElement, placeholder) {
    if (!inputElement) return null;

    if (inputElement.tagName === "SELECT") {
      if (!inputElement.querySelector("option[value='']")) {
        const placeholderOption = document.createElement("option");
        placeholderOption.value = "";
        placeholderOption.className = "rsi-select-placeholder";
        placeholderOption.textContent = placeholder || "Seleccione";
        inputElement.insertBefore(placeholderOption, inputElement.firstChild);
      }
      inputElement.classList.add("rsi-select-field");
      return inputElement;
    }

    const select = document.createElement("select");

    select.id = inputElement.id || "";
    select.name = inputElement.name || "";

    select.className = "sc-gSifMm jtIFEn rsi-select-field";

    select.style.cssText = `
      width: 100%;
      height: 32px;
      padding: 0px 25px;
      border: none;
      font-size: 16px;
      color: rgb(0, 0, 0);
      background-color: rgba(169, 181, 211, 0.09);
      box-shadow: none;
      outline: none;
      background-image: url(data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23000000%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E);
      background-repeat: no-repeat;
      background-position: right 0.7em top 50%;
      background-size: 0.65em;
      appearance: none;
      margin: 0px !important;
      border-radius: 0px 9px 9px 0px !important;
    `;

    ["autocomplete", "required", "data-maxl", "data-minl"].forEach(attr => {
      if (inputElement.hasAttribute(attr)) {
        select.setAttribute(attr, inputElement.getAttribute(attr));
      }
    });

    const placeholderOption = document.createElement("option");
    placeholderOption.value = "";
    placeholderOption.className = "rsi-select-placeholder";
    placeholderOption.textContent = placeholder || "Seleccione";
    select.appendChild(placeholderOption);

    inputElement.replaceWith(select);

    return select;
  }

  function populateDropdown(selectElement, options, placeholder) {
    if (!selectElement) return;

    function normalizeOptions(raw) {
      if (!raw) return [];
      if (Array.isArray(raw)) {
        if (!raw.length) return [];
        if (typeof raw[0] === "object") {
          return raw.map(o => {
            const v = o?.value != null ? String(o.value) : String(o?.label ?? "");
            const l = o?.label != null ? String(o.label) : v;
            return { value: v, label: l.trim() };
          });
        }
        return raw.map(s => {
          const txt = String(s);
          return { value: txt, label: txt.trim() };
        });
      }
      if (typeof raw === "object") {
        return Object.keys(raw).map(k => {
          const v = String(k);
          return { value: v, label: v.trim() };
        });
      }
      const asTxt = String(raw);
      return [{ value: asTxt, label: asTxt.trim() }];
    }

    selectElement.innerHTML = "";
    const placeholderOption = document.createElement("option");
    placeholderOption.value = "";
    placeholderOption.className = "rsi-select-placeholder";
    placeholderOption.textContent = placeholder || "";
    selectElement.appendChild(placeholderOption);

    let list = [];
    try {
      list = normalizeOptions(options);
    } catch (e) {
      console.error("[populateDropdown] error normalizando opciones:", e, options);
      list = [];
    }

    for (const item of list) {
      if (!item || item.value == null) continue;
      const option = document.createElement("option");
      option.value = String(item.value);                   
      option.textContent = String(item.label ?? item.value).trim(); 
      option.className = "rsi-select-option";
      selectElement.appendChild(option);
    }

    if (list.length === 1) {
      selectElement.value = list[0].value;
      selectElement.dispatchEvent(new Event("change"));
    }
  }

  function initializeDropdowns() {
    const provinceInput     = document.querySelector("#province_country_field, #province");
    const cityInput         = document.querySelector("#city");
    const municipalityInput = document.querySelector("#civic_number");

    if (!provinceInput || !cityInput || !municipalityInput) {
      console.error("Faltan campos requeridos:", {
        province: !!provinceInput, city: !!cityInput, civic: !!municipalityInput
      });
      return;
    }

    const provinceSelect     = transformInputToSelect(provinceInput, "Şehir");
    const citySelect         = transformInputToSelect(cityInput, "ilçe");
    const municipalitySelect = transformInputToSelect(municipalityInput, "Mahalle");

    citySelect.disabled = true;
    municipalitySelect.disabled = true;

    populateDropdown(provinceSelect, (typeof data === "object") ? data : {}, "Şehir");

    provinceSelect.addEventListener("change", function () {
      const selProv = provinceSelect.value;
      const provKey = findTrimmedKey(data, selProv);

      if (provKey && data[provKey]) {
        populateDropdown(citySelect, data[provKey], "ilçe");
        citySelect.disabled = false;

        municipalitySelect.innerHTML = '<option value="" class="rsi-select-placeholder">Mahalle</option>';
        municipalitySelect.disabled = true;

        const cityKeys = Object.keys(data[provKey] || {});
        if (cityKeys.length === 1) {
          citySelect.value = cityKeys[0];
          citySelect.dispatchEvent(new Event("change"));
        }
      } else {
        citySelect.innerHTML = '<option value="" class="rsi-select-placeholder">ilçe</option>';
        municipalitySelect.innerHTML = '<option value="" class="rsi-select-placeholder">Mahalle</option>';
        citySelect.disabled = true;
        municipalitySelect.disabled = true;
      }
    });

    citySelect.addEventListener("change", function () {
      const selProv = provinceSelect.value;
      const selCity = citySelect.value;

      const provKey = findTrimmedKey(data, selProv);
      const cityKey = provKey ? findTrimmedKey(data[provKey], selCity) : null;

      if (provKey && cityKey && data[provKey][cityKey]) {
        populateDropdown(
          municipalitySelect,
          data[provKey][cityKey],   
          "Mahalle"
        );
        municipalitySelect.disabled = false;

        const muniKeys = Object.keys(data[provKey][cityKey] || {});
        if (muniKeys.length === 1) {
          municipalitySelect.value = muniKeys[0];
          municipalitySelect.dispatchEvent(new Event("change"));
        }
      } else {
        municipalitySelect.innerHTML = '<option value="" class="rsi-select-placeholder">Mahalle</option>';
        municipalitySelect.disabled = true;
      }
    });
  }

  const PROV_SELECTOR = "#province_country_field, #province";
  let formWasOpen = false;

  function tryInit() {
    const provinceField = document.querySelector(PROV_SELECTOR);
    if (provinceField && !formWasOpen) {
      formWasOpen = true;
      initializeDropdowns();
    }
    if (!provinceField && formWasOpen) {
      formWasOpen = false;
    }
  }

  tryInit();
  document.addEventListener("DOMContentLoaded", tryInit);
  const observer = new MutationObserver(tryInit);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
